{
  "assets": {
    "LPC_Ancient_Rome_Architecture.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/LPC_Ancient_Rome_Architecture.png",
    "LPC_Ancient_Rome_Architecture_aquaduct.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/LPC_Ancient_Rome_Architecture_aquaduct.png",
    "LPC_Ancient_Rome_Architecture_therme.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/LPC_Ancient_Rome_Architecture_therme.png",
    "atlas.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/atlas.json",
    "atlas.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/atlas.png",
    "authored-terrain-v2.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/authored-terrain-v2.png",
    "authored-terrain.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/authored-terrain.json",
    "authored-terrain.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/authored-terrain.png",
    "beach-desert.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/beach-desert.json",
    "beach-desert.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/beach-desert.png",
    "bonecaller_chant.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/bonecaller_chant.ogg",
    "bonecaller_complete.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/bonecaller_complete.ogg",
    "bonecaller_spike_impact.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/bonecaller_spike_impact.ogg",
    "bonecaller_spike_windup.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/bonecaller_spike_windup.ogg",
    "bonecaller_sweep_impact.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/bonecaller_sweep_impact.ogg",
    "bonecaller_sweep_windup.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/bonecaller_sweep_windup.ogg",
    "boots/0.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/boots/0.ogg",
    "boots/1.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/boots/1.ogg",
    "boots/2.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/boots/2.ogg",
    "boots/3.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/boots/3.ogg",
    "boots/4.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/boots/4.ogg",
    "boots/5.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/boots/5.ogg",
    "boots/6.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/boots/6.ogg",
    "boots/7.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/boots/7.ogg",
    "boots/8.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/boots/8.ogg",
    "boots/license.txt": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/boots/license.txt",
    "build_atlas.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/build_atlas.json",
    "build_atlas.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/build_atlas.png",
    "build_printed.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/build_printed.ogg",
    "campfire_fed.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/campfire_fed.ogg",
    "campfire_lit.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/campfire_lit.ogg",
    "chapter_announce.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/chapter_announce.ogg",
    "chapter_begin.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/chapter_begin.ogg",
    "chapter_complete.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/chapter_complete.ogg",
    "chapter_task_complete.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/chapter_task_complete.ogg",
    "chapter_task_stamp.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/chapter_task_stamp.ogg",
    "click.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/click.mp3",
    "clocktick.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/clocktick.mp3",
    "cloth.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/cloth.ogg",
    "coin3.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/coin3.ogg",
    "colony.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/colony.json",
    "colony.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/colony.png",
    "container.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/container.json",
    "container.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/container.png",
    "cottage.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/cottage.json",
    "cottage.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/cottage.png",
    "decorations-medieval.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/decorations-medieval.json",
    "decorations-medieval.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/decorations-medieval.png",
    "discord.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/discord.png",
    "dome1.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/dome1.ogg",
    "door-open.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/door-open.ogg",
    "door_close.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/door_close.ogg",
    "door_open.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/door_open.ogg",
    "dooropen.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/dooropen.mp3",
    "dungeon-ambience.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/dungeon-ambience.ogg",
    "dungeon_tiles.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/dungeon_tiles.png",
    "ember_core_blast.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/ember_core_blast.ogg",
    "ember_core_charge.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/ember_core_charge.ogg",
    "ember_core_fire.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/ember_core_fire.ogg",
    "ember_core_fuse.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/ember_core_fuse.ogg",
    "ember_core_ready.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/ember_core_ready.ogg",
    "emp.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/emp.mp3",
    "explosion.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/explosion.mp3",
    "fence_medieval.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/fence_medieval.json",
    "fence_medieval.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/fence_medieval.png",
    "floors.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/floors.json",
    "floors.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/floors.png",
    "footstep.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/footstep.mp3",
    "forest-dirt.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/forest-dirt.json",
    "forest-dirt.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/forest-dirt.png",
    "forest-grass.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/forest-grass.json",
    "forest-grass.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/forest-grass.png",
    "furniture-blonde-wood.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/furniture-blonde-wood.json",
    "furniture-blonde-wood.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/furniture-blonde-wood.png",
    "grass/0.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/grass/0.ogg",
    "grass/1.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/grass/1.ogg",
    "ground_rupture.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/ground_rupture.ogg",
    "gunshot.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/gunshot.mp3",
    "hatch-wood.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/hatch-wood.json",
    "hatch-wood.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/hatch-wood.png",
    "health.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/health.mp3",
    "human/death/1.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/human/death/1.ogg",
    "human/death/2.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/human/death/2.ogg",
    "human/death/3.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/human/death/3.ogg",
    "human/death/4.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/human/death/4.ogg",
    "human/death/5.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/human/death/5.ogg",
    "human/death/6.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/human/death/6.ogg",
    "human/death/7.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/human/death/7.ogg",
    "human/death/8.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/human/death/8.ogg",
    "human/death/aargh.txt": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/human/death/aargh.txt",
    "humanoid.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/humanoid.json",
    "humanoid.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/humanoid.png",
    "intro/scene.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/intro/scene.png",
    "item-art-08bd1c8b4020c28035f1.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-08bd1c8b4020c28035f1.json",
    "item-art-08bd1c8b4020c28035f1.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-08bd1c8b4020c28035f1.png",
    "item-art-1a07b84a0c63a7a63c4f.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-1a07b84a0c63a7a63c4f.json",
    "item-art-1a07b84a0c63a7a63c4f.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-1a07b84a0c63a7a63c4f.png",
    "item-art-32902d50537ebad17e79.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-32902d50537ebad17e79.json",
    "item-art-32902d50537ebad17e79.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-32902d50537ebad17e79.png",
    "item-art-35c925e4db81912bfe38.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-35c925e4db81912bfe38.json",
    "item-art-35c925e4db81912bfe38.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-35c925e4db81912bfe38.png",
    "item-art-4d6c318ef966e097227a.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-4d6c318ef966e097227a.json",
    "item-art-4d6c318ef966e097227a.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-4d6c318ef966e097227a.png",
    "item-art-5902c8b486e89c8f8e57.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-5902c8b486e89c8f8e57.json",
    "item-art-5902c8b486e89c8f8e57.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-5902c8b486e89c8f8e57.png",
    "item-art-721c3f8a8d4621a46f90.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-721c3f8a8d4621a46f90.json",
    "item-art-721c3f8a8d4621a46f90.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-721c3f8a8d4621a46f90.png",
    "item-art-7fc02d2406eaa57e3be0.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-7fc02d2406eaa57e3be0.json",
    "item-art-7fc02d2406eaa57e3be0.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-7fc02d2406eaa57e3be0.png",
    "item-art-887e0636d4bbe2a4f448.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-887e0636d4bbe2a4f448.json",
    "item-art-887e0636d4bbe2a4f448.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-887e0636d4bbe2a4f448.png",
    "item-art-99ea85dcdc93fac8db18.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-99ea85dcdc93fac8db18.json",
    "item-art-99ea85dcdc93fac8db18.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-99ea85dcdc93fac8db18.png",
    "item-art-a7225776548a58ab4e04.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-a7225776548a58ab4e04.json",
    "item-art-a7225776548a58ab4e04.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-a7225776548a58ab4e04.png",
    "item-art-af19df691fc7aa944194.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-af19df691fc7aa944194.json",
    "item-art-af19df691fc7aa944194.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-af19df691fc7aa944194.png",
    "item-art-b1d5a86cbcd21ed656d3.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-b1d5a86cbcd21ed656d3.json",
    "item-art-b1d5a86cbcd21ed656d3.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-b1d5a86cbcd21ed656d3.png",
    "item-art-b9ef00e25a4177065abd.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-b9ef00e25a4177065abd.json",
    "item-art-b9ef00e25a4177065abd.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-b9ef00e25a4177065abd.png",
    "item-art-bb4afa7ce4e3c1ba55ba.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-bb4afa7ce4e3c1ba55ba.json",
    "item-art-bb4afa7ce4e3c1ba55ba.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-bb4afa7ce4e3c1ba55ba.png",
    "item-art-d9ecaed5ff4485611809.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-d9ecaed5ff4485611809.json",
    "item-art-d9ecaed5ff4485611809.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-d9ecaed5ff4485611809.png",
    "item-art-e46e4dec4aea45bf9d8e.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-e46e4dec4aea45bf9d8e.json",
    "item-art-e46e4dec4aea45bf9d8e.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-e46e4dec4aea45bf9d8e.png",
    "item-art-ebdd046fea0f3ab21669.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-ebdd046fea0f3ab21669.json",
    "item-art-ebdd046fea0f3ab21669.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-ebdd046fea0f3ab21669.png",
    "item-art-f728e0bbaefbd1982b2d.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-f728e0bbaefbd1982b2d.json",
    "item-art-f728e0bbaefbd1982b2d.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item-art-f728e0bbaefbd1982b2d.png",
    "item_crafted.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item_crafted.ogg",
    "item_pickup.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/item_pickup.ogg",
    "joystick-handle.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/joystick-handle.png",
    "joystick.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/joystick.png",
    "jungle-ruins.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/jungle-ruins.json",
    "jungle-ruins.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/jungle-ruins.png",
    "lpc-flowers-plants-fungi-wood.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc-flowers-plants-fungi-wood.json",
    "lpc-flowers-plants-fungi-wood.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc-flowers-plants-fungi-wood.png",
    "lpc-terrain.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc-terrain.json",
    "lpc-terrain.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc-terrain.png",
    "lpc/CREDITS.csv": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/CREDITS.csv",
    "lpc/spritesheets/authored/iron-pickaxe/female.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/iron-pickaxe/female.png",
    "lpc/spritesheets/authored/iron-pickaxe/female.png.frames.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/iron-pickaxe/female.png.frames.json",
    "lpc/spritesheets/authored/iron-pickaxe/female.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/iron-pickaxe/female.png.json",
    "lpc/spritesheets/authored/iron-pickaxe/male.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/iron-pickaxe/male.png",
    "lpc/spritesheets/authored/iron-pickaxe/male.png.frames.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/iron-pickaxe/male.png.frames.json",
    "lpc/spritesheets/authored/iron-pickaxe/male.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/iron-pickaxe/male.png.json",
    "lpc/spritesheets/authored/lpc-chicken.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/lpc-chicken.png",
    "lpc/spritesheets/authored/lpc-chicken.png.frames.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/lpc-chicken.png.frames.json",
    "lpc/spritesheets/authored/lpc-chicken.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/lpc-chicken.png.json",
    "lpc/spritesheets/authored/lpc-viper.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/lpc-viper.png",
    "lpc/spritesheets/authored/lpc-viper.png.frames.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/lpc-viper.png.frames.json",
    "lpc/spritesheets/authored/lpc-viper.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/lpc-viper.png.json",
    "lpc/spritesheets/authored/rage-slime.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/rage-slime.png",
    "lpc/spritesheets/authored/rage-slime.png.frames.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/rage-slime.png.frames.json",
    "lpc/spritesheets/authored/rage-slime.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/rage-slime.png.json",
    "lpc/spritesheets/authored/thistle.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/thistle.png",
    "lpc/spritesheets/authored/thistle.png.frames.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/thistle.png.frames.json",
    "lpc/spritesheets/authored/thistle.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/thistle.png.json",
    "lpc/spritesheets/authored/wild-hare.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/wild-hare.png",
    "lpc/spritesheets/authored/wild-hare.png.frames.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/wild-hare.png.frames.json",
    "lpc/spritesheets/authored/wild-hare.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/authored/wild-hare.png.json",
    "lpc/spritesheets/bauldron/female/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/bauldron/female/brown.png",
    "lpc/spritesheets/bauldron/female/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/bauldron/female/brown.png.json",
    "lpc/spritesheets/bauldron/male/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/bauldron/male/brown.png",
    "lpc/spritesheets/bauldron/male/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/bauldron/male/brown.png.json",
    "lpc/spritesheets/body/female/deer/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/deer/brown.png",
    "lpc/spritesheets/body/female/deer/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/deer/brown.png.json",
    "lpc/spritesheets/body/female/human/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/human/black.png",
    "lpc/spritesheets/body/female/human/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/human/black.png.json",
    "lpc/spritesheets/body/female/human/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/human/brown.png",
    "lpc/spritesheets/body/female/human/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/human/brown.png.json",
    "lpc/spritesheets/body/female/human/dark.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/human/dark.png",
    "lpc/spritesheets/body/female/human/dark.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/human/dark.png.json",
    "lpc/spritesheets/body/female/human/light.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/human/light.png",
    "lpc/spritesheets/body/female/human/light.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/human/light.png.json",
    "lpc/spritesheets/body/female/human/olive.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/human/olive.png",
    "lpc/spritesheets/body/female/human/olive.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/human/olive.png.json",
    "lpc/spritesheets/body/female/human/tanned.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/human/tanned.png",
    "lpc/spritesheets/body/female/human/tanned.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/human/tanned.png.json",
    "lpc/spritesheets/body/female/human/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/human/white.png",
    "lpc/spritesheets/body/female/human/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/human/white.png.json",
    "lpc/spritesheets/body/female/orcs/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/orcs/gray.png",
    "lpc/spritesheets/body/female/orcs/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/orcs/gray.png.json",
    "lpc/spritesheets/body/female/orcs/green_1.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/orcs/green_1.png",
    "lpc/spritesheets/body/female/orcs/green_1.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/orcs/green_1.png.json",
    "lpc/spritesheets/body/female/orcs/green_3.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/orcs/green_3.png",
    "lpc/spritesheets/body/female/orcs/green_3.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/orcs/green_3.png.json",
    "lpc/spritesheets/body/female/reptiles/blue_unwinged.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/reptiles/blue_unwinged.png",
    "lpc/spritesheets/body/female/reptiles/blue_unwinged.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/reptiles/blue_unwinged.png.json",
    "lpc/spritesheets/body/female/reptiles/blue_winged.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/reptiles/blue_winged.png",
    "lpc/spritesheets/body/female/reptiles/blue_winged.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/reptiles/blue_winged.png.json",
    "lpc/spritesheets/body/female/reptiles/green_unwinged.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/reptiles/green_unwinged.png",
    "lpc/spritesheets/body/female/reptiles/green_unwinged.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/reptiles/green_unwinged.png.json",
    "lpc/spritesheets/body/female/reptiles/green_winged.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/reptiles/green_winged.png",
    "lpc/spritesheets/body/female/reptiles/green_winged.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/reptiles/green_winged.png.json",
    "lpc/spritesheets/body/female/reptiles/lightgreen_unwinged.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/reptiles/lightgreen_unwinged.png",
    "lpc/spritesheets/body/female/reptiles/lightgreen_unwinged.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/reptiles/lightgreen_unwinged.png.json",
    "lpc/spritesheets/body/female/reptiles/lightgreen_winged.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/reptiles/lightgreen_winged.png",
    "lpc/spritesheets/body/female/reptiles/lightgreen_winged.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/reptiles/lightgreen_winged.png.json",
    "lpc/spritesheets/body/female/wolf/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/wolf/black.png",
    "lpc/spritesheets/body/female/wolf/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/wolf/black.png.json",
    "lpc/spritesheets/body/female/wolf/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/wolf/brown.png",
    "lpc/spritesheets/body/female/wolf/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/wolf/brown.png.json",
    "lpc/spritesheets/body/female/wolf/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/wolf/gray.png",
    "lpc/spritesheets/body/female/wolf/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/wolf/gray.png.json",
    "lpc/spritesheets/body/female/wolf/head/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/wolf/head/black.png",
    "lpc/spritesheets/body/female/wolf/head/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/wolf/head/black.png.json",
    "lpc/spritesheets/body/female/wolf/head/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/wolf/head/brown.png",
    "lpc/spritesheets/body/female/wolf/head/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/wolf/head/brown.png.json",
    "lpc/spritesheets/body/female/wolf/head/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/wolf/head/gray.png",
    "lpc/spritesheets/body/female/wolf/head/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/wolf/head/gray.png.json",
    "lpc/spritesheets/body/female/wolf/head/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/wolf/head/white.png",
    "lpc/spritesheets/body/female/wolf/head/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/wolf/head/white.png.json",
    "lpc/spritesheets/body/female/wolf/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/wolf/white.png",
    "lpc/spritesheets/body/female/wolf/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/female/wolf/white.png.json",
    "lpc/spritesheets/body/male/chicken/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/chicken/white.png",
    "lpc/spritesheets/body/male/chicken/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/chicken/white.png.json",
    "lpc/spritesheets/body/male/deer/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/deer/brown.png",
    "lpc/spritesheets/body/male/deer/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/deer/brown.png.json",
    "lpc/spritesheets/body/male/horse/burdened/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/horse/burdened/brown.png",
    "lpc/spritesheets/body/male/horse/burdened/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/horse/burdened/brown.png.json",
    "lpc/spritesheets/body/male/human/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/human/black.png",
    "lpc/spritesheets/body/male/human/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/human/black.png.json",
    "lpc/spritesheets/body/male/human/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/human/brown.png",
    "lpc/spritesheets/body/male/human/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/human/brown.png.json",
    "lpc/spritesheets/body/male/human/dark.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/human/dark.png",
    "lpc/spritesheets/body/male/human/dark.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/human/dark.png.json",
    "lpc/spritesheets/body/male/human/light.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/human/light.png",
    "lpc/spritesheets/body/male/human/light.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/human/light.png.json",
    "lpc/spritesheets/body/male/human/olive.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/human/olive.png",
    "lpc/spritesheets/body/male/human/olive.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/human/olive.png.json",
    "lpc/spritesheets/body/male/human/tanned.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/human/tanned.png",
    "lpc/spritesheets/body/male/human/tanned.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/human/tanned.png.json",
    "lpc/spritesheets/body/male/human/transparent.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/human/transparent.png",
    "lpc/spritesheets/body/male/human/transparent.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/human/transparent.png.json",
    "lpc/spritesheets/body/male/human/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/human/white.png",
    "lpc/spritesheets/body/male/human/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/human/white.png.json",
    "lpc/spritesheets/body/male/orcs/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/orcs/gray.png",
    "lpc/spritesheets/body/male/orcs/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/orcs/gray.png.json",
    "lpc/spritesheets/body/male/orcs/green_1.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/orcs/green_1.png",
    "lpc/spritesheets/body/male/orcs/green_1.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/orcs/green_1.png.json",
    "lpc/spritesheets/body/male/orcs/green_3.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/orcs/green_3.png",
    "lpc/spritesheets/body/male/orcs/green_3.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/orcs/green_3.png.json",
    "lpc/spritesheets/body/male/rabbit/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/rabbit/white.png",
    "lpc/spritesheets/body/male/rabbit/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/rabbit/white.png.json",
    "lpc/spritesheets/body/male/redspider/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/redspider/red.png",
    "lpc/spritesheets/body/male/redspider/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/redspider/red.png.json",
    "lpc/spritesheets/body/male/reptiles/blue_unwinged.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/reptiles/blue_unwinged.png",
    "lpc/spritesheets/body/male/reptiles/blue_unwinged.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/reptiles/blue_unwinged.png.json",
    "lpc/spritesheets/body/male/reptiles/blue_winged.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/reptiles/blue_winged.png",
    "lpc/spritesheets/body/male/reptiles/blue_winged.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/reptiles/blue_winged.png.json",
    "lpc/spritesheets/body/male/reptiles/green_unwinged.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/reptiles/green_unwinged.png",
    "lpc/spritesheets/body/male/reptiles/green_unwinged.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/reptiles/green_unwinged.png.json",
    "lpc/spritesheets/body/male/reptiles/green_winged.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/reptiles/green_winged.png",
    "lpc/spritesheets/body/male/reptiles/green_winged.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/reptiles/green_winged.png.json",
    "lpc/spritesheets/body/male/reptiles/lightgreen_unwinged.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/reptiles/lightgreen_unwinged.png",
    "lpc/spritesheets/body/male/reptiles/lightgreen_unwinged.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/reptiles/lightgreen_unwinged.png.json",
    "lpc/spritesheets/body/male/reptiles/lightgreen_winged.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/reptiles/lightgreen_winged.png",
    "lpc/spritesheets/body/male/reptiles/lightgreen_winged.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/reptiles/lightgreen_winged.png.json",
    "lpc/spritesheets/body/male/reptiles/red_winged.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/reptiles/red_winged.png",
    "lpc/spritesheets/body/male/reptiles/red_winged.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/reptiles/red_winged.png.json",
    "lpc/spritesheets/body/male/slime/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/slime/green.png",
    "lpc/spritesheets/body/male/slime/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/slime/green.png.json",
    "lpc/spritesheets/body/male/snake/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/snake/green.png",
    "lpc/spritesheets/body/male/snake/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/snake/green.png.json",
    "lpc/spritesheets/body/male/special/zombie.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/special/zombie.png",
    "lpc/spritesheets/body/male/special/zombie.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/special/zombie.png.json",
    "lpc/spritesheets/body/male/wasp/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/wasp/yellow.png",
    "lpc/spritesheets/body/male/wasp/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/wasp/yellow.png.json",
    "lpc/spritesheets/body/male/wolf/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/wolf/black.png",
    "lpc/spritesheets/body/male/wolf/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/wolf/black.png.json",
    "lpc/spritesheets/body/male/wolf/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/wolf/brown.png",
    "lpc/spritesheets/body/male/wolf/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/wolf/brown.png.json",
    "lpc/spritesheets/body/male/wolf/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/wolf/gray.png",
    "lpc/spritesheets/body/male/wolf/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/wolf/gray.png.json",
    "lpc/spritesheets/body/male/wolf/head/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/wolf/head/black.png",
    "lpc/spritesheets/body/male/wolf/head/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/wolf/head/black.png.json",
    "lpc/spritesheets/body/male/wolf/head/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/wolf/head/brown.png",
    "lpc/spritesheets/body/male/wolf/head/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/wolf/head/brown.png.json",
    "lpc/spritesheets/body/male/wolf/head/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/wolf/head/gray.png",
    "lpc/spritesheets/body/male/wolf/head/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/wolf/head/gray.png.json",
    "lpc/spritesheets/body/male/wolf/head/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/wolf/head/white.png",
    "lpc/spritesheets/body/male/wolf/head/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/wolf/head/white.png.json",
    "lpc/spritesheets/body/male/wolf/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/wolf/white.png",
    "lpc/spritesheets/body/male/wolf/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/male/wolf/white.png.json",
    "lpc/spritesheets/body/skeleton/beige.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/skeleton/beige.png",
    "lpc/spritesheets/body/skeleton/beige.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/skeleton/beige.png.json",
    "lpc/spritesheets/body/skeleton/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/skeleton/gray.png",
    "lpc/spritesheets/body/skeleton/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/skeleton/gray.png.json",
    "lpc/spritesheets/body/skeleton/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/skeleton/green.png",
    "lpc/spritesheets/body/skeleton/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/body/skeleton/green.png.json",
    "lpc/spritesheets/cape/solid/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid/male/black.png",
    "lpc/spritesheets/cape/solid/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid/male/black.png.json",
    "lpc/spritesheets/cape/solid/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid/male/blue.png",
    "lpc/spritesheets/cape/solid/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid/male/blue.png.json",
    "lpc/spritesheets/cape/solid/male/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid/male/brown.png",
    "lpc/spritesheets/cape/solid/male/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid/male/brown.png.json",
    "lpc/spritesheets/cape/solid/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid/male/gray.png",
    "lpc/spritesheets/cape/solid/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid/male/gray.png.json",
    "lpc/spritesheets/cape/solid/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid/male/green.png",
    "lpc/spritesheets/cape/solid/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid/male/green.png.json",
    "lpc/spritesheets/cape/solid/male/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid/male/maroon.png",
    "lpc/spritesheets/cape/solid/male/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid/male/maroon.png.json",
    "lpc/spritesheets/cape/solid/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid/male/red.png",
    "lpc/spritesheets/cape/solid/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid/male/red.png.json",
    "lpc/spritesheets/cape/solid/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid/male/white.png",
    "lpc/spritesheets/cape/solid/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid/male/white.png.json",
    "lpc/spritesheets/cape/solid/male/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid/male/yellow.png",
    "lpc/spritesheets/cape/solid/male/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid/male/yellow.png.json",
    "lpc/spritesheets/cape/solid_behind/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid_behind/black.png",
    "lpc/spritesheets/cape/solid_behind/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid_behind/black.png.json",
    "lpc/spritesheets/cape/solid_behind/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid_behind/blue.png",
    "lpc/spritesheets/cape/solid_behind/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid_behind/blue.png.json",
    "lpc/spritesheets/cape/solid_behind/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid_behind/brown.png",
    "lpc/spritesheets/cape/solid_behind/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid_behind/brown.png.json",
    "lpc/spritesheets/cape/solid_behind/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid_behind/gray.png",
    "lpc/spritesheets/cape/solid_behind/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid_behind/gray.png.json",
    "lpc/spritesheets/cape/solid_behind/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid_behind/green.png",
    "lpc/spritesheets/cape/solid_behind/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid_behind/green.png.json",
    "lpc/spritesheets/cape/solid_behind/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid_behind/maroon.png",
    "lpc/spritesheets/cape/solid_behind/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid_behind/maroon.png.json",
    "lpc/spritesheets/cape/solid_behind/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid_behind/red.png",
    "lpc/spritesheets/cape/solid_behind/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid_behind/red.png.json",
    "lpc/spritesheets/cape/solid_behind/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid_behind/white.png",
    "lpc/spritesheets/cape/solid_behind/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid_behind/white.png.json",
    "lpc/spritesheets/cape/solid_behind/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid_behind/yellow.png",
    "lpc/spritesheets/cape/solid_behind/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/solid_behind/yellow.png.json",
    "lpc/spritesheets/cape/tattered/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered/female/black.png",
    "lpc/spritesheets/cape/tattered/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered/female/black.png.json",
    "lpc/spritesheets/cape/tattered/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered/female/blue.png",
    "lpc/spritesheets/cape/tattered/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered/female/blue.png.json",
    "lpc/spritesheets/cape/tattered/female/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered/female/brown.png",
    "lpc/spritesheets/cape/tattered/female/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered/female/brown.png.json",
    "lpc/spritesheets/cape/tattered/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered/female/gray.png",
    "lpc/spritesheets/cape/tattered/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered/female/gray.png.json",
    "lpc/spritesheets/cape/tattered/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered/female/green.png",
    "lpc/spritesheets/cape/tattered/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered/female/green.png.json",
    "lpc/spritesheets/cape/tattered/female/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered/female/maroon.png",
    "lpc/spritesheets/cape/tattered/female/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered/female/maroon.png.json",
    "lpc/spritesheets/cape/tattered/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered/female/red.png",
    "lpc/spritesheets/cape/tattered/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered/female/red.png.json",
    "lpc/spritesheets/cape/tattered/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered/female/white.png",
    "lpc/spritesheets/cape/tattered/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered/female/white.png.json",
    "lpc/spritesheets/cape/tattered/female/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered/female/yellow.png",
    "lpc/spritesheets/cape/tattered/female/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered/female/yellow.png.json",
    "lpc/spritesheets/cape/tattered_behind/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered_behind/black.png",
    "lpc/spritesheets/cape/tattered_behind/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered_behind/black.png.json",
    "lpc/spritesheets/cape/tattered_behind/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered_behind/blue.png",
    "lpc/spritesheets/cape/tattered_behind/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered_behind/blue.png.json",
    "lpc/spritesheets/cape/tattered_behind/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered_behind/brown.png",
    "lpc/spritesheets/cape/tattered_behind/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered_behind/brown.png.json",
    "lpc/spritesheets/cape/tattered_behind/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered_behind/gray.png",
    "lpc/spritesheets/cape/tattered_behind/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered_behind/gray.png.json",
    "lpc/spritesheets/cape/tattered_behind/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered_behind/green.png",
    "lpc/spritesheets/cape/tattered_behind/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered_behind/green.png.json",
    "lpc/spritesheets/cape/tattered_behind/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered_behind/maroon.png",
    "lpc/spritesheets/cape/tattered_behind/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered_behind/maroon.png.json",
    "lpc/spritesheets/cape/tattered_behind/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered_behind/red.png",
    "lpc/spritesheets/cape/tattered_behind/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered_behind/red.png.json",
    "lpc/spritesheets/cape/tattered_behind/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered_behind/white.png",
    "lpc/spritesheets/cape/tattered_behind/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered_behind/white.png.json",
    "lpc/spritesheets/cape/tattered_behind/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered_behind/yellow.png",
    "lpc/spritesheets/cape/tattered_behind/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/tattered_behind/yellow.png.json",
    "lpc/spritesheets/cape/trimmed/female/white_blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/trimmed/female/white_blue.png",
    "lpc/spritesheets/cape/trimmed/female/white_blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/trimmed/female/white_blue.png.json",
    "lpc/spritesheets/cape/trimmed_behind/white_blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/trimmed_behind/white_blue.png",
    "lpc/spritesheets/cape/trimmed_behind/white_blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/cape/trimmed_behind/white_blue.png.json",
    "lpc/spritesheets/eyes/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/female/blue.png",
    "lpc/spritesheets/eyes/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/female/blue.png.json",
    "lpc/spritesheets/eyes/female/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/female/brown.png",
    "lpc/spritesheets/eyes/female/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/female/brown.png.json",
    "lpc/spritesheets/eyes/female/cyclope.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/female/cyclope.png",
    "lpc/spritesheets/eyes/female/cyclope.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/female/cyclope.png.json",
    "lpc/spritesheets/eyes/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/female/gray.png",
    "lpc/spritesheets/eyes/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/female/gray.png.json",
    "lpc/spritesheets/eyes/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/female/green.png",
    "lpc/spritesheets/eyes/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/female/green.png.json",
    "lpc/spritesheets/eyes/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/female/orange.png",
    "lpc/spritesheets/eyes/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/female/orange.png.json",
    "lpc/spritesheets/eyes/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/female/purple.png",
    "lpc/spritesheets/eyes/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/female/purple.png.json",
    "lpc/spritesheets/eyes/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/female/red.png",
    "lpc/spritesheets/eyes/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/female/red.png.json",
    "lpc/spritesheets/eyes/female/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/female/yellow.png",
    "lpc/spritesheets/eyes/female/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/female/yellow.png.json",
    "lpc/spritesheets/eyes/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/male/blue.png",
    "lpc/spritesheets/eyes/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/male/blue.png.json",
    "lpc/spritesheets/eyes/male/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/male/brown.png",
    "lpc/spritesheets/eyes/male/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/male/brown.png.json",
    "lpc/spritesheets/eyes/male/cyclope.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/male/cyclope.png",
    "lpc/spritesheets/eyes/male/cyclope.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/male/cyclope.png.json",
    "lpc/spritesheets/eyes/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/male/gray.png",
    "lpc/spritesheets/eyes/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/male/gray.png.json",
    "lpc/spritesheets/eyes/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/male/green.png",
    "lpc/spritesheets/eyes/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/male/green.png.json",
    "lpc/spritesheets/eyes/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/male/orange.png",
    "lpc/spritesheets/eyes/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/male/orange.png.json",
    "lpc/spritesheets/eyes/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/male/purple.png",
    "lpc/spritesheets/eyes/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/male/purple.png.json",
    "lpc/spritesheets/eyes/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/male/red.png",
    "lpc/spritesheets/eyes/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/male/red.png.json",
    "lpc/spritesheets/eyes/male/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/male/yellow.png",
    "lpc/spritesheets/eyes/male/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/eyes/male/yellow.png.json",
    "lpc/spritesheets/feet/armor/female/4.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/female/4.png",
    "lpc/spritesheets/feet/armor/female/4.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/female/4.png.json",
    "lpc/spritesheets/feet/armor/female/5.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/female/5.png",
    "lpc/spritesheets/feet/armor/female/5.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/female/5.png.json",
    "lpc/spritesheets/feet/armor/female/6.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/female/6.png",
    "lpc/spritesheets/feet/armor/female/6.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/female/6.png.json",
    "lpc/spritesheets/feet/armor/female/7.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/female/7.png",
    "lpc/spritesheets/feet/armor/female/7.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/female/7.png.json",
    "lpc/spritesheets/feet/armor/female/8.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/female/8.png",
    "lpc/spritesheets/feet/armor/female/8.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/female/8.png.json",
    "lpc/spritesheets/feet/armor/female/9.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/female/9.png",
    "lpc/spritesheets/feet/armor/female/9.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/female/9.png.json",
    "lpc/spritesheets/feet/armor/male/4.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/male/4.png",
    "lpc/spritesheets/feet/armor/male/4.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/male/4.png.json",
    "lpc/spritesheets/feet/armor/male/5.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/male/5.png",
    "lpc/spritesheets/feet/armor/male/5.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/male/5.png.json",
    "lpc/spritesheets/feet/armor/male/6.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/male/6.png",
    "lpc/spritesheets/feet/armor/male/6.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/male/6.png.json",
    "lpc/spritesheets/feet/armor/male/7.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/male/7.png",
    "lpc/spritesheets/feet/armor/male/7.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/male/7.png.json",
    "lpc/spritesheets/feet/armor/male/8.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/male/8.png",
    "lpc/spritesheets/feet/armor/male/8.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/male/8.png.json",
    "lpc/spritesheets/feet/armor/male/9.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/male/9.png",
    "lpc/spritesheets/feet/armor/male/9.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/armor/male/9.png.json",
    "lpc/spritesheets/feet/boots/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/black.png",
    "lpc/spritesheets/feet/boots/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/black.png.json",
    "lpc/spritesheets/feet/boots/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/blue.png",
    "lpc/spritesheets/feet/boots/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/blue.png.json",
    "lpc/spritesheets/feet/boots/female/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/brown.png",
    "lpc/spritesheets/feet/boots/female/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/brown.png.json",
    "lpc/spritesheets/feet/boots/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/gray.png",
    "lpc/spritesheets/feet/boots/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/gray.png.json",
    "lpc/spritesheets/feet/boots/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/green.png",
    "lpc/spritesheets/feet/boots/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/green.png.json",
    "lpc/spritesheets/feet/boots/female/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/maroon.png",
    "lpc/spritesheets/feet/boots/female/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/maroon.png.json",
    "lpc/spritesheets/feet/boots/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/orange.png",
    "lpc/spritesheets/feet/boots/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/orange.png.json",
    "lpc/spritesheets/feet/boots/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/purple.png",
    "lpc/spritesheets/feet/boots/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/purple.png.json",
    "lpc/spritesheets/feet/boots/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/red.png",
    "lpc/spritesheets/feet/boots/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/red.png.json",
    "lpc/spritesheets/feet/boots/female/tan.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/tan.png",
    "lpc/spritesheets/feet/boots/female/tan.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/tan.png.json",
    "lpc/spritesheets/feet/boots/female/teal.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/teal.png",
    "lpc/spritesheets/feet/boots/female/teal.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/teal.png.json",
    "lpc/spritesheets/feet/boots/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/white.png",
    "lpc/spritesheets/feet/boots/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/white.png.json",
    "lpc/spritesheets/feet/boots/female/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/yellow.png",
    "lpc/spritesheets/feet/boots/female/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/female/yellow.png.json",
    "lpc/spritesheets/feet/boots/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/black.png",
    "lpc/spritesheets/feet/boots/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/black.png.json",
    "lpc/spritesheets/feet/boots/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/blue.png",
    "lpc/spritesheets/feet/boots/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/blue.png.json",
    "lpc/spritesheets/feet/boots/male/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/brown.png",
    "lpc/spritesheets/feet/boots/male/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/brown.png.json",
    "lpc/spritesheets/feet/boots/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/gray.png",
    "lpc/spritesheets/feet/boots/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/gray.png.json",
    "lpc/spritesheets/feet/boots/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/green.png",
    "lpc/spritesheets/feet/boots/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/green.png.json",
    "lpc/spritesheets/feet/boots/male/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/maroon.png",
    "lpc/spritesheets/feet/boots/male/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/maroon.png.json",
    "lpc/spritesheets/feet/boots/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/orange.png",
    "lpc/spritesheets/feet/boots/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/orange.png.json",
    "lpc/spritesheets/feet/boots/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/purple.png",
    "lpc/spritesheets/feet/boots/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/purple.png.json",
    "lpc/spritesheets/feet/boots/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/red.png",
    "lpc/spritesheets/feet/boots/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/red.png.json",
    "lpc/spritesheets/feet/boots/male/tan.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/tan.png",
    "lpc/spritesheets/feet/boots/male/tan.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/tan.png.json",
    "lpc/spritesheets/feet/boots/male/teal.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/teal.png",
    "lpc/spritesheets/feet/boots/male/teal.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/teal.png.json",
    "lpc/spritesheets/feet/boots/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/white.png",
    "lpc/spritesheets/feet/boots/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/white.png.json",
    "lpc/spritesheets/feet/boots/male/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/yellow.png",
    "lpc/spritesheets/feet/boots/male/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/boots/male/yellow.png.json",
    "lpc/spritesheets/feet/sandals/female/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/sandals/female/brown.png",
    "lpc/spritesheets/feet/sandals/female/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/sandals/female/brown.png.json",
    "lpc/spritesheets/feet/sandals/male/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/sandals/male/brown.png",
    "lpc/spritesheets/feet/sandals/male/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/sandals/male/brown.png.json",
    "lpc/spritesheets/feet/shoes/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/shoes/female/black.png",
    "lpc/spritesheets/feet/shoes/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/shoes/female/black.png.json",
    "lpc/spritesheets/feet/shoes/female/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/shoes/female/brown.png",
    "lpc/spritesheets/feet/shoes/female/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/shoes/female/brown.png.json",
    "lpc/spritesheets/feet/shoes/female/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/shoes/female/maroon.png",
    "lpc/spritesheets/feet/shoes/female/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/shoes/female/maroon.png.json",
    "lpc/spritesheets/feet/shoes/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/shoes/male/black.png",
    "lpc/spritesheets/feet/shoes/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/shoes/male/black.png.json",
    "lpc/spritesheets/feet/shoes/male/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/shoes/male/brown.png",
    "lpc/spritesheets/feet/shoes/male/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/shoes/male/brown.png.json",
    "lpc/spritesheets/feet/shoes/male/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/shoes/male/maroon.png",
    "lpc/spritesheets/feet/shoes/male/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/shoes/male/maroon.png.json",
    "lpc/spritesheets/feet/slippers/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/slippers/female/black.png",
    "lpc/spritesheets/feet/slippers/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/slippers/female/black.png.json",
    "lpc/spritesheets/feet/slippers/female/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/slippers/female/brown.png",
    "lpc/spritesheets/feet/slippers/female/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/slippers/female/brown.png.json",
    "lpc/spritesheets/feet/slippers/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/slippers/female/gray.png",
    "lpc/spritesheets/feet/slippers/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/feet/slippers/female/gray.png.json",
    "lpc/spritesheets/hair/afro/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/black.png",
    "lpc/spritesheets/hair/afro/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/black.png.json",
    "lpc/spritesheets/hair/afro/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/blonde.png",
    "lpc/spritesheets/hair/afro/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/blonde.png.json",
    "lpc/spritesheets/hair/afro/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/blue.png",
    "lpc/spritesheets/hair/afro/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/blue.png.json",
    "lpc/spritesheets/hair/afro/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/dark_brown.png",
    "lpc/spritesheets/hair/afro/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/dark_brown.png.json",
    "lpc/spritesheets/hair/afro/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/gold.png",
    "lpc/spritesheets/hair/afro/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/gold.png.json",
    "lpc/spritesheets/hair/afro/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/gray.png",
    "lpc/spritesheets/hair/afro/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/gray.png.json",
    "lpc/spritesheets/hair/afro/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/green.png",
    "lpc/spritesheets/hair/afro/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/green.png.json",
    "lpc/spritesheets/hair/afro/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/light_brown.png",
    "lpc/spritesheets/hair/afro/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/light_brown.png.json",
    "lpc/spritesheets/hair/afro/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/orange.png",
    "lpc/spritesheets/hair/afro/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/orange.png.json",
    "lpc/spritesheets/hair/afro/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/purple.png",
    "lpc/spritesheets/hair/afro/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/purple.png.json",
    "lpc/spritesheets/hair/afro/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/red.png",
    "lpc/spritesheets/hair/afro/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/red.png.json",
    "lpc/spritesheets/hair/afro/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/white.png",
    "lpc/spritesheets/hair/afro/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/female/white.png.json",
    "lpc/spritesheets/hair/afro/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/black.png",
    "lpc/spritesheets/hair/afro/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/black.png.json",
    "lpc/spritesheets/hair/afro/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/blonde.png",
    "lpc/spritesheets/hair/afro/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/blonde.png.json",
    "lpc/spritesheets/hair/afro/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/blue.png",
    "lpc/spritesheets/hair/afro/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/blue.png.json",
    "lpc/spritesheets/hair/afro/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/dark_brown.png",
    "lpc/spritesheets/hair/afro/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/dark_brown.png.json",
    "lpc/spritesheets/hair/afro/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/gold.png",
    "lpc/spritesheets/hair/afro/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/gold.png.json",
    "lpc/spritesheets/hair/afro/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/gray.png",
    "lpc/spritesheets/hair/afro/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/gray.png.json",
    "lpc/spritesheets/hair/afro/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/green.png",
    "lpc/spritesheets/hair/afro/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/green.png.json",
    "lpc/spritesheets/hair/afro/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/light_brown.png",
    "lpc/spritesheets/hair/afro/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/light_brown.png.json",
    "lpc/spritesheets/hair/afro/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/orange.png",
    "lpc/spritesheets/hair/afro/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/orange.png.json",
    "lpc/spritesheets/hair/afro/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/purple.png",
    "lpc/spritesheets/hair/afro/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/purple.png.json",
    "lpc/spritesheets/hair/afro/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/red.png",
    "lpc/spritesheets/hair/afro/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/red.png.json",
    "lpc/spritesheets/hair/afro/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/white.png",
    "lpc/spritesheets/hair/afro/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/afro/male/white.png.json",
    "lpc/spritesheets/hair/balding/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/black.png",
    "lpc/spritesheets/hair/balding/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/black.png.json",
    "lpc/spritesheets/hair/balding/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/blonde.png",
    "lpc/spritesheets/hair/balding/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/blonde.png.json",
    "lpc/spritesheets/hair/balding/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/blue.png",
    "lpc/spritesheets/hair/balding/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/blue.png.json",
    "lpc/spritesheets/hair/balding/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/dark_brown.png",
    "lpc/spritesheets/hair/balding/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/dark_brown.png.json",
    "lpc/spritesheets/hair/balding/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/gold.png",
    "lpc/spritesheets/hair/balding/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/gold.png.json",
    "lpc/spritesheets/hair/balding/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/gray.png",
    "lpc/spritesheets/hair/balding/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/gray.png.json",
    "lpc/spritesheets/hair/balding/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/green.png",
    "lpc/spritesheets/hair/balding/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/green.png.json",
    "lpc/spritesheets/hair/balding/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/light_brown.png",
    "lpc/spritesheets/hair/balding/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/light_brown.png.json",
    "lpc/spritesheets/hair/balding/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/orange.png",
    "lpc/spritesheets/hair/balding/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/orange.png.json",
    "lpc/spritesheets/hair/balding/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/purple.png",
    "lpc/spritesheets/hair/balding/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/purple.png.json",
    "lpc/spritesheets/hair/balding/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/red.png",
    "lpc/spritesheets/hair/balding/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/red.png.json",
    "lpc/spritesheets/hair/balding/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/white.png",
    "lpc/spritesheets/hair/balding/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/female/white.png.json",
    "lpc/spritesheets/hair/balding/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/black.png",
    "lpc/spritesheets/hair/balding/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/black.png.json",
    "lpc/spritesheets/hair/balding/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/blonde.png",
    "lpc/spritesheets/hair/balding/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/blonde.png.json",
    "lpc/spritesheets/hair/balding/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/blue.png",
    "lpc/spritesheets/hair/balding/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/blue.png.json",
    "lpc/spritesheets/hair/balding/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/dark_brown.png",
    "lpc/spritesheets/hair/balding/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/dark_brown.png.json",
    "lpc/spritesheets/hair/balding/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/gold.png",
    "lpc/spritesheets/hair/balding/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/gold.png.json",
    "lpc/spritesheets/hair/balding/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/gray.png",
    "lpc/spritesheets/hair/balding/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/gray.png.json",
    "lpc/spritesheets/hair/balding/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/green.png",
    "lpc/spritesheets/hair/balding/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/green.png.json",
    "lpc/spritesheets/hair/balding/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/light_brown.png",
    "lpc/spritesheets/hair/balding/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/light_brown.png.json",
    "lpc/spritesheets/hair/balding/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/orange.png",
    "lpc/spritesheets/hair/balding/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/orange.png.json",
    "lpc/spritesheets/hair/balding/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/purple.png",
    "lpc/spritesheets/hair/balding/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/purple.png.json",
    "lpc/spritesheets/hair/balding/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/red.png",
    "lpc/spritesheets/hair/balding/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/red.png.json",
    "lpc/spritesheets/hair/balding/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/white.png",
    "lpc/spritesheets/hair/balding/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/balding/male/white.png.json",
    "lpc/spritesheets/hair/bangs/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/black.png",
    "lpc/spritesheets/hair/bangs/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/black.png.json",
    "lpc/spritesheets/hair/bangs/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/blonde.png",
    "lpc/spritesheets/hair/bangs/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/blonde.png.json",
    "lpc/spritesheets/hair/bangs/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/blue.png",
    "lpc/spritesheets/hair/bangs/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/blue.png.json",
    "lpc/spritesheets/hair/bangs/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/dark_brown.png",
    "lpc/spritesheets/hair/bangs/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/dark_brown.png.json",
    "lpc/spritesheets/hair/bangs/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/gold.png",
    "lpc/spritesheets/hair/bangs/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/gold.png.json",
    "lpc/spritesheets/hair/bangs/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/gray.png",
    "lpc/spritesheets/hair/bangs/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/gray.png.json",
    "lpc/spritesheets/hair/bangs/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/green.png",
    "lpc/spritesheets/hair/bangs/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/green.png.json",
    "lpc/spritesheets/hair/bangs/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/light_brown.png",
    "lpc/spritesheets/hair/bangs/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/light_brown.png.json",
    "lpc/spritesheets/hair/bangs/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/orange.png",
    "lpc/spritesheets/hair/bangs/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/orange.png.json",
    "lpc/spritesheets/hair/bangs/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/purple.png",
    "lpc/spritesheets/hair/bangs/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/purple.png.json",
    "lpc/spritesheets/hair/bangs/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/red.png",
    "lpc/spritesheets/hair/bangs/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/red.png.json",
    "lpc/spritesheets/hair/bangs/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/white.png",
    "lpc/spritesheets/hair/bangs/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/female/white.png.json",
    "lpc/spritesheets/hair/bangs/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/black.png",
    "lpc/spritesheets/hair/bangs/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/black.png.json",
    "lpc/spritesheets/hair/bangs/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/blonde.png",
    "lpc/spritesheets/hair/bangs/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/blonde.png.json",
    "lpc/spritesheets/hair/bangs/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/blue.png",
    "lpc/spritesheets/hair/bangs/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/blue.png.json",
    "lpc/spritesheets/hair/bangs/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/dark_brown.png",
    "lpc/spritesheets/hair/bangs/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/dark_brown.png.json",
    "lpc/spritesheets/hair/bangs/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/gold.png",
    "lpc/spritesheets/hair/bangs/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/gold.png.json",
    "lpc/spritesheets/hair/bangs/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/gray.png",
    "lpc/spritesheets/hair/bangs/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/gray.png.json",
    "lpc/spritesheets/hair/bangs/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/green.png",
    "lpc/spritesheets/hair/bangs/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/green.png.json",
    "lpc/spritesheets/hair/bangs/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/light_brown.png",
    "lpc/spritesheets/hair/bangs/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/light_brown.png.json",
    "lpc/spritesheets/hair/bangs/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/orange.png",
    "lpc/spritesheets/hair/bangs/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/orange.png.json",
    "lpc/spritesheets/hair/bangs/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/purple.png",
    "lpc/spritesheets/hair/bangs/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/purple.png.json",
    "lpc/spritesheets/hair/bangs/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/red.png",
    "lpc/spritesheets/hair/bangs/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/red.png.json",
    "lpc/spritesheets/hair/bangs/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/white.png",
    "lpc/spritesheets/hair/bangs/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs/male/white.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/black.png",
    "lpc/spritesheets/hair/bangs_bun/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/black.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/blonde.png",
    "lpc/spritesheets/hair/bangs_bun/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/blonde.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/blue.png",
    "lpc/spritesheets/hair/bangs_bun/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/blue.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/dark_brown.png",
    "lpc/spritesheets/hair/bangs_bun/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/dark_brown.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/gold.png",
    "lpc/spritesheets/hair/bangs_bun/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/gold.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/gray.png",
    "lpc/spritesheets/hair/bangs_bun/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/gray.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/green.png",
    "lpc/spritesheets/hair/bangs_bun/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/green.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/light_brown.png",
    "lpc/spritesheets/hair/bangs_bun/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/light_brown.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/orange.png",
    "lpc/spritesheets/hair/bangs_bun/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/orange.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/purple.png",
    "lpc/spritesheets/hair/bangs_bun/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/purple.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/red.png",
    "lpc/spritesheets/hair/bangs_bun/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/red.png.json",
    "lpc/spritesheets/hair/bangs_bun/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/white.png",
    "lpc/spritesheets/hair/bangs_bun/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/female/white.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/black.png",
    "lpc/spritesheets/hair/bangs_bun/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/black.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/blonde.png",
    "lpc/spritesheets/hair/bangs_bun/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/blonde.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/blue.png",
    "lpc/spritesheets/hair/bangs_bun/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/blue.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/dark_brown.png",
    "lpc/spritesheets/hair/bangs_bun/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/dark_brown.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/gold.png",
    "lpc/spritesheets/hair/bangs_bun/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/gold.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/gray.png",
    "lpc/spritesheets/hair/bangs_bun/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/gray.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/green.png",
    "lpc/spritesheets/hair/bangs_bun/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/green.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/light_brown.png",
    "lpc/spritesheets/hair/bangs_bun/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/light_brown.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/orange.png",
    "lpc/spritesheets/hair/bangs_bun/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/orange.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/purple.png",
    "lpc/spritesheets/hair/bangs_bun/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/purple.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/red.png",
    "lpc/spritesheets/hair/bangs_bun/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/red.png.json",
    "lpc/spritesheets/hair/bangs_bun/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/white.png",
    "lpc/spritesheets/hair/bangs_bun/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangs_bun/male/white.png.json",
    "lpc/spritesheets/hair/bangslong/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/black.png",
    "lpc/spritesheets/hair/bangslong/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/black.png.json",
    "lpc/spritesheets/hair/bangslong/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/blonde.png",
    "lpc/spritesheets/hair/bangslong/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/blonde.png.json",
    "lpc/spritesheets/hair/bangslong/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/blue.png",
    "lpc/spritesheets/hair/bangslong/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/blue.png.json",
    "lpc/spritesheets/hair/bangslong/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/dark_brown.png",
    "lpc/spritesheets/hair/bangslong/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/dark_brown.png.json",
    "lpc/spritesheets/hair/bangslong/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/gold.png",
    "lpc/spritesheets/hair/bangslong/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/gold.png.json",
    "lpc/spritesheets/hair/bangslong/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/gray.png",
    "lpc/spritesheets/hair/bangslong/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/gray.png.json",
    "lpc/spritesheets/hair/bangslong/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/green.png",
    "lpc/spritesheets/hair/bangslong/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/green.png.json",
    "lpc/spritesheets/hair/bangslong/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/light_brown.png",
    "lpc/spritesheets/hair/bangslong/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/light_brown.png.json",
    "lpc/spritesheets/hair/bangslong/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/orange.png",
    "lpc/spritesheets/hair/bangslong/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/orange.png.json",
    "lpc/spritesheets/hair/bangslong/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/purple.png",
    "lpc/spritesheets/hair/bangslong/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/purple.png.json",
    "lpc/spritesheets/hair/bangslong/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/red.png",
    "lpc/spritesheets/hair/bangslong/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/red.png.json",
    "lpc/spritesheets/hair/bangslong/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/white.png",
    "lpc/spritesheets/hair/bangslong/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/female/white.png.json",
    "lpc/spritesheets/hair/bangslong/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/black.png",
    "lpc/spritesheets/hair/bangslong/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/black.png.json",
    "lpc/spritesheets/hair/bangslong/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/blonde.png",
    "lpc/spritesheets/hair/bangslong/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/blonde.png.json",
    "lpc/spritesheets/hair/bangslong/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/blue.png",
    "lpc/spritesheets/hair/bangslong/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/blue.png.json",
    "lpc/spritesheets/hair/bangslong/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/dark_brown.png",
    "lpc/spritesheets/hair/bangslong/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/dark_brown.png.json",
    "lpc/spritesheets/hair/bangslong/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/gold.png",
    "lpc/spritesheets/hair/bangslong/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/gold.png.json",
    "lpc/spritesheets/hair/bangslong/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/gray.png",
    "lpc/spritesheets/hair/bangslong/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/gray.png.json",
    "lpc/spritesheets/hair/bangslong/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/green.png",
    "lpc/spritesheets/hair/bangslong/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/green.png.json",
    "lpc/spritesheets/hair/bangslong/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/light_brown.png",
    "lpc/spritesheets/hair/bangslong/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/light_brown.png.json",
    "lpc/spritesheets/hair/bangslong/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/orange.png",
    "lpc/spritesheets/hair/bangslong/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/orange.png.json",
    "lpc/spritesheets/hair/bangslong/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/purple.png",
    "lpc/spritesheets/hair/bangslong/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/purple.png.json",
    "lpc/spritesheets/hair/bangslong/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/red.png",
    "lpc/spritesheets/hair/bangslong/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/red.png.json",
    "lpc/spritesheets/hair/bangslong/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/white.png",
    "lpc/spritesheets/hair/bangslong/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong/male/white.png.json",
    "lpc/spritesheets/hair/bangslong2/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/black.png",
    "lpc/spritesheets/hair/bangslong2/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/black.png.json",
    "lpc/spritesheets/hair/bangslong2/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/blonde.png",
    "lpc/spritesheets/hair/bangslong2/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/blonde.png.json",
    "lpc/spritesheets/hair/bangslong2/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/blue.png",
    "lpc/spritesheets/hair/bangslong2/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/blue.png.json",
    "lpc/spritesheets/hair/bangslong2/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/dark_brown.png",
    "lpc/spritesheets/hair/bangslong2/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/dark_brown.png.json",
    "lpc/spritesheets/hair/bangslong2/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/gold.png",
    "lpc/spritesheets/hair/bangslong2/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/gold.png.json",
    "lpc/spritesheets/hair/bangslong2/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/gray.png",
    "lpc/spritesheets/hair/bangslong2/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/gray.png.json",
    "lpc/spritesheets/hair/bangslong2/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/green.png",
    "lpc/spritesheets/hair/bangslong2/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/green.png.json",
    "lpc/spritesheets/hair/bangslong2/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/light_brown.png",
    "lpc/spritesheets/hair/bangslong2/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/light_brown.png.json",
    "lpc/spritesheets/hair/bangslong2/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/orange.png",
    "lpc/spritesheets/hair/bangslong2/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/orange.png.json",
    "lpc/spritesheets/hair/bangslong2/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/purple.png",
    "lpc/spritesheets/hair/bangslong2/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/purple.png.json",
    "lpc/spritesheets/hair/bangslong2/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/red.png",
    "lpc/spritesheets/hair/bangslong2/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/red.png.json",
    "lpc/spritesheets/hair/bangslong2/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/white.png",
    "lpc/spritesheets/hair/bangslong2/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/female/white.png.json",
    "lpc/spritesheets/hair/bangslong2/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/black.png",
    "lpc/spritesheets/hair/bangslong2/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/black.png.json",
    "lpc/spritesheets/hair/bangslong2/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/blonde.png",
    "lpc/spritesheets/hair/bangslong2/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/blonde.png.json",
    "lpc/spritesheets/hair/bangslong2/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/blue.png",
    "lpc/spritesheets/hair/bangslong2/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/blue.png.json",
    "lpc/spritesheets/hair/bangslong2/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/dark_brown.png",
    "lpc/spritesheets/hair/bangslong2/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/dark_brown.png.json",
    "lpc/spritesheets/hair/bangslong2/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/gold.png",
    "lpc/spritesheets/hair/bangslong2/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/gold.png.json",
    "lpc/spritesheets/hair/bangslong2/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/gray.png",
    "lpc/spritesheets/hair/bangslong2/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/gray.png.json",
    "lpc/spritesheets/hair/bangslong2/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/green.png",
    "lpc/spritesheets/hair/bangslong2/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/green.png.json",
    "lpc/spritesheets/hair/bangslong2/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/light_brown.png",
    "lpc/spritesheets/hair/bangslong2/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/light_brown.png.json",
    "lpc/spritesheets/hair/bangslong2/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/orange.png",
    "lpc/spritesheets/hair/bangslong2/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/orange.png.json",
    "lpc/spritesheets/hair/bangslong2/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/purple.png",
    "lpc/spritesheets/hair/bangslong2/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/purple.png.json",
    "lpc/spritesheets/hair/bangslong2/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/red.png",
    "lpc/spritesheets/hair/bangslong2/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/red.png.json",
    "lpc/spritesheets/hair/bangslong2/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/white.png",
    "lpc/spritesheets/hair/bangslong2/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangslong2/male/white.png.json",
    "lpc/spritesheets/hair/bangsshort/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/black.png",
    "lpc/spritesheets/hair/bangsshort/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/black.png.json",
    "lpc/spritesheets/hair/bangsshort/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/blonde.png",
    "lpc/spritesheets/hair/bangsshort/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/blonde.png.json",
    "lpc/spritesheets/hair/bangsshort/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/blue.png",
    "lpc/spritesheets/hair/bangsshort/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/blue.png.json",
    "lpc/spritesheets/hair/bangsshort/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/dark_brown.png",
    "lpc/spritesheets/hair/bangsshort/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/dark_brown.png.json",
    "lpc/spritesheets/hair/bangsshort/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/gold.png",
    "lpc/spritesheets/hair/bangsshort/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/gold.png.json",
    "lpc/spritesheets/hair/bangsshort/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/gray.png",
    "lpc/spritesheets/hair/bangsshort/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/gray.png.json",
    "lpc/spritesheets/hair/bangsshort/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/green.png",
    "lpc/spritesheets/hair/bangsshort/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/green.png.json",
    "lpc/spritesheets/hair/bangsshort/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/light_brown.png",
    "lpc/spritesheets/hair/bangsshort/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/light_brown.png.json",
    "lpc/spritesheets/hair/bangsshort/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/orange.png",
    "lpc/spritesheets/hair/bangsshort/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/orange.png.json",
    "lpc/spritesheets/hair/bangsshort/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/purple.png",
    "lpc/spritesheets/hair/bangsshort/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/purple.png.json",
    "lpc/spritesheets/hair/bangsshort/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/red.png",
    "lpc/spritesheets/hair/bangsshort/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/red.png.json",
    "lpc/spritesheets/hair/bangsshort/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/white.png",
    "lpc/spritesheets/hair/bangsshort/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/female/white.png.json",
    "lpc/spritesheets/hair/bangsshort/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/black.png",
    "lpc/spritesheets/hair/bangsshort/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/black.png.json",
    "lpc/spritesheets/hair/bangsshort/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/blonde.png",
    "lpc/spritesheets/hair/bangsshort/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/blonde.png.json",
    "lpc/spritesheets/hair/bangsshort/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/blue.png",
    "lpc/spritesheets/hair/bangsshort/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/blue.png.json",
    "lpc/spritesheets/hair/bangsshort/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/dark_brown.png",
    "lpc/spritesheets/hair/bangsshort/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/dark_brown.png.json",
    "lpc/spritesheets/hair/bangsshort/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/gold.png",
    "lpc/spritesheets/hair/bangsshort/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/gold.png.json",
    "lpc/spritesheets/hair/bangsshort/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/gray.png",
    "lpc/spritesheets/hair/bangsshort/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/gray.png.json",
    "lpc/spritesheets/hair/bangsshort/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/green.png",
    "lpc/spritesheets/hair/bangsshort/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/green.png.json",
    "lpc/spritesheets/hair/bangsshort/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/light_brown.png",
    "lpc/spritesheets/hair/bangsshort/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/light_brown.png.json",
    "lpc/spritesheets/hair/bangsshort/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/orange.png",
    "lpc/spritesheets/hair/bangsshort/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/orange.png.json",
    "lpc/spritesheets/hair/bangsshort/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/purple.png",
    "lpc/spritesheets/hair/bangsshort/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/purple.png.json",
    "lpc/spritesheets/hair/bangsshort/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/red.png",
    "lpc/spritesheets/hair/bangsshort/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/red.png.json",
    "lpc/spritesheets/hair/bangsshort/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/white.png",
    "lpc/spritesheets/hair/bangsshort/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bangsshort/male/white.png.json",
    "lpc/spritesheets/hair/bedhead/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/black.png",
    "lpc/spritesheets/hair/bedhead/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/black.png.json",
    "lpc/spritesheets/hair/bedhead/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/blonde.png",
    "lpc/spritesheets/hair/bedhead/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/blonde.png.json",
    "lpc/spritesheets/hair/bedhead/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/blue.png",
    "lpc/spritesheets/hair/bedhead/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/blue.png.json",
    "lpc/spritesheets/hair/bedhead/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/dark_brown.png",
    "lpc/spritesheets/hair/bedhead/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/dark_brown.png.json",
    "lpc/spritesheets/hair/bedhead/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/gold.png",
    "lpc/spritesheets/hair/bedhead/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/gold.png.json",
    "lpc/spritesheets/hair/bedhead/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/gray.png",
    "lpc/spritesheets/hair/bedhead/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/gray.png.json",
    "lpc/spritesheets/hair/bedhead/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/green.png",
    "lpc/spritesheets/hair/bedhead/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/green.png.json",
    "lpc/spritesheets/hair/bedhead/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/light_brown.png",
    "lpc/spritesheets/hair/bedhead/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/light_brown.png.json",
    "lpc/spritesheets/hair/bedhead/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/orange.png",
    "lpc/spritesheets/hair/bedhead/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/orange.png.json",
    "lpc/spritesheets/hair/bedhead/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/purple.png",
    "lpc/spritesheets/hair/bedhead/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/purple.png.json",
    "lpc/spritesheets/hair/bedhead/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/red.png",
    "lpc/spritesheets/hair/bedhead/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/red.png.json",
    "lpc/spritesheets/hair/bedhead/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/white.png",
    "lpc/spritesheets/hair/bedhead/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/female/white.png.json",
    "lpc/spritesheets/hair/bedhead/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/black.png",
    "lpc/spritesheets/hair/bedhead/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/black.png.json",
    "lpc/spritesheets/hair/bedhead/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/blonde.png",
    "lpc/spritesheets/hair/bedhead/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/blonde.png.json",
    "lpc/spritesheets/hair/bedhead/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/blue.png",
    "lpc/spritesheets/hair/bedhead/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/blue.png.json",
    "lpc/spritesheets/hair/bedhead/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/dark_brown.png",
    "lpc/spritesheets/hair/bedhead/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/dark_brown.png.json",
    "lpc/spritesheets/hair/bedhead/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/gold.png",
    "lpc/spritesheets/hair/bedhead/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/gold.png.json",
    "lpc/spritesheets/hair/bedhead/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/gray.png",
    "lpc/spritesheets/hair/bedhead/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/gray.png.json",
    "lpc/spritesheets/hair/bedhead/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/green.png",
    "lpc/spritesheets/hair/bedhead/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/green.png.json",
    "lpc/spritesheets/hair/bedhead/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/light_brown.png",
    "lpc/spritesheets/hair/bedhead/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/light_brown.png.json",
    "lpc/spritesheets/hair/bedhead/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/orange.png",
    "lpc/spritesheets/hair/bedhead/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/orange.png.json",
    "lpc/spritesheets/hair/bedhead/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/purple.png",
    "lpc/spritesheets/hair/bedhead/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/purple.png.json",
    "lpc/spritesheets/hair/bedhead/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/red.png",
    "lpc/spritesheets/hair/bedhead/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/red.png.json",
    "lpc/spritesheets/hair/bedhead/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/white.png",
    "lpc/spritesheets/hair/bedhead/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bedhead/male/white.png.json",
    "lpc/spritesheets/hair/bob/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/black.png",
    "lpc/spritesheets/hair/bob/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/black.png.json",
    "lpc/spritesheets/hair/bob/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/blonde.png",
    "lpc/spritesheets/hair/bob/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/blonde.png.json",
    "lpc/spritesheets/hair/bob/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/blue.png",
    "lpc/spritesheets/hair/bob/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/blue.png.json",
    "lpc/spritesheets/hair/bob/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/dark_brown.png",
    "lpc/spritesheets/hair/bob/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/dark_brown.png.json",
    "lpc/spritesheets/hair/bob/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/gold.png",
    "lpc/spritesheets/hair/bob/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/gold.png.json",
    "lpc/spritesheets/hair/bob/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/gray.png",
    "lpc/spritesheets/hair/bob/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/gray.png.json",
    "lpc/spritesheets/hair/bob/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/green.png",
    "lpc/spritesheets/hair/bob/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/green.png.json",
    "lpc/spritesheets/hair/bob/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/light_brown.png",
    "lpc/spritesheets/hair/bob/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/light_brown.png.json",
    "lpc/spritesheets/hair/bob/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/orange.png",
    "lpc/spritesheets/hair/bob/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/orange.png.json",
    "lpc/spritesheets/hair/bob/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/purple.png",
    "lpc/spritesheets/hair/bob/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/purple.png.json",
    "lpc/spritesheets/hair/bob/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/red.png",
    "lpc/spritesheets/hair/bob/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/red.png.json",
    "lpc/spritesheets/hair/bob/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/white.png",
    "lpc/spritesheets/hair/bob/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/female/white.png.json",
    "lpc/spritesheets/hair/bob/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/black.png",
    "lpc/spritesheets/hair/bob/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/black.png.json",
    "lpc/spritesheets/hair/bob/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/blonde.png",
    "lpc/spritesheets/hair/bob/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/blonde.png.json",
    "lpc/spritesheets/hair/bob/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/blue.png",
    "lpc/spritesheets/hair/bob/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/blue.png.json",
    "lpc/spritesheets/hair/bob/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/dark_brown.png",
    "lpc/spritesheets/hair/bob/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/dark_brown.png.json",
    "lpc/spritesheets/hair/bob/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/gold.png",
    "lpc/spritesheets/hair/bob/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/gold.png.json",
    "lpc/spritesheets/hair/bob/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/gray.png",
    "lpc/spritesheets/hair/bob/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/gray.png.json",
    "lpc/spritesheets/hair/bob/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/green.png",
    "lpc/spritesheets/hair/bob/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/green.png.json",
    "lpc/spritesheets/hair/bob/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/light_brown.png",
    "lpc/spritesheets/hair/bob/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/light_brown.png.json",
    "lpc/spritesheets/hair/bob/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/orange.png",
    "lpc/spritesheets/hair/bob/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/orange.png.json",
    "lpc/spritesheets/hair/bob/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/purple.png",
    "lpc/spritesheets/hair/bob/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/purple.png.json",
    "lpc/spritesheets/hair/bob/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/red.png",
    "lpc/spritesheets/hair/bob/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/red.png.json",
    "lpc/spritesheets/hair/bob/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/white.png",
    "lpc/spritesheets/hair/bob/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob/male/white.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/black.png",
    "lpc/spritesheets/hair/bob_side_part/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/black.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/blonde.png",
    "lpc/spritesheets/hair/bob_side_part/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/blonde.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/blue.png",
    "lpc/spritesheets/hair/bob_side_part/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/blue.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/dark_brown.png",
    "lpc/spritesheets/hair/bob_side_part/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/dark_brown.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/gold.png",
    "lpc/spritesheets/hair/bob_side_part/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/gold.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/gray.png",
    "lpc/spritesheets/hair/bob_side_part/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/gray.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/green.png",
    "lpc/spritesheets/hair/bob_side_part/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/green.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/light_brown.png",
    "lpc/spritesheets/hair/bob_side_part/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/light_brown.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/orange.png",
    "lpc/spritesheets/hair/bob_side_part/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/orange.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/purple.png",
    "lpc/spritesheets/hair/bob_side_part/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/purple.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/red.png",
    "lpc/spritesheets/hair/bob_side_part/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/red.png.json",
    "lpc/spritesheets/hair/bob_side_part/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/white.png",
    "lpc/spritesheets/hair/bob_side_part/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/female/white.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/black.png",
    "lpc/spritesheets/hair/bob_side_part/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/black.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/blonde.png",
    "lpc/spritesheets/hair/bob_side_part/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/blonde.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/blue.png",
    "lpc/spritesheets/hair/bob_side_part/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/blue.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/dark_brown.png",
    "lpc/spritesheets/hair/bob_side_part/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/dark_brown.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/gold.png",
    "lpc/spritesheets/hair/bob_side_part/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/gold.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/gray.png",
    "lpc/spritesheets/hair/bob_side_part/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/gray.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/green.png",
    "lpc/spritesheets/hair/bob_side_part/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/green.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/light_brown.png",
    "lpc/spritesheets/hair/bob_side_part/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/light_brown.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/orange.png",
    "lpc/spritesheets/hair/bob_side_part/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/orange.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/purple.png",
    "lpc/spritesheets/hair/bob_side_part/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/purple.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/red.png",
    "lpc/spritesheets/hair/bob_side_part/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/red.png.json",
    "lpc/spritesheets/hair/bob_side_part/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/white.png",
    "lpc/spritesheets/hair/bob_side_part/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bob_side_part/male/white.png.json",
    "lpc/spritesheets/hair/braid/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/black.png",
    "lpc/spritesheets/hair/braid/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/black.png.json",
    "lpc/spritesheets/hair/braid/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/blonde.png",
    "lpc/spritesheets/hair/braid/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/blonde.png.json",
    "lpc/spritesheets/hair/braid/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/blue.png",
    "lpc/spritesheets/hair/braid/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/blue.png.json",
    "lpc/spritesheets/hair/braid/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/dark_brown.png",
    "lpc/spritesheets/hair/braid/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/dark_brown.png.json",
    "lpc/spritesheets/hair/braid/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/gold.png",
    "lpc/spritesheets/hair/braid/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/gold.png.json",
    "lpc/spritesheets/hair/braid/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/gray.png",
    "lpc/spritesheets/hair/braid/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/gray.png.json",
    "lpc/spritesheets/hair/braid/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/green.png",
    "lpc/spritesheets/hair/braid/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/green.png.json",
    "lpc/spritesheets/hair/braid/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/light_brown.png",
    "lpc/spritesheets/hair/braid/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/light_brown.png.json",
    "lpc/spritesheets/hair/braid/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/orange.png",
    "lpc/spritesheets/hair/braid/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/orange.png.json",
    "lpc/spritesheets/hair/braid/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/purple.png",
    "lpc/spritesheets/hair/braid/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/purple.png.json",
    "lpc/spritesheets/hair/braid/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/red.png",
    "lpc/spritesheets/hair/braid/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/red.png.json",
    "lpc/spritesheets/hair/braid/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/white.png",
    "lpc/spritesheets/hair/braid/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/female/white.png.json",
    "lpc/spritesheets/hair/braid/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/black.png",
    "lpc/spritesheets/hair/braid/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/black.png.json",
    "lpc/spritesheets/hair/braid/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/blonde.png",
    "lpc/spritesheets/hair/braid/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/blonde.png.json",
    "lpc/spritesheets/hair/braid/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/blue.png",
    "lpc/spritesheets/hair/braid/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/blue.png.json",
    "lpc/spritesheets/hair/braid/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/dark_brown.png",
    "lpc/spritesheets/hair/braid/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/dark_brown.png.json",
    "lpc/spritesheets/hair/braid/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/gold.png",
    "lpc/spritesheets/hair/braid/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/gold.png.json",
    "lpc/spritesheets/hair/braid/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/gray.png",
    "lpc/spritesheets/hair/braid/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/gray.png.json",
    "lpc/spritesheets/hair/braid/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/green.png",
    "lpc/spritesheets/hair/braid/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/green.png.json",
    "lpc/spritesheets/hair/braid/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/light_brown.png",
    "lpc/spritesheets/hair/braid/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/light_brown.png.json",
    "lpc/spritesheets/hair/braid/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/orange.png",
    "lpc/spritesheets/hair/braid/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/orange.png.json",
    "lpc/spritesheets/hair/braid/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/purple.png",
    "lpc/spritesheets/hair/braid/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/purple.png.json",
    "lpc/spritesheets/hair/braid/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/red.png",
    "lpc/spritesheets/hair/braid/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/red.png.json",
    "lpc/spritesheets/hair/braid/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/white.png",
    "lpc/spritesheets/hair/braid/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid/male/white.png.json",
    "lpc/spritesheets/hair/braid2/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/black.png",
    "lpc/spritesheets/hair/braid2/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/black.png.json",
    "lpc/spritesheets/hair/braid2/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/blonde.png",
    "lpc/spritesheets/hair/braid2/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/blonde.png.json",
    "lpc/spritesheets/hair/braid2/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/blue.png",
    "lpc/spritesheets/hair/braid2/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/blue.png.json",
    "lpc/spritesheets/hair/braid2/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/dark_brown.png",
    "lpc/spritesheets/hair/braid2/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/dark_brown.png.json",
    "lpc/spritesheets/hair/braid2/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/gold.png",
    "lpc/spritesheets/hair/braid2/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/gold.png.json",
    "lpc/spritesheets/hair/braid2/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/gray.png",
    "lpc/spritesheets/hair/braid2/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/gray.png.json",
    "lpc/spritesheets/hair/braid2/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/green.png",
    "lpc/spritesheets/hair/braid2/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/green.png.json",
    "lpc/spritesheets/hair/braid2/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/light_brown.png",
    "lpc/spritesheets/hair/braid2/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/light_brown.png.json",
    "lpc/spritesheets/hair/braid2/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/orange.png",
    "lpc/spritesheets/hair/braid2/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/orange.png.json",
    "lpc/spritesheets/hair/braid2/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/purple.png",
    "lpc/spritesheets/hair/braid2/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/purple.png.json",
    "lpc/spritesheets/hair/braid2/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/red.png",
    "lpc/spritesheets/hair/braid2/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/red.png.json",
    "lpc/spritesheets/hair/braid2/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/white.png",
    "lpc/spritesheets/hair/braid2/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/female/white.png.json",
    "lpc/spritesheets/hair/braid2/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/black.png",
    "lpc/spritesheets/hair/braid2/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/black.png.json",
    "lpc/spritesheets/hair/braid2/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/blonde.png",
    "lpc/spritesheets/hair/braid2/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/blonde.png.json",
    "lpc/spritesheets/hair/braid2/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/blue.png",
    "lpc/spritesheets/hair/braid2/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/blue.png.json",
    "lpc/spritesheets/hair/braid2/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/dark_brown.png",
    "lpc/spritesheets/hair/braid2/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/dark_brown.png.json",
    "lpc/spritesheets/hair/braid2/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/gold.png",
    "lpc/spritesheets/hair/braid2/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/gold.png.json",
    "lpc/spritesheets/hair/braid2/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/gray.png",
    "lpc/spritesheets/hair/braid2/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/gray.png.json",
    "lpc/spritesheets/hair/braid2/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/green.png",
    "lpc/spritesheets/hair/braid2/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/green.png.json",
    "lpc/spritesheets/hair/braid2/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/light_brown.png",
    "lpc/spritesheets/hair/braid2/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/light_brown.png.json",
    "lpc/spritesheets/hair/braid2/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/orange.png",
    "lpc/spritesheets/hair/braid2/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/orange.png.json",
    "lpc/spritesheets/hair/braid2/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/purple.png",
    "lpc/spritesheets/hair/braid2/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/purple.png.json",
    "lpc/spritesheets/hair/braid2/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/red.png",
    "lpc/spritesheets/hair/braid2/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/red.png.json",
    "lpc/spritesheets/hair/braid2/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/white.png",
    "lpc/spritesheets/hair/braid2/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/braid2/male/white.png.json",
    "lpc/spritesheets/hair/bunches/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/black.png",
    "lpc/spritesheets/hair/bunches/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/black.png.json",
    "lpc/spritesheets/hair/bunches/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/blonde.png",
    "lpc/spritesheets/hair/bunches/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/blonde.png.json",
    "lpc/spritesheets/hair/bunches/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/blue.png",
    "lpc/spritesheets/hair/bunches/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/blue.png.json",
    "lpc/spritesheets/hair/bunches/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/dark_brown.png",
    "lpc/spritesheets/hair/bunches/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/dark_brown.png.json",
    "lpc/spritesheets/hair/bunches/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/gold.png",
    "lpc/spritesheets/hair/bunches/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/gold.png.json",
    "lpc/spritesheets/hair/bunches/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/gray.png",
    "lpc/spritesheets/hair/bunches/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/gray.png.json",
    "lpc/spritesheets/hair/bunches/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/green.png",
    "lpc/spritesheets/hair/bunches/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/green.png.json",
    "lpc/spritesheets/hair/bunches/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/light_brown.png",
    "lpc/spritesheets/hair/bunches/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/light_brown.png.json",
    "lpc/spritesheets/hair/bunches/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/orange.png",
    "lpc/spritesheets/hair/bunches/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/orange.png.json",
    "lpc/spritesheets/hair/bunches/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/purple.png",
    "lpc/spritesheets/hair/bunches/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/purple.png.json",
    "lpc/spritesheets/hair/bunches/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/red.png",
    "lpc/spritesheets/hair/bunches/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/red.png.json",
    "lpc/spritesheets/hair/bunches/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/white.png",
    "lpc/spritesheets/hair/bunches/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/female/white.png.json",
    "lpc/spritesheets/hair/bunches/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/black.png",
    "lpc/spritesheets/hair/bunches/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/black.png.json",
    "lpc/spritesheets/hair/bunches/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/blonde.png",
    "lpc/spritesheets/hair/bunches/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/blonde.png.json",
    "lpc/spritesheets/hair/bunches/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/blue.png",
    "lpc/spritesheets/hair/bunches/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/blue.png.json",
    "lpc/spritesheets/hair/bunches/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/dark_brown.png",
    "lpc/spritesheets/hair/bunches/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/dark_brown.png.json",
    "lpc/spritesheets/hair/bunches/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/gold.png",
    "lpc/spritesheets/hair/bunches/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/gold.png.json",
    "lpc/spritesheets/hair/bunches/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/gray.png",
    "lpc/spritesheets/hair/bunches/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/gray.png.json",
    "lpc/spritesheets/hair/bunches/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/green.png",
    "lpc/spritesheets/hair/bunches/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/green.png.json",
    "lpc/spritesheets/hair/bunches/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/light_brown.png",
    "lpc/spritesheets/hair/bunches/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/light_brown.png.json",
    "lpc/spritesheets/hair/bunches/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/orange.png",
    "lpc/spritesheets/hair/bunches/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/orange.png.json",
    "lpc/spritesheets/hair/bunches/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/purple.png",
    "lpc/spritesheets/hair/bunches/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/purple.png.json",
    "lpc/spritesheets/hair/bunches/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/red.png",
    "lpc/spritesheets/hair/bunches/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/red.png.json",
    "lpc/spritesheets/hair/bunches/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/white.png",
    "lpc/spritesheets/hair/bunches/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/bunches/male/white.png.json",
    "lpc/spritesheets/hair/buzzcut/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/black.png",
    "lpc/spritesheets/hair/buzzcut/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/black.png.json",
    "lpc/spritesheets/hair/buzzcut/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/blonde.png",
    "lpc/spritesheets/hair/buzzcut/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/blonde.png.json",
    "lpc/spritesheets/hair/buzzcut/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/blue.png",
    "lpc/spritesheets/hair/buzzcut/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/blue.png.json",
    "lpc/spritesheets/hair/buzzcut/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/dark_brown.png",
    "lpc/spritesheets/hair/buzzcut/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/dark_brown.png.json",
    "lpc/spritesheets/hair/buzzcut/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/gold.png",
    "lpc/spritesheets/hair/buzzcut/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/gold.png.json",
    "lpc/spritesheets/hair/buzzcut/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/gray.png",
    "lpc/spritesheets/hair/buzzcut/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/gray.png.json",
    "lpc/spritesheets/hair/buzzcut/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/green.png",
    "lpc/spritesheets/hair/buzzcut/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/green.png.json",
    "lpc/spritesheets/hair/buzzcut/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/light_brown.png",
    "lpc/spritesheets/hair/buzzcut/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/light_brown.png.json",
    "lpc/spritesheets/hair/buzzcut/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/orange.png",
    "lpc/spritesheets/hair/buzzcut/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/orange.png.json",
    "lpc/spritesheets/hair/buzzcut/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/purple.png",
    "lpc/spritesheets/hair/buzzcut/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/purple.png.json",
    "lpc/spritesheets/hair/buzzcut/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/red.png",
    "lpc/spritesheets/hair/buzzcut/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/red.png.json",
    "lpc/spritesheets/hair/buzzcut/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/white.png",
    "lpc/spritesheets/hair/buzzcut/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/female/white.png.json",
    "lpc/spritesheets/hair/buzzcut/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/black.png",
    "lpc/spritesheets/hair/buzzcut/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/black.png.json",
    "lpc/spritesheets/hair/buzzcut/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/blonde.png",
    "lpc/spritesheets/hair/buzzcut/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/blonde.png.json",
    "lpc/spritesheets/hair/buzzcut/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/blue.png",
    "lpc/spritesheets/hair/buzzcut/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/blue.png.json",
    "lpc/spritesheets/hair/buzzcut/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/dark_brown.png",
    "lpc/spritesheets/hair/buzzcut/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/dark_brown.png.json",
    "lpc/spritesheets/hair/buzzcut/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/gold.png",
    "lpc/spritesheets/hair/buzzcut/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/gold.png.json",
    "lpc/spritesheets/hair/buzzcut/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/gray.png",
    "lpc/spritesheets/hair/buzzcut/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/gray.png.json",
    "lpc/spritesheets/hair/buzzcut/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/green.png",
    "lpc/spritesheets/hair/buzzcut/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/green.png.json",
    "lpc/spritesheets/hair/buzzcut/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/light_brown.png",
    "lpc/spritesheets/hair/buzzcut/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/light_brown.png.json",
    "lpc/spritesheets/hair/buzzcut/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/orange.png",
    "lpc/spritesheets/hair/buzzcut/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/orange.png.json",
    "lpc/spritesheets/hair/buzzcut/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/purple.png",
    "lpc/spritesheets/hair/buzzcut/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/purple.png.json",
    "lpc/spritesheets/hair/buzzcut/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/red.png",
    "lpc/spritesheets/hair/buzzcut/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/red.png.json",
    "lpc/spritesheets/hair/buzzcut/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/white.png",
    "lpc/spritesheets/hair/buzzcut/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/buzzcut/male/white.png.json",
    "lpc/spritesheets/hair/cornrows/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/black.png",
    "lpc/spritesheets/hair/cornrows/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/black.png.json",
    "lpc/spritesheets/hair/cornrows/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/blonde.png",
    "lpc/spritesheets/hair/cornrows/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/blonde.png.json",
    "lpc/spritesheets/hair/cornrows/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/blue.png",
    "lpc/spritesheets/hair/cornrows/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/blue.png.json",
    "lpc/spritesheets/hair/cornrows/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/dark_brown.png",
    "lpc/spritesheets/hair/cornrows/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/dark_brown.png.json",
    "lpc/spritesheets/hair/cornrows/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/gold.png",
    "lpc/spritesheets/hair/cornrows/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/gold.png.json",
    "lpc/spritesheets/hair/cornrows/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/gray.png",
    "lpc/spritesheets/hair/cornrows/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/gray.png.json",
    "lpc/spritesheets/hair/cornrows/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/green.png",
    "lpc/spritesheets/hair/cornrows/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/green.png.json",
    "lpc/spritesheets/hair/cornrows/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/light_brown.png",
    "lpc/spritesheets/hair/cornrows/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/light_brown.png.json",
    "lpc/spritesheets/hair/cornrows/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/orange.png",
    "lpc/spritesheets/hair/cornrows/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/orange.png.json",
    "lpc/spritesheets/hair/cornrows/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/purple.png",
    "lpc/spritesheets/hair/cornrows/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/purple.png.json",
    "lpc/spritesheets/hair/cornrows/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/red.png",
    "lpc/spritesheets/hair/cornrows/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/red.png.json",
    "lpc/spritesheets/hair/cornrows/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/white.png",
    "lpc/spritesheets/hair/cornrows/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/female/white.png.json",
    "lpc/spritesheets/hair/cornrows/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/black.png",
    "lpc/spritesheets/hair/cornrows/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/black.png.json",
    "lpc/spritesheets/hair/cornrows/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/blonde.png",
    "lpc/spritesheets/hair/cornrows/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/blonde.png.json",
    "lpc/spritesheets/hair/cornrows/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/blue.png",
    "lpc/spritesheets/hair/cornrows/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/blue.png.json",
    "lpc/spritesheets/hair/cornrows/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/dark_brown.png",
    "lpc/spritesheets/hair/cornrows/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/dark_brown.png.json",
    "lpc/spritesheets/hair/cornrows/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/gold.png",
    "lpc/spritesheets/hair/cornrows/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/gold.png.json",
    "lpc/spritesheets/hair/cornrows/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/gray.png",
    "lpc/spritesheets/hair/cornrows/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/gray.png.json",
    "lpc/spritesheets/hair/cornrows/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/green.png",
    "lpc/spritesheets/hair/cornrows/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/green.png.json",
    "lpc/spritesheets/hair/cornrows/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/light_brown.png",
    "lpc/spritesheets/hair/cornrows/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/light_brown.png.json",
    "lpc/spritesheets/hair/cornrows/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/orange.png",
    "lpc/spritesheets/hair/cornrows/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/orange.png.json",
    "lpc/spritesheets/hair/cornrows/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/purple.png",
    "lpc/spritesheets/hair/cornrows/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/purple.png.json",
    "lpc/spritesheets/hair/cornrows/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/red.png",
    "lpc/spritesheets/hair/cornrows/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/red.png.json",
    "lpc/spritesheets/hair/cornrows/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/white.png",
    "lpc/spritesheets/hair/cornrows/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cornrows/male/white.png.json",
    "lpc/spritesheets/hair/cowlick/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/black.png",
    "lpc/spritesheets/hair/cowlick/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/black.png.json",
    "lpc/spritesheets/hair/cowlick/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/blonde.png",
    "lpc/spritesheets/hair/cowlick/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/blonde.png.json",
    "lpc/spritesheets/hair/cowlick/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/blue.png",
    "lpc/spritesheets/hair/cowlick/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/blue.png.json",
    "lpc/spritesheets/hair/cowlick/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/dark_brown.png",
    "lpc/spritesheets/hair/cowlick/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/dark_brown.png.json",
    "lpc/spritesheets/hair/cowlick/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/gold.png",
    "lpc/spritesheets/hair/cowlick/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/gold.png.json",
    "lpc/spritesheets/hair/cowlick/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/gray.png",
    "lpc/spritesheets/hair/cowlick/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/gray.png.json",
    "lpc/spritesheets/hair/cowlick/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/green.png",
    "lpc/spritesheets/hair/cowlick/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/green.png.json",
    "lpc/spritesheets/hair/cowlick/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/light_brown.png",
    "lpc/spritesheets/hair/cowlick/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/light_brown.png.json",
    "lpc/spritesheets/hair/cowlick/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/orange.png",
    "lpc/spritesheets/hair/cowlick/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/orange.png.json",
    "lpc/spritesheets/hair/cowlick/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/purple.png",
    "lpc/spritesheets/hair/cowlick/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/purple.png.json",
    "lpc/spritesheets/hair/cowlick/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/red.png",
    "lpc/spritesheets/hair/cowlick/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/red.png.json",
    "lpc/spritesheets/hair/cowlick/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/white.png",
    "lpc/spritesheets/hair/cowlick/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/female/white.png.json",
    "lpc/spritesheets/hair/cowlick/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/black.png",
    "lpc/spritesheets/hair/cowlick/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/black.png.json",
    "lpc/spritesheets/hair/cowlick/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/blonde.png",
    "lpc/spritesheets/hair/cowlick/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/blonde.png.json",
    "lpc/spritesheets/hair/cowlick/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/blue.png",
    "lpc/spritesheets/hair/cowlick/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/blue.png.json",
    "lpc/spritesheets/hair/cowlick/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/dark_brown.png",
    "lpc/spritesheets/hair/cowlick/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/dark_brown.png.json",
    "lpc/spritesheets/hair/cowlick/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/gold.png",
    "lpc/spritesheets/hair/cowlick/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/gold.png.json",
    "lpc/spritesheets/hair/cowlick/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/gray.png",
    "lpc/spritesheets/hair/cowlick/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/gray.png.json",
    "lpc/spritesheets/hair/cowlick/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/green.png",
    "lpc/spritesheets/hair/cowlick/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/green.png.json",
    "lpc/spritesheets/hair/cowlick/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/light_brown.png",
    "lpc/spritesheets/hair/cowlick/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/light_brown.png.json",
    "lpc/spritesheets/hair/cowlick/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/orange.png",
    "lpc/spritesheets/hair/cowlick/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/orange.png.json",
    "lpc/spritesheets/hair/cowlick/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/purple.png",
    "lpc/spritesheets/hair/cowlick/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/purple.png.json",
    "lpc/spritesheets/hair/cowlick/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/red.png",
    "lpc/spritesheets/hair/cowlick/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/red.png.json",
    "lpc/spritesheets/hair/cowlick/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/white.png",
    "lpc/spritesheets/hair/cowlick/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick/male/white.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/black.png",
    "lpc/spritesheets/hair/cowlick_tall/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/black.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/blonde.png",
    "lpc/spritesheets/hair/cowlick_tall/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/blonde.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/blue.png",
    "lpc/spritesheets/hair/cowlick_tall/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/blue.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/dark_brown.png",
    "lpc/spritesheets/hair/cowlick_tall/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/dark_brown.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/gold.png",
    "lpc/spritesheets/hair/cowlick_tall/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/gold.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/gray.png",
    "lpc/spritesheets/hair/cowlick_tall/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/gray.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/green.png",
    "lpc/spritesheets/hair/cowlick_tall/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/green.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/light_brown.png",
    "lpc/spritesheets/hair/cowlick_tall/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/light_brown.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/orange.png",
    "lpc/spritesheets/hair/cowlick_tall/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/orange.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/purple.png",
    "lpc/spritesheets/hair/cowlick_tall/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/purple.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/red.png",
    "lpc/spritesheets/hair/cowlick_tall/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/red.png.json",
    "lpc/spritesheets/hair/cowlick_tall/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/white.png",
    "lpc/spritesheets/hair/cowlick_tall/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/female/white.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/black.png",
    "lpc/spritesheets/hair/cowlick_tall/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/black.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/blonde.png",
    "lpc/spritesheets/hair/cowlick_tall/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/blonde.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/blue.png",
    "lpc/spritesheets/hair/cowlick_tall/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/blue.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/dark_brown.png",
    "lpc/spritesheets/hair/cowlick_tall/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/dark_brown.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/gold.png",
    "lpc/spritesheets/hair/cowlick_tall/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/gold.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/gray.png",
    "lpc/spritesheets/hair/cowlick_tall/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/gray.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/green.png",
    "lpc/spritesheets/hair/cowlick_tall/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/green.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/light_brown.png",
    "lpc/spritesheets/hair/cowlick_tall/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/light_brown.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/orange.png",
    "lpc/spritesheets/hair/cowlick_tall/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/orange.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/purple.png",
    "lpc/spritesheets/hair/cowlick_tall/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/purple.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/red.png",
    "lpc/spritesheets/hair/cowlick_tall/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/red.png.json",
    "lpc/spritesheets/hair/cowlick_tall/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/white.png",
    "lpc/spritesheets/hair/cowlick_tall/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/cowlick_tall/male/white.png.json",
    "lpc/spritesheets/hair/curly_long/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/black.png",
    "lpc/spritesheets/hair/curly_long/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/black.png.json",
    "lpc/spritesheets/hair/curly_long/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/blonde.png",
    "lpc/spritesheets/hair/curly_long/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/blonde.png.json",
    "lpc/spritesheets/hair/curly_long/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/blue.png",
    "lpc/spritesheets/hair/curly_long/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/blue.png.json",
    "lpc/spritesheets/hair/curly_long/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/dark_brown.png",
    "lpc/spritesheets/hair/curly_long/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/dark_brown.png.json",
    "lpc/spritesheets/hair/curly_long/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/gold.png",
    "lpc/spritesheets/hair/curly_long/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/gold.png.json",
    "lpc/spritesheets/hair/curly_long/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/gray.png",
    "lpc/spritesheets/hair/curly_long/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/gray.png.json",
    "lpc/spritesheets/hair/curly_long/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/green.png",
    "lpc/spritesheets/hair/curly_long/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/green.png.json",
    "lpc/spritesheets/hair/curly_long/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/light_brown.png",
    "lpc/spritesheets/hair/curly_long/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/light_brown.png.json",
    "lpc/spritesheets/hair/curly_long/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/orange.png",
    "lpc/spritesheets/hair/curly_long/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/orange.png.json",
    "lpc/spritesheets/hair/curly_long/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/purple.png",
    "lpc/spritesheets/hair/curly_long/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/purple.png.json",
    "lpc/spritesheets/hair/curly_long/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/red.png",
    "lpc/spritesheets/hair/curly_long/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/red.png.json",
    "lpc/spritesheets/hair/curly_long/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/white.png",
    "lpc/spritesheets/hair/curly_long/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/female/white.png.json",
    "lpc/spritesheets/hair/curly_long/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/black.png",
    "lpc/spritesheets/hair/curly_long/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/black.png.json",
    "lpc/spritesheets/hair/curly_long/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/blonde.png",
    "lpc/spritesheets/hair/curly_long/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/blonde.png.json",
    "lpc/spritesheets/hair/curly_long/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/blue.png",
    "lpc/spritesheets/hair/curly_long/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/blue.png.json",
    "lpc/spritesheets/hair/curly_long/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/dark_brown.png",
    "lpc/spritesheets/hair/curly_long/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/dark_brown.png.json",
    "lpc/spritesheets/hair/curly_long/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/gold.png",
    "lpc/spritesheets/hair/curly_long/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/gold.png.json",
    "lpc/spritesheets/hair/curly_long/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/gray.png",
    "lpc/spritesheets/hair/curly_long/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/gray.png.json",
    "lpc/spritesheets/hair/curly_long/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/green.png",
    "lpc/spritesheets/hair/curly_long/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/green.png.json",
    "lpc/spritesheets/hair/curly_long/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/light_brown.png",
    "lpc/spritesheets/hair/curly_long/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/light_brown.png.json",
    "lpc/spritesheets/hair/curly_long/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/orange.png",
    "lpc/spritesheets/hair/curly_long/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/orange.png.json",
    "lpc/spritesheets/hair/curly_long/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/purple.png",
    "lpc/spritesheets/hair/curly_long/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/purple.png.json",
    "lpc/spritesheets/hair/curly_long/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/red.png",
    "lpc/spritesheets/hair/curly_long/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/red.png.json",
    "lpc/spritesheets/hair/curly_long/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/white.png",
    "lpc/spritesheets/hair/curly_long/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_long/male/white.png.json",
    "lpc/spritesheets/hair/curly_short/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/black.png",
    "lpc/spritesheets/hair/curly_short/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/black.png.json",
    "lpc/spritesheets/hair/curly_short/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/blonde.png",
    "lpc/spritesheets/hair/curly_short/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/blonde.png.json",
    "lpc/spritesheets/hair/curly_short/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/blue.png",
    "lpc/spritesheets/hair/curly_short/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/blue.png.json",
    "lpc/spritesheets/hair/curly_short/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/dark_brown.png",
    "lpc/spritesheets/hair/curly_short/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/dark_brown.png.json",
    "lpc/spritesheets/hair/curly_short/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/gold.png",
    "lpc/spritesheets/hair/curly_short/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/gold.png.json",
    "lpc/spritesheets/hair/curly_short/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/gray.png",
    "lpc/spritesheets/hair/curly_short/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/gray.png.json",
    "lpc/spritesheets/hair/curly_short/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/green.png",
    "lpc/spritesheets/hair/curly_short/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/green.png.json",
    "lpc/spritesheets/hair/curly_short/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/light_brown.png",
    "lpc/spritesheets/hair/curly_short/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/light_brown.png.json",
    "lpc/spritesheets/hair/curly_short/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/orange.png",
    "lpc/spritesheets/hair/curly_short/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/orange.png.json",
    "lpc/spritesheets/hair/curly_short/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/purple.png",
    "lpc/spritesheets/hair/curly_short/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/purple.png.json",
    "lpc/spritesheets/hair/curly_short/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/red.png",
    "lpc/spritesheets/hair/curly_short/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/red.png.json",
    "lpc/spritesheets/hair/curly_short/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/white.png",
    "lpc/spritesheets/hair/curly_short/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/female/white.png.json",
    "lpc/spritesheets/hair/curly_short/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/black.png",
    "lpc/spritesheets/hair/curly_short/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/black.png.json",
    "lpc/spritesheets/hair/curly_short/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/blonde.png",
    "lpc/spritesheets/hair/curly_short/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/blonde.png.json",
    "lpc/spritesheets/hair/curly_short/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/blue.png",
    "lpc/spritesheets/hair/curly_short/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/blue.png.json",
    "lpc/spritesheets/hair/curly_short/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/dark_brown.png",
    "lpc/spritesheets/hair/curly_short/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/dark_brown.png.json",
    "lpc/spritesheets/hair/curly_short/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/gold.png",
    "lpc/spritesheets/hair/curly_short/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/gold.png.json",
    "lpc/spritesheets/hair/curly_short/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/gray.png",
    "lpc/spritesheets/hair/curly_short/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/gray.png.json",
    "lpc/spritesheets/hair/curly_short/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/green.png",
    "lpc/spritesheets/hair/curly_short/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/green.png.json",
    "lpc/spritesheets/hair/curly_short/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/light_brown.png",
    "lpc/spritesheets/hair/curly_short/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/light_brown.png.json",
    "lpc/spritesheets/hair/curly_short/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/orange.png",
    "lpc/spritesheets/hair/curly_short/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/orange.png.json",
    "lpc/spritesheets/hair/curly_short/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/purple.png",
    "lpc/spritesheets/hair/curly_short/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/purple.png.json",
    "lpc/spritesheets/hair/curly_short/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/red.png",
    "lpc/spritesheets/hair/curly_short/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/red.png.json",
    "lpc/spritesheets/hair/curly_short/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/white.png",
    "lpc/spritesheets/hair/curly_short/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curly_short/male/white.png.json",
    "lpc/spritesheets/hair/curtains/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/black.png",
    "lpc/spritesheets/hair/curtains/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/black.png.json",
    "lpc/spritesheets/hair/curtains/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/blonde.png",
    "lpc/spritesheets/hair/curtains/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/blonde.png.json",
    "lpc/spritesheets/hair/curtains/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/blue.png",
    "lpc/spritesheets/hair/curtains/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/blue.png.json",
    "lpc/spritesheets/hair/curtains/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/dark_brown.png",
    "lpc/spritesheets/hair/curtains/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/dark_brown.png.json",
    "lpc/spritesheets/hair/curtains/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/gold.png",
    "lpc/spritesheets/hair/curtains/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/gold.png.json",
    "lpc/spritesheets/hair/curtains/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/gray.png",
    "lpc/spritesheets/hair/curtains/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/gray.png.json",
    "lpc/spritesheets/hair/curtains/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/green.png",
    "lpc/spritesheets/hair/curtains/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/green.png.json",
    "lpc/spritesheets/hair/curtains/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/light_brown.png",
    "lpc/spritesheets/hair/curtains/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/light_brown.png.json",
    "lpc/spritesheets/hair/curtains/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/orange.png",
    "lpc/spritesheets/hair/curtains/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/orange.png.json",
    "lpc/spritesheets/hair/curtains/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/purple.png",
    "lpc/spritesheets/hair/curtains/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/purple.png.json",
    "lpc/spritesheets/hair/curtains/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/red.png",
    "lpc/spritesheets/hair/curtains/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/red.png.json",
    "lpc/spritesheets/hair/curtains/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/white.png",
    "lpc/spritesheets/hair/curtains/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/female/white.png.json",
    "lpc/spritesheets/hair/curtains/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/black.png",
    "lpc/spritesheets/hair/curtains/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/black.png.json",
    "lpc/spritesheets/hair/curtains/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/blonde.png",
    "lpc/spritesheets/hair/curtains/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/blonde.png.json",
    "lpc/spritesheets/hair/curtains/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/blue.png",
    "lpc/spritesheets/hair/curtains/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/blue.png.json",
    "lpc/spritesheets/hair/curtains/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/dark_brown.png",
    "lpc/spritesheets/hair/curtains/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/dark_brown.png.json",
    "lpc/spritesheets/hair/curtains/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/gold.png",
    "lpc/spritesheets/hair/curtains/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/gold.png.json",
    "lpc/spritesheets/hair/curtains/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/gray.png",
    "lpc/spritesheets/hair/curtains/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/gray.png.json",
    "lpc/spritesheets/hair/curtains/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/green.png",
    "lpc/spritesheets/hair/curtains/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/green.png.json",
    "lpc/spritesheets/hair/curtains/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/light_brown.png",
    "lpc/spritesheets/hair/curtains/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/light_brown.png.json",
    "lpc/spritesheets/hair/curtains/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/orange.png",
    "lpc/spritesheets/hair/curtains/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/orange.png.json",
    "lpc/spritesheets/hair/curtains/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/purple.png",
    "lpc/spritesheets/hair/curtains/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/purple.png.json",
    "lpc/spritesheets/hair/curtains/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/red.png",
    "lpc/spritesheets/hair/curtains/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/red.png.json",
    "lpc/spritesheets/hair/curtains/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/white.png",
    "lpc/spritesheets/hair/curtains/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains/male/white.png.json",
    "lpc/spritesheets/hair/curtains_long/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/black.png",
    "lpc/spritesheets/hair/curtains_long/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/black.png.json",
    "lpc/spritesheets/hair/curtains_long/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/blonde.png",
    "lpc/spritesheets/hair/curtains_long/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/blonde.png.json",
    "lpc/spritesheets/hair/curtains_long/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/blue.png",
    "lpc/spritesheets/hair/curtains_long/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/blue.png.json",
    "lpc/spritesheets/hair/curtains_long/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/dark_brown.png",
    "lpc/spritesheets/hair/curtains_long/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/dark_brown.png.json",
    "lpc/spritesheets/hair/curtains_long/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/gold.png",
    "lpc/spritesheets/hair/curtains_long/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/gold.png.json",
    "lpc/spritesheets/hair/curtains_long/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/gray.png",
    "lpc/spritesheets/hair/curtains_long/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/gray.png.json",
    "lpc/spritesheets/hair/curtains_long/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/green.png",
    "lpc/spritesheets/hair/curtains_long/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/green.png.json",
    "lpc/spritesheets/hair/curtains_long/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/light_brown.png",
    "lpc/spritesheets/hair/curtains_long/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/light_brown.png.json",
    "lpc/spritesheets/hair/curtains_long/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/orange.png",
    "lpc/spritesheets/hair/curtains_long/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/orange.png.json",
    "lpc/spritesheets/hair/curtains_long/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/purple.png",
    "lpc/spritesheets/hair/curtains_long/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/purple.png.json",
    "lpc/spritesheets/hair/curtains_long/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/red.png",
    "lpc/spritesheets/hair/curtains_long/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/red.png.json",
    "lpc/spritesheets/hair/curtains_long/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/white.png",
    "lpc/spritesheets/hair/curtains_long/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/female/white.png.json",
    "lpc/spritesheets/hair/curtains_long/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/black.png",
    "lpc/spritesheets/hair/curtains_long/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/black.png.json",
    "lpc/spritesheets/hair/curtains_long/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/blonde.png",
    "lpc/spritesheets/hair/curtains_long/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/blonde.png.json",
    "lpc/spritesheets/hair/curtains_long/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/blue.png",
    "lpc/spritesheets/hair/curtains_long/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/blue.png.json",
    "lpc/spritesheets/hair/curtains_long/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/dark_brown.png",
    "lpc/spritesheets/hair/curtains_long/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/dark_brown.png.json",
    "lpc/spritesheets/hair/curtains_long/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/gold.png",
    "lpc/spritesheets/hair/curtains_long/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/gold.png.json",
    "lpc/spritesheets/hair/curtains_long/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/gray.png",
    "lpc/spritesheets/hair/curtains_long/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/gray.png.json",
    "lpc/spritesheets/hair/curtains_long/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/green.png",
    "lpc/spritesheets/hair/curtains_long/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/green.png.json",
    "lpc/spritesheets/hair/curtains_long/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/light_brown.png",
    "lpc/spritesheets/hair/curtains_long/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/light_brown.png.json",
    "lpc/spritesheets/hair/curtains_long/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/orange.png",
    "lpc/spritesheets/hair/curtains_long/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/orange.png.json",
    "lpc/spritesheets/hair/curtains_long/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/purple.png",
    "lpc/spritesheets/hair/curtains_long/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/purple.png.json",
    "lpc/spritesheets/hair/curtains_long/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/red.png",
    "lpc/spritesheets/hair/curtains_long/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/red.png.json",
    "lpc/spritesheets/hair/curtains_long/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/white.png",
    "lpc/spritesheets/hair/curtains_long/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/curtains_long/male/white.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/black.png",
    "lpc/spritesheets/hair/dreadlocks_long/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/black.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/blonde.png",
    "lpc/spritesheets/hair/dreadlocks_long/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/blonde.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/blue.png",
    "lpc/spritesheets/hair/dreadlocks_long/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/blue.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/dark_brown.png",
    "lpc/spritesheets/hair/dreadlocks_long/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/dark_brown.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/gold.png",
    "lpc/spritesheets/hair/dreadlocks_long/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/gold.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/gray.png",
    "lpc/spritesheets/hair/dreadlocks_long/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/gray.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/green.png",
    "lpc/spritesheets/hair/dreadlocks_long/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/green.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/light_brown.png",
    "lpc/spritesheets/hair/dreadlocks_long/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/light_brown.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/orange.png",
    "lpc/spritesheets/hair/dreadlocks_long/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/orange.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/purple.png",
    "lpc/spritesheets/hair/dreadlocks_long/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/purple.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/red.png",
    "lpc/spritesheets/hair/dreadlocks_long/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/red.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/white.png",
    "lpc/spritesheets/hair/dreadlocks_long/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/female/white.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/black.png",
    "lpc/spritesheets/hair/dreadlocks_long/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/black.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/blonde.png",
    "lpc/spritesheets/hair/dreadlocks_long/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/blonde.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/blue.png",
    "lpc/spritesheets/hair/dreadlocks_long/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/blue.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/dark_brown.png",
    "lpc/spritesheets/hair/dreadlocks_long/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/dark_brown.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/gold.png",
    "lpc/spritesheets/hair/dreadlocks_long/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/gold.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/gray.png",
    "lpc/spritesheets/hair/dreadlocks_long/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/gray.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/green.png",
    "lpc/spritesheets/hair/dreadlocks_long/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/green.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/light_brown.png",
    "lpc/spritesheets/hair/dreadlocks_long/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/light_brown.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/orange.png",
    "lpc/spritesheets/hair/dreadlocks_long/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/orange.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/purple.png",
    "lpc/spritesheets/hair/dreadlocks_long/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/purple.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/red.png",
    "lpc/spritesheets/hair/dreadlocks_long/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/red.png.json",
    "lpc/spritesheets/hair/dreadlocks_long/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/white.png",
    "lpc/spritesheets/hair/dreadlocks_long/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_long/male/white.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/black.png",
    "lpc/spritesheets/hair/dreadlocks_short/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/black.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/blonde.png",
    "lpc/spritesheets/hair/dreadlocks_short/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/blonde.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/blue.png",
    "lpc/spritesheets/hair/dreadlocks_short/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/blue.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/dark_brown.png",
    "lpc/spritesheets/hair/dreadlocks_short/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/dark_brown.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/gold.png",
    "lpc/spritesheets/hair/dreadlocks_short/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/gold.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/gray.png",
    "lpc/spritesheets/hair/dreadlocks_short/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/gray.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/green.png",
    "lpc/spritesheets/hair/dreadlocks_short/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/green.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/light_brown.png",
    "lpc/spritesheets/hair/dreadlocks_short/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/light_brown.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/orange.png",
    "lpc/spritesheets/hair/dreadlocks_short/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/orange.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/purple.png",
    "lpc/spritesheets/hair/dreadlocks_short/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/purple.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/red.png",
    "lpc/spritesheets/hair/dreadlocks_short/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/red.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/white.png",
    "lpc/spritesheets/hair/dreadlocks_short/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/female/white.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/black.png",
    "lpc/spritesheets/hair/dreadlocks_short/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/black.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/blonde.png",
    "lpc/spritesheets/hair/dreadlocks_short/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/blonde.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/blue.png",
    "lpc/spritesheets/hair/dreadlocks_short/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/blue.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/dark_brown.png",
    "lpc/spritesheets/hair/dreadlocks_short/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/dark_brown.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/gold.png",
    "lpc/spritesheets/hair/dreadlocks_short/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/gold.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/gray.png",
    "lpc/spritesheets/hair/dreadlocks_short/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/gray.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/green.png",
    "lpc/spritesheets/hair/dreadlocks_short/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/green.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/light_brown.png",
    "lpc/spritesheets/hair/dreadlocks_short/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/light_brown.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/orange.png",
    "lpc/spritesheets/hair/dreadlocks_short/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/orange.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/purple.png",
    "lpc/spritesheets/hair/dreadlocks_short/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/purple.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/red.png",
    "lpc/spritesheets/hair/dreadlocks_short/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/red.png.json",
    "lpc/spritesheets/hair/dreadlocks_short/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/white.png",
    "lpc/spritesheets/hair/dreadlocks_short/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/dreadlocks_short/male/white.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/black.png",
    "lpc/spritesheets/hair/flat_top_fade/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/black.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/blonde.png",
    "lpc/spritesheets/hair/flat_top_fade/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/blonde.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/blue.png",
    "lpc/spritesheets/hair/flat_top_fade/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/blue.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/dark_brown.png",
    "lpc/spritesheets/hair/flat_top_fade/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/dark_brown.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/gold.png",
    "lpc/spritesheets/hair/flat_top_fade/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/gold.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/gray.png",
    "lpc/spritesheets/hair/flat_top_fade/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/gray.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/green.png",
    "lpc/spritesheets/hair/flat_top_fade/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/green.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/light_brown.png",
    "lpc/spritesheets/hair/flat_top_fade/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/light_brown.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/orange.png",
    "lpc/spritesheets/hair/flat_top_fade/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/orange.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/purple.png",
    "lpc/spritesheets/hair/flat_top_fade/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/purple.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/red.png",
    "lpc/spritesheets/hair/flat_top_fade/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/red.png.json",
    "lpc/spritesheets/hair/flat_top_fade/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/white.png",
    "lpc/spritesheets/hair/flat_top_fade/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/female/white.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/black.png",
    "lpc/spritesheets/hair/flat_top_fade/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/black.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/blonde.png",
    "lpc/spritesheets/hair/flat_top_fade/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/blonde.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/blue.png",
    "lpc/spritesheets/hair/flat_top_fade/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/blue.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/dark_brown.png",
    "lpc/spritesheets/hair/flat_top_fade/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/dark_brown.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/gold.png",
    "lpc/spritesheets/hair/flat_top_fade/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/gold.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/gray.png",
    "lpc/spritesheets/hair/flat_top_fade/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/gray.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/green.png",
    "lpc/spritesheets/hair/flat_top_fade/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/green.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/light_brown.png",
    "lpc/spritesheets/hair/flat_top_fade/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/light_brown.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/orange.png",
    "lpc/spritesheets/hair/flat_top_fade/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/orange.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/purple.png",
    "lpc/spritesheets/hair/flat_top_fade/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/purple.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/red.png",
    "lpc/spritesheets/hair/flat_top_fade/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/red.png.json",
    "lpc/spritesheets/hair/flat_top_fade/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/white.png",
    "lpc/spritesheets/hair/flat_top_fade/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_fade/male/white.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/black.png",
    "lpc/spritesheets/hair/flat_top_straight/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/black.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/blonde.png",
    "lpc/spritesheets/hair/flat_top_straight/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/blonde.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/blue.png",
    "lpc/spritesheets/hair/flat_top_straight/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/blue.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/dark_brown.png",
    "lpc/spritesheets/hair/flat_top_straight/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/dark_brown.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/gold.png",
    "lpc/spritesheets/hair/flat_top_straight/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/gold.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/gray.png",
    "lpc/spritesheets/hair/flat_top_straight/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/gray.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/green.png",
    "lpc/spritesheets/hair/flat_top_straight/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/green.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/light_brown.png",
    "lpc/spritesheets/hair/flat_top_straight/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/light_brown.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/orange.png",
    "lpc/spritesheets/hair/flat_top_straight/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/orange.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/purple.png",
    "lpc/spritesheets/hair/flat_top_straight/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/purple.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/red.png",
    "lpc/spritesheets/hair/flat_top_straight/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/red.png.json",
    "lpc/spritesheets/hair/flat_top_straight/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/white.png",
    "lpc/spritesheets/hair/flat_top_straight/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/female/white.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/black.png",
    "lpc/spritesheets/hair/flat_top_straight/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/black.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/blonde.png",
    "lpc/spritesheets/hair/flat_top_straight/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/blonde.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/blue.png",
    "lpc/spritesheets/hair/flat_top_straight/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/blue.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/dark_brown.png",
    "lpc/spritesheets/hair/flat_top_straight/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/dark_brown.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/gold.png",
    "lpc/spritesheets/hair/flat_top_straight/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/gold.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/gray.png",
    "lpc/spritesheets/hair/flat_top_straight/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/gray.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/green.png",
    "lpc/spritesheets/hair/flat_top_straight/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/green.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/light_brown.png",
    "lpc/spritesheets/hair/flat_top_straight/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/light_brown.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/orange.png",
    "lpc/spritesheets/hair/flat_top_straight/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/orange.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/purple.png",
    "lpc/spritesheets/hair/flat_top_straight/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/purple.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/red.png",
    "lpc/spritesheets/hair/flat_top_straight/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/red.png.json",
    "lpc/spritesheets/hair/flat_top_straight/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/white.png",
    "lpc/spritesheets/hair/flat_top_straight/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/flat_top_straight/male/white.png.json",
    "lpc/spritesheets/hair/half_up/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/black.png",
    "lpc/spritesheets/hair/half_up/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/black.png.json",
    "lpc/spritesheets/hair/half_up/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/blonde.png",
    "lpc/spritesheets/hair/half_up/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/blonde.png.json",
    "lpc/spritesheets/hair/half_up/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/blue.png",
    "lpc/spritesheets/hair/half_up/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/blue.png.json",
    "lpc/spritesheets/hair/half_up/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/dark_brown.png",
    "lpc/spritesheets/hair/half_up/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/dark_brown.png.json",
    "lpc/spritesheets/hair/half_up/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/gold.png",
    "lpc/spritesheets/hair/half_up/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/gold.png.json",
    "lpc/spritesheets/hair/half_up/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/gray.png",
    "lpc/spritesheets/hair/half_up/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/gray.png.json",
    "lpc/spritesheets/hair/half_up/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/green.png",
    "lpc/spritesheets/hair/half_up/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/green.png.json",
    "lpc/spritesheets/hair/half_up/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/light_brown.png",
    "lpc/spritesheets/hair/half_up/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/light_brown.png.json",
    "lpc/spritesheets/hair/half_up/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/orange.png",
    "lpc/spritesheets/hair/half_up/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/orange.png.json",
    "lpc/spritesheets/hair/half_up/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/purple.png",
    "lpc/spritesheets/hair/half_up/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/purple.png.json",
    "lpc/spritesheets/hair/half_up/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/red.png",
    "lpc/spritesheets/hair/half_up/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/red.png.json",
    "lpc/spritesheets/hair/half_up/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/white.png",
    "lpc/spritesheets/hair/half_up/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/female/white.png.json",
    "lpc/spritesheets/hair/half_up/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/black.png",
    "lpc/spritesheets/hair/half_up/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/black.png.json",
    "lpc/spritesheets/hair/half_up/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/blonde.png",
    "lpc/spritesheets/hair/half_up/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/blonde.png.json",
    "lpc/spritesheets/hair/half_up/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/blue.png",
    "lpc/spritesheets/hair/half_up/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/blue.png.json",
    "lpc/spritesheets/hair/half_up/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/dark_brown.png",
    "lpc/spritesheets/hair/half_up/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/dark_brown.png.json",
    "lpc/spritesheets/hair/half_up/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/gold.png",
    "lpc/spritesheets/hair/half_up/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/gold.png.json",
    "lpc/spritesheets/hair/half_up/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/gray.png",
    "lpc/spritesheets/hair/half_up/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/gray.png.json",
    "lpc/spritesheets/hair/half_up/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/green.png",
    "lpc/spritesheets/hair/half_up/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/green.png.json",
    "lpc/spritesheets/hair/half_up/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/light_brown.png",
    "lpc/spritesheets/hair/half_up/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/light_brown.png.json",
    "lpc/spritesheets/hair/half_up/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/orange.png",
    "lpc/spritesheets/hair/half_up/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/orange.png.json",
    "lpc/spritesheets/hair/half_up/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/purple.png",
    "lpc/spritesheets/hair/half_up/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/purple.png.json",
    "lpc/spritesheets/hair/half_up/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/red.png",
    "lpc/spritesheets/hair/half_up/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/red.png.json",
    "lpc/spritesheets/hair/half_up/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/white.png",
    "lpc/spritesheets/hair/half_up/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/half_up/male/white.png.json",
    "lpc/spritesheets/hair/halfmessy/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/black.png",
    "lpc/spritesheets/hair/halfmessy/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/black.png.json",
    "lpc/spritesheets/hair/halfmessy/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/blonde.png",
    "lpc/spritesheets/hair/halfmessy/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/blonde.png.json",
    "lpc/spritesheets/hair/halfmessy/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/blue.png",
    "lpc/spritesheets/hair/halfmessy/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/blue.png.json",
    "lpc/spritesheets/hair/halfmessy/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/dark_brown.png",
    "lpc/spritesheets/hair/halfmessy/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/dark_brown.png.json",
    "lpc/spritesheets/hair/halfmessy/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/gold.png",
    "lpc/spritesheets/hair/halfmessy/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/gold.png.json",
    "lpc/spritesheets/hair/halfmessy/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/gray.png",
    "lpc/spritesheets/hair/halfmessy/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/gray.png.json",
    "lpc/spritesheets/hair/halfmessy/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/green.png",
    "lpc/spritesheets/hair/halfmessy/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/green.png.json",
    "lpc/spritesheets/hair/halfmessy/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/light_brown.png",
    "lpc/spritesheets/hair/halfmessy/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/light_brown.png.json",
    "lpc/spritesheets/hair/halfmessy/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/orange.png",
    "lpc/spritesheets/hair/halfmessy/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/orange.png.json",
    "lpc/spritesheets/hair/halfmessy/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/purple.png",
    "lpc/spritesheets/hair/halfmessy/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/purple.png.json",
    "lpc/spritesheets/hair/halfmessy/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/red.png",
    "lpc/spritesheets/hair/halfmessy/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/red.png.json",
    "lpc/spritesheets/hair/halfmessy/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/white.png",
    "lpc/spritesheets/hair/halfmessy/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/female/white.png.json",
    "lpc/spritesheets/hair/halfmessy/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/black.png",
    "lpc/spritesheets/hair/halfmessy/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/black.png.json",
    "lpc/spritesheets/hair/halfmessy/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/blonde.png",
    "lpc/spritesheets/hair/halfmessy/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/blonde.png.json",
    "lpc/spritesheets/hair/halfmessy/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/blue.png",
    "lpc/spritesheets/hair/halfmessy/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/blue.png.json",
    "lpc/spritesheets/hair/halfmessy/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/dark_brown.png",
    "lpc/spritesheets/hair/halfmessy/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/dark_brown.png.json",
    "lpc/spritesheets/hair/halfmessy/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/gold.png",
    "lpc/spritesheets/hair/halfmessy/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/gold.png.json",
    "lpc/spritesheets/hair/halfmessy/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/gray.png",
    "lpc/spritesheets/hair/halfmessy/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/gray.png.json",
    "lpc/spritesheets/hair/halfmessy/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/green.png",
    "lpc/spritesheets/hair/halfmessy/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/green.png.json",
    "lpc/spritesheets/hair/halfmessy/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/light_brown.png",
    "lpc/spritesheets/hair/halfmessy/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/light_brown.png.json",
    "lpc/spritesheets/hair/halfmessy/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/orange.png",
    "lpc/spritesheets/hair/halfmessy/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/orange.png.json",
    "lpc/spritesheets/hair/halfmessy/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/purple.png",
    "lpc/spritesheets/hair/halfmessy/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/purple.png.json",
    "lpc/spritesheets/hair/halfmessy/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/red.png",
    "lpc/spritesheets/hair/halfmessy/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/red.png.json",
    "lpc/spritesheets/hair/halfmessy/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/white.png",
    "lpc/spritesheets/hair/halfmessy/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/halfmessy/male/white.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/black.png",
    "lpc/spritesheets/hair/high_and_tight/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/black.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/blonde.png",
    "lpc/spritesheets/hair/high_and_tight/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/blonde.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/blue.png",
    "lpc/spritesheets/hair/high_and_tight/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/blue.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/dark_brown.png",
    "lpc/spritesheets/hair/high_and_tight/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/dark_brown.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/gold.png",
    "lpc/spritesheets/hair/high_and_tight/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/gold.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/gray.png",
    "lpc/spritesheets/hair/high_and_tight/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/gray.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/green.png",
    "lpc/spritesheets/hair/high_and_tight/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/green.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/light_brown.png",
    "lpc/spritesheets/hair/high_and_tight/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/light_brown.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/orange.png",
    "lpc/spritesheets/hair/high_and_tight/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/orange.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/purple.png",
    "lpc/spritesheets/hair/high_and_tight/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/purple.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/red.png",
    "lpc/spritesheets/hair/high_and_tight/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/red.png.json",
    "lpc/spritesheets/hair/high_and_tight/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/white.png",
    "lpc/spritesheets/hair/high_and_tight/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/female/white.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/black.png",
    "lpc/spritesheets/hair/high_and_tight/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/black.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/blonde.png",
    "lpc/spritesheets/hair/high_and_tight/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/blonde.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/blue.png",
    "lpc/spritesheets/hair/high_and_tight/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/blue.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/dark_brown.png",
    "lpc/spritesheets/hair/high_and_tight/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/dark_brown.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/gold.png",
    "lpc/spritesheets/hair/high_and_tight/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/gold.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/gray.png",
    "lpc/spritesheets/hair/high_and_tight/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/gray.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/green.png",
    "lpc/spritesheets/hair/high_and_tight/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/green.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/light_brown.png",
    "lpc/spritesheets/hair/high_and_tight/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/light_brown.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/orange.png",
    "lpc/spritesheets/hair/high_and_tight/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/orange.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/purple.png",
    "lpc/spritesheets/hair/high_and_tight/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/purple.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/red.png",
    "lpc/spritesheets/hair/high_and_tight/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/red.png.json",
    "lpc/spritesheets/hair/high_and_tight/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/white.png",
    "lpc/spritesheets/hair/high_and_tight/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_and_tight/male/white.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/black.png",
    "lpc/spritesheets/hair/high_ponytail/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/black.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/blonde.png",
    "lpc/spritesheets/hair/high_ponytail/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/blonde.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/blue.png",
    "lpc/spritesheets/hair/high_ponytail/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/blue.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/dark_brown.png",
    "lpc/spritesheets/hair/high_ponytail/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/dark_brown.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/gold.png",
    "lpc/spritesheets/hair/high_ponytail/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/gold.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/gray.png",
    "lpc/spritesheets/hair/high_ponytail/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/gray.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/green.png",
    "lpc/spritesheets/hair/high_ponytail/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/green.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/light_brown.png",
    "lpc/spritesheets/hair/high_ponytail/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/light_brown.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/orange.png",
    "lpc/spritesheets/hair/high_ponytail/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/orange.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/purple.png",
    "lpc/spritesheets/hair/high_ponytail/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/purple.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/red.png",
    "lpc/spritesheets/hair/high_ponytail/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/red.png.json",
    "lpc/spritesheets/hair/high_ponytail/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/white.png",
    "lpc/spritesheets/hair/high_ponytail/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/female/white.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/black.png",
    "lpc/spritesheets/hair/high_ponytail/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/black.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/blonde.png",
    "lpc/spritesheets/hair/high_ponytail/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/blonde.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/blue.png",
    "lpc/spritesheets/hair/high_ponytail/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/blue.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/dark_brown.png",
    "lpc/spritesheets/hair/high_ponytail/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/dark_brown.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/gold.png",
    "lpc/spritesheets/hair/high_ponytail/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/gold.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/gray.png",
    "lpc/spritesheets/hair/high_ponytail/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/gray.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/green.png",
    "lpc/spritesheets/hair/high_ponytail/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/green.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/light_brown.png",
    "lpc/spritesheets/hair/high_ponytail/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/light_brown.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/orange.png",
    "lpc/spritesheets/hair/high_ponytail/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/orange.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/purple.png",
    "lpc/spritesheets/hair/high_ponytail/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/purple.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/red.png",
    "lpc/spritesheets/hair/high_ponytail/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/red.png.json",
    "lpc/spritesheets/hair/high_ponytail/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/white.png",
    "lpc/spritesheets/hair/high_ponytail/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/high_ponytail/male/white.png.json",
    "lpc/spritesheets/hair/idol/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/black.png",
    "lpc/spritesheets/hair/idol/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/black.png.json",
    "lpc/spritesheets/hair/idol/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/blonde.png",
    "lpc/spritesheets/hair/idol/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/blonde.png.json",
    "lpc/spritesheets/hair/idol/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/blue.png",
    "lpc/spritesheets/hair/idol/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/blue.png.json",
    "lpc/spritesheets/hair/idol/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/dark_brown.png",
    "lpc/spritesheets/hair/idol/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/dark_brown.png.json",
    "lpc/spritesheets/hair/idol/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/gold.png",
    "lpc/spritesheets/hair/idol/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/gold.png.json",
    "lpc/spritesheets/hair/idol/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/gray.png",
    "lpc/spritesheets/hair/idol/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/gray.png.json",
    "lpc/spritesheets/hair/idol/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/green.png",
    "lpc/spritesheets/hair/idol/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/green.png.json",
    "lpc/spritesheets/hair/idol/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/light_brown.png",
    "lpc/spritesheets/hair/idol/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/light_brown.png.json",
    "lpc/spritesheets/hair/idol/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/orange.png",
    "lpc/spritesheets/hair/idol/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/orange.png.json",
    "lpc/spritesheets/hair/idol/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/purple.png",
    "lpc/spritesheets/hair/idol/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/purple.png.json",
    "lpc/spritesheets/hair/idol/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/red.png",
    "lpc/spritesheets/hair/idol/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/red.png.json",
    "lpc/spritesheets/hair/idol/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/white.png",
    "lpc/spritesheets/hair/idol/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/female/white.png.json",
    "lpc/spritesheets/hair/idol/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/black.png",
    "lpc/spritesheets/hair/idol/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/black.png.json",
    "lpc/spritesheets/hair/idol/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/blonde.png",
    "lpc/spritesheets/hair/idol/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/blonde.png.json",
    "lpc/spritesheets/hair/idol/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/blue.png",
    "lpc/spritesheets/hair/idol/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/blue.png.json",
    "lpc/spritesheets/hair/idol/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/dark_brown.png",
    "lpc/spritesheets/hair/idol/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/dark_brown.png.json",
    "lpc/spritesheets/hair/idol/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/gold.png",
    "lpc/spritesheets/hair/idol/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/gold.png.json",
    "lpc/spritesheets/hair/idol/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/gray.png",
    "lpc/spritesheets/hair/idol/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/gray.png.json",
    "lpc/spritesheets/hair/idol/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/green.png",
    "lpc/spritesheets/hair/idol/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/green.png.json",
    "lpc/spritesheets/hair/idol/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/light_brown.png",
    "lpc/spritesheets/hair/idol/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/light_brown.png.json",
    "lpc/spritesheets/hair/idol/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/orange.png",
    "lpc/spritesheets/hair/idol/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/orange.png.json",
    "lpc/spritesheets/hair/idol/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/purple.png",
    "lpc/spritesheets/hair/idol/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/purple.png.json",
    "lpc/spritesheets/hair/idol/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/red.png",
    "lpc/spritesheets/hair/idol/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/red.png.json",
    "lpc/spritesheets/hair/idol/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/white.png",
    "lpc/spritesheets/hair/idol/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/idol/male/white.png.json",
    "lpc/spritesheets/hair/jewfro/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/black.png",
    "lpc/spritesheets/hair/jewfro/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/black.png.json",
    "lpc/spritesheets/hair/jewfro/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/blonde.png",
    "lpc/spritesheets/hair/jewfro/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/blonde.png.json",
    "lpc/spritesheets/hair/jewfro/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/blue.png",
    "lpc/spritesheets/hair/jewfro/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/blue.png.json",
    "lpc/spritesheets/hair/jewfro/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/dark_brown.png",
    "lpc/spritesheets/hair/jewfro/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/dark_brown.png.json",
    "lpc/spritesheets/hair/jewfro/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/gold.png",
    "lpc/spritesheets/hair/jewfro/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/gold.png.json",
    "lpc/spritesheets/hair/jewfro/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/gray.png",
    "lpc/spritesheets/hair/jewfro/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/gray.png.json",
    "lpc/spritesheets/hair/jewfro/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/green.png",
    "lpc/spritesheets/hair/jewfro/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/green.png.json",
    "lpc/spritesheets/hair/jewfro/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/light_brown.png",
    "lpc/spritesheets/hair/jewfro/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/light_brown.png.json",
    "lpc/spritesheets/hair/jewfro/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/orange.png",
    "lpc/spritesheets/hair/jewfro/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/orange.png.json",
    "lpc/spritesheets/hair/jewfro/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/purple.png",
    "lpc/spritesheets/hair/jewfro/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/purple.png.json",
    "lpc/spritesheets/hair/jewfro/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/red.png",
    "lpc/spritesheets/hair/jewfro/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/red.png.json",
    "lpc/spritesheets/hair/jewfro/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/white.png",
    "lpc/spritesheets/hair/jewfro/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/female/white.png.json",
    "lpc/spritesheets/hair/jewfro/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/black.png",
    "lpc/spritesheets/hair/jewfro/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/black.png.json",
    "lpc/spritesheets/hair/jewfro/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/blonde.png",
    "lpc/spritesheets/hair/jewfro/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/blonde.png.json",
    "lpc/spritesheets/hair/jewfro/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/blue.png",
    "lpc/spritesheets/hair/jewfro/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/blue.png.json",
    "lpc/spritesheets/hair/jewfro/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/dark_brown.png",
    "lpc/spritesheets/hair/jewfro/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/dark_brown.png.json",
    "lpc/spritesheets/hair/jewfro/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/gold.png",
    "lpc/spritesheets/hair/jewfro/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/gold.png.json",
    "lpc/spritesheets/hair/jewfro/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/gray.png",
    "lpc/spritesheets/hair/jewfro/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/gray.png.json",
    "lpc/spritesheets/hair/jewfro/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/green.png",
    "lpc/spritesheets/hair/jewfro/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/green.png.json",
    "lpc/spritesheets/hair/jewfro/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/light_brown.png",
    "lpc/spritesheets/hair/jewfro/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/light_brown.png.json",
    "lpc/spritesheets/hair/jewfro/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/orange.png",
    "lpc/spritesheets/hair/jewfro/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/orange.png.json",
    "lpc/spritesheets/hair/jewfro/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/purple.png",
    "lpc/spritesheets/hair/jewfro/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/purple.png.json",
    "lpc/spritesheets/hair/jewfro/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/red.png",
    "lpc/spritesheets/hair/jewfro/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/red.png.json",
    "lpc/spritesheets/hair/jewfro/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/white.png",
    "lpc/spritesheets/hair/jewfro/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/jewfro/male/white.png.json",
    "lpc/spritesheets/hair/lob/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/black.png",
    "lpc/spritesheets/hair/lob/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/black.png.json",
    "lpc/spritesheets/hair/lob/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/blonde.png",
    "lpc/spritesheets/hair/lob/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/blonde.png.json",
    "lpc/spritesheets/hair/lob/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/blue.png",
    "lpc/spritesheets/hair/lob/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/blue.png.json",
    "lpc/spritesheets/hair/lob/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/dark_brown.png",
    "lpc/spritesheets/hair/lob/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/dark_brown.png.json",
    "lpc/spritesheets/hair/lob/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/gold.png",
    "lpc/spritesheets/hair/lob/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/gold.png.json",
    "lpc/spritesheets/hair/lob/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/gray.png",
    "lpc/spritesheets/hair/lob/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/gray.png.json",
    "lpc/spritesheets/hair/lob/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/green.png",
    "lpc/spritesheets/hair/lob/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/green.png.json",
    "lpc/spritesheets/hair/lob/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/light_brown.png",
    "lpc/spritesheets/hair/lob/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/light_brown.png.json",
    "lpc/spritesheets/hair/lob/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/orange.png",
    "lpc/spritesheets/hair/lob/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/orange.png.json",
    "lpc/spritesheets/hair/lob/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/purple.png",
    "lpc/spritesheets/hair/lob/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/purple.png.json",
    "lpc/spritesheets/hair/lob/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/red.png",
    "lpc/spritesheets/hair/lob/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/red.png.json",
    "lpc/spritesheets/hair/lob/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/white.png",
    "lpc/spritesheets/hair/lob/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/female/white.png.json",
    "lpc/spritesheets/hair/lob/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/black.png",
    "lpc/spritesheets/hair/lob/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/black.png.json",
    "lpc/spritesheets/hair/lob/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/blonde.png",
    "lpc/spritesheets/hair/lob/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/blonde.png.json",
    "lpc/spritesheets/hair/lob/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/blue.png",
    "lpc/spritesheets/hair/lob/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/blue.png.json",
    "lpc/spritesheets/hair/lob/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/dark_brown.png",
    "lpc/spritesheets/hair/lob/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/dark_brown.png.json",
    "lpc/spritesheets/hair/lob/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/gold.png",
    "lpc/spritesheets/hair/lob/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/gold.png.json",
    "lpc/spritesheets/hair/lob/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/gray.png",
    "lpc/spritesheets/hair/lob/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/gray.png.json",
    "lpc/spritesheets/hair/lob/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/green.png",
    "lpc/spritesheets/hair/lob/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/green.png.json",
    "lpc/spritesheets/hair/lob/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/light_brown.png",
    "lpc/spritesheets/hair/lob/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/light_brown.png.json",
    "lpc/spritesheets/hair/lob/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/orange.png",
    "lpc/spritesheets/hair/lob/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/orange.png.json",
    "lpc/spritesheets/hair/lob/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/purple.png",
    "lpc/spritesheets/hair/lob/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/purple.png.json",
    "lpc/spritesheets/hair/lob/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/red.png",
    "lpc/spritesheets/hair/lob/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/red.png.json",
    "lpc/spritesheets/hair/lob/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/white.png",
    "lpc/spritesheets/hair/lob/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/lob/male/white.png.json",
    "lpc/spritesheets/hair/long/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/black.png",
    "lpc/spritesheets/hair/long/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/black.png.json",
    "lpc/spritesheets/hair/long/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/blonde.png",
    "lpc/spritesheets/hair/long/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/blonde.png.json",
    "lpc/spritesheets/hair/long/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/blue.png",
    "lpc/spritesheets/hair/long/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/blue.png.json",
    "lpc/spritesheets/hair/long/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/dark_brown.png",
    "lpc/spritesheets/hair/long/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/dark_brown.png.json",
    "lpc/spritesheets/hair/long/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/gold.png",
    "lpc/spritesheets/hair/long/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/gold.png.json",
    "lpc/spritesheets/hair/long/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/gray.png",
    "lpc/spritesheets/hair/long/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/gray.png.json",
    "lpc/spritesheets/hair/long/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/green.png",
    "lpc/spritesheets/hair/long/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/green.png.json",
    "lpc/spritesheets/hair/long/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/light_brown.png",
    "lpc/spritesheets/hair/long/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/light_brown.png.json",
    "lpc/spritesheets/hair/long/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/orange.png",
    "lpc/spritesheets/hair/long/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/orange.png.json",
    "lpc/spritesheets/hair/long/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/purple.png",
    "lpc/spritesheets/hair/long/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/purple.png.json",
    "lpc/spritesheets/hair/long/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/red.png",
    "lpc/spritesheets/hair/long/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/red.png.json",
    "lpc/spritesheets/hair/long/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/white.png",
    "lpc/spritesheets/hair/long/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/female/white.png.json",
    "lpc/spritesheets/hair/long/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/black.png",
    "lpc/spritesheets/hair/long/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/black.png.json",
    "lpc/spritesheets/hair/long/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/blonde.png",
    "lpc/spritesheets/hair/long/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/blonde.png.json",
    "lpc/spritesheets/hair/long/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/blue.png",
    "lpc/spritesheets/hair/long/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/blue.png.json",
    "lpc/spritesheets/hair/long/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/dark_brown.png",
    "lpc/spritesheets/hair/long/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/dark_brown.png.json",
    "lpc/spritesheets/hair/long/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/gold.png",
    "lpc/spritesheets/hair/long/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/gold.png.json",
    "lpc/spritesheets/hair/long/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/gray.png",
    "lpc/spritesheets/hair/long/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/gray.png.json",
    "lpc/spritesheets/hair/long/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/green.png",
    "lpc/spritesheets/hair/long/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/green.png.json",
    "lpc/spritesheets/hair/long/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/light_brown.png",
    "lpc/spritesheets/hair/long/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/light_brown.png.json",
    "lpc/spritesheets/hair/long/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/orange.png",
    "lpc/spritesheets/hair/long/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/orange.png.json",
    "lpc/spritesheets/hair/long/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/purple.png",
    "lpc/spritesheets/hair/long/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/purple.png.json",
    "lpc/spritesheets/hair/long/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/red.png",
    "lpc/spritesheets/hair/long/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/red.png.json",
    "lpc/spritesheets/hair/long/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/white.png",
    "lpc/spritesheets/hair/long/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long/male/white.png.json",
    "lpc/spritesheets/hair/long_band/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/black.png",
    "lpc/spritesheets/hair/long_band/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/black.png.json",
    "lpc/spritesheets/hair/long_band/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/blonde.png",
    "lpc/spritesheets/hair/long_band/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/blonde.png.json",
    "lpc/spritesheets/hair/long_band/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/blue.png",
    "lpc/spritesheets/hair/long_band/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/blue.png.json",
    "lpc/spritesheets/hair/long_band/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/dark_brown.png",
    "lpc/spritesheets/hair/long_band/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/dark_brown.png.json",
    "lpc/spritesheets/hair/long_band/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/gold.png",
    "lpc/spritesheets/hair/long_band/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/gold.png.json",
    "lpc/spritesheets/hair/long_band/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/gray.png",
    "lpc/spritesheets/hair/long_band/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/gray.png.json",
    "lpc/spritesheets/hair/long_band/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/green.png",
    "lpc/spritesheets/hair/long_band/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/green.png.json",
    "lpc/spritesheets/hair/long_band/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/light_brown.png",
    "lpc/spritesheets/hair/long_band/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/light_brown.png.json",
    "lpc/spritesheets/hair/long_band/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/orange.png",
    "lpc/spritesheets/hair/long_band/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/orange.png.json",
    "lpc/spritesheets/hair/long_band/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/purple.png",
    "lpc/spritesheets/hair/long_band/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/purple.png.json",
    "lpc/spritesheets/hair/long_band/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/red.png",
    "lpc/spritesheets/hair/long_band/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/red.png.json",
    "lpc/spritesheets/hair/long_band/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/white.png",
    "lpc/spritesheets/hair/long_band/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/female/white.png.json",
    "lpc/spritesheets/hair/long_band/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/black.png",
    "lpc/spritesheets/hair/long_band/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/black.png.json",
    "lpc/spritesheets/hair/long_band/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/blonde.png",
    "lpc/spritesheets/hair/long_band/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/blonde.png.json",
    "lpc/spritesheets/hair/long_band/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/blue.png",
    "lpc/spritesheets/hair/long_band/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/blue.png.json",
    "lpc/spritesheets/hair/long_band/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/dark_brown.png",
    "lpc/spritesheets/hair/long_band/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/dark_brown.png.json",
    "lpc/spritesheets/hair/long_band/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/gold.png",
    "lpc/spritesheets/hair/long_band/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/gold.png.json",
    "lpc/spritesheets/hair/long_band/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/gray.png",
    "lpc/spritesheets/hair/long_band/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/gray.png.json",
    "lpc/spritesheets/hair/long_band/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/green.png",
    "lpc/spritesheets/hair/long_band/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/green.png.json",
    "lpc/spritesheets/hair/long_band/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/light_brown.png",
    "lpc/spritesheets/hair/long_band/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/light_brown.png.json",
    "lpc/spritesheets/hair/long_band/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/orange.png",
    "lpc/spritesheets/hair/long_band/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/orange.png.json",
    "lpc/spritesheets/hair/long_band/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/purple.png",
    "lpc/spritesheets/hair/long_band/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/purple.png.json",
    "lpc/spritesheets/hair/long_band/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/red.png",
    "lpc/spritesheets/hair/long_band/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/red.png.json",
    "lpc/spritesheets/hair/long_band/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/white.png",
    "lpc/spritesheets/hair/long_band/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_band/male/white.png.json",
    "lpc/spritesheets/hair/long_center_part/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/black.png",
    "lpc/spritesheets/hair/long_center_part/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/black.png.json",
    "lpc/spritesheets/hair/long_center_part/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/blonde.png",
    "lpc/spritesheets/hair/long_center_part/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/blonde.png.json",
    "lpc/spritesheets/hair/long_center_part/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/blue.png",
    "lpc/spritesheets/hair/long_center_part/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/blue.png.json",
    "lpc/spritesheets/hair/long_center_part/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/dark_brown.png",
    "lpc/spritesheets/hair/long_center_part/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/dark_brown.png.json",
    "lpc/spritesheets/hair/long_center_part/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/gold.png",
    "lpc/spritesheets/hair/long_center_part/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/gold.png.json",
    "lpc/spritesheets/hair/long_center_part/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/gray.png",
    "lpc/spritesheets/hair/long_center_part/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/gray.png.json",
    "lpc/spritesheets/hair/long_center_part/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/green.png",
    "lpc/spritesheets/hair/long_center_part/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/green.png.json",
    "lpc/spritesheets/hair/long_center_part/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/light_brown.png",
    "lpc/spritesheets/hair/long_center_part/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/light_brown.png.json",
    "lpc/spritesheets/hair/long_center_part/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/orange.png",
    "lpc/spritesheets/hair/long_center_part/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/orange.png.json",
    "lpc/spritesheets/hair/long_center_part/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/purple.png",
    "lpc/spritesheets/hair/long_center_part/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/purple.png.json",
    "lpc/spritesheets/hair/long_center_part/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/red.png",
    "lpc/spritesheets/hair/long_center_part/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/red.png.json",
    "lpc/spritesheets/hair/long_center_part/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/white.png",
    "lpc/spritesheets/hair/long_center_part/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/female/white.png.json",
    "lpc/spritesheets/hair/long_center_part/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/black.png",
    "lpc/spritesheets/hair/long_center_part/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/black.png.json",
    "lpc/spritesheets/hair/long_center_part/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/blonde.png",
    "lpc/spritesheets/hair/long_center_part/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/blonde.png.json",
    "lpc/spritesheets/hair/long_center_part/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/blue.png",
    "lpc/spritesheets/hair/long_center_part/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/blue.png.json",
    "lpc/spritesheets/hair/long_center_part/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/dark_brown.png",
    "lpc/spritesheets/hair/long_center_part/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/dark_brown.png.json",
    "lpc/spritesheets/hair/long_center_part/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/gold.png",
    "lpc/spritesheets/hair/long_center_part/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/gold.png.json",
    "lpc/spritesheets/hair/long_center_part/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/gray.png",
    "lpc/spritesheets/hair/long_center_part/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/gray.png.json",
    "lpc/spritesheets/hair/long_center_part/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/green.png",
    "lpc/spritesheets/hair/long_center_part/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/green.png.json",
    "lpc/spritesheets/hair/long_center_part/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/light_brown.png",
    "lpc/spritesheets/hair/long_center_part/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/light_brown.png.json",
    "lpc/spritesheets/hair/long_center_part/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/orange.png",
    "lpc/spritesheets/hair/long_center_part/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/orange.png.json",
    "lpc/spritesheets/hair/long_center_part/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/purple.png",
    "lpc/spritesheets/hair/long_center_part/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/purple.png.json",
    "lpc/spritesheets/hair/long_center_part/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/red.png",
    "lpc/spritesheets/hair/long_center_part/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/red.png.json",
    "lpc/spritesheets/hair/long_center_part/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/white.png",
    "lpc/spritesheets/hair/long_center_part/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_center_part/male/white.png.json",
    "lpc/spritesheets/hair/long_messy/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/black.png",
    "lpc/spritesheets/hair/long_messy/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/black.png.json",
    "lpc/spritesheets/hair/long_messy/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/blonde.png",
    "lpc/spritesheets/hair/long_messy/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/blonde.png.json",
    "lpc/spritesheets/hair/long_messy/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/blue.png",
    "lpc/spritesheets/hair/long_messy/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/blue.png.json",
    "lpc/spritesheets/hair/long_messy/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/dark_brown.png",
    "lpc/spritesheets/hair/long_messy/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/dark_brown.png.json",
    "lpc/spritesheets/hair/long_messy/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/gold.png",
    "lpc/spritesheets/hair/long_messy/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/gold.png.json",
    "lpc/spritesheets/hair/long_messy/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/gray.png",
    "lpc/spritesheets/hair/long_messy/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/gray.png.json",
    "lpc/spritesheets/hair/long_messy/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/green.png",
    "lpc/spritesheets/hair/long_messy/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/green.png.json",
    "lpc/spritesheets/hair/long_messy/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/light_brown.png",
    "lpc/spritesheets/hair/long_messy/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/light_brown.png.json",
    "lpc/spritesheets/hair/long_messy/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/orange.png",
    "lpc/spritesheets/hair/long_messy/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/orange.png.json",
    "lpc/spritesheets/hair/long_messy/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/purple.png",
    "lpc/spritesheets/hair/long_messy/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/purple.png.json",
    "lpc/spritesheets/hair/long_messy/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/red.png",
    "lpc/spritesheets/hair/long_messy/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/red.png.json",
    "lpc/spritesheets/hair/long_messy/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/white.png",
    "lpc/spritesheets/hair/long_messy/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/female/white.png.json",
    "lpc/spritesheets/hair/long_messy/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/black.png",
    "lpc/spritesheets/hair/long_messy/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/black.png.json",
    "lpc/spritesheets/hair/long_messy/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/blonde.png",
    "lpc/spritesheets/hair/long_messy/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/blonde.png.json",
    "lpc/spritesheets/hair/long_messy/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/blue.png",
    "lpc/spritesheets/hair/long_messy/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/blue.png.json",
    "lpc/spritesheets/hair/long_messy/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/dark_brown.png",
    "lpc/spritesheets/hair/long_messy/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/dark_brown.png.json",
    "lpc/spritesheets/hair/long_messy/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/gold.png",
    "lpc/spritesheets/hair/long_messy/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/gold.png.json",
    "lpc/spritesheets/hair/long_messy/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/gray.png",
    "lpc/spritesheets/hair/long_messy/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/gray.png.json",
    "lpc/spritesheets/hair/long_messy/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/green.png",
    "lpc/spritesheets/hair/long_messy/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/green.png.json",
    "lpc/spritesheets/hair/long_messy/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/light_brown.png",
    "lpc/spritesheets/hair/long_messy/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/light_brown.png.json",
    "lpc/spritesheets/hair/long_messy/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/orange.png",
    "lpc/spritesheets/hair/long_messy/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/orange.png.json",
    "lpc/spritesheets/hair/long_messy/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/purple.png",
    "lpc/spritesheets/hair/long_messy/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/purple.png.json",
    "lpc/spritesheets/hair/long_messy/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/red.png",
    "lpc/spritesheets/hair/long_messy/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/red.png.json",
    "lpc/spritesheets/hair/long_messy/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/white.png",
    "lpc/spritesheets/hair/long_messy/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy/male/white.png.json",
    "lpc/spritesheets/hair/long_messy2/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/black.png",
    "lpc/spritesheets/hair/long_messy2/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/black.png.json",
    "lpc/spritesheets/hair/long_messy2/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/blonde.png",
    "lpc/spritesheets/hair/long_messy2/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/blonde.png.json",
    "lpc/spritesheets/hair/long_messy2/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/blue.png",
    "lpc/spritesheets/hair/long_messy2/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/blue.png.json",
    "lpc/spritesheets/hair/long_messy2/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/dark_brown.png",
    "lpc/spritesheets/hair/long_messy2/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/dark_brown.png.json",
    "lpc/spritesheets/hair/long_messy2/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/gold.png",
    "lpc/spritesheets/hair/long_messy2/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/gold.png.json",
    "lpc/spritesheets/hair/long_messy2/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/gray.png",
    "lpc/spritesheets/hair/long_messy2/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/gray.png.json",
    "lpc/spritesheets/hair/long_messy2/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/green.png",
    "lpc/spritesheets/hair/long_messy2/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/green.png.json",
    "lpc/spritesheets/hair/long_messy2/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/light_brown.png",
    "lpc/spritesheets/hair/long_messy2/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/light_brown.png.json",
    "lpc/spritesheets/hair/long_messy2/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/orange.png",
    "lpc/spritesheets/hair/long_messy2/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/orange.png.json",
    "lpc/spritesheets/hair/long_messy2/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/purple.png",
    "lpc/spritesheets/hair/long_messy2/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/purple.png.json",
    "lpc/spritesheets/hair/long_messy2/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/red.png",
    "lpc/spritesheets/hair/long_messy2/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/red.png.json",
    "lpc/spritesheets/hair/long_messy2/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/white.png",
    "lpc/spritesheets/hair/long_messy2/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/female/white.png.json",
    "lpc/spritesheets/hair/long_messy2/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/black.png",
    "lpc/spritesheets/hair/long_messy2/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/black.png.json",
    "lpc/spritesheets/hair/long_messy2/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/blonde.png",
    "lpc/spritesheets/hair/long_messy2/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/blonde.png.json",
    "lpc/spritesheets/hair/long_messy2/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/blue.png",
    "lpc/spritesheets/hair/long_messy2/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/blue.png.json",
    "lpc/spritesheets/hair/long_messy2/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/dark_brown.png",
    "lpc/spritesheets/hair/long_messy2/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/dark_brown.png.json",
    "lpc/spritesheets/hair/long_messy2/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/gold.png",
    "lpc/spritesheets/hair/long_messy2/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/gold.png.json",
    "lpc/spritesheets/hair/long_messy2/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/gray.png",
    "lpc/spritesheets/hair/long_messy2/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/gray.png.json",
    "lpc/spritesheets/hair/long_messy2/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/green.png",
    "lpc/spritesheets/hair/long_messy2/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/green.png.json",
    "lpc/spritesheets/hair/long_messy2/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/light_brown.png",
    "lpc/spritesheets/hair/long_messy2/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/light_brown.png.json",
    "lpc/spritesheets/hair/long_messy2/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/orange.png",
    "lpc/spritesheets/hair/long_messy2/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/orange.png.json",
    "lpc/spritesheets/hair/long_messy2/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/purple.png",
    "lpc/spritesheets/hair/long_messy2/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/purple.png.json",
    "lpc/spritesheets/hair/long_messy2/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/red.png",
    "lpc/spritesheets/hair/long_messy2/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/red.png.json",
    "lpc/spritesheets/hair/long_messy2/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/white.png",
    "lpc/spritesheets/hair/long_messy2/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_messy2/male/white.png.json",
    "lpc/spritesheets/hair/long_tied/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/black.png",
    "lpc/spritesheets/hair/long_tied/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/black.png.json",
    "lpc/spritesheets/hair/long_tied/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/blonde.png",
    "lpc/spritesheets/hair/long_tied/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/blonde.png.json",
    "lpc/spritesheets/hair/long_tied/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/blue.png",
    "lpc/spritesheets/hair/long_tied/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/blue.png.json",
    "lpc/spritesheets/hair/long_tied/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/dark_brown.png",
    "lpc/spritesheets/hair/long_tied/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/dark_brown.png.json",
    "lpc/spritesheets/hair/long_tied/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/gold.png",
    "lpc/spritesheets/hair/long_tied/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/gold.png.json",
    "lpc/spritesheets/hair/long_tied/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/gray.png",
    "lpc/spritesheets/hair/long_tied/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/gray.png.json",
    "lpc/spritesheets/hair/long_tied/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/green.png",
    "lpc/spritesheets/hair/long_tied/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/green.png.json",
    "lpc/spritesheets/hair/long_tied/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/light_brown.png",
    "lpc/spritesheets/hair/long_tied/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/light_brown.png.json",
    "lpc/spritesheets/hair/long_tied/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/orange.png",
    "lpc/spritesheets/hair/long_tied/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/orange.png.json",
    "lpc/spritesheets/hair/long_tied/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/purple.png",
    "lpc/spritesheets/hair/long_tied/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/purple.png.json",
    "lpc/spritesheets/hair/long_tied/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/red.png",
    "lpc/spritesheets/hair/long_tied/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/red.png.json",
    "lpc/spritesheets/hair/long_tied/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/white.png",
    "lpc/spritesheets/hair/long_tied/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/female/white.png.json",
    "lpc/spritesheets/hair/long_tied/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/black.png",
    "lpc/spritesheets/hair/long_tied/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/black.png.json",
    "lpc/spritesheets/hair/long_tied/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/blonde.png",
    "lpc/spritesheets/hair/long_tied/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/blonde.png.json",
    "lpc/spritesheets/hair/long_tied/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/blue.png",
    "lpc/spritesheets/hair/long_tied/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/blue.png.json",
    "lpc/spritesheets/hair/long_tied/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/dark_brown.png",
    "lpc/spritesheets/hair/long_tied/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/dark_brown.png.json",
    "lpc/spritesheets/hair/long_tied/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/gold.png",
    "lpc/spritesheets/hair/long_tied/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/gold.png.json",
    "lpc/spritesheets/hair/long_tied/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/gray.png",
    "lpc/spritesheets/hair/long_tied/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/gray.png.json",
    "lpc/spritesheets/hair/long_tied/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/green.png",
    "lpc/spritesheets/hair/long_tied/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/green.png.json",
    "lpc/spritesheets/hair/long_tied/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/light_brown.png",
    "lpc/spritesheets/hair/long_tied/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/light_brown.png.json",
    "lpc/spritesheets/hair/long_tied/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/orange.png",
    "lpc/spritesheets/hair/long_tied/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/orange.png.json",
    "lpc/spritesheets/hair/long_tied/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/purple.png",
    "lpc/spritesheets/hair/long_tied/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/purple.png.json",
    "lpc/spritesheets/hair/long_tied/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/red.png",
    "lpc/spritesheets/hair/long_tied/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/red.png.json",
    "lpc/spritesheets/hair/long_tied/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/white.png",
    "lpc/spritesheets/hair/long_tied/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/long_tied/male/white.png.json",
    "lpc/spritesheets/hair/longhawk/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/black.png",
    "lpc/spritesheets/hair/longhawk/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/black.png.json",
    "lpc/spritesheets/hair/longhawk/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/blonde.png",
    "lpc/spritesheets/hair/longhawk/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/blonde.png.json",
    "lpc/spritesheets/hair/longhawk/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/blue.png",
    "lpc/spritesheets/hair/longhawk/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/blue.png.json",
    "lpc/spritesheets/hair/longhawk/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/dark_brown.png",
    "lpc/spritesheets/hair/longhawk/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/dark_brown.png.json",
    "lpc/spritesheets/hair/longhawk/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/gold.png",
    "lpc/spritesheets/hair/longhawk/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/gold.png.json",
    "lpc/spritesheets/hair/longhawk/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/gray.png",
    "lpc/spritesheets/hair/longhawk/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/gray.png.json",
    "lpc/spritesheets/hair/longhawk/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/green.png",
    "lpc/spritesheets/hair/longhawk/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/green.png.json",
    "lpc/spritesheets/hair/longhawk/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/light_brown.png",
    "lpc/spritesheets/hair/longhawk/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/light_brown.png.json",
    "lpc/spritesheets/hair/longhawk/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/orange.png",
    "lpc/spritesheets/hair/longhawk/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/orange.png.json",
    "lpc/spritesheets/hair/longhawk/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/purple.png",
    "lpc/spritesheets/hair/longhawk/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/purple.png.json",
    "lpc/spritesheets/hair/longhawk/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/red.png",
    "lpc/spritesheets/hair/longhawk/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/red.png.json",
    "lpc/spritesheets/hair/longhawk/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/white.png",
    "lpc/spritesheets/hair/longhawk/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/female/white.png.json",
    "lpc/spritesheets/hair/longhawk/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/black.png",
    "lpc/spritesheets/hair/longhawk/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/black.png.json",
    "lpc/spritesheets/hair/longhawk/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/blonde.png",
    "lpc/spritesheets/hair/longhawk/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/blonde.png.json",
    "lpc/spritesheets/hair/longhawk/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/blue.png",
    "lpc/spritesheets/hair/longhawk/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/blue.png.json",
    "lpc/spritesheets/hair/longhawk/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/dark_brown.png",
    "lpc/spritesheets/hair/longhawk/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/dark_brown.png.json",
    "lpc/spritesheets/hair/longhawk/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/gold.png",
    "lpc/spritesheets/hair/longhawk/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/gold.png.json",
    "lpc/spritesheets/hair/longhawk/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/gray.png",
    "lpc/spritesheets/hair/longhawk/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/gray.png.json",
    "lpc/spritesheets/hair/longhawk/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/green.png",
    "lpc/spritesheets/hair/longhawk/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/green.png.json",
    "lpc/spritesheets/hair/longhawk/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/light_brown.png",
    "lpc/spritesheets/hair/longhawk/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/light_brown.png.json",
    "lpc/spritesheets/hair/longhawk/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/orange.png",
    "lpc/spritesheets/hair/longhawk/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/orange.png.json",
    "lpc/spritesheets/hair/longhawk/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/purple.png",
    "lpc/spritesheets/hair/longhawk/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/purple.png.json",
    "lpc/spritesheets/hair/longhawk/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/red.png",
    "lpc/spritesheets/hair/longhawk/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/red.png.json",
    "lpc/spritesheets/hair/longhawk/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/white.png",
    "lpc/spritesheets/hair/longhawk/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longhawk/male/white.png.json",
    "lpc/spritesheets/hair/longknot/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/black.png",
    "lpc/spritesheets/hair/longknot/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/black.png.json",
    "lpc/spritesheets/hair/longknot/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/blonde.png",
    "lpc/spritesheets/hair/longknot/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/blonde.png.json",
    "lpc/spritesheets/hair/longknot/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/blue.png",
    "lpc/spritesheets/hair/longknot/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/blue.png.json",
    "lpc/spritesheets/hair/longknot/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/dark_brown.png",
    "lpc/spritesheets/hair/longknot/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/dark_brown.png.json",
    "lpc/spritesheets/hair/longknot/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/gold.png",
    "lpc/spritesheets/hair/longknot/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/gold.png.json",
    "lpc/spritesheets/hair/longknot/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/gray.png",
    "lpc/spritesheets/hair/longknot/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/gray.png.json",
    "lpc/spritesheets/hair/longknot/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/green.png",
    "lpc/spritesheets/hair/longknot/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/green.png.json",
    "lpc/spritesheets/hair/longknot/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/light_brown.png",
    "lpc/spritesheets/hair/longknot/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/light_brown.png.json",
    "lpc/spritesheets/hair/longknot/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/orange.png",
    "lpc/spritesheets/hair/longknot/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/orange.png.json",
    "lpc/spritesheets/hair/longknot/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/purple.png",
    "lpc/spritesheets/hair/longknot/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/purple.png.json",
    "lpc/spritesheets/hair/longknot/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/red.png",
    "lpc/spritesheets/hair/longknot/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/red.png.json",
    "lpc/spritesheets/hair/longknot/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/white.png",
    "lpc/spritesheets/hair/longknot/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/female/white.png.json",
    "lpc/spritesheets/hair/longknot/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/black.png",
    "lpc/spritesheets/hair/longknot/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/black.png.json",
    "lpc/spritesheets/hair/longknot/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/blonde.png",
    "lpc/spritesheets/hair/longknot/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/blonde.png.json",
    "lpc/spritesheets/hair/longknot/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/blue.png",
    "lpc/spritesheets/hair/longknot/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/blue.png.json",
    "lpc/spritesheets/hair/longknot/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/dark_brown.png",
    "lpc/spritesheets/hair/longknot/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/dark_brown.png.json",
    "lpc/spritesheets/hair/longknot/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/gold.png",
    "lpc/spritesheets/hair/longknot/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/gold.png.json",
    "lpc/spritesheets/hair/longknot/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/gray.png",
    "lpc/spritesheets/hair/longknot/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/gray.png.json",
    "lpc/spritesheets/hair/longknot/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/green.png",
    "lpc/spritesheets/hair/longknot/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/green.png.json",
    "lpc/spritesheets/hair/longknot/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/light_brown.png",
    "lpc/spritesheets/hair/longknot/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/light_brown.png.json",
    "lpc/spritesheets/hair/longknot/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/orange.png",
    "lpc/spritesheets/hair/longknot/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/orange.png.json",
    "lpc/spritesheets/hair/longknot/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/purple.png",
    "lpc/spritesheets/hair/longknot/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/purple.png.json",
    "lpc/spritesheets/hair/longknot/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/red.png",
    "lpc/spritesheets/hair/longknot/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/red.png.json",
    "lpc/spritesheets/hair/longknot/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/white.png",
    "lpc/spritesheets/hair/longknot/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/longknot/male/white.png.json",
    "lpc/spritesheets/hair/loose/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/black.png",
    "lpc/spritesheets/hair/loose/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/black.png.json",
    "lpc/spritesheets/hair/loose/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/blonde.png",
    "lpc/spritesheets/hair/loose/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/blonde.png.json",
    "lpc/spritesheets/hair/loose/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/blue.png",
    "lpc/spritesheets/hair/loose/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/blue.png.json",
    "lpc/spritesheets/hair/loose/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/dark_brown.png",
    "lpc/spritesheets/hair/loose/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/dark_brown.png.json",
    "lpc/spritesheets/hair/loose/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/gold.png",
    "lpc/spritesheets/hair/loose/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/gold.png.json",
    "lpc/spritesheets/hair/loose/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/gray.png",
    "lpc/spritesheets/hair/loose/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/gray.png.json",
    "lpc/spritesheets/hair/loose/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/green.png",
    "lpc/spritesheets/hair/loose/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/green.png.json",
    "lpc/spritesheets/hair/loose/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/light_brown.png",
    "lpc/spritesheets/hair/loose/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/light_brown.png.json",
    "lpc/spritesheets/hair/loose/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/orange.png",
    "lpc/spritesheets/hair/loose/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/orange.png.json",
    "lpc/spritesheets/hair/loose/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/purple.png",
    "lpc/spritesheets/hair/loose/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/purple.png.json",
    "lpc/spritesheets/hair/loose/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/red.png",
    "lpc/spritesheets/hair/loose/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/red.png.json",
    "lpc/spritesheets/hair/loose/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/white.png",
    "lpc/spritesheets/hair/loose/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/female/white.png.json",
    "lpc/spritesheets/hair/loose/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/black.png",
    "lpc/spritesheets/hair/loose/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/black.png.json",
    "lpc/spritesheets/hair/loose/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/blonde.png",
    "lpc/spritesheets/hair/loose/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/blonde.png.json",
    "lpc/spritesheets/hair/loose/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/blue.png",
    "lpc/spritesheets/hair/loose/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/blue.png.json",
    "lpc/spritesheets/hair/loose/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/dark_brown.png",
    "lpc/spritesheets/hair/loose/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/dark_brown.png.json",
    "lpc/spritesheets/hair/loose/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/gold.png",
    "lpc/spritesheets/hair/loose/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/gold.png.json",
    "lpc/spritesheets/hair/loose/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/gray.png",
    "lpc/spritesheets/hair/loose/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/gray.png.json",
    "lpc/spritesheets/hair/loose/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/green.png",
    "lpc/spritesheets/hair/loose/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/green.png.json",
    "lpc/spritesheets/hair/loose/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/light_brown.png",
    "lpc/spritesheets/hair/loose/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/light_brown.png.json",
    "lpc/spritesheets/hair/loose/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/orange.png",
    "lpc/spritesheets/hair/loose/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/orange.png.json",
    "lpc/spritesheets/hair/loose/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/purple.png",
    "lpc/spritesheets/hair/loose/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/purple.png.json",
    "lpc/spritesheets/hair/loose/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/red.png",
    "lpc/spritesheets/hair/loose/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/red.png.json",
    "lpc/spritesheets/hair/loose/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/white.png",
    "lpc/spritesheets/hair/loose/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/loose/male/white.png.json",
    "lpc/spritesheets/hair/messy1/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/black.png",
    "lpc/spritesheets/hair/messy1/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/black.png.json",
    "lpc/spritesheets/hair/messy1/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/blonde.png",
    "lpc/spritesheets/hair/messy1/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/blonde.png.json",
    "lpc/spritesheets/hair/messy1/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/blue.png",
    "lpc/spritesheets/hair/messy1/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/blue.png.json",
    "lpc/spritesheets/hair/messy1/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/dark_brown.png",
    "lpc/spritesheets/hair/messy1/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/dark_brown.png.json",
    "lpc/spritesheets/hair/messy1/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/gold.png",
    "lpc/spritesheets/hair/messy1/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/gold.png.json",
    "lpc/spritesheets/hair/messy1/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/gray.png",
    "lpc/spritesheets/hair/messy1/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/gray.png.json",
    "lpc/spritesheets/hair/messy1/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/green.png",
    "lpc/spritesheets/hair/messy1/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/green.png.json",
    "lpc/spritesheets/hair/messy1/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/light_brown.png",
    "lpc/spritesheets/hair/messy1/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/light_brown.png.json",
    "lpc/spritesheets/hair/messy1/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/orange.png",
    "lpc/spritesheets/hair/messy1/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/orange.png.json",
    "lpc/spritesheets/hair/messy1/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/purple.png",
    "lpc/spritesheets/hair/messy1/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/purple.png.json",
    "lpc/spritesheets/hair/messy1/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/red.png",
    "lpc/spritesheets/hair/messy1/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/red.png.json",
    "lpc/spritesheets/hair/messy1/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/white.png",
    "lpc/spritesheets/hair/messy1/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/female/white.png.json",
    "lpc/spritesheets/hair/messy1/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/black.png",
    "lpc/spritesheets/hair/messy1/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/black.png.json",
    "lpc/spritesheets/hair/messy1/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/blonde.png",
    "lpc/spritesheets/hair/messy1/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/blonde.png.json",
    "lpc/spritesheets/hair/messy1/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/blue.png",
    "lpc/spritesheets/hair/messy1/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/blue.png.json",
    "lpc/spritesheets/hair/messy1/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/dark_brown.png",
    "lpc/spritesheets/hair/messy1/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/dark_brown.png.json",
    "lpc/spritesheets/hair/messy1/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/gold.png",
    "lpc/spritesheets/hair/messy1/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/gold.png.json",
    "lpc/spritesheets/hair/messy1/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/gray.png",
    "lpc/spritesheets/hair/messy1/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/gray.png.json",
    "lpc/spritesheets/hair/messy1/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/green.png",
    "lpc/spritesheets/hair/messy1/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/green.png.json",
    "lpc/spritesheets/hair/messy1/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/light_brown.png",
    "lpc/spritesheets/hair/messy1/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/light_brown.png.json",
    "lpc/spritesheets/hair/messy1/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/orange.png",
    "lpc/spritesheets/hair/messy1/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/orange.png.json",
    "lpc/spritesheets/hair/messy1/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/purple.png",
    "lpc/spritesheets/hair/messy1/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/purple.png.json",
    "lpc/spritesheets/hair/messy1/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/red.png",
    "lpc/spritesheets/hair/messy1/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/red.png.json",
    "lpc/spritesheets/hair/messy1/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/white.png",
    "lpc/spritesheets/hair/messy1/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy1/male/white.png.json",
    "lpc/spritesheets/hair/messy2/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/black.png",
    "lpc/spritesheets/hair/messy2/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/black.png.json",
    "lpc/spritesheets/hair/messy2/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/blonde.png",
    "lpc/spritesheets/hair/messy2/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/blonde.png.json",
    "lpc/spritesheets/hair/messy2/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/blue.png",
    "lpc/spritesheets/hair/messy2/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/blue.png.json",
    "lpc/spritesheets/hair/messy2/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/dark_brown.png",
    "lpc/spritesheets/hair/messy2/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/dark_brown.png.json",
    "lpc/spritesheets/hair/messy2/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/gold.png",
    "lpc/spritesheets/hair/messy2/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/gold.png.json",
    "lpc/spritesheets/hair/messy2/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/gray.png",
    "lpc/spritesheets/hair/messy2/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/gray.png.json",
    "lpc/spritesheets/hair/messy2/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/green.png",
    "lpc/spritesheets/hair/messy2/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/green.png.json",
    "lpc/spritesheets/hair/messy2/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/light_brown.png",
    "lpc/spritesheets/hair/messy2/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/light_brown.png.json",
    "lpc/spritesheets/hair/messy2/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/orange.png",
    "lpc/spritesheets/hair/messy2/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/orange.png.json",
    "lpc/spritesheets/hair/messy2/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/purple.png",
    "lpc/spritesheets/hair/messy2/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/purple.png.json",
    "lpc/spritesheets/hair/messy2/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/red.png",
    "lpc/spritesheets/hair/messy2/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/red.png.json",
    "lpc/spritesheets/hair/messy2/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/white.png",
    "lpc/spritesheets/hair/messy2/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/female/white.png.json",
    "lpc/spritesheets/hair/messy2/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/black.png",
    "lpc/spritesheets/hair/messy2/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/black.png.json",
    "lpc/spritesheets/hair/messy2/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/blonde.png",
    "lpc/spritesheets/hair/messy2/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/blonde.png.json",
    "lpc/spritesheets/hair/messy2/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/blue.png",
    "lpc/spritesheets/hair/messy2/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/blue.png.json",
    "lpc/spritesheets/hair/messy2/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/dark_brown.png",
    "lpc/spritesheets/hair/messy2/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/dark_brown.png.json",
    "lpc/spritesheets/hair/messy2/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/gold.png",
    "lpc/spritesheets/hair/messy2/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/gold.png.json",
    "lpc/spritesheets/hair/messy2/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/gray.png",
    "lpc/spritesheets/hair/messy2/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/gray.png.json",
    "lpc/spritesheets/hair/messy2/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/green.png",
    "lpc/spritesheets/hair/messy2/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/green.png.json",
    "lpc/spritesheets/hair/messy2/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/light_brown.png",
    "lpc/spritesheets/hair/messy2/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/light_brown.png.json",
    "lpc/spritesheets/hair/messy2/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/orange.png",
    "lpc/spritesheets/hair/messy2/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/orange.png.json",
    "lpc/spritesheets/hair/messy2/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/purple.png",
    "lpc/spritesheets/hair/messy2/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/purple.png.json",
    "lpc/spritesheets/hair/messy2/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/red.png",
    "lpc/spritesheets/hair/messy2/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/red.png.json",
    "lpc/spritesheets/hair/messy2/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/white.png",
    "lpc/spritesheets/hair/messy2/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy2/male/white.png.json",
    "lpc/spritesheets/hair/messy3/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/black.png",
    "lpc/spritesheets/hair/messy3/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/black.png.json",
    "lpc/spritesheets/hair/messy3/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/blonde.png",
    "lpc/spritesheets/hair/messy3/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/blonde.png.json",
    "lpc/spritesheets/hair/messy3/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/blue.png",
    "lpc/spritesheets/hair/messy3/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/blue.png.json",
    "lpc/spritesheets/hair/messy3/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/dark_brown.png",
    "lpc/spritesheets/hair/messy3/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/dark_brown.png.json",
    "lpc/spritesheets/hair/messy3/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/gold.png",
    "lpc/spritesheets/hair/messy3/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/gold.png.json",
    "lpc/spritesheets/hair/messy3/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/gray.png",
    "lpc/spritesheets/hair/messy3/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/gray.png.json",
    "lpc/spritesheets/hair/messy3/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/green.png",
    "lpc/spritesheets/hair/messy3/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/green.png.json",
    "lpc/spritesheets/hair/messy3/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/light_brown.png",
    "lpc/spritesheets/hair/messy3/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/light_brown.png.json",
    "lpc/spritesheets/hair/messy3/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/orange.png",
    "lpc/spritesheets/hair/messy3/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/orange.png.json",
    "lpc/spritesheets/hair/messy3/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/purple.png",
    "lpc/spritesheets/hair/messy3/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/purple.png.json",
    "lpc/spritesheets/hair/messy3/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/red.png",
    "lpc/spritesheets/hair/messy3/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/red.png.json",
    "lpc/spritesheets/hair/messy3/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/white.png",
    "lpc/spritesheets/hair/messy3/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/female/white.png.json",
    "lpc/spritesheets/hair/messy3/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/black.png",
    "lpc/spritesheets/hair/messy3/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/black.png.json",
    "lpc/spritesheets/hair/messy3/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/blonde.png",
    "lpc/spritesheets/hair/messy3/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/blonde.png.json",
    "lpc/spritesheets/hair/messy3/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/blue.png",
    "lpc/spritesheets/hair/messy3/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/blue.png.json",
    "lpc/spritesheets/hair/messy3/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/dark_brown.png",
    "lpc/spritesheets/hair/messy3/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/dark_brown.png.json",
    "lpc/spritesheets/hair/messy3/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/gold.png",
    "lpc/spritesheets/hair/messy3/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/gold.png.json",
    "lpc/spritesheets/hair/messy3/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/gray.png",
    "lpc/spritesheets/hair/messy3/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/gray.png.json",
    "lpc/spritesheets/hair/messy3/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/green.png",
    "lpc/spritesheets/hair/messy3/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/green.png.json",
    "lpc/spritesheets/hair/messy3/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/light_brown.png",
    "lpc/spritesheets/hair/messy3/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/light_brown.png.json",
    "lpc/spritesheets/hair/messy3/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/orange.png",
    "lpc/spritesheets/hair/messy3/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/orange.png.json",
    "lpc/spritesheets/hair/messy3/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/purple.png",
    "lpc/spritesheets/hair/messy3/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/purple.png.json",
    "lpc/spritesheets/hair/messy3/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/red.png",
    "lpc/spritesheets/hair/messy3/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/red.png.json",
    "lpc/spritesheets/hair/messy3/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/white.png",
    "lpc/spritesheets/hair/messy3/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/messy3/male/white.png.json",
    "lpc/spritesheets/hair/mop/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/black.png",
    "lpc/spritesheets/hair/mop/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/black.png.json",
    "lpc/spritesheets/hair/mop/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/blonde.png",
    "lpc/spritesheets/hair/mop/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/blonde.png.json",
    "lpc/spritesheets/hair/mop/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/blue.png",
    "lpc/spritesheets/hair/mop/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/blue.png.json",
    "lpc/spritesheets/hair/mop/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/dark_brown.png",
    "lpc/spritesheets/hair/mop/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/dark_brown.png.json",
    "lpc/spritesheets/hair/mop/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/gold.png",
    "lpc/spritesheets/hair/mop/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/gold.png.json",
    "lpc/spritesheets/hair/mop/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/gray.png",
    "lpc/spritesheets/hair/mop/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/gray.png.json",
    "lpc/spritesheets/hair/mop/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/green.png",
    "lpc/spritesheets/hair/mop/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/green.png.json",
    "lpc/spritesheets/hair/mop/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/light_brown.png",
    "lpc/spritesheets/hair/mop/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/light_brown.png.json",
    "lpc/spritesheets/hair/mop/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/orange.png",
    "lpc/spritesheets/hair/mop/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/orange.png.json",
    "lpc/spritesheets/hair/mop/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/purple.png",
    "lpc/spritesheets/hair/mop/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/purple.png.json",
    "lpc/spritesheets/hair/mop/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/red.png",
    "lpc/spritesheets/hair/mop/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/red.png.json",
    "lpc/spritesheets/hair/mop/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/white.png",
    "lpc/spritesheets/hair/mop/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/female/white.png.json",
    "lpc/spritesheets/hair/mop/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/black.png",
    "lpc/spritesheets/hair/mop/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/black.png.json",
    "lpc/spritesheets/hair/mop/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/blonde.png",
    "lpc/spritesheets/hair/mop/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/blonde.png.json",
    "lpc/spritesheets/hair/mop/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/blue.png",
    "lpc/spritesheets/hair/mop/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/blue.png.json",
    "lpc/spritesheets/hair/mop/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/dark_brown.png",
    "lpc/spritesheets/hair/mop/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/dark_brown.png.json",
    "lpc/spritesheets/hair/mop/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/gold.png",
    "lpc/spritesheets/hair/mop/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/gold.png.json",
    "lpc/spritesheets/hair/mop/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/gray.png",
    "lpc/spritesheets/hair/mop/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/gray.png.json",
    "lpc/spritesheets/hair/mop/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/green.png",
    "lpc/spritesheets/hair/mop/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/green.png.json",
    "lpc/spritesheets/hair/mop/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/light_brown.png",
    "lpc/spritesheets/hair/mop/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/light_brown.png.json",
    "lpc/spritesheets/hair/mop/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/orange.png",
    "lpc/spritesheets/hair/mop/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/orange.png.json",
    "lpc/spritesheets/hair/mop/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/purple.png",
    "lpc/spritesheets/hair/mop/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/purple.png.json",
    "lpc/spritesheets/hair/mop/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/red.png",
    "lpc/spritesheets/hair/mop/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/red.png.json",
    "lpc/spritesheets/hair/mop/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/white.png",
    "lpc/spritesheets/hair/mop/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/mop/male/white.png.json",
    "lpc/spritesheets/hair/natural/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/black.png",
    "lpc/spritesheets/hair/natural/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/black.png.json",
    "lpc/spritesheets/hair/natural/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/blonde.png",
    "lpc/spritesheets/hair/natural/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/blonde.png.json",
    "lpc/spritesheets/hair/natural/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/blue.png",
    "lpc/spritesheets/hair/natural/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/blue.png.json",
    "lpc/spritesheets/hair/natural/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/dark_brown.png",
    "lpc/spritesheets/hair/natural/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/dark_brown.png.json",
    "lpc/spritesheets/hair/natural/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/gold.png",
    "lpc/spritesheets/hair/natural/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/gold.png.json",
    "lpc/spritesheets/hair/natural/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/gray.png",
    "lpc/spritesheets/hair/natural/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/gray.png.json",
    "lpc/spritesheets/hair/natural/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/green.png",
    "lpc/spritesheets/hair/natural/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/green.png.json",
    "lpc/spritesheets/hair/natural/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/light_brown.png",
    "lpc/spritesheets/hair/natural/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/light_brown.png.json",
    "lpc/spritesheets/hair/natural/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/orange.png",
    "lpc/spritesheets/hair/natural/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/orange.png.json",
    "lpc/spritesheets/hair/natural/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/purple.png",
    "lpc/spritesheets/hair/natural/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/purple.png.json",
    "lpc/spritesheets/hair/natural/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/red.png",
    "lpc/spritesheets/hair/natural/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/red.png.json",
    "lpc/spritesheets/hair/natural/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/white.png",
    "lpc/spritesheets/hair/natural/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/female/white.png.json",
    "lpc/spritesheets/hair/natural/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/black.png",
    "lpc/spritesheets/hair/natural/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/black.png.json",
    "lpc/spritesheets/hair/natural/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/blonde.png",
    "lpc/spritesheets/hair/natural/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/blonde.png.json",
    "lpc/spritesheets/hair/natural/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/blue.png",
    "lpc/spritesheets/hair/natural/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/blue.png.json",
    "lpc/spritesheets/hair/natural/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/dark_brown.png",
    "lpc/spritesheets/hair/natural/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/dark_brown.png.json",
    "lpc/spritesheets/hair/natural/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/gold.png",
    "lpc/spritesheets/hair/natural/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/gold.png.json",
    "lpc/spritesheets/hair/natural/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/gray.png",
    "lpc/spritesheets/hair/natural/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/gray.png.json",
    "lpc/spritesheets/hair/natural/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/green.png",
    "lpc/spritesheets/hair/natural/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/green.png.json",
    "lpc/spritesheets/hair/natural/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/light_brown.png",
    "lpc/spritesheets/hair/natural/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/light_brown.png.json",
    "lpc/spritesheets/hair/natural/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/orange.png",
    "lpc/spritesheets/hair/natural/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/orange.png.json",
    "lpc/spritesheets/hair/natural/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/purple.png",
    "lpc/spritesheets/hair/natural/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/purple.png.json",
    "lpc/spritesheets/hair/natural/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/red.png",
    "lpc/spritesheets/hair/natural/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/red.png.json",
    "lpc/spritesheets/hair/natural/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/white.png",
    "lpc/spritesheets/hair/natural/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/natural/male/white.png.json",
    "lpc/spritesheets/hair/page/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/black.png",
    "lpc/spritesheets/hair/page/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/black.png.json",
    "lpc/spritesheets/hair/page/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/blonde.png",
    "lpc/spritesheets/hair/page/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/blonde.png.json",
    "lpc/spritesheets/hair/page/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/blue.png",
    "lpc/spritesheets/hair/page/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/blue.png.json",
    "lpc/spritesheets/hair/page/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/dark_brown.png",
    "lpc/spritesheets/hair/page/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/dark_brown.png.json",
    "lpc/spritesheets/hair/page/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/gold.png",
    "lpc/spritesheets/hair/page/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/gold.png.json",
    "lpc/spritesheets/hair/page/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/gray.png",
    "lpc/spritesheets/hair/page/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/gray.png.json",
    "lpc/spritesheets/hair/page/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/green.png",
    "lpc/spritesheets/hair/page/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/green.png.json",
    "lpc/spritesheets/hair/page/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/light_brown.png",
    "lpc/spritesheets/hair/page/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/light_brown.png.json",
    "lpc/spritesheets/hair/page/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/orange.png",
    "lpc/spritesheets/hair/page/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/orange.png.json",
    "lpc/spritesheets/hair/page/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/purple.png",
    "lpc/spritesheets/hair/page/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/purple.png.json",
    "lpc/spritesheets/hair/page/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/red.png",
    "lpc/spritesheets/hair/page/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/red.png.json",
    "lpc/spritesheets/hair/page/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/white.png",
    "lpc/spritesheets/hair/page/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/female/white.png.json",
    "lpc/spritesheets/hair/page/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/black.png",
    "lpc/spritesheets/hair/page/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/black.png.json",
    "lpc/spritesheets/hair/page/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/blonde.png",
    "lpc/spritesheets/hair/page/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/blonde.png.json",
    "lpc/spritesheets/hair/page/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/blue.png",
    "lpc/spritesheets/hair/page/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/blue.png.json",
    "lpc/spritesheets/hair/page/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/dark_brown.png",
    "lpc/spritesheets/hair/page/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/dark_brown.png.json",
    "lpc/spritesheets/hair/page/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/gold.png",
    "lpc/spritesheets/hair/page/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/gold.png.json",
    "lpc/spritesheets/hair/page/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/gray.png",
    "lpc/spritesheets/hair/page/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/gray.png.json",
    "lpc/spritesheets/hair/page/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/green.png",
    "lpc/spritesheets/hair/page/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/green.png.json",
    "lpc/spritesheets/hair/page/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/light_brown.png",
    "lpc/spritesheets/hair/page/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/light_brown.png.json",
    "lpc/spritesheets/hair/page/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/orange.png",
    "lpc/spritesheets/hair/page/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/orange.png.json",
    "lpc/spritesheets/hair/page/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/purple.png",
    "lpc/spritesheets/hair/page/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/purple.png.json",
    "lpc/spritesheets/hair/page/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/red.png",
    "lpc/spritesheets/hair/page/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/red.png.json",
    "lpc/spritesheets/hair/page/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/white.png",
    "lpc/spritesheets/hair/page/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page/male/white.png.json",
    "lpc/spritesheets/hair/page2/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/black.png",
    "lpc/spritesheets/hair/page2/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/black.png.json",
    "lpc/spritesheets/hair/page2/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/blonde.png",
    "lpc/spritesheets/hair/page2/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/blonde.png.json",
    "lpc/spritesheets/hair/page2/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/blue.png",
    "lpc/spritesheets/hair/page2/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/blue.png.json",
    "lpc/spritesheets/hair/page2/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/dark_brown.png",
    "lpc/spritesheets/hair/page2/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/dark_brown.png.json",
    "lpc/spritesheets/hair/page2/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/gold.png",
    "lpc/spritesheets/hair/page2/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/gold.png.json",
    "lpc/spritesheets/hair/page2/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/gray.png",
    "lpc/spritesheets/hair/page2/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/gray.png.json",
    "lpc/spritesheets/hair/page2/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/green.png",
    "lpc/spritesheets/hair/page2/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/green.png.json",
    "lpc/spritesheets/hair/page2/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/light_brown.png",
    "lpc/spritesheets/hair/page2/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/light_brown.png.json",
    "lpc/spritesheets/hair/page2/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/orange.png",
    "lpc/spritesheets/hair/page2/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/orange.png.json",
    "lpc/spritesheets/hair/page2/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/purple.png",
    "lpc/spritesheets/hair/page2/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/purple.png.json",
    "lpc/spritesheets/hair/page2/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/red.png",
    "lpc/spritesheets/hair/page2/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/red.png.json",
    "lpc/spritesheets/hair/page2/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/white.png",
    "lpc/spritesheets/hair/page2/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/female/white.png.json",
    "lpc/spritesheets/hair/page2/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/black.png",
    "lpc/spritesheets/hair/page2/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/black.png.json",
    "lpc/spritesheets/hair/page2/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/blonde.png",
    "lpc/spritesheets/hair/page2/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/blonde.png.json",
    "lpc/spritesheets/hair/page2/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/blue.png",
    "lpc/spritesheets/hair/page2/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/blue.png.json",
    "lpc/spritesheets/hair/page2/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/dark_brown.png",
    "lpc/spritesheets/hair/page2/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/dark_brown.png.json",
    "lpc/spritesheets/hair/page2/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/gold.png",
    "lpc/spritesheets/hair/page2/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/gold.png.json",
    "lpc/spritesheets/hair/page2/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/gray.png",
    "lpc/spritesheets/hair/page2/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/gray.png.json",
    "lpc/spritesheets/hair/page2/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/green.png",
    "lpc/spritesheets/hair/page2/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/green.png.json",
    "lpc/spritesheets/hair/page2/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/light_brown.png",
    "lpc/spritesheets/hair/page2/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/light_brown.png.json",
    "lpc/spritesheets/hair/page2/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/orange.png",
    "lpc/spritesheets/hair/page2/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/orange.png.json",
    "lpc/spritesheets/hair/page2/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/purple.png",
    "lpc/spritesheets/hair/page2/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/purple.png.json",
    "lpc/spritesheets/hair/page2/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/red.png",
    "lpc/spritesheets/hair/page2/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/red.png.json",
    "lpc/spritesheets/hair/page2/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/white.png",
    "lpc/spritesheets/hair/page2/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/page2/male/white.png.json",
    "lpc/spritesheets/hair/part2/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/black.png",
    "lpc/spritesheets/hair/part2/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/black.png.json",
    "lpc/spritesheets/hair/part2/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/blonde.png",
    "lpc/spritesheets/hair/part2/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/blonde.png.json",
    "lpc/spritesheets/hair/part2/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/blue.png",
    "lpc/spritesheets/hair/part2/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/blue.png.json",
    "lpc/spritesheets/hair/part2/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/dark_brown.png",
    "lpc/spritesheets/hair/part2/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/dark_brown.png.json",
    "lpc/spritesheets/hair/part2/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/gold.png",
    "lpc/spritesheets/hair/part2/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/gold.png.json",
    "lpc/spritesheets/hair/part2/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/gray.png",
    "lpc/spritesheets/hair/part2/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/gray.png.json",
    "lpc/spritesheets/hair/part2/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/green.png",
    "lpc/spritesheets/hair/part2/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/green.png.json",
    "lpc/spritesheets/hair/part2/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/light_brown.png",
    "lpc/spritesheets/hair/part2/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/light_brown.png.json",
    "lpc/spritesheets/hair/part2/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/orange.png",
    "lpc/spritesheets/hair/part2/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/orange.png.json",
    "lpc/spritesheets/hair/part2/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/purple.png",
    "lpc/spritesheets/hair/part2/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/purple.png.json",
    "lpc/spritesheets/hair/part2/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/red.png",
    "lpc/spritesheets/hair/part2/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/red.png.json",
    "lpc/spritesheets/hair/part2/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/white.png",
    "lpc/spritesheets/hair/part2/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/female/white.png.json",
    "lpc/spritesheets/hair/part2/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/black.png",
    "lpc/spritesheets/hair/part2/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/black.png.json",
    "lpc/spritesheets/hair/part2/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/blonde.png",
    "lpc/spritesheets/hair/part2/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/blonde.png.json",
    "lpc/spritesheets/hair/part2/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/blue.png",
    "lpc/spritesheets/hair/part2/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/blue.png.json",
    "lpc/spritesheets/hair/part2/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/dark_brown.png",
    "lpc/spritesheets/hair/part2/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/dark_brown.png.json",
    "lpc/spritesheets/hair/part2/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/gold.png",
    "lpc/spritesheets/hair/part2/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/gold.png.json",
    "lpc/spritesheets/hair/part2/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/gray.png",
    "lpc/spritesheets/hair/part2/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/gray.png.json",
    "lpc/spritesheets/hair/part2/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/green.png",
    "lpc/spritesheets/hair/part2/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/green.png.json",
    "lpc/spritesheets/hair/part2/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/light_brown.png",
    "lpc/spritesheets/hair/part2/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/light_brown.png.json",
    "lpc/spritesheets/hair/part2/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/orange.png",
    "lpc/spritesheets/hair/part2/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/orange.png.json",
    "lpc/spritesheets/hair/part2/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/purple.png",
    "lpc/spritesheets/hair/part2/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/purple.png.json",
    "lpc/spritesheets/hair/part2/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/red.png",
    "lpc/spritesheets/hair/part2/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/red.png.json",
    "lpc/spritesheets/hair/part2/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/white.png",
    "lpc/spritesheets/hair/part2/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/part2/male/white.png.json",
    "lpc/spritesheets/hair/parted/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/black.png",
    "lpc/spritesheets/hair/parted/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/black.png.json",
    "lpc/spritesheets/hair/parted/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/blonde.png",
    "lpc/spritesheets/hair/parted/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/blonde.png.json",
    "lpc/spritesheets/hair/parted/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/blue.png",
    "lpc/spritesheets/hair/parted/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/blue.png.json",
    "lpc/spritesheets/hair/parted/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/dark_brown.png",
    "lpc/spritesheets/hair/parted/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/dark_brown.png.json",
    "lpc/spritesheets/hair/parted/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/gold.png",
    "lpc/spritesheets/hair/parted/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/gold.png.json",
    "lpc/spritesheets/hair/parted/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/gray.png",
    "lpc/spritesheets/hair/parted/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/gray.png.json",
    "lpc/spritesheets/hair/parted/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/green.png",
    "lpc/spritesheets/hair/parted/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/green.png.json",
    "lpc/spritesheets/hair/parted/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/light_brown.png",
    "lpc/spritesheets/hair/parted/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/light_brown.png.json",
    "lpc/spritesheets/hair/parted/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/orange.png",
    "lpc/spritesheets/hair/parted/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/orange.png.json",
    "lpc/spritesheets/hair/parted/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/purple.png",
    "lpc/spritesheets/hair/parted/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/purple.png.json",
    "lpc/spritesheets/hair/parted/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/red.png",
    "lpc/spritesheets/hair/parted/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/red.png.json",
    "lpc/spritesheets/hair/parted/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/white.png",
    "lpc/spritesheets/hair/parted/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/female/white.png.json",
    "lpc/spritesheets/hair/parted/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/black.png",
    "lpc/spritesheets/hair/parted/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/black.png.json",
    "lpc/spritesheets/hair/parted/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/blonde.png",
    "lpc/spritesheets/hair/parted/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/blonde.png.json",
    "lpc/spritesheets/hair/parted/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/blue.png",
    "lpc/spritesheets/hair/parted/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/blue.png.json",
    "lpc/spritesheets/hair/parted/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/dark_brown.png",
    "lpc/spritesheets/hair/parted/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/dark_brown.png.json",
    "lpc/spritesheets/hair/parted/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/gold.png",
    "lpc/spritesheets/hair/parted/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/gold.png.json",
    "lpc/spritesheets/hair/parted/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/gray.png",
    "lpc/spritesheets/hair/parted/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/gray.png.json",
    "lpc/spritesheets/hair/parted/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/green.png",
    "lpc/spritesheets/hair/parted/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/green.png.json",
    "lpc/spritesheets/hair/parted/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/light_brown.png",
    "lpc/spritesheets/hair/parted/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/light_brown.png.json",
    "lpc/spritesheets/hair/parted/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/orange.png",
    "lpc/spritesheets/hair/parted/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/orange.png.json",
    "lpc/spritesheets/hair/parted/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/purple.png",
    "lpc/spritesheets/hair/parted/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/purple.png.json",
    "lpc/spritesheets/hair/parted/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/red.png",
    "lpc/spritesheets/hair/parted/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/red.png.json",
    "lpc/spritesheets/hair/parted/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/white.png",
    "lpc/spritesheets/hair/parted/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/parted/male/white.png.json",
    "lpc/spritesheets/hair/pigtails/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/black.png",
    "lpc/spritesheets/hair/pigtails/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/black.png.json",
    "lpc/spritesheets/hair/pigtails/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/blonde.png",
    "lpc/spritesheets/hair/pigtails/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/blonde.png.json",
    "lpc/spritesheets/hair/pigtails/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/blue.png",
    "lpc/spritesheets/hair/pigtails/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/blue.png.json",
    "lpc/spritesheets/hair/pigtails/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/dark_brown.png",
    "lpc/spritesheets/hair/pigtails/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/dark_brown.png.json",
    "lpc/spritesheets/hair/pigtails/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/gold.png",
    "lpc/spritesheets/hair/pigtails/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/gold.png.json",
    "lpc/spritesheets/hair/pigtails/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/gray.png",
    "lpc/spritesheets/hair/pigtails/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/gray.png.json",
    "lpc/spritesheets/hair/pigtails/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/green.png",
    "lpc/spritesheets/hair/pigtails/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/green.png.json",
    "lpc/spritesheets/hair/pigtails/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/light_brown.png",
    "lpc/spritesheets/hair/pigtails/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/light_brown.png.json",
    "lpc/spritesheets/hair/pigtails/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/orange.png",
    "lpc/spritesheets/hair/pigtails/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/orange.png.json",
    "lpc/spritesheets/hair/pigtails/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/purple.png",
    "lpc/spritesheets/hair/pigtails/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/purple.png.json",
    "lpc/spritesheets/hair/pigtails/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/red.png",
    "lpc/spritesheets/hair/pigtails/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/red.png.json",
    "lpc/spritesheets/hair/pigtails/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/white.png",
    "lpc/spritesheets/hair/pigtails/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/female/white.png.json",
    "lpc/spritesheets/hair/pigtails/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/black.png",
    "lpc/spritesheets/hair/pigtails/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/black.png.json",
    "lpc/spritesheets/hair/pigtails/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/blonde.png",
    "lpc/spritesheets/hair/pigtails/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/blonde.png.json",
    "lpc/spritesheets/hair/pigtails/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/blue.png",
    "lpc/spritesheets/hair/pigtails/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/blue.png.json",
    "lpc/spritesheets/hair/pigtails/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/dark_brown.png",
    "lpc/spritesheets/hair/pigtails/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/dark_brown.png.json",
    "lpc/spritesheets/hair/pigtails/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/gold.png",
    "lpc/spritesheets/hair/pigtails/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/gold.png.json",
    "lpc/spritesheets/hair/pigtails/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/gray.png",
    "lpc/spritesheets/hair/pigtails/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/gray.png.json",
    "lpc/spritesheets/hair/pigtails/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/green.png",
    "lpc/spritesheets/hair/pigtails/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/green.png.json",
    "lpc/spritesheets/hair/pigtails/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/light_brown.png",
    "lpc/spritesheets/hair/pigtails/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/light_brown.png.json",
    "lpc/spritesheets/hair/pigtails/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/orange.png",
    "lpc/spritesheets/hair/pigtails/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/orange.png.json",
    "lpc/spritesheets/hair/pigtails/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/purple.png",
    "lpc/spritesheets/hair/pigtails/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/purple.png.json",
    "lpc/spritesheets/hair/pigtails/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/red.png",
    "lpc/spritesheets/hair/pigtails/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/red.png.json",
    "lpc/spritesheets/hair/pigtails/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/white.png",
    "lpc/spritesheets/hair/pigtails/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails/male/white.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/black.png",
    "lpc/spritesheets/hair/pigtails_bangs/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/black.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/blonde.png",
    "lpc/spritesheets/hair/pigtails_bangs/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/blonde.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/blue.png",
    "lpc/spritesheets/hair/pigtails_bangs/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/blue.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/dark_brown.png",
    "lpc/spritesheets/hair/pigtails_bangs/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/dark_brown.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/gold.png",
    "lpc/spritesheets/hair/pigtails_bangs/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/gold.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/gray.png",
    "lpc/spritesheets/hair/pigtails_bangs/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/gray.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/green.png",
    "lpc/spritesheets/hair/pigtails_bangs/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/green.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/light_brown.png",
    "lpc/spritesheets/hair/pigtails_bangs/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/light_brown.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/orange.png",
    "lpc/spritesheets/hair/pigtails_bangs/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/orange.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/purple.png",
    "lpc/spritesheets/hair/pigtails_bangs/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/purple.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/red.png",
    "lpc/spritesheets/hair/pigtails_bangs/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/red.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/white.png",
    "lpc/spritesheets/hair/pigtails_bangs/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/female/white.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/black.png",
    "lpc/spritesheets/hair/pigtails_bangs/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/black.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/blonde.png",
    "lpc/spritesheets/hair/pigtails_bangs/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/blonde.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/blue.png",
    "lpc/spritesheets/hair/pigtails_bangs/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/blue.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/dark_brown.png",
    "lpc/spritesheets/hair/pigtails_bangs/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/dark_brown.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/gold.png",
    "lpc/spritesheets/hair/pigtails_bangs/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/gold.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/gray.png",
    "lpc/spritesheets/hair/pigtails_bangs/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/gray.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/green.png",
    "lpc/spritesheets/hair/pigtails_bangs/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/green.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/light_brown.png",
    "lpc/spritesheets/hair/pigtails_bangs/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/light_brown.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/orange.png",
    "lpc/spritesheets/hair/pigtails_bangs/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/orange.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/purple.png",
    "lpc/spritesheets/hair/pigtails_bangs/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/purple.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/red.png",
    "lpc/spritesheets/hair/pigtails_bangs/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/red.png.json",
    "lpc/spritesheets/hair/pigtails_bangs/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/white.png",
    "lpc/spritesheets/hair/pigtails_bangs/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pigtails_bangs/male/white.png.json",
    "lpc/spritesheets/hair/pixie/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/black.png",
    "lpc/spritesheets/hair/pixie/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/black.png.json",
    "lpc/spritesheets/hair/pixie/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/blonde.png",
    "lpc/spritesheets/hair/pixie/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/blonde.png.json",
    "lpc/spritesheets/hair/pixie/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/blue.png",
    "lpc/spritesheets/hair/pixie/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/blue.png.json",
    "lpc/spritesheets/hair/pixie/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/dark_brown.png",
    "lpc/spritesheets/hair/pixie/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/dark_brown.png.json",
    "lpc/spritesheets/hair/pixie/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/gold.png",
    "lpc/spritesheets/hair/pixie/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/gold.png.json",
    "lpc/spritesheets/hair/pixie/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/gray.png",
    "lpc/spritesheets/hair/pixie/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/gray.png.json",
    "lpc/spritesheets/hair/pixie/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/green.png",
    "lpc/spritesheets/hair/pixie/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/green.png.json",
    "lpc/spritesheets/hair/pixie/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/light_brown.png",
    "lpc/spritesheets/hair/pixie/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/light_brown.png.json",
    "lpc/spritesheets/hair/pixie/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/orange.png",
    "lpc/spritesheets/hair/pixie/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/orange.png.json",
    "lpc/spritesheets/hair/pixie/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/purple.png",
    "lpc/spritesheets/hair/pixie/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/purple.png.json",
    "lpc/spritesheets/hair/pixie/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/red.png",
    "lpc/spritesheets/hair/pixie/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/red.png.json",
    "lpc/spritesheets/hair/pixie/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/white.png",
    "lpc/spritesheets/hair/pixie/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/female/white.png.json",
    "lpc/spritesheets/hair/pixie/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/black.png",
    "lpc/spritesheets/hair/pixie/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/black.png.json",
    "lpc/spritesheets/hair/pixie/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/blonde.png",
    "lpc/spritesheets/hair/pixie/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/blonde.png.json",
    "lpc/spritesheets/hair/pixie/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/blue.png",
    "lpc/spritesheets/hair/pixie/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/blue.png.json",
    "lpc/spritesheets/hair/pixie/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/dark_brown.png",
    "lpc/spritesheets/hair/pixie/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/dark_brown.png.json",
    "lpc/spritesheets/hair/pixie/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/gold.png",
    "lpc/spritesheets/hair/pixie/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/gold.png.json",
    "lpc/spritesheets/hair/pixie/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/gray.png",
    "lpc/spritesheets/hair/pixie/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/gray.png.json",
    "lpc/spritesheets/hair/pixie/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/green.png",
    "lpc/spritesheets/hair/pixie/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/green.png.json",
    "lpc/spritesheets/hair/pixie/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/light_brown.png",
    "lpc/spritesheets/hair/pixie/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/light_brown.png.json",
    "lpc/spritesheets/hair/pixie/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/orange.png",
    "lpc/spritesheets/hair/pixie/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/orange.png.json",
    "lpc/spritesheets/hair/pixie/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/purple.png",
    "lpc/spritesheets/hair/pixie/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/purple.png.json",
    "lpc/spritesheets/hair/pixie/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/red.png",
    "lpc/spritesheets/hair/pixie/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/red.png.json",
    "lpc/spritesheets/hair/pixie/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/white.png",
    "lpc/spritesheets/hair/pixie/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/pixie/male/white.png.json",
    "lpc/spritesheets/hair/plain/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/black.png",
    "lpc/spritesheets/hair/plain/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/black.png.json",
    "lpc/spritesheets/hair/plain/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/blonde.png",
    "lpc/spritesheets/hair/plain/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/blonde.png.json",
    "lpc/spritesheets/hair/plain/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/blue.png",
    "lpc/spritesheets/hair/plain/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/blue.png.json",
    "lpc/spritesheets/hair/plain/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/dark_brown.png",
    "lpc/spritesheets/hair/plain/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/dark_brown.png.json",
    "lpc/spritesheets/hair/plain/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/gold.png",
    "lpc/spritesheets/hair/plain/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/gold.png.json",
    "lpc/spritesheets/hair/plain/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/gray.png",
    "lpc/spritesheets/hair/plain/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/gray.png.json",
    "lpc/spritesheets/hair/plain/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/green.png",
    "lpc/spritesheets/hair/plain/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/green.png.json",
    "lpc/spritesheets/hair/plain/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/light_brown.png",
    "lpc/spritesheets/hair/plain/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/light_brown.png.json",
    "lpc/spritesheets/hair/plain/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/orange.png",
    "lpc/spritesheets/hair/plain/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/orange.png.json",
    "lpc/spritesheets/hair/plain/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/purple.png",
    "lpc/spritesheets/hair/plain/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/purple.png.json",
    "lpc/spritesheets/hair/plain/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/red.png",
    "lpc/spritesheets/hair/plain/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/red.png.json",
    "lpc/spritesheets/hair/plain/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/white.png",
    "lpc/spritesheets/hair/plain/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/female/white.png.json",
    "lpc/spritesheets/hair/plain/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/black.png",
    "lpc/spritesheets/hair/plain/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/black.png.json",
    "lpc/spritesheets/hair/plain/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/blonde.png",
    "lpc/spritesheets/hair/plain/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/blonde.png.json",
    "lpc/spritesheets/hair/plain/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/blue.png",
    "lpc/spritesheets/hair/plain/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/blue.png.json",
    "lpc/spritesheets/hair/plain/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/dark_brown.png",
    "lpc/spritesheets/hair/plain/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/dark_brown.png.json",
    "lpc/spritesheets/hair/plain/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/gold.png",
    "lpc/spritesheets/hair/plain/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/gold.png.json",
    "lpc/spritesheets/hair/plain/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/gray.png",
    "lpc/spritesheets/hair/plain/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/gray.png.json",
    "lpc/spritesheets/hair/plain/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/green.png",
    "lpc/spritesheets/hair/plain/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/green.png.json",
    "lpc/spritesheets/hair/plain/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/light_brown.png",
    "lpc/spritesheets/hair/plain/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/light_brown.png.json",
    "lpc/spritesheets/hair/plain/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/orange.png",
    "lpc/spritesheets/hair/plain/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/orange.png.json",
    "lpc/spritesheets/hair/plain/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/purple.png",
    "lpc/spritesheets/hair/plain/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/purple.png.json",
    "lpc/spritesheets/hair/plain/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/red.png",
    "lpc/spritesheets/hair/plain/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/red.png.json",
    "lpc/spritesheets/hair/plain/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/white.png",
    "lpc/spritesheets/hair/plain/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/plain/male/white.png.json",
    "lpc/spritesheets/hair/ponytail/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/black.png",
    "lpc/spritesheets/hair/ponytail/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/black.png.json",
    "lpc/spritesheets/hair/ponytail/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/blonde.png",
    "lpc/spritesheets/hair/ponytail/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/blonde.png.json",
    "lpc/spritesheets/hair/ponytail/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/blue.png",
    "lpc/spritesheets/hair/ponytail/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/blue.png.json",
    "lpc/spritesheets/hair/ponytail/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/dark_brown.png",
    "lpc/spritesheets/hair/ponytail/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/dark_brown.png.json",
    "lpc/spritesheets/hair/ponytail/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/gold.png",
    "lpc/spritesheets/hair/ponytail/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/gold.png.json",
    "lpc/spritesheets/hair/ponytail/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/gray.png",
    "lpc/spritesheets/hair/ponytail/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/gray.png.json",
    "lpc/spritesheets/hair/ponytail/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/green.png",
    "lpc/spritesheets/hair/ponytail/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/green.png.json",
    "lpc/spritesheets/hair/ponytail/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/light_brown.png",
    "lpc/spritesheets/hair/ponytail/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/light_brown.png.json",
    "lpc/spritesheets/hair/ponytail/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/orange.png",
    "lpc/spritesheets/hair/ponytail/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/orange.png.json",
    "lpc/spritesheets/hair/ponytail/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/purple.png",
    "lpc/spritesheets/hair/ponytail/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/purple.png.json",
    "lpc/spritesheets/hair/ponytail/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/red.png",
    "lpc/spritesheets/hair/ponytail/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/red.png.json",
    "lpc/spritesheets/hair/ponytail/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/white.png",
    "lpc/spritesheets/hair/ponytail/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/female/white.png.json",
    "lpc/spritesheets/hair/ponytail/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/black.png",
    "lpc/spritesheets/hair/ponytail/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/black.png.json",
    "lpc/spritesheets/hair/ponytail/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/blonde.png",
    "lpc/spritesheets/hair/ponytail/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/blonde.png.json",
    "lpc/spritesheets/hair/ponytail/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/blue.png",
    "lpc/spritesheets/hair/ponytail/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/blue.png.json",
    "lpc/spritesheets/hair/ponytail/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/dark_brown.png",
    "lpc/spritesheets/hair/ponytail/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/dark_brown.png.json",
    "lpc/spritesheets/hair/ponytail/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/gold.png",
    "lpc/spritesheets/hair/ponytail/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/gold.png.json",
    "lpc/spritesheets/hair/ponytail/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/gray.png",
    "lpc/spritesheets/hair/ponytail/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/gray.png.json",
    "lpc/spritesheets/hair/ponytail/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/green.png",
    "lpc/spritesheets/hair/ponytail/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/green.png.json",
    "lpc/spritesheets/hair/ponytail/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/light_brown.png",
    "lpc/spritesheets/hair/ponytail/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/light_brown.png.json",
    "lpc/spritesheets/hair/ponytail/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/orange.png",
    "lpc/spritesheets/hair/ponytail/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/orange.png.json",
    "lpc/spritesheets/hair/ponytail/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/purple.png",
    "lpc/spritesheets/hair/ponytail/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/purple.png.json",
    "lpc/spritesheets/hair/ponytail/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/red.png",
    "lpc/spritesheets/hair/ponytail/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/red.png.json",
    "lpc/spritesheets/hair/ponytail/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/white.png",
    "lpc/spritesheets/hair/ponytail/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail/male/white.png.json",
    "lpc/spritesheets/hair/ponytail2/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/black.png",
    "lpc/spritesheets/hair/ponytail2/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/black.png.json",
    "lpc/spritesheets/hair/ponytail2/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/blonde.png",
    "lpc/spritesheets/hair/ponytail2/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/blonde.png.json",
    "lpc/spritesheets/hair/ponytail2/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/blue.png",
    "lpc/spritesheets/hair/ponytail2/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/blue.png.json",
    "lpc/spritesheets/hair/ponytail2/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/dark_brown.png",
    "lpc/spritesheets/hair/ponytail2/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/dark_brown.png.json",
    "lpc/spritesheets/hair/ponytail2/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/gold.png",
    "lpc/spritesheets/hair/ponytail2/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/gold.png.json",
    "lpc/spritesheets/hair/ponytail2/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/gray.png",
    "lpc/spritesheets/hair/ponytail2/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/gray.png.json",
    "lpc/spritesheets/hair/ponytail2/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/green.png",
    "lpc/spritesheets/hair/ponytail2/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/green.png.json",
    "lpc/spritesheets/hair/ponytail2/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/light_brown.png",
    "lpc/spritesheets/hair/ponytail2/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/light_brown.png.json",
    "lpc/spritesheets/hair/ponytail2/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/orange.png",
    "lpc/spritesheets/hair/ponytail2/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/orange.png.json",
    "lpc/spritesheets/hair/ponytail2/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/purple.png",
    "lpc/spritesheets/hair/ponytail2/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/purple.png.json",
    "lpc/spritesheets/hair/ponytail2/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/red.png",
    "lpc/spritesheets/hair/ponytail2/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/red.png.json",
    "lpc/spritesheets/hair/ponytail2/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/white.png",
    "lpc/spritesheets/hair/ponytail2/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/female/white.png.json",
    "lpc/spritesheets/hair/ponytail2/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/black.png",
    "lpc/spritesheets/hair/ponytail2/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/black.png.json",
    "lpc/spritesheets/hair/ponytail2/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/blonde.png",
    "lpc/spritesheets/hair/ponytail2/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/blonde.png.json",
    "lpc/spritesheets/hair/ponytail2/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/blue.png",
    "lpc/spritesheets/hair/ponytail2/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/blue.png.json",
    "lpc/spritesheets/hair/ponytail2/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/dark_brown.png",
    "lpc/spritesheets/hair/ponytail2/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/dark_brown.png.json",
    "lpc/spritesheets/hair/ponytail2/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/gold.png",
    "lpc/spritesheets/hair/ponytail2/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/gold.png.json",
    "lpc/spritesheets/hair/ponytail2/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/gray.png",
    "lpc/spritesheets/hair/ponytail2/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/gray.png.json",
    "lpc/spritesheets/hair/ponytail2/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/green.png",
    "lpc/spritesheets/hair/ponytail2/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/green.png.json",
    "lpc/spritesheets/hair/ponytail2/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/light_brown.png",
    "lpc/spritesheets/hair/ponytail2/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/light_brown.png.json",
    "lpc/spritesheets/hair/ponytail2/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/orange.png",
    "lpc/spritesheets/hair/ponytail2/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/orange.png.json",
    "lpc/spritesheets/hair/ponytail2/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/purple.png",
    "lpc/spritesheets/hair/ponytail2/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/purple.png.json",
    "lpc/spritesheets/hair/ponytail2/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/red.png",
    "lpc/spritesheets/hair/ponytail2/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/red.png.json",
    "lpc/spritesheets/hair/ponytail2/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/white.png",
    "lpc/spritesheets/hair/ponytail2/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/ponytail2/male/white.png.json",
    "lpc/spritesheets/hair/princess/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/black.png",
    "lpc/spritesheets/hair/princess/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/black.png.json",
    "lpc/spritesheets/hair/princess/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/blonde.png",
    "lpc/spritesheets/hair/princess/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/blonde.png.json",
    "lpc/spritesheets/hair/princess/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/blue.png",
    "lpc/spritesheets/hair/princess/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/blue.png.json",
    "lpc/spritesheets/hair/princess/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/dark_brown.png",
    "lpc/spritesheets/hair/princess/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/dark_brown.png.json",
    "lpc/spritesheets/hair/princess/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/gold.png",
    "lpc/spritesheets/hair/princess/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/gold.png.json",
    "lpc/spritesheets/hair/princess/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/gray.png",
    "lpc/spritesheets/hair/princess/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/gray.png.json",
    "lpc/spritesheets/hair/princess/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/green.png",
    "lpc/spritesheets/hair/princess/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/green.png.json",
    "lpc/spritesheets/hair/princess/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/light_brown.png",
    "lpc/spritesheets/hair/princess/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/light_brown.png.json",
    "lpc/spritesheets/hair/princess/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/orange.png",
    "lpc/spritesheets/hair/princess/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/orange.png.json",
    "lpc/spritesheets/hair/princess/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/purple.png",
    "lpc/spritesheets/hair/princess/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/purple.png.json",
    "lpc/spritesheets/hair/princess/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/red.png",
    "lpc/spritesheets/hair/princess/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/red.png.json",
    "lpc/spritesheets/hair/princess/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/white.png",
    "lpc/spritesheets/hair/princess/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/female/white.png.json",
    "lpc/spritesheets/hair/princess/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/black.png",
    "lpc/spritesheets/hair/princess/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/black.png.json",
    "lpc/spritesheets/hair/princess/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/blonde.png",
    "lpc/spritesheets/hair/princess/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/blonde.png.json",
    "lpc/spritesheets/hair/princess/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/blue.png",
    "lpc/spritesheets/hair/princess/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/blue.png.json",
    "lpc/spritesheets/hair/princess/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/dark_brown.png",
    "lpc/spritesheets/hair/princess/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/dark_brown.png.json",
    "lpc/spritesheets/hair/princess/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/gold.png",
    "lpc/spritesheets/hair/princess/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/gold.png.json",
    "lpc/spritesheets/hair/princess/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/gray.png",
    "lpc/spritesheets/hair/princess/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/gray.png.json",
    "lpc/spritesheets/hair/princess/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/green.png",
    "lpc/spritesheets/hair/princess/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/green.png.json",
    "lpc/spritesheets/hair/princess/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/light_brown.png",
    "lpc/spritesheets/hair/princess/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/light_brown.png.json",
    "lpc/spritesheets/hair/princess/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/orange.png",
    "lpc/spritesheets/hair/princess/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/orange.png.json",
    "lpc/spritesheets/hair/princess/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/purple.png",
    "lpc/spritesheets/hair/princess/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/purple.png.json",
    "lpc/spritesheets/hair/princess/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/red.png",
    "lpc/spritesheets/hair/princess/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/red.png.json",
    "lpc/spritesheets/hair/princess/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/white.png",
    "lpc/spritesheets/hair/princess/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/princess/male/white.png.json",
    "lpc/spritesheets/hair/sara/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/black.png",
    "lpc/spritesheets/hair/sara/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/black.png.json",
    "lpc/spritesheets/hair/sara/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/blonde.png",
    "lpc/spritesheets/hair/sara/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/blonde.png.json",
    "lpc/spritesheets/hair/sara/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/blue.png",
    "lpc/spritesheets/hair/sara/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/blue.png.json",
    "lpc/spritesheets/hair/sara/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/dark_brown.png",
    "lpc/spritesheets/hair/sara/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/dark_brown.png.json",
    "lpc/spritesheets/hair/sara/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/gold.png",
    "lpc/spritesheets/hair/sara/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/gold.png.json",
    "lpc/spritesheets/hair/sara/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/gray.png",
    "lpc/spritesheets/hair/sara/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/gray.png.json",
    "lpc/spritesheets/hair/sara/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/green.png",
    "lpc/spritesheets/hair/sara/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/green.png.json",
    "lpc/spritesheets/hair/sara/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/light_brown.png",
    "lpc/spritesheets/hair/sara/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/light_brown.png.json",
    "lpc/spritesheets/hair/sara/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/orange.png",
    "lpc/spritesheets/hair/sara/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/orange.png.json",
    "lpc/spritesheets/hair/sara/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/purple.png",
    "lpc/spritesheets/hair/sara/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/purple.png.json",
    "lpc/spritesheets/hair/sara/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/red.png",
    "lpc/spritesheets/hair/sara/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/red.png.json",
    "lpc/spritesheets/hair/sara/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/white.png",
    "lpc/spritesheets/hair/sara/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/female/white.png.json",
    "lpc/spritesheets/hair/sara/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/black.png",
    "lpc/spritesheets/hair/sara/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/black.png.json",
    "lpc/spritesheets/hair/sara/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/blonde.png",
    "lpc/spritesheets/hair/sara/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/blonde.png.json",
    "lpc/spritesheets/hair/sara/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/blue.png",
    "lpc/spritesheets/hair/sara/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/blue.png.json",
    "lpc/spritesheets/hair/sara/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/dark_brown.png",
    "lpc/spritesheets/hair/sara/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/dark_brown.png.json",
    "lpc/spritesheets/hair/sara/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/gold.png",
    "lpc/spritesheets/hair/sara/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/gold.png.json",
    "lpc/spritesheets/hair/sara/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/gray.png",
    "lpc/spritesheets/hair/sara/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/gray.png.json",
    "lpc/spritesheets/hair/sara/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/green.png",
    "lpc/spritesheets/hair/sara/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/green.png.json",
    "lpc/spritesheets/hair/sara/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/light_brown.png",
    "lpc/spritesheets/hair/sara/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/light_brown.png.json",
    "lpc/spritesheets/hair/sara/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/orange.png",
    "lpc/spritesheets/hair/sara/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/orange.png.json",
    "lpc/spritesheets/hair/sara/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/purple.png",
    "lpc/spritesheets/hair/sara/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/purple.png.json",
    "lpc/spritesheets/hair/sara/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/red.png",
    "lpc/spritesheets/hair/sara/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/red.png.json",
    "lpc/spritesheets/hair/sara/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/white.png",
    "lpc/spritesheets/hair/sara/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/sara/male/white.png.json",
    "lpc/spritesheets/hair/shorthawk/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/black.png",
    "lpc/spritesheets/hair/shorthawk/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/black.png.json",
    "lpc/spritesheets/hair/shorthawk/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/blonde.png",
    "lpc/spritesheets/hair/shorthawk/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/blonde.png.json",
    "lpc/spritesheets/hair/shorthawk/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/blue.png",
    "lpc/spritesheets/hair/shorthawk/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/blue.png.json",
    "lpc/spritesheets/hair/shorthawk/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/dark_brown.png",
    "lpc/spritesheets/hair/shorthawk/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/dark_brown.png.json",
    "lpc/spritesheets/hair/shorthawk/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/gold.png",
    "lpc/spritesheets/hair/shorthawk/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/gold.png.json",
    "lpc/spritesheets/hair/shorthawk/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/gray.png",
    "lpc/spritesheets/hair/shorthawk/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/gray.png.json",
    "lpc/spritesheets/hair/shorthawk/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/green.png",
    "lpc/spritesheets/hair/shorthawk/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/green.png.json",
    "lpc/spritesheets/hair/shorthawk/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/light_brown.png",
    "lpc/spritesheets/hair/shorthawk/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/light_brown.png.json",
    "lpc/spritesheets/hair/shorthawk/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/orange.png",
    "lpc/spritesheets/hair/shorthawk/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/orange.png.json",
    "lpc/spritesheets/hair/shorthawk/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/purple.png",
    "lpc/spritesheets/hair/shorthawk/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/purple.png.json",
    "lpc/spritesheets/hair/shorthawk/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/red.png",
    "lpc/spritesheets/hair/shorthawk/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/red.png.json",
    "lpc/spritesheets/hair/shorthawk/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/white.png",
    "lpc/spritesheets/hair/shorthawk/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/female/white.png.json",
    "lpc/spritesheets/hair/shorthawk/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/black.png",
    "lpc/spritesheets/hair/shorthawk/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/black.png.json",
    "lpc/spritesheets/hair/shorthawk/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/blonde.png",
    "lpc/spritesheets/hair/shorthawk/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/blonde.png.json",
    "lpc/spritesheets/hair/shorthawk/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/blue.png",
    "lpc/spritesheets/hair/shorthawk/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/blue.png.json",
    "lpc/spritesheets/hair/shorthawk/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/dark_brown.png",
    "lpc/spritesheets/hair/shorthawk/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/dark_brown.png.json",
    "lpc/spritesheets/hair/shorthawk/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/gold.png",
    "lpc/spritesheets/hair/shorthawk/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/gold.png.json",
    "lpc/spritesheets/hair/shorthawk/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/gray.png",
    "lpc/spritesheets/hair/shorthawk/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/gray.png.json",
    "lpc/spritesheets/hair/shorthawk/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/green.png",
    "lpc/spritesheets/hair/shorthawk/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/green.png.json",
    "lpc/spritesheets/hair/shorthawk/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/light_brown.png",
    "lpc/spritesheets/hair/shorthawk/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/light_brown.png.json",
    "lpc/spritesheets/hair/shorthawk/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/orange.png",
    "lpc/spritesheets/hair/shorthawk/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/orange.png.json",
    "lpc/spritesheets/hair/shorthawk/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/purple.png",
    "lpc/spritesheets/hair/shorthawk/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/purple.png.json",
    "lpc/spritesheets/hair/shorthawk/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/red.png",
    "lpc/spritesheets/hair/shorthawk/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/red.png.json",
    "lpc/spritesheets/hair/shorthawk/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/white.png",
    "lpc/spritesheets/hair/shorthawk/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shorthawk/male/white.png.json",
    "lpc/spritesheets/hair/shortknot/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/black.png",
    "lpc/spritesheets/hair/shortknot/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/black.png.json",
    "lpc/spritesheets/hair/shortknot/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/blonde.png",
    "lpc/spritesheets/hair/shortknot/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/blonde.png.json",
    "lpc/spritesheets/hair/shortknot/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/blue.png",
    "lpc/spritesheets/hair/shortknot/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/blue.png.json",
    "lpc/spritesheets/hair/shortknot/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/dark_brown.png",
    "lpc/spritesheets/hair/shortknot/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/dark_brown.png.json",
    "lpc/spritesheets/hair/shortknot/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/gold.png",
    "lpc/spritesheets/hair/shortknot/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/gold.png.json",
    "lpc/spritesheets/hair/shortknot/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/gray.png",
    "lpc/spritesheets/hair/shortknot/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/gray.png.json",
    "lpc/spritesheets/hair/shortknot/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/green.png",
    "lpc/spritesheets/hair/shortknot/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/green.png.json",
    "lpc/spritesheets/hair/shortknot/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/light_brown.png",
    "lpc/spritesheets/hair/shortknot/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/light_brown.png.json",
    "lpc/spritesheets/hair/shortknot/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/orange.png",
    "lpc/spritesheets/hair/shortknot/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/orange.png.json",
    "lpc/spritesheets/hair/shortknot/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/purple.png",
    "lpc/spritesheets/hair/shortknot/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/purple.png.json",
    "lpc/spritesheets/hair/shortknot/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/red.png",
    "lpc/spritesheets/hair/shortknot/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/red.png.json",
    "lpc/spritesheets/hair/shortknot/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/white.png",
    "lpc/spritesheets/hair/shortknot/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/female/white.png.json",
    "lpc/spritesheets/hair/shortknot/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/black.png",
    "lpc/spritesheets/hair/shortknot/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/black.png.json",
    "lpc/spritesheets/hair/shortknot/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/blonde.png",
    "lpc/spritesheets/hair/shortknot/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/blonde.png.json",
    "lpc/spritesheets/hair/shortknot/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/blue.png",
    "lpc/spritesheets/hair/shortknot/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/blue.png.json",
    "lpc/spritesheets/hair/shortknot/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/dark_brown.png",
    "lpc/spritesheets/hair/shortknot/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/dark_brown.png.json",
    "lpc/spritesheets/hair/shortknot/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/gold.png",
    "lpc/spritesheets/hair/shortknot/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/gold.png.json",
    "lpc/spritesheets/hair/shortknot/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/gray.png",
    "lpc/spritesheets/hair/shortknot/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/gray.png.json",
    "lpc/spritesheets/hair/shortknot/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/green.png",
    "lpc/spritesheets/hair/shortknot/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/green.png.json",
    "lpc/spritesheets/hair/shortknot/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/light_brown.png",
    "lpc/spritesheets/hair/shortknot/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/light_brown.png.json",
    "lpc/spritesheets/hair/shortknot/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/orange.png",
    "lpc/spritesheets/hair/shortknot/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/orange.png.json",
    "lpc/spritesheets/hair/shortknot/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/purple.png",
    "lpc/spritesheets/hair/shortknot/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/purple.png.json",
    "lpc/spritesheets/hair/shortknot/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/red.png",
    "lpc/spritesheets/hair/shortknot/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/red.png.json",
    "lpc/spritesheets/hair/shortknot/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/white.png",
    "lpc/spritesheets/hair/shortknot/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shortknot/male/white.png.json",
    "lpc/spritesheets/hair/shoulderl/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/black.png",
    "lpc/spritesheets/hair/shoulderl/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/black.png.json",
    "lpc/spritesheets/hair/shoulderl/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/blonde.png",
    "lpc/spritesheets/hair/shoulderl/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/blonde.png.json",
    "lpc/spritesheets/hair/shoulderl/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/blue.png",
    "lpc/spritesheets/hair/shoulderl/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/blue.png.json",
    "lpc/spritesheets/hair/shoulderl/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/dark_brown.png",
    "lpc/spritesheets/hair/shoulderl/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/dark_brown.png.json",
    "lpc/spritesheets/hair/shoulderl/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/gold.png",
    "lpc/spritesheets/hair/shoulderl/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/gold.png.json",
    "lpc/spritesheets/hair/shoulderl/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/gray.png",
    "lpc/spritesheets/hair/shoulderl/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/gray.png.json",
    "lpc/spritesheets/hair/shoulderl/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/green.png",
    "lpc/spritesheets/hair/shoulderl/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/green.png.json",
    "lpc/spritesheets/hair/shoulderl/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/light_brown.png",
    "lpc/spritesheets/hair/shoulderl/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/light_brown.png.json",
    "lpc/spritesheets/hair/shoulderl/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/orange.png",
    "lpc/spritesheets/hair/shoulderl/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/orange.png.json",
    "lpc/spritesheets/hair/shoulderl/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/purple.png",
    "lpc/spritesheets/hair/shoulderl/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/purple.png.json",
    "lpc/spritesheets/hair/shoulderl/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/red.png",
    "lpc/spritesheets/hair/shoulderl/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/red.png.json",
    "lpc/spritesheets/hair/shoulderl/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/white.png",
    "lpc/spritesheets/hair/shoulderl/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/female/white.png.json",
    "lpc/spritesheets/hair/shoulderl/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/black.png",
    "lpc/spritesheets/hair/shoulderl/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/black.png.json",
    "lpc/spritesheets/hair/shoulderl/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/blonde.png",
    "lpc/spritesheets/hair/shoulderl/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/blonde.png.json",
    "lpc/spritesheets/hair/shoulderl/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/blue.png",
    "lpc/spritesheets/hair/shoulderl/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/blue.png.json",
    "lpc/spritesheets/hair/shoulderl/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/dark_brown.png",
    "lpc/spritesheets/hair/shoulderl/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/dark_brown.png.json",
    "lpc/spritesheets/hair/shoulderl/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/gold.png",
    "lpc/spritesheets/hair/shoulderl/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/gold.png.json",
    "lpc/spritesheets/hair/shoulderl/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/gray.png",
    "lpc/spritesheets/hair/shoulderl/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/gray.png.json",
    "lpc/spritesheets/hair/shoulderl/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/green.png",
    "lpc/spritesheets/hair/shoulderl/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/green.png.json",
    "lpc/spritesheets/hair/shoulderl/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/light_brown.png",
    "lpc/spritesheets/hair/shoulderl/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/light_brown.png.json",
    "lpc/spritesheets/hair/shoulderl/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/orange.png",
    "lpc/spritesheets/hair/shoulderl/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/orange.png.json",
    "lpc/spritesheets/hair/shoulderl/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/purple.png",
    "lpc/spritesheets/hair/shoulderl/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/purple.png.json",
    "lpc/spritesheets/hair/shoulderl/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/red.png",
    "lpc/spritesheets/hair/shoulderl/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/red.png.json",
    "lpc/spritesheets/hair/shoulderl/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/white.png",
    "lpc/spritesheets/hair/shoulderl/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderl/male/white.png.json",
    "lpc/spritesheets/hair/shoulderr/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/black.png",
    "lpc/spritesheets/hair/shoulderr/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/black.png.json",
    "lpc/spritesheets/hair/shoulderr/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/blonde.png",
    "lpc/spritesheets/hair/shoulderr/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/blonde.png.json",
    "lpc/spritesheets/hair/shoulderr/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/blue.png",
    "lpc/spritesheets/hair/shoulderr/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/blue.png.json",
    "lpc/spritesheets/hair/shoulderr/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/dark_brown.png",
    "lpc/spritesheets/hair/shoulderr/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/dark_brown.png.json",
    "lpc/spritesheets/hair/shoulderr/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/gold.png",
    "lpc/spritesheets/hair/shoulderr/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/gold.png.json",
    "lpc/spritesheets/hair/shoulderr/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/gray.png",
    "lpc/spritesheets/hair/shoulderr/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/gray.png.json",
    "lpc/spritesheets/hair/shoulderr/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/green.png",
    "lpc/spritesheets/hair/shoulderr/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/green.png.json",
    "lpc/spritesheets/hair/shoulderr/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/light_brown.png",
    "lpc/spritesheets/hair/shoulderr/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/light_brown.png.json",
    "lpc/spritesheets/hair/shoulderr/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/orange.png",
    "lpc/spritesheets/hair/shoulderr/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/orange.png.json",
    "lpc/spritesheets/hair/shoulderr/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/purple.png",
    "lpc/spritesheets/hair/shoulderr/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/purple.png.json",
    "lpc/spritesheets/hair/shoulderr/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/red.png",
    "lpc/spritesheets/hair/shoulderr/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/red.png.json",
    "lpc/spritesheets/hair/shoulderr/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/white.png",
    "lpc/spritesheets/hair/shoulderr/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/female/white.png.json",
    "lpc/spritesheets/hair/shoulderr/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/black.png",
    "lpc/spritesheets/hair/shoulderr/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/black.png.json",
    "lpc/spritesheets/hair/shoulderr/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/blonde.png",
    "lpc/spritesheets/hair/shoulderr/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/blonde.png.json",
    "lpc/spritesheets/hair/shoulderr/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/blue.png",
    "lpc/spritesheets/hair/shoulderr/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/blue.png.json",
    "lpc/spritesheets/hair/shoulderr/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/dark_brown.png",
    "lpc/spritesheets/hair/shoulderr/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/dark_brown.png.json",
    "lpc/spritesheets/hair/shoulderr/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/gold.png",
    "lpc/spritesheets/hair/shoulderr/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/gold.png.json",
    "lpc/spritesheets/hair/shoulderr/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/gray.png",
    "lpc/spritesheets/hair/shoulderr/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/gray.png.json",
    "lpc/spritesheets/hair/shoulderr/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/green.png",
    "lpc/spritesheets/hair/shoulderr/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/green.png.json",
    "lpc/spritesheets/hair/shoulderr/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/light_brown.png",
    "lpc/spritesheets/hair/shoulderr/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/light_brown.png.json",
    "lpc/spritesheets/hair/shoulderr/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/orange.png",
    "lpc/spritesheets/hair/shoulderr/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/orange.png.json",
    "lpc/spritesheets/hair/shoulderr/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/purple.png",
    "lpc/spritesheets/hair/shoulderr/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/purple.png.json",
    "lpc/spritesheets/hair/shoulderr/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/red.png",
    "lpc/spritesheets/hair/shoulderr/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/red.png.json",
    "lpc/spritesheets/hair/shoulderr/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/white.png",
    "lpc/spritesheets/hair/shoulderr/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/shoulderr/male/white.png.json",
    "lpc/spritesheets/hair/single/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/black.png",
    "lpc/spritesheets/hair/single/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/black.png.json",
    "lpc/spritesheets/hair/single/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/blonde.png",
    "lpc/spritesheets/hair/single/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/blonde.png.json",
    "lpc/spritesheets/hair/single/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/blue.png",
    "lpc/spritesheets/hair/single/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/blue.png.json",
    "lpc/spritesheets/hair/single/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/dark_brown.png",
    "lpc/spritesheets/hair/single/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/dark_brown.png.json",
    "lpc/spritesheets/hair/single/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/gold.png",
    "lpc/spritesheets/hair/single/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/gold.png.json",
    "lpc/spritesheets/hair/single/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/gray.png",
    "lpc/spritesheets/hair/single/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/gray.png.json",
    "lpc/spritesheets/hair/single/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/green.png",
    "lpc/spritesheets/hair/single/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/green.png.json",
    "lpc/spritesheets/hair/single/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/light_brown.png",
    "lpc/spritesheets/hair/single/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/light_brown.png.json",
    "lpc/spritesheets/hair/single/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/orange.png",
    "lpc/spritesheets/hair/single/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/orange.png.json",
    "lpc/spritesheets/hair/single/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/purple.png",
    "lpc/spritesheets/hair/single/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/purple.png.json",
    "lpc/spritesheets/hair/single/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/red.png",
    "lpc/spritesheets/hair/single/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/red.png.json",
    "lpc/spritesheets/hair/single/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/white.png",
    "lpc/spritesheets/hair/single/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/female/white.png.json",
    "lpc/spritesheets/hair/single/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/black.png",
    "lpc/spritesheets/hair/single/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/black.png.json",
    "lpc/spritesheets/hair/single/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/blonde.png",
    "lpc/spritesheets/hair/single/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/blonde.png.json",
    "lpc/spritesheets/hair/single/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/blue.png",
    "lpc/spritesheets/hair/single/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/blue.png.json",
    "lpc/spritesheets/hair/single/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/dark_brown.png",
    "lpc/spritesheets/hair/single/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/dark_brown.png.json",
    "lpc/spritesheets/hair/single/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/gold.png",
    "lpc/spritesheets/hair/single/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/gold.png.json",
    "lpc/spritesheets/hair/single/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/gray.png",
    "lpc/spritesheets/hair/single/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/gray.png.json",
    "lpc/spritesheets/hair/single/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/green.png",
    "lpc/spritesheets/hair/single/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/green.png.json",
    "lpc/spritesheets/hair/single/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/light_brown.png",
    "lpc/spritesheets/hair/single/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/light_brown.png.json",
    "lpc/spritesheets/hair/single/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/orange.png",
    "lpc/spritesheets/hair/single/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/orange.png.json",
    "lpc/spritesheets/hair/single/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/purple.png",
    "lpc/spritesheets/hair/single/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/purple.png.json",
    "lpc/spritesheets/hair/single/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/red.png",
    "lpc/spritesheets/hair/single/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/red.png.json",
    "lpc/spritesheets/hair/single/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/white.png",
    "lpc/spritesheets/hair/single/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/single/male/white.png.json",
    "lpc/spritesheets/hair/spiked/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/black.png",
    "lpc/spritesheets/hair/spiked/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/black.png.json",
    "lpc/spritesheets/hair/spiked/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/blonde.png",
    "lpc/spritesheets/hair/spiked/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/blonde.png.json",
    "lpc/spritesheets/hair/spiked/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/blue.png",
    "lpc/spritesheets/hair/spiked/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/blue.png.json",
    "lpc/spritesheets/hair/spiked/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/dark_brown.png",
    "lpc/spritesheets/hair/spiked/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/gold.png",
    "lpc/spritesheets/hair/spiked/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/gold.png.json",
    "lpc/spritesheets/hair/spiked/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/gray.png",
    "lpc/spritesheets/hair/spiked/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/gray.png.json",
    "lpc/spritesheets/hair/spiked/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/green.png",
    "lpc/spritesheets/hair/spiked/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/green.png.json",
    "lpc/spritesheets/hair/spiked/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/light_brown.png",
    "lpc/spritesheets/hair/spiked/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/light_brown.png.json",
    "lpc/spritesheets/hair/spiked/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/orange.png",
    "lpc/spritesheets/hair/spiked/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/orange.png.json",
    "lpc/spritesheets/hair/spiked/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/purple.png",
    "lpc/spritesheets/hair/spiked/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/purple.png.json",
    "lpc/spritesheets/hair/spiked/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/red.png",
    "lpc/spritesheets/hair/spiked/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/red.png.json",
    "lpc/spritesheets/hair/spiked/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/white.png",
    "lpc/spritesheets/hair/spiked/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/female/white.png.json",
    "lpc/spritesheets/hair/spiked/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/black.png",
    "lpc/spritesheets/hair/spiked/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/black.png.json",
    "lpc/spritesheets/hair/spiked/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/blonde.png",
    "lpc/spritesheets/hair/spiked/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/blonde.png.json",
    "lpc/spritesheets/hair/spiked/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/blue.png",
    "lpc/spritesheets/hair/spiked/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/blue.png.json",
    "lpc/spritesheets/hair/spiked/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/dark_brown.png",
    "lpc/spritesheets/hair/spiked/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/gold.png",
    "lpc/spritesheets/hair/spiked/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/gold.png.json",
    "lpc/spritesheets/hair/spiked/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/gray.png",
    "lpc/spritesheets/hair/spiked/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/gray.png.json",
    "lpc/spritesheets/hair/spiked/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/green.png",
    "lpc/spritesheets/hair/spiked/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/green.png.json",
    "lpc/spritesheets/hair/spiked/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/light_brown.png",
    "lpc/spritesheets/hair/spiked/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/light_brown.png.json",
    "lpc/spritesheets/hair/spiked/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/orange.png",
    "lpc/spritesheets/hair/spiked/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/orange.png.json",
    "lpc/spritesheets/hair/spiked/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/purple.png",
    "lpc/spritesheets/hair/spiked/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/purple.png.json",
    "lpc/spritesheets/hair/spiked/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/red.png",
    "lpc/spritesheets/hair/spiked/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/red.png.json",
    "lpc/spritesheets/hair/spiked/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/white.png",
    "lpc/spritesheets/hair/spiked/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked/male/white.png.json",
    "lpc/spritesheets/hair/spiked2/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/black.png",
    "lpc/spritesheets/hair/spiked2/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/black.png.json",
    "lpc/spritesheets/hair/spiked2/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/blonde.png",
    "lpc/spritesheets/hair/spiked2/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/blonde.png.json",
    "lpc/spritesheets/hair/spiked2/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/blue.png",
    "lpc/spritesheets/hair/spiked2/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/blue.png.json",
    "lpc/spritesheets/hair/spiked2/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/dark_brown.png",
    "lpc/spritesheets/hair/spiked2/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked2/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/gold.png",
    "lpc/spritesheets/hair/spiked2/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/gold.png.json",
    "lpc/spritesheets/hair/spiked2/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/gray.png",
    "lpc/spritesheets/hair/spiked2/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/gray.png.json",
    "lpc/spritesheets/hair/spiked2/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/green.png",
    "lpc/spritesheets/hair/spiked2/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/green.png.json",
    "lpc/spritesheets/hair/spiked2/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/light_brown.png",
    "lpc/spritesheets/hair/spiked2/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/light_brown.png.json",
    "lpc/spritesheets/hair/spiked2/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/orange.png",
    "lpc/spritesheets/hair/spiked2/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/orange.png.json",
    "lpc/spritesheets/hair/spiked2/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/purple.png",
    "lpc/spritesheets/hair/spiked2/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/purple.png.json",
    "lpc/spritesheets/hair/spiked2/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/red.png",
    "lpc/spritesheets/hair/spiked2/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/red.png.json",
    "lpc/spritesheets/hair/spiked2/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/white.png",
    "lpc/spritesheets/hair/spiked2/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/female/white.png.json",
    "lpc/spritesheets/hair/spiked2/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/black.png",
    "lpc/spritesheets/hair/spiked2/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/black.png.json",
    "lpc/spritesheets/hair/spiked2/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/blonde.png",
    "lpc/spritesheets/hair/spiked2/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/blonde.png.json",
    "lpc/spritesheets/hair/spiked2/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/blue.png",
    "lpc/spritesheets/hair/spiked2/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/blue.png.json",
    "lpc/spritesheets/hair/spiked2/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/dark_brown.png",
    "lpc/spritesheets/hair/spiked2/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked2/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/gold.png",
    "lpc/spritesheets/hair/spiked2/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/gold.png.json",
    "lpc/spritesheets/hair/spiked2/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/gray.png",
    "lpc/spritesheets/hair/spiked2/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/gray.png.json",
    "lpc/spritesheets/hair/spiked2/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/green.png",
    "lpc/spritesheets/hair/spiked2/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/green.png.json",
    "lpc/spritesheets/hair/spiked2/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/light_brown.png",
    "lpc/spritesheets/hair/spiked2/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/light_brown.png.json",
    "lpc/spritesheets/hair/spiked2/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/orange.png",
    "lpc/spritesheets/hair/spiked2/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/orange.png.json",
    "lpc/spritesheets/hair/spiked2/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/purple.png",
    "lpc/spritesheets/hair/spiked2/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/purple.png.json",
    "lpc/spritesheets/hair/spiked2/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/red.png",
    "lpc/spritesheets/hair/spiked2/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/red.png.json",
    "lpc/spritesheets/hair/spiked2/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/white.png",
    "lpc/spritesheets/hair/spiked2/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked2/male/white.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/black.png",
    "lpc/spritesheets/hair/spiked_beehive/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/black.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/blonde.png",
    "lpc/spritesheets/hair/spiked_beehive/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/blonde.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/blue.png",
    "lpc/spritesheets/hair/spiked_beehive/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/blue.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/dark_brown.png",
    "lpc/spritesheets/hair/spiked_beehive/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/gold.png",
    "lpc/spritesheets/hair/spiked_beehive/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/gold.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/gray.png",
    "lpc/spritesheets/hair/spiked_beehive/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/gray.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/green.png",
    "lpc/spritesheets/hair/spiked_beehive/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/green.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/light_brown.png",
    "lpc/spritesheets/hair/spiked_beehive/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/light_brown.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/orange.png",
    "lpc/spritesheets/hair/spiked_beehive/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/orange.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/purple.png",
    "lpc/spritesheets/hair/spiked_beehive/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/purple.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/red.png",
    "lpc/spritesheets/hair/spiked_beehive/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/red.png.json",
    "lpc/spritesheets/hair/spiked_beehive/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/white.png",
    "lpc/spritesheets/hair/spiked_beehive/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/female/white.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/black.png",
    "lpc/spritesheets/hair/spiked_beehive/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/black.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/blonde.png",
    "lpc/spritesheets/hair/spiked_beehive/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/blonde.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/blue.png",
    "lpc/spritesheets/hair/spiked_beehive/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/blue.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/dark_brown.png",
    "lpc/spritesheets/hair/spiked_beehive/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/gold.png",
    "lpc/spritesheets/hair/spiked_beehive/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/gold.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/gray.png",
    "lpc/spritesheets/hair/spiked_beehive/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/gray.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/green.png",
    "lpc/spritesheets/hair/spiked_beehive/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/green.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/light_brown.png",
    "lpc/spritesheets/hair/spiked_beehive/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/light_brown.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/orange.png",
    "lpc/spritesheets/hair/spiked_beehive/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/orange.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/purple.png",
    "lpc/spritesheets/hair/spiked_beehive/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/purple.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/red.png",
    "lpc/spritesheets/hair/spiked_beehive/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/red.png.json",
    "lpc/spritesheets/hair/spiked_beehive/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/white.png",
    "lpc/spritesheets/hair/spiked_beehive/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_beehive/male/white.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/black.png",
    "lpc/spritesheets/hair/spiked_liberty/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/black.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/blonde.png",
    "lpc/spritesheets/hair/spiked_liberty/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/blonde.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/blue.png",
    "lpc/spritesheets/hair/spiked_liberty/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/blue.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/dark_brown.png",
    "lpc/spritesheets/hair/spiked_liberty/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/gold.png",
    "lpc/spritesheets/hair/spiked_liberty/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/gold.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/gray.png",
    "lpc/spritesheets/hair/spiked_liberty/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/gray.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/green.png",
    "lpc/spritesheets/hair/spiked_liberty/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/green.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/light_brown.png",
    "lpc/spritesheets/hair/spiked_liberty/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/light_brown.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/orange.png",
    "lpc/spritesheets/hair/spiked_liberty/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/orange.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/purple.png",
    "lpc/spritesheets/hair/spiked_liberty/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/purple.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/red.png",
    "lpc/spritesheets/hair/spiked_liberty/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/red.png.json",
    "lpc/spritesheets/hair/spiked_liberty/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/white.png",
    "lpc/spritesheets/hair/spiked_liberty/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/female/white.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/black.png",
    "lpc/spritesheets/hair/spiked_liberty/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/black.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/blonde.png",
    "lpc/spritesheets/hair/spiked_liberty/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/blonde.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/blue.png",
    "lpc/spritesheets/hair/spiked_liberty/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/blue.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/dark_brown.png",
    "lpc/spritesheets/hair/spiked_liberty/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/gold.png",
    "lpc/spritesheets/hair/spiked_liberty/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/gold.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/gray.png",
    "lpc/spritesheets/hair/spiked_liberty/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/gray.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/green.png",
    "lpc/spritesheets/hair/spiked_liberty/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/green.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/light_brown.png",
    "lpc/spritesheets/hair/spiked_liberty/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/light_brown.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/orange.png",
    "lpc/spritesheets/hair/spiked_liberty/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/orange.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/purple.png",
    "lpc/spritesheets/hair/spiked_liberty/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/purple.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/red.png",
    "lpc/spritesheets/hair/spiked_liberty/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/red.png.json",
    "lpc/spritesheets/hair/spiked_liberty/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/white.png",
    "lpc/spritesheets/hair/spiked_liberty/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty/male/white.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/black.png",
    "lpc/spritesheets/hair/spiked_liberty2/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/black.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/blonde.png",
    "lpc/spritesheets/hair/spiked_liberty2/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/blonde.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/blue.png",
    "lpc/spritesheets/hair/spiked_liberty2/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/blue.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/dark_brown.png",
    "lpc/spritesheets/hair/spiked_liberty2/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/gold.png",
    "lpc/spritesheets/hair/spiked_liberty2/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/gold.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/gray.png",
    "lpc/spritesheets/hair/spiked_liberty2/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/gray.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/green.png",
    "lpc/spritesheets/hair/spiked_liberty2/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/green.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/light_brown.png",
    "lpc/spritesheets/hair/spiked_liberty2/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/light_brown.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/orange.png",
    "lpc/spritesheets/hair/spiked_liberty2/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/orange.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/purple.png",
    "lpc/spritesheets/hair/spiked_liberty2/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/purple.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/red.png",
    "lpc/spritesheets/hair/spiked_liberty2/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/red.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/white.png",
    "lpc/spritesheets/hair/spiked_liberty2/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/female/white.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/black.png",
    "lpc/spritesheets/hair/spiked_liberty2/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/black.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/blonde.png",
    "lpc/spritesheets/hair/spiked_liberty2/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/blonde.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/blue.png",
    "lpc/spritesheets/hair/spiked_liberty2/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/blue.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/dark_brown.png",
    "lpc/spritesheets/hair/spiked_liberty2/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/gold.png",
    "lpc/spritesheets/hair/spiked_liberty2/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/gold.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/gray.png",
    "lpc/spritesheets/hair/spiked_liberty2/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/gray.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/green.png",
    "lpc/spritesheets/hair/spiked_liberty2/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/green.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/light_brown.png",
    "lpc/spritesheets/hair/spiked_liberty2/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/light_brown.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/orange.png",
    "lpc/spritesheets/hair/spiked_liberty2/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/orange.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/purple.png",
    "lpc/spritesheets/hair/spiked_liberty2/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/purple.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/red.png",
    "lpc/spritesheets/hair/spiked_liberty2/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/red.png.json",
    "lpc/spritesheets/hair/spiked_liberty2/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/white.png",
    "lpc/spritesheets/hair/spiked_liberty2/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_liberty2/male/white.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/black.png",
    "lpc/spritesheets/hair/spiked_porcupine/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/black.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/blonde.png",
    "lpc/spritesheets/hair/spiked_porcupine/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/blonde.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/blue.png",
    "lpc/spritesheets/hair/spiked_porcupine/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/blue.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/dark_brown.png",
    "lpc/spritesheets/hair/spiked_porcupine/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/gold.png",
    "lpc/spritesheets/hair/spiked_porcupine/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/gold.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/gray.png",
    "lpc/spritesheets/hair/spiked_porcupine/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/gray.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/green.png",
    "lpc/spritesheets/hair/spiked_porcupine/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/green.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/light_brown.png",
    "lpc/spritesheets/hair/spiked_porcupine/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/light_brown.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/orange.png",
    "lpc/spritesheets/hair/spiked_porcupine/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/orange.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/purple.png",
    "lpc/spritesheets/hair/spiked_porcupine/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/purple.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/red.png",
    "lpc/spritesheets/hair/spiked_porcupine/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/red.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/white.png",
    "lpc/spritesheets/hair/spiked_porcupine/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/female/white.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/black.png",
    "lpc/spritesheets/hair/spiked_porcupine/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/black.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/blonde.png",
    "lpc/spritesheets/hair/spiked_porcupine/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/blonde.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/blue.png",
    "lpc/spritesheets/hair/spiked_porcupine/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/blue.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/dark_brown.png",
    "lpc/spritesheets/hair/spiked_porcupine/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/dark_brown.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/gold.png",
    "lpc/spritesheets/hair/spiked_porcupine/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/gold.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/gray.png",
    "lpc/spritesheets/hair/spiked_porcupine/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/gray.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/green.png",
    "lpc/spritesheets/hair/spiked_porcupine/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/green.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/light_brown.png",
    "lpc/spritesheets/hair/spiked_porcupine/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/light_brown.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/orange.png",
    "lpc/spritesheets/hair/spiked_porcupine/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/orange.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/purple.png",
    "lpc/spritesheets/hair/spiked_porcupine/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/purple.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/red.png",
    "lpc/spritesheets/hair/spiked_porcupine/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/red.png.json",
    "lpc/spritesheets/hair/spiked_porcupine/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/white.png",
    "lpc/spritesheets/hair/spiked_porcupine/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/spiked_porcupine/male/white.png.json",
    "lpc/spritesheets/hair/swoop/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/black.png",
    "lpc/spritesheets/hair/swoop/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/black.png.json",
    "lpc/spritesheets/hair/swoop/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/blonde.png",
    "lpc/spritesheets/hair/swoop/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/blonde.png.json",
    "lpc/spritesheets/hair/swoop/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/blue.png",
    "lpc/spritesheets/hair/swoop/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/blue.png.json",
    "lpc/spritesheets/hair/swoop/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/dark_brown.png",
    "lpc/spritesheets/hair/swoop/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/dark_brown.png.json",
    "lpc/spritesheets/hair/swoop/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/gold.png",
    "lpc/spritesheets/hair/swoop/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/gold.png.json",
    "lpc/spritesheets/hair/swoop/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/gray.png",
    "lpc/spritesheets/hair/swoop/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/gray.png.json",
    "lpc/spritesheets/hair/swoop/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/green.png",
    "lpc/spritesheets/hair/swoop/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/green.png.json",
    "lpc/spritesheets/hair/swoop/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/light_brown.png",
    "lpc/spritesheets/hair/swoop/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/light_brown.png.json",
    "lpc/spritesheets/hair/swoop/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/orange.png",
    "lpc/spritesheets/hair/swoop/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/orange.png.json",
    "lpc/spritesheets/hair/swoop/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/purple.png",
    "lpc/spritesheets/hair/swoop/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/purple.png.json",
    "lpc/spritesheets/hair/swoop/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/red.png",
    "lpc/spritesheets/hair/swoop/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/red.png.json",
    "lpc/spritesheets/hair/swoop/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/white.png",
    "lpc/spritesheets/hair/swoop/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/female/white.png.json",
    "lpc/spritesheets/hair/swoop/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/black.png",
    "lpc/spritesheets/hair/swoop/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/black.png.json",
    "lpc/spritesheets/hair/swoop/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/blonde.png",
    "lpc/spritesheets/hair/swoop/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/blonde.png.json",
    "lpc/spritesheets/hair/swoop/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/blue.png",
    "lpc/spritesheets/hair/swoop/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/blue.png.json",
    "lpc/spritesheets/hair/swoop/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/dark_brown.png",
    "lpc/spritesheets/hair/swoop/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/dark_brown.png.json",
    "lpc/spritesheets/hair/swoop/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/gold.png",
    "lpc/spritesheets/hair/swoop/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/gold.png.json",
    "lpc/spritesheets/hair/swoop/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/gray.png",
    "lpc/spritesheets/hair/swoop/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/gray.png.json",
    "lpc/spritesheets/hair/swoop/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/green.png",
    "lpc/spritesheets/hair/swoop/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/green.png.json",
    "lpc/spritesheets/hair/swoop/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/light_brown.png",
    "lpc/spritesheets/hair/swoop/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/light_brown.png.json",
    "lpc/spritesheets/hair/swoop/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/orange.png",
    "lpc/spritesheets/hair/swoop/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/orange.png.json",
    "lpc/spritesheets/hair/swoop/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/purple.png",
    "lpc/spritesheets/hair/swoop/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/purple.png.json",
    "lpc/spritesheets/hair/swoop/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/red.png",
    "lpc/spritesheets/hair/swoop/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/red.png.json",
    "lpc/spritesheets/hair/swoop/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/white.png",
    "lpc/spritesheets/hair/swoop/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/swoop/male/white.png.json",
    "lpc/spritesheets/hair/twists_fade/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/black.png",
    "lpc/spritesheets/hair/twists_fade/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/black.png.json",
    "lpc/spritesheets/hair/twists_fade/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/blonde.png",
    "lpc/spritesheets/hair/twists_fade/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/blonde.png.json",
    "lpc/spritesheets/hair/twists_fade/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/blue.png",
    "lpc/spritesheets/hair/twists_fade/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/blue.png.json",
    "lpc/spritesheets/hair/twists_fade/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/dark_brown.png",
    "lpc/spritesheets/hair/twists_fade/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/dark_brown.png.json",
    "lpc/spritesheets/hair/twists_fade/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/gold.png",
    "lpc/spritesheets/hair/twists_fade/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/gold.png.json",
    "lpc/spritesheets/hair/twists_fade/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/gray.png",
    "lpc/spritesheets/hair/twists_fade/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/gray.png.json",
    "lpc/spritesheets/hair/twists_fade/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/green.png",
    "lpc/spritesheets/hair/twists_fade/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/green.png.json",
    "lpc/spritesheets/hair/twists_fade/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/light_brown.png",
    "lpc/spritesheets/hair/twists_fade/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/light_brown.png.json",
    "lpc/spritesheets/hair/twists_fade/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/orange.png",
    "lpc/spritesheets/hair/twists_fade/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/orange.png.json",
    "lpc/spritesheets/hair/twists_fade/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/purple.png",
    "lpc/spritesheets/hair/twists_fade/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/purple.png.json",
    "lpc/spritesheets/hair/twists_fade/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/red.png",
    "lpc/spritesheets/hair/twists_fade/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/red.png.json",
    "lpc/spritesheets/hair/twists_fade/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/white.png",
    "lpc/spritesheets/hair/twists_fade/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/female/white.png.json",
    "lpc/spritesheets/hair/twists_fade/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/black.png",
    "lpc/spritesheets/hair/twists_fade/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/black.png.json",
    "lpc/spritesheets/hair/twists_fade/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/blonde.png",
    "lpc/spritesheets/hair/twists_fade/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/blonde.png.json",
    "lpc/spritesheets/hair/twists_fade/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/blue.png",
    "lpc/spritesheets/hair/twists_fade/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/blue.png.json",
    "lpc/spritesheets/hair/twists_fade/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/dark_brown.png",
    "lpc/spritesheets/hair/twists_fade/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/dark_brown.png.json",
    "lpc/spritesheets/hair/twists_fade/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/gold.png",
    "lpc/spritesheets/hair/twists_fade/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/gold.png.json",
    "lpc/spritesheets/hair/twists_fade/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/gray.png",
    "lpc/spritesheets/hair/twists_fade/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/gray.png.json",
    "lpc/spritesheets/hair/twists_fade/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/green.png",
    "lpc/spritesheets/hair/twists_fade/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/green.png.json",
    "lpc/spritesheets/hair/twists_fade/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/light_brown.png",
    "lpc/spritesheets/hair/twists_fade/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/light_brown.png.json",
    "lpc/spritesheets/hair/twists_fade/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/orange.png",
    "lpc/spritesheets/hair/twists_fade/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/orange.png.json",
    "lpc/spritesheets/hair/twists_fade/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/purple.png",
    "lpc/spritesheets/hair/twists_fade/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/purple.png.json",
    "lpc/spritesheets/hair/twists_fade/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/red.png",
    "lpc/spritesheets/hair/twists_fade/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/red.png.json",
    "lpc/spritesheets/hair/twists_fade/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/white.png",
    "lpc/spritesheets/hair/twists_fade/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_fade/male/white.png.json",
    "lpc/spritesheets/hair/twists_straight/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/black.png",
    "lpc/spritesheets/hair/twists_straight/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/black.png.json",
    "lpc/spritesheets/hair/twists_straight/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/blonde.png",
    "lpc/spritesheets/hair/twists_straight/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/blonde.png.json",
    "lpc/spritesheets/hair/twists_straight/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/blue.png",
    "lpc/spritesheets/hair/twists_straight/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/blue.png.json",
    "lpc/spritesheets/hair/twists_straight/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/dark_brown.png",
    "lpc/spritesheets/hair/twists_straight/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/dark_brown.png.json",
    "lpc/spritesheets/hair/twists_straight/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/gold.png",
    "lpc/spritesheets/hair/twists_straight/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/gold.png.json",
    "lpc/spritesheets/hair/twists_straight/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/gray.png",
    "lpc/spritesheets/hair/twists_straight/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/gray.png.json",
    "lpc/spritesheets/hair/twists_straight/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/green.png",
    "lpc/spritesheets/hair/twists_straight/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/green.png.json",
    "lpc/spritesheets/hair/twists_straight/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/light_brown.png",
    "lpc/spritesheets/hair/twists_straight/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/light_brown.png.json",
    "lpc/spritesheets/hair/twists_straight/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/orange.png",
    "lpc/spritesheets/hair/twists_straight/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/orange.png.json",
    "lpc/spritesheets/hair/twists_straight/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/purple.png",
    "lpc/spritesheets/hair/twists_straight/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/purple.png.json",
    "lpc/spritesheets/hair/twists_straight/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/red.png",
    "lpc/spritesheets/hair/twists_straight/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/red.png.json",
    "lpc/spritesheets/hair/twists_straight/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/white.png",
    "lpc/spritesheets/hair/twists_straight/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/female/white.png.json",
    "lpc/spritesheets/hair/twists_straight/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/black.png",
    "lpc/spritesheets/hair/twists_straight/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/black.png.json",
    "lpc/spritesheets/hair/twists_straight/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/blonde.png",
    "lpc/spritesheets/hair/twists_straight/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/blonde.png.json",
    "lpc/spritesheets/hair/twists_straight/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/blue.png",
    "lpc/spritesheets/hair/twists_straight/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/blue.png.json",
    "lpc/spritesheets/hair/twists_straight/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/dark_brown.png",
    "lpc/spritesheets/hair/twists_straight/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/dark_brown.png.json",
    "lpc/spritesheets/hair/twists_straight/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/gold.png",
    "lpc/spritesheets/hair/twists_straight/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/gold.png.json",
    "lpc/spritesheets/hair/twists_straight/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/gray.png",
    "lpc/spritesheets/hair/twists_straight/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/gray.png.json",
    "lpc/spritesheets/hair/twists_straight/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/green.png",
    "lpc/spritesheets/hair/twists_straight/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/green.png.json",
    "lpc/spritesheets/hair/twists_straight/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/light_brown.png",
    "lpc/spritesheets/hair/twists_straight/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/light_brown.png.json",
    "lpc/spritesheets/hair/twists_straight/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/orange.png",
    "lpc/spritesheets/hair/twists_straight/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/orange.png.json",
    "lpc/spritesheets/hair/twists_straight/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/purple.png",
    "lpc/spritesheets/hair/twists_straight/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/purple.png.json",
    "lpc/spritesheets/hair/twists_straight/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/red.png",
    "lpc/spritesheets/hair/twists_straight/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/red.png.json",
    "lpc/spritesheets/hair/twists_straight/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/white.png",
    "lpc/spritesheets/hair/twists_straight/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/twists_straight/male/white.png.json",
    "lpc/spritesheets/hair/unkempt/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/black.png",
    "lpc/spritesheets/hair/unkempt/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/black.png.json",
    "lpc/spritesheets/hair/unkempt/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/blonde.png",
    "lpc/spritesheets/hair/unkempt/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/blonde.png.json",
    "lpc/spritesheets/hair/unkempt/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/blue.png",
    "lpc/spritesheets/hair/unkempt/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/blue.png.json",
    "lpc/spritesheets/hair/unkempt/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/dark_brown.png",
    "lpc/spritesheets/hair/unkempt/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/dark_brown.png.json",
    "lpc/spritesheets/hair/unkempt/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/gold.png",
    "lpc/spritesheets/hair/unkempt/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/gold.png.json",
    "lpc/spritesheets/hair/unkempt/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/gray.png",
    "lpc/spritesheets/hair/unkempt/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/gray.png.json",
    "lpc/spritesheets/hair/unkempt/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/green.png",
    "lpc/spritesheets/hair/unkempt/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/green.png.json",
    "lpc/spritesheets/hair/unkempt/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/light_brown.png",
    "lpc/spritesheets/hair/unkempt/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/light_brown.png.json",
    "lpc/spritesheets/hair/unkempt/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/orange.png",
    "lpc/spritesheets/hair/unkempt/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/orange.png.json",
    "lpc/spritesheets/hair/unkempt/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/purple.png",
    "lpc/spritesheets/hair/unkempt/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/purple.png.json",
    "lpc/spritesheets/hair/unkempt/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/red.png",
    "lpc/spritesheets/hair/unkempt/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/red.png.json",
    "lpc/spritesheets/hair/unkempt/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/white.png",
    "lpc/spritesheets/hair/unkempt/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/female/white.png.json",
    "lpc/spritesheets/hair/unkempt/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/black.png",
    "lpc/spritesheets/hair/unkempt/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/black.png.json",
    "lpc/spritesheets/hair/unkempt/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/blonde.png",
    "lpc/spritesheets/hair/unkempt/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/blonde.png.json",
    "lpc/spritesheets/hair/unkempt/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/blue.png",
    "lpc/spritesheets/hair/unkempt/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/blue.png.json",
    "lpc/spritesheets/hair/unkempt/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/dark_brown.png",
    "lpc/spritesheets/hair/unkempt/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/dark_brown.png.json",
    "lpc/spritesheets/hair/unkempt/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/gold.png",
    "lpc/spritesheets/hair/unkempt/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/gold.png.json",
    "lpc/spritesheets/hair/unkempt/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/gray.png",
    "lpc/spritesheets/hair/unkempt/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/gray.png.json",
    "lpc/spritesheets/hair/unkempt/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/green.png",
    "lpc/spritesheets/hair/unkempt/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/green.png.json",
    "lpc/spritesheets/hair/unkempt/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/light_brown.png",
    "lpc/spritesheets/hair/unkempt/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/light_brown.png.json",
    "lpc/spritesheets/hair/unkempt/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/orange.png",
    "lpc/spritesheets/hair/unkempt/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/orange.png.json",
    "lpc/spritesheets/hair/unkempt/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/purple.png",
    "lpc/spritesheets/hair/unkempt/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/purple.png.json",
    "lpc/spritesheets/hair/unkempt/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/red.png",
    "lpc/spritesheets/hair/unkempt/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/red.png.json",
    "lpc/spritesheets/hair/unkempt/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/white.png",
    "lpc/spritesheets/hair/unkempt/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/unkempt/male/white.png.json",
    "lpc/spritesheets/hair/wavy/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/black.png",
    "lpc/spritesheets/hair/wavy/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/black.png.json",
    "lpc/spritesheets/hair/wavy/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/blonde.png",
    "lpc/spritesheets/hair/wavy/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/blonde.png.json",
    "lpc/spritesheets/hair/wavy/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/blue.png",
    "lpc/spritesheets/hair/wavy/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/blue.png.json",
    "lpc/spritesheets/hair/wavy/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/dark_brown.png",
    "lpc/spritesheets/hair/wavy/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/dark_brown.png.json",
    "lpc/spritesheets/hair/wavy/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/gold.png",
    "lpc/spritesheets/hair/wavy/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/gold.png.json",
    "lpc/spritesheets/hair/wavy/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/gray.png",
    "lpc/spritesheets/hair/wavy/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/gray.png.json",
    "lpc/spritesheets/hair/wavy/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/green.png",
    "lpc/spritesheets/hair/wavy/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/green.png.json",
    "lpc/spritesheets/hair/wavy/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/light_brown.png",
    "lpc/spritesheets/hair/wavy/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/light_brown.png.json",
    "lpc/spritesheets/hair/wavy/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/orange.png",
    "lpc/spritesheets/hair/wavy/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/orange.png.json",
    "lpc/spritesheets/hair/wavy/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/purple.png",
    "lpc/spritesheets/hair/wavy/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/purple.png.json",
    "lpc/spritesheets/hair/wavy/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/red.png",
    "lpc/spritesheets/hair/wavy/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/red.png.json",
    "lpc/spritesheets/hair/wavy/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/white.png",
    "lpc/spritesheets/hair/wavy/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/female/white.png.json",
    "lpc/spritesheets/hair/wavy/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/black.png",
    "lpc/spritesheets/hair/wavy/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/black.png.json",
    "lpc/spritesheets/hair/wavy/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/blonde.png",
    "lpc/spritesheets/hair/wavy/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/blonde.png.json",
    "lpc/spritesheets/hair/wavy/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/blue.png",
    "lpc/spritesheets/hair/wavy/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/blue.png.json",
    "lpc/spritesheets/hair/wavy/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/dark_brown.png",
    "lpc/spritesheets/hair/wavy/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/dark_brown.png.json",
    "lpc/spritesheets/hair/wavy/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/gold.png",
    "lpc/spritesheets/hair/wavy/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/gold.png.json",
    "lpc/spritesheets/hair/wavy/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/gray.png",
    "lpc/spritesheets/hair/wavy/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/gray.png.json",
    "lpc/spritesheets/hair/wavy/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/green.png",
    "lpc/spritesheets/hair/wavy/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/green.png.json",
    "lpc/spritesheets/hair/wavy/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/light_brown.png",
    "lpc/spritesheets/hair/wavy/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/light_brown.png.json",
    "lpc/spritesheets/hair/wavy/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/orange.png",
    "lpc/spritesheets/hair/wavy/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/orange.png.json",
    "lpc/spritesheets/hair/wavy/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/purple.png",
    "lpc/spritesheets/hair/wavy/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/purple.png.json",
    "lpc/spritesheets/hair/wavy/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/red.png",
    "lpc/spritesheets/hair/wavy/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/red.png.json",
    "lpc/spritesheets/hair/wavy/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/white.png",
    "lpc/spritesheets/hair/wavy/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/wavy/male/white.png.json",
    "lpc/spritesheets/hair/xlong/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/black.png",
    "lpc/spritesheets/hair/xlong/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/black.png.json",
    "lpc/spritesheets/hair/xlong/female/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/blonde.png",
    "lpc/spritesheets/hair/xlong/female/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/blonde.png.json",
    "lpc/spritesheets/hair/xlong/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/blue.png",
    "lpc/spritesheets/hair/xlong/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/blue.png.json",
    "lpc/spritesheets/hair/xlong/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/dark_brown.png",
    "lpc/spritesheets/hair/xlong/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/dark_brown.png.json",
    "lpc/spritesheets/hair/xlong/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/gold.png",
    "lpc/spritesheets/hair/xlong/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/gold.png.json",
    "lpc/spritesheets/hair/xlong/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/gray.png",
    "lpc/spritesheets/hair/xlong/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/gray.png.json",
    "lpc/spritesheets/hair/xlong/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/green.png",
    "lpc/spritesheets/hair/xlong/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/green.png.json",
    "lpc/spritesheets/hair/xlong/female/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/light_brown.png",
    "lpc/spritesheets/hair/xlong/female/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/light_brown.png.json",
    "lpc/spritesheets/hair/xlong/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/orange.png",
    "lpc/spritesheets/hair/xlong/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/orange.png.json",
    "lpc/spritesheets/hair/xlong/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/purple.png",
    "lpc/spritesheets/hair/xlong/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/purple.png.json",
    "lpc/spritesheets/hair/xlong/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/red.png",
    "lpc/spritesheets/hair/xlong/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/red.png.json",
    "lpc/spritesheets/hair/xlong/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/white.png",
    "lpc/spritesheets/hair/xlong/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/female/white.png.json",
    "lpc/spritesheets/hair/xlong/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/black.png",
    "lpc/spritesheets/hair/xlong/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/black.png.json",
    "lpc/spritesheets/hair/xlong/male/blonde.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/blonde.png",
    "lpc/spritesheets/hair/xlong/male/blonde.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/blonde.png.json",
    "lpc/spritesheets/hair/xlong/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/blue.png",
    "lpc/spritesheets/hair/xlong/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/blue.png.json",
    "lpc/spritesheets/hair/xlong/male/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/dark_brown.png",
    "lpc/spritesheets/hair/xlong/male/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/dark_brown.png.json",
    "lpc/spritesheets/hair/xlong/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/gold.png",
    "lpc/spritesheets/hair/xlong/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/gold.png.json",
    "lpc/spritesheets/hair/xlong/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/gray.png",
    "lpc/spritesheets/hair/xlong/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/gray.png.json",
    "lpc/spritesheets/hair/xlong/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/green.png",
    "lpc/spritesheets/hair/xlong/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/green.png.json",
    "lpc/spritesheets/hair/xlong/male/light_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/light_brown.png",
    "lpc/spritesheets/hair/xlong/male/light_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/light_brown.png.json",
    "lpc/spritesheets/hair/xlong/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/orange.png",
    "lpc/spritesheets/hair/xlong/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/orange.png.json",
    "lpc/spritesheets/hair/xlong/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/purple.png",
    "lpc/spritesheets/hair/xlong/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/purple.png.json",
    "lpc/spritesheets/hair/xlong/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/red.png",
    "lpc/spritesheets/hair/xlong/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/red.png.json",
    "lpc/spritesheets/hair/xlong/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/white.png",
    "lpc/spritesheets/hair/xlong/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/hair/xlong/male/white.png.json",
    "lpc/spritesheets/head/nose/big/female/darkelf.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/big/female/darkelf.png",
    "lpc/spritesheets/head/nose/big/female/darkelf.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/big/female/darkelf.png.json",
    "lpc/spritesheets/head/nose/big/female/light.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/big/female/light.png",
    "lpc/spritesheets/head/nose/big/female/light.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/big/female/light.png.json",
    "lpc/spritesheets/head/nose/big/female/tanned.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/big/female/tanned.png",
    "lpc/spritesheets/head/nose/big/female/tanned.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/big/female/tanned.png.json",
    "lpc/spritesheets/head/nose/big/male/darkelf.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/big/male/darkelf.png",
    "lpc/spritesheets/head/nose/big/male/darkelf.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/big/male/darkelf.png.json",
    "lpc/spritesheets/head/nose/big/male/light.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/big/male/light.png",
    "lpc/spritesheets/head/nose/big/male/light.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/big/male/light.png.json",
    "lpc/spritesheets/head/nose/big/male/tanned.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/big/male/tanned.png",
    "lpc/spritesheets/head/nose/big/male/tanned.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/big/male/tanned.png.json",
    "lpc/spritesheets/head/nose/button/female/darkelf.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/button/female/darkelf.png",
    "lpc/spritesheets/head/nose/button/female/darkelf.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/button/female/darkelf.png.json",
    "lpc/spritesheets/head/nose/button/female/light.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/button/female/light.png",
    "lpc/spritesheets/head/nose/button/female/light.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/button/female/light.png.json",
    "lpc/spritesheets/head/nose/button/female/tanned.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/button/female/tanned.png",
    "lpc/spritesheets/head/nose/button/female/tanned.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/button/female/tanned.png.json",
    "lpc/spritesheets/head/nose/button/male/darkelf.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/button/male/darkelf.png",
    "lpc/spritesheets/head/nose/button/male/darkelf.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/button/male/darkelf.png.json",
    "lpc/spritesheets/head/nose/button/male/light.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/button/male/light.png",
    "lpc/spritesheets/head/nose/button/male/light.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/button/male/light.png.json",
    "lpc/spritesheets/head/nose/button/male/tanned.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/button/male/tanned.png",
    "lpc/spritesheets/head/nose/button/male/tanned.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/button/male/tanned.png.json",
    "lpc/spritesheets/head/nose/straight/female/darkelf.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/straight/female/darkelf.png",
    "lpc/spritesheets/head/nose/straight/female/darkelf.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/straight/female/darkelf.png.json",
    "lpc/spritesheets/head/nose/straight/female/light.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/straight/female/light.png",
    "lpc/spritesheets/head/nose/straight/female/light.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/straight/female/light.png.json",
    "lpc/spritesheets/head/nose/straight/female/tanned.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/straight/female/tanned.png",
    "lpc/spritesheets/head/nose/straight/female/tanned.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/straight/female/tanned.png.json",
    "lpc/spritesheets/head/nose/straight/male/darkelf.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/straight/male/darkelf.png",
    "lpc/spritesheets/head/nose/straight/male/darkelf.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/straight/male/darkelf.png.json",
    "lpc/spritesheets/head/nose/straight/male/light.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/straight/male/light.png",
    "lpc/spritesheets/head/nose/straight/male/light.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/straight/male/light.png.json",
    "lpc/spritesheets/head/nose/straight/male/tanned.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/straight/male/tanned.png",
    "lpc/spritesheets/head/nose/straight/male/tanned.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/head/nose/straight/male/tanned.png.json",
    "lpc/spritesheets/legs/armour/female/10.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/armour/female/10.png",
    "lpc/spritesheets/legs/armour/female/10.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/armour/female/10.png.json",
    "lpc/spritesheets/legs/armour/female/11.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/armour/female/11.png",
    "lpc/spritesheets/legs/armour/female/11.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/armour/female/11.png.json",
    "lpc/spritesheets/legs/armour/female/7.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/armour/female/7.png",
    "lpc/spritesheets/legs/armour/female/7.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/armour/female/7.png.json",
    "lpc/spritesheets/legs/armour/female/8.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/armour/female/8.png",
    "lpc/spritesheets/legs/armour/female/8.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/armour/female/8.png.json",
    "lpc/spritesheets/legs/armour/female/9.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/armour/female/9.png",
    "lpc/spritesheets/legs/armour/female/9.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/armour/female/9.png.json",
    "lpc/spritesheets/legs/armour/male/10.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/armour/male/10.png",
    "lpc/spritesheets/legs/armour/male/10.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/armour/male/10.png.json",
    "lpc/spritesheets/legs/armour/male/11.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/armour/male/11.png",
    "lpc/spritesheets/legs/armour/male/11.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/armour/male/11.png.json",
    "lpc/spritesheets/legs/armour/male/7.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/armour/male/7.png",
    "lpc/spritesheets/legs/armour/male/7.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/armour/male/7.png.json",
    "lpc/spritesheets/legs/armour/male/8.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/armour/male/8.png",
    "lpc/spritesheets/legs/armour/male/8.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/armour/male/8.png.json",
    "lpc/spritesheets/legs/armour/male/9.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/armour/male/9.png",
    "lpc/spritesheets/legs/armour/male/9.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/armour/male/9.png.json",
    "lpc/spritesheets/legs/pantaloons/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/black.png",
    "lpc/spritesheets/legs/pantaloons/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/black.png.json",
    "lpc/spritesheets/legs/pantaloons/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/blue.png",
    "lpc/spritesheets/legs/pantaloons/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/blue.png.json",
    "lpc/spritesheets/legs/pantaloons/male/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/brown.png",
    "lpc/spritesheets/legs/pantaloons/male/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/brown.png.json",
    "lpc/spritesheets/legs/pantaloons/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/gray.png",
    "lpc/spritesheets/legs/pantaloons/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/gray.png.json",
    "lpc/spritesheets/legs/pantaloons/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/green.png",
    "lpc/spritesheets/legs/pantaloons/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/green.png.json",
    "lpc/spritesheets/legs/pantaloons/male/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/maroon.png",
    "lpc/spritesheets/legs/pantaloons/male/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/maroon.png.json",
    "lpc/spritesheets/legs/pantaloons/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/orange.png",
    "lpc/spritesheets/legs/pantaloons/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/orange.png.json",
    "lpc/spritesheets/legs/pantaloons/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/purple.png",
    "lpc/spritesheets/legs/pantaloons/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/purple.png.json",
    "lpc/spritesheets/legs/pantaloons/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/red.png",
    "lpc/spritesheets/legs/pantaloons/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/red.png.json",
    "lpc/spritesheets/legs/pantaloons/male/tan.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/tan.png",
    "lpc/spritesheets/legs/pantaloons/male/tan.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/tan.png.json",
    "lpc/spritesheets/legs/pantaloons/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/white.png",
    "lpc/spritesheets/legs/pantaloons/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/white.png.json",
    "lpc/spritesheets/legs/pantaloons/male/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/yellow.png",
    "lpc/spritesheets/legs/pantaloons/male/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pantaloons/male/yellow.png.json",
    "lpc/spritesheets/legs/pants/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/black.png",
    "lpc/spritesheets/legs/pants/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/black.png.json",
    "lpc/spritesheets/legs/pants/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/blue.png",
    "lpc/spritesheets/legs/pants/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/blue.png.json",
    "lpc/spritesheets/legs/pants/female/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/brown.png",
    "lpc/spritesheets/legs/pants/female/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/brown.png.json",
    "lpc/spritesheets/legs/pants/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/gray.png",
    "lpc/spritesheets/legs/pants/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/gray.png.json",
    "lpc/spritesheets/legs/pants/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/green.png",
    "lpc/spritesheets/legs/pants/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/green.png.json",
    "lpc/spritesheets/legs/pants/female/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/maroon.png",
    "lpc/spritesheets/legs/pants/female/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/maroon.png.json",
    "lpc/spritesheets/legs/pants/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/orange.png",
    "lpc/spritesheets/legs/pants/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/orange.png.json",
    "lpc/spritesheets/legs/pants/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/purple.png",
    "lpc/spritesheets/legs/pants/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/purple.png.json",
    "lpc/spritesheets/legs/pants/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/red.png",
    "lpc/spritesheets/legs/pants/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/red.png.json",
    "lpc/spritesheets/legs/pants/female/tan.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/tan.png",
    "lpc/spritesheets/legs/pants/female/tan.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/tan.png.json",
    "lpc/spritesheets/legs/pants/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/white.png",
    "lpc/spritesheets/legs/pants/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/white.png.json",
    "lpc/spritesheets/legs/pants/female/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/yellow.png",
    "lpc/spritesheets/legs/pants/female/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/female/yellow.png.json",
    "lpc/spritesheets/legs/pants/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/black.png",
    "lpc/spritesheets/legs/pants/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/black.png.json",
    "lpc/spritesheets/legs/pants/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/blue.png",
    "lpc/spritesheets/legs/pants/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/blue.png.json",
    "lpc/spritesheets/legs/pants/male/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/brown.png",
    "lpc/spritesheets/legs/pants/male/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/brown.png.json",
    "lpc/spritesheets/legs/pants/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/gray.png",
    "lpc/spritesheets/legs/pants/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/gray.png.json",
    "lpc/spritesheets/legs/pants/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/green.png",
    "lpc/spritesheets/legs/pants/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/green.png.json",
    "lpc/spritesheets/legs/pants/male/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/maroon.png",
    "lpc/spritesheets/legs/pants/male/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/maroon.png.json",
    "lpc/spritesheets/legs/pants/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/orange.png",
    "lpc/spritesheets/legs/pants/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/orange.png.json",
    "lpc/spritesheets/legs/pants/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/purple.png",
    "lpc/spritesheets/legs/pants/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/purple.png.json",
    "lpc/spritesheets/legs/pants/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/red.png",
    "lpc/spritesheets/legs/pants/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/red.png.json",
    "lpc/spritesheets/legs/pants/male/tan.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/tan.png",
    "lpc/spritesheets/legs/pants/male/tan.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/tan.png.json",
    "lpc/spritesheets/legs/pants/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/white.png",
    "lpc/spritesheets/legs/pants/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/white.png.json",
    "lpc/spritesheets/legs/pants/male/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/yellow.png",
    "lpc/spritesheets/legs/pants/male/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/pants/male/yellow.png.json",
    "lpc/spritesheets/legs/skirts/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/skirts/female/black.png",
    "lpc/spritesheets/legs/skirts/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/skirts/female/black.png.json",
    "lpc/spritesheets/legs/skirts/female/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/skirts/female/brown.png",
    "lpc/spritesheets/legs/skirts/female/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/skirts/female/brown.png.json",
    "lpc/spritesheets/legs/skirts/female/legion.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/skirts/female/legion.png",
    "lpc/spritesheets/legs/skirts/female/legion.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/skirts/female/legion.png.json",
    "lpc/spritesheets/legs/skirts/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/skirts/female/white.png",
    "lpc/spritesheets/legs/skirts/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/skirts/female/white.png.json",
    "lpc/spritesheets/legs/skirts/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/skirts/male/black.png",
    "lpc/spritesheets/legs/skirts/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/skirts/male/black.png.json",
    "lpc/spritesheets/legs/skirts/male/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/skirts/male/brown.png",
    "lpc/spritesheets/legs/skirts/male/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/skirts/male/brown.png.json",
    "lpc/spritesheets/legs/skirts/male/legion.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/skirts/male/legion.png",
    "lpc/spritesheets/legs/skirts/male/legion.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/skirts/male/legion.png.json",
    "lpc/spritesheets/legs/skirts/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/skirts/male/white.png",
    "lpc/spritesheets/legs/skirts/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/legs/skirts/male/white.png.json",
    "lpc/spritesheets/shield/female/crusader.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/crusader.png",
    "lpc/spritesheets/shield/female/crusader.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/crusader.png.json",
    "lpc/spritesheets/shield/female/kite_blue_blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/kite_blue_blue.png",
    "lpc/spritesheets/shield/female/kite_blue_blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/kite_blue_blue.png.json",
    "lpc/spritesheets/shield/female/kite_blue_gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/kite_blue_gray.png",
    "lpc/spritesheets/shield/female/kite_blue_gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/kite_blue_gray.png.json",
    "lpc/spritesheets/shield/female/kite_gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/kite_gray.png",
    "lpc/spritesheets/shield/female/kite_gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/kite_gray.png.json",
    "lpc/spritesheets/shield/female/kite_gray_blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/kite_gray_blue.png",
    "lpc/spritesheets/shield/female/kite_gray_blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/kite_gray_blue.png.json",
    "lpc/spritesheets/shield/female/kite_gray_gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/kite_gray_gray.png",
    "lpc/spritesheets/shield/female/kite_gray_gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/kite_gray_gray.png.json",
    "lpc/spritesheets/shield/female/kite_gray_green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/kite_gray_green.png",
    "lpc/spritesheets/shield/female/kite_gray_green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/kite_gray_green.png.json",
    "lpc/spritesheets/shield/female/kite_gray_orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/kite_gray_orange.png",
    "lpc/spritesheets/shield/female/kite_gray_orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/kite_gray_orange.png.json",
    "lpc/spritesheets/shield/female/kite_green_gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/kite_green_gray.png",
    "lpc/spritesheets/shield/female/kite_green_gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/kite_green_gray.png.json",
    "lpc/spritesheets/shield/female/kite_orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/kite_orange.png",
    "lpc/spritesheets/shield/female/kite_orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/kite_orange.png.json",
    "lpc/spritesheets/shield/female/kite_red_gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/kite_red_gray.png",
    "lpc/spritesheets/shield/female/kite_red_gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/kite_red_gray.png.json",
    "lpc/spritesheets/shield/female/round_black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/round_black.png",
    "lpc/spritesheets/shield/female/round_black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/round_black.png.json",
    "lpc/spritesheets/shield/female/round_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/round_brown.png",
    "lpc/spritesheets/shield/female/round_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/round_brown.png.json",
    "lpc/spritesheets/shield/female/round_gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/round_gold.png",
    "lpc/spritesheets/shield/female/round_gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/round_gold.png.json",
    "lpc/spritesheets/shield/female/round_green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/round_green.png",
    "lpc/spritesheets/shield/female/round_green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/round_green.png.json",
    "lpc/spritesheets/shield/female/round_silver.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/round_silver.png",
    "lpc/spritesheets/shield/female/round_silver.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/round_silver.png.json",
    "lpc/spritesheets/shield/female/round_yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/round_yellow.png",
    "lpc/spritesheets/shield/female/round_yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/round_yellow.png.json",
    "lpc/spritesheets/shield/female/spartan.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/spartan.png",
    "lpc/spritesheets/shield/female/spartan.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/female/spartan.png.json",
    "lpc/spritesheets/shield/male/crusader.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/crusader.png",
    "lpc/spritesheets/shield/male/crusader.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/crusader.png.json",
    "lpc/spritesheets/shield/male/kite_blue_blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/kite_blue_blue.png",
    "lpc/spritesheets/shield/male/kite_blue_blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/kite_blue_blue.png.json",
    "lpc/spritesheets/shield/male/kite_blue_gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/kite_blue_gray.png",
    "lpc/spritesheets/shield/male/kite_blue_gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/kite_blue_gray.png.json",
    "lpc/spritesheets/shield/male/kite_gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/kite_gray.png",
    "lpc/spritesheets/shield/male/kite_gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/kite_gray.png.json",
    "lpc/spritesheets/shield/male/kite_gray_blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/kite_gray_blue.png",
    "lpc/spritesheets/shield/male/kite_gray_blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/kite_gray_blue.png.json",
    "lpc/spritesheets/shield/male/kite_gray_gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/kite_gray_gray.png",
    "lpc/spritesheets/shield/male/kite_gray_gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/kite_gray_gray.png.json",
    "lpc/spritesheets/shield/male/kite_gray_green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/kite_gray_green.png",
    "lpc/spritesheets/shield/male/kite_gray_green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/kite_gray_green.png.json",
    "lpc/spritesheets/shield/male/kite_gray_orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/kite_gray_orange.png",
    "lpc/spritesheets/shield/male/kite_gray_orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/kite_gray_orange.png.json",
    "lpc/spritesheets/shield/male/kite_green_gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/kite_green_gray.png",
    "lpc/spritesheets/shield/male/kite_green_gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/kite_green_gray.png.json",
    "lpc/spritesheets/shield/male/kite_orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/kite_orange.png",
    "lpc/spritesheets/shield/male/kite_orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/kite_orange.png.json",
    "lpc/spritesheets/shield/male/kite_red_gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/kite_red_gray.png",
    "lpc/spritesheets/shield/male/kite_red_gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/kite_red_gray.png.json",
    "lpc/spritesheets/shield/male/round_black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/round_black.png",
    "lpc/spritesheets/shield/male/round_black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/round_black.png.json",
    "lpc/spritesheets/shield/male/round_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/round_brown.png",
    "lpc/spritesheets/shield/male/round_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/round_brown.png.json",
    "lpc/spritesheets/shield/male/round_gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/round_gold.png",
    "lpc/spritesheets/shield/male/round_gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/round_gold.png.json",
    "lpc/spritesheets/shield/male/round_green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/round_green.png",
    "lpc/spritesheets/shield/male/round_green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/round_green.png.json",
    "lpc/spritesheets/shield/male/round_silver.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/round_silver.png",
    "lpc/spritesheets/shield/male/round_silver.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/round_silver.png.json",
    "lpc/spritesheets/shield/male/round_yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/round_yellow.png",
    "lpc/spritesheets/shield/male/round_yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/round_yellow.png.json",
    "lpc/spritesheets/shield/male/spartan.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/spartan.png",
    "lpc/spritesheets/shield/male/spartan.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/shield/male/spartan.png.json",
    "lpc/spritesheets/spike/spikes1.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/spike/spikes1.png",
    "lpc/spritesheets/spike/spikes1.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/spike/spikes1.png.json",
    "lpc/spritesheets/torso/armour/leather/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/leather/female/blue.png",
    "lpc/spritesheets/torso/armour/leather/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/leather/female/blue.png.json",
    "lpc/spritesheets/torso/armour/leather/female/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/leather/female/brown.png",
    "lpc/spritesheets/torso/armour/leather/female/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/leather/female/brown.png.json",
    "lpc/spritesheets/torso/armour/leather/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/leather/female/green.png",
    "lpc/spritesheets/torso/armour/leather/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/leather/female/green.png.json",
    "lpc/spritesheets/torso/armour/leather/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/leather/male/blue.png",
    "lpc/spritesheets/torso/armour/leather/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/leather/male/blue.png.json",
    "lpc/spritesheets/torso/armour/leather/male/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/leather/male/brown.png",
    "lpc/spritesheets/torso/armour/leather/male/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/leather/male/brown.png.json",
    "lpc/spritesheets/torso/armour/leather/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/leather/male/green.png",
    "lpc/spritesheets/torso/armour/leather/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/leather/male/green.png.json",
    "lpc/spritesheets/torso/armour/legion/female/bronze.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/legion/female/bronze.png",
    "lpc/spritesheets/torso/armour/legion/female/bronze.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/legion/female/bronze.png.json",
    "lpc/spritesheets/torso/armour/legion/female/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/legion/female/gold.png",
    "lpc/spritesheets/torso/armour/legion/female/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/legion/female/gold.png.json",
    "lpc/spritesheets/torso/armour/legion/female/steel.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/legion/female/steel.png",
    "lpc/spritesheets/torso/armour/legion/female/steel.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/legion/female/steel.png.json",
    "lpc/spritesheets/torso/armour/legion/male/bronze.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/legion/male/bronze.png",
    "lpc/spritesheets/torso/armour/legion/male/bronze.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/legion/male/bronze.png.json",
    "lpc/spritesheets/torso/armour/legion/male/gold.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/legion/male/gold.png",
    "lpc/spritesheets/torso/armour/legion/male/gold.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/legion/male/gold.png.json",
    "lpc/spritesheets/torso/armour/legion/male/steel.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/legion/male/steel.png",
    "lpc/spritesheets/torso/armour/legion/male/steel.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/legion/male/steel.png.json",
    "lpc/spritesheets/torso/armour/plate/female/11.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/plate/female/11.png",
    "lpc/spritesheets/torso/armour/plate/female/11.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/plate/female/11.png.json",
    "lpc/spritesheets/torso/armour/plate/female/12.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/plate/female/12.png",
    "lpc/spritesheets/torso/armour/plate/female/12.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/plate/female/12.png.json",
    "lpc/spritesheets/torso/armour/plate/female/14.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/plate/female/14.png",
    "lpc/spritesheets/torso/armour/plate/female/14.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/plate/female/14.png.json",
    "lpc/spritesheets/torso/armour/plate/female/16.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/plate/female/16.png",
    "lpc/spritesheets/torso/armour/plate/female/16.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/plate/female/16.png.json",
    "lpc/spritesheets/torso/armour/plate/female/special.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/plate/female/special.png",
    "lpc/spritesheets/torso/armour/plate/female/special.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/plate/female/special.png.json",
    "lpc/spritesheets/torso/armour/plate/male/11.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/plate/male/11.png",
    "lpc/spritesheets/torso/armour/plate/male/11.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/plate/male/11.png.json",
    "lpc/spritesheets/torso/armour/plate/male/12.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/plate/male/12.png",
    "lpc/spritesheets/torso/armour/plate/male/12.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/plate/male/12.png.json",
    "lpc/spritesheets/torso/armour/plate/male/14.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/plate/male/14.png",
    "lpc/spritesheets/torso/armour/plate/male/14.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/plate/male/14.png.json",
    "lpc/spritesheets/torso/armour/plate/male/16.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/plate/male/16.png",
    "lpc/spritesheets/torso/armour/plate/male/16.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/plate/male/16.png.json",
    "lpc/spritesheets/torso/armour/plate/male/special.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/plate/male/special.png",
    "lpc/spritesheets/torso/armour/plate/male/special.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/armour/plate/male/special.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/black.png",
    "lpc/spritesheets/torso/clothes/blouse/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/black.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/blue.png",
    "lpc/spritesheets/torso/clothes/blouse/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/blue.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/gray.png",
    "lpc/spritesheets/torso/clothes/blouse/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/gray.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/green.png",
    "lpc/spritesheets/torso/clothes/blouse/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/green.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/maroon.png",
    "lpc/spritesheets/torso/clothes/blouse/female/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/maroon.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/orange.png",
    "lpc/spritesheets/torso/clothes/blouse/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/orange.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/purple.png",
    "lpc/spritesheets/torso/clothes/blouse/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/purple.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/red.png",
    "lpc/spritesheets/torso/clothes/blouse/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/red.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/tan.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/tan.png",
    "lpc/spritesheets/torso/clothes/blouse/female/tan.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/tan.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/teal.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/teal.png",
    "lpc/spritesheets/torso/clothes/blouse/female/teal.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/teal.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/white.png",
    "lpc/spritesheets/torso/clothes/blouse/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/white.png.json",
    "lpc/spritesheets/torso/clothes/blouse/female/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/yellow.png",
    "lpc/spritesheets/torso/clothes/blouse/female/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse/female/yellow.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/black.png",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/black.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/blue.png",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/blue.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/gray.png",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/gray.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/green.png",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/green.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/maroon.png",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/maroon.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/orange.png",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/orange.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/purple.png",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/purple.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/red.png",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/red.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/tan.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/tan.png",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/tan.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/tan.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/teal.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/teal.png",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/teal.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/teal.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/white.png",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/white.png.json",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/yellow.png",
    "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/yellow.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/black.png",
    "lpc/spritesheets/torso/clothes/corset/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/black.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/blue.png",
    "lpc/spritesheets/torso/clothes/corset/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/blue.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/gray.png",
    "lpc/spritesheets/torso/clothes/corset/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/gray.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/green.png",
    "lpc/spritesheets/torso/clothes/corset/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/green.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/leather.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/leather.png",
    "lpc/spritesheets/torso/clothes/corset/female/leather.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/leather.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/maroon.png",
    "lpc/spritesheets/torso/clothes/corset/female/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/maroon.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/orange.png",
    "lpc/spritesheets/torso/clothes/corset/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/orange.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/purple.png",
    "lpc/spritesheets/torso/clothes/corset/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/purple.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/red.png",
    "lpc/spritesheets/torso/clothes/corset/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/red.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/tan.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/tan.png",
    "lpc/spritesheets/torso/clothes/corset/female/tan.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/tan.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/teal.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/teal.png",
    "lpc/spritesheets/torso/clothes/corset/female/teal.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/teal.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/white.png",
    "lpc/spritesheets/torso/clothes/corset/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/white.png.json",
    "lpc/spritesheets/torso/clothes/corset/female/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/yellow.png",
    "lpc/spritesheets/torso/clothes/corset/female/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/corset/female/yellow.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/black.png",
    "lpc/spritesheets/torso/clothes/longsleeve/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/black.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/blue.png",
    "lpc/spritesheets/torso/clothes/longsleeve/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/blue.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/gray.png",
    "lpc/spritesheets/torso/clothes/longsleeve/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/gray.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/green.png",
    "lpc/spritesheets/torso/clothes/longsleeve/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/green.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/maroon.png",
    "lpc/spritesheets/torso/clothes/longsleeve/female/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/maroon.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/orange.png",
    "lpc/spritesheets/torso/clothes/longsleeve/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/orange.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/purple.png",
    "lpc/spritesheets/torso/clothes/longsleeve/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/purple.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/red.png",
    "lpc/spritesheets/torso/clothes/longsleeve/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/red.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/tan.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/tan.png",
    "lpc/spritesheets/torso/clothes/longsleeve/female/tan.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/tan.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/teal.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/teal.png",
    "lpc/spritesheets/torso/clothes/longsleeve/female/teal.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/teal.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/white.png",
    "lpc/spritesheets/torso/clothes/longsleeve/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/white.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/female/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/yellow.png",
    "lpc/spritesheets/torso/clothes/longsleeve/female/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/female/yellow.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/male/black.png",
    "lpc/spritesheets/torso/clothes/longsleeve/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/male/black.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/male/blue.png",
    "lpc/spritesheets/torso/clothes/longsleeve/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/male/blue.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/male/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/male/brown.png",
    "lpc/spritesheets/torso/clothes/longsleeve/male/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/male/brown.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/male/green.png",
    "lpc/spritesheets/torso/clothes/longsleeve/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/male/green.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/male/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/male/maroon.png",
    "lpc/spritesheets/torso/clothes/longsleeve/male/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/male/maroon.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/male/purple.png",
    "lpc/spritesheets/torso/clothes/longsleeve/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/male/purple.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/male/red.png",
    "lpc/spritesheets/torso/clothes/longsleeve/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/male/red.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/male/teal.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/male/teal.png",
    "lpc/spritesheets/torso/clothes/longsleeve/male/teal.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/male/teal.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/male/white.png",
    "lpc/spritesheets/torso/clothes/longsleeve/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/male/white.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve/male/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/male/yellow.png",
    "lpc/spritesheets/torso/clothes/longsleeve/male/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve/male/yellow.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/black.png",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/black.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/blue.png",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/blue.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/brown.png",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/brown.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/gray.png",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/gray.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/green.png",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/green.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/maroon.png",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/maroon.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/orange.png",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/orange.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/purple.png",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/purple.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/red.png",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/red.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/tan.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/tan.png",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/tan.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/tan.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/teal.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/teal.png",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/teal.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/teal.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/white.png",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/white.png.json",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/yellow.png",
    "lpc/spritesheets/torso/clothes/longsleeve_laced/male/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/longsleeve_laced/male/yellow.png.json",
    "lpc/spritesheets/torso/clothes/robe/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/robe/female/black.png",
    "lpc/spritesheets/torso/clothes/robe/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/robe/female/black.png.json",
    "lpc/spritesheets/torso/clothes/robe/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/robe/female/blue.png",
    "lpc/spritesheets/torso/clothes/robe/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/robe/female/blue.png.json",
    "lpc/spritesheets/torso/clothes/robe/female/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/robe/female/brown.png",
    "lpc/spritesheets/torso/clothes/robe/female/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/robe/female/brown.png.json",
    "lpc/spritesheets/torso/clothes/robe/female/dark_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/robe/female/dark_brown.png",
    "lpc/spritesheets/torso/clothes/robe/female/dark_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/robe/female/dark_brown.png.json",
    "lpc/spritesheets/torso/clothes/robe/female/dark_gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/robe/female/dark_gray.png",
    "lpc/spritesheets/torso/clothes/robe/female/dark_gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/robe/female/dark_gray.png.json",
    "lpc/spritesheets/torso/clothes/robe/female/forest_green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/robe/female/forest_green.png",
    "lpc/spritesheets/torso/clothes/robe/female/forest_green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/robe/female/forest_green.png.json",
    "lpc/spritesheets/torso/clothes/robe/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/robe/female/purple.png",
    "lpc/spritesheets/torso/clothes/robe/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/robe/female/purple.png.json",
    "lpc/spritesheets/torso/clothes/robe/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/robe/female/red.png",
    "lpc/spritesheets/torso/clothes/robe/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/robe/female/red.png.json",
    "lpc/spritesheets/torso/clothes/robe/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/robe/female/white.png",
    "lpc/spritesheets/torso/clothes/robe/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/robe/female/white.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/black.png",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/black.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/blue.png",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/blue.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/gray.png",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/gray.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/green.png",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/green.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/maroon.png",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/maroon.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/orange.png",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/orange.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/purple.png",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/purple.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/red.png",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/red.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/tan.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/tan.png",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/tan.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/tan.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/teal.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/teal.png",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/teal.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/teal.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/white.png",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/white.png.json",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/yellow.png",
    "lpc/spritesheets/torso/clothes/scoop_shirt/female/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/scoop_shirt/female/yellow.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/black.png",
    "lpc/spritesheets/torso/clothes/sleeveless/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/black.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/blue.png",
    "lpc/spritesheets/torso/clothes/sleeveless/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/blue.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/brown.png",
    "lpc/spritesheets/torso/clothes/sleeveless/male/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/brown.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/gray.png",
    "lpc/spritesheets/torso/clothes/sleeveless/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/gray.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/green.png",
    "lpc/spritesheets/torso/clothes/sleeveless/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/green.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/maroon.png",
    "lpc/spritesheets/torso/clothes/sleeveless/male/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/maroon.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/orange.png",
    "lpc/spritesheets/torso/clothes/sleeveless/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/orange.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/purple.png",
    "lpc/spritesheets/torso/clothes/sleeveless/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/purple.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/red.png",
    "lpc/spritesheets/torso/clothes/sleeveless/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/red.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/tan.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/tan.png",
    "lpc/spritesheets/torso/clothes/sleeveless/male/tan.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/tan.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/teal.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/teal.png",
    "lpc/spritesheets/torso/clothes/sleeveless/male/teal.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/teal.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/white.png",
    "lpc/spritesheets/torso/clothes/sleeveless/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/white.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless/male/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/yellow.png",
    "lpc/spritesheets/torso/clothes/sleeveless/male/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless/male/yellow.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/black.png",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/black.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/blue.png",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/blue.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/brown.png",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/brown.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/gray.png",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/gray.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/green.png",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/green.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/maroon.png",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/maroon.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/orange.png",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/orange.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/purple.png",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/purple.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/red.png",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/red.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/tan.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/tan.png",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/tan.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/tan.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/teal.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/teal.png",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/teal.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/teal.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/white.png",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/white.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/yellow.png",
    "lpc/spritesheets/torso/clothes/sleeveless_laced/male/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_laced/male/yellow.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/black.png",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/black.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/blue.png",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/blue.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/brown.png",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/brown.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/gray.png",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/gray.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/green.png",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/green.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/maroon.png",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/maroon.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/orange.png",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/orange.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/purple.png",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/purple.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/red.png",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/red.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/tan.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/tan.png",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/tan.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/tan.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/teal.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/teal.png",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/teal.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/teal.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/white.png",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/white.png.json",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/yellow.png",
    "lpc/spritesheets/torso/clothes/sleeveless_striped/male/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/sleeveless_striped/male/yellow.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/black.png",
    "lpc/spritesheets/torso/clothes/tanktop/female/black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/black.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/blue.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/blue.png",
    "lpc/spritesheets/torso/clothes/tanktop/female/blue.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/blue.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/gray.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/gray.png",
    "lpc/spritesheets/torso/clothes/tanktop/female/gray.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/gray.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/green.png",
    "lpc/spritesheets/torso/clothes/tanktop/female/green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/green.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/maroon.png",
    "lpc/spritesheets/torso/clothes/tanktop/female/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/maroon.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/orange.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/orange.png",
    "lpc/spritesheets/torso/clothes/tanktop/female/orange.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/orange.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/purple.png",
    "lpc/spritesheets/torso/clothes/tanktop/female/purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/purple.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/red.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/red.png",
    "lpc/spritesheets/torso/clothes/tanktop/female/red.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/red.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/tan.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/tan.png",
    "lpc/spritesheets/torso/clothes/tanktop/female/tan.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/tan.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/teal.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/teal.png",
    "lpc/spritesheets/torso/clothes/tanktop/female/teal.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/teal.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/white.png",
    "lpc/spritesheets/torso/clothes/tanktop/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/white.png.json",
    "lpc/spritesheets/torso/clothes/tanktop/female/yellow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/yellow.png",
    "lpc/spritesheets/torso/clothes/tanktop/female/yellow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tanktop/female/yellow.png.json",
    "lpc/spritesheets/torso/clothes/tunic/female/brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tunic/female/brown.png",
    "lpc/spritesheets/torso/clothes/tunic/female/brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tunic/female/brown.png.json",
    "lpc/spritesheets/torso/clothes/tunic/female/maroon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tunic/female/maroon.png",
    "lpc/spritesheets/torso/clothes/tunic/female/maroon.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tunic/female/maroon.png.json",
    "lpc/spritesheets/torso/clothes/tunic/female/teal.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tunic/female/teal.png",
    "lpc/spritesheets/torso/clothes/tunic/female/teal.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tunic/female/teal.png.json",
    "lpc/spritesheets/torso/clothes/tunic/female/white.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tunic/female/white.png",
    "lpc/spritesheets/torso/clothes/tunic/female/white.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/torso/clothes/tunic/female/white.png.json",
    "lpc/spritesheets/weapon/bow/10.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/bow/10.png",
    "lpc/spritesheets/weapon/bow/10.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/bow/10.png.json",
    "lpc/spritesheets/weapon/bow/normal.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/bow/normal.png",
    "lpc/spritesheets/weapon/bow/normal.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/bow/normal.png.json",
    "lpc/spritesheets/weapon/slash/female/axe.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash/female/axe.png",
    "lpc/spritesheets/weapon/slash/female/axe.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash/female/axe.png.json",
    "lpc/spritesheets/weapon/slash/female/axe_2.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash/female/axe_2.png",
    "lpc/spritesheets/weapon/slash/female/axe_2.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash/female/axe_2.png.json",
    "lpc/spritesheets/weapon/slash/female/dagger.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash/female/dagger.png",
    "lpc/spritesheets/weapon/slash/female/dagger.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash/female/dagger.png.json",
    "lpc/spritesheets/weapon/slash/female/dagger_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash/female/dagger_brown.png",
    "lpc/spritesheets/weapon/slash/female/dagger_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash/female/dagger_brown.png.json",
    "lpc/spritesheets/weapon/slash/female/warhammer.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash/female/warhammer.png",
    "lpc/spritesheets/weapon/slash/female/warhammer.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash/female/warhammer.png.json",
    "lpc/spritesheets/weapon/slash/male/axe.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash/male/axe.png",
    "lpc/spritesheets/weapon/slash/male/axe.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash/male/axe.png.json",
    "lpc/spritesheets/weapon/slash/male/axe_2.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash/male/axe_2.png",
    "lpc/spritesheets/weapon/slash/male/axe_2.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash/male/axe_2.png.json",
    "lpc/spritesheets/weapon/slash/male/dagger.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash/male/dagger.png",
    "lpc/spritesheets/weapon/slash/male/dagger.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash/male/dagger.png.json",
    "lpc/spritesheets/weapon/slash/male/dagger_brown.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash/male/dagger_brown.png",
    "lpc/spritesheets/weapon/slash/male/dagger_brown.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash/male/dagger_brown.png.json",
    "lpc/spritesheets/weapon/slash/male/warhammer.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash/male/warhammer.png",
    "lpc/spritesheets/weapon/slash/male/warhammer.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash/male/warhammer.png.json",
    "lpc/spritesheets/weapon/slash_oversize/female/flail.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/female/flail.png",
    "lpc/spritesheets/weapon/slash_oversize/female/flail.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/female/flail.png.json",
    "lpc/spritesheets/weapon/slash_oversize/female/halberd.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/female/halberd.png",
    "lpc/spritesheets/weapon/slash_oversize/female/halberd.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/female/halberd.png.json",
    "lpc/spritesheets/weapon/slash_oversize/female/universal/flail.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/female/universal/flail.png",
    "lpc/spritesheets/weapon/slash_oversize/female/universal/flail.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/female/universal/flail.png.json",
    "lpc/spritesheets/weapon/slash_oversize/female/universal/halberd.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/female/universal/halberd.png",
    "lpc/spritesheets/weapon/slash_oversize/female/universal/halberd.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/female/universal/halberd.png.json",
    "lpc/spritesheets/weapon/slash_oversize/female/universal/waraxe.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/female/universal/waraxe.png",
    "lpc/spritesheets/weapon/slash_oversize/female/universal/waraxe.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/female/universal/waraxe.png.json",
    "lpc/spritesheets/weapon/slash_oversize/female/waraxe.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/female/waraxe.png",
    "lpc/spritesheets/weapon/slash_oversize/female/waraxe.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/female/waraxe.png.json",
    "lpc/spritesheets/weapon/slash_oversize/male/flail.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/male/flail.png",
    "lpc/spritesheets/weapon/slash_oversize/male/flail.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/male/flail.png.json",
    "lpc/spritesheets/weapon/slash_oversize/male/halberd.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/male/halberd.png",
    "lpc/spritesheets/weapon/slash_oversize/male/halberd.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/male/halberd.png.json",
    "lpc/spritesheets/weapon/slash_oversize/male/universal/flail.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/male/universal/flail.png",
    "lpc/spritesheets/weapon/slash_oversize/male/universal/flail.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/male/universal/flail.png.json",
    "lpc/spritesheets/weapon/slash_oversize/male/universal/halberd.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/male/universal/halberd.png",
    "lpc/spritesheets/weapon/slash_oversize/male/universal/halberd.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/male/universal/halberd.png.json",
    "lpc/spritesheets/weapon/slash_oversize/male/universal/waraxe.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/male/universal/waraxe.png",
    "lpc/spritesheets/weapon/slash_oversize/male/universal/waraxe.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/male/universal/waraxe.png.json",
    "lpc/spritesheets/weapon/slash_oversize/male/waraxe.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/male/waraxe.png",
    "lpc/spritesheets/weapon/slash_oversize/male/waraxe.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize/male/waraxe.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/longsword.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/longsword.png",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/longsword.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/longsword.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/mace.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/mace.png",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/mace.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/mace.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/rapier.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/rapier.png",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/rapier.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/rapier.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/saber.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/saber.png",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/saber.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/saber.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/scythe.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/scythe.png",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/scythe.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/scythe.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/longsword.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/longsword.png",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/longsword.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/longsword.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/mace.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/mace.png",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/mace.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/mace.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/rapier.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/rapier.png",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/rapier.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/rapier.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/saber.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/saber.png",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/saber.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/saber.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/scythe.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/scythe.png",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/scythe.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/scythe.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/longsword.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/longsword.png",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/longsword.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/longsword.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/mace.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/mace.png",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/mace.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/mace.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/rapier.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/rapier.png",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/rapier.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/rapier.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/saber.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/saber.png",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/saber.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/saber.png.json",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/scythe.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/scythe.png",
    "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/scythe.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/scythe.png.json",
    "lpc/spritesheets/weapon/thrust/female/crossbow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/female/crossbow.png",
    "lpc/spritesheets/weapon/thrust/female/crossbow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/female/crossbow.png.json",
    "lpc/spritesheets/weapon/thrust/female/simple_staff.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/female/simple_staff.png",
    "lpc/spritesheets/weapon/thrust/female/simple_staff.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/female/simple_staff.png.json",
    "lpc/spritesheets/weapon/thrust/female/spear_2.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/female/spear_2.png",
    "lpc/spritesheets/weapon/thrust/female/spear_2.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/female/spear_2.png.json",
    "lpc/spritesheets/weapon/thrust/female/spear_black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/female/spear_black.png",
    "lpc/spritesheets/weapon/thrust/female/spear_black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/female/spear_black.png.json",
    "lpc/spritesheets/weapon/thrust/female/spear_green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/female/spear_green.png",
    "lpc/spritesheets/weapon/thrust/female/spear_green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/female/spear_green.png.json",
    "lpc/spritesheets/weapon/thrust/female/spear_metal.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/female/spear_metal.png",
    "lpc/spritesheets/weapon/thrust/female/spear_metal.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/female/spear_metal.png.json",
    "lpc/spritesheets/weapon/thrust/female/spear_purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/female/spear_purple.png",
    "lpc/spritesheets/weapon/thrust/female/spear_purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/female/spear_purple.png.json",
    "lpc/spritesheets/weapon/thrust/male/crossbow.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/male/crossbow.png",
    "lpc/spritesheets/weapon/thrust/male/crossbow.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/male/crossbow.png.json",
    "lpc/spritesheets/weapon/thrust/male/simple_staff.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/male/simple_staff.png",
    "lpc/spritesheets/weapon/thrust/male/simple_staff.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/male/simple_staff.png.json",
    "lpc/spritesheets/weapon/thrust/male/spear_2.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/male/spear_2.png",
    "lpc/spritesheets/weapon/thrust/male/spear_2.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/male/spear_2.png.json",
    "lpc/spritesheets/weapon/thrust/male/spear_black.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/male/spear_black.png",
    "lpc/spritesheets/weapon/thrust/male/spear_black.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/male/spear_black.png.json",
    "lpc/spritesheets/weapon/thrust/male/spear_green.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/male/spear_green.png",
    "lpc/spritesheets/weapon/thrust/male/spear_green.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/male/spear_green.png.json",
    "lpc/spritesheets/weapon/thrust/male/spear_metal.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/male/spear_metal.png",
    "lpc/spritesheets/weapon/thrust/male/spear_metal.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/male/spear_metal.png.json",
    "lpc/spritesheets/weapon/thrust/male/spear_purple.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/male/spear_purple.png",
    "lpc/spritesheets/weapon/thrust/male/spear_purple.png.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/lpc/spritesheets/weapon/thrust/male/spear_purple.png.json",
    "mana.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/mana.mp3",
    "map-atlas.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/map-atlas.json",
    "map-atlas.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/map-atlas.png",
    "map_location.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/map_location.ogg",
    "maps/templates/caves.tmj": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/templates/caves.tmj",
    "maps/templates/geo.tmj": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/templates/geo.tmj",
    "maps/templates/item.tmj": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/templates/item.tmj",
    "maps/templates/ruins.tmj": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/templates/ruins.tmj",
    "maps/templates/settlement.tmj": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/templates/settlement.tmj",
    "maps/tilesets/authored-terrain.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/authored-terrain.tsx",
    "maps/tilesets/beach-desert.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/beach-desert.tsx",
    "maps/tilesets/bonecaller-stones.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/bonecaller-stones.json",
    "maps/tilesets/build_atlas.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/build_atlas.tsx",
    "maps/tilesets/container.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/container.tsx",
    "maps/tilesets/cottage.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/cottage.tsx",
    "maps/tilesets/decorations-medieval.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/decorations-medieval.tsx",
    "maps/tilesets/fence_medieval.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/fence_medieval.tsx",
    "maps/tilesets/floors.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/floors.tsx",
    "maps/tilesets/forest-dirt.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/forest-dirt.tsx",
    "maps/tilesets/forest-grass.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/forest-grass.tsx",
    "maps/tilesets/furniture-blonde-wood.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/furniture-blonde-wood.tsx",
    "maps/tilesets/jungle-ruins.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/jungle-ruins.tsx",
    "maps/tilesets/lpc-flowers-plants-fungi-wood.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/lpc-flowers-plants-fungi-wood.tsx",
    "maps/tilesets/lpc-terrain.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/lpc-terrain.tsx",
    "maps/tilesets/map-atlas.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/map-atlas.tsx",
    "maps/tilesets/mountains-v6.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/mountains-v6.tsx",
    "maps/tilesets/ore.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/ore.tsx",
    "maps/tilesets/plants.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/plants.tsx",
    "maps/tilesets/roofs.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/roofs.tsx",
    "maps/tilesets/walls.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/walls.tsx",
    "maps/tilesets/walls2.tsx": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/maps/tilesets/walls2.tsx",
    "mountains-v6.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/mountains-v6.json",
    "mountains-v6.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/mountains-v6.png",
    "ore.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/ore.json",
    "ore.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/ore.png",
    "overworld-day-noises.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/overworld-day-noises.ogg",
    "overworld-night-noises.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/overworld-night-noises.ogg",
    "overworld1.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/overworld1.ogg",
    "plants.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/plants.json",
    "plants.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/plants.png",
    "powerup.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/powerup.mp3",
    "reddit.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/reddit.png",
    "roofs.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/roofs.json",
    "roofs.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/roofs.png",
    "samsara_cropped.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/samsara_cropped.png",
    "shoot.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/shoot.ogg",
    "shotgun.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/shotgun.mp3",
    "stairs-icon.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/stairs-icon.json",
    "stairs-icon.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/stairs-icon.png",
    "strike1.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/strike1.ogg",
    "strike2.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/strike2.ogg",
    "swamp/0.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/swamp/0.ogg",
    "swamp/1.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/swamp/1.ogg",
    "swordswing.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/swordswing.ogg",
    "thatched-roof.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/thatched-roof.png",
    "to_battle.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/to_battle.ogg",
    "tree_creak.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/tree_creak.ogg",
    "tree_fall.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/tree_fall.ogg",
    "visitor_arrives.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/visitor_arrives.ogg",
    "walls.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/walls.json",
    "walls.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/walls.png",
    "walls2.json": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/walls2.json",
    "walls2.png": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/walls2.png",
    "wave_starting.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/wave_starting.ogg",
    "wheel_select.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/wheel_select.ogg",
    "woodhit.ogg": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/woodhit.ogg",
    "zombie/attack/1.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/attack/1.mp3",
    "zombie/attack/2.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/attack/2.mp3",
    "zombie/attack/3.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/attack/3.mp3",
    "zombie/attack/4.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/attack/4.mp3",
    "zombie/attack/5.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/attack/5.mp3",
    "zombie/attack/6.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/attack/6.mp3",
    "zombie/attack/7.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/attack/7.mp3",
    "zombie/death/1.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/death/1.mp3",
    "zombie/death/2.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/death/2.mp3",
    "zombie/death/3.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/death/3.mp3",
    "zombie/death/4.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/death/4.mp3",
    "zombie/death/5.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/death/5.mp3",
    "zombie/death/6.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/death/6.mp3",
    "zombie/detect/1.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/detect/1.mp3",
    "zombie/detect/2.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/detect/2.mp3",
    "zombie/detect/3.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/detect/3.mp3",
    "zombie/detect/4.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/detect/4.mp3",
    "zombie/detect/5.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/detect/5.mp3",
    "zombie/hit/1.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/hit/1.mp3",
    "zombie/hit/2.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/hit/2.mp3",
    "zombie/hit/3.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/hit/3.mp3",
    "zombie/hit/4.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/hit/4.mp3",
    "zombie/hit/5.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/hit/5.mp3",
    "zombie/hit/6.mp3": "content/d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470/zombie/hit/6.mp3"
  },
  "creatures": {
    "lpc-chicken": {
      "template": "chicken"
    },
    "lpc-viper": {
      "template": "snake"
    },
    "rage-slime": {
      "template": "snake"
    },
    "thistle": {
      "template": "rabbit"
    },
    "wild-hare": {
      "template": "rabbit"
    }
  },
  "itemDrops": {
    "armor-leather": [
      {
        "itemType": {
          "class": "resource",
          "color": "gray",
          "type": "shard-metal"
        },
        "quantity": 3
      }
    ],
    "armor-legion": [
      {
        "itemType": {
          "class": "resource",
          "color": "gray",
          "type": "shard-metal"
        },
        "quantity": 2
      }
    ],
    "armor-plate": [
      {
        "itemType": {
          "class": "resource",
          "color": "gray",
          "type": "shard-metal"
        },
        "quantity": 3
      }
    ],
    "axe": [
      {
        "itemType": {
          "class": "resource",
          "color": "gray",
          "type": "shard-metal"
        },
        "quantity": 2
      }
    ],
    "dagger": [
      {
        "itemType": {
          "class": "resource",
          "color": "gray",
          "type": "shard-metal"
        },
        "quantity": 1
      }
    ],
    "spear": [
      {
        "itemType": {
          "class": "resource",
          "color": "gray",
          "type": "shard-metal"
        },
        "quantity": 1
      }
    ]
  },
  "items": {
    "all": [
      "armor-leather",
      "armor-legion",
      "armor-plate",
      "arrow",
      "axe",
      "bauldron",
      "blouse",
      "blouse_longsleeve",
      "boots",
      "bow",
      "campfire",
      "cape-solid",
      "cape-tattered",
      "cape-trimmed",
      "castlekey",
      "chest-wood",
      "coal",
      "copper",
      "corset",
      "crossbow",
      "dagger",
      "door-wood",
      "drumstick",
      "feather",
      "flail",
      "floor-cobble",
      "floor-stone",
      "floor-wood",
      "flower-single-blue",
      "flower-single-purple",
      "flower-single-red",
      "flower-single-yellow",
      "gold",
      "halberd",
      "hide",
      "iron",
      "legion",
      "longsleeve",
      "longsleeve_laced",
      "longsword",
      "mace",
      "metal-bar-copper",
      "metal-bar-gold",
      "metal-bar-iron",
      "metal-bar-silver",
      "mushroom-purple",
      "mushroom-red",
      "mushroom-yellow",
      "none",
      "pantaloons",
      "pants",
      "pants-armor",
      "planks",
      "railing-wood",
      "rapier",
      "roof-wood",
      "rope",
      "saber",
      "sandals",
      "scoop_shirt",
      "scythe",
      "seed",
      "grass-seed",
      "shard-metal",
      "shield-crusader",
      "shield-kite",
      "shield-kite_blue",
      "shield-kite_gray",
      "shield-kite_green",
      "shield-kite_red",
      "shield-round",
      "shield-spartan",
      "shoes",
      "shoes-armor",
      "silver",
      "skirts",
      "sleeveless",
      "sleeveless_laced",
      "sleeveless_striped",
      "slippers",
      "snare-rabbit",
      "spear",
      "staff",
      "stick",
      "stool-small",
      "straw",
      "table-large-rough",
      "table-mid-round",
      "tanktop",
      "torch",
      "tunic",
      "wall-wood",
      "wall2-wood",
      "wall-stone",
      "waraxe",
      "warhammer",
      "web",
      "webAmmo",
      "wood",
      "ember-charge",
      "spider-silk",
      "barrel1",
      "stackedBags",
      "stool1",
      "table-mid-rough",
      "strawBed",
      "strawBedSmall",
      "iron-pickaxe",
      "stairs",
      "floor-opening",
      "timber-frame-wall",
      "thatch-roof",
      "window-frame",
      "chimney-stack",
      "dormer-window",
      "grove-oak-a",
      "grove-oak-b",
      "grove-spruce-a",
      "grove-spruce-b",
      "grove-round-a",
      "grove-round-b",
      "grove-low-a",
      "grove-low-b",
      "meadow-grass-a",
      "meadow-grass-b",
      "meadow-grass-c",
      "meadow-grass-d",
      "meadow-grass-e",
      "meadow-grass-f",
      "meadow-sprout",
      "hatch-wood",
      "castle-footing",
      "castle-wall",
      "castle-merlons",
      "arrow-slit",
      "tower-render"
    ],
    "characteristics": {
      "arrow": {
        "isAmmo": true,
        "stackable": true,
        "unsellable": true
      },
      "arrow-slit": {
        "buildType": "wall",
        "buildable": true,
        "exclusiveReadiness": true,
        "ornament": "arrow-slit",
        "stackable": true,
        "useHasWorldEffect": true
      },
      "barrel1": {
        "buildable": true,
        "readyable": true,
        "unbuyable": true
      },
      "campfire": {
        "placementAction": "use",
        "placementRange": 1,
        "useHasWorldEffect": true,
        "useable": true
      },
      "castle-footing": {
        "buildType": "wall",
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": true,
        "useHasWorldEffect": true
      },
      "castle-merlons": {
        "buildType": "wall",
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": true,
        "useHasWorldEffect": true
      },
      "castle-wall": {
        "buildType": "wall",
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": true,
        "useHasWorldEffect": true
      },
      "castlekey": {
        "stackable": true
      },
      "chest-wood": {
        "buildType": "entity",
        "buildable": true,
        "exclusiveReadiness": true,
        "placementAction": "build",
        "placementRange": 1,
        "stackable": false,
        "useHasWorldEffect": true
      },
      "chimney-stack": {
        "buildType": "roof",
        "buildable": true,
        "exclusiveReadiness": true,
        "ornament": "chimney",
        "stackable": true,
        "useHasWorldEffect": true
      },
      "crossbow": {
        "unbuyable": true
      },
      "door-wood": {
        "buildType": "entity",
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": false,
        "useHasWorldEffect": true
      },
      "dormer-window": {
        "buildType": "roof",
        "buildable": true,
        "exclusiveReadiness": true,
        "ornament": "dormer",
        "stackable": true,
        "useHasWorldEffect": true
      },
      "drumstick": {
        "primaryUseable": true,
        "unbuyable": true,
        "useHasWorldEffect": true,
        "useable": true
      },
      "ember-charge": {
        "isAmmo": true,
        "stackable": true,
        "unbuyable": true,
        "unsellable": true
      },
      "feather": {
        "unbuyable": true,
        "unsellable": true
      },
      "flail": {
        "unbuyable": true
      },
      "floor-cobble": {
        "buildType": "floor",
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": true,
        "useHasWorldEffect": true
      },
      "floor-opening": {
        "buildType": "entity",
        "buildable": false,
        "stackable": false
      },
      "floor-stone": {
        "buildType": "floor",
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": true,
        "useHasWorldEffect": true
      },
      "floor-wood": {
        "buildType": "floor",
        "buildable": true,
        "campfireFuel": true,
        "exclusiveReadiness": true,
        "stackable": true,
        "useHasWorldEffect": true
      },
      "flower-single-blue": {
        "unbuyable": true,
        "unsellable": true
      },
      "flower-single-purple": {
        "unbuyable": true,
        "unsellable": true
      },
      "flower-single-red": {
        "unbuyable": true,
        "unsellable": true
      },
      "flower-single-yellow": {
        "unbuyable": true,
        "unsellable": true
      },
      "grass-seed": {
        "noAutoReady": true,
        "placementAction": "use",
        "placementRange": 1,
        "unbuyable": true,
        "unsellable": true,
        "useHasWorldEffect": true,
        "useable": true
      },
      "grove-low-a": {
        "buildType": "entity",
        "buildable": true,
        "placementAction": "build",
        "placementRange": 1,
        "stackable": true
      },
      "grove-low-b": {
        "buildType": "entity",
        "buildable": true,
        "placementAction": "build",
        "placementRange": 1,
        "stackable": true
      },
      "grove-oak-a": {
        "buildType": "entity",
        "buildable": true,
        "placementAction": "build",
        "placementRange": 1,
        "stackable": true
      },
      "grove-oak-b": {
        "buildType": "entity",
        "buildable": true,
        "placementAction": "build",
        "placementRange": 1,
        "stackable": true
      },
      "grove-round-a": {
        "buildType": "entity",
        "buildable": true,
        "placementAction": "build",
        "placementRange": 1,
        "stackable": true
      },
      "grove-round-b": {
        "buildType": "entity",
        "buildable": true,
        "placementAction": "build",
        "placementRange": 1,
        "stackable": true
      },
      "grove-spruce-a": {
        "buildType": "entity",
        "buildable": true,
        "placementAction": "build",
        "placementRange": 1,
        "stackable": true
      },
      "grove-spruce-b": {
        "buildType": "entity",
        "buildable": true,
        "placementAction": "build",
        "placementRange": 1,
        "stackable": true
      },
      "halberd": {
        "unbuyable": true
      },
      "hatch-wood": {
        "buildType": "entity",
        "buildable": false,
        "stackable": true
      },
      "hide": {
        "unbuyable": true
      },
      "longsword": {
        "unbuyable": true
      },
      "mace": {
        "unbuyable": true
      },
      "meadow-grass-a": {
        "buildType": "entity",
        "buildable": true,
        "placementAction": "build",
        "placementRange": 1,
        "stackable": true
      },
      "meadow-grass-b": {
        "buildType": "entity",
        "buildable": true,
        "placementAction": "build",
        "placementRange": 1,
        "stackable": true
      },
      "meadow-grass-c": {
        "buildType": "entity",
        "buildable": true,
        "placementAction": "build",
        "placementRange": 1,
        "stackable": true
      },
      "meadow-grass-d": {
        "buildType": "entity",
        "buildable": true,
        "placementAction": "build",
        "placementRange": 1,
        "stackable": true
      },
      "meadow-grass-e": {
        "buildType": "entity",
        "buildable": true,
        "placementAction": "build",
        "placementRange": 1,
        "stackable": true
      },
      "meadow-grass-f": {
        "buildType": "entity",
        "buildable": true,
        "placementAction": "build",
        "placementRange": 1,
        "stackable": true
      },
      "meadow-sprout": {
        "buildType": "entity",
        "buildable": true,
        "placementAction": "build",
        "placementRange": 1,
        "stackable": true
      },
      "mushroom-purple": {
        "unbuyable": true,
        "useHasWorldEffect": true,
        "useable": true
      },
      "mushroom-red": {
        "unbuyable": true,
        "useHasWorldEffect": true,
        "useable": true
      },
      "mushroom-yellow": {
        "unbuyable": true,
        "useHasWorldEffect": true,
        "useable": true
      },
      "none": {
        "hasDurability": false
      },
      "railing-wood": {
        "buildType": "wall",
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": true,
        "useHasWorldEffect": true
      },
      "rapier": {
        "unbuyable": true
      },
      "roof-wood": {
        "buildType": "roof",
        "buildable": true,
        "campfireFuel": true,
        "exclusiveReadiness": true,
        "stackable": true,
        "useHasWorldEffect": true
      },
      "rope": {
        "unbuyable": true
      },
      "saber": {
        "unbuyable": true
      },
      "scythe": {
        "unbuyable": true
      },
      "seed": {
        "noAutoReady": true,
        "placementAction": "use",
        "placementRange": 1,
        "unbuyable": true,
        "unsellable": true,
        "useHasWorldEffect": true,
        "useable": true
      },
      "snare-rabbit": {
        "useHasWorldEffect": true,
        "useable": true
      },
      "spider-silk": {
        "stackable": true,
        "unbuyable": true,
        "unsellable": true
      },
      "stackedBags": {
        "buildable": true,
        "readyable": true,
        "unbuyable": true
      },
      "staff": {
        "unbuyable": true
      },
      "stairs": {
        "buildType": "entity",
        "buildable": true,
        "deactivateAfterPlacement": true,
        "exclusiveReadiness": true,
        "placementAction": "build",
        "stackable": false,
        "useHasWorldEffect": true
      },
      "stool-small": {
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": false,
        "useHasWorldEffect": true
      },
      "stool1": {
        "buildable": true,
        "readyable": true,
        "unbuyable": true,
        "useable": false
      },
      "straw": {
        "unbuyable": true,
        "unsellable": true
      },
      "strawBed": {
        "buildable": true,
        "readyable": true,
        "unbuyable": true,
        "useable": false
      },
      "strawBedSmall": {
        "buildable": true,
        "readyable": true,
        "unbuyable": true,
        "useable": false
      },
      "table-large-rough": {
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": false,
        "useHasWorldEffect": true,
        "useable": false
      },
      "table-mid-rough": {
        "buildable": true,
        "readyable": true,
        "unbuyable": true,
        "useable": false
      },
      "table-mid-round": {
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": false,
        "useHasWorldEffect": true,
        "useable": false
      },
      "thatch-roof": {
        "buildType": "roof",
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": true,
        "useHasWorldEffect": true
      },
      "timber-frame-wall": {
        "buildType": "wall",
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": true,
        "useHasWorldEffect": true
      },
      "torch": {
        "useable": true
      },
      "tower-render": {
        "buildType": "wall",
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": true,
        "useHasWorldEffect": true
      },
      "wall-stone": {
        "buildType": "wall",
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": true,
        "useHasWorldEffect": true
      },
      "wall-wood": {
        "buildType": "wall",
        "buildable": true,
        "campfireFuel": true,
        "exclusiveReadiness": true,
        "stackable": true,
        "useHasWorldEffect": true
      },
      "wall2-wood": {
        "buildType": "wall",
        "buildable": true,
        "exclusiveReadiness": true,
        "stackable": true,
        "useHasWorldEffect": true
      },
      "waraxe": {
        "unbuyable": true
      },
      "warhammer": {
        "unbuyable": true
      },
      "window-frame": {
        "buildType": "wall",
        "buildable": true,
        "exclusiveReadiness": true,
        "ornament": "window",
        "stackable": true,
        "useHasWorldEffect": true
      },
      "wood": {
        "campfireFuel": true,
        "exclusiveReadiness": true,
        "primaryUseable": true,
        "unbuyable": true
      }
    },
    "classCharacteristics": {
      "armor": {
        "equippable": true,
        "exclusiveReadiness": true,
        "readyable": true
      },
      "bauldron": {
        "equippable": true,
        "exclusiveReadiness": true,
        "readyable": true
      },
      "cape": {
        "equippable": true,
        "exclusiveReadiness": true,
        "readyable": true
      },
      "key": {
        "exclusiveReadiness": true,
        "readyable": true
      },
      "pants": {
        "equippable": true,
        "exclusiveReadiness": true,
        "readyable": true
      },
      "resource": {
        "disallowedClassesOnActive": [
          "weapon",
          "structure"
        ],
        "exclusiveReadiness": true,
        "readyable": true,
        "stackable": true
      },
      "shield": {
        "equippable": true,
        "exclusiveReadiness": true,
        "readyable": true
      },
      "shirt": {
        "equippable": true,
        "exclusiveReadiness": true,
        "readyable": true
      },
      "shoes": {
        "equippable": true,
        "exclusiveReadiness": true,
        "readyable": true
      },
      "structure": {
        "disallowedClassesOnActive": [
          "weapon",
          "resource"
        ],
        "exclusiveReadiness": true,
        "readyable": true,
        "stableAngleOnDrop": true,
        "unbuyable": true
      },
      "weapon": {
        "disallowedClassesOnActive": [
          "resource",
          "structure"
        ],
        "equippable": true,
        "exclusiveReadiness": true,
        "hasDurability": true,
        "readyable": true
      }
    },
    "classToTypes": {
      "armor": [
        "armor-leather",
        "armor-legion",
        "armor-plate"
      ],
      "bauldron": [
        "bauldron"
      ],
      "cape": [
        "cape-solid",
        "cape-tattered",
        "cape-trimmed"
      ],
      "key": [
        "castlekey"
      ],
      "pants": [
        "legion",
        "pantaloons",
        "pants",
        "pants-armor",
        "skirts"
      ],
      "resource": [
        "arrow",
        "webAmmo",
        "ember-charge",
        "coal",
        "copper",
        "gold",
        "iron",
        "silver",
        "drumstick",
        "feather",
        "planks",
        "rope",
        "stick",
        "spider-silk",
        "flower-single-blue",
        "flower-single-purple",
        "flower-single-red",
        "flower-single-yellow",
        "hide",
        "metal-bar-copper",
        "metal-bar-gold",
        "metal-bar-iron",
        "metal-bar-silver",
        "mushroom-purple",
        "mushroom-red",
        "mushroom-yellow",
        "seed",
        "shard-metal",
        "straw",
        "torch",
        "wood",
        "shard-metal",
        "grass-seed"
      ],
      "shield": [
        "shield-crusader",
        "shield-kite",
        "shield-kite_blue",
        "shield-kite_gray",
        "shield-kite_green",
        "shield-kite_red",
        "shield-round",
        "shield-spartan"
      ],
      "shirt": [
        "blouse",
        "blouse_longsleeve",
        "corset",
        "longsleeve",
        "longsleeve_laced",
        "scoop_shirt",
        "sleeveless",
        "sleeveless_laced",
        "sleeveless_striped",
        "tanktop",
        "tunic"
      ],
      "shoes": [
        "boots",
        "sandals",
        "shoes",
        "shoes-armor",
        "slippers"
      ],
      "structure": [
        "campfire",
        "snare-rabbit",
        "stool-small",
        "table-large-rough",
        "table-mid-round",
        "barrel1",
        "stackedBags",
        "stool1",
        "table-mid-rough",
        "strawBed",
        "strawBedSmall",
        "chest-wood",
        "door-wood",
        "floor-wood",
        "floor-stone",
        "floor-cobble",
        "roof-wood",
        "wall-wood",
        "wall2-wood",
        "wall-stone",
        "railing-wood",
        "stairs",
        "floor-opening",
        "hatch-wood",
        "timber-frame-wall",
        "thatch-roof",
        "window-frame",
        "chimney-stack",
        "dormer-window",
        "grove-oak-a",
        "grove-oak-b",
        "grove-spruce-a",
        "grove-spruce-b",
        "grove-round-a",
        "grove-round-b",
        "grove-low-a",
        "grove-low-b",
        "meadow-grass-a",
        "meadow-grass-b",
        "meadow-grass-c",
        "meadow-grass-d",
        "meadow-grass-e",
        "meadow-grass-f",
        "meadow-sprout",
        "castle-footing",
        "castle-wall",
        "castle-merlons",
        "arrow-slit",
        "tower-render"
      ],
      "weapon": [
        "axe",
        "bow",
        "crossbow",
        "dagger",
        "flail",
        "halberd",
        "longsword",
        "mace",
        "none",
        "rapier",
        "saber",
        "scythe",
        "spear",
        "staff",
        "waraxe",
        "warhammer",
        "web",
        "iron-pickaxe"
      ]
    },
    "classes": [
      "armor",
      "bauldron",
      "cape",
      "key",
      "pants",
      "resource",
      "shield",
      "shirt",
      "shoes",
      "structure",
      "weapon"
    ],
    "metadata": {
      "armor-leather": [
        {
          "class": "armor",
          "color": "brown",
          "spriteId": null,
          "type": "armor-leather"
        }
      ],
      "armor-legion": [
        {
          "class": "armor",
          "color": "brown",
          "spriteId": null,
          "type": "armor-legion"
        }
      ],
      "arrow": [
        {
          "class": "resource",
          "color": "brown",
          "spriteId": null,
          "type": "arrow"
        }
      ],
      "arrow-slit": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:899",
          "type": "arrow-slit"
        }
      ],
      "barrel1": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "container:60",
          "type": "barrel1"
        }
      ],
      "bauldron": [
        {
          "class": "bauldron",
          "color": "brown",
          "spriteId": null,
          "type": "bauldron"
        }
      ],
      "campfire": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": null,
          "type": "campfire"
        }
      ],
      "castle-footing": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:824",
          "type": "castle-footing"
        }
      ],
      "castle-merlons": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:924",
          "type": "castle-merlons"
        }
      ],
      "castle-wall": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:872",
          "type": "castle-wall"
        }
      ],
      "castlekey": [
        {
          "class": "key",
          "color": "gold",
          "spriteId": null,
          "type": "castlekey"
        }
      ],
      "chest-wood": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "container:140",
          "type": "chest-wood"
        }
      ],
      "chimney-stack": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:421",
          "type": "chimney-stack"
        }
      ],
      "coal": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:161",
          "type": "coal"
        }
      ],
      "copper": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:180",
          "type": "copper"
        }
      ],
      "dagger": [
        {
          "class": "weapon",
          "color": "brown",
          "spriteId": null,
          "type": "dagger"
        },
        {
          "class": "weapon",
          "color": "metal",
          "spriteId": null,
          "type": "dagger"
        }
      ],
      "door-wood": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "fence_medieval:478",
          "type": "door-wood"
        }
      ],
      "dormer-window": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:424",
          "type": "dormer-window"
        }
      ],
      "drumstick": [
        {
          "class": "resource",
          "color": "brown",
          "spriteId": null,
          "type": "drumstick"
        }
      ],
      "ember-charge": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:180",
          "type": "ember-charge"
        }
      ],
      "feather": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:72",
          "type": "feather"
        }
      ],
      "floor-cobble": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "floors:225",
          "type": "floor-cobble"
        }
      ],
      "floor-opening": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:3",
          "type": "floor-opening"
        }
      ],
      "floor-stone": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "floors:129",
          "type": "floor-stone"
        }
      ],
      "floor-wood": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "floors:33",
          "type": "floor-wood"
        }
      ],
      "flower-single-blue": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "lpc-flowers-plants-fungi-wood:104",
          "type": "flower-single-blue"
        }
      ],
      "flower-single-purple": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "lpc-flowers-plants-fungi-wood:103",
          "type": "flower-single-purple"
        }
      ],
      "flower-single-red": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "lpc-flowers-plants-fungi-wood:105",
          "type": "flower-single-red"
        }
      ],
      "flower-single-yellow": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "lpc-flowers-plants-fungi-wood:106",
          "type": "flower-single-yellow"
        }
      ],
      "gold": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:182",
          "type": "gold"
        }
      ],
      "grass-seed": [
        {
          "class": "resource",
          "color": "na",
          "noGlint": true,
          "spriteId": "item-art-08bd1c8b4020c28035f1:1",
          "type": "grass-seed"
        }
      ],
      "grove-low-a": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-32902d50537ebad17e79:1",
          "type": "grove-low-a"
        }
      ],
      "grove-low-b": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-5902c8b486e89c8f8e57:1",
          "type": "grove-low-b"
        }
      ],
      "grove-oak-a": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-887e0636d4bbe2a4f448:1",
          "type": "grove-oak-a"
        }
      ],
      "grove-oak-b": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-f728e0bbaefbd1982b2d:1",
          "type": "grove-oak-b"
        }
      ],
      "grove-round-a": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-bb4afa7ce4e3c1ba55ba:1",
          "type": "grove-round-a"
        }
      ],
      "grove-round-b": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-e46e4dec4aea45bf9d8e:1",
          "type": "grove-round-b"
        }
      ],
      "grove-spruce-a": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-35c925e4db81912bfe38:1",
          "type": "grove-spruce-a"
        }
      ],
      "grove-spruce-b": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-99ea85dcdc93fac8db18:1",
          "type": "grove-spruce-b"
        }
      ],
      "hatch-wood": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "hatch-wood:1",
          "type": "hatch-wood"
        }
      ],
      "hide": [
        {
          "class": "resource",
          "color": "brown",
          "spriteId": null,
          "type": "hide"
        }
      ],
      "iron": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:179",
          "type": "iron"
        }
      ],
      "iron-pickaxe": [
        {
          "class": "weapon",
          "color": "na",
          "spriteId": "item-art-b1d5a86cbcd21ed656d3:1",
          "type": "iron-pickaxe"
        }
      ],
      "legion": [
        {
          "class": "pants",
          "color": "brown",
          "spriteId": null,
          "type": "legion"
        }
      ],
      "meadow-grass-a": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-ebdd046fea0f3ab21669:1",
          "type": "meadow-grass-a"
        }
      ],
      "meadow-grass-b": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-4d6c318ef966e097227a:1",
          "type": "meadow-grass-b"
        }
      ],
      "meadow-grass-c": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-721c3f8a8d4621a46f90:1",
          "type": "meadow-grass-c"
        }
      ],
      "meadow-grass-d": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-7fc02d2406eaa57e3be0:1",
          "type": "meadow-grass-d"
        }
      ],
      "meadow-grass-e": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-a7225776548a58ab4e04:1",
          "type": "meadow-grass-e"
        }
      ],
      "meadow-grass-f": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-d9ecaed5ff4485611809:1",
          "type": "meadow-grass-f"
        }
      ],
      "meadow-sprout": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-af19df691fc7aa944194:1",
          "type": "meadow-sprout"
        }
      ],
      "metal-bar-copper": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:180",
          "type": "metal-bar-copper"
        }
      ],
      "metal-bar-gold": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:182",
          "type": "metal-bar-gold"
        }
      ],
      "metal-bar-iron": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:179",
          "type": "metal-bar-iron"
        }
      ],
      "metal-bar-silver": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:181",
          "type": "metal-bar-silver"
        }
      ],
      "mushroom-purple": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "lpc-flowers-plants-fungi-wood:353",
          "type": "mushroom-purple"
        }
      ],
      "mushroom-red": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "lpc-flowers-plants-fungi-wood:355",
          "type": "mushroom-red"
        }
      ],
      "mushroom-yellow": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "lpc-flowers-plants-fungi-wood:354",
          "type": "mushroom-yellow"
        }
      ],
      "planks": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:25",
          "type": "planks"
        }
      ],
      "railing-wood": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "fence_medieval:1",
          "type": "railing-wood"
        }
      ],
      "roof-wood": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:807",
          "type": "roof-wood"
        }
      ],
      "rope": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:88",
          "type": "rope"
        }
      ],
      "seed": [
        {
          "class": "resource",
          "color": "na",
          "noGlint": true,
          "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
          "type": "seed"
        }
      ],
      "shard-metal": [
        {
          "class": "resource",
          "color": "gray",
          "type": "shard-metal"
        }
      ],
      "shield-crusader": [
        {
          "class": "shield",
          "color": "white",
          "spriteId": null,
          "type": "shield-crusader"
        }
      ],
      "shield-kite": [
        {
          "class": "shield",
          "color": "white",
          "spriteId": null,
          "type": "shield-kite"
        }
      ],
      "shield-round": [
        {
          "class": "shield",
          "color": "brown",
          "spriteId": null,
          "type": "shield-round"
        }
      ],
      "silver": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:181",
          "type": "silver"
        }
      ],
      "snare-rabbit": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "snare-rabbit.png",
          "type": "snare-rabbit"
        }
      ],
      "spider-silk": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:88",
          "type": "spider-silk"
        }
      ],
      "stackedBags": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "container:449",
          "type": "stackedBags"
        }
      ],
      "stairs": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "stairs-icon:1",
          "type": "stairs"
        }
      ],
      "stick": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:26",
          "type": "stick"
        }
      ],
      "stool-small": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "furniture-blonde-wood:126",
          "type": "stool-small"
        }
      ],
      "stool1": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "furniture-blond-wood:128",
          "type": "stool1"
        }
      ],
      "straw": [
        {
          "class": "resource",
          "color": "na",
          "noGlint": true,
          "spriteId": "item-art-b9ef00e25a4177065abd:1",
          "type": "straw"
        }
      ],
      "strawBed": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "build_atlas:684",
          "type": "strawBed"
        }
      ],
      "strawBedSmall": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "build_atlas:684",
          "type": "strawBedSmall"
        }
      ],
      "table-large-rough": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "furniture-blonde-wood:458",
          "type": "table-large-rough"
        }
      ],
      "table-mid-rough": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "furniture-blonde-wood:141",
          "type": "table-mid-rough"
        }
      ],
      "table-mid-round": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "furniture-blonde-wood:124",
          "type": "table-mid-round"
        }
      ],
      "thatch-roof": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:378",
          "type": "thatch-roof"
        }
      ],
      "timber-frame-wall": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:50",
          "type": "timber-frame-wall"
        }
      ],
      "torch": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": null,
          "type": "torch"
        }
      ],
      "tower-render": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:927",
          "type": "tower-render"
        }
      ],
      "wall-stone": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "walls2:53",
          "type": "wall-stone"
        }
      ],
      "wall-wood": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:643",
          "type": "wall-wood"
        }
      ],
      "wall2-wood": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "walls2:43",
          "type": "wall2-wood"
        }
      ],
      "web": [
        {
          "class": "weapon",
          "color": "white",
          "type": "web"
        }
      ],
      "webAmmo": [
        {
          "class": "resource",
          "color": "white",
          "type": "webAmmo"
        }
      ],
      "window-frame": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:419",
          "type": "window-frame"
        }
      ],
      "wood": [
        {
          "class": "resource",
          "color": "brown",
          "noGlint": true,
          "spriteId": null,
          "type": "wood"
        }
      ]
    },
    "protection": {
      "armor": {
        "armor-leather": 0.1,
        "armor-legion": 0.2,
        "armor-plate": 0.3
      },
      "bauldron": {
        "bauldron": 0.05
      },
      "cape": {},
      "key": {},
      "pants": {
        "legion": 0.1,
        "pantaloons": 0.01,
        "pants-armor": 0.1,
        "skirts": 0.01
      },
      "resource": {},
      "shield": {
        "shield-crusader": 0.2,
        "shield-kite": 0.2,
        "shield-kite_blue": 0.2,
        "shield-kite_gray": 0.2,
        "shield-kite_green": 0.2,
        "shield-kite_red": 0.2,
        "shield-round": 0.1,
        "shield-spartan": 0.15
      },
      "shirt": {
        "blouse": 0.01,
        "blouse_longsleeve": 0.01,
        "corset": 0.01,
        "longsleeve": 0.01,
        "longsleeve_laced": 0.01,
        "scoop_shirt": 0.01,
        "sleeveless": 0.01,
        "sleeveless_laced": 0.01,
        "sleeveless_striped": 0.01,
        "tanktop": 0.01,
        "tunic": 0.01
      },
      "shoes": {
        "boots": 0.01,
        "sandals": 0.01,
        "shoes": 0.01,
        "shoes-armor": 0.1,
        "slippers": 0.01
      },
      "structure": {},
      "weapon": {}
    },
    "recipes": [
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:179",
              "type": "iron"
            },
            "quantity": 5
          }
        ],
        "itemTypeMeta": {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:179",
          "type": "metal-bar-iron"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:181",
              "type": "silver"
            },
            "quantity": 5
          }
        ],
        "itemTypeMeta": {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:181",
          "type": "metal-bar-silver"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:180",
              "type": "copper"
            },
            "quantity": 5
          }
        ],
        "itemTypeMeta": {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:180",
          "type": "metal-bar-copper"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:182",
              "type": "gold"
            },
            "quantity": 5
          }
        ],
        "itemTypeMeta": {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:182",
          "type": "metal-bar-gold"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:179",
              "type": "iron"
            },
            "quantity": 1
          }
        ],
        "itemTypeMeta": {
          "class": "resource",
          "color": "gray",
          "type": "shard-metal"
        },
        "quantity": 5
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "brown",
              "noGlint": true,
              "spriteId": null,
              "type": "wood"
            },
            "quantity": 1
          }
        ],
        "itemTypeMeta": {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:26",
          "type": "stick"
        },
        "quantity": 5
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "noGlint": true,
              "spriteId": "item-art-b9ef00e25a4177065abd:1",
              "type": "straw"
            },
            "quantity": 3
          }
        ],
        "itemTypeMeta": {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:88",
          "type": "rope"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "brown",
              "noGlint": true,
              "spriteId": null,
              "type": "wood"
            },
            "quantity": 1
          }
        ],
        "itemTypeMeta": {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:25",
          "type": "planks"
        },
        "quantity": 4
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:25",
              "type": "planks"
            },
            "quantity": 3
          }
        ],
        "itemTypeMeta": {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:643",
          "type": "wall-wood"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:25",
              "type": "planks"
            },
            "quantity": 3
          }
        ],
        "itemTypeMeta": {
          "class": "structure",
          "color": "na",
          "spriteId": "walls2:53",
          "type": "wall-stone"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:25",
              "type": "planks"
            },
            "quantity": 3
          }
        ],
        "itemTypeMeta": {
          "class": "structure",
          "color": "na",
          "spriteId": "floors:33",
          "type": "floor-wood"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:25",
              "type": "planks"
            },
            "quantity": 3
          }
        ],
        "itemTypeMeta": {
          "class": "structure",
          "color": "na",
          "spriteId": "fence_medieval:478",
          "type": "door-wood"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:25",
              "type": "planks"
            },
            "quantity": 5
          }
        ],
        "itemTypeMeta": {
          "class": "structure",
          "color": "na",
          "spriteId": "container:140",
          "type": "chest-wood"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:25",
              "type": "planks"
            },
            "quantity": 4
          }
        ],
        "itemTypeMeta": {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:807",
          "type": "roof-wood"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "brown",
              "noGlint": true,
              "spriteId": null,
              "type": "wood"
            },
            "quantity": 2
          }
        ],
        "itemTypeMeta": {
          "class": "structure",
          "color": "na",
          "spriteId": null,
          "type": "campfire"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:26",
              "type": "stick"
            },
            "quantity": 5
          },
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "gray",
              "type": "shard-metal"
            },
            "quantity": 5
          }
        ],
        "itemTypeMeta": {
          "class": "weapon",
          "color": "metal",
          "spriteId": null,
          "type": "dagger"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:26",
              "type": "stick"
            },
            "quantity": 5
          }
        ],
        "itemTypeMeta": {
          "class": "weapon",
          "color": "brown",
          "spriteId": null,
          "type": "dagger"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:26",
              "type": "stick"
            },
            "quantity": 2
          },
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:72",
              "type": "feather"
            },
            "quantity": 3
          },
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "gray",
              "type": "shard-metal"
            },
            "quantity": 2
          }
        ],
        "itemTypeMeta": {
          "class": "resource",
          "color": "brown",
          "spriteId": null,
          "type": "arrow"
        },
        "quantity": 10
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:179",
              "type": "metal-bar-iron"
            },
            "quantity": 3
          },
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:26",
              "type": "stick"
            },
            "quantity": 2
          }
        ],
        "itemTypeMeta": {
          "class": "weapon",
          "color": "metal",
          "type": "axe"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:26",
              "type": "stick"
            },
            "quantity": 5
          },
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "gray",
              "type": "shard-metal"
            },
            "quantity": 3
          }
        ],
        "itemTypeMeta": {
          "class": "weapon",
          "color": "na",
          "spriteId": "item-art-b1d5a86cbcd21ed656d3:1",
          "type": "iron-pickaxe"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "brown",
              "noGlint": true,
              "spriteId": null,
              "type": "wood"
            },
            "quantity": 10
          },
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "gray",
              "type": "shard-metal"
            },
            "quantity": 3
          }
        ],
        "itemTypeMeta": {
          "class": "weapon",
          "color": "brown",
          "type": "spear"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:179",
              "type": "metal-bar-iron"
            },
            "quantity": 3
          },
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:25",
              "type": "planks"
            },
            "quantity": 1
          }
        ],
        "itemTypeMeta": {
          "class": "weapon",
          "color": "metal",
          "type": "longsword"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:179",
              "type": "metal-bar-iron"
            },
            "quantity": 4
          },
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:25",
              "type": "planks"
            },
            "quantity": 2
          }
        ],
        "itemTypeMeta": {
          "class": "weapon",
          "color": "metal",
          "type": "waraxe"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:26",
              "type": "stick"
            },
            "quantity": 15
          },
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "gray",
              "type": "shard-metal"
            },
            "quantity": 5
          },
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:88",
              "type": "rope"
            },
            "quantity": 2
          }
        ],
        "itemTypeMeta": {
          "class": "weapon",
          "color": "brown",
          "type": "bow"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:26",
              "type": "stick"
            },
            "quantity": 3
          },
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:88",
              "type": "rope"
            },
            "quantity": 1
          }
        ],
        "itemTypeMeta": {
          "class": "structure",
          "color": "na",
          "spriteId": "snare-rabbit.png",
          "type": "snare-rabbit"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:180",
              "type": "copper"
            },
            "quantity": 1
          },
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:161",
              "type": "coal"
            },
            "quantity": 2
          },
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:88",
              "type": "spider-silk"
            },
            "quantity": 1
          }
        ],
        "itemTypeMeta": {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:180",
          "type": "ember-charge"
        },
        "quantity": 9
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:25",
              "type": "planks"
            },
            "quantity": 4
          }
        ],
        "itemTypeMeta": {
          "class": "structure",
          "color": "na",
          "spriteId": "stairs-icon:1",
          "type": "stairs"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:25",
              "type": "planks"
            },
            "quantity": 4
          }
        ],
        "itemTypeMeta": {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:378",
          "type": "thatch-roof"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:25",
              "type": "planks"
            },
            "quantity": 3
          }
        ],
        "itemTypeMeta": {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:50",
          "type": "timber-frame-wall"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:25",
              "type": "planks"
            },
            "quantity": 2
          }
        ],
        "itemTypeMeta": {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:419",
          "type": "window-frame"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:25",
              "type": "planks"
            },
            "quantity": 3
          }
        ],
        "itemTypeMeta": {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:421",
          "type": "chimney-stack"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:25",
              "type": "planks"
            },
            "quantity": 2
          }
        ],
        "itemTypeMeta": {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:424",
          "type": "dormer-window"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:25",
              "type": "planks"
            },
            "quantity": 2
          }
        ],
        "itemTypeMeta": {
          "class": "structure",
          "color": "na",
          "spriteId": "hatch-wood:1",
          "type": "hatch-wood"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:25",
              "type": "planks"
            },
            "quantity": 5
          }
        ],
        "itemTypeMeta": {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:824",
          "type": "castle-footing"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:25",
              "type": "planks"
            },
            "quantity": 5
          }
        ],
        "itemTypeMeta": {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:872",
          "type": "castle-wall"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:25",
              "type": "planks"
            },
            "quantity": 3
          }
        ],
        "itemTypeMeta": {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:924",
          "type": "castle-merlons"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:25",
              "type": "planks"
            },
            "quantity": 2
          }
        ],
        "itemTypeMeta": {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:899",
          "type": "arrow-slit"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "itemTypeMeta": {
              "class": "resource",
              "color": "na",
              "spriteId": "ore:25",
              "type": "planks"
            },
            "quantity": 4
          }
        ],
        "itemTypeMeta": {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:927",
          "type": "tower-render"
        },
        "quantity": 1
      }
    ],
    "resolvedMetadata": {
      "armor-leather": [
        {
          "class": "armor",
          "color": "brown",
          "spriteId": null,
          "type": "armor-leather"
        }
      ],
      "armor-legion": [
        {
          "class": "armor",
          "color": "brown",
          "spriteId": null,
          "type": "armor-legion"
        }
      ],
      "armor-plate": [
        {
          "class": "armor",
          "color": "gray",
          "type": "armor-plate"
        },
        {
          "class": "armor",
          "color": "metal",
          "type": "armor-plate"
        },
        {
          "class": "armor",
          "color": "yellow",
          "type": "armor-plate"
        },
        {
          "class": "armor",
          "color": "gold",
          "type": "armor-plate"
        },
        {
          "class": "armor",
          "color": "orange",
          "type": "armor-plate"
        },
        {
          "class": "armor",
          "color": "tan",
          "type": "armor-plate"
        }
      ],
      "arrow": [
        {
          "class": "resource",
          "color": "brown",
          "spriteId": null,
          "type": "arrow"
        }
      ],
      "arrow-slit": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:899",
          "type": "arrow-slit"
        }
      ],
      "axe": [
        {
          "class": "weapon",
          "color": "metal",
          "type": "axe"
        }
      ],
      "barrel1": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "container:60",
          "type": "barrel1"
        }
      ],
      "bauldron": [
        {
          "class": "bauldron",
          "color": "brown",
          "spriteId": null,
          "type": "bauldron"
        }
      ],
      "blouse": [
        {
          "class": "shirt",
          "color": "black",
          "type": "blouse"
        },
        {
          "class": "shirt",
          "color": "blue",
          "type": "blouse"
        },
        {
          "class": "shirt",
          "color": "green",
          "type": "blouse"
        },
        {
          "class": "shirt",
          "color": "maroon",
          "type": "blouse"
        },
        {
          "class": "shirt",
          "color": "purple",
          "type": "blouse"
        },
        {
          "class": "shirt",
          "color": "red",
          "type": "blouse"
        },
        {
          "class": "shirt",
          "color": "teal",
          "type": "blouse"
        },
        {
          "class": "shirt",
          "color": "white",
          "type": "blouse"
        },
        {
          "class": "shirt",
          "color": "yellow",
          "type": "blouse"
        },
        {
          "class": "shirt",
          "color": "tan",
          "type": "blouse"
        },
        {
          "class": "shirt",
          "color": "gray",
          "type": "blouse"
        },
        {
          "class": "shirt",
          "color": "orange",
          "type": "blouse"
        }
      ],
      "blouse_longsleeve": [
        {
          "class": "shirt",
          "color": "black",
          "type": "blouse_longsleeve"
        },
        {
          "class": "shirt",
          "color": "blue",
          "type": "blouse_longsleeve"
        },
        {
          "class": "shirt",
          "color": "green",
          "type": "blouse_longsleeve"
        },
        {
          "class": "shirt",
          "color": "maroon",
          "type": "blouse_longsleeve"
        },
        {
          "class": "shirt",
          "color": "purple",
          "type": "blouse_longsleeve"
        },
        {
          "class": "shirt",
          "color": "red",
          "type": "blouse_longsleeve"
        },
        {
          "class": "shirt",
          "color": "teal",
          "type": "blouse_longsleeve"
        },
        {
          "class": "shirt",
          "color": "white",
          "type": "blouse_longsleeve"
        },
        {
          "class": "shirt",
          "color": "yellow",
          "type": "blouse_longsleeve"
        },
        {
          "class": "shirt",
          "color": "tan",
          "type": "blouse_longsleeve"
        },
        {
          "class": "shirt",
          "color": "gray",
          "type": "blouse_longsleeve"
        },
        {
          "class": "shirt",
          "color": "orange",
          "type": "blouse_longsleeve"
        }
      ],
      "boots": [
        {
          "class": "shoes",
          "color": "black",
          "type": "boots"
        },
        {
          "class": "shoes",
          "color": "blue",
          "type": "boots"
        },
        {
          "class": "shoes",
          "color": "brown",
          "type": "boots"
        },
        {
          "class": "shoes",
          "color": "gray",
          "type": "boots"
        },
        {
          "class": "shoes",
          "color": "green",
          "type": "boots"
        },
        {
          "class": "shoes",
          "color": "maroon",
          "type": "boots"
        },
        {
          "class": "shoes",
          "color": "orange",
          "type": "boots"
        },
        {
          "class": "shoes",
          "color": "purple",
          "type": "boots"
        },
        {
          "class": "shoes",
          "color": "red",
          "type": "boots"
        },
        {
          "class": "shoes",
          "color": "tan",
          "type": "boots"
        },
        {
          "class": "shoes",
          "color": "teal",
          "type": "boots"
        },
        {
          "class": "shoes",
          "color": "white",
          "type": "boots"
        },
        {
          "class": "shoes",
          "color": "yellow",
          "type": "boots"
        }
      ],
      "bow": [
        {
          "class": "weapon",
          "color": "brown",
          "type": "bow"
        }
      ],
      "campfire": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": null,
          "type": "campfire"
        }
      ],
      "cape-solid": [
        {
          "class": "cape",
          "color": "black",
          "type": "cape-solid"
        },
        {
          "class": "cape",
          "color": "blue",
          "type": "cape-solid"
        },
        {
          "class": "cape",
          "color": "brown",
          "type": "cape-solid"
        },
        {
          "class": "cape",
          "color": "gray",
          "type": "cape-solid"
        },
        {
          "class": "cape",
          "color": "green",
          "type": "cape-solid"
        },
        {
          "class": "cape",
          "color": "maroon",
          "type": "cape-solid"
        },
        {
          "class": "cape",
          "color": "red",
          "type": "cape-solid"
        },
        {
          "class": "cape",
          "color": "white",
          "type": "cape-solid"
        },
        {
          "class": "cape",
          "color": "yellow",
          "type": "cape-solid"
        }
      ],
      "cape-tattered": [
        {
          "class": "cape",
          "color": "black",
          "type": "cape-tattered"
        },
        {
          "class": "cape",
          "color": "blue",
          "type": "cape-tattered"
        },
        {
          "class": "cape",
          "color": "brown",
          "type": "cape-tattered"
        },
        {
          "class": "cape",
          "color": "gray",
          "type": "cape-tattered"
        },
        {
          "class": "cape",
          "color": "green",
          "type": "cape-tattered"
        },
        {
          "class": "cape",
          "color": "maroon",
          "type": "cape-tattered"
        },
        {
          "class": "cape",
          "color": "red",
          "type": "cape-tattered"
        },
        {
          "class": "cape",
          "color": "white",
          "type": "cape-tattered"
        },
        {
          "class": "cape",
          "color": "yellow",
          "type": "cape-tattered"
        }
      ],
      "cape-trimmed": [
        {
          "class": "cape",
          "color": "white",
          "type": "cape-trimmed"
        }
      ],
      "castle-footing": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:824",
          "type": "castle-footing"
        }
      ],
      "castle-merlons": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:924",
          "type": "castle-merlons"
        }
      ],
      "castle-wall": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:872",
          "type": "castle-wall"
        }
      ],
      "castlekey": [
        {
          "class": "key",
          "color": "gold",
          "spriteId": null,
          "type": "castlekey"
        }
      ],
      "chest-wood": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "container:140",
          "type": "chest-wood"
        }
      ],
      "chimney-stack": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:421",
          "type": "chimney-stack"
        }
      ],
      "coal": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:161",
          "type": "coal"
        }
      ],
      "copper": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:180",
          "type": "copper"
        }
      ],
      "corset": [
        {
          "class": "shirt",
          "color": "black",
          "type": "corset"
        },
        {
          "class": "shirt",
          "color": "blue",
          "type": "corset"
        },
        {
          "class": "shirt",
          "color": "green",
          "type": "corset"
        },
        {
          "class": "shirt",
          "color": "maroon",
          "type": "corset"
        },
        {
          "class": "shirt",
          "color": "purple",
          "type": "corset"
        },
        {
          "class": "shirt",
          "color": "red",
          "type": "corset"
        },
        {
          "class": "shirt",
          "color": "teal",
          "type": "corset"
        },
        {
          "class": "shirt",
          "color": "white",
          "type": "corset"
        },
        {
          "class": "shirt",
          "color": "yellow",
          "type": "corset"
        },
        {
          "class": "shirt",
          "color": "brown",
          "type": "corset"
        },
        {
          "class": "shirt",
          "color": "tan",
          "type": "corset"
        },
        {
          "class": "shirt",
          "color": "gray",
          "type": "corset"
        },
        {
          "class": "shirt",
          "color": "orange",
          "type": "corset"
        }
      ],
      "crossbow": [
        {
          "class": "weapon",
          "color": "brown",
          "type": "crossbow"
        }
      ],
      "dagger": [
        {
          "class": "weapon",
          "color": "brown",
          "spriteId": null,
          "type": "dagger"
        },
        {
          "class": "weapon",
          "color": "metal",
          "spriteId": null,
          "type": "dagger"
        }
      ],
      "door-wood": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "fence_medieval:478",
          "type": "door-wood"
        }
      ],
      "dormer-window": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:424",
          "type": "dormer-window"
        }
      ],
      "drumstick": [
        {
          "class": "resource",
          "color": "brown",
          "spriteId": null,
          "type": "drumstick"
        }
      ],
      "ember-charge": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:180",
          "type": "ember-charge"
        }
      ],
      "feather": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:72",
          "type": "feather"
        }
      ],
      "flail": [
        {
          "class": "weapon",
          "color": "metal",
          "type": "flail"
        }
      ],
      "floor-cobble": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "floors:225",
          "type": "floor-cobble"
        }
      ],
      "floor-opening": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:3",
          "type": "floor-opening"
        }
      ],
      "floor-stone": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "floors:129",
          "type": "floor-stone"
        }
      ],
      "floor-wood": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "floors:33",
          "type": "floor-wood"
        }
      ],
      "flower-single-blue": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "lpc-flowers-plants-fungi-wood:104",
          "type": "flower-single-blue"
        }
      ],
      "flower-single-purple": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "lpc-flowers-plants-fungi-wood:103",
          "type": "flower-single-purple"
        }
      ],
      "flower-single-red": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "lpc-flowers-plants-fungi-wood:105",
          "type": "flower-single-red"
        }
      ],
      "flower-single-yellow": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "lpc-flowers-plants-fungi-wood:106",
          "type": "flower-single-yellow"
        }
      ],
      "gold": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:182",
          "type": "gold"
        }
      ],
      "grass-seed": [
        {
          "class": "resource",
          "color": "na",
          "noGlint": true,
          "spriteId": "item-art-08bd1c8b4020c28035f1:1",
          "type": "grass-seed"
        }
      ],
      "grove-low-a": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-32902d50537ebad17e79:1",
          "type": "grove-low-a"
        }
      ],
      "grove-low-b": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-5902c8b486e89c8f8e57:1",
          "type": "grove-low-b"
        }
      ],
      "grove-oak-a": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-887e0636d4bbe2a4f448:1",
          "type": "grove-oak-a"
        }
      ],
      "grove-oak-b": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-f728e0bbaefbd1982b2d:1",
          "type": "grove-oak-b"
        }
      ],
      "grove-round-a": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-bb4afa7ce4e3c1ba55ba:1",
          "type": "grove-round-a"
        }
      ],
      "grove-round-b": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-e46e4dec4aea45bf9d8e:1",
          "type": "grove-round-b"
        }
      ],
      "grove-spruce-a": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-35c925e4db81912bfe38:1",
          "type": "grove-spruce-a"
        }
      ],
      "grove-spruce-b": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-99ea85dcdc93fac8db18:1",
          "type": "grove-spruce-b"
        }
      ],
      "halberd": [
        {
          "class": "weapon",
          "color": "metal",
          "type": "halberd"
        }
      ],
      "hatch-wood": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "hatch-wood:1",
          "type": "hatch-wood"
        }
      ],
      "hide": [
        {
          "class": "resource",
          "color": "brown",
          "spriteId": null,
          "type": "hide"
        }
      ],
      "iron": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:179",
          "type": "iron"
        }
      ],
      "iron-pickaxe": [
        {
          "class": "weapon",
          "color": "na",
          "spriteId": "item-art-b1d5a86cbcd21ed656d3:1",
          "type": "iron-pickaxe"
        }
      ],
      "legion": [
        {
          "class": "pants",
          "color": "brown",
          "spriteId": null,
          "type": "legion"
        }
      ],
      "longsleeve": [
        {
          "class": "shirt",
          "color": "black",
          "type": "longsleeve"
        },
        {
          "class": "shirt",
          "color": "blue",
          "type": "longsleeve"
        },
        {
          "class": "shirt",
          "color": "green",
          "type": "longsleeve"
        },
        {
          "class": "shirt",
          "color": "maroon",
          "type": "longsleeve"
        },
        {
          "class": "shirt",
          "color": "purple",
          "type": "longsleeve"
        },
        {
          "class": "shirt",
          "color": "red",
          "type": "longsleeve"
        },
        {
          "class": "shirt",
          "color": "teal",
          "type": "longsleeve"
        },
        {
          "class": "shirt",
          "color": "white",
          "type": "longsleeve"
        },
        {
          "class": "shirt",
          "color": "yellow",
          "type": "longsleeve"
        }
      ],
      "longsleeve_laced": [
        {
          "class": "shirt",
          "color": "black",
          "type": "longsleeve_laced"
        },
        {
          "class": "shirt",
          "color": "blue",
          "type": "longsleeve_laced"
        },
        {
          "class": "shirt",
          "color": "green",
          "type": "longsleeve_laced"
        },
        {
          "class": "shirt",
          "color": "maroon",
          "type": "longsleeve_laced"
        },
        {
          "class": "shirt",
          "color": "purple",
          "type": "longsleeve_laced"
        },
        {
          "class": "shirt",
          "color": "red",
          "type": "longsleeve_laced"
        },
        {
          "class": "shirt",
          "color": "teal",
          "type": "longsleeve_laced"
        },
        {
          "class": "shirt",
          "color": "white",
          "type": "longsleeve_laced"
        },
        {
          "class": "shirt",
          "color": "yellow",
          "type": "longsleeve_laced"
        },
        {
          "class": "shirt",
          "color": "tan",
          "type": "longsleeve_laced"
        },
        {
          "class": "shirt",
          "color": "gray",
          "type": "longsleeve_laced"
        },
        {
          "class": "shirt",
          "color": "orange",
          "type": "longsleeve_laced"
        }
      ],
      "longsword": [
        {
          "class": "weapon",
          "color": "metal",
          "type": "longsword"
        }
      ],
      "mace": [
        {
          "class": "weapon",
          "color": "metal",
          "type": "mace"
        }
      ],
      "meadow-grass-a": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-ebdd046fea0f3ab21669:1",
          "type": "meadow-grass-a"
        }
      ],
      "meadow-grass-b": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-4d6c318ef966e097227a:1",
          "type": "meadow-grass-b"
        }
      ],
      "meadow-grass-c": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-721c3f8a8d4621a46f90:1",
          "type": "meadow-grass-c"
        }
      ],
      "meadow-grass-d": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-7fc02d2406eaa57e3be0:1",
          "type": "meadow-grass-d"
        }
      ],
      "meadow-grass-e": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-a7225776548a58ab4e04:1",
          "type": "meadow-grass-e"
        }
      ],
      "meadow-grass-f": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-d9ecaed5ff4485611809:1",
          "type": "meadow-grass-f"
        }
      ],
      "meadow-sprout": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "item-art-af19df691fc7aa944194:1",
          "type": "meadow-sprout"
        }
      ],
      "metal-bar-copper": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:180",
          "type": "metal-bar-copper"
        }
      ],
      "metal-bar-gold": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:182",
          "type": "metal-bar-gold"
        }
      ],
      "metal-bar-iron": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:179",
          "type": "metal-bar-iron"
        }
      ],
      "metal-bar-silver": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:181",
          "type": "metal-bar-silver"
        }
      ],
      "mushroom-purple": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "lpc-flowers-plants-fungi-wood:353",
          "type": "mushroom-purple"
        }
      ],
      "mushroom-red": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "lpc-flowers-plants-fungi-wood:355",
          "type": "mushroom-red"
        }
      ],
      "mushroom-yellow": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "lpc-flowers-plants-fungi-wood:354",
          "type": "mushroom-yellow"
        }
      ],
      "pantaloons": [
        {
          "class": "pants",
          "color": "black",
          "type": "pantaloons"
        },
        {
          "class": "pants",
          "color": "blue",
          "type": "pantaloons"
        },
        {
          "class": "pants",
          "color": "brown",
          "type": "pantaloons"
        },
        {
          "class": "pants",
          "color": "gray",
          "type": "pantaloons"
        },
        {
          "class": "pants",
          "color": "green",
          "type": "pantaloons"
        },
        {
          "class": "pants",
          "color": "maroon",
          "type": "pantaloons"
        },
        {
          "class": "pants",
          "color": "orange",
          "type": "pantaloons"
        },
        {
          "class": "pants",
          "color": "purple",
          "type": "pantaloons"
        },
        {
          "class": "pants",
          "color": "red",
          "type": "pantaloons"
        },
        {
          "class": "pants",
          "color": "tan",
          "type": "pantaloons"
        },
        {
          "class": "pants",
          "color": "white",
          "type": "pantaloons"
        },
        {
          "class": "pants",
          "color": "yellow",
          "type": "pantaloons"
        }
      ],
      "pants": [
        {
          "class": "pants",
          "color": "black",
          "type": "pants"
        },
        {
          "class": "pants",
          "color": "blue",
          "type": "pants"
        },
        {
          "class": "pants",
          "color": "brown",
          "type": "pants"
        },
        {
          "class": "pants",
          "color": "gray",
          "type": "pants"
        },
        {
          "class": "pants",
          "color": "green",
          "type": "pants"
        },
        {
          "class": "pants",
          "color": "maroon",
          "type": "pants"
        },
        {
          "class": "pants",
          "color": "orange",
          "type": "pants"
        },
        {
          "class": "pants",
          "color": "purple",
          "type": "pants"
        },
        {
          "class": "pants",
          "color": "red",
          "type": "pants"
        },
        {
          "class": "pants",
          "color": "tan",
          "type": "pants"
        },
        {
          "class": "pants",
          "color": "white",
          "type": "pants"
        },
        {
          "class": "pants",
          "color": "yellow",
          "type": "pants"
        }
      ],
      "pants-armor": [
        {
          "class": "pants",
          "color": "gray",
          "type": "pants-armor"
        },
        {
          "class": "pants",
          "color": "metal",
          "type": "pants-armor"
        },
        {
          "class": "pants",
          "color": "yellow",
          "type": "pants-armor"
        },
        {
          "class": "pants",
          "color": "gold",
          "type": "pants-armor"
        },
        {
          "class": "pants",
          "color": "tan",
          "type": "pants-armor"
        },
        {
          "class": "pants",
          "color": "orange",
          "type": "pants-armor"
        }
      ],
      "planks": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:25",
          "type": "planks"
        }
      ],
      "railing-wood": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "fence_medieval:1",
          "type": "railing-wood"
        }
      ],
      "rapier": [
        {
          "class": "weapon",
          "color": "metal",
          "type": "rapier"
        }
      ],
      "roof-wood": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:807",
          "type": "roof-wood"
        }
      ],
      "rope": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:88",
          "type": "rope"
        }
      ],
      "saber": [
        {
          "class": "weapon",
          "color": "metal",
          "type": "saber"
        }
      ],
      "sandals": [
        {
          "class": "shoes",
          "color": "brown",
          "type": "sandals"
        }
      ],
      "scoop_shirt": [
        {
          "class": "shirt",
          "color": "black",
          "type": "scoop_shirt"
        },
        {
          "class": "shirt",
          "color": "blue",
          "type": "scoop_shirt"
        },
        {
          "class": "shirt",
          "color": "green",
          "type": "scoop_shirt"
        },
        {
          "class": "shirt",
          "color": "maroon",
          "type": "scoop_shirt"
        },
        {
          "class": "shirt",
          "color": "purple",
          "type": "scoop_shirt"
        },
        {
          "class": "shirt",
          "color": "red",
          "type": "scoop_shirt"
        },
        {
          "class": "shirt",
          "color": "teal",
          "type": "scoop_shirt"
        },
        {
          "class": "shirt",
          "color": "white",
          "type": "scoop_shirt"
        },
        {
          "class": "shirt",
          "color": "yellow",
          "type": "scoop_shirt"
        },
        {
          "class": "shirt",
          "color": "gray",
          "type": "scoop_shirt"
        },
        {
          "class": "shirt",
          "color": "orange",
          "type": "scoop_shirt"
        }
      ],
      "scythe": [
        {
          "class": "weapon",
          "color": "metal",
          "type": "scythe"
        }
      ],
      "seed": [
        {
          "class": "resource",
          "color": "na",
          "noGlint": true,
          "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
          "type": "seed"
        }
      ],
      "shard-metal": [
        {
          "class": "resource",
          "color": "gray",
          "type": "shard-metal"
        }
      ],
      "shield-crusader": [
        {
          "class": "shield",
          "color": "white",
          "spriteId": null,
          "type": "shield-crusader"
        }
      ],
      "shield-kite": [
        {
          "class": "shield",
          "color": "white",
          "spriteId": null,
          "type": "shield-kite"
        }
      ],
      "shield-kite_blue": [
        {
          "class": "shield",
          "color": "blue",
          "type": "shield-kite_blue"
        },
        {
          "class": "shield",
          "color": "gray",
          "type": "shield-kite_blue"
        }
      ],
      "shield-kite_gray": [
        {
          "class": "shield",
          "color": "blue",
          "type": "shield-kite_gray"
        },
        {
          "class": "shield",
          "color": "gray",
          "type": "shield-kite_gray"
        },
        {
          "class": "shield",
          "color": "green",
          "type": "shield-kite_gray"
        },
        {
          "class": "shield",
          "color": "orange",
          "type": "shield-kite_gray"
        }
      ],
      "shield-kite_green": [
        {
          "class": "shield",
          "color": "gray",
          "type": "shield-kite_green"
        }
      ],
      "shield-kite_red": [
        {
          "class": "shield",
          "color": "gray",
          "type": "shield-kite_red"
        }
      ],
      "shield-round": [
        {
          "class": "shield",
          "color": "brown",
          "spriteId": null,
          "type": "shield-round"
        }
      ],
      "shield-spartan": [
        {
          "class": "shield",
          "color": "brown",
          "type": "shield-spartan"
        }
      ],
      "shoes": [
        {
          "class": "shoes",
          "color": "black",
          "type": "shoes"
        },
        {
          "class": "shoes",
          "color": "brown",
          "type": "shoes"
        },
        {
          "class": "shoes",
          "color": "maroon",
          "type": "shoes"
        }
      ],
      "shoes-armor": [
        {
          "class": "shoes",
          "color": "gray",
          "type": "shoes-armor"
        },
        {
          "class": "shoes",
          "color": "metal",
          "type": "shoes-armor"
        },
        {
          "class": "shoes",
          "color": "yellow",
          "type": "shoes-armor"
        },
        {
          "class": "shoes",
          "color": "gold",
          "type": "shoes-armor"
        },
        {
          "class": "shoes",
          "color": "tan",
          "type": "shoes-armor"
        },
        {
          "class": "shoes",
          "color": "orange",
          "type": "shoes-armor"
        }
      ],
      "silver": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:181",
          "type": "silver"
        }
      ],
      "skirts": [
        {
          "class": "pants",
          "color": "brown",
          "type": "skirts"
        },
        {
          "class": "pants",
          "color": "black",
          "type": "skirts"
        },
        {
          "class": "pants",
          "color": "white",
          "type": "skirts"
        }
      ],
      "sleeveless": [
        {
          "class": "shirt",
          "color": "black",
          "type": "sleeveless"
        },
        {
          "class": "shirt",
          "color": "blue",
          "type": "sleeveless"
        },
        {
          "class": "shirt",
          "color": "green",
          "type": "sleeveless"
        },
        {
          "class": "shirt",
          "color": "maroon",
          "type": "sleeveless"
        },
        {
          "class": "shirt",
          "color": "purple",
          "type": "sleeveless"
        },
        {
          "class": "shirt",
          "color": "red",
          "type": "sleeveless"
        },
        {
          "class": "shirt",
          "color": "teal",
          "type": "sleeveless"
        },
        {
          "class": "shirt",
          "color": "white",
          "type": "sleeveless"
        },
        {
          "class": "shirt",
          "color": "yellow",
          "type": "sleeveless"
        },
        {
          "class": "shirt",
          "color": "brown",
          "type": "sleeveless"
        },
        {
          "class": "shirt",
          "color": "tan",
          "type": "sleeveless"
        },
        {
          "class": "shirt",
          "color": "gray",
          "type": "sleeveless"
        },
        {
          "class": "shirt",
          "color": "orange",
          "type": "sleeveless"
        }
      ],
      "sleeveless_laced": [
        {
          "class": "shirt",
          "color": "black",
          "type": "sleeveless_laced"
        },
        {
          "class": "shirt",
          "color": "blue",
          "type": "sleeveless_laced"
        },
        {
          "class": "shirt",
          "color": "green",
          "type": "sleeveless_laced"
        },
        {
          "class": "shirt",
          "color": "maroon",
          "type": "sleeveless_laced"
        },
        {
          "class": "shirt",
          "color": "purple",
          "type": "sleeveless_laced"
        },
        {
          "class": "shirt",
          "color": "red",
          "type": "sleeveless_laced"
        },
        {
          "class": "shirt",
          "color": "teal",
          "type": "sleeveless_laced"
        },
        {
          "class": "shirt",
          "color": "white",
          "type": "sleeveless_laced"
        },
        {
          "class": "shirt",
          "color": "yellow",
          "type": "sleeveless_laced"
        },
        {
          "class": "shirt",
          "color": "brown",
          "type": "sleeveless_laced"
        },
        {
          "class": "shirt",
          "color": "tan",
          "type": "sleeveless_laced"
        },
        {
          "class": "shirt",
          "color": "gray",
          "type": "sleeveless_laced"
        },
        {
          "class": "shirt",
          "color": "orange",
          "type": "sleeveless_laced"
        }
      ],
      "sleeveless_striped": [
        {
          "class": "shirt",
          "color": "black",
          "type": "sleeveless_striped"
        },
        {
          "class": "shirt",
          "color": "blue",
          "type": "sleeveless_striped"
        },
        {
          "class": "shirt",
          "color": "green",
          "type": "sleeveless_striped"
        },
        {
          "class": "shirt",
          "color": "maroon",
          "type": "sleeveless_striped"
        },
        {
          "class": "shirt",
          "color": "purple",
          "type": "sleeveless_striped"
        },
        {
          "class": "shirt",
          "color": "red",
          "type": "sleeveless_striped"
        },
        {
          "class": "shirt",
          "color": "teal",
          "type": "sleeveless_striped"
        },
        {
          "class": "shirt",
          "color": "white",
          "type": "sleeveless_striped"
        },
        {
          "class": "shirt",
          "color": "yellow",
          "type": "sleeveless_striped"
        },
        {
          "class": "shirt",
          "color": "brown",
          "type": "sleeveless_striped"
        },
        {
          "class": "shirt",
          "color": "tan",
          "type": "sleeveless_striped"
        },
        {
          "class": "shirt",
          "color": "gray",
          "type": "sleeveless_striped"
        },
        {
          "class": "shirt",
          "color": "orange",
          "type": "sleeveless_striped"
        }
      ],
      "slippers": [
        {
          "class": "shoes",
          "color": "black",
          "type": "slippers"
        },
        {
          "class": "shoes",
          "color": "brown",
          "type": "slippers"
        },
        {
          "class": "shoes",
          "color": "gray",
          "type": "slippers"
        }
      ],
      "snare-rabbit": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "snare-rabbit.png",
          "type": "snare-rabbit"
        }
      ],
      "spear": [
        {
          "class": "weapon",
          "color": "brown",
          "type": "spear"
        },
        {
          "class": "weapon",
          "color": "black",
          "type": "spear"
        },
        {
          "class": "weapon",
          "color": "green",
          "type": "spear"
        },
        {
          "class": "weapon",
          "color": "metal",
          "type": "spear"
        },
        {
          "class": "weapon",
          "color": "purple",
          "type": "spear"
        }
      ],
      "spider-silk": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:88",
          "type": "spider-silk"
        }
      ],
      "stackedBags": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "container:449",
          "type": "stackedBags"
        }
      ],
      "staff": [
        {
          "class": "weapon",
          "color": "brown",
          "type": "staff"
        }
      ],
      "stairs": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "stairs-icon:1",
          "type": "stairs"
        }
      ],
      "stick": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:26",
          "type": "stick"
        }
      ],
      "stool-small": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "furniture-blonde-wood:126",
          "type": "stool-small"
        }
      ],
      "stool1": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "furniture-blond-wood:128",
          "type": "stool1"
        }
      ],
      "straw": [
        {
          "class": "resource",
          "color": "na",
          "noGlint": true,
          "spriteId": "item-art-b9ef00e25a4177065abd:1",
          "type": "straw"
        }
      ],
      "strawBed": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "build_atlas:684",
          "type": "strawBed"
        }
      ],
      "strawBedSmall": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "build_atlas:684",
          "type": "strawBedSmall"
        }
      ],
      "table-large-rough": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "furniture-blonde-wood:458",
          "type": "table-large-rough"
        }
      ],
      "table-mid-rough": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "furniture-blonde-wood:141",
          "type": "table-mid-rough"
        }
      ],
      "table-mid-round": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "furniture-blonde-wood:124",
          "type": "table-mid-round"
        }
      ],
      "tanktop": [
        {
          "class": "shirt",
          "color": "black",
          "type": "tanktop"
        },
        {
          "class": "shirt",
          "color": "blue",
          "type": "tanktop"
        },
        {
          "class": "shirt",
          "color": "green",
          "type": "tanktop"
        },
        {
          "class": "shirt",
          "color": "maroon",
          "type": "tanktop"
        },
        {
          "class": "shirt",
          "color": "purple",
          "type": "tanktop"
        },
        {
          "class": "shirt",
          "color": "red",
          "type": "tanktop"
        },
        {
          "class": "shirt",
          "color": "teal",
          "type": "tanktop"
        },
        {
          "class": "shirt",
          "color": "white",
          "type": "tanktop"
        },
        {
          "class": "shirt",
          "color": "yellow",
          "type": "tanktop"
        },
        {
          "class": "shirt",
          "color": "tan",
          "type": "tanktop"
        },
        {
          "class": "shirt",
          "color": "gray",
          "type": "tanktop"
        },
        {
          "class": "shirt",
          "color": "orange",
          "type": "tanktop"
        }
      ],
      "thatch-roof": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:378",
          "type": "thatch-roof"
        }
      ],
      "timber-frame-wall": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:50",
          "type": "timber-frame-wall"
        }
      ],
      "torch": [
        {
          "class": "resource",
          "color": "na",
          "spriteId": null,
          "type": "torch"
        }
      ],
      "tower-render": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:927",
          "type": "tower-render"
        }
      ],
      "tunic": [
        {
          "class": "shirt",
          "color": "brown",
          "type": "tunic"
        },
        {
          "class": "shirt",
          "color": "maroon",
          "type": "tunic"
        },
        {
          "class": "shirt",
          "color": "teal",
          "type": "tunic"
        },
        {
          "class": "shirt",
          "color": "white",
          "type": "tunic"
        }
      ],
      "wall-stone": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "walls2:53",
          "type": "wall-stone"
        }
      ],
      "wall-wood": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:643",
          "type": "wall-wood"
        }
      ],
      "wall2-wood": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "walls2:43",
          "type": "wall2-wood"
        }
      ],
      "waraxe": [
        {
          "class": "weapon",
          "color": "metal",
          "type": "waraxe"
        }
      ],
      "warhammer": [
        {
          "class": "weapon",
          "color": "metal",
          "type": "warhammer"
        }
      ],
      "web": [
        {
          "class": "weapon",
          "color": "white",
          "type": "web"
        }
      ],
      "webAmmo": [
        {
          "class": "resource",
          "color": "white",
          "type": "webAmmo"
        }
      ],
      "window-frame": [
        {
          "class": "structure",
          "color": "na",
          "spriteId": "authored-terrain:419",
          "type": "window-frame"
        }
      ],
      "wood": [
        {
          "class": "resource",
          "color": "brown",
          "noGlint": true,
          "spriteId": null,
          "type": "wood"
        }
      ]
    },
    "sprites": {
      "arrow-slit": "authored-terrain:899",
      "barrel1": "container:60",
      "castle-footing": "authored-terrain:824",
      "castle-merlons": "authored-terrain:924",
      "castle-wall": "authored-terrain:872",
      "chest-wood": "container:140",
      "chimney-stack": "authored-terrain:421",
      "coal": "ore:161",
      "copper": "ore:180",
      "door-wood": "fence_medieval:478",
      "dormer-window": "authored-terrain:424",
      "ember-charge": "ore:180",
      "feather": "ore:72",
      "floor-cobble": "floors:225",
      "floor-opening": "authored-terrain:3",
      "floor-stone": "floors:129",
      "floor-wood": "floors:33",
      "flower-single-blue": "lpc-flowers-plants-fungi-wood:104",
      "flower-single-purple": "lpc-flowers-plants-fungi-wood:103",
      "flower-single-red": "lpc-flowers-plants-fungi-wood:105",
      "flower-single-yellow": "lpc-flowers-plants-fungi-wood:106",
      "gold": "ore:182",
      "grass-seed": "item-art-08bd1c8b4020c28035f1:1",
      "grove-low-a": "item-art-32902d50537ebad17e79:1",
      "grove-low-b": "item-art-5902c8b486e89c8f8e57:1",
      "grove-oak-a": "item-art-887e0636d4bbe2a4f448:1",
      "grove-oak-b": "item-art-f728e0bbaefbd1982b2d:1",
      "grove-round-a": "item-art-bb4afa7ce4e3c1ba55ba:1",
      "grove-round-b": "item-art-e46e4dec4aea45bf9d8e:1",
      "grove-spruce-a": "item-art-35c925e4db81912bfe38:1",
      "grove-spruce-b": "item-art-99ea85dcdc93fac8db18:1",
      "hatch-wood": "hatch-wood:1",
      "iron": "ore:179",
      "iron-pickaxe": "item-art-b1d5a86cbcd21ed656d3:1",
      "meadow-grass-a": "item-art-ebdd046fea0f3ab21669:1",
      "meadow-grass-b": "item-art-4d6c318ef966e097227a:1",
      "meadow-grass-c": "item-art-721c3f8a8d4621a46f90:1",
      "meadow-grass-d": "item-art-7fc02d2406eaa57e3be0:1",
      "meadow-grass-e": "item-art-a7225776548a58ab4e04:1",
      "meadow-grass-f": "item-art-d9ecaed5ff4485611809:1",
      "meadow-sprout": "item-art-af19df691fc7aa944194:1",
      "metal-bar-copper": "ore:180",
      "metal-bar-gold": "ore:182",
      "metal-bar-iron": "ore:179",
      "metal-bar-silver": "ore:181",
      "mushroom-purple": "lpc-flowers-plants-fungi-wood:353",
      "mushroom-red": "lpc-flowers-plants-fungi-wood:355",
      "mushroom-yellow": "lpc-flowers-plants-fungi-wood:354",
      "planks": "ore:25",
      "railing-wood": "fence_medieval:1",
      "roof-wood": "authored-terrain:807",
      "rope": "ore:88",
      "seed": "item-art-1a07b84a0c63a7a63c4f:1",
      "silver": "ore:181",
      "snare-rabbit": "snare-rabbit.png",
      "spider-silk": "ore:88",
      "stackedBags": "container:449",
      "stairs": "stairs-icon:1",
      "stick": "ore:26",
      "stool-small": "furniture-blonde-wood:126",
      "stool1": "furniture-blond-wood:128",
      "straw": "item-art-b9ef00e25a4177065abd:1",
      "strawBed": "build_atlas:684",
      "strawBedSmall": "build_atlas:684",
      "table-large-rough": "furniture-blonde-wood:458",
      "table-mid-rough": "furniture-blonde-wood:141",
      "table-mid-round": "furniture-blonde-wood:124",
      "thatch-roof": "authored-terrain:378",
      "timber-frame-wall": "authored-terrain:50",
      "tower-render": "authored-terrain:927",
      "wall-stone": "walls2:53",
      "wall-wood": "authored-terrain:643",
      "wall2-wood": "walls2:43",
      "window-frame": "authored-terrain:419"
    },
    "subClasses": {
      "ammo": [
        "arrow",
        "webAmmo",
        "ember-charge"
      ],
      "armor": [
        "armor-leather",
        "armor-legion",
        "armor-plate"
      ],
      "bauldron": [
        "bauldron"
      ],
      "cape": [
        "cape-solid",
        "cape-tattered",
        "cape-trimmed"
      ],
      "chest": [
        "chest-wood"
      ],
      "chimney": [
        "chimney-stack"
      ],
      "craftResource": [
        "feather",
        "planks",
        "rope",
        "stick",
        "spider-silk"
      ],
      "door": [
        "door-wood"
      ],
      "dormer": [
        "dormer-window"
      ],
      "drumstick": [
        "drumstick"
      ],
      "floor": [
        "floor-wood",
        "floor-stone",
        "floor-cobble"
      ],
      "flower": [
        "flower-single-blue",
        "flower-single-purple",
        "flower-single-red",
        "flower-single-yellow"
      ],
      "hide": [
        "hide"
      ],
      "key": [
        "castlekey"
      ],
      "metalBar": [
        "metal-bar-copper",
        "metal-bar-gold",
        "metal-bar-iron",
        "metal-bar-silver"
      ],
      "mushroom": [
        "mushroom-purple",
        "mushroom-red",
        "mushroom-yellow"
      ],
      "ore": [
        "coal",
        "copper",
        "gold",
        "iron",
        "silver"
      ],
      "pants": [
        "legion",
        "pantaloons",
        "pants",
        "pants-armor",
        "skirts"
      ],
      "resource": [
        "shard-metal"
      ],
      "roof": [
        "roof-wood",
        "thatch-roof"
      ],
      "seed": [
        "seed",
        "grass-seed"
      ],
      "shard": [
        "shard-metal"
      ],
      "shield": [
        "shield-crusader",
        "shield-kite",
        "shield-kite_blue",
        "shield-kite_gray",
        "shield-kite_green",
        "shield-kite_red",
        "shield-round",
        "shield-spartan"
      ],
      "shirt": [
        "blouse",
        "blouse_longsleeve",
        "corset",
        "longsleeve",
        "longsleeve_laced",
        "scoop_shirt",
        "sleeveless",
        "sleeveless_laced",
        "sleeveless_striped",
        "tanktop",
        "tunic"
      ],
      "shoes": [
        "boots",
        "sandals",
        "shoes",
        "shoes-armor",
        "slippers"
      ],
      "straw": [
        "straw"
      ],
      "structure": [
        "campfire",
        "snare-rabbit",
        "stool-small",
        "table-large-rough",
        "table-mid-round",
        "barrel1",
        "stackedBags",
        "stool1",
        "table-mid-rough",
        "strawBed",
        "strawBedSmall",
        "stairs",
        "floor-opening",
        "hatch-wood",
        "grove-oak-a",
        "grove-oak-b",
        "grove-spruce-a",
        "grove-spruce-b",
        "grove-round-a",
        "grove-round-b",
        "grove-low-a",
        "grove-low-b",
        "meadow-grass-a",
        "meadow-grass-b",
        "meadow-grass-c",
        "meadow-grass-d",
        "meadow-grass-e",
        "meadow-grass-f",
        "meadow-sprout"
      ],
      "torch": [
        "torch"
      ],
      "wall": [
        "wall-wood",
        "wall2-wood",
        "wall-stone",
        "railing-wood",
        "timber-frame-wall",
        "castle-footing",
        "castle-wall",
        "castle-merlons",
        "tower-render"
      ],
      "weapon": [
        "axe",
        "bow",
        "crossbow",
        "dagger",
        "flail",
        "halberd",
        "longsword",
        "mace",
        "none",
        "rapier",
        "saber",
        "scythe",
        "spear",
        "staff",
        "waraxe",
        "warhammer",
        "web",
        "iron-pickaxe"
      ],
      "window": [
        "window-frame",
        "arrow-slit"
      ],
      "wood": [
        "wood"
      ]
    },
    "trade": {
      "armor-leather": {
        "itemType": "shard-metal",
        "quantity": 60
      },
      "armor-legion": {
        "itemType": "shard-metal",
        "quantity": 240
      },
      "armor-plate": {
        "itemType": "shard-metal",
        "quantity": 360
      },
      "arrow": {
        "itemType": "shard-metal",
        "quantity": 0.1
      },
      "coal": {
        "itemType": "shard-metal",
        "quantity": 3
      },
      "copper": {
        "itemType": "shard-metal",
        "quantity": 9
      },
      "dagger": {
        "itemType": "shard-metal",
        "quantity": 10
      },
      "drumstick": {
        "itemType": "shard-metal",
        "quantity": 10
      },
      "feather": {
        "itemType": "shard-metal",
        "quantity": 10
      },
      "gold": {
        "itemType": "shard-metal",
        "quantity": 15
      },
      "hide": {
        "itemType": "shard-metal",
        "quantity": 2
      },
      "iron": {
        "itemType": "shard-metal",
        "quantity": 6
      },
      "metal-bar-copper": {
        "itemType": "shard-metal",
        "quantity": 45
      },
      "metal-bar-gold": {
        "itemType": "shard-metal",
        "quantity": 80
      },
      "metal-bar-iron": {
        "itemType": "shard-metal",
        "quantity": 30
      },
      "metal-bar-silver": {
        "itemType": "shard-metal",
        "quantity": 60
      },
      "shield-crusader": {
        "itemType": "shard-metal",
        "quantity": 120
      },
      "shield-kite": {
        "itemType": "shard-metal",
        "quantity": 120
      },
      "shield-kite_blue": {
        "itemType": "shard-metal",
        "quantity": 120
      },
      "shield-kite_gray": {
        "itemType": "shard-metal",
        "quantity": 120
      },
      "shield-kite_green": {
        "itemType": "shard-metal",
        "quantity": 120
      },
      "shield-kite_red": {
        "itemType": "shard-metal",
        "quantity": 120
      },
      "shield-round": {
        "itemType": "shard-metal",
        "quantity": 120
      },
      "silver": {
        "itemType": "shard-metal",
        "quantity": 12
      },
      "spear": {
        "itemType": "shard-metal",
        "quantity": 20
      }
    },
    "weight": {
      "armor": {
        "armor-leather": 0.1,
        "armor-legion": 0.2,
        "armor-plate": 0.3
      },
      "bauldron": {
        "bauldron": 0.05
      },
      "cape": {},
      "key": {},
      "pants": {
        "legion": 0.1,
        "pants-armor": 0.1
      },
      "resource": {},
      "shield": {
        "shield-crusader": 0.2,
        "shield-kite": 0.2,
        "shield-kite_blue": 0.2,
        "shield-kite_gray": 0.2,
        "shield-kite_green": 0.2,
        "shield-kite_red": 0.2,
        "shield-round": 0.1,
        "shield-spartan": 0.15
      },
      "shirt": {},
      "shoes": {
        "shoes-armor": 0.1,
        "slippers": 0.01
      },
      "structure": {},
      "weapon": {
        "axe": 0.08,
        "bow": 0.05,
        "iron-pickaxe": 0.08,
        "spear": 0.05,
        "staff": 0.05,
        "warhammer": 0.1
      }
    }
  },
  "mapTemplates": {
    "caves": {
      "compressionlevel": -1,
      "height": 50,
      "infinite": false,
      "layers": [
        {
          "data": [
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            2091,
            2091,
            2091,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            2091,
            2091,
            2091,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            2091,
            2091,
            2091,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            354,
            354,
            354,
            354,
            354,
            354,
            354,
            354,
            354,
            354,
            354,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            2091,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            2091,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            308,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            308,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            308,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            308,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            308,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            308,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            308,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            308,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            2091,
            2091,
            2091,
            0,
            0,
            308,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            308,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2091,
            0,
            0,
            2091,
            2091,
            2091,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            308,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            354,
            354,
            354,
            2091,
            2091,
            354,
            354,
            354,
            354,
            354,
            354,
            354,
            354,
            354,
            354,
            308,
            308,
            308,
            308,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 1,
          "name": "map1",
          "opacity": 1,
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            258,
            258,
            258,
            258,
            227,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1570,
            1570,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1223,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4177,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4050,
            1223,
            1223,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1223,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1223,
            1223,
            1223,
            1223,
            1223,
            1223,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1223,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 2,
          "name": "map2",
          "opacity": 1,
          "properties": [
            {
              "name": "entityTileSurface",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            723,
            723,
            0,
            0,
            1133,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 3,
          "name": "map3",
          "opacity": 1,
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2569,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2635,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2759,
            2759,
            2759,
            0,
            4175,
            4112,
            4177,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4115,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4053,
            4112,
            4052,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4115,
            4114,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4179,
            0,
            4179,
            0,
            0,
            0,
            4053,
            4052,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2758,
            0,
            0,
            0,
            0,
            0,
            4115,
            0,
            4114,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4112,
            0,
            4053,
            0,
            4052,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2632,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4112,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2760,
            0,
            0,
            0,
            0,
            0,
            2631,
            0,
            4112,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4111,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4112,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4179,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4112,
            2759,
            2759,
            2759,
            2759,
            2759,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2632,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4175,
            4112,
            2760,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2759,
            2759,
            2759,
            2759,
            2759,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2758,
            4112,
            4112,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2758,
            4112,
            4112,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4112,
            4177,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4112,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4112,
            2759,
            2759,
            4179,
            2759,
            4112,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2759,
            0,
            0,
            4115,
            0,
            0,
            0,
            0,
            0,
            0,
            2632,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4112,
            4112,
            4112,
            4112,
            4112,
            4112,
            2760,
            0,
            0,
            0,
            0,
            0,
            2759,
            2759,
            2759,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2759,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4112,
            0,
            0,
            0,
            4053,
            2759,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 4,
          "name": "map4",
          "opacity": 1,
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            2569,
            2631,
            2631,
            583,
            2631,
            2565,
            0,
            2569,
            583,
            2631,
            2631,
            2631,
            2565,
            0,
            2569,
            2631,
            2631,
            2631,
            2631,
            2565,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2569,
            2631,
            2631,
            2565,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2571,
            2759,
            2759,
            711,
            2759,
            2563,
            0,
            2571,
            711,
            2759,
            2759,
            2759,
            2563,
            0,
            2571,
            2759,
            2759,
            2759,
            2759,
            2563,
            0,
            0,
            2569,
            2631,
            2631,
            583,
            2565,
            0,
            0,
            2571,
            2759,
            2759,
            2630,
            2631,
            2631,
            2631,
            2631,
            2565,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            0,
            0,
            0,
            3149,
            0,
            3147,
            0,
            0,
            0,
            184,
            3149,
            0,
            3147,
            0,
            0,
            0,
            0,
            2630,
            2631,
            2631,
            2635,
            2759,
            2759,
            711,
            2563,
            0,
            0,
            3147,
            0,
            0,
            0,
            2759,
            2759,
            2759,
            2759,
            2563,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            184,
            0,
            0,
            0,
            3149,
            0,
            3147,
            0,
            0,
            0,
            0,
            3149,
            0,
            3147,
            0,
            0,
            0,
            0,
            2758,
            2759,
            2759,
            2760,
            0,
            184,
            0,
            3149,
            0,
            0,
            3147,
            0,
            0,
            3140,
            3212,
            3212,
            3141,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            0,
            0,
            184,
            3149,
            0,
            3147,
            0,
            0,
            0,
            0,
            3149,
            0,
            3147,
            184,
            0,
            0,
            0,
            3140,
            3212,
            3212,
            3141,
            0,
            0,
            0,
            3149,
            0,
            0,
            3211,
            3212,
            3212,
            3213,
            0,
            0,
            3147,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3211,
            3212,
            3212,
            3212,
            3212,
            3213,
            0,
            3211,
            3212,
            3141,
            0,
            3140,
            3213,
            0,
            3211,
            3212,
            3212,
            3212,
            3212,
            3213,
            0,
            0,
            3211,
            3212,
            3212,
            3212,
            3213,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2569,
            2632,
            0,
            2630,
            2565,
            0,
            2569,
            583,
            2565,
            2567,
            2569,
            2631,
            2631,
            2631,
            2631,
            2631,
            2631,
            2631,
            2565,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2571,
            2760,
            0,
            2758,
            2563,
            0,
            2571,
            711,
            2563,
            2567,
            3147,
            2759,
            2759,
            2759,
            2759,
            2759,
            2759,
            2759,
            2563,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2569,
            2632,
            0,
            2630,
            2631,
            2631,
            2565,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            0,
            0,
            3149,
            0,
            3147,
            0,
            2566,
            2567,
            3211,
            3212,
            3212,
            3212,
            3212,
            3212,
            3141,
            184,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2571,
            2760,
            0,
            2758,
            2759,
            2759,
            2630,
            2631,
            2631,
            2631,
            2631,
            2565,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            184,
            0,
            0,
            3149,
            0,
            3147,
            0,
            2566,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2568,
            0,
            3149,
            0,
            0,
            0,
            0,
            2569,
            2631,
            2631,
            2632,
            0,
            0,
            0,
            0,
            0,
            2758,
            2759,
            2759,
            2759,
            2759,
            2563,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3211,
            3212,
            3212,
            3212,
            3213,
            0,
            3147,
            0,
            2630,
            2631,
            2631,
            2631,
            2631,
            2631,
            2631,
            2631,
            2632,
            0,
            3149,
            0,
            0,
            0,
            0,
            2571,
            2759,
            2759,
            2760,
            0,
            0,
            0,
            0,
            0,
            3140,
            3212,
            3212,
            3141,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            184,
            2758,
            2759,
            2759,
            2759,
            2759,
            2759,
            2759,
            2759,
            2760,
            0,
            3149,
            0,
            0,
            0,
            0,
            3147,
            0,
            3140,
            3141,
            0,
            0,
            0,
            0,
            0,
            3149,
            0,
            0,
            3147,
            0,
            2630,
            2631,
            2631,
            2565,
            0,
            0,
            2569,
            2631,
            2565,
            0,
            2631,
            2631,
            2631,
            0,
            0,
            0,
            0,
            0,
            0,
            3211,
            3212,
            3212,
            3212,
            3212,
            3212,
            3212,
            3212,
            3212,
            3212,
            3212,
            3212,
            3213,
            0,
            0,
            0,
            0,
            3147,
            0,
            3149,
            3147,
            0,
            0,
            0,
            0,
            0,
            3149,
            0,
            0,
            3147,
            0,
            2758,
            2759,
            2759,
            2563,
            0,
            0,
            0,
            2759,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            3149,
            3211,
            3212,
            3141,
            0,
            3140,
            3212,
            3213,
            0,
            0,
            3147,
            0,
            3140,
            3212,
            3212,
            3213,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2631,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            8173,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            3149,
            0,
            0,
            3147,
            0,
            3149,
            0,
            0,
            0,
            0,
            3147,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            8205,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            3149,
            0,
            0,
            3147,
            0,
            2630,
            2631,
            2631,
            2631,
            2631,
            2632,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4178,
            0,
            4178,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            3149,
            0,
            0,
            3147,
            0,
            2758,
            2759,
            2759,
            2759,
            2759,
            2760,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            2630,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4178,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            3149,
            0,
            0,
            3211,
            3212,
            3212,
            3212,
            3212,
            3212,
            3212,
            3141,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2631,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2631,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2569,
            2631,
            2631,
            2632,
            0,
            2630,
            2631,
            2565,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2571,
            2759,
            2759,
            2760,
            0,
            2758,
            2759,
            2563,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            0,
            0,
            0,
            0,
            0,
            2630,
            2631,
            2631,
            2631,
            2631,
            2631,
            2631,
            2631,
            2632,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2631,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            0,
            0,
            0,
            0,
            0,
            2758,
            2759,
            2759,
            2759,
            2759,
            2759,
            2759,
            2759,
            2760,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            4178,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            0,
            0,
            0,
            0,
            0,
            3140,
            3212,
            3212,
            3212,
            3212,
            3212,
            3212,
            3212,
            3212,
            3212,
            3213,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3211,
            3212,
            3141,
            0,
            3140,
            3212,
            3212,
            3213,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4180,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2632,
            0,
            2630,
            0,
            0,
            2569,
            2631,
            2631,
            2631,
            2631,
            2631,
            2565,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            723,
            723,
            2567,
            2567,
            2567,
            2567,
            2567,
            2569,
            2631,
            2631,
            2631,
            2631,
            2565,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            2569,
            2631,
            2565,
            0,
            2632,
            2760,
            0,
            2758,
            2630,
            0,
            2571,
            2759,
            2759,
            2759,
            2759,
            2759,
            2563,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2632,
            0,
            0,
            0,
            0,
            0,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            2571,
            2759,
            2563,
            0,
            2760,
            0,
            0,
            0,
            2758,
            0,
            3147,
            0,
            3140,
            3212,
            3141,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2631,
            2631,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            3211,
            3212,
            3213,
            0,
            3141,
            0,
            0,
            0,
            3140,
            0,
            3147,
            0,
            3149,
            0,
            3147,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            2569,
            2631,
            2631,
            2631,
            2565,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2630,
            2631,
            2631,
            2631,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3141,
            0,
            3140,
            0,
            0,
            3147,
            0,
            2630,
            2631,
            2632,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            0,
            2759,
            2759,
            2759,
            0,
            2567,
            2567,
            4047,
            2567,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            2758,
            2759,
            2760,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            0,
            0,
            0,
            0,
            2630,
            2631,
            2631,
            4051,
            2567,
            0,
            4180,
            0,
            0,
            0,
            0,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            2632,
            0,
            3149,
            0,
            3147,
            0,
            2630,
            0,
            0,
            0,
            3211,
            3212,
            3212,
            3212,
            3212,
            3212,
            3213,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            2567,
            4047,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            2760,
            0,
            3149,
            0,
            3147,
            0,
            2758,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            0,
            0,
            0,
            0,
            0,
            2567,
            2567,
            2567,
            2567,
            2567,
            4047,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            3141,
            0,
            3149,
            0,
            3147,
            0,
            3140,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            0,
            0,
            4180,
            0,
            0,
            2567,
            2567,
            2567,
            2567,
            2567,
            0,
            2631,
            2631,
            2567,
            2567,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            2567,
            2567,
            0,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            2567,
            2567,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            2632,
            0,
            2630,
            0,
            2632,
            0,
            2630,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2631,
            2567,
            2567,
            0,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            4047,
            2567,
            2567,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            2760,
            0,
            2758,
            0,
            2760,
            0,
            2758,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            2567,
            0,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2569,
            2631,
            2631,
            4178,
            2631,
            2565,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            3141,
            0,
            3140,
            0,
            3212,
            3212,
            3212,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2631,
            2567,
            2567,
            0,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            2567,
            0,
            2631,
            2631,
            2631,
            2631,
            2631,
            2631,
            0,
            0,
            0,
            0,
            0,
            0,
            2631,
            2631,
            2631,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2631,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            2567,
            0,
            0,
            0,
            2567,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2631,
            2567,
            2567,
            0,
            0,
            2631,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            2567,
            0,
            0,
            0,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2567,
            2567,
            2567,
            0,
            0,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            2567,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 6,
          "name": "sprite",
          "opacity": 1,
          "properties": [
            {
              "name": "sprite",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 7,
          "name": "skyTrigger",
          "opacity": 1,
          "properties": [
            {
              "name": "skyTrigger",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4048,
            0,
            4049,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4306,
            0,
            4307,
            0,
            4309,
            4113,
            4308,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            3149,
            0,
            4050,
            0,
            4051,
            0,
            4047,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3211,
            3212,
            3213,
            0,
            4303,
            4113,
            4305,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4048,
            4049,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4304,
            0,
            4244,
            0,
            0,
            0,
            4303,
            4305,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4243,
            0,
            0,
            0,
            0,
            0,
            4048,
            0,
            4049,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4244,
            0,
            4048,
            0,
            4049,
            0,
            4049,
            0,
            4116,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4305,
            0,
            4181,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4242,
            0,
            0,
            0,
            0,
            0,
            4116,
            0,
            4113,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4048,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4303,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4306,
            0,
            0,
            0,
            0,
            4307,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4048,
            0,
            0,
            0,
            0,
            0,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4113,
            4242,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4049,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4306,
            0,
            0,
            0,
            4307,
            0,
            0,
            0,
            0,
            3147,
            0,
            0,
            0,
            0,
            4243,
            4113,
            4113,
            4113,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3211,
            0,
            3212,
            3212,
            3212,
            3213,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            0,
            0,
            4243,
            4113,
            4113,
            4305,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            0,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3211,
            3212,
            0,
            3212,
            3213,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4047,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4303,
            4113,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4047,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4113,
            0,
            0,
            4047,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4047,
            0,
            0,
            0,
            0,
            0,
            0,
            4306,
            0,
            0,
            0,
            0,
            4307,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4304,
            0,
            0,
            4048,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4303,
            4113,
            4113,
            4113,
            4113,
            4113,
            4113,
            4242,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            0,
            0,
            0,
            0,
            3212,
            3212,
            3212,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3147,
            0,
            0,
            0,
            0,
            3149,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4304,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3211,
            3212,
            3212,
            3212,
            3212,
            3213,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4113,
            0,
            0,
            0,
            4048,
            4304,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            4241,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 5,
          "name": "sky",
          "opacity": 1,
          "properties": [
            {
              "name": "sky",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            122,
            122,
            122,
            0,
            122,
            122,
            0,
            122,
            0,
            122,
            122,
            122,
            122,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            122,
            122,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            122,
            122,
            122,
            0,
            122,
            122,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            122,
            122,
            0,
            122,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            122,
            0,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            122,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            0,
            122,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 6,
          "name": "blocking",
          "opacity": 1,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "draworder": "topdown",
          "id": 1,
          "name": "objects",
          "objects": [
            {
              "class": "FRAGMENT",
              "height": 192,
              "id": 994,
              "name": "cave1",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "cave"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 192,
              "x": 0,
              "y": 0
            },
            {
              "class": "FRAGMENT",
              "height": 384,
              "id": 995,
              "name": "cave2",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "cave"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "large"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 192,
              "x": 224,
              "y": 0
            },
            {
              "class": "FRAGMENT",
              "height": 192,
              "id": 996,
              "name": "cave3",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "cave"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "large"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 416,
              "x": 448,
              "y": 0
            },
            {
              "class": "FRAGMENT",
              "height": 224,
              "id": 997,
              "name": "cave4",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "cave"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "large"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 416,
              "x": 448,
              "y": 224
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 1006,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "cave"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "mid_right"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 96,
              "y": 480
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 1007,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "cave"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "bottom_right"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 96,
              "y": 512
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 1008,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "cave"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "bottom_mid"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 64,
              "y": 512
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 1009,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "cave"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "bottom_left"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 32,
              "y": 512
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 1010,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "cave"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "mid_left"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 32,
              "y": 480
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1014,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "tunnel_entrance_left"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 32,
              "y": 576
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1017,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "tunnel_entrance_right"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 32,
              "y": 672
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1018,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "tunnel_entrance_top"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 32,
              "y": 768
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 1019,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "tunnel_entrance_bottom"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 32,
              "y": 864
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1031,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "top_left"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 160,
              "y": 416
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1032,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "top_mid"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 192,
              "y": 416
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1033,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "top_right"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 224,
              "y": 416
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 1034,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "mid_left"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 160,
              "y": 480
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 1035,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "mid_right"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 224,
              "y": 480
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1040,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "bottom_mid"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 192,
              "y": 480
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1044,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "cave"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "top_left"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 32,
              "y": 416
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1045,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "cave"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "top_mid"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 64,
              "y": 416
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1046,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "cave"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "top_right"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 96,
              "y": 416
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 1049,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "north_south"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 288,
              "y": 480
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1051,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "bottom_left"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 352,
              "y": 544
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1053,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "junction_9"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 160,
              "y": 544
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1057,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "junction_21"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 160,
              "y": 608
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1058,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "junction_all"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 224,
              "y": 544
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1059,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "bottom_right"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 384,
              "y": 544
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1060,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "junction_19"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 224,
              "y": 608
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1061,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "junction_16"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 288,
              "y": 608
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1063,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "end_right"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 352,
              "y": 640
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1064,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "end_left"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 352,
              "y": 736
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 1067,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "end_top"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 416,
              "y": 640
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 1069,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tunnel"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "end_bottom"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 416,
              "y": 672
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1071,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "object"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "door-up-down"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 480,
              "y": 480
            }
          ],
          "opacity": 1,
          "type": "objectgroup",
          "visible": true,
          "x": 0,
          "y": 0
        }
      ],
      "nextlayerid": 8,
      "nextobjectid": 1072,
      "orientation": "orthogonal",
      "renderorder": "right-down",
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tilesets": [
        {
          "firstgid": 1,
          "source": "../tilesets/lpc-terrain.tsx"
        },
        {
          "firstgid": 1025,
          "source": "../tilesets/plants.tsx"
        },
        {
          "firstgid": 1194,
          "source": "../tilesets/lpc-flowers-plants-fungi-wood.tsx"
        },
        {
          "firstgid": 1706,
          "source": "../tilesets/mountains-v6.tsx"
        },
        {
          "firstgid": 6826,
          "source": "../tilesets/ore.tsx"
        },
        {
          "firstgid": 7082,
          "source": "../tilesets/jungle-ruins.tsx"
        },
        {
          "firstgid": 8106,
          "source": "../tilesets/build_atlas.tsx"
        },
        {
          "firstgid": 9130,
          "source": "../tilesets/decorations-medieval.tsx"
        },
        {
          "firstgid": 10154,
          "source": "../tilesets/roofs.tsx"
        },
        {
          "firstgid": 14250,
          "source": "../tilesets/cottage.tsx"
        },
        {
          "firstgid": 14506,
          "source": "../tilesets/walls.tsx"
        }
      ],
      "tilewidth": 32,
      "type": "map",
      "version": "1.9",
      "width": 50
    },
    "geo": {
      "compressionlevel": -1,
      "height": 50,
      "infinite": false,
      "layers": [
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 1,
          "name": "map1",
          "opacity": 1,
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            8828,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            8828,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            378,
            378,
            378,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            378,
            378,
            378,
            378,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            378,
            378,
            378,
            378,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            378,
            378,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            378,
            378,
            378,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            378,
            378,
            378,
            378,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            813,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            378,
            378,
            378,
            378,
            0,
            0,
            0,
            0,
            378,
            378,
            378,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            813,
            606,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            813,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            378,
            378,
            378,
            0,
            0,
            0,
            0,
            0,
            378,
            378,
            378,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            606,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            813,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            813,
            0,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            378,
            378,
            378,
            378,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            606,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            378,
            378,
            378,
            378,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            0,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            378,
            378,
            378,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            606,
            723,
            723,
            723,
            723,
            723,
            783,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            638,
            813,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            606,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            813,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            813,
            606,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            813,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            606,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            813,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            813,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            606,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            606,
            723,
            723,
            723,
            723,
            723,
            783,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            638,
            813,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            606,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            257,
            258,
            259,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            257,
            227,
            290,
            226,
            258,
            259,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            257,
            227,
            290,
            290,
            290,
            290,
            291,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            289,
            290,
            290,
            290,
            290,
            194,
            323,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            321,
            195,
            290,
            290,
            194,
            323,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            321,
            322,
            322,
            323,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            257,
            259,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            257,
            258,
            258,
            259,
            321,
            323,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            289,
            290,
            290,
            226,
            258,
            259,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            289,
            290,
            290,
            290,
            290,
            291,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            257,
            227,
            290,
            290,
            290,
            194,
            323,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            321,
            322,
            322,
            322,
            322,
            323,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 2,
          "name": "map2",
          "opacity": 1,
          "properties": [
            {
              "name": "entityTileSurface",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            8828,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            8828,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            442,
            723,
            442,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            474,
            8828,
            474,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            8828,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 3,
          "name": "map3",
          "opacity": 0,
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2981,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3045,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            723,
            723,
            442,
            443,
            0,
            0,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            441,
            442,
            723,
            0,
            0,
            0,
            0,
            723,
            442,
            474,
            475,
            0,
            0,
            0,
            0,
            0,
            723,
            0,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            473,
            474,
            442,
            723,
            723,
            723,
            723,
            442,
            474,
            723,
            723,
            0,
            0,
            0,
            0,
            441,
            409,
            0,
            411,
            443,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            474,
            723,
            723,
            723,
            723,
            474,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            473,
            441,
            0,
            443,
            475,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            473,
            0,
            475,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            0,
            0,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            0,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            442,
            442,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            345,
            346,
            346,
            347,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            474,
            474,
            475,
            0,
            0,
            723,
            723,
            442,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            345,
            191,
            378,
            378,
            192,
            347,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            474,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            377,
            378,
            378,
            378,
            378,
            379,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            723,
            723,
            442,
            443,
            0,
            0,
            0,
            409,
            410,
            410,
            410,
            410,
            411,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            441,
            442,
            723,
            0,
            0,
            0,
            0,
            723,
            442,
            474,
            475,
            0,
            0,
            0,
            441,
            442,
            442,
            442,
            442,
            443,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            473,
            474,
            442,
            723,
            723,
            723,
            723,
            442,
            474,
            723,
            723,
            0,
            0,
            0,
            473,
            474,
            474,
            474,
            474,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            474,
            723,
            723,
            723,
            723,
            474,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            442,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            473,
            474,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 4,
          "name": "map4",
          "opacity": 1,
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            345,
            346,
            346,
            346,
            347,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            345,
            191,
            2104,
            2104,
            2104,
            192,
            346,
            347,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            345,
            191,
            2104,
            2104,
            2104,
            2104,
            2104,
            2104,
            192,
            347,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            345,
            191,
            2104,
            2104,
            2104,
            2104,
            2104,
            2104,
            2104,
            2104,
            379,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            377,
            2104,
            2104,
            2104,
            2104,
            2104,
            2104,
            2104,
            2104,
            224,
            411,
            0,
            0,
            0,
            0,
            723,
            345,
            346,
            346,
            347,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            409,
            223,
            2104,
            2104,
            2104,
            2104,
            2104,
            2104,
            224,
            411,
            0,
            0,
            0,
            0,
            0,
            345,
            191,
            104,
            104,
            379,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            409,
            223,
            2104,
            2104,
            2104,
            2104,
            224,
            411,
            443,
            0,
            0,
            0,
            0,
            0,
            409,
            223,
            104,
            224,
            411,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            441,
            409,
            410,
            410,
            410,
            410,
            411,
            443,
            475,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            410,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            473,
            441,
            442,
            442,
            442,
            442,
            443,
            475,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            473,
            474,
            474,
            474,
            474,
            475,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            345,
            346,
            347,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            377,
            2104,
            192,
            347,
            0,
            0,
            723,
            345,
            346,
            347,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            723,
            345,
            346,
            346,
            346,
            347,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            409,
            223,
            224,
            411,
            0,
            0,
            345,
            191,
            2104,
            379,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            345,
            191,
            2104,
            2104,
            2104,
            192,
            346,
            347,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            441,
            409,
            411,
            443,
            0,
            0,
            409,
            410,
            223,
            379,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            345,
            191,
            2104,
            2104,
            2104,
            2104,
            2104,
            2104,
            192,
            347,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            473,
            441,
            443,
            0,
            0,
            0,
            441,
            442,
            409,
            411,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            345,
            191,
            2104,
            2104,
            2104,
            2104,
            2104,
            2104,
            2104,
            2104,
            379,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            473,
            475,
            0,
            0,
            0,
            473,
            474,
            441,
            443,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            377,
            2104,
            2104,
            2104,
            2104,
            2104,
            2104,
            2104,
            2104,
            224,
            411,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            409,
            223,
            2104,
            2104,
            2104,
            2104,
            2104,
            2104,
            224,
            411,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            345,
            347,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            409,
            223,
            2104,
            2104,
            2104,
            2104,
            224,
            411,
            443,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            377,
            192,
            347,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            441,
            409,
            410,
            410,
            410,
            410,
            411,
            443,
            475,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            409,
            223,
            379,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            473,
            441,
            442,
            442,
            442,
            442,
            443,
            475,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            441,
            377,
            379,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            723,
            473,
            474,
            474,
            474,
            474,
            475,
            723,
            723,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            0,
            409,
            411,
            723,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            441,
            443,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            723,
            473,
            475,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1421,
            1421,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1602,
            1421,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1602,
            0,
            0,
            1421,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1421,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1133,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1602,
            0,
            0,
            1133,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1133,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1602,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1133,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 6,
          "name": "sprite",
          "opacity": 1,
          "properties": [
            {
              "name": "sprite",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 5,
          "name": "sky",
          "opacity": 1,
          "properties": [
            {
              "name": "sky",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 6,
          "name": "blocking",
          "opacity": 1,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": false,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "draworder": "topdown",
          "id": 1,
          "name": "objects",
          "objects": [
            {
              "class": "FRAGMENT",
              "height": 192,
              "id": 959,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "mountain"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"locationIcon\": \"cave.png\",\n  \"isDungeonEntrance\": true,\n  \"noResourceSpawn\": true\n}"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "minehill"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 160,
              "x": 768,
              "y": 416
            },
            {
              "class": "FRAGMENT",
              "height": 192,
              "id": 962,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "mountain"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"locationIcon\": \"cave.png\",\n  \"isDungeonEntrance\": true,\n  \"noResourceSpawn\": true\n}"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 128,
              "x": 1024,
              "y": 224
            },
            {
              "class": "FRAGMENT",
              "height": 128,
              "id": 963,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "mountain"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"locationIcon\": \"cave.png\",\n  \"isDungeonEntrance\": true,\n  \"noResourceSpawn\": true\n}"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 96,
              "x": 1280,
              "y": 288
            },
            {
              "class": "FRAGMENT",
              "height": 160,
              "id": 964,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "mountain"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"locationIcon\": \"cave.png\",\n  \"isDungeonEntrance\": true,\n  \"noResourceSpawn\": true\n}"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 128,
              "x": 1280,
              "y": 448
            },
            {
              "class": "FRAGMENT",
              "height": 160,
              "id": 966,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "mountain"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"noResourceSpawn\": true\n}"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 128,
              "x": 1280,
              "y": 672
            },
            {
              "class": "FRAGMENT",
              "height": 224,
              "id": 967,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "mountain"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"noResourceSpawn\": true\n}"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 96,
              "x": 1120,
              "y": 864
            },
            {
              "class": "FRAGMENT",
              "height": 384,
              "id": 972,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "mountain"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"noResourceSpawn\": true\n}"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 416,
              "x": 256,
              "y": 672
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 976,
              "name": "cavedoor",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "cavedoor"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "cavedoor"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 32,
              "y": 64
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 979,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"geo\",\n    \"tag\": \"cavedoor\",\n    \"category\": \"cavedoor\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 832,
              "y": 544
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 980,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"geo\",\n    \"tag\": \"cavedoor\",\n    \"category\": \"cavedoor\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1056,
              "y": 352
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 981,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"geo\",\n    \"tag\": \"cavedoor\",\n    \"category\": \"cavedoor\"\n  },\n  \"noResourceSpawn\": true\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1344,
              "y": 544
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 984,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"geo\",\n    \"tag\": \"cavedoor\",\n    \"category\": \"cavedoor\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1312,
              "y": 352
            },
            {
              "class": "FRAGMENT",
              "height": 192,
              "id": 988,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "mountain"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"noResourceSpawn\": true\n}"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 128,
              "x": 1088,
              "y": 640
            },
            {
              "class": "mapSpriteCap",
              "height": 0,
              "id": 989,
              "name": "",
              "point": true,
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1200.81165133596,
              "y": 762.907139728428
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1003,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"geo\",\n    \"tag\": \"grasses|trees\",\n    \"category\": \"geo\",\n    \"subcategory\": \"topping\",\n    \"renderStrategy\": \"sprite\",\n    \"context\": {\n       \"renderZIdxOffset\": 300\n    }\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 368.69281961956,
              "y": 759.246170138566
            },
            {
              "class": "FRAGMENT",
              "height": 192,
              "id": 1004,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "geo"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "topping"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "grasses"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 224,
              "x": 352,
              "y": 1120
            },
            {
              "class": "FRAGMENT",
              "height": 192,
              "id": 1008,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "geo"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "topping"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "trees"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 224,
              "x": 352,
              "y": 1344
            },
            {
              "class": "FRAGMENT",
              "height": 192,
              "id": 1009,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "geo"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "cover"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "grass1"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 224,
              "x": 96,
              "y": 1120
            },
            {
              "class": "FRAGMENT",
              "height": 192,
              "id": 1011,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "geo"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "cover"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "grass2"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 224,
              "x": 96,
              "y": 1344
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1012,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"geo\",\n    \"tag\": \"grass1|grass2\",\n    \"category\": \"geo\",\n    \"subcategory\": \"cover\",\n    \"renderStrategy\": \"sprite\",\n    \"context\": {\n       \"renderZIdxOffset\": 200\n    }\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 368.049121659673,
              "y": 749.904626955147
            },
            {
              "class": "FRAGMENT",
              "height": 192,
              "id": 1015,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "geo"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "cover"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "rock1"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 224,
              "x": 704,
              "y": 768
            },
            {
              "class": "FRAGMENT",
              "height": 384,
              "id": 1017,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "mountain"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"noResourceSpawn\": true\n}"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 416,
              "x": 256,
              "y": 256
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1018,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"geo\",\n    \"tag\": \"rock1\",\n    \"category\": \"geo\",\n    \"subcategory\": \"cover\",\n    \"renderStrategy\": \"sprite\",\n    \"context\": {\n       \"renderZIdxOffset\": 200\n    }\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 364.503952332967,
              "y": 342.057545526337
            },
            {
              "class": "FRAGMENT",
              "height": 96,
              "id": 1025,
              "name": "",
              "properties": [
                {
                  "name": "catalog",
                  "type": "string",
                  "value": "geo"
                },
                {
                  "name": "category",
                  "type": "string",
                  "value": "dirt"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 128,
              "x": 864,
              "y": 1024
            },
            {
              "class": "FRAGMENT",
              "height": 224,
              "id": 1027,
              "name": "",
              "properties": [
                {
                  "name": "catalog",
                  "type": "string",
                  "value": "geo"
                },
                {
                  "name": "category",
                  "type": "string",
                  "value": "dirt"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 224,
              "x": 768,
              "y": 1184
            },
            {
              "class": "FRAGMENT",
              "height": 192,
              "id": 1029,
              "name": "",
              "properties": [
                {
                  "name": "catalog",
                  "type": "string",
                  "value": "geo"
                },
                {
                  "name": "category",
                  "type": "string",
                  "value": "dirt"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 192,
              "x": 1120,
              "y": 1184
            },
            {
              "class": "FRAGMENT",
              "height": 192,
              "id": 1030,
              "name": "",
              "properties": [
                {
                  "name": "catalog",
                  "type": "string",
                  "value": "geo"
                },
                {
                  "name": "category",
                  "type": "string",
                  "value": "dirt"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 128,
              "x": 1472,
              "y": 768
            },
            {
              "class": "FRAGMENT",
              "height": 192,
              "id": 1031,
              "name": "",
              "properties": [
                {
                  "name": "catalog",
                  "type": "string",
                  "value": "geo"
                },
                {
                  "name": "category",
                  "type": "string",
                  "value": "dirt"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 192,
              "x": 1376,
              "y": 1024
            },
            {
              "class": "FRAGMENT",
              "height": 192,
              "id": 1032,
              "name": "",
              "properties": [
                {
                  "name": "catalog",
                  "type": "string",
                  "value": "geo"
                },
                {
                  "name": "category",
                  "type": "string",
                  "value": "dirt"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 224,
              "x": 1344,
              "y": 1408
            },
            {
              "class": "FRAGMENT",
              "height": 128,
              "id": 1033,
              "name": "",
              "properties": [
                {
                  "name": "catalog",
                  "type": "string",
                  "value": "geo"
                },
                {
                  "name": "category",
                  "type": "string",
                  "value": "dirt"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 160,
              "x": 992,
              "y": 1408
            },
            {
              "class": "FRAGMENT",
              "height": 160,
              "id": 1034,
              "name": "",
              "properties": [
                {
                  "name": "catalog",
                  "type": "string",
                  "value": "geo"
                },
                {
                  "name": "category",
                  "type": "string",
                  "value": "dirt"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 288,
              "x": 640,
              "y": 1440
            }
          ],
          "opacity": 1,
          "type": "objectgroup",
          "visible": true,
          "x": 0,
          "y": 0
        }
      ],
      "nextlayerid": 7,
      "nextobjectid": 1036,
      "orientation": "orthogonal",
      "renderorder": "right-down",
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tilesets": [
        {
          "firstgid": 1,
          "source": "../tilesets/lpc-terrain.tsx"
        },
        {
          "firstgid": 1025,
          "source": "../tilesets/plants.tsx"
        },
        {
          "firstgid": 1194,
          "source": "../tilesets/lpc-flowers-plants-fungi-wood.tsx"
        },
        {
          "firstgid": 1706,
          "source": "../tilesets/mountains-v6.tsx"
        },
        {
          "firstgid": 6826,
          "source": "../tilesets/ore.tsx"
        },
        {
          "firstgid": 7082,
          "source": "../tilesets/jungle-ruins.tsx"
        },
        {
          "firstgid": 8106,
          "source": "../tilesets/build_atlas.tsx"
        },
        {
          "firstgid": 9130,
          "source": "../tilesets/decorations-medieval.tsx"
        },
        {
          "firstgid": 10154,
          "source": "../tilesets/roofs.tsx"
        }
      ],
      "tilewidth": 32,
      "type": "map",
      "version": "1.9",
      "width": 50
    },
    "item": {
      "compressionlevel": -1,
      "height": 50,
      "infinite": false,
      "layers": [
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 1,
          "name": "map1",
          "opacity": 1,
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 2,
          "name": "map2",
          "opacity": 1,
          "properties": [
            {
              "name": "entityTileSurface",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            8757,
            8758,
            8757,
            8758,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            8789,
            8790,
            8821,
            8822,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            8821,
            8822,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 3,
          "name": "map3",
          "opacity": 1,
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 4,
          "name": "map4",
          "opacity": 1,
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 17,
          "name": "map5",
          "opacity": 1,
          "type": "tilelayer",
          "visible": false,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 18,
          "name": "map6",
          "opacity": 1,
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 6,
          "name": "sprite",
          "opacity": 1,
          "properties": [
            {
              "name": "sprite",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            20651,
            21053,
            21054,
            22313,
            22298,
            22299,
            22300,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            20667,
            21069,
            21070,
            0,
            22314,
            22315,
            22316,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 9,
          "name": "sprite2",
          "opacity": 1,
          "properties": [
            {
              "name": "sprite",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 10,
          "name": "sprite3",
          "opacity": 1,
          "properties": [
            {
              "name": "sprite",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 7,
          "name": "skyTrigger",
          "opacity": 1,
          "properties": [
            {
              "name": "skyTrigger",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": false,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 5,
          "name": "sky",
          "opacity": 1,
          "properties": [
            {
              "name": "sky",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 12,
          "name": "sky2",
          "opacity": 1,
          "properties": [
            {
              "name": "sky",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            122,
            122,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 6,
          "name": "blocking",
          "opacity": 0.25,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "draworder": "topdown",
          "id": 1,
          "name": "objects",
          "objects": [
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1195,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "barrel1"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"clearPointsForLayers\": [\"sprite\"]\n}"
                },
                {
                  "name": "craftableMeta",
                  "type": "string",
                  "value": "{\n    \"buildType\": \"entity\",\n    \"fragmentPointer\": {\n        \"catalog\": \"item\",\n        \"tag\": \"barrel1\"\n    },\n    \"itemType\": \"barrel1\"\n}\n"
                },
                {
                  "name": "itemId",
                  "type": "string",
                  "value": "barrel1"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "barrel1"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 0,
              "y": 0
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1196,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "stackedBags"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"mustBeFreeAtLayers\": [\"sprite\", \"sprite2\"]\n}"
                },
                {
                  "name": "craftableMeta",
                  "type": "string",
                  "value": "{\n    \"buildType\": \"entity\",\n    \"fragmentPointer\": {\n        \"catalog\": \"item\",\n        \"tag\": \"stackedBags\"\n    },\n    \"itemType\": \"stackedBags\"\n}\n"
                },
                {
                  "name": "itemId",
                  "type": "string",
                  "value": "stackedBags"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "stackedBags"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 64,
              "x": 32,
              "y": 0
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 1197,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "stool1"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n}"
                },
                {
                  "name": "craftableMeta",
                  "type": "string",
                  "value": "{\n    \"buildType\": \"entity\",\n    \"fragmentPointer\": {\n        \"catalog\": \"item\",\n        \"tag\": \"stool1\"\n    },\n    \"itemType\": \"stool1\"\n}\n"
                },
                {
                  "name": "itemId",
                  "type": "string",
                  "value": "stool1"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "stool1"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 96,
              "y": 0
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1200,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "midRoughTable"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"mustBeFreeAtLayers\": [\"sprite\", \"sprite2\"]\n}"
                },
                {
                  "name": "craftableMeta",
                  "type": "string",
                  "value": "{\n    \"buildType\": \"entity\",\n    \"fragmentPointer\": {\n        \"catalog\": \"item\",\n        \"tag\": \"midRoughTable\"\n    },\n    \"itemType\": \"table-mid-rough\"\n}\n"
                },
                {
                  "name": "itemId",
                  "type": "string",
                  "value": "table-mid-rough"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "midRoughTable"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 96,
              "x": 128,
              "y": 0
            },
            {
              "class": "FRAGMENT",
              "height": 96,
              "id": 1202,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "strawBed"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"mustBeFreeAtLayers\": [\"map3\"]\n}"
                },
                {
                  "name": "craftableMeta",
                  "type": "string",
                  "value": "{\n    \"buildType\": \"floor2\",\n    \"fragmentPointer\": {\n        \"catalog\": \"item\",\n        \"tag\": \"strawBed\"\n    },\n    \"itemType\": \"strawBed\"\n}\n"
                },
                {
                  "name": "itemId",
                  "type": "string",
                  "value": "strawBed"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "strawBed"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 64,
              "x": 0,
              "y": 64
            },
            {
              "class": "mapSpriteCap",
              "height": 0,
              "id": 1203,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"exclusive\": \"furniture-blonde-wood-128\"\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 113.380281690141,
              "y": 23.943661971831
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1205,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "strawBedSmall"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"mustBeFreeAtLayers\": [\"map3\"]\n}"
                },
                {
                  "name": "craftableMeta",
                  "type": "string",
                  "value": "{\n    \"buildType\": \"floor2\",\n    \"fragmentPointer\": {\n        \"catalog\": \"item\",\n        \"tag\": \"strawBedSmall\"\n    },\n    \"itemType\": \"strawBedSmall\"\n}\n"
                },
                {
                  "name": "itemId",
                  "type": "string",
                  "value": "strawBedSmall"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "strawBedSmall"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 64,
              "x": 64,
              "y": 64
            }
          ],
          "opacity": 1,
          "type": "objectgroup",
          "visible": true,
          "x": 0,
          "y": 0
        }
      ],
      "nextlayerid": 19,
      "nextobjectid": 1206,
      "orientation": "orthogonal",
      "renderorder": "right-down",
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tilesets": [
        {
          "firstgid": 1,
          "source": "../tilesets/lpc-terrain.tsx"
        },
        {
          "firstgid": 1025,
          "source": "../tilesets/plants.tsx"
        },
        {
          "firstgid": 1194,
          "source": "../tilesets/lpc-flowers-plants-fungi-wood.tsx"
        },
        {
          "firstgid": 1706,
          "source": "../tilesets/mountains-v6.tsx"
        },
        {
          "firstgid": 6826,
          "source": "../tilesets/ore.tsx"
        },
        {
          "firstgid": 7082,
          "source": "../tilesets/jungle-ruins.tsx"
        },
        {
          "firstgid": 8106,
          "source": "../tilesets/build_atlas.tsx"
        },
        {
          "firstgid": 9130,
          "source": "../tilesets/decorations-medieval.tsx"
        },
        {
          "firstgid": 10154,
          "source": "../tilesets/roofs.tsx"
        },
        {
          "firstgid": 14250,
          "source": "../tilesets/cottage.tsx"
        },
        {
          "firstgid": 14506,
          "source": "../tilesets/walls.tsx"
        },
        {
          "firstgid": 20650,
          "source": "../tilesets/container.tsx"
        },
        {
          "firstgid": 21674,
          "source": "../tilesets/fence_medieval.tsx"
        },
        {
          "firstgid": 22186,
          "source": "../tilesets/furniture-blonde-wood.tsx"
        }
      ],
      "tilewidth": 32,
      "type": "map",
      "version": "1.9",
      "width": 50
    },
    "ruins": {
      "compressionlevel": -1,
      "height": 50,
      "infinite": false,
      "layers": [
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 1,
          "name": "map1",
          "opacity": 1,
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 2,
          "name": "map2",
          "opacity": 1,
          "properties": [
            {
              "name": "entityTileSurface",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            8084,
            8086,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            8083,
            8085,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 3,
          "name": "map3",
          "opacity": 1,
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 4,
          "name": "map4",
          "opacity": 1,
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            7402,
            7628,
            7403,
            7404,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            7434,
            7435,
            7435,
            7436,
            0,
            0,
            7694,
            7559,
            7560,
            7539,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            7498,
            0,
            0,
            0,
            0,
            7629,
            7692,
            7591,
            7592,
            7571,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            7530,
            7531,
            7690,
            7694,
            0,
            7757,
            7691,
            7623,
            7624,
            7603,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            7562,
            7563,
            7563,
            7564,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            7594,
            7595,
            7756,
            7596,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            7520,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            7552,
            0,
            7553,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            7584,
            0,
            7584,
            0,
            7553,
            0,
            8019,
            8021,
            8022,
            0,
            0,
            8010,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            7616,
            0,
            7616,
            0,
            7616,
            0,
            8051,
            8053,
            8054,
            0,
            0,
            8076,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            8252,
            8253,
            8254,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 6,
          "name": "sprite",
          "opacity": 1,
          "properties": [
            {
              "name": "sprite",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            7484,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            7516,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            7516,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 5,
          "name": "sky",
          "opacity": 1,
          "properties": [
            {
              "name": "sky",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": false,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            122,
            0,
            122,
            0,
            122,
            122,
            122,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 6,
          "name": "blocking",
          "opacity": 1,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": false,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "draworder": "topdown",
          "id": 1,
          "name": "objects",
          "objects": [
            {
              "class": "FRAGMENT",
              "height": 192,
              "id": 927,
              "name": "smallBuilding",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "building"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 128,
              "x": 32,
              "y": 0
            },
            {
              "class": "FRAGMENT",
              "height": 96,
              "id": 928,
              "name": "mediumWall",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "fragment"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 160,
              "x": 192,
              "y": 32
            },
            {
              "class": "FRAGMENT",
              "height": 128,
              "id": 929,
              "name": "tallPillar",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "tall"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 192,
              "y": 192
            },
            {
              "class": "FRAGMENT",
              "height": 96,
              "id": 930,
              "name": "mediumPillar",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "tall"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 256,
              "y": 224
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 932,
              "name": "shortPillar",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "tall"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 320,
              "y": 256
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 940,
              "name": "rubble1",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "tall"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 384,
              "y": 256
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 941,
              "name": "rubble2",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "tall"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 416,
              "y": 256
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 942,
              "name": "rubble3",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "tall"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 448,
              "y": 256
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 943,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "tile"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 480,
              "y": 256
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 944,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "tile"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 512,
              "y": 256
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 945,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "tile"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 480,
              "y": 288
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 946,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "tile"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 512,
              "y": 288
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 948,
              "name": "seatedFigure1",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "tall"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 544,
              "y": 256
            },
            {
              "class": "FRAGMENTX",
              "height": 32,
              "id": 950,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "tall"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 96,
              "x": 192,
              "y": 352
            }
          ],
          "opacity": 1,
          "type": "objectgroup",
          "visible": true,
          "x": 0,
          "y": 0
        }
      ],
      "nextlayerid": 7,
      "nextobjectid": 952,
      "orientation": "orthogonal",
      "renderorder": "right-down",
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tilesets": [
        {
          "firstgid": 1,
          "source": "../tilesets/lpc-terrain.tsx"
        },
        {
          "firstgid": 1025,
          "source": "../tilesets/plants.tsx"
        },
        {
          "firstgid": 1194,
          "source": "../tilesets/lpc-flowers-plants-fungi-wood.tsx"
        },
        {
          "firstgid": 1706,
          "source": "../tilesets/mountains-v6.tsx"
        },
        {
          "firstgid": 6826,
          "source": "../tilesets/ore.tsx"
        },
        {
          "firstgid": 7082,
          "source": "../tilesets/jungle-ruins.tsx"
        },
        {
          "firstgid": 8106,
          "source": "../tilesets/build_atlas.tsx"
        }
      ],
      "tilewidth": 32,
      "type": "map",
      "version": "1.9",
      "width": 50
    },
    "settlement": {
      "compressionlevel": -1,
      "height": 50,
      "infinite": false,
      "layers": [
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            0,
            0,
            101,
            101,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            101,
            101,
            101,
            101,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 1,
          "name": "map1",
          "opacity": 1,
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            71,
            72,
            72,
            73,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            103,
            104,
            104,
            105,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            103,
            104,
            104,
            105,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            103,
            104,
            104,
            105,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            135,
            136,
            136,
            137,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            71,
            72,
            72,
            72,
            72,
            72,
            72,
            72,
            72,
            72,
            72,
            72,
            72,
            72,
            72,
            72,
            73,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            103,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            105,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            103,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            169,
            104,
            104,
            104,
            168,
            104,
            104,
            104,
            105,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            103,
            104,
            104,
            169,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            169,
            169,
            104,
            104,
            104,
            105,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            103,
            104,
            104,
            104,
            104,
            169,
            104,
            104,
            104,
            167,
            104,
            169,
            169,
            169,
            104,
            104,
            105,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            8397,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            103,
            104,
            104,
            167,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            169,
            169,
            104,
            104,
            105,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            8429,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            103,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            105,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            103,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            168,
            104,
            169,
            104,
            104,
            104,
            104,
            105,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            11920,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            103,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            105,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            11920,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            103,
            104,
            104,
            104,
            104,
            169,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            167,
            104,
            104,
            105,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            11920,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            103,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            168,
            104,
            104,
            105,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            103,
            104,
            104,
            168,
            104,
            167,
            104,
            104,
            104,
            169,
            104,
            104,
            104,
            104,
            104,
            104,
            105,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            103,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            169,
            104,
            169,
            104,
            104,
            104,
            105,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            103,
            104,
            104,
            104,
            104,
            104,
            169,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            105,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            773,
            773,
            773,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            103,
            104,
            104,
            104,
            104,
            104,
            169,
            169,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            105,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            773,
            773,
            773,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            103,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            168,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            105,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            773,
            773,
            773,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            103,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            104,
            105,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            135,
            136,
            136,
            136,
            136,
            136,
            136,
            136,
            136,
            136,
            136,
            136,
            136,
            136,
            136,
            136,
            137,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            773,
            773,
            773,
            773,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            773,
            773,
            773,
            773,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            773,
            773,
            773,
            773,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            773,
            773,
            773,
            773,
            773,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            773,
            773,
            773,
            773,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            773,
            773,
            8397,
            773,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            773,
            773,
            8429,
            773,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 2,
          "name": "map2",
          "opacity": 1,
          "properties": [
            {
              "name": "entityTileSurface",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            10090,
            10090,
            10090,
            10090,
            0,
            0,
            10090,
            10090,
            10090,
            10090,
            10090,
            10090,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10090,
            10090,
            10090,
            10090,
            0,
            10090,
            10090,
            10090,
            10090,
            10090,
            10090,
            10090,
            10090,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10090,
            10090,
            10090,
            10090,
            0,
            10090,
            10090,
            10090,
            10090,
            10090,
            10090,
            10090,
            10090,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10090,
            0,
            0,
            10090,
            0,
            10090,
            10090,
            10090,
            10090,
            10090,
            10090,
            10090,
            10090,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10090,
            10090,
            10090,
            10009,
            0,
            10090,
            10090,
            10090,
            10090,
            10090,
            10090,
            10090,
            10090,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            11468,
            11468,
            11468,
            11468,
            11468,
            11468,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            11468,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            11468,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            11468,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            11468,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            11468,
            0,
            0,
            0,
            14259,
            14260,
            14260,
            14260,
            14252,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            107,
            107,
            107,
            107,
            107,
            107,
            107,
            107,
            107,
            107,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            11468,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            107,
            107,
            107,
            107,
            107,
            107,
            107,
            107,
            107,
            107,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            11468,
            0,
            0,
            0,
            0,
            0,
            0,
            8174,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            107,
            107,
            107,
            107,
            107,
            107,
            107,
            107,
            107,
            107,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            11468,
            0,
            0,
            597,
            597,
            597,
            597,
            597,
            597,
            597,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            107,
            107,
            107,
            107,
            107,
            107,
            107,
            107,
            107,
            107,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            677,
            677,
            677,
            677,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            107,
            107,
            107,
            107,
            107,
            107,
            107,
            107,
            107,
            107,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            677,
            677,
            677,
            677,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            9674,
            9675,
            9675,
            9676,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            107,
            107,
            107,
            107,
            107,
            107,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            677,
            677,
            677,
            677,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            9690,
            9691,
            9691,
            9692,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            107,
            107,
            107,
            107,
            107,
            107,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            677,
            677,
            677,
            677,
            0,
            677,
            677,
            677,
            677,
            677,
            677,
            677,
            0,
            0,
            0,
            0,
            9690,
            9691,
            9691,
            9692,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            107,
            107,
            107,
            107,
            107,
            107,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            677,
            677,
            677,
            677,
            0,
            677,
            677,
            677,
            677,
            677,
            677,
            677,
            0,
            0,
            0,
            0,
            9706,
            9707,
            9707,
            9708,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            677,
            677,
            677,
            677,
            0,
            677,
            677,
            677,
            677,
            677,
            677,
            677,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            677,
            677,
            677,
            677,
            0,
            677,
            677,
            677,
            677,
            677,
            677,
            677,
            0,
            0,
            0,
            0,
            9674,
            9675,
            9676,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            9690,
            9691,
            9692,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            9706,
            9707,
            9708,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            107,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            107,
            107,
            107,
            107,
            107,
            107,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            107,
            107,
            107,
            107,
            107,
            107,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            107,
            107,
            107,
            107,
            107,
            107,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            107,
            107,
            107,
            107,
            107,
            107,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            17179,
            17179,
            17179,
            17179,
            0,
            104,
            104,
            104,
            104,
            104,
            104,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            107,
            107,
            107,
            107,
            107,
            107,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            104,
            104,
            104,
            104,
            104,
            104,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            107,
            107,
            107,
            107,
            107,
            107,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            8174,
            0,
            0,
            104,
            104,
            104,
            104,
            104,
            104,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            107,
            107,
            107,
            107,
            107,
            107,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            104,
            104,
            104,
            104,
            104,
            104,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            104,
            104,
            104,
            104,
            104,
            104,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            104,
            104,
            104,
            104,
            104,
            104,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 3,
          "name": "map3",
          "opacity": 1,
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            14427,
            14427,
            14427,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            14427,
            14427,
            14427,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15802,
            15802,
            15802,
            15802,
            15802,
            15802,
            15802,
            15802,
            15802,
            15802,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15930,
            15930,
            15930,
            15930,
            15930,
            15930,
            15930,
            15930,
            15930,
            15930,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            8757,
            8758,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            8789,
            8790,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            8821,
            8822,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            816,
            816,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            816,
            816,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            816,
            816,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            816,
            816,
            0,
            0,
            0,
            816,
            816,
            816,
            816,
            816,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            816,
            816,
            0,
            0,
            0,
            816,
            816,
            816,
            816,
            816,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            773,
            773,
            773,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            773,
            773,
            773,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            773,
            773,
            773,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15818,
            15820,
            15818,
            15820,
            15818,
            15820,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            9924,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15882,
            15884,
            15882,
            15884,
            15882,
            15884,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            743,
            743,
            743,
            743,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            743,
            743,
            743,
            743,
            0,
            15802,
            15802,
            15802,
            15802,
            15802,
            15802,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            14451,
            14451,
            14452,
            14453,
            0,
            15930,
            15930,
            15930,
            15930,
            15930,
            15930,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            17179,
            17179,
            743,
            17179,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            17179,
            17179,
            743,
            17179,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 4,
          "name": "map4",
          "opacity": 1,
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 17,
          "name": "map5",
          "opacity": 1,
          "type": "tilelayer",
          "visible": false,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 18,
          "name": "map6",
          "opacity": 1,
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            10007,
            10008,
            0,
            0,
            0,
            9931,
            9939,
            9939,
            9939,
            9940,
            9935,
            0,
            0,
            0,
            9459,
            9460,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10022,
            10023,
            10024,
            10025,
            0,
            9946,
            9947,
            0,
            0,
            0,
            0,
            9951,
            9952,
            0,
            0,
            9475,
            9476,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10038,
            10089,
            10089,
            10041,
            0,
            9962,
            9963,
            0,
            0,
            0,
            0,
            9967,
            9968,
            0,
            0,
            9491,
            9492,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10054,
            0,
            0,
            10057,
            0,
            9978,
            9979,
            0,
            0,
            0,
            0,
            9983,
            9984,
            0,
            0,
            9507,
            9508,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10070,
            10071,
            10072,
            10073,
            0,
            9994,
            9995,
            9996,
            0,
            0,
            9998,
            9999,
            10000,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15818,
            15820,
            15818,
            15820,
            15818,
            15820,
            15818,
            15820,
            15818,
            15820,
            15818,
            15820,
            15821,
            15818,
            15820,
            15818,
            15820,
            15818,
            15820,
            15818,
            15820,
            15818,
            15820,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15882,
            15884,
            15882,
            15884,
            15597,
            15407,
            15407,
            15407,
            15407,
            15407,
            15407,
            15407,
            15407,
            15407,
            15407,
            15407,
            15407,
            15407,
            15601,
            15882,
            15884,
            15882,
            15884,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10181,
            0,
            0,
            0,
            0,
            0,
            0,
            20986,
            20987,
            20696,
            20697,
            0,
            0,
            15690,
            0,
            0,
            0,
            15473,
            15791,
            15791,
            15791,
            15791,
            15792,
            20214,
            20215,
            20216,
            15792,
            15791,
            15791,
            15791,
            15792,
            15473,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            21930,
            21966,
            21966,
            21966,
            21934,
            0,
            0,
            0,
            0,
            0,
            10244,
            10245,
            10246,
            0,
            0,
            0,
            0,
            0,
            21002,
            21003,
            20712,
            20713,
            0,
            0,
            15690,
            0,
            0,
            0,
            15473,
            15855,
            15855,
            15855,
            15855,
            15856,
            20278,
            20279,
            20280,
            15856,
            15855,
            15855,
            15855,
            15856,
            15473,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            21946,
            21982,
            21982,
            21982,
            21951,
            0,
            0,
            0,
            0,
            10307,
            10308,
            10309,
            10310,
            10311,
            0,
            0,
            8799,
            8800,
            8801,
            8391,
            0,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            15473,
            15919,
            15919,
            15919,
            15919,
            15920,
            20278,
            0,
            20280,
            15920,
            15919,
            15919,
            15919,
            15920,
            15473,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            21946,
            21982,
            21982,
            21982,
            21951,
            0,
            0,
            0,
            13526,
            10371,
            10372,
            10373,
            10374,
            10375,
            13533,
            0,
            8831,
            8832,
            8833,
            8423,
            0,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            15473,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15473,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            21949,
            0,
            0,
            0,
            21919,
            0,
            0,
            0,
            13590,
            10435,
            10436,
            0,
            10438,
            10439,
            13597,
            0,
            8736,
            8737,
            0,
            8393,
            8457,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            15537,
            0,
            0,
            15610,
            15611,
            15611,
            15611,
            15611,
            15611,
            15611,
            15611,
            15611,
            15612,
            0,
            15537,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            21950,
            21966,
            21966,
            21966,
            21887,
            0,
            0,
            0,
            13590,
            10499,
            0,
            0,
            0,
            10503,
            13597,
            0,
            8768,
            8769,
            0,
            8425,
            8489,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            15791,
            0,
            0,
            15674,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15676,
            0,
            15791,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            21982,
            21982,
            21982,
            21982,
            21982,
            0,
            0,
            0,
            0,
            14266,
            14276,
            14276,
            0,
            14268,
            0,
            0,
            0,
            0,
            8585,
            9456,
            0,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            15855,
            0,
            0,
            15674,
            0,
            0,
            15675,
            0,
            0,
            0,
            0,
            0,
            15676,
            0,
            15855,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            21982,
            22016,
            21982,
            21982,
            21982,
            0,
            0,
            0,
            0,
            14282,
            14292,
            14292,
            0,
            14284,
            0,
            0,
            0,
            0,
            0,
            9472,
            0,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            15919,
            0,
            0,
            15738,
            15739,
            15739,
            15739,
            15547,
            0,
            0,
            0,
            0,
            15676,
            0,
            15919,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            8585,
            0,
            0,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            0,
            0,
            0,
            15802,
            15802,
            15802,
            15803,
            15674,
            0,
            0,
            0,
            0,
            15676,
            0,
            0,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            15409,
            0,
            0,
            15930,
            15930,
            15930,
            15931,
            15674,
            0,
            0,
            0,
            0,
            15676,
            0,
            15409,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            15473,
            0,
            0,
            0,
            0,
            0,
            0,
            15738,
            15739,
            15739,
            15739,
            15739,
            15740,
            0,
            15473,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            15473,
            0,
            0,
            0,
            0,
            9896,
            0,
            15802,
            15802,
            8628,
            8629,
            15803,
            15804,
            0,
            15473,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            15473,
            0,
            0,
            0,
            0,
            9912,
            0,
            15930,
            15930,
            8660,
            8661,
            15932,
            15933,
            0,
            15473,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            15473,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15473,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            15725,
            15407,
            15407,
            15407,
            15407,
            15407,
            15407,
            15407,
            15407,
            15407,
            15407,
            15407,
            15407,
            15407,
            15729,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            15791,
            15791,
            15791,
            15790,
            15791,
            15792,
            20214,
            20215,
            20216,
            15792,
            15792,
            15792,
            15792,
            15792,
            15791,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            15855,
            15855,
            15855,
            15854,
            15855,
            15856,
            20278,
            20279,
            20280,
            15856,
            15856,
            15856,
            15856,
            15856,
            15855,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            15919,
            15919,
            15919,
            15918,
            15919,
            15920,
            20278,
            0,
            20280,
            15920,
            15920,
            15920,
            15920,
            15920,
            15919,
            15821,
            0,
            15818,
            15820,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22336,
            22337,
            22258,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15885,
            0,
            15882,
            15884,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22352,
            22353,
            22274,
            0,
            22313,
            0,
            0,
            0,
            0,
            0,
            0,
            15754,
            15755,
            15755,
            15755,
            15755,
            15755,
            15755,
            15755,
            15755,
            15755,
            15755,
            15755,
            15755,
            15755,
            15755,
            15755,
            15755,
            15755,
            15755,
            15755,
            15755,
            15755,
            15756,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22290,
            0,
            22311,
            0,
            0,
            0,
            0,
            0,
            0,
            15818,
            15820,
            15818,
            15820,
            15820,
            15818,
            15820,
            15818,
            15820,
            15818,
            15820,
            15818,
            15820,
            15818,
            15820,
            15818,
            15820,
            15818,
            15820,
            15818,
            15820,
            0,
            15820,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15882,
            15884,
            15882,
            15884,
            15884,
            15882,
            15884,
            15882,
            15884,
            15882,
            15884,
            15882,
            15884,
            15882,
            15884,
            15882,
            15884,
            15882,
            15884,
            15882,
            15884,
            0,
            15884,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22189,
            22190,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22205,
            22206,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            9641,
            0,
            9673,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            18122,
            18122,
            18122,
            18123,
            18124,
            18125,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15626,
            15627,
            15627,
            15627,
            15627,
            15628,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            18186,
            18186,
            18186,
            18187,
            18188,
            18189,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            9641,
            0,
            9673,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            11502,
            11503,
            11503,
            11505,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            11566,
            11567,
            11567,
            11569,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            11630,
            11567,
            11567,
            11633,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            11694,
            11695,
            11695,
            11697,
            0,
            15610,
            15611,
            15611,
            15611,
            15611,
            15612,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15690,
            0,
            0,
            0,
            0,
            15692,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            11758,
            11759,
            11759,
            11759,
            0,
            15674,
            0,
            0,
            0,
            0,
            15676,
            21754,
            21678,
            21678,
            21711,
            0,
            0,
            0,
            0,
            15754,
            15755,
            15755,
            15755,
            15755,
            15756,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            14467,
            14467,
            0,
            14469,
            0,
            15674,
            0,
            0,
            0,
            0,
            15676,
            0,
            0,
            0,
            21694,
            0,
            0,
            0,
            0,
            15818,
            15820,
            15626,
            15628,
            15818,
            15820,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            14483,
            14483,
            0,
            14485,
            0,
            15674,
            0,
            0,
            0,
            0,
            15676,
            0,
            0,
            0,
            21694,
            0,
            0,
            0,
            0,
            15882,
            15884,
            15690,
            15692,
            15882,
            15884,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15738,
            15739,
            0,
            15739,
            15739,
            15740,
            0,
            0,
            0,
            21694,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            15755,
            15739,
            0,
            15802,
            15802,
            0,
            15803,
            15803,
            15804,
            0,
            0,
            0,
            21694,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            16167,
            16167,
            16167,
            0,
            15930,
            15930,
            0,
            15932,
            15932,
            15933,
            21711,
            0,
            0,
            21694,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            9743,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            21694,
            0,
            0,
            21694,
            0,
            0,
            0,
            0,
            14478,
            14478,
            14478,
            14478,
            14478,
            14478,
            0,
            9741,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            9759,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            21741,
            21755,
            21678,
            21743,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22308,
            22309,
            22310,
            0,
            9757,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            9773,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 6,
          "name": "sprite",
          "opacity": 1,
          "properties": [
            {
              "name": "sprite",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22135,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22151,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22135,
            22136,
            8109,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22151,
            22152,
            8141,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22615,
            22616,
            22617,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22631,
            22632,
            22633,
            0,
            22305,
            22306,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            20790,
            20806,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22647,
            22648,
            22649,
            0,
            22321,
            22322,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 9,
          "name": "sprite2",
          "opacity": 1,
          "properties": [
            {
              "name": "sprite",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 10,
          "name": "sprite3",
          "opacity": 1,
          "properties": [
            {
              "name": "sprite",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            9997,
            9997,
            9997,
            9997,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            9997,
            9997,
            9997,
            9997,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            9997,
            9997,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10064,
            10064,
            10064,
            10064,
            10064,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10064,
            10064,
            10064,
            10064,
            10064,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10064,
            10064,
            10064,
            10064,
            10064,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10064,
            10064,
            10064,
            10064,
            10064,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 7,
          "name": "skyTrigger",
          "opacity": 1,
          "properties": [
            {
              "name": "skyTrigger",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": false,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            9932,
            9933,
            9933,
            9934,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            9948,
            9949,
            9949,
            9950,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10039,
            10040,
            0,
            0,
            0,
            0,
            9964,
            9965,
            9965,
            9966,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10055,
            10056,
            0,
            0,
            0,
            0,
            9980,
            9981,
            9981,
            9982,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22076,
            22076,
            22076,
            22076,
            22076,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22091,
            22092,
            22124,
            22124,
            22124,
            22092,
            22093,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22091,
            22092,
            22092,
            22092,
            22092,
            22092,
            22093,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            12341,
            12344,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22091,
            22092,
            22124,
            22124,
            22124,
            22092,
            22093,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            12340,
            12342,
            12343,
            12344,
            12341,
            12342,
            12405,
            12408,
            12343,
            12344,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22091,
            22124,
            22124,
            22092,
            22092,
            22092,
            22093,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            13526,
            12404,
            12405,
            12407,
            12407,
            12469,
            12405,
            12405,
            12472,
            12407,
            12408,
            13533,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22091,
            22092,
            22092,
            22092,
            22092,
            22124,
            22093,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            13590,
            12404,
            12405,
            12407,
            12407,
            12469,
            12405,
            12405,
            12472,
            12471,
            12472,
            13597,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            22108,
            22108,
            22108,
            22108,
            22108,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            13590,
            12404,
            12405,
            12407,
            12407,
            12469,
            12405,
            12405,
            12472,
            12407,
            12408,
            13597,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            13590,
            12532,
            12534,
            12535,
            12536,
            12469,
            12405,
            12405,
            12408,
            12407,
            12408,
            13597,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            13654,
            0,
            0,
            0,
            13526,
            12469,
            12405,
            12405,
            12408,
            12407,
            12408,
            13597,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            13590,
            12469,
            12469,
            12533,
            12536,
            12407,
            12408,
            13597,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            13590,
            12533,
            12534,
            0,
            0,
            12535,
            12536,
            13597,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            13654,
            0,
            0,
            0,
            0,
            0,
            0,
            13661,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            12331,
            12332,
            12332,
            12333,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            12395,
            12396,
            12396,
            12397,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            12459,
            12460,
            12460,
            12461,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            11947,
            12203,
            12204,
            12204,
            12205,
            11949,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            12138,
            12011,
            12203,
            12204,
            12205,
            12205,
            12013,
            12142,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            9541,
            9542,
            9542,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            12202,
            12011,
            12203,
            12204,
            12204,
            12205,
            12013,
            12206,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            9557,
            9558,
            9558,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            12202,
            12011,
            12203,
            12204,
            12205,
            12205,
            12013,
            12206,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            9573,
            0,
            9574,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            12202,
            12011,
            12203,
            12204,
            12205,
            12205,
            12013,
            12206,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            12341,
            12344,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            12202,
            12011,
            12203,
            12204,
            12204,
            12205,
            12013,
            12206,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            12341,
            12342,
            12405,
            12408,
            12343,
            12344,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            12202,
            12011,
            12204,
            12204,
            12204,
            12204,
            12013,
            12206,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            13526,
            12469,
            12405,
            12405,
            12472,
            12407,
            12408,
            13533,
            0,
            0,
            0,
            0,
            0,
            0,
            12202,
            12011,
            12204,
            12204,
            12205,
            12205,
            12013,
            12206,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            13590,
            12469,
            12405,
            12405,
            12472,
            12471,
            12472,
            13597,
            0,
            0,
            0,
            0,
            0,
            0,
            12202,
            12522,
            0,
            0,
            0,
            0,
            12526,
            12206,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            13590,
            12469,
            12405,
            12405,
            12472,
            12407,
            12408,
            13597,
            0,
            0,
            0,
            0,
            0,
            0,
            12266,
            0,
            0,
            0,
            0,
            0,
            0,
            12270,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            13590,
            12469,
            12469,
            12533,
            12536,
            12407,
            12408,
            13597,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            13590,
            12533,
            12534,
            0,
            0,
            12535,
            12536,
            13597,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            13654,
            0,
            0,
            0,
            0,
            0,
            0,
            13661,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 5,
          "name": "sky",
          "opacity": 1,
          "properties": [
            {
              "name": "sky",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 12,
          "name": "sky2",
          "opacity": 1,
          "properties": [
            {
              "name": "sky",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "data": [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            958,
            959,
            959,
            960,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            990,
            959,
            959,
            992,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            990,
            0,
            0,
            992,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1022,
            0,
            0,
            1024,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            122,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            122,
            122,
            0,
            122,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            122,
            122,
            0,
            0,
            122,
            122,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            0,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            122,
            0,
            122,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            0,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            0,
            122,
            122,
            122,
            122,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            0,
            0,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            122,
            122,
            122,
            122,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
          ],
          "height": 50,
          "id": 6,
          "name": "blocking",
          "opacity": 0.25,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ],
          "type": "tilelayer",
          "visible": true,
          "width": 50,
          "x": 0,
          "y": 0
        },
        {
          "draworder": "topdown",
          "id": 1,
          "name": "objects",
          "objects": [
            {
              "class": "FRAGMENT",
              "height": 192,
              "id": 951,
              "name": "smallTent",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tent"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"transportTarget\": true,\n  \"noResourceSpawn\": true\n}"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 192,
              "x": 0,
              "y": 0
            },
            {
              "class": "FRAGMENT",
              "height": 160,
              "id": 952,
              "name": "largeTent",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "tent"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"transportTarget\": true,\n  \"noResourceSpawn\": true\n}"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "large"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 256,
              "x": 192,
              "y": 0
            },
            {
              "class": "FRAGMENT",
              "height": 96,
              "id": 958,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "hay"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 64,
              "x": 544,
              "y": 416
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 959,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "woodPile"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 608,
              "y": 448
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 962,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "barrel"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 64,
              "x": 640,
              "y": 352
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 963,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "hayCart"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 96,
              "x": 544,
              "y": 288
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 964,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "fork"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 640,
              "y": 416
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 965,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "emptyCart"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 64,
              "x": 544,
              "y": 352
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 966,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "barrel"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 640,
              "y": 288
            },
            {
              "class": "FRAGMENT",
              "height": 128,
              "id": 968,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "platform"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "large"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "woodPlatform"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 128,
              "x": 576,
              "y": 544
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 970,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "bucket"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 608,
              "y": 416
            },
            {
              "class": "FRAGMENT",
              "height": 96,
              "id": 971,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "platform"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "woodPlatform"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 96,
              "x": 576,
              "y": 704
            },
            {
              "class": "FRAGMENT",
              "height": 256,
              "id": 974,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "house"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": ""
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 224,
              "x": 288,
              "y": 224
            },
            {
              "class": "FRAGMENT",
              "height": 224,
              "id": 975,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "house"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": ""
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 128,
              "x": 640,
              "y": 1184
            },
            {
              "class": "FRAGMENT",
              "height": 128,
              "id": 976,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "field"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 224,
              "x": 224,
              "y": 608
            },
            {
              "class": "FRAGMENT",
              "height": 224,
              "id": 977,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "field"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 128,
              "x": 64,
              "y": 512
            },
            {
              "class": "FRAGMENT",
              "height": 768,
              "id": 980,
              "name": "warlordCompound",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "compound"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"locationIcon\": \"castle.png\",\n  \"noResourceSpawn\": true,\n  \"noProximitySpawn\": true\n}"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "warlord1"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 736,
              "x": 800,
              "y": 160
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 983,
              "name": "warlord",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"warlord\"\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1245.77564558162,
              "y": 471.023058571008
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 984,
              "name": "guard",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"guard\",\n  \"vassalCount\": 4\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1168.5951196399,
              "y": 345.896532817096
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 985,
              "name": "guard",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"guard\",\n  \"vassalCount\": 4\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1392.06666779218,
              "y": 507.640213111478
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 986,
              "name": "guard",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"guard\",\n  \"vassalCount\": 4\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 993.372026906084,
              "y": 503.889918076573
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 987,
              "name": "guard",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"guard\",\n  \"vassalCount\": 4\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1166.87119992558,
              "y": 755.22688551167
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 988,
              "name": "guard",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"guard\",\n  \"vassalCount\": 4\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1198.9196872779,
              "y": 503.164179104478
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 989,
              "name": "guard",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"guard\",\n  \"vassalCount\": 4\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1297.4745321014,
              "y": 502.21653636579
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 990,
              "name": "guard",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"guard\",\n  \"vassalCount\": 4\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1056.29945510543,
              "y": 607.878701729448
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 991,
              "name": "guard",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"guard\",\n  \"vassalCount\": 4\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1245.22309163037,
              "y": 675.574357458389
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 992,
              "name": "guard",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"guard\",\n  \"vassalCount\": 4\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1246.30182421227,
              "y": 549.467583456947
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 993,
              "name": "guard",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"guard\",\n  \"vassalCount\": 4\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1009.86496090974,
              "y": 704.064439706231
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 994,
              "name": "entrance",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"tentCampaign\": true,\n  \"type\": \"entrance\"\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 96.6429298067141,
              "y": 156.832824686334
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 995,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"stackedBoxes\",\n    \"category\": \"stackedBoxes\",\n    \"subcategory\": \"medium\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 335.729420461832,
              "y": 26.8907795529035
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 996,
              "name": "trader",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"trader\": {}\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 273.478906084376,
              "y": 72.7863755211646
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 997,
              "name": "entrance",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"tentCampaign\": true,\n  \"type\": \"entrance\"\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 315.515649911891,
              "y": 129.646723168583
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 998,
              "name": "guard",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"guard\",\n  \"boundToWarlord\": true,\n  \"weapon\": \"dagger\"\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1293.04197136229,
              "y": 1305.69361106082
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 999,
              "name": "guard",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"guard\",\n  \"boundToWarlord\": true,\n  \"weapon\": \"axe\"\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1335.70161297231,
              "y": 1306.38675409772
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1001,
              "name": "guard",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"guard\",\n  \"boundToWarlord\": true,\n  \"weapon\": \"spear\"\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1314.99774735056,
              "y": 1268.03479709253
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1002,
              "name": "guard",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"guard\",\n  \"weapon\": \"axe\"\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1389.32773558251,
              "y": 1438.67752049268
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1003,
              "name": "guard",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"guard\",\n  \"weapon\": \"spear\"\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1294.47305571578,
              "y": 1438.11331376733
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1005,
              "name": "guard",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"guard\",\n  \"vassalCount\": 2\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1345.73229821573,
              "y": 1438.06368463239
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1008,
              "name": "warlord",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"warlord\"\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1313.16480433151,
              "y": 1241.18411348239
            },
            {
              "class": "FRAGMENT",
              "height": 416,
              "id": 1009,
              "name": "warlordSubCompound",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "compound"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"locationIcon\": \"building.png\",\n  \"noResourceSpawn\": true,\n  \"noProximitySpawn\": true\n}"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "warlordSmall"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 320,
              "x": 1184,
              "y": 1056
            },
            {
              "class": "FRAGMENT",
              "height": 352,
              "id": 1013,
              "name": "warlordSubCompound",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "compound"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"locationIcon\": \"building.png\",\n  \"noResourceSpawn\": true\n}"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "warlordSmall"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 352,
              "x": 768,
              "y": 1216
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1014,
              "name": "warlord",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"warlord\"\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 887.106846912483,
              "y": 1400.02211214174
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1015,
              "name": "guard",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"guard\",\n  \"boundToWarlord\": true,\n  \"weapon\": \"axe\"\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 865.559103927082,
              "y": 1422.49385849316
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1016,
              "name": "guard",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"guard\",\n  \"boundToWarlord\": true,\n  \"weapon\": \"spear\"\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 902.678005950269,
              "y": 1423.67160646618
            },
            {
              "class": "mapSpriteCap",
              "height": 0,
              "id": 1025,
              "name": "",
              "point": true,
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 645.131976473575,
              "y": 295.075614606694
            },
            {
              "class": "mapSpriteCap",
              "height": 0,
              "id": 1026,
              "name": "",
              "point": true,
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 646.976685143655,
              "y": 359.666567934668
            },
            {
              "class": "mapSpriteCap",
              "height": 0,
              "id": 1027,
              "name": "",
              "point": true,
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 678.905591769766,
              "y": 361.403041993703
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1039,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "stackedBoxes"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "stackedBoxes"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 64,
              "x": 608,
              "y": 224
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1040,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"stackedBoxes\",\n    \"category\": \"stackedBoxes\",\n    \"subcategory\": \"medium\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1042.29814084459,
              "y": 1396.68480878788
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1042,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"bucket2\",\n    \"category\": \"decoration\",\n    \"subcategory\": \"small\",\n    \"renderStrategy\": \"sprite\",\n    \"context\": {\n       \"absolutePosition\": true\n    }\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 858.02437276563,
              "y": 1384.05630234478
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1045,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"fork\",\n    \"category\": \"decoration\",\n    \"subcategory\": \"small\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1006.83133945364,
              "y": 1401.65923032355
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1046,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"wallDeco1\",\n    \"category\": \"decoration\",\n    \"subcategory\": \"building\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 846.931140966989,
              "y": 1465.41213777149
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 1048,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "bucket2"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 608,
              "y": 480
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1051,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"veryLargeBarrel\",\n    \"category\": \"veryLargeBarrel\",\n    \"subcategory\": \"medium\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1030.23366043325,
              "y": 1305.3486391409
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1054,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"largeCabinet\",\n    \"category\": \"largeCabinet\",\n    \"subcategory\": \"medium\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 817.974787903599,
              "y": 1329.90997678676
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1055,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "roofShadow"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "roofShadow"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 192,
              "x": 800,
              "y": 1120
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1056,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"stackedBoxes\",\n    \"category\": \"stackedBoxes\",\n    \"subcategory\": \"medium\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1008.89060688056,
              "y": 1361.42249710089
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1058,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "largeCabinet"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "largeCabinet"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 64,
              "x": 448,
              "y": 800
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1059,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"largeCabinetSide\",\n    \"category\": \"largeCabinetSide\",\n    \"subcategory\": \"medium\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 968.846507434443,
              "y": 1332.95170775697
            },
            {
              "class": "FRAGMENT",
              "height": 96,
              "id": 1080,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "largeCabinetSide"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "largeCabinetSide"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 512,
              "y": 800
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 1083,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "craftableMeta",
                  "type": "string",
                  "value": "{\n    \"buildType\": \"entity\",\n    \"fragmentPointer\": {\n        \"catalog\": \"settlement\",\n        \"tag\": \"stool\"\n    },\n    \"itemType\": \"stool-small\"\n}\n"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "stool"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 576,
              "y": 832
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 1084,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "table"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 576,
              "y": 864
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1085,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"table\",\n    \"category\": \"decoration\",\n    \"subcategory\": \"small\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 943.645366658807,
              "y": 1398.25512850743
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1086,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"stool\",\n    \"category\": \"decoration\",\n    \"subcategory\": \"small\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 943.413558699247,
              "y": 1368.73047951497
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1087,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"stool\",\n    \"category\": \"decoration\",\n    \"subcategory\": \"small\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 912.86275083674,
              "y": 1398.9352374176
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1088,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"stool\",\n    \"category\": \"decoration\",\n    \"subcategory\": \"small\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 944.204933959279,
              "y": 1428.93131290004
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1089,
              "name": "door",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\"type\":\"door\", \"direction\":\"Down\"}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 880.972927418075,
              "y": 1493.94833319717
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1090,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n   \"renderZIdxOffset\": 32\n}"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "building"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "arch"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 736,
              "y": 1440
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1092,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"arch\",\n    \"category\": \"decoration\",\n    \"subcategory\": \"building\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 879.663231238206,
              "y": 1425.64232834954
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1100,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"roofShadow\",\n    \"category\": \"roofShadow\",\n    \"subcategory\": \"medium\",\n    \"renderStrategy\": \"sprite\",\n    \"context\": {\n       \"roofLayer\": \"below\"\n    }\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 817.645480240261,
              "y": 1397.11880252454
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1109,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "veryLargeBarrel"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "veryLargeBarrel"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 64,
              "x": 672,
              "y": 224
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1111,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n   \"renderZIdxOffset\": 32\n}"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "building"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "wallDeco1"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 736,
              "y": 1504
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 1117,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "roofShadow2"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "roofShadow2"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 192,
              "x": 1248,
              "y": 1504
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1121,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"roofShadow2\",\n    \"category\": \"roofShadow2\",\n    \"subcategory\": \"medium\",\n    \"renderStrategy\": \"sprite\",\n    \"context\": {\n       \"roofLayer\": \"below\"\n    }\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1263.31160810231,
              "y": 1332.15656275044
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 1122,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "benchHorizontal"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "benchHorizontal"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 96,
              "x": 1344,
              "y": 1536
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1124,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"benchHorizontal\",\n    \"category\": \"benchHorizontal\",\n    \"subcategory\": \"small\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1357.94282346006,
              "y": 1204.00058944887
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1127,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"benchHorizontal\",\n    \"category\": \"benchHorizontal\",\n    \"subcategory\": \"small\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1357.83760683761,
              "y": 1235.21131741821
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1128,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"benchHorizontal\",\n    \"category\": \"benchHorizontal\",\n    \"subcategory\": \"small\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1357.83760683761,
              "y": 1266.68552903036
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1131,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"benchHorizontal\",\n    \"category\": \"benchHorizontal\",\n    \"subcategory\": \"small\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1358.10079575597,
              "y": 1298.21013852048
            },
            {
              "class": "FRAGMENT",
              "height": 96,
              "id": 1132,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "wallFlagRed"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "wallFlagRed"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 1472,
              "y": 1504
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1133,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"wallFlagRed\",\n    \"category\": \"wallFlagRed\",\n    \"subcategory\": \"small\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1329.65517241379,
              "y": 1141.6091954023
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1135,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"wallFlagRed\",\n    \"category\": \"wallFlagRed\",\n    \"subcategory\": \"small\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1361.57471264368,
              "y": 1141.33333333333
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1136,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"wallFlagRed\",\n    \"category\": \"wallFlagRed\",\n    \"subcategory\": \"small\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1394.57471264368,
              "y": 1141.33333333333
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1137,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "diasHorizontal"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "diasHorizontal"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 64,
              "x": 1184,
              "y": 960
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1138,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"diasHorizontal\",\n    \"category\": \"diasHorizontal\",\n    \"subcategory\": \"small\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1291,
              "y": 1173.5
            },
            {
              "class": "FRAGMENT",
              "height": 224,
              "id": 1148,
              "name": "warlordSubCompound",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "compound"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"locationIcon\": \"building.png\",\n  \"initialMapFeature\": true,\n  \"noResourceSpawn\": true\n}"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "warlordSmall"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 224,
              "x": 192,
              "y": 1056
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1149,
              "name": "warlord",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"warlord\",\n  \"weapon\": \"axe\"\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 274.666666666667,
              "y": 1178
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1151,
              "name": "guard",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"warlordsCampaign\": true,\n  \"type\": \"guard\",\n  \"boundToWarlord\": true,\n  \"weapon\": \"spear\"\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 304.5,
              "y": 1205
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1153,
              "name": "chestSpawner",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"chestSpawner\": true\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 305.253194510175,
              "y": 1146.86859126045
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1154,
              "name": "chestSpawner",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"chestSpawner\": true\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 913.206897916319,
              "y": 1369.07351165162
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1155,
              "name": "chestSpawner",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"chestSpawner\": true\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1269.21932347981,
              "y": 1238.46840591211
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1156,
              "name": "door",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"type\":\"door\", \n  \"direction\":\"Down\",\n  \"accessRequires\": \"castlekey:3\"\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1488,
              "y": 916
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1157,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"arch2\",\n    \"category\": \"decoration\",\n    \"subcategory\": \"building\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1487.5,
              "y": 856.5
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1158,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n   \"renderZIdxOffset\": 32\n}"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "building"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "arch2"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 704,
              "y": 1440
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1160,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"arch3\",\n    \"category\": \"decoration\",\n    \"subcategory\": \"building\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1454.93436293436,
              "y": 762.208494208494
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1162,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "decoration"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n   \"renderZIdxOffset\": 32\n}"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "building"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "arch3"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 672,
              "y": 1440
            },
            {
              "class": "mapSpriteCap",
              "height": 0,
              "id": 1163,
              "name": "",
              "point": true,
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 1413.98093508852,
              "y": 851.112119836587
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1164,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"table\",\n    \"category\": \"decoration\",\n    \"subcategory\": \"small\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 367.221552129605,
              "y": 84.9558165665011
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1165,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"fragmentPointer\": {\n    \"catalog\": \"settlement\",\n    \"tag\": \"stool\",\n    \"category\": \"decoration\",\n    \"subcategory\": \"small\",\n    \"renderStrategy\": \"sprite\"\n  }\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 367.781552129605,
              "y": 115.625816566501
            },
            {
              "class": "mapSpriteCap",
              "height": 0,
              "id": 1169,
              "name": "",
              "point": true,
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 75.9416767922236,
              "y": 103.888213851762
            },
            {
              "class": "FRAGMENT",
              "height": 288,
              "id": 1170,
              "name": "smallWoodenHouse",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "house"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"noResourceSpawn\": true\n}"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 224,
              "x": 0,
              "y": 224
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1175,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "woodDoor"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"entityType\": \"door\",\n  \"openFragment\": \"settlement:woodDoorSide\",\n  \"closedFragment\": \"settlement:woodDoor\",\n  \"clearPointsForLayers\": [\"sprite\"]\n}"
                },
                {
                  "name": "craftableMeta",
                  "type": "string",
                  "value": "{\n    \"buildType\": \"entity\",\n    \"entityType\": \"door\",\n    \"fragmentPointer\": {\n        \"catalog\": \"settlement\",\n        \"tag\": \"woodDoor\"\n    },\n    \"itemType\": \"door-wood\"\n}\n"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "woodDoor"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 64,
              "y": 864
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1176,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"anchor\": true\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 79.656862745098,
              "y": 908.90522875817
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1179,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "window"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "window"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 128,
              "y": 864
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1180,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"anchor\": true,\n  \"occlusion\": \"remove\"\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 143.5,
              "y": 915.5
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1182,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"anchor\": true,\n  \"blocking\": \"remove\",\n  \"occlusion\": \"remove\"\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 115.292384601279,
              "y": 908.862152016455
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1184,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "woodDoorSide"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"entityType\": \"door\",\n  \"clearPointsForLayers\": [\"sprite\", \"occlusion\"]\n}"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "woodDoorSide"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 96,
              "y": 864
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 1186,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "woodChest"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"entityType\": \"chest\",\n  \"openFragment\": \"settlement:woodChestOpen\",\n  \"closedFragment\": \"settlement:woodChest\"\n}"
                },
                {
                  "name": "craftableMeta",
                  "type": "string",
                  "value": "{\n    \"buildType\": \"entity\",\n    \"entityType\": \"chest\",\n    \"fragmentPointer\": {\n        \"catalog\": \"settlement\",\n        \"tag\": \"woodChest\"\n    },\n    \"itemType\": \"chest-wood\"\n}\n"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "woodChest"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 64,
              "y": 960
            },
            {
              "class": "FRAGMENT",
              "height": 32,
              "id": 1187,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "woodChestOpen"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"entityType\": \"chest\"\n}"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "small"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "woodChestOpen"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 32,
              "x": 96,
              "y": 960
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1190,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"anchor\": true,\n  \"occlusion\": \"remove\",\n  \"blocking\": \"remove\"\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 80.2151019493614,
              "y": 979.161998655613
            },
            {
              "class": "FRAGMENT_POINT",
              "height": 0,
              "id": 1191,
              "name": "",
              "point": true,
              "properties": [
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"anchor\": true\n}"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 0,
              "x": 112.256329822989,
              "y": 979.610127716782
            },
            {
              "class": "FRAGMENT",
              "height": 96,
              "id": 1193,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "largeRoughTable"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"mustBeFreeAtLayers\": [\"sprite\", \"sprite2\"]\n}"
                },
                {
                  "name": "craftableMeta",
                  "type": "string",
                  "value": "{\n    \"buildType\": \"entity\",\n    \"fragmentPointer\": {\n        \"catalog\": \"settlement\",\n        \"tag\": \"largeRoughTable\"\n    },\n    \"itemType\": \"table-large-rough\"\n}\n"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "largeRoughTable"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 96,
              "x": 448,
              "y": 896
            },
            {
              "class": "FRAGMENT",
              "height": 64,
              "id": 1194,
              "name": "",
              "properties": [
                {
                  "name": "category",
                  "type": "string",
                  "value": "medRoundTable"
                },
                {
                  "name": "context",
                  "type": "string",
                  "value": "{\n  \"mustBeFreeAtLayers\": [\"sprite\", \"sprite2\"]\n}"
                },
                {
                  "name": "craftableMeta",
                  "type": "string",
                  "value": "{\n    \"buildType\": \"entity\",\n    \"fragmentPointer\": {\n        \"catalog\": \"settlement\",\n        \"tag\": \"medRoundTable\"\n    },\n    \"itemType\": \"table-mid-round\"\n}\n"
                },
                {
                  "name": "renderStrategy",
                  "type": "string",
                  "value": "sprite"
                },
                {
                  "name": "subcategory",
                  "type": "string",
                  "value": "medium"
                },
                {
                  "name": "tag",
                  "type": "string",
                  "value": "medRoundTable"
                }
              ],
              "rotation": 0,
              "visible": true,
              "width": 64,
              "x": 576,
              "y": 928
            }
          ],
          "opacity": 1,
          "type": "objectgroup",
          "visible": true,
          "x": 0,
          "y": 0
        }
      ],
      "nextlayerid": 19,
      "nextobjectid": 1197,
      "orientation": "orthogonal",
      "renderorder": "right-down",
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tilesets": [
        {
          "firstgid": 1,
          "source": "../tilesets/lpc-terrain.tsx"
        },
        {
          "firstgid": 1025,
          "source": "../tilesets/plants.tsx"
        },
        {
          "firstgid": 1194,
          "source": "../tilesets/lpc-flowers-plants-fungi-wood.tsx"
        },
        {
          "firstgid": 1706,
          "source": "../tilesets/mountains-v6.tsx"
        },
        {
          "firstgid": 6826,
          "source": "../tilesets/ore.tsx"
        },
        {
          "firstgid": 7082,
          "source": "../tilesets/jungle-ruins.tsx"
        },
        {
          "firstgid": 8106,
          "source": "../tilesets/build_atlas.tsx"
        },
        {
          "firstgid": 9130,
          "source": "../tilesets/decorations-medieval.tsx"
        },
        {
          "firstgid": 10154,
          "source": "../tilesets/roofs.tsx"
        },
        {
          "firstgid": 14250,
          "source": "../tilesets/cottage.tsx"
        },
        {
          "firstgid": 14506,
          "source": "../tilesets/walls.tsx"
        },
        {
          "firstgid": 20650,
          "source": "../tilesets/container.tsx"
        },
        {
          "firstgid": 21674,
          "source": "../tilesets/fence_medieval.tsx"
        },
        {
          "firstgid": 22186,
          "source": "../tilesets/furniture-blonde-wood.tsx"
        }
      ],
      "tilewidth": 32,
      "type": "map",
      "version": "1.9",
      "width": 50
    }
  },
  "mapTilesets": {
    "authored-terrain": {
      "columns": 32,
      "image": "../../media/authored-terrain-v2.png",
      "imageheight": 1024,
      "imagewidth": 1024,
      "margin": 0,
      "name": "authored-terrain",
      "spacing": 0,
      "tilecount": 1024,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tiles": [
        {
          "id": 0,
          "properties": [
            {
              "name": "entityTileId",
              "type": "string",
              "value": "stairs-down"
            },
            {
              "name": "labItemType",
              "type": "string",
              "value": "stairs-down"
            }
          ]
        },
        {
          "id": 1,
          "properties": [
            {
              "name": "entityTileId",
              "type": "string",
              "value": "stairs-up"
            },
            {
              "name": "labItemType",
              "type": "string",
              "value": "stairs-up"
            }
          ]
        },
        {
          "id": 2,
          "properties": [
            {
              "name": "entityTileId",
              "type": "string",
              "value": "floor-opening"
            },
            {
              "name": "labItemType",
              "type": "string",
              "value": "floor-opening"
            }
          ]
        },
        {
          "id": 469,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-a"
            }
          ]
        },
        {
          "id": 470,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-a"
            }
          ]
        },
        {
          "id": 471,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-a"
            }
          ]
        },
        {
          "id": 472,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-b"
            }
          ]
        },
        {
          "id": 473,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-b"
            }
          ]
        },
        {
          "id": 474,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-b"
            }
          ]
        },
        {
          "id": 475,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-a"
            }
          ]
        },
        {
          "id": 476,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-a"
            }
          ]
        },
        {
          "id": 477,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-a"
            }
          ]
        },
        {
          "id": 478,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-bush-a"
            }
          ]
        },
        {
          "id": 479,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-bush-a"
            }
          ]
        },
        {
          "id": 480,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "grove-shrub-a"
            },
            {
              "name": "castsShadow",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 481,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "grove-shrub-b"
            },
            {
              "name": "castsShadow",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 482,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "grove-shrub-c"
            },
            {
              "name": "castsShadow",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 483,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "meadow-tuft-a"
            },
            {
              "name": "renderZIdxOffset",
              "type": "float",
              "value": -4
            }
          ]
        },
        {
          "id": 484,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-b"
            }
          ]
        },
        {
          "id": 485,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-b"
            }
          ]
        },
        {
          "id": 486,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-b"
            }
          ]
        },
        {
          "id": 487,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-a"
            }
          ]
        },
        {
          "id": 488,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-a"
            }
          ]
        },
        {
          "id": 489,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-a"
            }
          ]
        },
        {
          "id": 490,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-b"
            }
          ]
        },
        {
          "id": 491,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-b"
            }
          ]
        },
        {
          "id": 492,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-b"
            }
          ]
        },
        {
          "id": 493,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-a"
            }
          ]
        },
        {
          "id": 494,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-a"
            }
          ]
        },
        {
          "id": 495,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-a"
            }
          ]
        },
        {
          "id": 496,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-a"
            }
          ]
        },
        {
          "id": 497,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-b"
            }
          ]
        },
        {
          "id": 498,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-b"
            }
          ]
        },
        {
          "id": 499,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-b"
            }
          ]
        },
        {
          "id": 500,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-b"
            }
          ]
        },
        {
          "id": 501,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-a"
            }
          ]
        },
        {
          "id": 502,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-a"
            }
          ]
        },
        {
          "id": 503,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-a"
            }
          ]
        },
        {
          "id": 504,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-b"
            }
          ]
        },
        {
          "id": 505,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-b"
            }
          ]
        },
        {
          "id": 506,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-b"
            }
          ]
        },
        {
          "id": 507,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-a"
            }
          ]
        },
        {
          "id": 508,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-a"
            }
          ]
        },
        {
          "id": 509,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-a"
            }
          ]
        },
        {
          "id": 510,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "grove-bush-a"
            },
            {
              "name": "castsShadow",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderYOffset",
              "type": "float",
              "value": 16
            }
          ]
        },
        {
          "id": 511,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-bush-a"
            }
          ]
        },
        {
          "id": 516,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-b"
            }
          ]
        },
        {
          "id": 517,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-b"
            }
          ]
        },
        {
          "id": 518,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-b"
            }
          ]
        },
        {
          "id": 519,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-a"
            }
          ]
        },
        {
          "id": 520,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-a"
            }
          ]
        },
        {
          "id": 521,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-a"
            }
          ]
        },
        {
          "id": 522,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-b"
            }
          ]
        },
        {
          "id": 523,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-b"
            }
          ]
        },
        {
          "id": 524,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-b"
            }
          ]
        },
        {
          "id": 525,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-a"
            }
          ]
        },
        {
          "id": 526,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-a"
            }
          ]
        },
        {
          "id": 527,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-a"
            }
          ]
        },
        {
          "id": 528,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-a"
            }
          ]
        },
        {
          "id": 529,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-b"
            }
          ]
        },
        {
          "id": 530,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-b"
            }
          ]
        },
        {
          "id": 531,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-b"
            }
          ]
        },
        {
          "id": 532,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-b"
            }
          ]
        },
        {
          "id": 533,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-a"
            }
          ]
        },
        {
          "id": 534,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-a"
            }
          ]
        },
        {
          "id": 535,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-a"
            }
          ]
        },
        {
          "id": 536,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-b"
            }
          ]
        },
        {
          "id": 537,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-b"
            }
          ]
        },
        {
          "id": 538,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-b"
            }
          ]
        },
        {
          "id": 539,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-a"
            }
          ]
        },
        {
          "id": 540,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-a"
            }
          ]
        },
        {
          "id": 541,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-a"
            }
          ]
        },
        {
          "id": 542,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-bush-b"
            }
          ]
        },
        {
          "id": 543,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-bush-b"
            }
          ]
        },
        {
          "id": 548,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-b"
            }
          ]
        },
        {
          "id": 549,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-b"
            }
          ]
        },
        {
          "id": 550,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-b"
            }
          ]
        },
        {
          "id": 551,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-a"
            }
          ]
        },
        {
          "id": 552,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-a"
            }
          ]
        },
        {
          "id": 553,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-a"
            }
          ]
        },
        {
          "id": 554,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-b"
            }
          ]
        },
        {
          "id": 555,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-b"
            }
          ]
        },
        {
          "id": 556,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-b"
            }
          ]
        },
        {
          "id": 557,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-a"
            }
          ]
        },
        {
          "id": 558,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-a"
            }
          ]
        },
        {
          "id": 559,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-a"
            }
          ]
        },
        {
          "id": 560,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-a"
            }
          ]
        },
        {
          "id": 561,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-b"
            }
          ]
        },
        {
          "id": 562,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-b"
            }
          ]
        },
        {
          "id": 563,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-b"
            }
          ]
        },
        {
          "id": 564,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-b"
            }
          ]
        },
        {
          "id": 565,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-a"
            }
          ]
        },
        {
          "id": 566,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-a"
            }
          ]
        },
        {
          "id": 567,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-a"
            }
          ]
        },
        {
          "id": 568,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-b"
            }
          ]
        },
        {
          "id": 569,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-b"
            }
          ]
        },
        {
          "id": 570,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-b"
            }
          ]
        },
        {
          "id": 571,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-a"
            }
          ]
        },
        {
          "id": 572,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-a"
            }
          ]
        },
        {
          "id": 573,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-a"
            }
          ]
        },
        {
          "id": 574,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "grove-bush-b"
            },
            {
              "name": "castsShadow",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderYOffset",
              "type": "float",
              "value": 16
            }
          ]
        },
        {
          "id": 575,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-bush-b"
            }
          ]
        },
        {
          "id": 578,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-bush-c"
            }
          ]
        },
        {
          "id": 579,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-bush-c"
            }
          ]
        },
        {
          "id": 580,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-b"
            }
          ]
        },
        {
          "id": 581,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-b"
            }
          ]
        },
        {
          "id": 582,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-b"
            }
          ]
        },
        {
          "id": 583,
          "properties": [
            {
              "name": "entityTileId",
              "type": "string",
              "value": "grove-round-a"
            },
            {
              "name": "labItemType",
              "type": "string",
              "value": "grove-round-a"
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "grove-round-a"
            },
            {
              "name": "castsShadow",
              "type": "bool",
              "value": true
            },
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderXOffset",
              "type": "float",
              "value": -8
            },
            {
              "name": "renderYOffset",
              "type": "float",
              "value": 16
            },
            {
              "name": "blockingRects",
              "type": "string",
              "value": "[{\"x\":6,\"y\":10,\"width\":20,\"height\":9,\"bodyInsetBottom\":8}]"
            }
          ]
        },
        {
          "id": 584,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-a"
            }
          ]
        },
        {
          "id": 585,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-a"
            }
          ]
        },
        {
          "id": 586,
          "properties": [
            {
              "name": "entityTileId",
              "type": "string",
              "value": "grove-round-b"
            },
            {
              "name": "labItemType",
              "type": "string",
              "value": "grove-round-b"
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "grove-round-b"
            },
            {
              "name": "castsShadow",
              "type": "bool",
              "value": true
            },
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderXOffset",
              "type": "float",
              "value": -8
            },
            {
              "name": "renderYOffset",
              "type": "float",
              "value": 16
            },
            {
              "name": "blockingRects",
              "type": "string",
              "value": "[{\"x\":6,\"y\":10,\"width\":20,\"height\":9,\"bodyInsetBottom\":8}]"
            }
          ]
        },
        {
          "id": 587,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-b"
            }
          ]
        },
        {
          "id": 588,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-round-b"
            }
          ]
        },
        {
          "id": 589,
          "properties": [
            {
              "name": "entityTileId",
              "type": "string",
              "value": "grove-low-a"
            },
            {
              "name": "labItemType",
              "type": "string",
              "value": "grove-low-a"
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "grove-low-a"
            },
            {
              "name": "castsShadow",
              "type": "bool",
              "value": true
            },
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderXOffset",
              "type": "float",
              "value": -16
            },
            {
              "name": "renderYOffset",
              "type": "float",
              "value": 16
            },
            {
              "name": "blockingRects",
              "type": "string",
              "value": "[{\"x\":6,\"y\":10,\"width\":20,\"height\":9,\"bodyInsetBottom\":8}]"
            }
          ]
        },
        {
          "id": 590,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-a"
            }
          ]
        },
        {
          "id": 591,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-a"
            }
          ]
        },
        {
          "id": 592,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-a"
            }
          ]
        },
        {
          "id": 593,
          "properties": [
            {
              "name": "entityTileId",
              "type": "string",
              "value": "grove-low-b"
            },
            {
              "name": "labItemType",
              "type": "string",
              "value": "grove-low-b"
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "grove-low-b"
            },
            {
              "name": "castsShadow",
              "type": "bool",
              "value": true
            },
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderXOffset",
              "type": "float",
              "value": -16
            },
            {
              "name": "renderYOffset",
              "type": "float",
              "value": 16
            },
            {
              "name": "blockingRects",
              "type": "string",
              "value": "[{\"x\":6,\"y\":10,\"width\":20,\"height\":9,\"bodyInsetBottom\":8}]"
            }
          ]
        },
        {
          "id": 594,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-b"
            }
          ]
        },
        {
          "id": 595,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-b"
            }
          ]
        },
        {
          "id": 596,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-low-b"
            }
          ]
        },
        {
          "id": 597,
          "properties": [
            {
              "name": "entityTileId",
              "type": "string",
              "value": "grove-oak-a"
            },
            {
              "name": "labItemType",
              "type": "string",
              "value": "grove-oak-a"
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "grove-oak-a"
            },
            {
              "name": "castsShadow",
              "type": "bool",
              "value": true
            },
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderXOffset",
              "type": "float",
              "value": -8
            },
            {
              "name": "renderYOffset",
              "type": "float",
              "value": 16
            },
            {
              "name": "blockingRects",
              "type": "string",
              "value": "[{\"x\":6,\"y\":10,\"width\":20,\"height\":9,\"bodyInsetBottom\":8}]"
            }
          ]
        },
        {
          "id": 598,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-a"
            }
          ]
        },
        {
          "id": 599,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-a"
            }
          ]
        },
        {
          "id": 600,
          "properties": [
            {
              "name": "entityTileId",
              "type": "string",
              "value": "grove-oak-b"
            },
            {
              "name": "labItemType",
              "type": "string",
              "value": "grove-oak-b"
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "grove-oak-b"
            },
            {
              "name": "castsShadow",
              "type": "bool",
              "value": true
            },
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderXOffset",
              "type": "float",
              "value": -8
            },
            {
              "name": "renderYOffset",
              "type": "float",
              "value": 16
            },
            {
              "name": "blockingRects",
              "type": "string",
              "value": "[{\"x\":6,\"y\":10,\"width\":20,\"height\":9,\"bodyInsetBottom\":8}]"
            }
          ]
        },
        {
          "id": 601,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-b"
            }
          ]
        },
        {
          "id": 602,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-oak-b"
            }
          ]
        },
        {
          "id": 603,
          "properties": [
            {
              "name": "entityTileId",
              "type": "string",
              "value": "grove-spruce-a"
            },
            {
              "name": "labItemType",
              "type": "string",
              "value": "grove-spruce-a"
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "grove-spruce-a"
            },
            {
              "name": "castsShadow",
              "type": "bool",
              "value": true
            },
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderXOffset",
              "type": "float",
              "value": -8
            },
            {
              "name": "renderYOffset",
              "type": "float",
              "value": 16
            },
            {
              "name": "blockingRects",
              "type": "string",
              "value": "[{\"x\":6,\"y\":10,\"width\":20,\"height\":9,\"bodyInsetBottom\":8}]"
            }
          ]
        },
        {
          "id": 604,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-a"
            }
          ]
        },
        {
          "id": 605,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-a"
            }
          ]
        },
        {
          "id": 606,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-bush-d"
            }
          ]
        },
        {
          "id": 607,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-bush-d"
            }
          ]
        },
        {
          "id": 608,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "meadow-grass-a"
            }
          ]
        },
        {
          "id": 609,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "meadow-grass-b"
            }
          ]
        },
        {
          "id": 610,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "grove-bush-c"
            },
            {
              "name": "castsShadow",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderYOffset",
              "type": "float",
              "value": 16
            }
          ]
        },
        {
          "id": 611,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-bush-c"
            }
          ]
        },
        {
          "id": 612,
          "properties": [
            {
              "name": "entityTileId",
              "type": "string",
              "value": "grove-spruce-b"
            },
            {
              "name": "labItemType",
              "type": "string",
              "value": "grove-spruce-b"
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "grove-spruce-b"
            },
            {
              "name": "castsShadow",
              "type": "bool",
              "value": true
            },
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderXOffset",
              "type": "float",
              "value": -8
            },
            {
              "name": "renderYOffset",
              "type": "float",
              "value": 16
            },
            {
              "name": "blockingRects",
              "type": "string",
              "value": "[{\"x\":6,\"y\":10,\"width\":20,\"height\":9,\"bodyInsetBottom\":8}]"
            }
          ]
        },
        {
          "id": 613,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-b"
            }
          ]
        },
        {
          "id": 614,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-spruce-b"
            }
          ]
        },
        {
          "id": 615,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "meadow-grass-c"
            }
          ]
        },
        {
          "id": 616,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "meadow-grass-d"
            }
          ]
        },
        {
          "id": 617,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "meadow-grass-e"
            }
          ]
        },
        {
          "id": 618,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "meadow-grass-f"
            }
          ]
        },
        {
          "id": 619,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "meadow-tuft-b"
            },
            {
              "name": "renderZIdxOffset",
              "type": "float",
              "value": -4
            }
          ]
        },
        {
          "id": 620,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "meadow-tuft-c"
            },
            {
              "name": "renderZIdxOffset",
              "type": "float",
              "value": -4
            }
          ]
        },
        {
          "id": 621,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "meadow-tuft-d"
            },
            {
              "name": "renderZIdxOffset",
              "type": "float",
              "value": -4
            }
          ]
        },
        {
          "id": 622,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "meadow-tuft-e"
            },
            {
              "name": "renderZIdxOffset",
              "type": "float",
              "value": -4
            }
          ]
        },
        {
          "id": 623,
          "properties": [
            {
              "name": "entityTileId",
              "type": "string",
              "value": "meadow-sprout"
            },
            {
              "name": "labItemType",
              "type": "string",
              "value": "meadow-sprout"
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "meadow-sprout"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderZIdxOffset",
              "type": "float",
              "value": -4
            }
          ]
        },
        {
          "id": 624,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "dirt-sedge-a"
            },
            {
              "name": "renderZIdxOffset",
              "type": "float",
              "value": -4
            }
          ]
        },
        {
          "id": 625,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "dirt-sedge-b"
            },
            {
              "name": "renderZIdxOffset",
              "type": "float",
              "value": -4
            }
          ]
        },
        {
          "id": 626,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "dirt-sedge-c"
            },
            {
              "name": "renderZIdxOffset",
              "type": "float",
              "value": -4
            }
          ]
        },
        {
          "id": 627,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "dirt-herb-a"
            },
            {
              "name": "renderZIdxOffset",
              "type": "float",
              "value": -4
            }
          ]
        },
        {
          "id": 628,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "dirt-herb-b"
            },
            {
              "name": "renderZIdxOffset",
              "type": "float",
              "value": -4
            }
          ]
        },
        {
          "id": 629,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "dirt-herb-c"
            },
            {
              "name": "renderZIdxOffset",
              "type": "float",
              "value": -4
            }
          ]
        },
        {
          "id": 630,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 9
            }
          ]
        },
        {
          "id": 631,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 632,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 633,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 634,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 635,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 7
            }
          ]
        },
        {
          "id": 636,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 10
            }
          ]
        },
        {
          "id": 637,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 2
            }
          ]
        },
        {
          "id": 638,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "grove-bush-d"
            },
            {
              "name": "castsShadow",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderYOffset",
              "type": "float",
              "value": 16
            }
          ]
        },
        {
          "id": 639,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "grove-bush-d"
            }
          ]
        },
        {
          "id": 640,
          "properties": [
            {
              "name": "entityTileId",
              "type": "string",
              "value": "meadow-grass-a"
            },
            {
              "name": "labItemType",
              "type": "string",
              "value": "meadow-grass-a"
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "meadow-grass-a"
            },
            {
              "name": "densityStrategy",
              "type": "string",
              "value": "denseVertical"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderZIdxOffset",
              "type": "float",
              "value": -4
            },
            {
              "name": "denseCopies",
              "type": "float",
              "value": 1
            }
          ]
        },
        {
          "id": 641,
          "properties": [
            {
              "name": "entityTileId",
              "type": "string",
              "value": "meadow-grass-b"
            },
            {
              "name": "labItemType",
              "type": "string",
              "value": "meadow-grass-b"
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "meadow-grass-b"
            },
            {
              "name": "densityStrategy",
              "type": "string",
              "value": "denseVertical"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderZIdxOffset",
              "type": "float",
              "value": -4
            },
            {
              "name": "denseCopies",
              "type": "float",
              "value": 1
            }
          ]
        },
        {
          "id": 642,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 643,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 3
            }
          ]
        },
        {
          "id": 644,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 8
            }
          ]
        },
        {
          "id": 645,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 646,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 0
            }
          ]
        },
        {
          "id": 647,
          "properties": [
            {
              "name": "entityTileId",
              "type": "string",
              "value": "meadow-grass-c"
            },
            {
              "name": "labItemType",
              "type": "string",
              "value": "meadow-grass-c"
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "meadow-grass-c"
            },
            {
              "name": "densityStrategy",
              "type": "string",
              "value": "denseVertical"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderZIdxOffset",
              "type": "float",
              "value": -4
            },
            {
              "name": "denseCopies",
              "type": "float",
              "value": 1
            }
          ]
        },
        {
          "id": 648,
          "properties": [
            {
              "name": "entityTileId",
              "type": "string",
              "value": "meadow-grass-d"
            },
            {
              "name": "labItemType",
              "type": "string",
              "value": "meadow-grass-d"
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "meadow-grass-d"
            },
            {
              "name": "densityStrategy",
              "type": "string",
              "value": "denseVertical"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderZIdxOffset",
              "type": "float",
              "value": -4
            },
            {
              "name": "denseCopies",
              "type": "float",
              "value": 1
            }
          ]
        },
        {
          "id": 649,
          "properties": [
            {
              "name": "entityTileId",
              "type": "string",
              "value": "meadow-grass-e"
            },
            {
              "name": "labItemType",
              "type": "string",
              "value": "meadow-grass-e"
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "meadow-grass-e"
            },
            {
              "name": "densityStrategy",
              "type": "string",
              "value": "denseVertical"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderZIdxOffset",
              "type": "float",
              "value": -4
            },
            {
              "name": "denseCopies",
              "type": "float",
              "value": 1
            }
          ]
        },
        {
          "id": 650,
          "properties": [
            {
              "name": "entityTileId",
              "type": "string",
              "value": "meadow-grass-f"
            },
            {
              "name": "labItemType",
              "type": "string",
              "value": "meadow-grass-f"
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "meadow-grass-f"
            },
            {
              "name": "densityStrategy",
              "type": "string",
              "value": "denseVertical"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderZIdxOffset",
              "type": "float",
              "value": -4
            },
            {
              "name": "denseCopies",
              "type": "float",
              "value": 1
            }
          ]
        },
        {
          "id": 651,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 652,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 653,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 11
            }
          ]
        },
        {
          "id": 654,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 655,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 656,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 657,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 5
            }
          ]
        },
        {
          "id": 658,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 12
            }
          ]
        },
        {
          "id": 659,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 6
            }
          ]
        },
        {
          "id": 660,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 661,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 662,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 663,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 4
            }
          ]
        },
        {
          "id": 664,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 665,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 666,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 9
            }
          ]
        },
        {
          "id": 667,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 10
            }
          ]
        },
        {
          "id": 668,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 2
            }
          ]
        },
        {
          "id": 669,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 670,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 3
            }
          ]
        },
        {
          "id": 671,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 672,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 673,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 11
            }
          ]
        },
        {
          "id": 674,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 5
            }
          ]
        },
        {
          "id": 675,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 12
            }
          ]
        },
        {
          "id": 676,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 6
            }
          ]
        },
        {
          "id": 677,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 678,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 679,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 4
            }
          ]
        },
        {
          "id": 680,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 681,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 682,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 683,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 684,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 685,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 686,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 687,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 688,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 689,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 690,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 691,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 692,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 693,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 694,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 695,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 696,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 8
            }
          ]
        },
        {
          "id": 697,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 698,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 699,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 700,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 701,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 702,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 703,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 704,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 705,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 706,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 707,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 708,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 709,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 710,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 711,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 712,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 7
            }
          ]
        },
        {
          "id": 713,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 0
            }
          ]
        },
        {
          "id": 714,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 9
            }
          ]
        },
        {
          "id": 715,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 10
            }
          ]
        },
        {
          "id": 716,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 2
            }
          ]
        },
        {
          "id": 717,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 718,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 3
            }
          ]
        },
        {
          "id": 719,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 11
            }
          ]
        },
        {
          "id": 720,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 5
            }
          ]
        },
        {
          "id": 721,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 12
            }
          ]
        },
        {
          "id": 722,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 6
            }
          ]
        },
        {
          "id": 723,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 724,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 725,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 726,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 727,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 728,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 729,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 730,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 731,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 732,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 733,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 734,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        }
      ],
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    },
    "beach-desert": {
      "columns": 32,
      "image": "../../media/beach-desert.png",
      "imageheight": 1024,
      "imagewidth": 1024,
      "margin": 0,
      "name": "beach-desert",
      "spacing": 0,
      "tilecount": 1024,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tiles": [
        {
          "id": 256,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm1"
            }
          ]
        },
        {
          "id": 257,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm1"
            }
          ]
        },
        {
          "id": 258,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm1"
            }
          ]
        },
        {
          "id": 259,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm2"
            }
          ]
        },
        {
          "id": 260,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm2"
            }
          ]
        },
        {
          "id": 261,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm2"
            }
          ]
        },
        {
          "id": 262,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm3"
            }
          ]
        },
        {
          "id": 263,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm3"
            }
          ]
        },
        {
          "id": 264,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm3"
            }
          ]
        },
        {
          "id": 265,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm4"
            }
          ]
        },
        {
          "id": 266,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm4"
            }
          ]
        },
        {
          "id": 267,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm4"
            }
          ]
        },
        {
          "id": 268,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm5"
            }
          ]
        },
        {
          "id": 269,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm5"
            }
          ]
        },
        {
          "id": 270,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm5"
            }
          ]
        },
        {
          "id": 271,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm6"
            }
          ]
        },
        {
          "id": 272,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm6"
            }
          ]
        },
        {
          "id": 273,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm6"
            }
          ]
        },
        {
          "id": 288,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm1"
            }
          ]
        },
        {
          "id": 289,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm1"
            }
          ]
        },
        {
          "id": 290,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm1"
            }
          ]
        },
        {
          "id": 291,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm2"
            }
          ]
        },
        {
          "id": 292,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm2"
            }
          ]
        },
        {
          "id": 293,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm2"
            }
          ]
        },
        {
          "id": 294,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm3"
            }
          ]
        },
        {
          "id": 295,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm3"
            }
          ]
        },
        {
          "id": 296,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm3"
            }
          ]
        },
        {
          "id": 297,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm4"
            }
          ]
        },
        {
          "id": 298,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm4"
            }
          ]
        },
        {
          "id": 299,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm4"
            }
          ]
        },
        {
          "id": 300,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm5"
            }
          ]
        },
        {
          "id": 301,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm5"
            }
          ]
        },
        {
          "id": 302,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm5"
            }
          ]
        },
        {
          "id": 303,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm6"
            }
          ]
        },
        {
          "id": 304,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm6"
            }
          ]
        },
        {
          "id": 305,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm6"
            }
          ]
        },
        {
          "id": 321,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm1"
            }
          ]
        },
        {
          "id": 324,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm2"
            }
          ]
        },
        {
          "id": 326,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm3"
            }
          ]
        },
        {
          "id": 327,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm3"
            }
          ]
        },
        {
          "id": 328,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm3"
            }
          ]
        },
        {
          "id": 329,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm4"
            }
          ]
        },
        {
          "id": 330,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm4"
            }
          ]
        },
        {
          "id": 331,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm4"
            }
          ]
        },
        {
          "id": 332,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm5"
            }
          ]
        },
        {
          "id": 333,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm5"
            }
          ]
        },
        {
          "id": 334,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm5"
            }
          ]
        },
        {
          "id": 335,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm6"
            }
          ]
        },
        {
          "id": 336,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm6"
            }
          ]
        },
        {
          "id": 337,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm6"
            }
          ]
        },
        {
          "id": 352,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm1"
            }
          ]
        },
        {
          "id": 353,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "palm1"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "palmTree1"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderYOffset",
              "type": "int",
              "value": 25
            }
          ]
        },
        {
          "id": 354,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm1"
            }
          ]
        },
        {
          "id": 356,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "palm2"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "palmTree2"
            },
            {
              "name": "renderYOffset",
              "type": "int",
              "value": 25
            }
          ]
        },
        {
          "id": 358,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm3"
            }
          ]
        },
        {
          "id": 359,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "palm3"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "palmTree3"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderYOffset",
              "type": "int",
              "value": 25
            }
          ]
        },
        {
          "id": 360,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm3"
            }
          ]
        },
        {
          "id": 361,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm4"
            }
          ]
        },
        {
          "id": 362,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "palm4"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "palmTree4"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderYOffset",
              "type": "int",
              "value": 25
            }
          ]
        },
        {
          "id": 363,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm4"
            }
          ]
        },
        {
          "id": 364,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm5"
            }
          ]
        },
        {
          "id": 365,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm5"
            }
          ]
        },
        {
          "id": 366,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm5"
            }
          ]
        },
        {
          "id": 367,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm6"
            }
          ]
        },
        {
          "id": 368,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm6"
            }
          ]
        },
        {
          "id": 369,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm6"
            }
          ]
        },
        {
          "id": 396,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm5"
            }
          ]
        },
        {
          "id": 397,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm5"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "palmTree5"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 398,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm5"
            }
          ]
        },
        {
          "id": 399,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm6"
            }
          ]
        },
        {
          "id": 400,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm6"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "palmTree6"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 401,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm6"
            }
          ]
        },
        {
          "id": 428,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm5"
            }
          ]
        },
        {
          "id": 429,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "palm5"
            },
            {
              "name": "renderYOffset",
              "type": "int",
              "value": 25
            }
          ]
        },
        {
          "id": 430,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm5"
            }
          ]
        },
        {
          "id": 431,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm6"
            }
          ]
        },
        {
          "id": 432,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "palm6"
            },
            {
              "name": "renderYOffset",
              "type": "int",
              "value": 25
            }
          ]
        },
        {
          "id": 433,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "palm6"
            }
          ]
        }
      ],
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    },
    "bonecaller-stones": {
      "columns": 32,
      "image": "../../media/lpc-terrain.png",
      "imageheight": 1024,
      "imagewidth": 1024,
      "margin": 0,
      "name": "bonecaller-stones",
      "spacing": 0,
      "tilecount": 1024,
      "tileheight": 32,
      "tiles": [
        {
          "id": 0,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "bonecaller-stone"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "bonecaller-stone"
            }
          ]
        }
      ],
      "tilewidth": 32,
      "type": "tileset",
      "version": "1.8"
    },
    "build_atlas": {
      "columns": 32,
      "image": "../../media/build_atlas.png",
      "imageheight": 1024,
      "imagewidth": 1024,
      "margin": 0,
      "name": "build_atlas",
      "spacing": 0,
      "tilecount": 1024,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tiles": [
        {
          "id": 153,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 154,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 155,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 156,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 157,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 186,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 188,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 216,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 217,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 218,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 219,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 220,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 221,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 222,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 248,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 249,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 250,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 251,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 252,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 253,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 254,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "fancyGate"
            }
          ]
        },
        {
          "id": 283,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "lionStatue"
            }
          ]
        },
        {
          "id": 284,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "lionStatue"
            }
          ]
        },
        {
          "id": 285,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "barrel1"
            }
          ]
        },
        {
          "id": 315,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "lionStatue"
            }
          ]
        },
        {
          "id": 316,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "lionStatue"
            }
          ]
        },
        {
          "id": 317,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "barrel1"
            }
          ]
        },
        {
          "id": 347,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "lionStatue"
            }
          ]
        },
        {
          "id": 348,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "lionStatue"
            }
          ]
        },
        {
          "id": 526,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tent"
            }
          ]
        },
        {
          "id": 527,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tent"
            }
          ]
        },
        {
          "id": 557,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tent"
            }
          ]
        },
        {
          "id": 558,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "tent"
            }
          ]
        },
        {
          "id": 559,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tent"
            }
          ]
        },
        {
          "id": 560,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tent"
            }
          ]
        },
        {
          "id": 589,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 590,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 591,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 592,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 621,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 622,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 623,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 624,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 653,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 656,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 687,
          "properties": [
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -12
            }
          ]
        },
        {
          "id": 688,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "chestOpen"
            }
          ]
        },
        {
          "id": 783,
          "properties": [
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -12
            }
          ]
        }
      ],
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    },
    "container": {
      "columns": 16,
      "image": "../../media/container.png",
      "imageheight": 2048,
      "imagewidth": 512,
      "margin": 0,
      "name": "container",
      "spacing": 0,
      "tilecount": 1024,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    },
    "cottage": {
      "columns": 16,
      "image": "../../media/cottage.png",
      "imageheight": 512,
      "imagewidth": 512,
      "margin": 0,
      "name": "cottage",
      "spacing": 0,
      "tilecount": 256,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    },
    "decorations-medieval": {
      "columns": 16,
      "image": "../../media/decorations-medieval.png",
      "imageheight": 2048,
      "imagewidth": 512,
      "margin": 0,
      "name": "decorations-medieval",
      "spacing": 0,
      "tilecount": 1024,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    },
    "fence_medieval": {
      "columns": 16,
      "image": "../../media/fence_medieval.png",
      "imageheight": 1024,
      "imagewidth": 512,
      "margin": 0,
      "name": "fence_medieval",
      "spacing": 0,
      "tilecount": 512,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tiles": [
        {
          "id": 396,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 9
            }
          ]
        },
        {
          "id": 408,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 409,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 410,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 411,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 412,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 7
            }
          ]
        },
        {
          "id": 424,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 10
            }
          ]
        },
        {
          "id": 425,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 2
            }
          ]
        },
        {
          "id": 426,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 427,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 3
            }
          ]
        },
        {
          "id": 431,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 8
            }
          ]
        },
        {
          "id": 440,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 441,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 0
            }
          ]
        },
        {
          "id": 444,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 445,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 456,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 11
            }
          ]
        },
        {
          "id": 457,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 458,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 459,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 473,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 5
            }
          ]
        },
        {
          "id": 474,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 12
            }
          ]
        },
        {
          "id": 475,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 6
            }
          ]
        },
        {
          "id": 490,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 492,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 493,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 495,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 4
            }
          ]
        },
        {
          "id": 506,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 508,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        }
      ],
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    },
    "floors": {
      "columns": 32,
      "image": "../../media/floors.png",
      "imageheight": 1024,
      "imagewidth": 1024,
      "margin": 0,
      "name": "floors",
      "spacing": 0,
      "tilecount": 1024,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tiles": [
        {
          "id": 0,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 1,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 2,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 3,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 4,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 5,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 6,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 7,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 8,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 9,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 10,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 12,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 13,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 14,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 15,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 16,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 17,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 32,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 33,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 34,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 35,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 36,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 37,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 38,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 39,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 40,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 41,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 42,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 64,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 65,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 66,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 67,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 68,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 69,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 70,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 71,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 72,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 73,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 74,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 96,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 97,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 98,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 99,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 100,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 101,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 102,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 103,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 104,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 105,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 106,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 108,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 109,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 110,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 111,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 112,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 113,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 128,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 129,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 130,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 131,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 132,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 133,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 134,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 135,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 136,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 137,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 138,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 160,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 161,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 162,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 163,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 164,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 165,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 166,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 167,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 168,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 169,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 170,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 192,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 193,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 194,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 195,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 196,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 197,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 198,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 199,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 200,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 201,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 202,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 204,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 205,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 206,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 207,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 208,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 209,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 224,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 225,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 226,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 227,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 228,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 229,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 230,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 231,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 232,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 233,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 234,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 256,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 257,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 258,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 259,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 260,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 261,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 262,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 263,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 264,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 265,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 266,
          "properties": [
            {
              "name": "floor",
              "type": "bool",
              "value": true
            }
          ]
        }
      ],
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    },
    "forest-dirt": {
      "columns": 32,
      "image": "../../media/forest-dirt.png",
      "imageheight": 3808,
      "imagewidth": 1024,
      "margin": 0,
      "name": "forest-dirt",
      "spacing": 0,
      "tilecount": 3796,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    },
    "forest-grass": {
      "columns": 32,
      "image": "../../media/forest-grass.png",
      "imageheight": 4096,
      "imagewidth": 1024,
      "margin": 0,
      "name": "forest-grass",
      "spacing": 0,
      "tilecount": 4096,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    },
    "furniture-blonde-wood": {
      "columns": 16,
      "image": "../../media/furniture-blonde-wood.png",
      "imageheight": 1024,
      "imagewidth": 512,
      "margin": 0,
      "name": "furniture-blonde-wood",
      "spacing": 0,
      "tilecount": 512,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    },
    "jungle-ruins": {
      "columns": 32,
      "image": "../../media/jungle-ruins.png",
      "imageheight": 1024,
      "imagewidth": 1024,
      "margin": 0,
      "name": "jungle-ruins",
      "spacing": 0,
      "tilecount": 1024,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    },
    "lpc-flowers-plants-fungi-wood": {
      "columns": 16,
      "image": "../../media/lpc-flowers-plants-fungi-wood.png",
      "imageheight": 1024,
      "imagewidth": 512,
      "margin": 0,
      "name": "lpc-flowers-plants-fungi-wood",
      "spacing": 0,
      "tilecount": 512,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tiles": [
        {
          "id": 69,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 85,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 100,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            },
            {
              "name": "densityStrategy",
              "type": "string",
              "value": ""
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": ""
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 101,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 102,
          "properties": [
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -16
            }
          ]
        },
        {
          "id": 103,
          "properties": [
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -16
            }
          ]
        },
        {
          "id": 104,
          "properties": [
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -16
            }
          ]
        },
        {
          "id": 105,
          "properties": [
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -16
            }
          ]
        },
        {
          "id": 116,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 117,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 130,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 131,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 144,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 145,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 146,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 147,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 149,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 154,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 155,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 157,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 160,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "altGrass1"
            },
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -4
            }
          ]
        },
        {
          "id": 161,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "shortGrassTuft2"
            },
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -4
            }
          ]
        },
        {
          "id": 162,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "altGrass3"
            },
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -4
            }
          ]
        },
        {
          "id": 170,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 177,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "altGrass5"
            },
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -4
            }
          ]
        },
        {
          "id": 178,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "altGrass4"
            },
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -4
            }
          ]
        },
        {
          "id": 179,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "grassSprout"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "grassSprout"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -4
            }
          ]
        },
        {
          "id": 186,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 188,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 202,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 203,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 204,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 205,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 206,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 209,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "cattails1"
            }
          ]
        },
        {
          "id": 211,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tallGrass"
            }
          ]
        },
        {
          "id": 218,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "testgrass2"
            }
          ]
        },
        {
          "id": 219,
          "properties": [
            {
              "name": "compositeTileDense",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "testgrass"
            },
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -12
            },
            {
              "name": "variant",
              "type": "string",
              "value": "noisy"
            }
          ]
        },
        {
          "id": 220,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "altGrass2"
            }
          ]
        },
        {
          "id": 225,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "cattails1"
            }
          ]
        },
        {
          "id": 227,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "tallGrass"
            },
            {
              "name": "densityStrategy",
              "type": "string",
              "value": "denseVertical"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "tallGrass"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -4
            }
          ]
        },
        {
          "id": 228,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "reedsShort"
            }
          ]
        },
        {
          "id": 229,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tallReeds"
            }
          ]
        },
        {
          "id": 245,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "tallReeds"
            },
            {
              "name": "densityStrategy",
              "type": "string",
              "value": "denseVertical"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "tallReeds"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -4
            }
          ]
        },
        {
          "id": 278,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tallVine"
            }
          ]
        },
        {
          "id": 279,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tallVine"
            }
          ]
        },
        {
          "id": 280,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tallVine"
            }
          ]
        },
        {
          "id": 294,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tallVine"
            }
          ]
        },
        {
          "id": 295,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tallVine"
            }
          ]
        },
        {
          "id": 296,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tallVine"
            }
          ]
        },
        {
          "id": 310,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "tallVine"
            }
          ]
        },
        {
          "id": 323,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 324,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 325,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 339,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 340,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 341,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 352,
          "properties": [
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -12
            }
          ]
        },
        {
          "id": 353,
          "properties": [
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -12
            }
          ]
        },
        {
          "id": 354,
          "properties": [
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -12
            }
          ]
        },
        {
          "id": 355,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 356,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 357,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 360,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "bush2"
            }
          ]
        },
        {
          "id": 361,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "bush2"
            }
          ]
        },
        {
          "id": 364,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "deadBush"
            }
          ]
        },
        {
          "id": 365,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "deadBush"
            }
          ]
        },
        {
          "id": 366,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "deadTree1"
            }
          ]
        },
        {
          "id": 367,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "deadTree2"
            }
          ]
        },
        {
          "id": 368,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 369,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 370,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 371,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 372,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 373,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 376,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "bush2"
            },
            {
              "name": "renderYOffset",
              "type": "int",
              "value": 16
            }
          ]
        },
        {
          "id": 377,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "bush2"
            }
          ]
        },
        {
          "id": 380,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "deadBush"
            },
            {
              "name": "renderYOffset",
              "type": "int",
              "value": 16
            }
          ]
        },
        {
          "id": 381,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "deadBush"
            }
          ]
        },
        {
          "id": 382,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "deadTree1"
            }
          ]
        },
        {
          "id": 383,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "deadTree2"
            }
          ]
        },
        {
          "id": 384,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 385,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 388,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 389,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 392,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "bush1"
            }
          ]
        },
        {
          "id": 393,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "bush1"
            }
          ]
        },
        {
          "id": 396,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 397,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 400,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 408,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "bush1"
            },
            {
              "name": "renderYOffset",
              "type": "int",
              "value": 16
            }
          ]
        },
        {
          "id": 409,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "bush1"
            }
          ]
        },
        {
          "id": 412,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "smallBush"
            }
          ]
        },
        {
          "id": 416,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 420,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "sapling"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "sapling"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 421,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "groundLog"
            },
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -6
            }
          ]
        },
        {
          "id": 422,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 427,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 429,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 430,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 431,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 432,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "bigLog"
            }
          ]
        },
        {
          "id": 433,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "bigLog"
            }
          ]
        },
        {
          "id": 434,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "bigLog"
            }
          ]
        },
        {
          "id": 435,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "bigLog"
            }
          ]
        },
        {
          "id": 436,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "twig3"
            }
          ]
        },
        {
          "id": 437,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "twig3"
            }
          ]
        },
        {
          "id": 438,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 443,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 444,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 445,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "smallBush3"
            }
          ]
        },
        {
          "id": 446,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "smallBush4"
            }
          ]
        },
        {
          "id": 447,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 448,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "bigLog"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": ""
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 449,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "bigLog"
            }
          ]
        },
        {
          "id": 450,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "bigLog"
            }
          ]
        },
        {
          "id": 451,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "twig1"
            }
          ]
        },
        {
          "id": 452,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "twig2"
            }
          ]
        },
        {
          "id": 453,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "twig2"
            }
          ]
        },
        {
          "id": 464,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "bigLog"
            }
          ]
        },
        {
          "id": 465,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "bigLog"
            }
          ]
        },
        {
          "id": 466,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "bigLog2"
            }
          ]
        },
        {
          "id": 467,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "bigLog2"
            }
          ]
        },
        {
          "id": 468,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "bigLog2"
            }
          ]
        },
        {
          "id": 472,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 473,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "smallBush3"
            }
          ]
        },
        {
          "id": 475,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 476,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 478,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 479,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 487,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "smallTree1"
            }
          ]
        },
        {
          "id": 488,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "smallTree2"
            }
          ]
        },
        {
          "id": 489,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree2Small"
            }
          ]
        },
        {
          "id": 494,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree1Small"
            }
          ]
        },
        {
          "id": 503,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "smallTree1"
            }
          ]
        },
        {
          "id": 504,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "smallTree2"
            }
          ]
        },
        {
          "id": 505,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "tree2Small"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "tree2Small"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 510,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "tree1Small"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "tree1Small"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            }
          ]
        }
      ],
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    },
    "lpc-terrain": {
      "columns": 32,
      "image": "../../media/lpc-terrain.png",
      "imageheight": 1024,
      "imagewidth": 1024,
      "margin": 0,
      "name": "lpc-terrain",
      "spacing": 0,
      "tilecount": 1024,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tiles": [
        {
          "id": 121,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 124,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 227,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 440,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 441,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 442,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 472,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 473,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 474,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 478,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 481,
          "properties": [
            {
              "name": "deep",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 509,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderYOffset",
              "type": "int",
              "value": -16
            }
          ]
        },
        {
          "id": 544,
          "properties": [
            {
              "name": "deep",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 545,
          "properties": [
            {
              "name": "deep",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 546,
          "properties": [
            {
              "name": "deep",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 574,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 575,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 590,
          "properties": [
            {
              "name": "lava",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 591,
          "properties": [
            {
              "name": "lava",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 592,
          "properties": [
            {
              "name": "lava",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 594,
          "properties": [
            {
              "name": "lava",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 595,
          "properties": [
            {
              "name": "lava",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 596,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "generic_marker"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 606,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 622,
          "properties": [
            {
              "name": "lava",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 623,
          "properties": [
            {
              "name": "lava",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 624,
          "properties": [
            {
              "name": "lava",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 626,
          "properties": [
            {
              "name": "lava",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 627,
          "properties": [
            {
              "name": "lava",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 632,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "boulder1"
            }
          ]
        },
        {
          "id": 633,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "boulder1"
            }
          ]
        },
        {
          "id": 634,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "boulder2"
            }
          ]
        },
        {
          "id": 635,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "boulder2"
            }
          ]
        },
        {
          "id": 636,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "boulder3"
            }
          ]
        },
        {
          "id": 639,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": ""
            }
          ]
        },
        {
          "id": 651,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 654,
          "properties": [
            {
              "name": "lava",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 655,
          "properties": [
            {
              "name": "lava",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 656,
          "properties": [
            {
              "name": "lava",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 658,
          "properties": [
            {
              "name": "lava",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 659,
          "properties": [
            {
              "name": "lava",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 664,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "boulder1"
            }
          ]
        },
        {
          "id": 665,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "boulder1"
            }
          ]
        },
        {
          "id": 666,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "boulder2"
            }
          ]
        },
        {
          "id": 667,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "boulder2"
            }
          ]
        },
        {
          "id": 668,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "boulder3"
            }
          ]
        },
        {
          "id": 696,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "boulder4"
            }
          ]
        },
        {
          "id": 697,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "boulder4"
            }
          ]
        },
        {
          "id": 698,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "boulder5"
            }
          ]
        },
        {
          "id": 699,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "boulder5"
            }
          ]
        },
        {
          "id": 728,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "boulder4"
            }
          ]
        },
        {
          "id": 729,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "boulder4"
            }
          ]
        },
        {
          "id": 730,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "boulder5"
            }
          ]
        },
        {
          "id": 731,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "boulder5"
            }
          ]
        },
        {
          "id": 732,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 758,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "campfire"
            }
          ]
        },
        {
          "id": 759,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "campfire"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "campfire"
            },
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -16
            }
          ]
        },
        {
          "id": 760,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "campfire"
            }
          ]
        },
        {
          "id": 793,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 813,
          "properties": [
            {
              "name": "compositeTileDense",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "shrub"
            }
          ]
        },
        {
          "id": 815,
          "properties": [
            {
              "name": "compositeTileDense",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "corn"
            },
            {
              "name": "spriteId",
              "type": "string",
              "value": "corn.png"
            }
          ]
        }
      ],
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    },
    "map-atlas": {
      "columns": 7,
      "image": "../../media/map-atlas.png",
      "imageheight": 672,
      "imagewidth": 239,
      "margin": 0,
      "name": "map-atlas",
      "spacing": 0,
      "tilecount": 147,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tiles": [
        {
          "id": 0,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 1,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 2,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 3,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 4,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 5,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 6,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 7,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 9,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 10,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 11,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 12,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 13,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 14,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 17,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 18,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 19,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 21,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 22,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 23,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 24,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 25,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 26,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 27,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 28,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 29,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 30,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 31,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 32,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 33,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 34,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 35,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 36,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 37,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 38,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 39,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 40,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 41,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 42,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 43,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 44,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 45,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 46,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 47,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 48,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 49,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 50,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 51,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 52,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 53,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 54,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 55,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 56,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 57,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 58,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 59,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 60,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 61,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 62,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 63,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 64,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 65,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 66,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 67,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 68,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 69,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 70,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 71,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 72,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 73,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 74,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 75,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 76,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 77,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 78,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 79,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 80,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 81,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 82,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 83,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 84,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 85,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 86,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 87,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 88,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 89,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 90,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 91,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 92,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 93,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 94,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 95,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 96,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 97,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 98,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 99,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 100,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 101,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 102,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 103,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 104,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 105,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 106,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 107,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 108,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 109,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 110,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 111,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 112,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 113,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 114,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 115,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 116,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 117,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 118,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 119,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 120,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 121,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 122,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 123,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 124,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 125,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 126,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 127,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 128,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 129,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 130,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 131,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        },
        {
          "id": 132,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        }
      ],
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    },
    "mountains-v6": {
      "columns": 64,
      "image": "../../media/mountains-v6.png",
      "imageheight": 2560,
      "imagewidth": 2048,
      "margin": 0,
      "name": "mountains-v6",
      "spacing": 0,
      "tilecount": 5120,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tiles": [
        {
          "id": 2328,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "testore"
            }
          ]
        },
        {
          "id": 2329,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "stoneBreaklevel1"
            }
          ]
        },
        {
          "id": 2330,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "stoneBreaklevel2"
            }
          ]
        },
        {
          "id": 2331,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "stoneBreaklevel3"
            }
          ]
        },
        {
          "id": 2392,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "breakageMeta",
              "type": "string",
              "value": "{\n    \"descriptors\": [\n        {\n            \"tilesetId\": \"mountains-v6\",\n            \"compositeTileId\": \"stoneBreaklevel1\",\n            \"thresholdLow\": 0.3,\n            \"thresholdHigh\": 0.5\n        },\n        {\n            \"tilesetId\": \"mountains-v6\",\n            \"compositeTileId\": \"stoneBreaklevel2\",\n            \"thresholdLow\": 0.5,\n            \"thresholdHigh\": 0.7\n        },\n        {\n            \"tilesetId\": \"mountains-v6\",\n            \"compositeTileId\": \"stoneBreaklevel3\",\n            \"thresholdLow\": 0.7\n        }\n    ]\n}"
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "testore"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "testore"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 2393,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "stoneBreaklevel1"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "stoneBreaklevel1"
            }
          ]
        },
        {
          "id": 2394,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "stoneBreaklevel2"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "stoneBreaklevel2"
            }
          ]
        },
        {
          "id": 2395,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "stoneBreaklevel3"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "stoneBreaklevel3"
            }
          ]
        }
      ],
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    },
    "ore": {
      "columns": 16,
      "image": "../../media/ore.png",
      "imageheight": 512,
      "imagewidth": 512,
      "margin": 0,
      "name": "ore",
      "spacing": 0,
      "tilecount": 256,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tiles": [
        {
          "id": 0,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "ore-coal1"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "ore-coal"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 1,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 2,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 3,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 4,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 5,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 18,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 19,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 20,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 21,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 22,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 33,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 34,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 35,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 36,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 37,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 38,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 48,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 49,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 50,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 51,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 52,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 53,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 54,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 64,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "ore-coal2"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "ore-coal"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 65,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 66,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 67,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 68,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 69,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 70,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 82,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 83,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 84,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 85,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 86,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 96,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "ore-coal3"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "ore-coal"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 97,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 98,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 99,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 100,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 101,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 102,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "rock1"
            },
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -12
            }
          ]
        },
        {
          "id": 112,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "ore-coal4"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "ore-coal"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 113,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 114,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 115,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 116,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 117,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 118,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "rock2"
            },
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -12
            }
          ]
        },
        {
          "id": 178,
          "properties": [
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -24
            }
          ]
        },
        {
          "id": 179,
          "properties": [
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -24
            }
          ]
        },
        {
          "id": 180,
          "properties": [
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -24
            }
          ]
        },
        {
          "id": 181,
          "properties": [
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -24
            }
          ]
        },
        {
          "id": 182,
          "properties": [
            {
              "name": "renderZIdxOffset",
              "type": "int",
              "value": -24
            }
          ]
        }
      ],
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    },
    "plants": {
      "columns": 13,
      "image": "../../media/plants.png",
      "imageheight": 416,
      "imagewidth": 416,
      "margin": 0,
      "name": "plants",
      "spacing": 0,
      "tilecount": 169,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tiles": [
        {
          "id": 2,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree3"
            }
          ]
        },
        {
          "id": 3,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree3"
            }
          ]
        },
        {
          "id": 4,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree3"
            }
          ]
        },
        {
          "id": 5,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree3"
            }
          ]
        },
        {
          "id": 6,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree4"
            }
          ]
        },
        {
          "id": 7,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree4"
            }
          ]
        },
        {
          "id": 8,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree4"
            }
          ]
        },
        {
          "id": 15,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree3"
            }
          ]
        },
        {
          "id": 16,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree3"
            }
          ]
        },
        {
          "id": 17,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree3"
            }
          ]
        },
        {
          "id": 18,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree3"
            }
          ]
        },
        {
          "id": 19,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree4"
            }
          ]
        },
        {
          "id": 20,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree4"
            }
          ]
        },
        {
          "id": 21,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree4"
            }
          ]
        },
        {
          "id": 28,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree3"
            }
          ]
        },
        {
          "id": 29,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree3"
            }
          ]
        },
        {
          "id": 30,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree3"
            }
          ]
        },
        {
          "id": 31,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree3"
            }
          ]
        },
        {
          "id": 32,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree4"
            }
          ]
        },
        {
          "id": 33,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree4"
            }
          ]
        },
        {
          "id": 34,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree4"
            }
          ]
        },
        {
          "id": 41,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree3"
            }
          ]
        },
        {
          "id": 42,
          "properties": [
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "tree3"
            }
          ]
        },
        {
          "id": 43,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree3"
            }
          ]
        },
        {
          "id": 44,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree3"
            }
          ]
        },
        {
          "id": 45,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree4"
            }
          ]
        },
        {
          "id": 46,
          "properties": [
            {
              "name": "blockingRects",
              "type": "string",
              "value": "[{\"x\":6,\"y\":1,\"width\":20,\"height\":12,\"bodyInsetBottom\":8}]"
            },
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "tree4"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "tree4"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderXOffset",
              "type": "int",
              "value": -8
            },
            {
              "name": "renderYOffset",
              "type": "int",
              "value": 25
            }
          ]
        },
        {
          "id": 47,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree4"
            }
          ]
        },
        {
          "id": 52,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 53,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 55,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree1"
            }
          ]
        },
        {
          "id": 56,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree1"
            }
          ]
        },
        {
          "id": 57,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree1"
            }
          ]
        },
        {
          "id": 58,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree2"
            }
          ]
        },
        {
          "id": 59,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree2"
            }
          ]
        },
        {
          "id": 60,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree2"
            }
          ]
        },
        {
          "id": 68,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree1"
            }
          ]
        },
        {
          "id": 69,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree1"
            }
          ]
        },
        {
          "id": 70,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree1"
            }
          ]
        },
        {
          "id": 71,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree2"
            }
          ]
        },
        {
          "id": 72,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree2"
            }
          ]
        },
        {
          "id": 73,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree2"
            }
          ]
        },
        {
          "id": 78,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "deadTree"
            }
          ]
        },
        {
          "id": 79,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "deadTree"
            }
          ]
        },
        {
          "id": 80,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "deadTree"
            }
          ]
        },
        {
          "id": 81,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree1"
            }
          ]
        },
        {
          "id": 82,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree1"
            }
          ]
        },
        {
          "id": 83,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree1"
            }
          ]
        },
        {
          "id": 84,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree2"
            }
          ]
        },
        {
          "id": 85,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree2"
            }
          ]
        },
        {
          "id": 86,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree2"
            }
          ]
        },
        {
          "id": 87,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "smallTree1"
            }
          ]
        },
        {
          "id": 88,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "smallTree1"
            }
          ]
        },
        {
          "id": 91,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "deadTree"
            }
          ]
        },
        {
          "id": 92,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "deadTree"
            }
          ]
        },
        {
          "id": 93,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "deadTree"
            }
          ]
        },
        {
          "id": 94,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree1"
            }
          ]
        },
        {
          "id": 95,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree1"
            }
          ]
        },
        {
          "id": 96,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree1"
            }
          ]
        },
        {
          "id": 97,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree2"
            }
          ]
        },
        {
          "id": 98,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree2"
            }
          ]
        },
        {
          "id": 99,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree2"
            }
          ]
        },
        {
          "id": 100,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "smallTree1"
            }
          ]
        },
        {
          "id": 101,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "smallTree1"
            }
          ]
        },
        {
          "id": 104,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "deadTree"
            }
          ]
        },
        {
          "id": 105,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "deadTree"
            }
          ]
        },
        {
          "id": 106,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "deadTree"
            }
          ]
        },
        {
          "id": 107,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree1"
            }
          ]
        },
        {
          "id": 108,
          "properties": [
            {
              "name": "blockingRects",
              "type": "string",
              "value": "[{\"x\":6,\"y\":10,\"width\":24,\"height\":9,\"bodyInsetBottom\":8}]"
            },
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "tree1"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "tree1"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderXOffset",
              "type": "int",
              "value": -8
            },
            {
              "name": "renderYOffset",
              "type": "int",
              "value": 25
            }
          ]
        },
        {
          "id": 109,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree1"
            }
          ]
        },
        {
          "id": 110,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree2"
            }
          ]
        },
        {
          "id": 111,
          "properties": [
            {
              "name": "blockingRects",
              "type": "string",
              "value": "[{\"x\":0,\"y\":1,\"width\":32,\"height\":12,\"bodyInsetBottom\":8}]"
            },
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "tree2"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "tree2"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            },
            {
              "name": "renderXOffset",
              "type": "int",
              "value": -8
            },
            {
              "name": "renderYOffset",
              "type": "int",
              "value": 25
            }
          ]
        },
        {
          "id": 112,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree2"
            }
          ]
        },
        {
          "id": 113,
          "properties": [
            {
              "name": "blockingRects",
              "type": "string",
              "value": "[{\"x\":8,\"y\":-20,\"width\":16,\"height\":10,\"bodyInsetBottom\":8}]"
            },
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "smallTree1"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "smallTree1"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 114,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "smallTree1"
            }
          ]
        },
        {
          "id": 117,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree6"
            }
          ]
        },
        {
          "id": 118,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree6"
            }
          ]
        },
        {
          "id": 119,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree6"
            }
          ]
        },
        {
          "id": 120,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree6"
            }
          ]
        },
        {
          "id": 121,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree5"
            }
          ]
        },
        {
          "id": 122,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree5"
            }
          ]
        },
        {
          "id": 123,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree5"
            }
          ]
        },
        {
          "id": 130,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree6"
            }
          ]
        },
        {
          "id": 131,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree6"
            }
          ]
        },
        {
          "id": 132,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree6"
            }
          ]
        },
        {
          "id": 133,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree6"
            }
          ]
        },
        {
          "id": 134,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree5"
            }
          ]
        },
        {
          "id": 135,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree5"
            }
          ]
        },
        {
          "id": 136,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree5"
            }
          ]
        },
        {
          "id": 143,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree6"
            }
          ]
        },
        {
          "id": 144,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree6"
            }
          ]
        },
        {
          "id": 145,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree6"
            }
          ]
        },
        {
          "id": 146,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree6"
            }
          ]
        },
        {
          "id": 147,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree5"
            }
          ]
        },
        {
          "id": 148,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree5"
            }
          ]
        },
        {
          "id": 149,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree5"
            }
          ]
        },
        {
          "id": 156,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree6"
            }
          ]
        },
        {
          "id": 157,
          "properties": [
            {
              "name": "blockingRects",
              "type": "string",
              "value": "[{\"x\":8,\"y\":-20,\"width\":24,\"height\":9,\"bodyInsetBottom\":8}]"
            },
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "tree6"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "tree6"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 158,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree6"
            }
          ]
        },
        {
          "id": 159,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree6"
            }
          ]
        },
        {
          "id": 160,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree5"
            }
          ]
        },
        {
          "id": 161,
          "properties": [
            {
              "name": "blockingRects",
              "type": "string",
              "value": "[{\"x\":8,\"y\":-20,\"width\":32,\"height\":9,\"bodyInsetBottom\":8}]"
            },
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            },
            {
              "name": "compositeTileIdParent",
              "type": "string",
              "value": "tree5"
            },
            {
              "name": "entityTileId",
              "type": "string",
              "value": "tree5"
            },
            {
              "name": "malleable",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 162,
          "properties": [
            {
              "name": "compositeTileId",
              "type": "string",
              "value": "tree5"
            }
          ]
        },
        {
          "id": 164,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": true
            }
          ]
        },
        {
          "id": 167,
          "properties": [
            {
              "name": "blocking",
              "type": "bool",
              "value": false
            }
          ]
        }
      ],
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    },
    "roofs": {
      "columns": 64,
      "image": "../../media/roofs.png",
      "imageheight": 2048,
      "imagewidth": 2048,
      "margin": 0,
      "name": "roofs",
      "spacing": 0,
      "tilecount": 4096,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    },
    "walls": {
      "columns": 64,
      "image": "../../media/walls.png",
      "imageheight": 3072,
      "imagewidth": 2048,
      "margin": 0,
      "name": "walls",
      "spacing": 0,
      "tilecount": 6144,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    },
    "walls2": {
      "columns": 32,
      "image": "../../media/walls2.png",
      "imageheight": 1024,
      "imagewidth": 1024,
      "margin": 0,
      "name": "walls2",
      "spacing": 0,
      "tilecount": 1024,
      "tiledversion": "1.9.0",
      "tileheight": 32,
      "tiles": [
        {
          "id": 14,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 9
            }
          ]
        },
        {
          "id": 42,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 43,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 44,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 45,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 46,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 7
            }
          ]
        },
        {
          "id": 74,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 10
            }
          ]
        },
        {
          "id": 75,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 2
            }
          ]
        },
        {
          "id": 76,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 1
            }
          ]
        },
        {
          "id": 77,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 3
            }
          ]
        },
        {
          "id": 81,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 8
            }
          ]
        },
        {
          "id": 106,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 107,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 0
            }
          ]
        },
        {
          "id": 110,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 111,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 138,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 11
            }
          ]
        },
        {
          "id": 139,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 140,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 141,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 171,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 5
            }
          ]
        },
        {
          "id": 172,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 12
            }
          ]
        },
        {
          "id": 173,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 6
            }
          ]
        },
        {
          "id": 204,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 206,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 207,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 209,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 4
            }
          ]
        },
        {
          "id": 236,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        },
        {
          "id": 238,
          "properties": [
            {
              "name": "woodenWall",
              "type": "int",
              "value": 13
            }
          ]
        }
      ],
      "tilewidth": 32,
      "type": "tileset",
      "version": 1.9
    }
  },
  "npcDrops": {
    "chicken": [
      {
        "itemType": {
          "class": "resource",
          "color": "brown",
          "type": "drumstick"
        },
        "quantity": 1
      },
      {
        "itemType": {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:72",
          "type": "feather"
        },
        "quantity": 10
      }
    ],
    "deer": [
      {
        "itemType": {
          "class": "resource",
          "color": "brown",
          "type": "hide"
        },
        "quantity": 3
      },
      {
        "itemType": {
          "class": "resource",
          "color": "brown",
          "type": "drumstick"
        },
        "quantity": 3
      }
    ],
    "human": [
      {
        "itemType": {
          "class": "resource",
          "color": "gray",
          "type": "shard-metal"
        },
        "probability": 0.2,
        "quantity": 10
      }
    ],
    "rabbit": [
      {
        "itemType": {
          "class": "resource",
          "color": "brown",
          "type": "hide"
        },
        "quantity": 1
      },
      {
        "itemType": {
          "class": "resource",
          "color": "brown",
          "type": "drumstick"
        },
        "quantity": 2
      }
    ],
    "redspider": [
      {
        "itemType": {
          "class": "resource",
          "color": "na",
          "spriteId": "ore:88",
          "type": "spider-silk"
        },
        "probability": 1,
        "quantity": 1
      }
    ],
    "skeleton": [
      {
        "itemType": {
          "class": "resource",
          "color": "gray",
          "type": "shard-metal"
        },
        "probability": 0.6,
        "quantity": 2
      }
    ],
    "slime": [
      {
        "itemType": {
          "class": "resource",
          "color": "gray",
          "type": "shard-metal"
        },
        "probability": 0.35,
        "quantity": 1
      }
    ],
    "snake": [
      {
        "itemType": {
          "class": "resource",
          "color": "gray",
          "type": "shard-metal"
        },
        "probability": 0.25,
        "quantity": 1
      }
    ],
    "wolfman": [
      {
        "itemType": {
          "class": "resource",
          "color": "gray",
          "type": "shard-metal"
        },
        "probability": 1,
        "quantity": 8
      },
      {
        "itemType": {
          "class": "resource",
          "color": "gray",
          "type": "shard-metal"
        },
        "probability": 0.5,
        "quantity": 1
      },
      {
        "itemType": {
          "class": "resource",
          "color": "brown",
          "type": "hide"
        },
        "probability": 0.5,
        "quantity": 2
      }
    ]
  },
  "revision": "d0e0ae59ade249820052064486358534c84ac7040f435cb689203b823bc7f470",
  "schemaVersion": 1,
  "source": {
    "autotiles": {
      "about": "Autotile definitions: parameters only. The mechanics stay in code (packages/common/room/autotile_library.ts, and autotile_wall.ts for kind `wall`), selected by each definition's `kind`. Indices are autotiler.ts bitmask indices 1-47; tile positions are 0-based cells of the named tileset. A `wall` entry is a building wall material: per index, the tiles to emit at offsets from the wall's cell, in order (later steps see earlier ones); which item builds it is mapped in house.ts. Validated on load and by autotile_library.test.ts.",
      "definitions": [
        {
          "id": "lpc-terrain:353",
          "kind": "bitmask",
          "name": "Grass (Tiled templates)",
          "tilePos": 353,
          "tiledTemplate": true,
          "tiles": {
            "4": 322,
            "7": 320,
            "12": 321,
            "26": 258,
            "28": 290,
            "33": 193,
            "34": 256,
            "36": 288,
            "41": 194,
            "42": 257,
            "44": 225,
            "45": 226
          },
          "tilesetId": "lpc-terrain"
        },
        {
          "id": "lpc-terrain:676",
          "kind": "bitmask",
          "name": "Dirt patch with grass fringe (Tiled templates)",
          "tilePos": 676,
          "tiledTemplate": true,
          "tiles": {
            "4": 709,
            "7": 707,
            "12": 708,
            "26": 645,
            "28": 677,
            "33": 580,
            "34": 643,
            "36": 675,
            "41": 581,
            "42": 644,
            "44": 612,
            "45": 613
          },
          "tilesetId": "lpc-terrain"
        },
        {
          "fallback": -1,
          "id": "grass",
          "kind": "bitmask",
          "layerId": "map1",
          "name": "Grass",
          "tilePos": 353,
          "tiles": {
            "1": 1011,
            "2": 981,
            "3": 950,
            "4": 322,
            "5": 980,
            "6": 949,
            "7": 320,
            "8": 886,
            "10": 934,
            "11": 889,
            "12": 321,
            "13": 979,
            "14": 917,
            "15": 918,
            "17": 890,
            "18": 885,
            "20": 986,
            "25": 1015,
            "26": 258,
            "27": 933,
            "28": 290,
            "29": 955,
            "31": 984,
            "32": 887,
            "33": 193,
            "34": 256,
            "35": 967,
            "36": 288,
            "37": 954,
            "39": 888,
            "40": 982,
            "41": 194,
            "42": 257,
            "43": 951,
            "44": 225,
            "45": 226,
            "47": 192
          },
          "tilesetId": "lpc-terrain"
        },
        {
          "fallback": 481,
          "id": "swamp",
          "kind": "bitmask",
          "layerId": "map1",
          "name": "Swamp water",
          "tilePos": 546,
          "tiles": {
            "4": 514,
            "7": 512,
            "10": 514,
            "11": 512,
            "12": 513,
            "14": 785,
            "17": 514,
            "20": 512,
            "26": 450,
            "27": 450,
            "28": 482,
            "29": 450,
            "33": 385,
            "34": 448,
            "35": 448,
            "36": 480,
            "37": 448,
            "41": 386,
            "42": 449,
            "44": 417,
            "45": 418
          },
          "tilesetId": "lpc-terrain"
        },
        {
          "fallback": 623,
          "id": "lava",
          "kind": "bitmask",
          "layerId": "map4",
          "name": "Lava",
          "notes": {
            "1": "rim E,S,W -> S edge (bottom cap / south tip)",
            "2": "rim N,E,S -> E edge (east cap / east tip)",
            "3": "rim E,S, notch NW -> SE corner",
            "4": "rim S,E SE corner (swamp's 514)",
            "5": "rim N,S,W -> W edge (west cap / west tip)",
            "6": "rim S,W, notch NE -> SW corner",
            "7": "rim S,W SW corner (swamp's 512)",
            "8": "rim N,S -> S edge",
            "9": "rim S, notches NW+NE",
            "10": "rim S, notch NE -> S edge (was 656, the SE corner, as swamp maps it)",
            "11": "rim S, notch NW -> S edge (was 654, the SW corner, as swamp maps it)",
            "12": "rim S S edge (swamp's 513)",
            "13": "rim N,E,W -> N edge (top cap of a vertical run / north tip of a diamond)",
            "14": "rim W,E the 1-wide N/S channel (swamp's 785)",
            "15": "rim N,E, notch SW -> NE corner",
            "16": "rim E, notches NW+SW",
            "17": "rim E, notch SW -> E edge (was 656, the SE corner, as swamp maps it)",
            "18": "rim N,W, notch SE -> NW corner",
            "19": "rim W, notches NE+SE",
            "20": "rim W, notch SE -> W edge (was 654, the SW corner, as swamp maps it)",
            "21": "rim N, notches SW+SE",
            "22": "all four notches <- the centre of a plus, i.e. of a radius-1 flood",
            "23": "notches NE+SW+SE",
            "24": "notches NW+SW+SE",
            "25": "notches SW+SE <- the south mid-edge cell",
            "26": "rim N,E NE corner (swamp's 450)",
            "27": "rim E, notch NW -> E edge (was 592, the NE corner, as swamp maps it)",
            "28": "rim E E edge (swamp's 482)",
            "29": "rim N, notch SE -> N edge (was 592, the NE corner, as swamp maps it)",
            "30": "notches NW+NE+SE",
            "31": "notches NE+SE <- the east mid-edge cell",
            "32": "notches NW+SE (saddle)",
            "33": "no rim, notch SE inner corner (swamp's 385)",
            "34": "rim N,W NW corner (swamp's 448)",
            "35": "rim W, notch NE -> W edge (was 590, the NW corner, as swamp maps it)",
            "36": "rim W W edge (swamp's 480)",
            "37": "rim N, notch SW -> N edge (was 590, the NW corner, as swamp maps it)",
            "38": "notches NW+NE+SW",
            "39": "notches NE+SW (saddle)",
            "40": "notches NW+SW <- the west mid-edge cell",
            "41": "no rim, notch SW inner corner (swamp's 386)",
            "42": "rim N N edge (swamp's 449)",
            "43": "notches NW+NE <- the north mid-edge cell of every flood diamond",
            "44": "no rim, notch NE inner corner (swamp's 417)",
            "45": "no rim, notch NW inner corner (swamp's 418)",
            "47": "rim N,E,S,W -> the N/S channel, read as a one-cell segment"
          },
          "tilePos": 658,
          "tiles": {
            "1": 655,
            "2": 624,
            "3": 656,
            "4": 656,
            "5": 622,
            "6": 654,
            "7": 654,
            "8": 655,
            "9": 655,
            "10": 655,
            "11": 655,
            "12": 655,
            "13": 591,
            "14": 659,
            "15": 592,
            "16": 624,
            "17": 624,
            "18": 590,
            "19": 622,
            "20": 622,
            "21": 591,
            "22": 658,
            "23": 658,
            "24": 658,
            "25": 658,
            "26": 592,
            "27": 624,
            "28": 624,
            "29": 591,
            "30": 658,
            "31": 658,
            "32": 658,
            "33": 594,
            "34": 590,
            "35": 622,
            "36": 622,
            "37": 591,
            "38": 658,
            "39": 658,
            "40": 658,
            "41": 595,
            "42": 591,
            "43": 658,
            "44": 626,
            "45": 627,
            "47": 659
          },
          "tilesetId": "lpc-terrain"
        },
        {
          "id": "forest-dirt",
          "indices": [
            4,
            7,
            12,
            26,
            28,
            33,
            34,
            36,
            41,
            42,
            44,
            45
          ],
          "kind": "uniform",
          "layerId": "map3",
          "name": "Forest dirt",
          "previewTilePos": 436,
          "tilesetId": "lpc-flowers-plants-fungi-wood"
        },
        {
          "id": "lpc-terrain:377",
          "kind": "platform",
          "name": "Cave wall / rock cliff",
          "preview": {
            "autoBlocking": true,
            "autoOcclusion": true,
            "layerId": "map3"
          },
          "tilePos": 377,
          "tilesetId": "lpc-terrain",
          "variants": [
            344,
            345,
            346,
            376,
            378,
            408,
            409,
            410,
            440,
            441,
            442,
            472,
            473,
            474,
            223,
            222,
            191,
            190,
            5,
            344,
            346,
            408,
            410
          ]
        },
        {
          "id": "mountains-v6:837",
          "kind": "platform",
          "name": "Mountain cliff, pale stone",
          "preview": {
            "autoBlocking": true,
            "autoOcclusion": false,
            "layerId": "map4"
          },
          "tilePos": 837,
          "tilesetId": "mountains-v6",
          "variants": [
            772,
            773,
            774,
            836,
            838,
            900,
            901,
            902,
            964,
            965,
            966,
            1028,
            1029,
            1030,
            839,
            835,
            1481,
            1483,
            -1,
            772,
            774,
            900,
            902
          ]
        },
        {
          "id": "mountains-v6:861",
          "kind": "platform",
          "name": "Mountain cliff, dark stone",
          "preview": {
            "autoBlocking": true,
            "autoOcclusion": false,
            "layerId": "map4"
          },
          "tilePos": 861,
          "tilesetId": "mountains-v6",
          "variants": [
            796,
            797,
            798,
            860,
            862,
            924,
            925,
            926,
            988,
            989,
            990,
            1052,
            1053,
            1054,
            863,
            859,
            1505,
            1507,
            23,
            796,
            798,
            924,
            926
          ]
        },
        {
          "cell": {
            "blocking": {
              "tilePos": 121,
              "tilesetId": "lpc-terrain"
            },
            "occlusion": {
              "tilePos": 121,
              "tilesetId": "lpc-terrain"
            }
          },
          "id": "wall-wood",
          "itemType": "wall-wood",
          "kind": "wall",
          "layerId": "sprite",
          "name": "Log cabin wall",
          "notes": {
            "1": "south end of a north-south run: one tile on the cell, the column's foot",
            "2": "east end of an east-west run: cap above, base",
            "3": "bottom-right corner (walls north and west). Its cap lands on the wall above and re-points that wall's tile: the joint under a top-left corner or an east T (index 18/19), the plain one otherwise",
            "5": "west end of an east-west run: cap above, base",
            "6": "bottom-left corner (walls north and east). Its cap lands on the wall above and re-points that wall's tile: the joint under a top-right corner or a west T (index 15/16), the plain one otherwise",
            "8": "middle of an east-west run (and the only index a door may stand on): cap above, base",
            "9": "T with its stem north (walls west, east and north): the cap re-points the stem's foot",
            "13": "north end of a north-south run: one tile on the cell, the column's top; a different top when the wall south-east of it is an east end (index 2)",
            "14": "middle of a north-south run: one tile on the cell",
            "15": "top-right corner (walls west and south): cap above, base. The other base needs a tile already east of the cell, which no wall puts there (only another feature on the layer)",
            "16": "west T (walls north, west and south): its cap re-points the wall above, with the joint under a top-left corner (index 18)",
            "18": "top-left corner (walls east and south): cap above, base",
            "19": "east T (walls north, east and south). The cap re-points the wall above: the joint when no tile is north-west of the cell, the other when a wall's base already is. If a tile already sits west of the cell (no wall puts one there), it draws on the cell instead, the base re-points that tile, and there is no cap",
            "21": "T with its stem south (walls west, east and south): cap above, base",
            "22": "cross (walls on all four sides): the cap re-points the wall above",
            "47": "a lone wall: cap above, base"
          },
          "ornaments": {
            "burl": {
              "scatter": 0.06,
              "tiles": {
                "642": 680,
                "669": 681
              }
            },
            "fungus": {
              "scatter": 0.04,
              "tiles": {
                "642": 682,
                "669": 683
              }
            },
            "knots": {
              "scatter": 0.09,
              "tiles": {
                "642": 684,
                "669": 685
              }
            },
            "lichen": {
              "scatter": 0.06,
              "tiles": {
                "642": 686,
                "669": 687
              }
            },
            "moss": {
              "scatter": 0.1,
              "tiles": {
                "642": 688,
                "669": 689
              }
            },
            "split": {
              "scatter": 0.07,
              "tiles": {
                "642": 690,
                "669": 691
              }
            }
          },
          "rules": {
            "1": [
              {
                "tile": 630
              }
            ],
            "2": [
              {
                "dy": -1,
                "tile": 645
              },
              {
                "tile": 653
              }
            ],
            "3": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 651
                      }
                    ],
                    "when": {
                      "index": [
                        18,
                        19
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 656
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 659
              }
            ],
            "5": [
              {
                "dy": -1,
                "tile": 631
              },
              {
                "tile": 636
              }
            ],
            "6": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 652
                      }
                    ],
                    "when": {
                      "index": [
                        15,
                        16
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 654
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 657
              }
            ],
            "8": [
              {
                "dy": -1,
                "tile": 633
              },
              {
                "tile": 642
              }
            ],
            "9": [
              {
                "dy": -1,
                "tile": 664
              },
              {
                "tile": 642
              }
            ],
            "13": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 644
                      }
                    ],
                    "when": {
                      "index": [
                        2
                      ],
                      "neighbour": [
                        1,
                        1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "tile": 635
                      }
                    ]
                  }
                ]
              }
            ],
            "14": [
              {
                "tile": 646
              }
            ],
            "15": [
              {
                "dy": -1,
                "tile": 634
              },
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 663
                      }
                    ],
                    "when": {
                      "exists": [
                        1,
                        0
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "tile": 643
                      }
                    ]
                  }
                ]
              }
            ],
            "16": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 661
                      }
                    ],
                    "when": {
                      "index": [
                        18
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 665
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 643
              }
            ],
            "18": [
              {
                "dy": -1,
                "tile": 632
              },
              {
                "tile": 637
              }
            ],
            "19": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 651
                      }
                    ],
                    "when": {
                      "all": [
                        {
                          "exists": [
                            -1,
                            0
                          ]
                        },
                        {
                          "neighbour": [
                            1,
                            0
                          ]
                        }
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 644
                      }
                    ],
                    "when": {
                      "not": {
                        "exists": [
                          -1,
                          -1
                        ]
                      }
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 662
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 637
              }
            ],
            "21": [
              {
                "dy": -1,
                "tile": 655
              },
              {
                "tile": 658
              }
            ],
            "22": [
              {
                "dy": -1,
                "tile": 660
              },
              {
                "tile": 658
              }
            ],
            "47": [
              {
                "dy": -1,
                "tile": 633
              },
              {
                "tile": 642
              }
            ]
          },
          "seams": {
            "continued": {
              "635": {
                "tilePos": 712,
                "tilesetId": "authored-terrain"
              },
              "646": {
                "tilePos": 713,
                "tilesetId": "authored-terrain"
              },
              "666": {
                "tilePos": 714,
                "tilesetId": "authored-terrain"
              },
              "667": {
                "tilePos": 715,
                "tilesetId": "authored-terrain"
              },
              "668": {
                "tilePos": 716,
                "tilesetId": "authored-terrain"
              },
              "669": {
                "tilePos": 717,
                "tilesetId": "authored-terrain"
              },
              "670": {
                "tilePos": 718,
                "tilesetId": "authored-terrain"
              },
              "673": {
                "tilePos": 719,
                "tilesetId": "authored-terrain"
              },
              "674": {
                "tilePos": 720,
                "tilesetId": "authored-terrain"
              },
              "675": {
                "tilePos": 721,
                "tilesetId": "authored-terrain"
              },
              "676": {
                "tilePos": 722,
                "tilesetId": "authored-terrain"
              },
              "680": {
                "tilePos": 723,
                "tilesetId": "authored-terrain"
              },
              "681": {
                "tilePos": 724,
                "tilesetId": "authored-terrain"
              },
              "682": {
                "tilePos": 725,
                "tilesetId": "authored-terrain"
              },
              "683": {
                "tilePos": 726,
                "tilesetId": "authored-terrain"
              },
              "684": {
                "tilePos": 727,
                "tilesetId": "authored-terrain"
              },
              "685": {
                "tilePos": 728,
                "tilesetId": "authored-terrain"
              },
              "686": {
                "tilePos": 729,
                "tilesetId": "authored-terrain"
              },
              "687": {
                "tilePos": 730,
                "tilesetId": "authored-terrain"
              },
              "688": {
                "tilePos": 731,
                "tilesetId": "authored-terrain"
              },
              "689": {
                "tilePos": 732,
                "tilesetId": "authored-terrain"
              },
              "690": {
                "tilePos": 733,
                "tilesetId": "authored-terrain"
              },
              "691": {
                "tilePos": 734,
                "tilesetId": "authored-terrain"
              }
            },
            "covered": {
              "631": {
                "tilePos": 692,
                "tilesetId": "authored-terrain"
              },
              "632": {
                "tilePos": 693,
                "tilesetId": "authored-terrain"
              },
              "633": {
                "tilePos": 694,
                "tilesetId": "authored-terrain"
              },
              "634": {
                "tilePos": 695,
                "tilesetId": "authored-terrain"
              },
              "644": {
                "tilePos": 696,
                "tilesetId": "authored-terrain"
              },
              "645": {
                "tilePos": 697,
                "tilesetId": "authored-terrain"
              },
              "651": {
                "tilePos": 698,
                "tilesetId": "authored-terrain"
              },
              "652": {
                "tilePos": 699,
                "tilesetId": "authored-terrain"
              },
              "654": {
                "tilePos": 700,
                "tilesetId": "authored-terrain"
              },
              "655": {
                "tilePos": 701,
                "tilesetId": "authored-terrain"
              },
              "656": {
                "tilePos": 702,
                "tilesetId": "authored-terrain"
              },
              "660": {
                "tilePos": 703,
                "tilesetId": "authored-terrain"
              },
              "661": {
                "tilePos": 704,
                "tilesetId": "authored-terrain"
              },
              "662": {
                "tilePos": 705,
                "tilesetId": "authored-terrain"
              },
              "664": {
                "tilePos": 706,
                "tilesetId": "authored-terrain"
              },
              "665": {
                "tilePos": 707,
                "tilesetId": "authored-terrain"
              },
              "671": {
                "tilePos": 708,
                "tilesetId": "authored-terrain"
              },
              "672": {
                "tilePos": 709,
                "tilesetId": "authored-terrain"
              },
              "677": {
                "tilePos": 710,
                "tilesetId": "authored-terrain"
              },
              "678": {
                "tilePos": 711,
                "tilesetId": "authored-terrain"
              }
            },
            "joints": {
              "635": {
                "tilePos": 818,
                "tilesetId": "authored-terrain"
              },
              "646": {
                "tilePos": 820,
                "tilesetId": "authored-terrain"
              },
              "666": {
                "tilePos": 821,
                "tilesetId": "authored-terrain"
              }
            },
            "lintel": {
              "tilePos": 735,
              "tilesetId": "authored-terrain"
            },
            "style": "seamless"
          },
          "tilesetId": "authored-terrain",
          "upperTiles": {
            "630": 666,
            "636": 667,
            "637": 668,
            "642": 669,
            "643": 670,
            "651": 671,
            "652": 672,
            "653": 673,
            "657": 674,
            "658": 675,
            "659": 676,
            "661": 677,
            "662": 678,
            "663": 679
          }
        },
        {
          "cell": {
            "blocking": {
              "tilePos": 121,
              "tilesetId": "lpc-terrain"
            },
            "occlusion": {
              "tilePos": 121,
              "tilesetId": "lpc-terrain"
            }
          },
          "id": "wall2-wood",
          "itemType": "wall2-wood",
          "kind": "wall",
          "layerId": "sprite",
          "name": "Wooden wall 2",
          "notes": {
            "1": "south end of a north-south run: one tile on the cell, the column's foot",
            "2": "east end of an east-west run: cap above, base",
            "3": "bottom-right corner (walls north and west). Its cap lands on the wall above and re-points that wall's tile: the joint under a top-left corner or an east T (index 18/19), the plain one otherwise",
            "5": "west end of an east-west run: cap above, base",
            "6": "bottom-left corner (walls north and east). Its cap lands on the wall above and re-points that wall's tile: the joint under a top-right corner or a west T (index 15/16), the plain one otherwise",
            "8": "middle of an east-west run (and the only index a door may stand on): cap above, base",
            "9": "T with its stem north (walls west, east and north): the cap re-points the stem's foot",
            "13": "north end of a north-south run: one tile on the cell, the column's top; a different top when the wall south-east of it is an east end (index 2)",
            "14": "middle of a north-south run: one tile on the cell",
            "15": "top-right corner (walls west and south): cap above, base. The other base needs a tile already east of the cell, which no wall puts there (only another feature on the layer)",
            "16": "west T (walls north, west and south): its cap re-points the wall above, with the joint under a top-left corner (index 18)",
            "18": "top-left corner (walls east and south): cap above, base",
            "19": "east T (walls north, east and south). The cap re-points the wall above: the joint when no tile is north-west of the cell, the other when a wall's base already is. If a tile already sits west of the cell (no wall puts one there), it draws on the cell instead, the base re-points that tile, and there is no cap",
            "21": "T with its stem south (walls west, east and south): cap above, base",
            "22": "cross (walls on all four sides): the cap re-points the wall above",
            "47": "a lone wall: cap above, base"
          },
          "rules": {
            "1": [
              {
                "tile": 14
              }
            ],
            "2": [
              {
                "dy": -1,
                "tile": 106
              },
              {
                "tile": 138
              }
            ],
            "3": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 110
                      }
                    ],
                    "when": {
                      "index": [
                        18,
                        19
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 141
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 173
              }
            ],
            "5": [
              {
                "dy": -1,
                "tile": 42
              },
              {
                "tile": 74
              }
            ],
            "6": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 111
                      }
                    ],
                    "when": {
                      "index": [
                        15,
                        16
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 139
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 171
              }
            ],
            "8": [
              {
                "dy": -1,
                "tile": 44
              },
              {
                "tile": 76
              }
            ],
            "9": [
              {
                "dy": -1,
                "tile": 236
              },
              {
                "tile": 76
              }
            ],
            "13": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 81
                      }
                    ],
                    "when": {
                      "index": [
                        2
                      ],
                      "neighbour": [
                        1,
                        1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "tile": 46
                      }
                    ]
                  }
                ]
              }
            ],
            "14": [
              {
                "tile": 107
              }
            ],
            "15": [
              {
                "dy": -1,
                "tile": 45
              },
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 209
                      }
                    ],
                    "when": {
                      "exists": [
                        1,
                        0
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "tile": 77
                      }
                    ]
                  }
                ]
              }
            ],
            "16": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 206
                      }
                    ],
                    "when": {
                      "index": [
                        18
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 238
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 77
              }
            ],
            "18": [
              {
                "dy": -1,
                "tile": 43
              },
              {
                "tile": 75
              }
            ],
            "19": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 110
                      }
                    ],
                    "when": {
                      "all": [
                        {
                          "exists": [
                            -1,
                            0
                          ]
                        },
                        {
                          "neighbour": [
                            1,
                            0
                          ]
                        }
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 81
                      }
                    ],
                    "when": {
                      "not": {
                        "exists": [
                          -1,
                          -1
                        ]
                      }
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 207
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 75
              }
            ],
            "21": [
              {
                "dy": -1,
                "tile": 140
              },
              {
                "tile": 172
              }
            ],
            "22": [
              {
                "dy": -1,
                "tile": 204
              },
              {
                "tile": 172
              }
            ],
            "47": [
              {
                "dy": -1,
                "tile": 44
              },
              {
                "tile": 76
              }
            ]
          },
          "tilesetId": "walls2"
        },
        {
          "cell": {
            "blocking": {
              "tilePos": 121,
              "tilesetId": "lpc-terrain"
            },
            "occlusion": {
              "tilePos": 121,
              "tilesetId": "lpc-terrain"
            }
          },
          "id": "wall-stone",
          "itemType": "wall-stone",
          "kind": "wall",
          "layerId": "sprite",
          "name": "Stone wall",
          "notes": {
            "1": "south end of a north-south run: one tile on the cell, the column's foot",
            "2": "east end of an east-west run: cap above, base",
            "3": "bottom-right corner (walls north and west). Its cap lands on the wall above and re-points that wall's tile: the joint under a top-left corner or an east T (index 18/19), the plain one otherwise",
            "5": "west end of an east-west run: cap above, base",
            "6": "bottom-left corner (walls north and east). Its cap lands on the wall above and re-points that wall's tile: the joint under a top-right corner or a west T (index 15/16), the plain one otherwise",
            "8": "middle of an east-west run (and the only index a door may stand on): cap above, base",
            "9": "T with its stem north (walls west, east and north): the cap re-points the stem's foot",
            "13": "north end of a north-south run: one tile on the cell, the column's top; a different top when the wall south-east of it is an east end (index 2)",
            "14": "middle of a north-south run: one tile on the cell",
            "15": "top-right corner (walls west and south): cap above, base. The other base needs a tile already east of the cell, which no wall puts there (only another feature on the layer)",
            "16": "west T (walls north, west and south): its cap re-points the wall above, with the joint under a top-left corner (index 18)",
            "18": "top-left corner (walls east and south): cap above, base",
            "19": "east T (walls north, east and south). The cap re-points the wall above: the joint when no tile is north-west of the cell, the other when a wall's base already is. If a tile already sits west of the cell (no wall puts one there), it draws on the cell instead, the base re-points that tile, and there is no cap",
            "21": "T with its stem south (walls west, east and south): cap above, base",
            "22": "cross (walls on all four sides): the cap re-points the wall above",
            "47": "a lone wall: cap above, base"
          },
          "rules": {
            "1": [
              {
                "tile": 24
              }
            ],
            "2": [
              {
                "dy": -1,
                "tile": 116
              },
              {
                "tile": 148
              }
            ],
            "3": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 120
                      }
                    ],
                    "when": {
                      "index": [
                        18,
                        19
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 151
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 183
              }
            ],
            "5": [
              {
                "dy": -1,
                "tile": 52
              },
              {
                "tile": 84
              }
            ],
            "6": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 121
                      }
                    ],
                    "when": {
                      "index": [
                        15,
                        16
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 149
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 181
              }
            ],
            "8": [
              {
                "dy": -1,
                "tile": 54
              },
              {
                "tile": 86
              }
            ],
            "9": [
              {
                "dy": -1,
                "tile": 246
              },
              {
                "tile": 86
              }
            ],
            "13": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 91
                      }
                    ],
                    "when": {
                      "index": [
                        2
                      ],
                      "neighbour": [
                        1,
                        1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "tile": 56
                      }
                    ]
                  }
                ]
              }
            ],
            "14": [
              {
                "tile": 117
              }
            ],
            "15": [
              {
                "dy": -1,
                "tile": 55
              },
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 219
                      }
                    ],
                    "when": {
                      "exists": [
                        1,
                        0
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "tile": 87
                      }
                    ]
                  }
                ]
              }
            ],
            "16": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 216
                      }
                    ],
                    "when": {
                      "index": [
                        18
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 248
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 87
              }
            ],
            "18": [
              {
                "dy": -1,
                "tile": 53
              },
              {
                "tile": 85
              }
            ],
            "19": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 120
                      }
                    ],
                    "when": {
                      "all": [
                        {
                          "exists": [
                            -1,
                            0
                          ]
                        },
                        {
                          "neighbour": [
                            1,
                            0
                          ]
                        }
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 91
                      }
                    ],
                    "when": {
                      "not": {
                        "exists": [
                          -1,
                          -1
                        ]
                      }
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 217
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 85
              }
            ],
            "21": [
              {
                "dy": -1,
                "tile": 150
              },
              {
                "tile": 182
              }
            ],
            "22": [
              {
                "dy": -1,
                "tile": 214
              },
              {
                "tile": 182
              }
            ],
            "47": [
              {
                "dy": -1,
                "tile": 54
              },
              {
                "tile": 86
              }
            ]
          },
          "seams": {
            "covered": {
              "52": {
                "tilePos": 451,
                "tilesetId": "authored-terrain"
              },
              "53": {
                "tilePos": 452,
                "tilesetId": "authored-terrain"
              },
              "54": {
                "tilePos": 453,
                "tilesetId": "authored-terrain"
              },
              "55": {
                "tilePos": 454,
                "tilesetId": "authored-terrain"
              },
              "91": {
                "tilePos": 455,
                "tilesetId": "authored-terrain"
              },
              "116": {
                "tilePos": 456,
                "tilesetId": "authored-terrain"
              },
              "120": {
                "tilePos": 457,
                "tilesetId": "authored-terrain"
              },
              "121": {
                "tilePos": 458,
                "tilesetId": "authored-terrain"
              },
              "149": {
                "tilePos": 459,
                "tilesetId": "authored-terrain"
              },
              "150": {
                "tilePos": 460,
                "tilesetId": "authored-terrain"
              },
              "151": {
                "tilePos": 461,
                "tilesetId": "authored-terrain"
              },
              "214": {
                "tilePos": 462,
                "tilesetId": "authored-terrain"
              },
              "216": {
                "tilePos": 463,
                "tilesetId": "authored-terrain"
              },
              "217": {
                "tilePos": 464,
                "tilesetId": "authored-terrain"
              },
              "246": {
                "tilePos": 465,
                "tilesetId": "authored-terrain"
              },
              "248": {
                "tilePos": 466,
                "tilesetId": "authored-terrain"
              }
            },
            "lintel": {
              "tilePos": 467,
              "tilesetId": "authored-terrain"
            },
            "style": "seamless"
          },
          "tilesetId": "walls2"
        },
        {
          "id": "mossy-carpet",
          "kind": "bitmask",
          "layerId": "map3",
          "name": "Mossy carpet",
          "notes": {
            "1": "composed: NW corner-sw · NE corner-se · SW corner-sw · SE corner-se",
            "2": "composed: NW corner-ne · NE corner-ne · SW corner-se · SE corner-se",
            "3": "composed: NW notch-nw · NE corner-se · SW corner-se · SE corner-se",
            "4": "composed: corner-se, whole",
            "5": "composed: NW corner-nw · NE corner-nw · SW corner-sw · SE corner-sw",
            "6": "composed: NW corner-sw · NE notch-ne · SW corner-sw · SE corner-sw",
            "7": "composed: corner-sw, whole",
            "8": "composed: NW edge-n · NE edge-n · SW edge-s · SE edge-s",
            "9": "composed: NW notch-nw · NE notch-ne · SW edge-s · SE edge-s",
            "10": "composed: NW edge-s · NE notch-ne · SW edge-s · SE edge-s",
            "11": "composed: NW notch-nw · NE edge-s · SW edge-s · SE edge-s",
            "12": "composed: edge-s, whole",
            "13": "composed: NW corner-nw · NE corner-ne · SW corner-nw · SE corner-ne",
            "14": "composed: NW edge-w · NE edge-e · SW edge-w · SE edge-e",
            "15": "composed: NW corner-ne · NE corner-ne · SW notch-sw · SE corner-ne",
            "16": "composed: NW notch-nw · NE edge-e · SW notch-sw · SE edge-e",
            "17": "composed: NW edge-e · NE edge-e · SW notch-sw · SE edge-e",
            "18": "composed: NW corner-nw · NE corner-nw · SW corner-nw · SE notch-se",
            "19": "composed: NW edge-w · NE notch-ne · SW edge-w · SE notch-se",
            "20": "composed: NW edge-w · NE edge-w · SW edge-w · SE notch-se",
            "21": "composed: NW edge-n · NE edge-n · SW notch-sw · SE notch-se",
            "22": "composed: NW notch-nw · NE notch-ne · SW notch-sw · SE notch-se",
            "23": "composed: NW centre · NE notch-ne · SW notch-sw · SE notch-se",
            "24": "composed: NW notch-nw · NE centre · SW notch-sw · SE notch-se",
            "25": "composed: NW centre · NE centre · SW notch-sw · SE notch-se",
            "26": "composed: corner-ne, whole",
            "27": "composed: NW notch-nw · NE edge-e · SW edge-e · SE edge-e",
            "28": "composed: edge-e, whole",
            "29": "composed: NW edge-n · NE edge-n · SW edge-n · SE notch-se",
            "30": "composed: NW notch-nw · NE notch-ne · SW centre · SE notch-se",
            "31": "composed: NW centre · NE notch-ne · SW centre · SE notch-se",
            "32": "composed: NW notch-nw · NE centre · SW centre · SE notch-se",
            "33": "composed: notch-se, whole",
            "34": "composed: corner-nw, whole",
            "35": "composed: NW edge-w · NE notch-ne · SW edge-w · SE edge-w",
            "36": "composed: edge-w, whole",
            "37": "composed: NW edge-n · NE edge-n · SW notch-sw · SE edge-n",
            "38": "composed: NW notch-nw · NE notch-ne · SW notch-sw · SE centre",
            "39": "composed: NW centre · NE notch-ne · SW notch-sw · SE centre",
            "40": "composed: NW notch-nw · NE centre · SW notch-sw · SE centre",
            "41": "composed: notch-sw, whole",
            "42": "composed: edge-n, whole",
            "43": "composed: NW notch-nw · NE notch-ne · SW centre · SE centre",
            "44": "composed: notch-ne, whole",
            "45": "composed: notch-nw, whole",
            "46": "keeps the base: the composed centre",
            "47": "composed: the blob cell, whole"
          },
          "tilePos": 1,
          "tiledTemplate": true,
          "tiles": {
            "1": 2,
            "2": 3,
            "3": 4,
            "4": 5,
            "5": 6,
            "6": 7,
            "7": 8,
            "8": 9,
            "9": 10,
            "10": 11,
            "11": 12,
            "12": 13,
            "13": 14,
            "14": 15,
            "15": 16,
            "16": 17,
            "17": 18,
            "18": 19,
            "19": 20,
            "20": 21,
            "21": 22,
            "22": 23,
            "23": 24,
            "24": 25,
            "25": 26,
            "26": 27,
            "27": 28,
            "28": 29,
            "29": 30,
            "30": 31,
            "31": 32,
            "32": 33,
            "33": 34,
            "34": 35,
            "35": 36,
            "36": 37,
            "37": 38,
            "38": 39,
            "39": 40,
            "40": 41,
            "41": 42,
            "42": 43,
            "43": 44,
            "44": 45,
            "45": 46,
            "47": 47
          },
          "tilesetId": "authored-terrain"
        },
        {
          "cell": {
            "blocking": {
              "tilePos": 121,
              "tilesetId": "lpc-terrain"
            },
            "occlusion": {
              "tilePos": 121,
              "tilesetId": "lpc-terrain"
            }
          },
          "id": "timber-frame-wall",
          "itemType": "timber-frame-wall",
          "kind": "wall",
          "layerId": "sprite",
          "name": "Timber-frame wall",
          "notes": {
            "1": "south end of a north-south run: one tile on the cell, the column's foot",
            "2": "east end of an east-west run: cap above, base",
            "3": "bottom-right corner (walls north and west). Its cap lands on the wall above and re-points that wall's tile: the joint under a top-left corner or an east T (index 18/19), the plain one otherwise",
            "5": "west end of an east-west run: cap above, base",
            "6": "bottom-left corner (walls north and east). Its cap lands on the wall above and re-points that wall's tile: the joint under a top-right corner or a west T (index 15/16), the plain one otherwise",
            "8": "middle of an east-west run (and the only index a door may stand on): cap above, base",
            "9": "T with its stem north (walls west, east and north): the cap re-points the stem's foot",
            "13": "north end of a north-south run: one tile on the cell, the column's top; a different top when the wall south-east of it is an east end (index 2)",
            "14": "middle of a north-south run: one tile on the cell",
            "15": "top-right corner (walls west and south): cap above, base. The other base needs a tile already east of the cell, which no wall puts there (only another feature on the layer)",
            "16": "west T (walls north, west and south): its cap re-points the wall above, with the joint under a top-left corner (index 18)",
            "18": "top-left corner (walls east and south): cap above, base",
            "19": "east T (walls north, east and south). The cap re-points the wall above: the joint when no tile is north-west of the cell, the other when a wall's base already is. If a tile already sits west of the cell (no wall puts one there), it draws on the cell instead, the base re-points that tile, and there is no cap",
            "21": "T with its stem south (walls west, east and south): cap above, base",
            "22": "cross (walls on all four sides): the cap re-points the wall above",
            "47": "a lone wall: cap above, base"
          },
          "ornaments": {
            "crack": {
              "scatter": 0.07,
              "tiles": {
                "56": 980,
                "381": 981
              }
            },
            "damp": {
              "scatter": 0.05,
              "tiles": {
                "56": 982,
                "381": 983
              }
            },
            "nest": {
              "scatter": 0.03,
              "tiles": {
                "56": 984,
                "381": 985
              }
            },
            "patched": {
              "scatter": 0.05,
              "tiles": {
                "56": 416,
                "381": 417
              }
            },
            "wattle": {
              "scatter": 0.05,
              "tiles": {
                "56": 986,
                "381": 987
              }
            },
            "window": {
              "tiles": {
                "56": 418,
                "381": 419
              }
            }
          },
          "rules": {
            "1": [
              {
                "tile": 48
              }
            ],
            "2": [
              {
                "dy": -1,
                "tile": 59
              },
              {
                "tile": 63
              }
            ],
            "3": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 61
                      }
                    ],
                    "when": {
                      "index": [
                        18,
                        19
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 322
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 325
              }
            ],
            "5": [
              {
                "dy": -1,
                "tile": 49
              },
              {
                "tile": 54
              }
            ],
            "6": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 62
                      }
                    ],
                    "when": {
                      "index": [
                        15,
                        16
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 320
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 323
              }
            ],
            "8": [
              {
                "dy": -1,
                "tile": 51
              },
              {
                "tile": 56
              }
            ],
            "9": [
              {
                "dy": -1,
                "tile": 330
              },
              {
                "tile": 56
              }
            ],
            "13": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 58
                      }
                    ],
                    "when": {
                      "index": [
                        2
                      ],
                      "neighbour": [
                        1,
                        1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "tile": 53
                      }
                    ]
                  }
                ]
              }
            ],
            "14": [
              {
                "tile": 60
              }
            ],
            "15": [
              {
                "dy": -1,
                "tile": 52
              },
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 329
                      }
                    ],
                    "when": {
                      "exists": [
                        1,
                        0
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "tile": 57
                      }
                    ]
                  }
                ]
              }
            ],
            "16": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 327
                      }
                    ],
                    "when": {
                      "index": [
                        18
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 331
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 57
              }
            ],
            "18": [
              {
                "dy": -1,
                "tile": 50
              },
              {
                "tile": 55
              }
            ],
            "19": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 61
                      }
                    ],
                    "when": {
                      "all": [
                        {
                          "exists": [
                            -1,
                            0
                          ]
                        },
                        {
                          "neighbour": [
                            1,
                            0
                          ]
                        }
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 58
                      }
                    ],
                    "when": {
                      "not": {
                        "exists": [
                          -1,
                          -1
                        ]
                      }
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 328
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 55
              }
            ],
            "21": [
              {
                "dy": -1,
                "tile": 321
              },
              {
                "tile": 324
              }
            ],
            "22": [
              {
                "dy": -1,
                "tile": 326
              },
              {
                "tile": 324
              }
            ],
            "47": [
              {
                "dy": -1,
                "tile": 51
              },
              {
                "tile": 56
              }
            ]
          },
          "seams": {
            "covered": {
              "49": {
                "tilePos": 430,
                "tilesetId": "authored-terrain"
              },
              "50": {
                "tilePos": 431,
                "tilesetId": "authored-terrain"
              },
              "51": {
                "tilePos": 432,
                "tilesetId": "authored-terrain"
              },
              "52": {
                "tilePos": 433,
                "tilesetId": "authored-terrain"
              },
              "58": {
                "tilePos": 434,
                "tilesetId": "authored-terrain"
              },
              "59": {
                "tilePos": 435,
                "tilesetId": "authored-terrain"
              },
              "61": {
                "tilePos": 436,
                "tilesetId": "authored-terrain"
              },
              "62": {
                "tilePos": 437,
                "tilesetId": "authored-terrain"
              },
              "320": {
                "tilePos": 438,
                "tilesetId": "authored-terrain"
              },
              "321": {
                "tilePos": 439,
                "tilesetId": "authored-terrain"
              },
              "322": {
                "tilePos": 440,
                "tilesetId": "authored-terrain"
              },
              "326": {
                "tilePos": 441,
                "tilesetId": "authored-terrain"
              },
              "327": {
                "tilePos": 442,
                "tilesetId": "authored-terrain"
              },
              "328": {
                "tilePos": 443,
                "tilesetId": "authored-terrain"
              },
              "330": {
                "tilePos": 444,
                "tilesetId": "authored-terrain"
              },
              "331": {
                "tilePos": 445,
                "tilesetId": "authored-terrain"
              },
              "383": {
                "tilePos": 446,
                "tilesetId": "authored-terrain"
              },
              "384": {
                "tilePos": 447,
                "tilesetId": "authored-terrain"
              },
              "389": {
                "tilePos": 448,
                "tilesetId": "authored-terrain"
              },
              "390": {
                "tilePos": 449,
                "tilesetId": "authored-terrain"
              }
            },
            "joints": {
              "53": {
                "tilePos": 822,
                "tilesetId": "authored-terrain"
              },
              "60": {
                "tilePos": 824,
                "tilesetId": "authored-terrain"
              },
              "468": {
                "tilePos": 825,
                "tilesetId": "authored-terrain"
              }
            },
            "lintel": {
              "tilePos": 450,
              "tilesetId": "authored-terrain"
            },
            "ownBeam": true,
            "style": "beam"
          },
          "tilesetId": "authored-terrain",
          "trims": {
            "creepers": {
              "bloom": 0.35,
              "reach": [
                0.8,
                1.7
              ],
              "share": 0.15,
              "spread": 18
            },
            "foot": {
              "moss": 0,
              "rubble": 0.25,
              "tufts": 0.6
            },
            "framing": {
              "bays": [
                26,
                28,
                30,
                32,
                34
              ],
              "over": [
                "#4a3524",
                "#6a4c31",
                "#8a6943",
                "#a88757"
              ],
              "panels": [
                {
                  "fills": {
                    "arched": 1.5,
                    "brace": 3,
                    "chevron": 2,
                    "plain": 1.5,
                    "stud": 1
                  },
                  "rows": [
                    0,
                    11
                  ]
                },
                {
                  "fills": {
                    "brace": 1.5,
                    "cross": 1,
                    "plain": 3,
                    "stud": 3
                  },
                  "rows": [
                    15,
                    22
                  ]
                }
              ],
              "posts": [
                0,
                22
              ],
              "tones": 0.03,
              "width": 4
            },
            "masonry": {
              "ground": {
                "rows": [
                  26,
                  30
                ],
                "splits": [
                  [
                    5
                  ]
                ],
                "widths": [
                  6,
                  7,
                  8,
                  9,
                  10,
                  11,
                  12,
                  14
                ]
              }
            },
            "palette": {
              "dressed": [
                "#3a261b",
                "#553826",
                "#6f4c34",
                "#8a6243"
              ],
              "flowers": [
                "#7a1f2e",
                "#b8384a",
                "#e8788a"
              ],
              "grass": [
                "#2e5628",
                "#447632",
                "#609243",
                "#84ac50"
              ],
              "joint": "#4d4741",
              "leaves": [
                "#1e3c22",
                "#2e562a",
                "#467a36",
                "#68983e",
                "#8ab250"
              ],
              "moss": [
                "#424d2c",
                "#5d6b3c",
                "#7d8a4c"
              ],
              "outline": "#241914",
              "stem": "#4e3c28",
              "stone": [
                "#5c564f",
                "#756e64",
                "#8d8579",
                "#a59c8f",
                "#bdb4a6"
              ],
              "timber": [
                "#3a261b",
                "#553826",
                "#6f4c34",
                "#8a6243",
                "#a37b55"
              ],
              "top": [
                "#5e4a39",
                "#7c634d",
                "#937a62",
                "#a99079",
                "#bea78f"
              ]
            },
            "parts": {
              "face": [
                "#4d4741",
                "#5c564f",
                "#756e64",
                "#8c7250",
                "#8d8579",
                "#9a8058",
                "#a59c8f",
                "#b59a6e",
                "#bdb4a6",
                "#ccb183",
                "#dcc394",
                "#e6cfa3",
                "#ecd8b2",
                "#f0dfbd",
                "#f4e4c4",
                "#f7ead0"
              ],
              "top": [
                "#5e4a39",
                "#7c634d",
                "#937a62",
                "#a99079",
                "#bea78f"
              ]
            }
          },
          "upperTiles": {
            "48": 468,
            "54": 379,
            "55": 380,
            "56": 381,
            "57": 382,
            "61": 383,
            "62": 384,
            "63": 385,
            "323": 386,
            "324": 387,
            "325": 388,
            "327": 389,
            "328": 390,
            "329": 391
          }
        },
        {
          "id": "thatch-roof",
          "itemType": "thatch-roof",
          "kind": "roof",
          "name": "Thatch roof",
          "ornaments": {
            "chimney": {
              "pieces": {
                "ridge.mid": 420,
                "ridgeTop.mid": 421,
                "solo.mid": 422
              }
            },
            "dormer": {
              "pieces": {
                "front.mid": 423
              }
            },
            "moss": {
              "pieces": {
                "front.mid": 424
              },
              "scatter": 0.12
            }
          },
          "pitched": {
            "back.east": 394,
            "back.mid": 392,
            "back.single": 395,
            "back.west": 393,
            "eave.east": 410,
            "eave.mid": 408,
            "eave.single": 411,
            "eave.west": 409,
            "front.bothJoin": 429,
            "front.east": 406,
            "front.eastJoin": 426,
            "front.eastJoinWest": 428,
            "front.mid": 404,
            "front.single": 407,
            "front.west": 405,
            "front.westJoin": 425,
            "front.westJoinEast": 427,
            "ridge.east": 402,
            "ridge.mid": 400,
            "ridge.single": 403,
            "ridge.west": 401,
            "ridgeTop.east": 398,
            "ridgeTop.mid": 396,
            "ridgeTop.single": 399,
            "ridgeTop.west": 397,
            "solo.east": 414,
            "solo.mid": 412,
            "solo.single": 415,
            "solo.west": 413
          },
          "tiles": {
            "1": 332,
            "2": 333,
            "3": 334,
            "4": 335,
            "5": 336,
            "6": 337,
            "7": 338,
            "8": 339,
            "9": 340,
            "10": 341,
            "11": 342,
            "12": 343,
            "13": 344,
            "14": 345,
            "15": 346,
            "16": 347,
            "17": 348,
            "18": 349,
            "19": 350,
            "20": 351,
            "21": 352,
            "22": 353,
            "23": 354,
            "24": 355,
            "25": 356,
            "26": 357,
            "27": 358,
            "28": 359,
            "29": 360,
            "30": 361,
            "31": 362,
            "32": 363,
            "33": 364,
            "34": 365,
            "35": 366,
            "36": 367,
            "37": 368,
            "38": 369,
            "39": 370,
            "40": 371,
            "41": 372,
            "42": 373,
            "43": 374,
            "44": 375,
            "45": 376,
            "46": 377,
            "47": 378
          },
          "tilesetId": "authored-terrain"
        },
        {
          "id": "roof-wood",
          "itemType": "roof-wood",
          "kind": "roof",
          "name": "Plank roof",
          "ornaments": {
            "knothole": {
              "pieces": {
                "front.mid": 812
              },
              "scatter": 0.05
            },
            "lichen": {
              "pieces": {
                "front.mid": 813
              },
              "scatter": 0.07
            },
            "moss": {
              "pieces": {
                "front.mid": 814
              },
              "scatter": 0.1
            },
            "moss-back": {
              "pieces": {
                "back.mid": 815
              },
              "scatter": 0.22
            },
            "split": {
              "pieces": {
                "front.mid": 816
              },
              "scatter": 0.05
            },
            "warped": {
              "pieces": {
                "front.mid": 817
              },
              "scatter": 0.05
            }
          },
          "pitched": {
            "back.east": 785,
            "back.mid": 783,
            "back.single": 786,
            "back.west": 784,
            "eave.east": 801,
            "eave.mid": 799,
            "eave.single": 802,
            "eave.west": 800,
            "front.bothJoin": 811,
            "front.east": 797,
            "front.eastJoin": 808,
            "front.eastJoinWest": 810,
            "front.mid": 795,
            "front.single": 798,
            "front.west": 796,
            "front.westJoin": 807,
            "front.westJoinEast": 809,
            "ridge.east": 793,
            "ridge.mid": 791,
            "ridge.single": 794,
            "ridge.west": 792,
            "ridgeTop.east": 789,
            "ridgeTop.mid": 787,
            "ridgeTop.single": 790,
            "ridgeTop.west": 788,
            "solo.east": 805,
            "solo.mid": 803,
            "solo.single": 806,
            "solo.west": 804
          },
          "tiles": {
            "1": 736,
            "2": 737,
            "3": 738,
            "4": 739,
            "5": 740,
            "6": 741,
            "7": 742,
            "8": 743,
            "9": 744,
            "10": 745,
            "11": 746,
            "12": 747,
            "13": 748,
            "14": 749,
            "15": 750,
            "16": 751,
            "17": 752,
            "18": 753,
            "19": 754,
            "20": 755,
            "21": 756,
            "22": 757,
            "23": 758,
            "24": 759,
            "25": 760,
            "26": 761,
            "27": 762,
            "28": 763,
            "29": 764,
            "30": 765,
            "31": 766,
            "32": 767,
            "33": 768,
            "34": 769,
            "35": 770,
            "36": 771,
            "37": 772,
            "38": 773,
            "39": 774,
            "40": 775,
            "41": 776,
            "42": 777,
            "43": 778,
            "44": 779,
            "45": 780,
            "46": 781,
            "47": 782
          },
          "tilesetId": "authored-terrain"
        },
        {
          "id": "floor-wood",
          "itemType": "floor-wood",
          "kind": "bitmask",
          "layerId": "map2",
          "name": "Rough-hewn plank floor",
          "ornaments": {
            "burl": {
              "scatter": 0.09,
              "tiles": {
                "46": 12
              }
            },
            "long-grain": {
              "scatter": 0.23,
              "tiles": {
                "46": 16
              }
            },
            "small-burl": {
              "scatter": 0.07,
              "tiles": {
                "46": 15
              }
            },
            "split": {
              "scatter": 0.08,
              "tiles": {
                "46": 14
              }
            },
            "stain": {
              "scatter": 0.08,
              "tiles": {
                "46": 13
              }
            },
            "worn": {
              "scatter": 0.23,
              "tiles": {
                "46": 17
              }
            }
          },
          "tilePos": 33,
          "tiles": {
            "1": 39,
            "2": 68,
            "3": 70,
            "4": 66,
            "5": 67,
            "6": 69,
            "7": 64,
            "8": 6,
            "9": 65,
            "10": 65,
            "11": 65,
            "12": 65,
            "13": 71,
            "14": 37,
            "15": 7,
            "16": 34,
            "17": 34,
            "18": 5,
            "19": 32,
            "20": 32,
            "21": 1,
            "22": 33,
            "23": 33,
            "24": 33,
            "25": 73,
            "26": 2,
            "27": 34,
            "28": 34,
            "29": 1,
            "30": 33,
            "31": 42,
            "32": 33,
            "33": 3,
            "34": 0,
            "35": 32,
            "36": 32,
            "37": 1,
            "38": 33,
            "39": 33,
            "40": 40,
            "41": 4,
            "42": 1,
            "43": 9,
            "44": 35,
            "45": 36,
            "46": 33,
            "47": 38
          },
          "tilesetId": "floors"
        },
        {
          "id": "floor-stone",
          "itemType": "floor-stone",
          "kind": "bitmask",
          "layerId": "map2",
          "name": "Flagstone floor",
          "ornaments": {
            "chip": {
              "scatter": 0.06,
              "tiles": {
                "46": 109
              }
            },
            "crack": {
              "scatter": 0.06,
              "tiles": {
                "46": 108
              }
            },
            "moss": {
              "scatter": 0.05,
              "tiles": {
                "46": 110
              }
            },
            "stain": {
              "scatter": 0.05,
              "tiles": {
                "46": 111
              }
            },
            "worn": {
              "scatter": 0.06,
              "tiles": {
                "46": 112
              }
            }
          },
          "tilePos": 129,
          "tiles": {
            "1": 135,
            "2": 164,
            "3": 166,
            "4": 162,
            "5": 163,
            "6": 165,
            "7": 160,
            "8": 102,
            "9": 161,
            "10": 161,
            "11": 161,
            "12": 161,
            "13": 167,
            "14": 133,
            "15": 103,
            "16": 130,
            "17": 130,
            "18": 101,
            "19": 128,
            "20": 128,
            "21": 97,
            "22": 129,
            "23": 129,
            "24": 129,
            "25": 169,
            "26": 98,
            "27": 130,
            "28": 130,
            "29": 97,
            "30": 129,
            "31": 138,
            "32": 129,
            "33": 99,
            "34": 96,
            "35": 128,
            "36": 128,
            "37": 97,
            "38": 129,
            "39": 129,
            "40": 136,
            "41": 100,
            "42": 97,
            "43": 105,
            "44": 131,
            "45": 132,
            "46": 129,
            "47": 134
          },
          "tilesetId": "floors"
        },
        {
          "id": "floor-cobble",
          "itemType": "floor-cobble",
          "kind": "bitmask",
          "layerId": "map2",
          "name": "Cobbled floor",
          "ornaments": {
            "earth": {
              "scatter": 0.06,
              "tiles": {
                "46": 204
              }
            },
            "earth-b": {
              "scatter": 0.03,
              "tiles": {
                "46": 208
              }
            },
            "grass": {
              "scatter": 0.05,
              "tiles": {
                "46": 206
              }
            },
            "grass-b": {
              "scatter": 0.03,
              "tiles": {
                "46": 209
              }
            },
            "tint": {
              "scatter": 0.05,
              "tiles": {
                "46": 205
              }
            },
            "tint-b": {
              "scatter": 0.05,
              "tiles": {
                "46": 207
              }
            }
          },
          "tilePos": 225,
          "tiles": {
            "1": 231,
            "2": 260,
            "3": 262,
            "4": 258,
            "5": 259,
            "6": 261,
            "7": 256,
            "8": 198,
            "9": 257,
            "10": 257,
            "11": 257,
            "12": 257,
            "13": 263,
            "14": 229,
            "15": 199,
            "16": 226,
            "17": 226,
            "18": 197,
            "19": 224,
            "20": 224,
            "21": 193,
            "22": 225,
            "23": 225,
            "24": 225,
            "25": 265,
            "26": 194,
            "27": 226,
            "28": 226,
            "29": 193,
            "30": 225,
            "31": 234,
            "32": 225,
            "33": 195,
            "34": 192,
            "35": 224,
            "36": 224,
            "37": 193,
            "38": 225,
            "39": 225,
            "40": 232,
            "41": 196,
            "42": 193,
            "43": 201,
            "44": 227,
            "45": 228,
            "46": 225,
            "47": 230
          },
          "tilesetId": "floors"
        },
        {
          "cell": {
            "blocking": {
              "tilePos": 121,
              "tilesetId": "lpc-terrain"
            }
          },
          "id": "railing-wood",
          "itemType": "railing-wood",
          "joins": "own",
          "kind": "wall",
          "layerId": "sprite",
          "name": "Wooden railing",
          "notes": {
            "47": "A lone post: the south end of a north-south run, no rail drawn."
          },
          "rules": {
            "1": [
              {
                "tile": 16
              }
            ],
            "2": [
              {
                "tile": 2
              }
            ],
            "3": [
              {
                "tile": 66
              }
            ],
            "5": [
              {
                "tile": 0
              }
            ],
            "6": [
              {
                "tile": 64
              }
            ],
            "8": [
              {
                "tile": 1
              }
            ],
            "9": [
              {
                "tile": 65
              }
            ],
            "13": [
              {
                "tile": 18
              }
            ],
            "14": [
              {
                "tile": 17
              }
            ],
            "15": [
              {
                "tile": 34
              }
            ],
            "16": [
              {
                "tile": 50
              }
            ],
            "18": [
              {
                "tile": 32
              }
            ],
            "19": [
              {
                "tile": 48
              }
            ],
            "21": [
              {
                "tile": 33
              }
            ],
            "22": [
              {
                "tile": 49
              }
            ],
            "47": [
              {
                "tile": 16
              }
            ]
          },
          "tilesetId": "fence_medieval"
        },
        {
          "cell": {
            "blocking": {
              "tilePos": 121,
              "tilesetId": "lpc-terrain"
            },
            "occlusion": {
              "tilePos": 121,
              "tilesetId": "lpc-terrain"
            }
          },
          "id": "castle-footing",
          "itemType": "castle-footing",
          "kind": "wall",
          "layerId": "sprite",
          "name": "Castle footing",
          "notes": {
            "1": "south end of a north-south run: one tile on the cell, the column's foot",
            "2": "east end of an east-west run: cap above, base",
            "3": "bottom-right corner (walls north and west). Its cap lands on the wall above and re-points that wall's tile: the joint under a top-left corner or an east T (index 18/19), the plain one otherwise",
            "5": "west end of an east-west run: cap above, base",
            "6": "bottom-left corner (walls north and east). Its cap lands on the wall above and re-points that wall's tile: the joint under a top-right corner or a west T (index 15/16), the plain one otherwise",
            "8": "middle of an east-west run (and the only index a door may stand on): cap above, base",
            "9": "T with its stem north (walls west, east and north): the cap re-points the stem's foot",
            "13": "north end of a north-south run: one tile on the cell, the column's top; a different top when the wall south-east of it is an east end (index 2)",
            "14": "middle of a north-south run: one tile on the cell",
            "15": "top-right corner (walls west and south): cap above, base. The other base needs a tile already east of the cell, which no wall puts there (only another feature on the layer)",
            "16": "west T (walls north, west and south): its cap re-points the wall above, with the joint under a top-left corner (index 18)",
            "18": "top-left corner (walls east and south): cap above, base",
            "19": "east T (walls north, east and south). The cap re-points the wall above: the joint when no tile is north-west of the cell, the other when a wall's base already is. If a tile already sits west of the cell (no wall puts one there), it draws on the cell instead, the base re-points that tile, and there is no cap",
            "21": "T with its stem south (walls west, east and south): cap above, base",
            "22": "cross (walls on all four sides): the cap re-points the wall above",
            "47": "a lone wall: cap above, base"
          },
          "ornaments": {
            "arrow-slit": {
              "tiles": {
                "832": 852
              }
            }
          },
          "rules": {
            "1": [
              {
                "tile": 819
              }
            ],
            "2": [
              {
                "dy": -1,
                "tile": 835
              },
              {
                "tile": 839
              }
            ],
            "3": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 837
                      }
                    ],
                    "when": {
                      "index": [
                        18,
                        19
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 842
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 845
              }
            ],
            "5": [
              {
                "dy": -1,
                "tile": 823
              },
              {
                "tile": 830
              }
            ],
            "6": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 838
                      }
                    ],
                    "when": {
                      "index": [
                        15,
                        16
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 840
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 843
              }
            ],
            "8": [
              {
                "dy": -1,
                "tile": 827
              },
              {
                "tile": 832
              }
            ],
            "9": [
              {
                "dy": -1,
                "tile": 850
              },
              {
                "tile": 832
              }
            ],
            "13": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 834
                      }
                    ],
                    "when": {
                      "index": [
                        2
                      ],
                      "neighbour": [
                        1,
                        1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "tile": 829
                      }
                    ]
                  }
                ]
              }
            ],
            "14": [
              {
                "tile": 836
              }
            ],
            "15": [
              {
                "dy": -1,
                "tile": 828
              },
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 849
                      }
                    ],
                    "when": {
                      "exists": [
                        1,
                        0
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "tile": 833
                      }
                    ]
                  }
                ]
              }
            ],
            "16": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 847
                      }
                    ],
                    "when": {
                      "index": [
                        18
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 851
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 833
              }
            ],
            "18": [
              {
                "dy": -1,
                "tile": 826
              },
              {
                "tile": 831
              }
            ],
            "19": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 837
                      }
                    ],
                    "when": {
                      "all": [
                        {
                          "exists": [
                            -1,
                            0
                          ]
                        },
                        {
                          "neighbour": [
                            1,
                            0
                          ]
                        }
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 834
                      }
                    ],
                    "when": {
                      "not": {
                        "exists": [
                          -1,
                          -1
                        ]
                      }
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 848
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 831
              }
            ],
            "21": [
              {
                "dy": -1,
                "tile": 841
              },
              {
                "tile": 844
              }
            ],
            "22": [
              {
                "dy": -1,
                "tile": 846
              },
              {
                "tile": 844
              }
            ],
            "47": [
              {
                "dy": -1,
                "tile": 827
              },
              {
                "tile": 832
              }
            ]
          },
          "seams": {
            "covered": {
              "823": {
                "tilePos": 853,
                "tilesetId": "authored-terrain"
              },
              "826": {
                "tilePos": 854,
                "tilesetId": "authored-terrain"
              },
              "827": {
                "tilePos": 855,
                "tilesetId": "authored-terrain"
              },
              "828": {
                "tilePos": 856,
                "tilesetId": "authored-terrain"
              },
              "834": {
                "tilePos": 857,
                "tilesetId": "authored-terrain"
              },
              "835": {
                "tilePos": 858,
                "tilesetId": "authored-terrain"
              },
              "837": {
                "tilePos": 859,
                "tilesetId": "authored-terrain"
              },
              "838": {
                "tilePos": 860,
                "tilesetId": "authored-terrain"
              },
              "840": {
                "tilePos": 861,
                "tilesetId": "authored-terrain"
              },
              "841": {
                "tilePos": 862,
                "tilesetId": "authored-terrain"
              },
              "842": {
                "tilePos": 863,
                "tilesetId": "authored-terrain"
              },
              "846": {
                "tilePos": 864,
                "tilesetId": "authored-terrain"
              },
              "847": {
                "tilePos": 865,
                "tilesetId": "authored-terrain"
              },
              "848": {
                "tilePos": 866,
                "tilesetId": "authored-terrain"
              },
              "850": {
                "tilePos": 867,
                "tilesetId": "authored-terrain"
              },
              "851": {
                "tilePos": 868,
                "tilesetId": "authored-terrain"
              }
            },
            "lintel": {
              "tilePos": 869,
              "tilesetId": "authored-terrain"
            },
            "style": "seamless"
          },
          "shadow": {
            "body": {
              "depth": 18,
              "left": 3,
              "right": 29
            }
          },
          "tilesetId": "authored-terrain",
          "trims": {
            "arch": {
              "maxSpan": 3,
              "ring": 6,
              "rise": 26
            },
            "coping": {
              "lengths": [
                8,
                18
              ]
            },
            "creepers": {
              "reach": [
                1.2,
                3.5
              ],
              "share": 0.3,
              "spread": 16
            },
            "foot": {
              "moss": 0.5,
              "rubble": 0.5,
              "tufts": 0.5
            },
            "masonry": {
              "ground": {
                "rows": [
                  4,
                  23
                ],
                "splits": [
                  [
                    20
                  ],
                  [
                    10,
                    10
                  ],
                  [
                    12,
                    8
                  ],
                  [
                    8,
                    12
                  ]
                ],
                "widths": [
                  16,
                  20,
                  26,
                  32,
                  40,
                  48
                ]
              }
            },
            "palette": {
              "dressed": [
                "#6c635f",
                "#887e73",
                "#ada393",
                "#cbc1b0"
              ],
              "grass": [
                "#2e5628",
                "#447632",
                "#609243",
                "#84ac50"
              ],
              "joint": "#463d40",
              "leaves": [
                "#1e3c22",
                "#2e562a",
                "#467a36",
                "#68983e",
                "#8ab250"
              ],
              "moss": [
                "#424d2c",
                "#5d6b3c",
                "#7d8a4c"
              ],
              "outline": "#2b2427",
              "stem": "#4e3c28",
              "stone": [
                "#635a57",
                "#72686a",
                "#827872",
                "#9c9289",
                "#bdb3a4"
              ],
              "top": [
                "#776e62",
                "#9c9382",
                "#afa694",
                "#c0b7a5",
                "#d6cebd"
              ],
              "vault": "#231d20"
            },
            "parts": {
              "coping": [
                "#4b4346",
                "#6e665f",
                "#8c8377",
                "#a29a8b",
                "#b8af9f",
                "#d3cab9"
              ],
              "face": [
                "#463d40",
                "#635a57",
                "#72686a",
                "#827872",
                "#90867e",
                "#9c9289",
                "#aaa094",
                "#bdb3a4"
              ],
              "top": [
                "#776e62",
                "#979c74",
                "#9c9382",
                "#afa694",
                "#b2b48a",
                "#c0b7a5",
                "#d6cebd"
              ]
            },
            "spurs": {
              "height": 28,
              "reach": 12
            },
            "streaks": {
              "share": 0.04
            },
            "weeds": {
              "share": 0.1
            }
          }
        },
        {
          "cell": {
            "blocking": {
              "tilePos": 121,
              "tilesetId": "lpc-terrain"
            },
            "occlusion": {
              "tilePos": 121,
              "tilesetId": "lpc-terrain"
            }
          },
          "id": "castle-wall",
          "itemType": "castle-wall",
          "kind": "wall",
          "layerId": "sprite",
          "name": "Castle wall",
          "notes": {
            "1": "south end of a north-south run: one tile on the cell, the column's foot",
            "2": "east end of an east-west run: cap above, base",
            "3": "bottom-right corner (walls north and west). Its cap lands on the wall above and re-points that wall's tile: the joint under a top-left corner or an east T (index 18/19), the plain one otherwise",
            "5": "west end of an east-west run: cap above, base",
            "6": "bottom-left corner (walls north and east). Its cap lands on the wall above and re-points that wall's tile: the joint under a top-right corner or a west T (index 15/16), the plain one otherwise",
            "8": "middle of an east-west run (and the only index a door may stand on): cap above, base",
            "9": "T with its stem north (walls west, east and north): the cap re-points the stem's foot",
            "13": "north end of a north-south run: one tile on the cell, the column's top; a different top when the wall south-east of it is an east end (index 2)",
            "14": "middle of a north-south run: one tile on the cell",
            "15": "top-right corner (walls west and south): cap above, base. The other base needs a tile already east of the cell, which no wall puts there (only another feature on the layer)",
            "16": "west T (walls north, west and south): its cap re-points the wall above, with the joint under a top-left corner (index 18)",
            "18": "top-left corner (walls east and south): cap above, base",
            "19": "east T (walls north, east and south). The cap re-points the wall above: the joint when no tile is north-west of the cell, the other when a wall's base already is. If a tile already sits west of the cell (no wall puts one there), it draws on the cell instead, the base re-points that tile, and there is no cap",
            "21": "T with its stem south (walls west, east and south): cap above, base",
            "22": "cross (walls on all four sides): the cap re-points the wall above",
            "47": "a lone wall: cap above, base"
          },
          "ornaments": {
            "arrow-slit": {
              "tiles": {
                "878": 898
              }
            },
            "cracked-coping": {
              "scatter": 0.08,
              "tiles": {
                "873": 899
              }
            },
            "putlogs": {
              "scatter": 0.07,
              "tiles": {
                "878": 900
              }
            },
            "sunken-coping": {
              "scatter": 0.06,
              "tiles": {
                "873": 901
              }
            },
            "weeds": {
              "scatter": 0.07,
              "tiles": {
                "873": 902
              }
            }
          },
          "rules": {
            "1": [
              {
                "tile": 870
              }
            ],
            "2": [
              {
                "dy": -1,
                "tile": 881
              },
              {
                "tile": 885
              }
            ],
            "3": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 883
                      }
                    ],
                    "when": {
                      "index": [
                        18,
                        19
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 888
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 891
              }
            ],
            "5": [
              {
                "dy": -1,
                "tile": 871
              },
              {
                "tile": 876
              }
            ],
            "6": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 884
                      }
                    ],
                    "when": {
                      "index": [
                        15,
                        16
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 886
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 889
              }
            ],
            "8": [
              {
                "dy": -1,
                "tile": 873
              },
              {
                "tile": 878
              }
            ],
            "9": [
              {
                "dy": -1,
                "tile": 896
              },
              {
                "tile": 878
              }
            ],
            "13": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 880
                      }
                    ],
                    "when": {
                      "index": [
                        2
                      ],
                      "neighbour": [
                        1,
                        1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "tile": 875
                      }
                    ]
                  }
                ]
              }
            ],
            "14": [
              {
                "tile": 882
              }
            ],
            "15": [
              {
                "dy": -1,
                "tile": 874
              },
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 895
                      }
                    ],
                    "when": {
                      "exists": [
                        1,
                        0
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "tile": 879
                      }
                    ]
                  }
                ]
              }
            ],
            "16": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 893
                      }
                    ],
                    "when": {
                      "index": [
                        18
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 897
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 879
              }
            ],
            "18": [
              {
                "dy": -1,
                "tile": 872
              },
              {
                "tile": 877
              }
            ],
            "19": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 883
                      }
                    ],
                    "when": {
                      "all": [
                        {
                          "exists": [
                            -1,
                            0
                          ]
                        },
                        {
                          "neighbour": [
                            1,
                            0
                          ]
                        }
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 880
                      }
                    ],
                    "when": {
                      "not": {
                        "exists": [
                          -1,
                          -1
                        ]
                      }
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 894
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 877
              }
            ],
            "21": [
              {
                "dy": -1,
                "tile": 887
              },
              {
                "tile": 890
              }
            ],
            "22": [
              {
                "dy": -1,
                "tile": 892
              },
              {
                "tile": 890
              }
            ],
            "47": [
              {
                "dy": -1,
                "tile": 873
              },
              {
                "tile": 878
              }
            ]
          },
          "seams": {
            "covered": {
              "871": {
                "tilePos": 903,
                "tilesetId": "authored-terrain"
              },
              "872": {
                "tilePos": 904,
                "tilesetId": "authored-terrain"
              },
              "873": {
                "tilePos": 905,
                "tilesetId": "authored-terrain"
              },
              "874": {
                "tilePos": 906,
                "tilesetId": "authored-terrain"
              },
              "880": {
                "tilePos": 907,
                "tilesetId": "authored-terrain"
              },
              "881": {
                "tilePos": 908,
                "tilesetId": "authored-terrain"
              },
              "883": {
                "tilePos": 909,
                "tilesetId": "authored-terrain"
              },
              "884": {
                "tilePos": 910,
                "tilesetId": "authored-terrain"
              },
              "886": {
                "tilePos": 911,
                "tilesetId": "authored-terrain"
              },
              "887": {
                "tilePos": 912,
                "tilesetId": "authored-terrain"
              },
              "888": {
                "tilePos": 913,
                "tilesetId": "authored-terrain"
              },
              "892": {
                "tilePos": 914,
                "tilesetId": "authored-terrain"
              },
              "893": {
                "tilePos": 915,
                "tilesetId": "authored-terrain"
              },
              "894": {
                "tilePos": 916,
                "tilesetId": "authored-terrain"
              },
              "896": {
                "tilePos": 917,
                "tilesetId": "authored-terrain"
              },
              "897": {
                "tilePos": 918,
                "tilesetId": "authored-terrain"
              },
              "899": {
                "tilePos": 919,
                "tilesetId": "authored-terrain"
              },
              "901": {
                "tilePos": 920,
                "tilesetId": "authored-terrain"
              },
              "902": {
                "tilePos": 921,
                "tilesetId": "authored-terrain"
              }
            },
            "lintel": {
              "tilePos": 922,
              "tilesetId": "authored-terrain"
            },
            "style": "seamless"
          },
          "shadow": {
            "body": {
              "depth": 18,
              "left": 3,
              "right": 29
            }
          },
          "tilesetId": "authored-terrain",
          "trims": {
            "arch": {
              "maxSpan": 3,
              "ring": 6,
              "rise": 26
            },
            "coping": {
              "lengths": [
                7,
                16
              ]
            },
            "creepers": {
              "reach": [
                1,
                3.5
              ],
              "share": 0.2,
              "spread": 14
            },
            "foot": {
              "moss": 0.45,
              "rubble": 0.45,
              "tufts": 0.5
            },
            "masonry": {
              "ground": {
                "rows": [
                  0,
                  30
                ],
                "splits": [
                  [
                    31
                  ],
                  [
                    20,
                    11
                  ],
                  [
                    11,
                    20
                  ],
                  [
                    15,
                    16
                  ],
                  [
                    14,
                    17
                  ]
                ],
                "widths": [
                  14,
                  18,
                  22,
                  26,
                  30,
                  36,
                  44
                ]
              },
              "upper": {
                "rows": [
                  0,
                  30
                ],
                "splits": [
                  [
                    16,
                    15
                  ],
                  [
                    10,
                    10,
                    11
                  ],
                  [
                    9,
                    22
                  ],
                  [
                    20,
                    11
                  ],
                  [
                    12,
                    19
                  ],
                  [
                    31
                  ],
                  [
                    11,
                    20
                  ]
                ],
                "widths": [
                  10,
                  12,
                  14,
                  16,
                  20,
                  24,
                  28
                ]
              }
            },
            "palette": {
              "dressed": [
                "#6c635f",
                "#887e73",
                "#ada393",
                "#cbc1b0"
              ],
              "grass": [
                "#2e5628",
                "#447632",
                "#609243",
                "#84ac50"
              ],
              "joint": "#463d40",
              "leaves": [
                "#1e3c22",
                "#2e562a",
                "#467a36",
                "#68983e",
                "#8ab250"
              ],
              "moss": [
                "#424d2c",
                "#5d6b3c",
                "#7d8a4c"
              ],
              "outline": "#2b2427",
              "stem": "#4e3c28",
              "stone": [
                "#635a57",
                "#72686a",
                "#827872",
                "#9c9289",
                "#bdb3a4"
              ],
              "top": [
                "#776e62",
                "#9c9382",
                "#afa694",
                "#c0b7a5",
                "#d6cebd"
              ],
              "vault": "#231d20"
            },
            "parts": {
              "coping": [
                "#4b4346",
                "#6e665f",
                "#8c8377",
                "#a29a8b",
                "#b8af9f",
                "#d3cab9"
              ],
              "face": [
                "#463d40",
                "#635a57",
                "#72686a",
                "#827872",
                "#90867e",
                "#9c9289",
                "#aaa094",
                "#bdb3a4"
              ],
              "top": [
                "#776e62",
                "#979c74",
                "#9c9382",
                "#afa694",
                "#b2b48a",
                "#c0b7a5",
                "#d6cebd"
              ]
            },
            "spurs": {
              "height": 26,
              "reach": 10
            },
            "streaks": {
              "share": 0.05
            },
            "weeds": {
              "share": 0.12
            }
          }
        },
        {
          "cell": {
            "blocking": {
              "tilePos": 121,
              "tilesetId": "lpc-terrain"
            }
          },
          "id": "castle-merlons",
          "itemType": "castle-merlons",
          "kind": "wall",
          "layerId": "sprite",
          "name": "Merlons",
          "ornaments": {
            "weathered": {
              "scatter": 0.3,
              "tiles": {
                "923": 924
              }
            }
          },
          "parapet": true,
          "rules": {
            "1": [
              {
                "tile": 923
              }
            ],
            "2": [
              {
                "tile": 923
              }
            ],
            "3": [
              {
                "tile": 923
              }
            ],
            "5": [
              {
                "tile": 923
              }
            ],
            "6": [
              {
                "tile": 923
              }
            ],
            "8": [
              {
                "tile": 923
              }
            ],
            "9": [
              {
                "tile": 923
              }
            ],
            "13": [
              {
                "tile": 923
              }
            ],
            "14": [
              {
                "tile": 923
              }
            ],
            "15": [
              {
                "tile": 923
              }
            ],
            "16": [
              {
                "tile": 923
              }
            ],
            "18": [
              {
                "tile": 923
              }
            ],
            "19": [
              {
                "tile": 923
              }
            ],
            "21": [
              {
                "tile": 923
              }
            ],
            "22": [
              {
                "tile": 923
              }
            ],
            "47": [
              {
                "tile": 923
              }
            ]
          },
          "shadow": {
            "block": {
              "bottom": 29,
              "height": 12,
              "left": 7,
              "right": 25,
              "top": 17
            }
          },
          "tilesetId": "authored-terrain"
        },
        {
          "cell": {
            "blocking": {
              "tilePos": 121,
              "tilesetId": "lpc-terrain"
            },
            "occlusion": {
              "tilePos": 121,
              "tilesetId": "lpc-terrain"
            }
          },
          "id": "tower-render",
          "itemType": "tower-render",
          "kind": "wall",
          "layerId": "sprite",
          "name": "Tower render",
          "notes": {
            "1": "south end of a north-south run: one tile on the cell, the column's foot",
            "2": "east end of an east-west run: cap above, base",
            "3": "bottom-right corner (walls north and west). Its cap lands on the wall above and re-points that wall's tile: the joint under a top-left corner or an east T (index 18/19), the plain one otherwise",
            "5": "west end of an east-west run: cap above, base",
            "6": "bottom-left corner (walls north and east). Its cap lands on the wall above and re-points that wall's tile: the joint under a top-right corner or a west T (index 15/16), the plain one otherwise",
            "8": "middle of an east-west run (and the only index a door may stand on): cap above, base",
            "9": "T with its stem north (walls west, east and north): the cap re-points the stem's foot",
            "13": "north end of a north-south run: one tile on the cell, the column's top; a different top when the wall south-east of it is an east end (index 2)",
            "14": "middle of a north-south run: one tile on the cell",
            "15": "top-right corner (walls west and south): cap above, base. The other base needs a tile already east of the cell, which no wall puts there (only another feature on the layer)",
            "16": "west T (walls north, west and south): its cap re-points the wall above, with the joint under a top-left corner (index 18)",
            "18": "top-left corner (walls east and south): cap above, base",
            "19": "east T (walls north, east and south). The cap re-points the wall above: the joint when no tile is north-west of the cell, the other when a wall's base already is. If a tile already sits west of the cell (no wall puts one there), it draws on the cell instead, the base re-points that tile, and there is no cap",
            "21": "T with its stem south (walls west, east and south): cap above, base",
            "22": "cross (walls on all four sides): the cap re-points the wall above",
            "47": "a lone wall: cap above, base"
          },
          "ornaments": {
            "arrow-slit": {
              "tiles": {
                "933": 953
              }
            },
            "crack": {
              "scatter": 0.09,
              "tiles": {
                "933": 954
              }
            },
            "damp": {
              "scatter": 0.07,
              "tiles": {
                "933": 955
              }
            },
            "patch": {
              "scatter": 0.06,
              "tiles": {
                "933": 956
              }
            },
            "putlogs": {
              "scatter": 0.07,
              "tiles": {
                "933": 957
              }
            },
            "spall": {
              "scatter": 0.06,
              "tiles": {
                "933": 958
              }
            },
            "spall-high": {
              "scatter": 0.05,
              "tiles": {
                "933": 959
              }
            },
            "tie-plate": {
              "scatter": 0.05,
              "tiles": {
                "933": 960
              }
            }
          },
          "rules": {
            "1": [
              {
                "tile": 925
              }
            ],
            "2": [
              {
                "dy": -1,
                "tile": 936
              },
              {
                "tile": 940
              }
            ],
            "3": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 938
                      }
                    ],
                    "when": {
                      "index": [
                        18,
                        19
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 943
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 946
              }
            ],
            "5": [
              {
                "dy": -1,
                "tile": 926
              },
              {
                "tile": 931
              }
            ],
            "6": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 939
                      }
                    ],
                    "when": {
                      "index": [
                        15,
                        16
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 941
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 944
              }
            ],
            "8": [
              {
                "dy": -1,
                "tile": 928
              },
              {
                "tile": 933
              }
            ],
            "9": [
              {
                "dy": -1,
                "tile": 951
              },
              {
                "tile": 933
              }
            ],
            "13": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 935
                      }
                    ],
                    "when": {
                      "index": [
                        2
                      ],
                      "neighbour": [
                        1,
                        1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "tile": 930
                      }
                    ]
                  }
                ]
              }
            ],
            "14": [
              {
                "tile": 937
              }
            ],
            "15": [
              {
                "dy": -1,
                "tile": 929
              },
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 950
                      }
                    ],
                    "when": {
                      "exists": [
                        1,
                        0
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "tile": 934
                      }
                    ]
                  }
                ]
              }
            ],
            "16": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 948
                      }
                    ],
                    "when": {
                      "index": [
                        18
                      ],
                      "neighbour": [
                        0,
                        -1
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 952
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 934
              }
            ],
            "18": [
              {
                "dy": -1,
                "tile": 927
              },
              {
                "tile": 932
              }
            ],
            "19": [
              {
                "choose": [
                  {
                    "emit": [
                      {
                        "tile": 938
                      }
                    ],
                    "when": {
                      "all": [
                        {
                          "exists": [
                            -1,
                            0
                          ]
                        },
                        {
                          "neighbour": [
                            1,
                            0
                          ]
                        }
                      ]
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 935
                      }
                    ],
                    "when": {
                      "not": {
                        "exists": [
                          -1,
                          -1
                        ]
                      }
                    }
                  },
                  {
                    "emit": [
                      {
                        "dy": -1,
                        "tile": 949
                      }
                    ]
                  }
                ]
              },
              {
                "tile": 932
              }
            ],
            "21": [
              {
                "dy": -1,
                "tile": 942
              },
              {
                "tile": 945
              }
            ],
            "22": [
              {
                "dy": -1,
                "tile": 947
              },
              {
                "tile": 945
              }
            ],
            "47": [
              {
                "dy": -1,
                "tile": 928
              },
              {
                "tile": 933
              }
            ]
          },
          "seams": {
            "covered": {
              "926": {
                "tilePos": 961,
                "tilesetId": "authored-terrain"
              },
              "927": {
                "tilePos": 962,
                "tilesetId": "authored-terrain"
              },
              "928": {
                "tilePos": 963,
                "tilesetId": "authored-terrain"
              },
              "929": {
                "tilePos": 964,
                "tilesetId": "authored-terrain"
              },
              "935": {
                "tilePos": 965,
                "tilesetId": "authored-terrain"
              },
              "936": {
                "tilePos": 966,
                "tilesetId": "authored-terrain"
              },
              "938": {
                "tilePos": 967,
                "tilesetId": "authored-terrain"
              },
              "939": {
                "tilePos": 968,
                "tilesetId": "authored-terrain"
              },
              "941": {
                "tilePos": 969,
                "tilesetId": "authored-terrain"
              },
              "942": {
                "tilePos": 970,
                "tilesetId": "authored-terrain"
              },
              "943": {
                "tilePos": 971,
                "tilesetId": "authored-terrain"
              },
              "947": {
                "tilePos": 972,
                "tilesetId": "authored-terrain"
              },
              "948": {
                "tilePos": 973,
                "tilesetId": "authored-terrain"
              },
              "949": {
                "tilePos": 974,
                "tilesetId": "authored-terrain"
              },
              "951": {
                "tilePos": 975,
                "tilesetId": "authored-terrain"
              },
              "952": {
                "tilePos": 976,
                "tilesetId": "authored-terrain"
              }
            },
            "lintel": {
              "tilePos": 977,
              "tilesetId": "authored-terrain"
            },
            "style": "seamless"
          },
          "tilesetId": "authored-terrain",
          "trims": {
            "arch": {
              "maxSpan": 2,
              "ring": 5,
              "rise": 22
            },
            "continuous": true,
            "creepers": {
              "reach": [
                1.5,
                4.5
              ],
              "share": 0.12,
              "spread": 12
            },
            "damp": {
              "height": [
                4,
                10
              ]
            },
            "foot": {
              "moss": 0.35,
              "rubble": 0.3,
              "tufts": 0.55
            },
            "palette": {
              "dressed": [
                "#6c635f",
                "#887e73",
                "#ada393",
                "#cbc1b0"
              ],
              "grass": [
                "#2e5628",
                "#447632",
                "#609243",
                "#84ac50"
              ],
              "joint": "#755733",
              "leaves": [
                "#1e3c22",
                "#2e562a",
                "#467a36",
                "#68983e",
                "#8ab250"
              ],
              "moss": [
                "#424d2c",
                "#5d6b3c",
                "#7d8a4c"
              ],
              "outline": "#2e2421",
              "stem": "#4e3c28",
              "stone": [
                "#8c693c",
                "#9c7746",
                "#ab854f",
                "#c49d64",
                "#d9b982"
              ],
              "top": [
                "#a99f8b",
                "#c6bca8",
                "#d7cfbd",
                "#e4ddcd",
                "#f1ebdf"
              ],
              "vault": "#231d20"
            },
            "parts": {
              "coping": [
                "#8a6a43",
                "#b08e5c",
                "#cbb48b",
                "#dfd5c1",
                "#f4efe4"
              ],
              "face": [
                "#755733",
                "#8c693c",
                "#9c7746",
                "#ab854f",
                "#b28b54",
                "#b99159",
                "#be975e",
                "#c2a274",
                "#c49d64",
                "#ccb085",
                "#cfab73",
                "#d9b982",
                "#e2d3b0"
              ],
              "top": [
                "#a99f8b",
                "#c6bca8",
                "#d7cfbd",
                "#ddd6c5",
                "#e4ddcd",
                "#e9e3d5",
                "#f1ebdf"
              ]
            },
            "quoins": {
              "course": 8,
              "long": 11,
              "short": 6
            },
            "streaks": {
              "share": 0.06
            },
            "weeds": {
              "share": 0.06
            }
          }
        }
      ],
      "version": 1
    },
    "classes": [
      {
        "characteristics": {
          "equippable": true,
          "exclusiveReadiness": true,
          "readyable": true
        },
        "id": "armor"
      },
      {
        "characteristics": {
          "equippable": true,
          "exclusiveReadiness": true,
          "readyable": true
        },
        "id": "bauldron"
      },
      {
        "characteristics": {
          "equippable": true,
          "exclusiveReadiness": true,
          "readyable": true
        },
        "id": "cape"
      },
      {
        "characteristics": {
          "exclusiveReadiness": true,
          "readyable": true
        },
        "id": "key"
      },
      {
        "characteristics": {
          "equippable": true,
          "exclusiveReadiness": true,
          "readyable": true
        },
        "id": "pants"
      },
      {
        "characteristics": {
          "disallowedClassesOnActive": [
            "weapon",
            "structure"
          ],
          "exclusiveReadiness": true,
          "readyable": true,
          "stackable": true
        },
        "id": "resource"
      },
      {
        "characteristics": {
          "equippable": true,
          "exclusiveReadiness": true,
          "readyable": true
        },
        "id": "shield"
      },
      {
        "characteristics": {
          "equippable": true,
          "exclusiveReadiness": true,
          "readyable": true
        },
        "id": "shirt"
      },
      {
        "characteristics": {
          "equippable": true,
          "exclusiveReadiness": true,
          "readyable": true
        },
        "id": "shoes"
      },
      {
        "characteristics": {
          "disallowedClassesOnActive": [
            "weapon",
            "resource"
          ],
          "exclusiveReadiness": true,
          "readyable": true,
          "stableAngleOnDrop": true,
          "unbuyable": true
        },
        "id": "structure"
      },
      {
        "characteristics": {
          "disallowedClassesOnActive": [
            "resource",
            "structure"
          ],
          "equippable": true,
          "exclusiveReadiness": true,
          "hasDurability": true,
          "readyable": true
        },
        "id": "weapon"
      }
    ],
    "ember": {
      "about": "Ember humanoid equipment as data. MODELS say what a garment, shield or weapon is made of -- volumes hung on the solved skeleton, cut and painted -- in the expression language of game-common/ember_sprite/expr.ts; DESIGNS bind an item type to a model and its parameters. See game-common/ember_sprite/model.ts.",
      "designs": [
        {
          "handling": {},
          "id": "axe",
          "model": "axe",
          "slot": "held"
        },
        {
          "handling": {
            "rest": {
              "out": 75,
              "wrist": 60
            }
          },
          "id": "dagger",
          "model": "dagger",
          "slot": "held"
        },
        {
          "handling": {
            "frame": 112,
            "rest": {
              "out": 15,
              "wrist": 18
            }
          },
          "id": "longsword",
          "model": "longsword",
          "slot": "held"
        },
        {
          "handling": {
            "frame": 112,
            "rest": {
              "out": 15,
              "wrist": 18
            }
          },
          "id": "saber",
          "model": "saber",
          "slot": "held"
        },
        {
          "handling": {
            "twoHanded": true
          },
          "id": "bow",
          "model": "bow",
          "slot": "held"
        },
        {
          "handling": {},
          "id": "mace",
          "model": "mace",
          "slot": "held"
        },
        {
          "handling": {},
          "id": "warhammer",
          "model": "warhammer",
          "slot": "held"
        },
        {
          "handling": {},
          "id": "flail",
          "model": "flail",
          "slot": "held"
        },
        {
          "handling": {
            "frame": 112,
            "twoHanded": true
          },
          "id": "waraxe",
          "model": "waraxe",
          "slot": "held"
        },
        {
          "handling": {
            "frame": 128,
            "polearm": true,
            "twoHanded": true
          },
          "id": "halberd",
          "model": "halberd",
          "slot": "held"
        },
        {
          "handling": {
            "frame": 128,
            "polearm": true,
            "twoHanded": true
          },
          "id": "scythe",
          "model": "scythe",
          "slot": "held"
        },
        {
          "handling": {
            "frame": 112,
            "rest": {
              "out": 15,
              "wrist": 18
            }
          },
          "id": "rapier",
          "model": "rapier",
          "slot": "held"
        },
        {
          "handling": {},
          "id": "iron-pickaxe",
          "model": "iron-pickaxe",
          "slot": "held"
        },
        {
          "handling": {
            "frame": 128,
            "polearm": true,
            "twoHanded": true
          },
          "id": "spear",
          "model": "spear",
          "slot": "held"
        },
        {
          "handling": {
            "frame": 128,
            "polearm": true,
            "twoHanded": true
          },
          "id": "staff",
          "model": "staff",
          "slot": "held"
        },
        {
          "handling": {
            "twoHanded": true
          },
          "icon": {
            "tilt": 50,
            "turn": 40
          },
          "id": "crossbow",
          "model": "crossbow",
          "slot": "held"
        },
        {
          "bind": {
            "chargeMaterial": "rampFrom('#9b2a24')",
            "field": "tincture('white')",
            "rim": "SHIELD_STEEL"
          },
          "id": "shield-crusader",
          "model": "shield",
          "params": {
            "charge": "cross",
            "shape": "heater"
          },
          "slot": "shield"
        },
        {
          "bind": {
            "field": "tincture(color)",
            "rim": "SHIELD_STEEL"
          },
          "id": "shield-kite",
          "model": "shield",
          "params": {
            "shape": "heater"
          },
          "slot": "shield"
        },
        {
          "bind": {
            "chargeMaterial": "tincture(color)",
            "field": "tincture('blue')",
            "rim": "SHIELD_BRASS"
          },
          "id": "shield-kite_blue",
          "model": "shield",
          "params": {
            "charge": "chevron",
            "shape": "heater"
          },
          "slot": "shield"
        },
        {
          "bind": {
            "chargeMaterial": "tincture(color)",
            "field": "tincture('gray')",
            "rim": "SHIELD_BRASS"
          },
          "id": "shield-kite_gray",
          "model": "shield",
          "params": {
            "charge": "chevron",
            "shape": "heater"
          },
          "slot": "shield"
        },
        {
          "bind": {
            "chargeMaterial": "tincture(color)",
            "field": "tincture('green')",
            "rim": "SHIELD_BRASS"
          },
          "id": "shield-kite_green",
          "model": "shield",
          "params": {
            "charge": "chevron",
            "shape": "heater"
          },
          "slot": "shield"
        },
        {
          "bind": {
            "chargeMaterial": "tincture(color)",
            "field": "tincture('red')",
            "rim": "SHIELD_BRASS"
          },
          "id": "shield-kite_red",
          "model": "shield",
          "params": {
            "charge": "chevron",
            "shape": "heater"
          },
          "slot": "shield"
        },
        {
          "bind": {
            "field": "SHIELD_WOOD",
            "rim": "SHIELD_IRON"
          },
          "id": "shield-round",
          "model": "shield",
          "params": {
            "shape": "round"
          },
          "slot": "shield"
        },
        {
          "bind": {
            "chargeMaterial": "metalFrom('#6e4a1f')",
            "field": "SHIELD_BRONZE",
            "rim": "SHIELD_BRONZE"
          },
          "id": "shield-spartan",
          "model": "shield",
          "params": {
            "charge": "lambda",
            "metal": true,
            "shape": "aspis"
          },
          "slot": "shield"
        },
        {
          "id": "shoes",
          "model": "shoes",
          "slot": "shoes"
        },
        {
          "id": "boots",
          "model": "boots",
          "slot": "shoes"
        },
        {
          "id": "slippers",
          "model": "slippers",
          "slot": "shoes"
        },
        {
          "id": "sandals",
          "model": "sandals",
          "slot": "shoes"
        },
        {
          "id": "shoes-armor",
          "model": "sabatons",
          "slot": "shoes"
        },
        {
          "id": "pants",
          "model": "trousers",
          "slot": "pants"
        },
        {
          "id": "pantaloons",
          "model": "pantaloons",
          "slot": "pants"
        },
        {
          "id": "skirts",
          "model": "skirt",
          "slot": "pants"
        },
        {
          "id": "legion",
          "model": "legion",
          "slot": "pants"
        },
        {
          "id": "pants-armor",
          "model": "greaves",
          "slot": "pants"
        },
        {
          "id": "longsleeve",
          "model": "shirt",
          "params": {
            "sleeves": "long"
          },
          "slot": "shirt"
        },
        {
          "id": "longsleeve_laced",
          "model": "shirt",
          "params": {
            "neck": "laced",
            "sleeves": "long"
          },
          "slot": "shirt"
        },
        {
          "id": "sleeveless",
          "model": "shirt",
          "params": {
            "neck": "scoop",
            "sleeves": "none"
          },
          "slot": "shirt"
        },
        {
          "id": "sleeveless_laced",
          "model": "shirt",
          "params": {
            "neck": "laced",
            "sleeves": "none"
          },
          "slot": "shirt"
        },
        {
          "id": "sleeveless_striped",
          "model": "shirt",
          "params": {
            "neck": "scoop",
            "pattern": "stripes",
            "sleeves": "none"
          },
          "slot": "shirt"
        },
        {
          "id": "blouse",
          "model": "shirt",
          "params": {
            "neck": "scoop",
            "puffed": true,
            "sleeves": "short"
          },
          "slot": "shirt"
        },
        {
          "id": "blouse_longsleeve",
          "model": "shirt",
          "params": {
            "neck": "scoop",
            "puffed": true,
            "sleeves": "long"
          },
          "slot": "shirt"
        },
        {
          "id": "corset",
          "model": "shirt",
          "params": {
            "neck": "low",
            "pattern": "lacing",
            "sleeves": "none"
          },
          "slot": "shirt"
        },
        {
          "id": "scoop_shirt",
          "model": "shirt",
          "params": {
            "neck": "scoop",
            "sleeves": "short"
          },
          "slot": "shirt"
        },
        {
          "id": "tanktop",
          "model": "shirt",
          "params": {
            "neck": "low",
            "sleeves": "none"
          },
          "slot": "shirt"
        },
        {
          "id": "tunic",
          "model": "shirt",
          "params": {
            "hem": "thigh",
            "sleeves": "none",
            "tunic": true
          },
          "slot": "shirt"
        },
        {
          "id": "armor-leather",
          "model": "leather",
          "slot": "armor"
        },
        {
          "id": "armor-legion",
          "model": "legion",
          "slot": "armor"
        },
        {
          "id": "armor-plate",
          "model": "plate",
          "slot": "armor"
        },
        {
          "id": "bauldron",
          "model": "bauldron",
          "slot": "bauldron"
        }
      ],
      "library": [
        [
          "AXE_HAFT",
          "rampFrom('#8a5b34')"
        ],
        [
          "AXE_HEAD",
          "rampFrom('#a3acb5')"
        ],
        [
          "SWORD_STEEL",
          "rampFrom('#c3cbd3', '#4b525e')",
          "Materials (rampFrom / metalFrom ramps) the game's weapons are made of: AXE_HAFT AXE_HEAD SWORD_STEEL SWORD_BRASS SWORD_GRIP DAGGER_GRIP DAGGER_GUARD BOW_WOOD BOW_GRIP BOW_STRING ARROW_SHAFT ARROW_HEAD ARROW_FLETCH IRON DARK_WOOD STAFF_WOOD STAFF_GEM RAPIER_GOLD CROSSBOW_STOCK."
        ],
        [
          "SWORD_BRASS",
          "rampFrom('#b8924a')"
        ],
        [
          "SWORD_GRIP",
          "rampFrom('#4a2e22')"
        ],
        [
          "DAGGER_GRIP",
          "rampFrom('#5b3a26')"
        ],
        [
          "DAGGER_GUARD",
          "rampFrom('#8d7a55')"
        ],
        [
          "BOW_WOOD",
          "rampFrom('#a8692f')"
        ],
        [
          "BOW_GRIP",
          "rampFrom('#4a3022')"
        ],
        [
          "BOW_STRING",
          "rampFrom('#ddd5c2')"
        ],
        [
          "ARROW_SHAFT",
          "rampFrom('#c29a68')"
        ],
        [
          "ARROW_HEAD",
          "rampFrom('#a9b2ba')"
        ],
        [
          "ARROW_FLETCH",
          "rampFrom('#b0443a')"
        ],
        [
          "IRON",
          "rampFrom('#7d848c', '#2f3338')"
        ],
        [
          "DARK_WOOD",
          "rampFrom('#5e3b22')"
        ],
        [
          "STAFF_WOOD",
          "rampFrom('#9b6a3c')"
        ],
        [
          "STAFF_GEM",
          "rampFrom('#5fc4e8', '#1f4c66')"
        ],
        [
          "RAPIER_GOLD",
          "rampFrom('#d6b04a', '#5a4520')"
        ],
        [
          "CROSSBOW_STOCK",
          "rampFrom('#8a3e2c', '#3a1a12')"
        ],
        [
          "bladeFrame",
          {
            "fn": [
              "j",
              "d"
            ],
            "let": [
              [
                "across",
                "sub(j.edge, scale(d, dot(j.edge, d)))"
              ],
              [
                "edge",
                "dot(across, across) > 1e-6 ? normalize(across) : normalize(cross(d, [1, 0, 0]))"
              ],
              [
                "thin",
                "normalize(cross(edge, d))"
              ]
            ],
            "return": "{ edge, thin, basis: [thin[0], d[0], edge[0], thin[1], d[1], edge[1], thin[2], d[2], edge[2]] }"
          },
          "bladeFrame(j, d) -> { edge, thin, basis }: a blade's frame from the hand's joints j and its axis d -- edge across its width, in the plane the wrist bends in (j.edge), thin through its flat; basis is [thin, d, edge] as a Mat3."
        ],
        [
          "blade",
          {
            "fn": [
              "base",
              "d",
              "edge",
              "thin",
              "length",
              "width",
              "point",
              "thick",
              "curve",
              "steel"
            ],
            "let": [
              [
                "bow",
                "curve ?? 0"
              ],
              [
                "m",
                "steel ?? SWORD_STEEL"
              ],
              [
                "at",
                "u => add(add(base, scale(d, u * length)), scale(edge, -bow * length * u * u))"
              ],
              [
                "slice",
                {
                  "fn": [
                    "i"
                  ],
                  "let": [
                    [
                      "u0",
                      "i / 8"
                    ],
                    [
                      "u1",
                      "(i + 1) / 8"
                    ],
                    [
                      "a",
                      "at(u0)"
                    ],
                    [
                      "b",
                      "at(u1)"
                    ],
                    [
                      "along",
                      "normalize(sub(b, a))"
                    ],
                    [
                      "across",
                      "normalize(cross(thin, along))"
                    ],
                    [
                      "basis",
                      "[thin[0], along[0], across[0], thin[1], along[1], across[1], thin[2], along[2], across[2]]"
                    ],
                    [
                      "half",
                      "sqrt(dot(sub(b, a), sub(b, a))) / 2"
                    ],
                    [
                      "u",
                      "(u0 + u1) / 2"
                    ],
                    [
                      "w",
                      "u < 0.65 ? width + (point - width) * 0.25 * (u / 0.65) : width * 0.75 + (point - width * 0.75) * ((u - 0.65) / 0.35)"
                    ]
                  ],
                  "return": "ellipsoid(scale(add(a, b), 0.5), basis, [thick, half * 1.35, w], m, 'held')"
                }
              ]
            ],
            "return": "range(8).map(i => slice(i))"
          },
          "blade(base, d, edge, thin, length, width, point, thick, curve?, steel?) -> 8 ellipsoids: a flat blade from base along d, width across (along edge) narrowing to point at the tip, thick through the flat; curve sweeps it back off the edge (a share of its length); steel defaults to SWORD_STEEL. Group 'held'."
        ],
        [
          "around",
          {
            "fn": [
              "d"
            ],
            "let": [
              [
                "a",
                "normalize(abs(d[1]) < 0.9 ? cross(d, [0, 1, 0]) : cross(d, [1, 0, 0]))"
              ]
            ],
            "return": "[a, normalize(cross(d, a))]"
          },
          "around(d) -> [a, b]: two unit vectors square to d and to each other: a frame round a shaft."
        ],
        [
          "spikes",
          {
            "fn": [
              "at",
              "d",
              "r",
              "length",
              "m"
            ],
            "let": [
              [
                "ab",
                "around(d)"
              ],
              [
                "spike",
                {
                  "fn": [
                    "i"
                  ],
                  "let": [
                    [
                      "t",
                      "(i / 6) * 2 * PI"
                    ],
                    [
                      "out",
                      "add(scale(ab[0], cos(t)), scale(ab[1], sin(t)))"
                    ]
                  ],
                  "return": "segment(add(at, scale(out, r * 0.6)), add(at, scale(out, r + length)), max(0.7, r * 0.3), m, 'held')"
                }
              ]
            ],
            "return": "[...range(6).map(i => spike(i)), segment(at, add(at, scale(d, r + length)), max(0.7, r * 0.3), m, 'held')]"
          },
          "spikes(at, d, r, length, m) -> segments: six spikes standing out of a ball of radius r round at, square to d, and one off its end along d."
        ],
        [
          "haft",
          {
            "fn": [
              "fist",
              "d",
              "length",
              "behind",
              "r",
              "m"
            ],
            "let": [
              [
                "butt",
                "add(fist, scale(d, -length * behind))"
              ],
              [
                "tip",
                "add(fist, scale(d, length * (1 - behind)))"
              ]
            ],
            "return": "{ butt, tip, prim: capsule(butt, tip, r, m, 'held') }"
          },
          "haft(fist, d, length, behind, r, m) -> { butt, tip, prim }: a capsule haft through the fist along d, `behind` (a share of its length) below the fist, the rest ahead; prim is the capsule (group 'held')."
        ],
        [
          "TINCTURES",
          {
            "blue": "#3e63a0",
            "gray": "#8b9096",
            "green": "#4f7a3a",
            "orange": "#c06a2c",
            "red": "#a33a33",
            "white": "#dcd6c8"
          }
        ],
        [
          "tincture",
          "name => rampFrom(TINCTURES[name] ?? TINCTURES.gray)",
          "tincture(name) -> a heraldic paint ramp (TINCTURES: white gray blue green red orange; others gray)."
        ],
        [
          "SHIELD_STEEL",
          "metalFrom('#9aa2aa')"
        ],
        [
          "SHIELD_IRON",
          "metalFrom('#5d6268')"
        ],
        [
          "SHIELD_BRASS",
          "metalFrom('#b8924a')"
        ],
        [
          "SHIELD_WOOD",
          "rampFrom('#7a5134')"
        ],
        [
          "SHIELD_BACK",
          "rampFrom('#5e4029')"
        ],
        [
          "SHIELD_BRONZE",
          "metalFrom('#a5712f')"
        ],
        [
          "SHIELD_TURN",
          "{ front: deg(15), back: deg(25), left: deg(55), right: deg(-55), frontleft: deg(35), frontright: deg(-20), backleft: deg(40), backright: deg(-15) }",
          "Per facing, how far (radians) a shield's face is turned from the body's forward toward the camera."
        ],
        [
          "ARMOR_COLORS",
          {
            "leather": {
              "blue": "#3d5170",
              "brown": "#6b4a30",
              "green": "#4c5f36"
            },
            "legion": {
              "brown": "#a5712f",
              "gold": "#c39a34",
              "gray": "#87919b"
            },
            "plate": {
              "gold": "#c39a34",
              "gray": "#6b727a",
              "metal": "#88929c",
              "orange": "#b0662f",
              "tan": "#9e8866",
              "yellow": "#c2a240"
            }
          },
          "Body armour's base colours by kind (leather, legion, plate), by the item colour's name; plate's metals are also sabatons' and greaves'."
        ],
        [
          "shoeOf",
          {
            "fn": [
              "sk",
              "p",
              "side",
              "by",
              "m",
              "footWidth",
              "keep"
            ],
            "let": [
              [
                "j",
                "sk[side]"
              ]
            ],
            "return": "{ ...foot(j.heel, j.toe, p.footRadius + by, footWidth + by, m, legOf(side)), ...(keep ? { keep } : {}) }"
          },
          "shoeOf(sk, p, side, by, m, footWidth, keep?) -> the side's foot volume `by` off the skin in m, cut by keep (a (q) => boolean on the foot's own frame: q[2] forward, q[1] up)."
        ],
        [
          "LEGION_LEATHER",
          "rampFrom('#5e3017')",
          "The legionary skirt's leather (LEGION_TUNIC its red tunic)."
        ],
        [
          "LEGION_TUNIC",
          "rampFrom('#8e2a22')"
        ],
        [
          "skirtLike",
          {
            "fn": [
              "sk",
              "p",
              "m",
              "t",
              "hem",
              "lining",
              "slice"
            ],
            "let": [
              [
                "off",
                "lining.off ?? 0.5 + 0.3 * t"
              ],
              [
                "endOf",
                "j => hem <= 1 ? lerp(j.hip, j.knee, hem) : lerp(j.knee, j.ankle, hem - 1)"
              ],
              [
                "liningOf",
                {
                  "cases": [
                    [
                      "hem <= 1",
                      "[capsule(lerp(j.hip, end, lining.from ?? 0), end, p.thighRadius + off, lining.m, 'skirt')]"
                    ]
                  ],
                  "fn": [
                    "side"
                  ],
                  "let": [
                    [
                      "j",
                      "sk[side]"
                    ],
                    [
                      "end",
                      "endOf(j)"
                    ]
                  ],
                  "return": "[segment(j.hip, j.knee, p.thighRadius + off, lining.m, 'skirt'), joint(j.knee, p.shinRadius * 0.9 + off, lining.m, 'skirt'), segment(j.knee, end, p.shinRadius + off, lining.m, 'skirt')]"
                }
              ],
              [
                "path",
                {
                  "fn": [
                    "side"
                  ],
                  "let": [
                    [
                      "j",
                      "sk[side]"
                    ],
                    [
                      "end",
                      "endOf(j)"
                    ],
                    [
                      "knee",
                      "hem <= 1 ? end : j.knee"
                    ],
                    [
                      "upper",
                      "sqrt(dot(sub(knee, j.hip), sub(knee, j.hip)))"
                    ],
                    [
                      "lower",
                      "hem <= 1 ? 0 : sqrt(dot(sub(end, j.knee), sub(end, j.knee)))"
                    ],
                    [
                      "at",
                      {
                        "cases": [
                          [
                            "d <= upper",
                            "{ at: lerp(j.hip, knee, d / upper), along: normalize(sub(knee, j.hip)) }"
                          ]
                        ],
                        "fn": [
                          "f"
                        ],
                        "let": [
                          [
                            "d",
                            "f * (upper + lower)"
                          ]
                        ],
                        "return": "{ at: lerp(j.knee, end, (d - upper) / lower), along: normalize(sub(end, j.knee)) }"
                      }
                    ]
                  ],
                  "return": "{ length: upper + lower, at }"
                }
              ],
              [
                "legL",
                "path('L')"
              ],
              [
                "legR",
                "path('R')"
              ],
              [
                "N",
                "max(4, round(hem * 6))"
              ],
              [
                "spacing",
                "(legL.length + legR.length) / 2 / N"
              ],
              [
                "sliceAt",
                {
                  "fn": [
                    "i"
                  ],
                  "let": [
                    [
                      "f",
                      "i / N"
                    ],
                    [
                      "a",
                      "legL.at(f)"
                    ],
                    [
                      "b",
                      "legR.at(f)"
                    ],
                    [
                      "center",
                      "scale(add(a.at, b.at), 0.5)"
                    ],
                    [
                      "y",
                      "normalize(scale(add(a.along, b.along), -1))"
                    ],
                    [
                      "span",
                      "sub(a.at, b.at)"
                    ],
                    [
                      "flat",
                      "sub(span, scale(y, dot(span, y)))"
                    ],
                    [
                      "x",
                      "dot(flat, flat) > 1e-6 ? normalize(flat) : normalize(apply(sk.pelvisBasis, [1, 0, 0]))"
                    ],
                    [
                      "z",
                      "normalize(cross(x, y))"
                    ],
                    [
                      "basis",
                      "[x[0], y[0], z[0], x[1], y[1], z[1], x[2], y[2], z[2]]"
                    ],
                    [
                      "slant",
                      "max(0.6, min(-dot(a.along, y), -dot(b.along, y)))"
                    ],
                    [
                      "legRadius",
                      "hem <= 1 || f < 0.5 ? p.thighRadius : p.shinRadius"
                    ],
                    [
                      "reach",
                      "(legRadius + 0.5 + 0.6 * t + (hem / 1.7) * f) / slant"
                    ],
                    [
                      "half",
                      "sqrt(dot(flat, flat)) / 2"
                    ],
                    [
                      "radii",
                      "[half + reach, spacing * 1.2, reach]"
                    ],
                    [
                      "toWorld",
                      "q => add(center, apply(basis, q))"
                    ]
                  ],
                  "return": "ellipsoid(center, basis, radii, m, 'skirt', { exponent: [3.5, 4, 3.5], ...(slice ? slice(i, N, radii, toWorld) : {}) })"
                }
              ]
            ],
            "return": "[...lowerBody(sk, p, m, 0.9 * t, undefined, true).map(prim => ({ ...prim, group: 'skirt' })), ...liningOf('L'), ...liningOf('R'), ...range(N).map(k => sliceAt(k + 1))]"
          },
          "skirtLike(sk, p, m, t, hem, lining, slice?) -> one volume round both legs from the hips to `hem` (in leg segments: 0.55 mid-thigh, 1 the knee, 1.7 the lower calf): the hips, a lining per leg (lining: { m, from?, off? }) and a stack of drum slices spanning the legs; slice(i, n, radii, toWorld) may add a decal or keep to each slice. Group 'skirt'."
        ],
        [
          "LACE",
          "rampFrom('#e6dcc4')"
        ],
        [
          "ARMOR_BUCKLE",
          "metalFrom('#c3c8cc')"
        ],
        [
          "BAULDRON_COLORS",
          {
            "brown": "#5a2410"
          }
        ],
        [
          "BAULDRON_TIP",
          "metalFrom('#9a9a9a')"
        ]
      ],
      "models": {
        "armor": {
          "leather": {
            "about": "A leather jerkin to the hips, belted at the waist, a metal buckle at the front; the cloth ramp's softer light.",
            "let": [
              [
                "base",
                "(tones && tones[color]) ?? ARMOR_COLORS.leather[color] ?? ARMOR_COLORS.leather.brown"
              ],
              [
                "m",
                "rampFrom(base)"
              ],
              [
                "by",
                "0.9 * t + 0.1"
              ],
              [
                "chest",
                "upperBody(sk, p, m, by, facing).filter(prim => prim.group === 'torso' || prim.group === 'bust')"
              ],
              [
                "hips",
                "lowerBody(sk, p, m, by + 0.15, q => q[1] > -p.pelvis[1] * 0.5)"
              ],
              [
                "up",
                "apply(sk.torsoBasis, [0, 1, 0])"
              ],
              [
                "across",
                "apply(sk.torsoBasis, [1, 0, 0])"
              ],
              [
                "ahead",
                "apply(sk.torsoBasis, [0, 0, 1])"
              ],
              [
                "waist",
                "add(sk.pelvis, apply(sk.pelvisBasis, [0, p.pelvis[1] * 0.45, 0]))"
              ],
              [
                "belt",
                "[p.pelvis[0] + by + 0.9, 1.0, p.pelvis[2] + by + 0.9]"
              ]
            ],
            "params": {
              "color": "brown",
              "tones": null
            },
            "parts": [
              "chest",
              "hips",
              "ellipsoid(waist, sk.pelvisBasis, belt, rampFrom('#3a2a20'), 'torso', { exponent: [3, 4, 3], decal: q => (abs(q[0]) < 1.0 && q[2] > 0 ? ARMOR_BUCKLE.light : undefined) })"
            ]
          },
          "legion": {
            "about": "A legionary's banded cuirass: overlapping bands round the torso to the waist, following its lean, a dark seam a pixel wide where each overlaps the next; metal's own light (sheen).",
            "let": [
              [
                "base",
                "(tones && tones[color]) ?? ARMOR_COLORS.legion[color] ?? ARMOR_COLORS.legion.brown"
              ],
              [
                "m",
                "metalFrom(base)"
              ],
              [
                "by",
                "1.0 * t + 0.35"
              ],
              [
                "chest",
                "upperBody(sk, p, m, by, facing).filter(prim => prim.group === 'torso' || prim.group === 'bust')"
              ],
              [
                "hips",
                "lowerBody(sk, p, m, by + 0.15, q => q[1] > -p.pelvis[1] * 0.05)"
              ],
              [
                "up",
                "apply(sk.torsoBasis, [0, 1, 0])"
              ],
              [
                "across",
                "apply(sk.torsoBasis, [1, 0, 0])"
              ],
              [
                "ahead",
                "apply(sk.torsoBasis, [0, 0, 1])"
              ],
              [
                "band",
                "2.6"
              ],
              [
                "shine",
                "sheen(m, facing)"
              ]
            ],
            "params": {
              "color": "brown",
              "tones": null
            },
            "parts": [
              {
                "paint": {
                  "fn": [
                    "w",
                    "n"
                  ],
                  "let": [
                    [
                      "y",
                      "dot(sub(w, sk.chest), up) / band"
                    ]
                  ],
                  "return": "y - floor(y) < 0.38 ? m.deep : shine(n)"
                },
                "parts": [
                  "chest",
                  "hips"
                ]
              }
            ]
          },
          "plate": {
            "about": "A plate breastplate: a rigid shell, not the body's own shape -- swelling out ahead of the chest, a barrel in profile, ending in a flared fauld over the hips (a hard edge cloth never has) -- with a raised ridge down its middle, lit on the side toward the light, shadowed beside it; metal's own light.",
            "let": [
              [
                "base",
                "(tones && tones[color]) ?? ARMOR_COLORS.plate[color] ?? ARMOR_COLORS.plate.gray"
              ],
              [
                "m",
                "metalFrom(base)"
              ],
              [
                "by",
                "1.0 * t + 0.35"
              ],
              [
                "chest",
                "upperBody(sk, p, m, by, facing).filter(prim => prim.group === 'torso' || prim.group === 'bust')"
              ],
              [
                "hips",
                "lowerBody(sk, p, m, by + 0.15, q => q[1] > -p.pelvis[1] * 0.25)"
              ],
              [
                "up",
                "apply(sk.torsoBasis, [0, 1, 0])"
              ],
              [
                "across",
                "apply(sk.torsoBasis, [1, 0, 0])"
              ],
              [
                "ahead",
                "apply(sk.torsoBasis, [0, 0, 1])"
              ],
              [
                "breast",
                "add(sk.chest, apply(sk.torsoBasis, [0, -0.4, p.posture + 0.7]))"
              ],
              [
                "shell",
                "ellipsoid(breast, sk.torsoBasis, [p.torso[0] + by * 0.6, p.torso[1] * 0.9 + by, p.torso[2] + by + 0.5], m, 'torso', { exponent: [3, 2.4, 2] })"
              ],
              [
                "fauldAt",
                "add(sk.pelvis, apply(sk.pelvisBasis, [0, p.pelvis[1] * 0.15, 0.2]))"
              ],
              [
                "fauld",
                "ellipsoid(fauldAt, sk.pelvisBasis, [p.pelvis[0] + by + 0.8, 1.4, p.pelvis[2] + by + 0.9], m, 'torso', { exponent: [2.6, 4, 2.6] })"
              ],
              [
                "shine",
                "sheen(m, facing)"
              ]
            ],
            "params": {
              "color": "gray",
              "tones": null
            },
            "parts": [
              {
                "paint": {
                  "cases": [
                    [
                      "ridge && x > -0.6 && x <= 0.3",
                      "m.light"
                    ],
                    [
                      "ridge && x > 0.3 && x < 1.1",
                      "m.deep"
                    ]
                  ],
                  "fn": [
                    "w",
                    "n"
                  ],
                  "let": [
                    [
                      "v",
                      "sub(w, sk.chest)"
                    ],
                    [
                      "x",
                      "dot(v, across)"
                    ],
                    [
                      "ridge",
                      "dot(v, ahead) > 0 && dot(v, up) > -p.spine"
                    ]
                  ],
                  "return": "shine(n)"
                },
                "parts": [
                  "chest",
                  "shell",
                  "hips",
                  "fauld"
                ]
              }
            ]
          }
        },
        "bauldron": {
          "bauldron": {
            "about": "The game's bauldron, as LPC draws it: a leather pauldron capping the RIGHT shoulder, two lames deep, hard-edged and standing off whatever the shoulder wears (a sleeve or not), hidden side-on with that shoulder away; and its strap (a baldric), PAINTED over every torso surface -- skin, shirt or armour, whichever the camera sees -- from the top of the right shoulder down across the chest to the left side and the same way round the back, its steel tip hanging at the left side in front.",
            "let": [
              [
                "m",
                "rampFrom((tones && tones[color]) ?? BAULDRON_COLORS[color] ?? BAULDRON_COLORS.brown)"
              ],
              [
                "under",
                "look.shirt && look.shirt.sleeves !== 'none' ? 0.6 * t : 0"
              ],
              [
                "hidden",
                "(facing === 'left' || facing === 'right') && farSide(facing) === 'R'"
              ],
              [
                "j",
                "sk.R"
              ],
              [
                "out",
                "apply(sk.torsoBasis, [sideSign('R'), 0, 0])"
              ],
              [
                "lit",
                "lighting(facing)"
              ],
              [
                "r",
                "p.deltoidRadius + under + 0.9"
              ],
              [
                "cap",
                "add(j.shoulder, apply(sk.torsoBasis, [sideSign('R') * 0.6, 0.7, 0]))"
              ],
              [
                "dome",
                "ellipsoid(cap, sk.torsoBasis, [r + 0.2, r * 0.8, r + 0.2], m, 'armR', { part: 'pauldron', keep: q => q[1] > -r * 0.35 })"
              ],
              [
                "arm",
                "distance(j.shoulder, j.elbow)"
              ],
              [
                "lame",
                "as(segment(j.shoulder, lerp(j.shoulder, j.elbow, 0.45), p.upperArmRadius + under + 0.7, m, 'armR'), 'pauldron')"
              ],
              [
                "lower",
                "{ ...lame, keep: q => dot(apply(lame.basis, q), out) > -0.3 && q[1] < arm * 0.12 }"
              ],
              [
                "sAcross",
                "apply(sk.torsoBasis, [1, 0, 0])"
              ],
              [
                "sUp",
                "apply(sk.torsoBasis, [0, 1, 0])"
              ],
              [
                "sAhead",
                "apply(sk.torsoBasis, [0, 0, 1])"
              ],
              [
                "shoulder",
                "sub(sk.R.shoulder, sk.chest)"
              ],
              [
                "from",
                "[dot(shoulder, sAcross) * 0.7, dot(shoulder, sUp) + p.deltoidRadius * 0.6]"
              ],
              [
                "to",
                "[p.torso[0] * 0.95, -p.torso[1] * 0.55]"
              ],
              [
                "run",
                "[to[0] - from[0], to[1] - from[1]]"
              ],
              [
                "runLength",
                "hypot(run[0], run[1])"
              ],
              [
                "dir",
                "[run[0] / runLength, run[1] / runLength]"
              ],
              [
                "half",
                "max(1.05, p.torso[0] * 0.13)"
              ],
              [
                "strap",
                {
                  "cases": [
                    [
                      "s < -half * 2 || s > runLength",
                      "undefined"
                    ],
                    [
                      "abs(d) > half",
                      "undefined"
                    ],
                    [
                      "s > runLength - half * 1.6 && dot(v, sAhead) > 0",
                      "tone(BAULDRON_TIP, lit(n))"
                    ]
                  ],
                  "fn": [
                    "w",
                    "n"
                  ],
                  "let": [
                    [
                      "v",
                      "sub(w, sk.chest)"
                    ],
                    [
                      "x",
                      "dot(v, sAcross) - from[0]"
                    ],
                    [
                      "y",
                      "dot(v, sUp) - from[1]"
                    ],
                    [
                      "s",
                      "x * dir[0] + y * dir[1]"
                    ],
                    [
                      "d",
                      "x * -dir[1] + y * dir[0]"
                    ]
                  ],
                  "return": "d < -half * 0.35 ? m.deep : tone(m, min(2, lit(n)))"
                }
              ]
            ],
            "overBody": {
              "groups": [
                "torso",
                "bust",
                "shoulder"
              ],
              "paint": "strap"
            },
            "params": {
              "color": "brown",
              "tones": null
            },
            "parts": [
              {
                "parts": [
                  {
                    "paint": {
                      "fn": [
                        "w",
                        "n"
                      ],
                      "let": [
                        [
                          "below",
                          "dot(sub(w, cap), apply(sk.torsoBasis, [0, 1, 0]))"
                        ]
                      ],
                      "return": "abs(below + r * 0.3) < 0.45 ? m.deep : tone(m, lit(n))"
                    },
                    "parts": [
                      "dome",
                      "lower"
                    ]
                  }
                ],
                "when": "!hidden"
              }
            ]
          }
        },
        "belt": {
          "belt": {
            "about": "A belt: a flat band round the pelvis at the top of the hips, over whatever is worn there.",
            "let": [
              [
                "m",
                "cloth(dye)"
              ],
              [
                "waist",
                "add(sk.pelvis, apply(sk.pelvisBasis, [0, p.pelvis[1] * 0.55, 0]))"
              ]
            ],
            "params": {
              "dye": "black"
            },
            "parts": [
              "ellipsoid(waist, sk.pelvisBasis, [p.pelvis[0] + 1.3 * t, 0.9, p.pelvis[2] + 1.3 * t], m, 'torso', { exponent: p.pelvisRoundness })"
            ]
          }
        },
        "held": {
          "axe": {
            "about": "A woodsman's axe in the fist: a haft through the hand along its grip, the iron head at the far end with its edge on the forearm's side of the haft -- the side that leads when the arm chops. Sized to the body that holds it.",
            "let": [
              [
                "j",
                "sk.R"
              ],
              [
                "fist",
                "fistCenter(sk, p, 'R')"
              ],
              [
                "leg",
                "legLength(p)"
              ],
              [
                "d",
                "normalize(j.grip)"
              ],
              [
                "forearm",
                "normalize(sub(j.hand, j.elbow))"
              ],
              [
                "across",
                "sub(forearm, scale(d, dot(forearm, d)))"
              ],
              [
                "edge",
                "dot(across, across) > 1e-6 ? normalize(across) : normalize(cross(d, [1, 0, 0]))"
              ],
              [
                "len",
                "leg * 0.93"
              ],
              [
                "r",
                "max(0.8, leg * 0.042)"
              ],
              [
                "butt",
                "add(fist, scale(d, -len * 0.12))"
              ],
              [
                "tip",
                "add(fist, scale(d, len * 0.88))"
              ],
              [
                "thin",
                "normalize(cross(edge, d))"
              ],
              [
                "basis",
                "[thin[0], d[0], edge[0], thin[1], d[1], edge[1], thin[2], d[2], edge[2]]"
              ],
              [
                "bladeAt",
                "add(add(tip, scale(d, -len * 0.1)), scale(edge, len * 0.09))"
              ],
              [
                "pollAt",
                "add(add(tip, scale(d, -len * 0.09)), scale(edge, -len * 0.05))"
              ]
            ],
            "parts": [
              "capsule(butt, tip, r, AXE_HAFT, 'held')",
              "ellipsoid(bladeAt, basis, [r * 0.9, len * 0.15, len * 0.16], AXE_HEAD, 'held', { exponent: [2, 2.6, 2.2] })",
              "ellipsoid(pollAt, basis, [r * 1.1, len * 0.06, len * 0.06], AXE_HEAD, 'held', { exponent: 2.6 })"
            ]
          },
          "bow": {
            "about": "A longbow in the LEFT hand, about as tall as the man: its limbs run along the hand's grip (biased to upright) and curve back toward the archer at the tips, further the harder it is drawn (the skeleton's draw). Undrawn the string runs tip to tip; drawn, to the right hand at the jaw, an arrow nocked there and laid across the bow hand.",
            "let": [
              [
                "leg",
                "legLength(p)"
              ],
              [
                "draw",
                "sk.draw ?? 0"
              ],
              [
                "grip",
                "fistCenter(sk, p, 'L')"
              ],
              [
                "nock",
                "fistCenter(sk, p, 'R')"
              ],
              [
                "axis",
                "normalize(add(normalize(sk.L.grip), [0, 1.5, 0]))"
              ],
              [
                "aim",
                "draw > 0 ? sub(grip, nock) : apply(sk.pelvisBasis, [0, 0, 1])"
              ],
              [
                "ahead0",
                "sub(aim, scale(axis, dot(aim, axis)))"
              ],
              [
                "ahead",
                "dot(ahead0, ahead0) > 1e-6 ? normalize(ahead0) : normalize(cross(axis, [1, 0, 0]))"
              ],
              [
                "half",
                "leg * 0.85"
              ],
              [
                "bend",
                "0.1 + 0.22 * draw"
              ],
              [
                "r0",
                "max(1.9, leg * 0.07)"
              ],
              [
                "at",
                "u => add(add(grip, scale(axis, u * half * (1 - 0.15 * bend * u * u))), scale(ahead, -bend * half * u * u))"
              ],
              [
                "limb",
                {
                  "fn": [
                    "i"
                  ],
                  "let": [
                    [
                      "u0",
                      "-1 + (2 * i) / 12"
                    ],
                    [
                      "u1",
                      "-1 + (2 * (i + 1)) / 12"
                    ],
                    [
                      "mid",
                      "(u0 + u1) / 2"
                    ],
                    [
                      "material",
                      "abs(mid) < 0.12 ? BOW_GRIP : BOW_WOOD"
                    ]
                  ],
                  "return": "capsule(at(u0), at(u1), r0 * (1 - 0.4 * mid * mid), material, 'held')"
                }
              ],
              [
                "top",
                "at(1)"
              ],
              [
                "bottom",
                "at(-1)"
              ],
              [
                "flight",
                "normalize(sub(grip, nock))"
              ],
              [
                "arrowTip",
                "add(nock, scale(flight, leg * 0.82))"
              ]
            ],
            "parts": [
              "range(12).map(i => limb(i))",
              {
                "else": [
                  "capsule(top, bottom, 0.5, BOW_STRING, 'held')"
                ],
                "parts": [
                  "capsule(top, nock, 0.5, BOW_STRING, 'held')",
                  "capsule(nock, bottom, 0.5, BOW_STRING, 'held')",
                  "capsule(nock, arrowTip, 0.42, ARROW_SHAFT, 'held')",
                  "ellipsoid(arrowTip, sk.torsoBasis, [0.7, 0.7, 0.7], ARROW_HEAD, 'held')",
                  "capsule(nock, add(nock, scale(flight, leg * 0.1)), 0.7, ARROW_FLETCH, 'held')"
                ],
                "when": "draw > 0"
              }
            ]
          },
          "crossbow": {
            "about": "A crossbow: a stock along the grip from behind the fist, a prod across its front swept back at the tips (lying flat whatever the stock does), the string drawn back to the nut and a bolt along the top.",
            "let": [
              [
                "j",
                "sk.R"
              ],
              [
                "fist",
                "fistCenter(sk, p, 'R')"
              ],
              [
                "leg",
                "legLength(p)"
              ],
              [
                "d",
                "normalize(j.grip)"
              ],
              [
                "r",
                "max(1.0, leg * 0.045)"
              ],
              [
                "back",
                "add(fist, scale(d, -leg * 0.14))"
              ],
              [
                "front",
                "add(fist, scale(d, leg * 0.45))"
              ],
              [
                "level",
                "cross(d, [0, 1, 0])"
              ],
              [
                "across",
                "dot(level, level) > 1e-6 ? normalize(level) : around(d)[0]"
              ],
              [
                "up",
                "normalize(cross(across, d))"
              ],
              [
                "nut",
                "add(fist, scale(d, leg * 0.16))"
              ],
              [
                "prod",
                {
                  "fn": [
                    "s"
                  ],
                  "let": [
                    [
                      "tipAt",
                      "add(add(front, scale(across, s * leg * 0.3)), scale(d, -leg * 0.08))"
                    ]
                  ],
                  "return": "[capsule(front, tipAt, max(0.8, leg * 0.03), BOW_GRIP, 'held'), capsule(tipAt, nut, 0.45, BOW_STRING, 'held')]"
                }
              ]
            ],
            "parts": [
              "capsule(back, front, r, CROSSBOW_STOCK, 'held')",
              "prod(1)",
              "prod(-1)",
              "capsule(add(nut, scale(up, r * 0.8)), add(front, add(scale(d, leg * 0.06), scale(up, r * 0.8))), 0.5, ARROW_SHAFT, 'held')"
            ]
          },
          "dagger": {
            "about": "A dagger in the fist: a short handle, a small crossguard and a blade two-fifths of the leg long, laid along the blade's line (between the grip and the forearm). Its blade by the item's colour: metal is steel, brown bronze.",
            "let": [
              [
                "j",
                "sk.R"
              ],
              [
                "fist",
                "fistCenter(sk, p, 'R')"
              ],
              [
                "leg",
                "legLength(p)"
              ],
              [
                "d",
                "bladeAxis(j)"
              ],
              [
                "r",
                "max(0.9, leg * 0.032)"
              ],
              [
                "pommel",
                "add(fist, scale(d, -leg * 0.09))"
              ],
              [
                "guardAt",
                "add(fist, scale(d, leg * 0.07))"
              ],
              [
                "frame",
                "bladeFrame(j, d)"
              ],
              [
                "blades",
                "{ metal: rampFrom('#b9c2cb', '#4b525e'), brown: rampFrom('#b5824a', '#5a3a22') }"
              ],
              [
                "steel",
                "blades[color ?? 'metal'] ?? blades.metal"
              ]
            ],
            "params": {
              "color": "metal"
            },
            "parts": [
              "capsule(pommel, guardAt, r, DAGGER_GRIP, 'held')",
              "ellipsoid(guardAt, frame.basis, [r * 1.2, r, leg * 0.09], DAGGER_GUARD, 'held')",
              "blade(guardAt, d, frame.edge, frame.thin, leg * 0.42, max(1.8, leg * 0.07), 0.6, max(1.1, leg * 0.04), 0, steel)"
            ]
          },
          "flail": {
            "about": "A flail: a short haft, a chain from its end drooping under the ball, a spiked iron ball.",
            "let": [
              [
                "j",
                "sk.R"
              ],
              [
                "fist",
                "fistCenter(sk, p, 'R')"
              ],
              [
                "leg",
                "legLength(p)"
              ],
              [
                "d",
                "normalize(j.grip)"
              ],
              [
                "h",
                "haft(fist, d, leg * 0.45, 0.2, max(0.8, leg * 0.038), DARK_WOOD)"
              ],
              [
                "hr",
                "max(2.6, leg * 0.09)"
              ],
              [
                "chain",
                "normalize(add(d, [0, -1.4, 0]))"
              ],
              [
                "ball",
                "add(h.tip, scale(chain, leg * 0.3))"
              ]
            ],
            "parts": [
              "h.prim",
              "[1, 2, 3].map(i => ellipsoid(lerp(h.tip, ball, i / 4), [1, 0, 0, 0, 1, 0, 0, 0, 1], [1, 1, 1], IRON, 'held'))",
              "ellipsoid(ball, [1, 0, 0, 0, 1, 0, 0, 0, 1], [hr, hr, hr], IRON, 'held')",
              "spikes(ball, chain, hr, max(1.2, leg * 0.04), IRON)"
            ]
          },
          "halberd": {
            "about": "A halberd: a pole taller than its bearer, an axe blade and a spike at the top, a hook behind.",
            "let": [
              [
                "j",
                "sk.R"
              ],
              [
                "fist",
                "fistCenter(sk, p, 'R')"
              ],
              [
                "leg",
                "legLength(p)"
              ],
              [
                "d",
                "normalize(j.grip)"
              ],
              [
                "len",
                "leg * 1.85"
              ],
              [
                "r",
                "max(0.9, leg * 0.038)"
              ],
              [
                "h",
                "haft(fist, d, len, 0.35, r, DARK_WOOD)"
              ],
              [
                "frame",
                "bladeFrame(j, d)"
              ],
              [
                "bladeAt",
                "add(add(h.tip, scale(d, -leg * 0.13)), scale(frame.edge, leg * 0.13))"
              ]
            ],
            "parts": [
              "h.prim",
              "segment(h.tip, add(h.tip, scale(d, leg * 0.26)), max(1.0, leg * 0.035), SWORD_STEEL, 'held')",
              "ellipsoid(bladeAt, frame.basis, [r * 0.9, leg * 0.2, leg * 0.14], SWORD_STEEL, 'held', { exponent: [2, 2.6, 2] })",
              "segment(add(h.tip, scale(d, -leg * 0.1)), add(add(h.tip, scale(d, -leg * 0.06)), scale(frame.edge, -leg * 0.14)), max(0.7, leg * 0.026), SWORD_STEEL, 'held')"
            ]
          },
          "iron-pickaxe": {
            "about": "An iron pickaxe: a haft and, square across its end, a pick bar drawn to a point both ways, each arm curving down toward the hand.",
            "let": [
              [
                "j",
                "sk.R"
              ],
              [
                "fist",
                "fistCenter(sk, p, 'R')"
              ],
              [
                "leg",
                "legLength(p)"
              ],
              [
                "d",
                "normalize(j.grip)"
              ],
              [
                "h",
                "haft(fist, d, leg * 0.85, 0.12, max(0.8, leg * 0.04), AXE_HAFT)"
              ],
              [
                "edge",
                "bladeFrame(j, d).edge"
              ],
              [
                "arm",
                {
                  "fn": [
                    "s"
                  ],
                  "let": [
                    [
                      "mid",
                      "add(add(h.tip, scale(edge, s * leg * 0.12)), scale(d, -leg * 0.015))"
                    ],
                    [
                      "end",
                      "add(add(h.tip, scale(edge, s * leg * 0.24)), scale(d, -leg * 0.07))"
                    ]
                  ],
                  "return": "[capsule(h.tip, mid, max(1.1, leg * 0.04), IRON, 'held'), capsule(mid, end, max(0.7, leg * 0.026), IRON, 'held')]"
                }
              ]
            ],
            "parts": [
              "h.prim",
              "arm(1)",
              "arm(-1)"
            ]
          },
          "longsword": {
            "about": "A longsword: a straight double-edged blade about a leg long (never under 24px), a cross of brass quillons, a grip long enough for both hands, a wheel pommel.",
            "let": [
              [
                "j",
                "sk.R"
              ],
              [
                "fist",
                "fistCenter(sk, p, 'R')"
              ],
              [
                "leg",
                "legLength(p)"
              ],
              [
                "d",
                "swordAxis(j)"
              ],
              [
                "frame",
                "bladeFrame(j, d)"
              ],
              [
                "edge",
                "frame.edge"
              ],
              [
                "guardAt",
                "add(fist, scale(d, p.handRadius + 0.3))"
              ],
              [
                "pommelAt",
                "add(fist, scale(d, -(twoHandSpan(p) + p.handRadius + 0.4)))"
              ],
              [
                "quillon",
                "max(3.6, leg * 0.15)"
              ]
            ],
            "parts": [
              "blade(guardAt, d, edge, frame.thin, max(24, leg * 0.95), max(2.2, leg * 0.085), 0.7, max(1.4, leg * 0.05))",
              "capsule(add(guardAt, scale(edge, -quillon)), add(guardAt, scale(edge, quillon)), max(1.0, leg * 0.04), SWORD_BRASS, 'held')",
              "capsule(guardAt, pommelAt, max(1.0, leg * 0.036), SWORD_GRIP, 'held')",
              "ellipsoid(pommelAt, frame.basis, [1.3, 1.4, 1.8], SWORD_BRASS, 'held')"
            ]
          },
          "mace": {
            "about": "A mace: a short haft and a flanged iron head, heavy enough to read as one.",
            "let": [
              [
                "j",
                "sk.R"
              ],
              [
                "fist",
                "fistCenter(sk, p, 'R')"
              ],
              [
                "leg",
                "legLength(p)"
              ],
              [
                "d",
                "normalize(j.grip)"
              ],
              [
                "h",
                "haft(fist, d, leg * 0.6, 0.15, max(0.9, leg * 0.04), DARK_WOOD)"
              ],
              [
                "hr",
                "max(3, leg * 0.1)"
              ],
              [
                "head",
                "add(h.tip, scale(d, -hr * 0.3))"
              ]
            ],
            "parts": [
              "h.prim",
              "ellipsoid(head, [1, 0, 0, 0, 1, 0, 0, 0, 1], [hr, hr, hr], IRON, 'held')",
              "spikes(head, d, hr, max(1.4, leg * 0.045), IRON)"
            ]
          },
          "rapier": {
            "about": "A rapier: a long, narrow, straight blade for the point, and a gold swept hilt -- a cup at the guard, quillons across it and a knuckle-bow round the fingers to the pommel.",
            "let": [
              [
                "j",
                "sk.R"
              ],
              [
                "fist",
                "fistCenter(sk, p, 'R')"
              ],
              [
                "leg",
                "legLength(p)"
              ],
              [
                "d",
                "swordAxis(j)"
              ],
              [
                "frame",
                "bladeFrame(j, d)"
              ],
              [
                "edge",
                "frame.edge"
              ],
              [
                "guardAt",
                "add(fist, scale(d, p.handRadius + 0.3))"
              ],
              [
                "capAt",
                "add(fist, scale(d, -(p.handRadius + 0.4)))"
              ],
              [
                "r",
                "max(0.8, leg * 0.03)"
              ],
              [
                "bow",
                "u => add(add(guardAt, scale(d, -u * (p.handRadius * 2 + 0.7))), scale(edge, (p.handRadius + 0.7) * sin(PI * min(1, u * 1.15)) + 0.6))"
              ]
            ],
            "parts": [
              "blade(guardAt, d, edge, frame.thin, max(22, leg * 0.95), max(1.4, leg * 0.05), 0.4, max(1.0, leg * 0.035))",
              "range(4).map(i => capsule(bow(i / 4), bow((i + 1) / 4), r, RAPIER_GOLD, 'held'))",
              "ellipsoid(guardAt, [1, 0, 0, 0, 1, 0, 0, 0, 1], [1.5, 1.5, 1.5], RAPIER_GOLD, 'held')",
              "capsule(add(guardAt, scale(edge, -2.2)), add(guardAt, scale(edge, 2.2)), max(0.8, leg * 0.03), RAPIER_GOLD, 'held')",
              "ellipsoid(capAt, [1, 0, 0, 0, 1, 0, 0, 0, 1], [1.2, 1.2, 1.2], RAPIER_GOLD, 'held')"
            ]
          },
          "saber": {
            "about": "A cavalry saber: a single-edged blade sweeping back off its edge (never under 20px), a short grip, a brass knuckle-bow from the guard round the fist to the pommel cap.",
            "let": [
              [
                "j",
                "sk.R"
              ],
              [
                "fist",
                "fistCenter(sk, p, 'R')"
              ],
              [
                "leg",
                "legLength(p)"
              ],
              [
                "d",
                "swordAxis(j)"
              ],
              [
                "frame",
                "bladeFrame(j, d)"
              ],
              [
                "edge",
                "frame.edge"
              ],
              [
                "guardAt",
                "add(fist, scale(d, p.handRadius + 0.2))"
              ],
              [
                "capAt",
                "add(fist, scale(d, -(p.handRadius + 0.3)))"
              ],
              [
                "bow",
                "u => add(add(guardAt, scale(d, -u * (p.handRadius * 2 + 0.5))), scale(edge, (p.handRadius + 0.6) * sin(PI * min(1, u * 1.15)) + 0.6))"
              ],
              [
                "r",
                "max(0.8, leg * 0.03)"
              ]
            ],
            "parts": [
              "blade(guardAt, d, edge, frame.thin, max(20, leg * 0.85), max(2.0, leg * 0.075), 0.6, max(1.2, leg * 0.045), 0.12)",
              "range(4).map(i => capsule(bow(i / 4), bow((i + 1) / 4), r, SWORD_BRASS, 'held'))",
              "capsule(add(guardAt, scale(edge, -1.2)), add(guardAt, scale(edge, 1.2)), max(0.9, leg * 0.034), SWORD_BRASS, 'held')",
              "ellipsoid(capAt, [1, 0, 0, 0, 1, 0, 0, 0, 1], [1.2, 1.2, 1.2], SWORD_BRASS, 'held')"
            ]
          },
          "scythe": {
            "about": "A scythe: a long snath and, square to it at the top, a long blade curving down toward the hands.",
            "let": [
              [
                "j",
                "sk.R"
              ],
              [
                "fist",
                "fistCenter(sk, p, 'R')"
              ],
              [
                "leg",
                "legLength(p)"
              ],
              [
                "d",
                "normalize(j.grip)"
              ],
              [
                "len",
                "leg * 1.7"
              ],
              [
                "h",
                "haft(fist, d, len, 0.28, max(0.9, leg * 0.036), DARK_WOOD)"
              ],
              [
                "edge",
                "bladeFrame(j, d).edge"
              ],
              [
                "thin",
                "normalize(cross(d, edge))"
              ]
            ],
            "parts": [
              "h.prim",
              "blade(h.tip, edge, d, thin, leg * 0.75, max(2.0, leg * 0.07), 0.5, max(1.1, leg * 0.035), 0.3)"
            ]
          },
          "spear": {
            "about": "A spear: a long shaft and a leaf-shaped iron point on a socket.",
            "let": [
              [
                "j",
                "sk.R"
              ],
              [
                "fist",
                "fistCenter(sk, p, 'R')"
              ],
              [
                "leg",
                "legLength(p)"
              ],
              [
                "d",
                "normalize(j.grip)"
              ],
              [
                "h",
                "haft(fist, d, leg * 1.95, 0.35, max(0.8, leg * 0.034), DARK_WOOD)"
              ],
              [
                "basis",
                "bladeFrame(j, d).basis"
              ]
            ],
            "parts": [
              "h.prim",
              "ellipsoid(add(h.tip, scale(d, leg * 0.12)), basis, [max(0.9, leg * 0.03), leg * 0.15, max(1.8, leg * 0.065)], SWORD_STEEL, 'held')",
              "ellipsoid(h.tip, basis, [1.1, 1.0, 1.1], IRON, 'held')"
            ]
          },
          "staff": {
            "about": "A staff: a tall plain stave and, held in a knot of its wood at the top, a blue gem (LPC's).",
            "let": [
              [
                "j",
                "sk.R"
              ],
              [
                "fist",
                "fistCenter(sk, p, 'R')"
              ],
              [
                "leg",
                "legLength(p)"
              ],
              [
                "d",
                "normalize(j.grip)"
              ],
              [
                "h",
                "haft(fist, d, leg * 1.8, 0.3, max(1.0, leg * 0.042), STAFF_WOOD)"
              ],
              [
                "gr",
                "max(1.6, leg * 0.06)"
              ],
              [
                "gem",
                "add(h.tip, scale(d, gr * 0.9))"
              ],
              [
                "a",
                "around(d)[0]"
              ]
            ],
            "parts": [
              "h.prim",
              "ellipsoid(h.tip, [1, 0, 0, 0, 1, 0, 0, 0, 1], [gr * 0.9, gr * 0.9, gr * 0.9], STAFF_WOOD, 'held')",
              "segment(add(h.tip, scale(a, gr * 0.8)), add(gem, scale(a, gr * 0.9)), 0.6, STAFF_WOOD, 'held')",
              "segment(add(h.tip, scale(a, -gr * 0.8)), add(gem, scale(a, -gr * 0.9)), 0.6, STAFF_WOOD, 'held')",
              "ellipsoid(gem, [1, 0, 0, 0, 1, 0, 0, 0, 1], [gr, gr, gr], STAFF_GEM, 'held')"
            ]
          },
          "waraxe": {
            "about": "A war axe: a great axe for two hands, a long haft and a crescent blade either side of its head.",
            "let": [
              [
                "j",
                "sk.R"
              ],
              [
                "fist",
                "fistCenter(sk, p, 'R')"
              ],
              [
                "leg",
                "legLength(p)"
              ],
              [
                "d",
                "normalize(j.grip)"
              ],
              [
                "len",
                "leg * 1.15"
              ],
              [
                "r",
                "max(0.9, leg * 0.042)"
              ],
              [
                "h",
                "haft(fist, d, len, 0.25, r, DARK_WOOD)"
              ],
              [
                "frame",
                "bladeFrame(j, d)"
              ],
              [
                "at",
                "add(h.tip, scale(d, -len * 0.12))"
              ]
            ],
            "parts": [
              "h.prim",
              "ellipsoid(add(at, scale(frame.edge, len * 0.12)), frame.basis, [r * 0.9, len * 0.19, len * 0.12], AXE_HEAD, 'held', { exponent: [2, 2.4, 2] })",
              "ellipsoid(add(at, scale(frame.edge, -len * 0.1)), frame.basis, [r * 0.9, len * 0.15, len * 0.1], AXE_HEAD, 'held', { exponent: [2, 2.4, 2] })"
            ]
          },
          "warhammer": {
            "about": "A warhammer: a haft with a squared iron block across its end, a spike behind.",
            "let": [
              [
                "j",
                "sk.R"
              ],
              [
                "fist",
                "fistCenter(sk, p, 'R')"
              ],
              [
                "leg",
                "legLength(p)"
              ],
              [
                "d",
                "normalize(j.grip)"
              ],
              [
                "h",
                "haft(fist, d, leg * 0.78, 0.15, max(0.8, leg * 0.04), DARK_WOOD)"
              ],
              [
                "frame",
                "bladeFrame(j, d)"
              ],
              [
                "hr",
                "max(2.6, leg * 0.09)"
              ],
              [
                "head",
                "add(h.tip, scale(d, -hr * 0.5))"
              ]
            ],
            "parts": [
              "h.prim",
              "ellipsoid(add(head, scale(frame.edge, hr * 0.5)), frame.basis, [hr * 0.95, hr * 1.1, hr * 1.8], IRON, 'held', { exponent: 4 })",
              "segment(head, add(head, scale(frame.edge, -hr * 2.4)), max(0.7, hr * 0.35), IRON, 'held')"
            ]
          }
        },
        "pants": {
          "greaves": {
            "about": "Armoured leg wear, LPC's steel leggings: plate over the seat, cuisses down each thigh in three overlapping lames, a cop standing proud over the knee, a greave down the shin to the ankle, in the plate armour's metals. Shaded as legs are (LPC's greaves are dark steel); only the knee cop takes the glint. Each plate is a limb segment of its own, so the raster lines it where it overlaps the next.",
            "let": [
              [
                "m",
                "metalFrom(ARMOR_COLORS.plate[dye] ?? ARMOR_COLORS.plate.metal)"
              ],
              [
                "lit",
                "lighting(facing)"
              ],
              [
                "by",
                "0.6 * t + 0.25"
              ]
            ],
            "params": {
              "dye": "metal"
            },
            "parts": [
              "lowerBody(sk, p, m, by + 0.1, undefined, true)",
              {
                "as": "side",
                "each": "SIDES",
                "let": [
                  [
                    "j",
                    "sk[side]"
                  ],
                  [
                    "g",
                    "legOf(side)"
                  ],
                  [
                    "along",
                    "normalize(sub(j.knee, j.hip))"
                  ],
                  [
                    "lame",
                    "distance(j.hip, j.knee) / 3"
                  ]
                ],
                "parts": [
                  {
                    "paint": {
                      "fn": [
                        "w"
                      ],
                      "let": [
                        [
                          "d",
                          "dot(sub(w, j.hip), along) / lame"
                        ]
                      ],
                      "return": "d > 0.8 && d < 2.8 && d - floor(d) < 0.3 ? m.deep : undefined"
                    },
                    "parts": [
                      "thighOf(sk, side, p, by, m, g).map(prim => as(prim, 'thigh'))"
                    ]
                  },
                  {
                    "paint": "(_w, n) => (lit(n) === 0 ? m.light : undefined)",
                    "parts": [
                      "as(joint(j.knee, p.shinRadius * 0.9 + by + 0.6, m, g), 'knee')"
                    ]
                  },
                  "shinOf(sk, side, p, by, m, g, 0.94).map(prim => as(prim, 'shin'))"
                ]
              }
            ]
          },
          "legion": {
            "about": "A legionary's pteruges: a short skirt of leather straps hanging from a studded belt to mid-thigh, each strap tipped with a brass stud and hanging free at the bottom, where the red tunic worn under it shows between them. Straps run round the body's own upright axis, the same for every slice, so a seam falls straight down the skirt. The item comes in one colour.",
            "let": [
              [
                "ax",
                "apply(sk.pelvisBasis, [1, 0, 0])"
              ],
              [
                "az",
                "apply(sk.pelvisBasis, [0, 0, 1])"
              ],
              [
                "strap",
                {
                  "fn": [
                    "world",
                    "count"
                  ],
                  "let": [
                    [
                      "v",
                      "sub(world, sk.pelvis)"
                    ]
                  ],
                  "return": "((atan2(dot(v, az), dot(v, ax)) / (2 * PI) + 0.5) * (count ?? 12)) % 1"
                }
              ],
              [
                "slice",
                {
                  "fn": [
                    "i",
                    "n",
                    "radii",
                    "toWorld"
                  ],
                  "let": [
                    [
                      "free",
                      "i > n * 0.55"
                    ]
                  ],
                  "return": "{ decal: q => strapDecal(q, i, n, radii, toWorld), keep: free ? (q => strap(toWorld(q)) >= 0.34) : undefined }"
                }
              ],
              [
                "strapDecal",
                {
                  "cases": [
                    [
                      "u < 0.3",
                      "LEGION_LEATHER.line"
                    ],
                    [
                      "i === n && u > 0.5 && u < 0.85 && abs(q[1]) < radii[1] * 0.45",
                      "SWORD_BRASS.base"
                    ]
                  ],
                  "fn": [
                    "q",
                    "i",
                    "n",
                    "radii",
                    "toWorld"
                  ],
                  "let": [
                    [
                      "u",
                      "strap(toWorld(q))"
                    ]
                  ],
                  "return": "undefined"
                }
              ],
              [
                "waist",
                "add(sk.pelvis, apply(sk.pelvisBasis, [0, p.pelvis[1] * 0.55, 0]))"
              ],
              [
                "beltRadii",
                "[p.pelvis[0] + 1.6 * t, 1.1, p.pelvis[2] + 1.6 * t]"
              ]
            ],
            "params": {
              "dye": "brown"
            },
            "parts": [
              "skirtLike(sk, p, LEGION_LEATHER, t, 0.55, { m: LEGION_TUNIC, from: 0.5, off: 0.3 }, slice)",
              {
                "as": "side",
                "each": "SIDES",
                "let": [
                  [
                    "j",
                    "sk[side]"
                  ]
                ],
                "parts": [
                  "capsule(j.hip, lerp(j.hip, j.knee, 0.15), p.thighRadius + 0.2, LEGION_LEATHER, 'skirt')"
                ]
              },
              "ellipsoid(waist, sk.pelvisBasis, beltRadii, LEGION_LEATHER, 'skirt', { exponent: [3, 4, 3], decal: q => (strap(add(waist, apply(sk.pelvisBasis, q)), 12) < 0.72 ? SWORD_BRASS.base : LEGION_LEATHER.deep) })"
            ]
          },
          "pantaloons": {
            "about": "Pantaloons: loose, full trousers. Roomy through the seat and thigh, blousing over the knee and calf, then gathered into a band three-quarters of the way down the shin, the ankle left bare. The fullness hangs off the OUTSIDE of each leg, as the cut drapes, so the legs stay apart below the seat.",
            "let": [
              [
                "m",
                "cloth(dye)"
              ],
              [
                "loose",
                "0.8 + 0.7 * t"
              ]
            ],
            "params": {
              "dye": "brown"
            },
            "parts": [
              "lowerBody(sk, p, m, 0.8 * t, undefined, true)",
              {
                "as": "side",
                "each": "SIDES",
                "let": [
                  [
                    "j",
                    "sk[side]"
                  ],
                  [
                    "band",
                    "lerp(j.knee, j.ankle, 0.74)"
                  ],
                  [
                    "out",
                    "scale(apply(sk.pelvisBasis, [sideSign(side), 0, 0]), loose * 0.45)"
                  ]
                ],
                "parts": [
                  "segment(add(j.hip, scale(out, 0.5)), add(j.knee, out), p.thighRadius + loose, m, legOf(side))",
                  "joint(add(j.knee, out), p.shinRadius * 0.9 + loose * 1.1, m, legOf(side))",
                  "segment(add(j.knee, out), add(band, scale(out, 0.6)), p.shinRadius + loose * 1.2, m, legOf(side))",
                  "as(capsule(lerp(j.knee, j.ankle, 0.7), lerp(j.knee, j.ankle, 0.8), p.shinRadius * 0.8 + 0.35 * t, m, legOf(side)), 'band')"
                ]
              }
            ]
          },
          "shorts": {
            "about": "Shorts: trousers cut at the knee.",
            "params": {
              "cut": "shorts",
              "dye": "brown"
            },
            "parts": [
              {
                "use": "trousers",
                "with": {
                  "cut": "shorts"
                }
              }
            ]
          },
          "skirt": {
            "about": "A skirt to the lower calf, round both legs, the feet stepping out beneath it.",
            "let": [
              [
                "m",
                "cloth(dye)"
              ]
            ],
            "params": {
              "dye": "brown"
            },
            "parts": [
              "skirtLike(sk, p, m, t, 1.7, { m })"
            ]
          },
          "trousers": {
            "about": "Trousers (and `shorts`, cut at the knee): the hips, a thigh and a knee per leg, and the shin to the ankle, each the body's own volume a little off it.",
            "let": [
              [
                "m",
                "cloth(dye)"
              ]
            ],
            "params": {
              "cut": "trousers",
              "dye": "brown"
            },
            "parts": [
              "lowerBody(sk, p, m, 0.5 * t, undefined, true)",
              {
                "as": "side",
                "each": "SIDES",
                "let": [
                  [
                    "j",
                    "sk[side]"
                  ]
                ],
                "parts": [
                  "thighOf(sk, side, p, 0.45 * t, m, legOf(side))",
                  "joint(j.knee, p.shinRadius * 0.9 + 0.4 * t, m, legOf(side))",
                  {
                    "parts": [
                      "shinOf(sk, side, p, 0.4 * t, m, legOf(side), 0.92)"
                    ],
                    "when": "cut !== 'shorts'"
                  }
                ]
              }
            ]
          }
        },
        "shield": {
          "shield": {
            "about": "A shield gripped in the LEFT fist (a centre grip, as LPC holds every shield), its face turned toward the camera for the facing, or slung on the back (`slung`) while that hand has a bow. A heater is a flat slab cut to a point below; a round shield a disc with an iron rim and boss over planks; the aspis a bronze dome with a raised rim. Paint is lit here (decals skip the raster's shading); the back shows bare wood. Parameters: shape (heater | round | aspis), field and rim (materials, usually bound: tincture(color), SHIELD_WOOD), charge (cross | chevron | lambda, in chargeMaterial), metal (a polished face), size (1 the game's own; 0.7 a buckler).",
            "let": [
              [
                "leg",
                "legLength(p)"
              ],
              [
                "up",
                "apply(sk.torsoBasis, [0, 1, 0])"
              ],
              [
                "w",
                "(shape === 'heater' ? max(6.5, leg * 0.3) : max(8, leg * (shape === 'aspis' ? 0.42 : 0.38))) * size"
              ],
              [
                "h",
                "shape === 'heater' ? max(9, leg * 0.42) * size : w"
              ],
              [
                "thick",
                "shape === 'aspis' ? 2.8 : 0.9"
              ],
              [
                "turn",
                "SHIELD_TURN[facing]"
              ],
              [
                "face",
                "slung ? apply(sk.torsoBasis, [0.25, 0, -1]) : apply(sk.torsoBasis, [sin(turn), 0, cos(turn)])"
              ],
              [
                "center",
                "slung ? add(sk.chest, apply(sk.torsoBasis, [0.5, -1.5, -(p.torso[2] + thick + 1.2)])) : add(fistCenter(sk, p, 'L'), scale(face, p.handRadius * 0.7 + thick))"
              ],
              [
                "n",
                "normalize(face)"
              ],
              [
                "x",
                "normalize(cross(up, n))"
              ],
              [
                "y",
                "normalize(cross(n, x))"
              ],
              [
                "basis",
                "[x[0], y[0], n[0], x[1], y[1], n[1], x[2], y[2], n[2]]"
              ],
              [
                "toLocal",
                "world => apply(transpose(basis), sub(world, center))"
              ],
              [
                "halfWidth",
                "yn => (shape !== 'heater' ? sqrt(max(0, 1 - yn * yn)) : yn > -0.2 ? 1 : sqrt(max(0, 1 - ((-0.2 - yn) / 0.8) ** 2)))"
              ],
              [
                "stroke",
                {
                  "fn": [
                    "xn",
                    "yn",
                    "sx"
                  ],
                  "let": [
                    [
                      "ax",
                      "0"
                    ],
                    [
                      "ay",
                      "0.5"
                    ],
                    [
                      "bx",
                      "sx * 0.42"
                    ],
                    [
                      "by",
                      "-0.5"
                    ],
                    [
                      "t",
                      "max(0, min(1, ((xn - ax) * (bx - ax) + (yn - ay) * (by - ay)) / ((bx - ax) ** 2 + (by - ay) ** 2)))"
                    ]
                  ],
                  "return": "hypot(xn - (ax + t * (bx - ax)), yn - (ay + t * (by - ay))) < 0.09"
                }
              ],
              [
                "charged",
                {
                  "cases": [
                    [
                      "!charge",
                      "false"
                    ],
                    [
                      "charge === 'cross'",
                      "(abs(xn) < 0.14 && yn > -0.7 && yn < 0.8) || (abs(yn - 0.3) < 0.11 && abs(xn) < 0.62)"
                    ],
                    [
                      "charge === 'chevron'",
                      "abs(yn - (0.35 - 0.85 * abs(xn))) < 0.14"
                    ]
                  ],
                  "fn": [
                    "xn",
                    "yn"
                  ],
                  "return": "stroke(xn, yn, 1) || stroke(xn, yn, -1)"
                }
              ],
              [
                "lit",
                "lighting(facing)"
              ],
              [
                "shine",
                "sheen(field, facing)"
              ],
              [
                "rimWidth",
                "shape === 'aspis' ? 1.5 : 1.1"
              ],
              [
                "paint",
                {
                  "cases": [
                    [
                      "lz < 0",
                      "tone(SHIELD_BACK, step)"
                    ],
                    [
                      "edge < rimWidth || (shape !== 'heater' && hypot(lx, ly) > w - rimWidth)",
                      "tone(rim, step)"
                    ],
                    [
                      "charged(xn, yn)",
                      "tone(chargeMaterial, step)"
                    ],
                    [
                      "metal",
                      "shine(normal)"
                    ],
                    [
                      "shape === 'round' && ((lx / 2.6) % 1 + 1) % 1 < 0.2",
                      "tone(field, min(3, step + 1))"
                    ]
                  ],
                  "fn": [
                    "world",
                    "normal"
                  ],
                  "let": [
                    [
                      "l",
                      "toLocal(world)"
                    ],
                    [
                      "lx",
                      "l[0]"
                    ],
                    [
                      "ly",
                      "l[1]"
                    ],
                    [
                      "lz",
                      "l[2]"
                    ],
                    [
                      "step",
                      "lit(normal)"
                    ],
                    [
                      "xn",
                      "lx / w"
                    ],
                    [
                      "yn",
                      "ly / h"
                    ],
                    [
                      "edge",
                      "min(w * halfWidth(yn) - abs(lx), shape === 'heater' ? h - ly : w * 9)"
                    ]
                  ],
                  "return": "tone(field, step)"
                }
              ],
              [
                "slab",
                "ellipsoid(center, basis, [w, h, thick], field, 'held', { exponent: shape === 'heater' ? [6, 6, 2] : shape === 'round' ? [2, 2, 4] : [2, 2, 2], keep: shape === 'heater' ? q => abs(q[0]) <= w * halfWidth(q[1] / h) : undefined })"
              ],
              [
                "shineBoss",
                "sheen(SHIELD_IRON, facing)"
              ]
            ],
            "params": {
              "charge": null,
              "chargeMaterial": null,
              "color": "white",
              "field": null,
              "metal": false,
              "rim": null,
              "shape": "heater",
              "size": 1,
              "slung": false
            },
            "parts": [
              "painted([slab], paint)",
              {
                "parts": [
                  "painted([ellipsoid(add(center, scale(n, thick * 0.8)), basis, [w * 0.24, w * 0.24, 1.5], SHIELD_IRON, 'held')], (_w, normal) => shineBoss(normal))"
                ],
                "when": "shape === 'round' && !slung"
              }
            ]
          }
        },
        "shirt": {
          "shirt": {
            "about": "A shirt: the body's chest, shoulders and hips inflated in the dye (sleeveless leaves the deltoids bare), down to the belt -- or, on a body with a waist, to the waist's narrowest, where leg wear begins -- or over the hips as a `tunic` (with `hem: 'thigh'` a skirt to mid-thigh); sleeves `short` or `long`, `puffed` at the shoulder. A neckline (`scoop`, `low`, `laced`) and a pattern (`stripes`, `lacing`) are PAINTED in the body's own skin and lace, lit as the cloth is: they never change the silhouette.",
            "let": [
              [
                "m",
                "cloth(dye)"
              ],
              [
                "shoulders",
                "upperBody(sk, p, m, 0.6 * t, facing)"
              ],
              [
                "top",
                "p.waist ? (p.pelvisLow ?? 0) + (p.waistHeight ?? 0) : -p.pelvis[1] * 0.1"
              ],
              [
                "lit",
                "lighting(facing)"
              ],
              [
                "up",
                "apply(sk.torsoBasis, [0, 1, 0])"
              ],
              [
                "across",
                "apply(sk.torsoBasis, [1, 0, 0])"
              ],
              [
                "ahead",
                "apply(sk.torsoBasis, [0, 0, 1])"
              ],
              [
                "collar",
                "p.torso[1] * 0.92"
              ],
              [
                "white",
                "cloth('white')"
              ],
              [
                "laced",
                "(x, y) => (((y + abs(x) * 1.6) / 2.0) % 1 + 1) % 1 < 0.34"
              ],
              [
                "paint",
                {
                  "cases": [
                    [
                      "(neck === 'scoop' || neck === 'low') && front && abs(x) < width && y > collar - depth * (1 - (x / width) ** 2)",
                      "tone(skin, step)"
                    ],
                    [
                      "(neck === 'scoop' || neck === 'low') && low && abs(x) > width + 1.4 && y > collar - p.torso[1] * 0.3",
                      "tone(skin, step)"
                    ],
                    [
                      "neck === 'laced' && front && abs(x) < (y - (collar - vDepth)) * 0.5",
                      "laced(x, y) ? tone(LACE, step) : tone(skin, step)"
                    ],
                    [
                      "pattern === 'stripes' && (((y / 1.8) % 1) + 1) % 1 < 0.45",
                      "tone(white, step)"
                    ],
                    [
                      "pattern === 'lacing' && front && abs(x) < 1.7 && y < collar - p.torso[1] * 0.4 && laced(x, y)",
                      "tone(LACE, step)"
                    ]
                  ],
                  "fn": [
                    "w",
                    "n"
                  ],
                  "let": [
                    [
                      "v",
                      "sub(w, sk.chest)"
                    ],
                    [
                      "x",
                      "dot(v, across)"
                    ],
                    [
                      "y",
                      "dot(v, up)"
                    ],
                    [
                      "front",
                      "dot(v, ahead) > 0"
                    ],
                    [
                      "step",
                      "lit(n)"
                    ],
                    [
                      "low",
                      "neck === 'low'"
                    ],
                    [
                      "width",
                      "p.shoulderWidth * (low ? 0.55 : 0.42)"
                    ],
                    [
                      "depth",
                      "p.torso[1] * (low ? 0.45 : 0.28)"
                    ],
                    [
                      "vDepth",
                      "p.torso[1] * 0.75"
                    ]
                  ],
                  "return": "undefined"
                }
              ],
              [
                "body",
                "[...(sleeves === 'none' ? shoulders.filter(s => s.group === 'torso' || s.group === 'bust') : shoulders), ...lowerBody(sk, p, m, (tunic ? 1.1 : 0.85) * t, tunic ? undefined : q => q[1] > top)]"
              ],
              [
                "puff",
                "puffed ? 0.5 + 0.6 * t : 0"
              ]
            ],
            "params": {
              "dye": "white",
              "hem": null,
              "neck": null,
              "pattern": null,
              "puffed": false,
              "sleeves": "none",
              "tunic": false
            },
            "parts": [
              "neck || pattern ? painted(body, paint) : body",
              {
                "as": "side",
                "each": "SIDES",
                "let": [
                  [
                    "j",
                    "sk[side]"
                  ]
                ],
                "parts": [
                  {
                    "parts": [
                      "segment(j.shoulder, lerp(j.shoulder, j.elbow, 0.6), p.upperArmRadius + 0.5 * t + puff, m, armOf(side))"
                    ],
                    "when": "sleeves === 'short'"
                  },
                  {
                    "parts": [
                      "segment(j.shoulder, j.elbow, p.upperArmRadius + 0.5 * t, m, armOf(side))",
                      "joint(j.elbow, p.forearmRadius * 0.85 + 0.45 * t, m, armOf(side))",
                      "segment(j.elbow, lerp(j.elbow, j.hand, 0.8), p.forearmRadius + 0.45 * t, m, armOf(side))",
                      {
                        "parts": [
                          "segment(j.shoulder, lerp(j.shoulder, j.elbow, 0.4), p.upperArmRadius + 0.5 * t + puff, m, armOf(side))"
                        ],
                        "when": "puff"
                      }
                    ],
                    "when": "sleeves === 'long'"
                  }
                ]
              },
              {
                "parts": [
                  "skirtLike(sk, p, m, t, 0.45, { m })"
                ],
                "when": "hem === 'thigh'"
              }
            ]
          }
        },
        "shoes": {
          "boots": {
            "about": "Boots: shoes, and a shaft climbing the shin almost halfway to the knee.",
            "let": [
              [
                "m",
                "cloth(dye)"
              ]
            ],
            "params": {
              "dye": "brown"
            },
            "parts": [
              {
                "as": "side",
                "each": "SIDES",
                "let": [
                  [
                    "j",
                    "sk[side]"
                  ]
                ],
                "parts": [
                  "shoeOf(sk, p, side, 0.5 * t, m, footWidth)",
                  "capsule(j.ankle, lerp(j.ankle, j.knee, 0.45), p.shinRadius + 0.8 * t, m, legOf(side))"
                ]
              }
            ]
          },
          "sabatons": {
            "about": "Sabatons: steel plates across the foot, overlapping toward the toe, and a cuff over the ankle, in plate armour's metals with metal's own light.",
            "let": [
              [
                "m",
                "metalFrom(ARMOR_COLORS.plate[dye] ?? ARMOR_COLORS.plate.metal)"
              ]
            ],
            "params": {
              "dye": "metal"
            },
            "parts": [
              {
                "as": "side",
                "each": "SIDES",
                "let": [
                  [
                    "j",
                    "sk[side]"
                  ],
                  [
                    "along",
                    "normalize(sub(j.toe, j.heel))"
                  ],
                  [
                    "shine",
                    "sheen(m, facing)"
                  ]
                ],
                "parts": [
                  {
                    "paint": {
                      "fn": [
                        "w",
                        "n"
                      ],
                      "let": [
                        [
                          "d",
                          "dot(sub(w, j.heel), along) / 1.7"
                        ]
                      ],
                      "return": "d > 1 && d - floor(d) < 0.3 ? m.deep : shine(n)"
                    },
                    "parts": [
                      "shoeOf(sk, p, side, 0.6 * t, m, footWidth)",
                      "capsule(j.ankle, lerp(j.ankle, j.knee, 0.22), p.shinRadius + 0.7 * t, m, legOf(side))"
                    ]
                  }
                ]
              }
            ]
          },
          "sandals": {
            "about": "Sandals: the sole under the foot, straps criss-crossing over it with the skin between them, tied round the ankle. Stood well off the foot and over a pixel wide, or a small foot's straps never win a pixel.",
            "let": [
              [
                "m",
                "cloth(dye)"
              ],
              [
                "by",
                "0.5 + 0.3 * t"
              ],
              [
                "r",
                "p.footRadius + by"
              ],
              [
                "strap",
                "q => (((q[2] + abs(q[0]) * 1.2) / 2.4) % 1 + 1) % 1 < 0.5"
              ]
            ],
            "params": {
              "dye": "brown"
            },
            "parts": [
              {
                "as": "side",
                "each": "SIDES",
                "let": [
                  [
                    "j",
                    "sk[side]"
                  ]
                ],
                "parts": [
                  "shoeOf(sk, p, side, by, m, footWidth, q => q[1] < -r * 0.35 || strap(q))",
                  "ellipsoid(j.ankle, sk.pelvisBasis, [p.shinRadius * 0.8 + 0.8, 1.6, p.shinRadius * 0.8 + 0.8], m, legOf(side), { keep: q => abs(q[1]) < 0.7 })"
                ]
              }
            ]
          },
          "shoes": {
            "about": "Shoes: the foot's volume, half a pixel of leather off it, to the ankle.",
            "let": [
              [
                "m",
                "cloth(dye)"
              ]
            ],
            "params": {
              "dye": "brown"
            },
            "parts": [
              {
                "as": "side",
                "each": "SIDES",
                "parts": [
                  "shoeOf(sk, p, side, 0.5 * t, m, footWidth)"
                ]
              }
            ]
          },
          "slippers": {
            "about": "Slippers: low all round, and a toe box over the front: the top of the foot behind it shows.",
            "let": [
              [
                "m",
                "cloth(dye)"
              ],
              [
                "r",
                "p.footRadius + 0.35 * t"
              ]
            ],
            "params": {
              "dye": "brown"
            },
            "parts": [
              {
                "as": "side",
                "each": "SIDES",
                "parts": [
                  "shoeOf(sk, p, side, 0.35 * t, m, footWidth, q => q[1] < r * 0.1 || q[2] > 0)"
                ]
              }
            ]
          }
        }
      },
      "version": 1
    },
    "emberAnimations": {
      "about": "Animations made as data: PERFORMANCES any Ember body can play when something asks it to (the `/perform <name>` dev command, or whatever sets an entity's performance). Each is a keyframed clip like the game's own strikes and falls: KEYS -- poses of the whole body at times t from 0 to 1 -- eased between and drawn in `frames` frames of `frameMs` each, in every facing, on every body; `loop` plays it until it is stopped. A key says how the body rises (rise, px), shifts (shiftX), rolls, pitches forward from the pelvis (pitch: a bow), is let down onto whatever of it is lowest (ground, 0..1), bends forward (lean) and sideways (sideBend), turns its chest (twist; with hips and head given, those turn too), nods (headPitch); each arm as [pitch (raised forward: 90 level, 180 straight up), abduct (out to the side), flex (the elbow), wrist?] and each leg as planted feet [x out from the hip, z ahead] in px or angles [pitch, abduct, flex]. Angles in degrees. A name is lowercase letters, digits and _, never one of the game's actions.",
      "animations": {
        "bow": {
          "about": "A courtly bow: the right hand brought across the chest, the left swept out behind, the body bent forward from the hips with the head down, held a moment, and back up.",
          "frameMs": 80,
          "frames": 14,
          "keys": [
            {
              "armL": [
                8,
                12,
                20
              ],
              "armR": [
                10,
                12,
                25
              ],
              "feetL": [
                0.5,
                1.5
              ],
              "feetR": [
                0.5,
                -1.5
              ],
              "t": 0
            },
            {
              "armL": [
                -35,
                30,
                10
              ],
              "armR": [
                55,
                -40,
                95
              ],
              "feetL": [
                0.5,
                1.5
              ],
              "feetR": [
                0.5,
                -1.5
              ],
              "headPitch": 18,
              "pitch": 34,
              "t": 0.35
            },
            {
              "armL": [
                -35,
                30,
                10
              ],
              "armR": [
                55,
                -40,
                95
              ],
              "feetL": [
                0.5,
                1.5
              ],
              "feetR": [
                0.5,
                -1.5
              ],
              "headPitch": 18,
              "pitch": 34,
              "t": 0.65
            },
            {
              "armL": [
                8,
                12,
                20
              ],
              "armR": [
                10,
                12,
                25
              ],
              "feetL": [
                0.5,
                1.5
              ],
              "feetR": [
                0.5,
                -1.5
              ],
              "t": 1
            }
          ]
        },
        "wave": {
          "about": "A friendly wave: the right arm raised high and swung side to side over the head twice, the body leaning a little away from it, and lowered.",
          "frameMs": 70,
          "frames": 16,
          "keys": [
            {
              "armL": [
                8,
                12,
                20
              ],
              "armR": [
                10,
                12,
                25
              ],
              "feetL": [
                0.5,
                1
              ],
              "feetR": [
                0.5,
                -1
              ],
              "t": 0
            },
            {
              "armL": [
                8,
                12,
                20
              ],
              "armR": [
                155,
                55,
                25,
                150
              ],
              "feetL": [
                0.5,
                1
              ],
              "feetR": [
                0.5,
                -1
              ],
              "headPitch": -6,
              "sideBend": -5,
              "t": 0.2
            },
            {
              "armL": [
                8,
                12,
                20
              ],
              "armR": [
                155,
                22,
                35,
                150
              ],
              "feetL": [
                0.5,
                1
              ],
              "feetR": [
                0.5,
                -1
              ],
              "headPitch": -6,
              "sideBend": -5,
              "t": 0.36
            },
            {
              "armL": [
                8,
                12,
                20
              ],
              "armR": [
                155,
                55,
                25,
                150
              ],
              "feetL": [
                0.5,
                1
              ],
              "feetR": [
                0.5,
                -1
              ],
              "headPitch": -6,
              "sideBend": -5,
              "t": 0.52
            },
            {
              "armL": [
                8,
                12,
                20
              ],
              "armR": [
                155,
                22,
                35,
                150
              ],
              "feetL": [
                0.5,
                1
              ],
              "feetR": [
                0.5,
                -1
              ],
              "headPitch": -6,
              "sideBend": -5,
              "t": 0.68
            },
            {
              "armL": [
                8,
                12,
                20
              ],
              "armR": [
                155,
                55,
                25,
                150
              ],
              "feetL": [
                0.5,
                1
              ],
              "feetR": [
                0.5,
                -1
              ],
              "headPitch": -6,
              "sideBend": -5,
              "t": 0.84
            },
            {
              "armL": [
                8,
                12,
                20
              ],
              "armR": [
                10,
                12,
                25
              ],
              "feetL": [
                0.5,
                1
              ],
              "feetR": [
                0.5,
                -1
              ],
              "t": 1
            }
          ]
        }
      },
      "version": 1
    },
    "emberBodies": {
      "about": "The Ember humanoid's body as data: what is hung on the solved skeleton (rig.ts, clips.ts) for its flesh, its bones, a beast's head and fur, a dead body's wounds -- in the model language of game-common/ember_sprite/model.ts and expr.ts, like equipment.json. The engine draws a body with the `human` model (a look may name another: look.body), then the FEATURES a look adds to it (look.features: models of slot `feature` -- horns, markings; Sprite Lab's creatures bring their own); its LIBRARY is the body's own volumes, which every garment in equipment.json is an inflated copy of (upperBody, lowerBody, thighOf, shinOf, legFrame), and the paint and materials the bodies use. A model sees the posed skeleton (sk), the body's proportions (p), the look, the facing, the skin's material (skin) and the foot's half-width this facing (footWidth).",
      "features": {
        "horns": {
          "about": "A pair of horns from the top of the brow: rising out and up, then sweeping back the further they `curl` (0 straight, 1 swept right back over the skull). `length` is in heads (1 about the head's own height), `spread` how far they splay out, `thickness` their girth at the root; `color` the horn's, as #rrggbb.",
          "let": [
            [
              "a",
              "p.head[0]"
            ],
            [
              "b",
              "p.head[1]"
            ],
            [
              "c",
              "p.head[2]"
            ],
            [
              "at",
              "v => add(sk.head, apply(sk.headBasis, v))"
            ],
            [
              "m",
              "rampFrom(color)"
            ],
            [
              "N",
              "4"
            ],
            [
              "L",
              "b * 1.7 * length"
            ],
            [
              "r0",
              "max(1.5, a * 0.36) * thickness"
            ],
            [
              "horn",
              {
                "fn": [
                  "s"
                ],
                "let": [
                  [
                    "base",
                    "[s * a * 0.62, b * 0.78, c * 0.2]"
                  ],
                  [
                    "d0",
                    "normalize([s * spread, 1, 0.2])"
                  ],
                  [
                    "d1",
                    "normalize([s * spread * 1.4, -0.35, -1])"
                  ],
                  [
                    "points",
                    "range(N).reduce((list, i) => [...list, add(list[list.length - 1], scale(normalize(lerp(d0, d1, curl * (i + 0.5) / N)), L / N))], [base])"
                  ]
                ],
                "return": "taper(points.map(at), r0, max(0.7, r0 * 0.35), m, 'head')"
              }
            ]
          ],
          "params": {
            "color": "#d8c9a0",
            "curl": 0.5,
            "length": 1.4,
            "spread": 0.5,
            "thickness": 1
          },
          "parts": [
            "horn(1)",
            "horn(-1)"
          ]
        },
        "markings": {
          "about": "Markings painted on the bare skin -- what is worn over them covers them: `stripes` (bands round the body and limbs, as a tiger's), `spots`, or `scars` (pale welts across chest, arms and thighs). `color` their colour (unset: a shade darker than the skin; scars: a shade lighter), `spacing` in pixels.",
          "let": [
            [
              "lit",
              "lighting(facing)"
            ],
            [
              "m",
              "color ? rampFrom(color) : skin"
            ],
            [
              "shade",
              "n => color ? tone(m, lit(n)) : pattern === 'scars' ? tone(skin, max(0, lit(n) - 1)) : lit(n) >= 2 ? skin.line : tone(skin, lit(n) + 2)"
            ],
            [
              "across",
              "apply(sk.torsoBasis, [1, 0, 0])"
            ],
            [
              "up",
              "apply(sk.torsoBasis, [0, 1, 0])"
            ],
            [
              "ahead",
              "apply(sk.torsoBasis, [0, 0, 1])"
            ],
            [
              "mark",
              {
                "cases": [
                  [
                    "pattern === 'stripes'",
                    "((y + 1.4 * sin(x * 0.55 + z * 0.4)) / spacing % 1 + 1) % 1 < 0.34 ? shade(n) : undefined"
                  ],
                  [
                    "pattern === 'spots'",
                    "hash3(floor(x / spacing), floor(y / spacing), floor(z / spacing)) % 7 === 0 ? shade(n) : undefined"
                  ]
                ],
                "fn": [
                  "w",
                  "n"
                ],
                "let": [
                  [
                    "v",
                    "sub(w, sk.chest)"
                  ],
                  [
                    "x",
                    "dot(v, across)"
                  ],
                  [
                    "y",
                    "dot(v, up)"
                  ],
                  [
                    "z",
                    "dot(v, ahead)"
                  ]
                ],
                "return": "abs(((x * 0.8 - y) / spacing / 2.5 % 1 + 1) % 1 - 0.5) < 0.06 && hash3(floor((x + y) / 6), 3, floor(z / 4)) % 3 === 0 ? shade(n) : undefined"
              }
            ]
          ],
          "overBody": {
            "groups": [
              "head",
              "torso",
              "bust",
              "shoulder",
              "armL",
              "armR",
              "legL",
              "legR",
              "tail"
            ],
            "paint": "mark",
            "skin": true
          },
          "params": {
            "color": null,
            "pattern": "stripes",
            "spacing": 4
          },
          "parts": []
        }
      },
      "library": [
        [
          "TUNE_LEG",
          {
            "calfBack": 0.45,
            "calfDepth": 0.85,
            "calfLength": 0.28,
            "calfWidth": 1,
            "heads": [
              [
                0.3,
                0.3,
                0.9
              ],
              [
                0.36,
                -0.35,
                1
              ]
            ],
            "quadAhead": 0.3,
            "quadDepth": 0.9,
            "quadDown": 0.38,
            "quadLength": 0.4,
            "quadOut": 0.15,
            "quadWidth": 1
          },
          "An athlete's leg muscles, as shares of the leg: where the quadriceps swells the thigh (down, ahead, out, and its size) and where the calf's two heads sit behind the shin's upper third ([down, outward, size] each)."
        ],
        [
          "legFrame",
          {
            "fn": [
              "sk",
              "side",
              "a",
              "b"
            ],
            "let": [
              [
                "along",
                "normalize(sub(b, a))"
              ],
              [
                "square",
                "v => sub(v, scale(along, dot(v, along)))"
              ],
              [
                "toe",
                "square(sub(sk[side].toe, sk[side].heel))"
              ],
              [
                "ahead",
                "normalize(dot(toe, toe) > 1e-4 ? toe : square(apply(sk.pelvisBasis, [0, 0, 1])))"
              ],
              [
                "x",
                "cross(along, ahead)"
              ],
              [
                "basis",
                "[x[0], along[0], ahead[0], x[1], along[1], ahead[1], x[2], along[2], ahead[2]]"
              ],
              [
                "out",
                "scale(x, dot(x, apply(sk.pelvisBasis, [sideSign(side), 0, 0])) < 0 ? -1 : 1)"
              ]
            ],
            "return": "{ along, ahead, out, basis, length: distance(a, b) }"
          },
          "legFrame(sk, side, a, b): a frame square to a leg bone from a to b -- along it, ahead the way its foot points, out away from the other leg -- and basis (x, along, ahead) for ellipsoids laid along it, and the bone's length."
        ],
        [
          "thighOf",
          {
            "fn": [
              "sk",
              "side",
              "p",
              "by",
              "m",
              "g"
            ],
            "let": [
              [
                "j",
                "sk[side]"
              ],
              [
                "thigh",
                "segment(j.hip, j.knee, p.thighRadius + by, m, g)"
              ],
              [
                "quad",
                {
                  "fn": [],
                  "let": [
                    [
                      "f",
                      "legFrame(sk, side, j.hip, j.knee)"
                    ],
                    [
                      "L",
                      "TUNE_LEG"
                    ],
                    [
                      "at",
                      "add(lerp(j.hip, j.knee, L.quadDown), add(scale(f.ahead, p.thighRadius * L.quadAhead), scale(f.out, p.thighRadius * L.quadOut)))"
                    ]
                  ],
                  "return": "ellipsoid(at, f.basis, [p.quad * L.quadWidth + by, f.length * L.quadLength + by, p.quad * L.quadDepth + by], m, g)"
                }
              ]
            ],
            "return": "p.quad ? [thigh, quad()] : [thigh]"
          },
          "thighOf(sk, side, p, by, m, group): a thigh `by` off the skin -- one muscle-shaped segment, and on an athlete's legs (p.quad) the quadriceps swelling it in front and to the outside, fullest a third of the way down and drawn in to the knee."
        ],
        [
          "shinOf",
          {
            "fn": [
              "sk",
              "side",
              "p",
              "by",
              "m",
              "g",
              "to"
            ],
            "let": [
              [
                "j",
                "sk[side]"
              ],
              [
                "shin",
                "segment(j.knee, (to ?? 1) === 1 ? j.ankle : lerp(j.knee, j.ankle, to), p.shinRadius + by, m, g)"
              ],
              [
                "calf",
                {
                  "fn": [],
                  "let": [
                    [
                      "f",
                      "legFrame(sk, side, j.knee, j.ankle)"
                    ],
                    [
                      "L",
                      "TUNE_LEG"
                    ],
                    [
                      "back",
                      "scale(f.ahead, -p.shinRadius * L.calfBack)"
                    ]
                  ],
                  "return": "L.heads.map(h => ellipsoid(add(lerp(j.knee, j.ankle, h[0]), add(back, scale(f.out, h[1] * p.shinRadius))), f.basis, [p.calf * h[2] * L.calfWidth + by, f.length * L.calfLength + by, p.calf * h[2] * L.calfDepth + by], m, g))"
                }
              ]
            ],
            "return": "p.calf ? [shin, ...calf()] : [shin]"
          },
          "shinOf(sk, side, p, by, m, group, to?): a shin from the knee to `to` of the way to the ankle (all of it unless given), `by` off the skin -- one segment, and on an athlete's legs (p.calf) the two heads of the calf behind its upper third, the inner one fuller and lower."
        ],
        [
          "headOf",
          {
            "fn": [
              "sk",
              "p",
              "skin"
            ],
            "let": [
              [
                "a",
                "p.head[0]"
              ],
              [
                "b",
                "p.head[1]"
              ],
              [
                "c",
                "p.head[2]"
              ],
              [
                "skull",
                "ellipsoid(add(sk.head, apply(sk.headBasis, [0, p.craniumLift, 0])), sk.headBasis, p.head, skin, 'head', { exponent: p.headRoundness })"
              ],
              [
                "jaw",
                "ellipsoid(add(sk.head, apply(sk.headBasis, [0, -b * 0.5, c * 0.38])), sk.headBasis, [a * 0.9, b * 0.62, c * 0.6], skin, 'head', { exponent: [2.6, 3, 2.0] })"
              ],
              [
                "kx",
                "a / 10.05"
              ],
              [
                "ky",
                "b / 8.7"
              ],
              [
                "kz",
                "c / 9.15"
              ],
              [
                "ears",
                "[1, -1].map(s => ellipsoid(add(sk.head, apply(sk.headBasis, [s * (a - 0.5 * kx), p.earHeight, -0.8 * kz])), sk.headBasis, [1.6 * kx, 2.3 * ky, 1.5 * kz], skin, 'head'))"
              ]
            ],
            "return": "[skull, jaw, ...ears]"
          },
          "headOf(sk, p, skin): the skull -- a rounded box, flat at the sides and across the face, widest at the cheeks, as the LPC head is drawn -- the jaw forward and below it (tall and flat-fronted: in profile the face runs straight down from brow to chin), and ears standing a pixel proud at eye level. The eyes are not geometry: they are stamped on (marks.json eyeStyles)."
        ],
        [
          "upperBody",
          {
            "fn": [
              "sk",
              "p",
              "m",
              "inflateBy",
              "facingGiven"
            ],
            "let": [
              [
                "by",
                "inflateBy ?? 0"
              ],
              [
                "facing",
                "facingGiven ?? 'front'"
              ],
              [
                "chest",
                "add(sk.chest, apply(sk.torsoBasis, [0, 0, p.posture]))"
              ],
              [
                "ribs",
                "ellipsoid(chest, sk.torsoBasis, inflate(p.torso, by), m, 'torso', { exponent: p.torsoRoundness })"
              ],
              [
                "cut",
                "p.girdle.cut"
              ],
              [
                "girdle",
                "ellipsoid(add(sk.chest, apply(sk.torsoBasis, [0, p.girdle.drop - by, -0.3])), sk.torsoBasis, inflate(p.girdle.radii, by), m, 'torso', { keep: q => q[1] > cut, exponent: p.girdle.exponent })"
              ],
              [
                "sideOn",
                "facing === 'left' || facing === 'right'"
              ],
              [
                "deltoids",
                "SIDES.filter(side => !(sideOn && side === farSide(facing))).map(side => ellipsoid(add(sk[side].shoulder, apply(sk.torsoBasis, [sideSign(side) * 0.3, 0.5, 0])), sk.torsoBasis, [p.deltoidRadius + by, p.deltoidRadius + by, p.deltoidRadius + by], m, 'shoulder'))"
              ],
              [
                "pecs",
                "p.pecs ? [1, -1].map(s => ellipsoid(add(chest, apply(sk.torsoBasis, [s * p.torso[0] * 0.36, p.torso[1] * 0.22, p.torso[2] * 0.72])), sk.torsoBasis, [p.pecs * 1.25 + by, p.pecs * 0.8 + by, p.pecs * 0.62 + by], m, 'torso', { exponent: [2.4, 2.2, 2] })) : []"
              ],
              [
                "bust",
                "p.bust ? [1, -1].map(s => ellipsoid(add(chest, apply(sk.torsoBasis, [s * p.torso[0] * 0.47, -p.torso[1] * 0.2, p.torso[2] * 1.0])), sk.torsoBasis, [p.bust + by, p.bust * 0.9 + by, p.bust * 0.85 + by], m, 'bust')) : []"
              ]
            ],
            "return": "[ribs, girdle, ...deltoids, ...pecs, ...bust]"
          },
          "upperBody(sk, p, m, by?, facing?): chest, shoulder girdle and deltoids, every volume `by` off the skin (garments). The girdle is the top of a wide dome, so the line from the neck to each deltoid slopes and each deltoid caps its arm round; a garment's girdle grows out and around but not up, so a collar sits under the chin. Side-on the far deltoid is left out (it would show past the throat, where LPC leaves a notch). Pectorals (p.pecs) are wide flat slabs either side of the breastbone; a woman's bust (p.bust) sits on the chest's front below the collarbones, group `bust`, so a shirt or breastplate covers it and the raster draws the seam under it."
        ],
        [
          "lowerBody",
          {
            "fn": [
              "sk",
              "p",
              "m",
              "inflateBy",
              "keep",
              "legWear"
            ],
            "let": [
              [
                "by",
                "inflateBy ?? 0"
              ],
              [
                "hips",
                "ellipsoid(p.pelvisLow ? add(sk.pelvis, apply(sk.pelvisBasis, [0, -p.pelvisLow, 0])) : sk.pelvis, sk.pelvisBasis, inflate(p.pelvis, by), m, 'torso', { exponent: p.pelvisRoundness, keep })"
              ],
              [
                "waist",
                {
                  "fn": [],
                  "let": [
                    [
                      "lift",
                      "p.waistHeight ?? 0"
                    ],
                    [
                      "low",
                      "p.pelvisLow ?? 0"
                    ],
                    [
                      "garment",
                      "keep && (q => keep([q[0], q[1] + lift + low, q[2]]))"
                    ],
                    [
                      "waistKeep",
                      "legWear ? (q => q[1] < 0 && (!garment || garment(q))) : garment"
                    ]
                  ],
                  "return": "ellipsoid(add(sk.pelvis, apply(sk.pelvisBasis, [0, lift, 0])), sk.pelvisBasis, inflate(p.waist, by), m, 'torso', { keep: waistKeep })"
                }
              ]
            ],
            "return": "p.waist ? [hips, waist()] : [hips]"
          },
          "lowerBody(sk, p, m, by?, keep?, legWear?): the hips, and a woman's waist above them (p.waist), `by` off the skin; `keep` cuts them in the pelvis's frame (a garment's top edge), and `legWear` stops the waist at the natural waist, as trousers and skirts do, instead of riding up the ribs."
        ],
        [
          "absOf",
          {
            "fn": [
              "sk",
              "p",
              "skin",
              "facing"
            ],
            "let": [
              [
                "lit",
                "lighting(facing)"
              ],
              [
                "up",
                "apply(sk.torsoBasis, [0, 1, 0])"
              ],
              [
                "across",
                "apply(sk.torsoBasis, [1, 0, 0])"
              ],
              [
                "ahead",
                "apply(sk.torsoBasis, [0, 0, 1])"
              ],
              [
                "top",
                "p.torso[1] * 0.0"
              ],
              [
                "bottom",
                "-p.torso[1] * 0.8"
              ],
              [
                "half",
                "p.torso[0] * 0.3"
              ]
            ],
            "return": {
              "cases": [
                [
                  "dot(v, ahead) <= 0 || y > top || y < bottom || abs(x) > half",
                  "undefined"
                ]
              ],
              "fn": [
                "w",
                "n"
              ],
              "let": [
                [
                  "v",
                  "sub(w, sk.chest)"
                ],
                [
                  "x",
                  "dot(v, across)"
                ],
                [
                  "y",
                  "dot(v, up)"
                ],
                [
                  "row",
                  "(top - y) / ((top - bottom) / 3)"
                ]
              ],
              "return": "abs(x) < 0.45 || (row % 1 < 0.22 && row > 0.5) ? tone(skin, min(3, lit(n) + 1)) : undefined"
            }
          },
          "absOf(sk, p, skin, facing): paint for a muscled belly's six-pack down the front of the bare chest below the pectorals -- the line down the middle and two across, a shade darker than the skin round them."
        ],
        [
          "furred",
          {
            "fn": [
              "prims",
              "fur",
              "facing"
            ],
            "let": [
              [
                "lit",
                "lighting(facing)"
              ],
              [
                "furOn",
                {
                  "fn": [
                    "prim"
                  ],
                  "let": [
                    [
                      "before",
                      "prim.decal"
                    ],
                    [
                      "decal",
                      {
                        "cases": [
                          [
                            "own !== undefined",
                            "own"
                          ],
                          [
                            "hash3(floor(q[0] / 1.3), floor(q[1] / 2.4), floor(q[2] / 1.3)) % 5 !== 0",
                            "undefined"
                          ]
                        ],
                        "fn": [
                          "q"
                        ],
                        "let": [
                          [
                            "own",
                            "before ? before(q) : undefined"
                          ]
                        ],
                        "return": "tone(fur, min(3, lit(normalOf(prim, q)) + 1))"
                      }
                    ]
                  ],
                  "return": "{ ...prim, decal }"
                }
              ]
            ],
            "return": "prims.map(prim => prim.kind !== 'ellipsoid' ? prim : furOn(prim))"
          },
          "furred(prims, fur, facing): fur on a beast's body -- short strands a shade darker than the light gives each spot, about one in five cells, scattered over every volume; hashed in each volume's own frame, so the grain moves with the body instead of crawling over it, and paint already there (a muscled chest's abs) shows first."
        ],
        [
          "WOUND",
          "rampFrom('#8a3a34')",
          "A wound's raw rim."
        ],
        [
          "GORE",
          "rampFrom('#5a1f22')",
          "A wound's dark core."
        ],
        [
          "woundsOf",
          {
            "fn": [
              "sk",
              "p",
              "facing"
            ],
            "let": [
              [
                "lit",
                "lighting(facing)"
              ],
              [
                "T",
                "v => add(sk.chest, apply(sk.torsoBasis, v))"
              ],
              [
                "P",
                "v => add(sk.pelvis, apply(sk.pelvisBasis, v))"
              ],
              [
                "r",
                "max(1.2, p.torso[0] * 0.2)"
              ],
              [
                "wounds",
                "[[T([p.torso[0] * 0.45, p.torso[1] * 0.3, p.torso[2]]), r], [T([-p.torso[0] * 0.3, -p.torso[1] * 0.4, p.torso[2]]), r * 0.8], [T([p.torso[0] * 0.2, p.torso[1] * 0.1, -p.torso[2]]), r], [lerp(sk.R.elbow, sk.R.hand, 0.5), r * 0.75], [P([p.hipWidth, -p.thigh * 0.35, p.thighRadius * 0.8]), r * 0.8], [lerp(sk.L.knee, sk.L.ankle, 0.4), r * 0.7]]"
              ]
            ],
            "return": {
              "cases": [
                [
                  "!hit",
                  "undefined"
                ],
                [
                  "distance(w, hit[0]) < hit[1] * 0.55",
                  "tone(GORE, lit(n))"
                ]
              ],
              "fn": [
                "w",
                "n"
              ],
              "let": [
                [
                  "hit",
                  "wounds.find(x => distance(w, x[0]) < x[1])"
                ]
              ],
              "return": "tone(WOUND, lit(n))"
            }
          },
          "woundsOf(sk, p, facing): paint for a dead body torn open -- wounds at fixed places on the skeleton (the chest, the belly, the back, a forearm, a thigh, a shin), each a dark core in a raw rim, lit like the flesh round them."
        ],
        [
          "WOLF_NOSE",
          "rampFrom('#2a1f22', '#0c0809')",
          "A wolf's nose."
        ],
        [
          "WOLF_EAR",
          "rampFrom('#c98a86')",
          "The pink inside a wolf's ear."
        ],
        [
          "wolfHeadOf",
          {
            "fn": [
              "sk",
              "p",
              "fur",
              "facing"
            ],
            "let": [
              [
                "a",
                "p.head[0]"
              ],
              [
                "b",
                "p.head[1]"
              ],
              [
                "c",
                "p.head[2]"
              ],
              [
                "at",
                "v => add(sk.head, apply(sk.headBasis, v))"
              ],
              [
                "muzzle",
                "{ ...fur, light: fur.base, base: fur.shade, shade: fur.deep, deep: fur.line }"
              ],
              [
                "lit",
                "lighting(facing)"
              ],
              [
                "toHead",
                "transpose(sk.headBasis)"
              ],
              [
                "bridge",
                {
                  "fn": [
                    "w",
                    "n"
                  ],
                  "let": [
                    [
                      "q",
                      "apply(toHead, sub(w, sk.head))"
                    ],
                    [
                      "width",
                      "a * (0.22 - 0.1 * max(0, q[1] / b))"
                    ]
                  ],
                  "return": "q[2] > c * 0.3 && abs(q[0]) < width && q[1] > -b * 0.3 && q[1] < b * 0.45 ? tone(muzzle, lit(n)) : undefined"
                }
              ],
              [
                "skull",
                "painted([ellipsoid(at([0, p.craniumLift * 0.5, -c * 0.05]), sk.headBasis, [a * 0.95, b * 0.88, c * 0.95], fur, 'head', { exponent: p.headRoundness })], bridge)"
              ],
              [
                "snout",
                "[ellipsoid(at([0, -b * 0.32, c * 1.0]), sk.headBasis, [a * 0.42, b * 0.38, c * 0.8], muzzle, 'head', { exponent: [2.2, 2.6, 2] }), ellipsoid(at([0, -b * 0.62, c * 0.72]), sk.headBasis, [a * 0.36, b * 0.22, c * 0.6], muzzle, 'head'), ellipsoid(at([0, -b * 0.16, c * 1.8]), sk.headBasis, [max(0.9, a * 0.22), max(0.8, b * 0.18), 0.8], WOLF_NOSE, 'head')]"
              ],
              [
                "jowls",
                "[1, -1].map(s => ellipsoid(at([s * a * 0.7, -b * 0.4, -c * 0.1]), sk.headBasis, [a * 0.36, b * 0.48, c * 0.6], fur, 'head'))"
              ],
              [
                "ahead",
                "apply(sk.headBasis, [0, 0, 1])"
              ],
              [
                "ears",
                "painted([1, -1].map(s => segment(at([s * a * 0.5, b * 0.5, -c * 0.1]), at([s * a * 0.95, b * 1.6, -c * 0.3]), max(1.3, a * 0.34), fur, 'head')), (w, n) => (dot(n, ahead) > 0.4 ? tone(WOLF_EAR, lit(n)) : undefined))"
              ]
            ],
            "return": "[...skull, ...snout, ...jowls, ...ears]"
          },
          "wolfHeadOf(sk, p, fur, facing): a wolf's head on the man's neck, as LPC's wolfman wears one -- the skull, its muzzle a shade darker than the coat and that dark running up the bridge between the eyes, a long muzzle with a dark nose on its tip and a lower jaw under it, the jowls filling out the cheeks, and tall pointed ears standing up off the crown, pink inside. Sized off the man's own head (p.head), so the eyes still sit where his would."
        ],
        [
          "wolfFurOf",
          {
            "fn": [
              "sk",
              "p",
              "fur"
            ],
            "let": [
              [
                "leg",
                "legLength(p)"
              ],
              [
                "ruff",
                "ellipsoid(add(sk.neck, apply(sk.torsoBasis, [0, -p.neckRadius * 0.3, -p.neckRadius * 0.2])), sk.torsoBasis, [p.neckRadius * 2.0, p.neckRadius * 1.35, p.neckRadius * 1.75], fur, 'torso')"
              ],
              [
                "root",
                "add(sk.pelvis, apply(sk.pelvisBasis, [0, -p.pelvis[1] * 0.15, -p.pelvis[2] * 0.85]))"
              ],
              [
                "mid",
                "add(root, apply(sk.pelvisBasis, [0, -leg * 0.2, -leg * 0.14]))"
              ],
              [
                "tip",
                "add(root, apply(sk.pelvisBasis, [0, -leg * 0.46, -leg * 0.16]))"
              ],
              [
                "r",
                "max(1.3, p.thighRadius * 0.45)"
              ]
            ],
            "return": "[ruff, segment(root, mid, r, fur, 'tail'), segment(mid, tip, r * 1.35, fur, 'tail')]"
          },
          "wolfFurOf(sk, p, fur): the rest of a wolfman's wolf -- a thick ruff of fur round the neck, setting the head down into the shoulders as LPC draws it, and a bushy tail from the base of the spine, outlined as a part of its own."
        ],
        [
          "HOLLOW",
          "rampFrom('#3b3330')",
          "The dark of a skull's sockets and the hollow behind the ribs."
        ],
        [
          "taper",
          {
            "fn": [
              "points",
              "r0",
              "r1",
              "m",
              "g"
            ],
            "return": "range(points.length - 1).map(i => segment(points[i], points[i + 1], r0 + (r1 - r0) * i / max(1, points.length - 2), m, g))"
          },
          "taper(points, r0, r1, m, group): a limb-like chain of segments through the points, radius r0 at the first easing to r1 at the last: horns, tails, spines."
        ]
      ],
      "models": {
        "flesh": {
          "about": "The living body: head (a wolf's, with its ruff and tail, on a wolf: look.beast), neck, chest (a muscled one's abs painted on it, under any shirt), hips, and limbs as muscle-shaped volumes in the skin. Each joint ball belongs to the segment below it, so a joint gets one line, not two. A hand is a fist, or -- empty, at rest (ArmPose.open) -- hangs open: longer, the fingers down, and narrow seen from the front, the palm turned to the thigh.",
          "parts": [
            {
              "else": [
                "headOf(sk, p, skin)"
              ],
              "parts": [
                "wolfHeadOf(sk, p, skin, facing)",
                "wolfFurOf(sk, p, skin)"
              ],
              "when": "look.beast === 'wolf'"
            },
            "capsule(sk.chest, sk.neck, p.neckRadius, skin, 'torso')",
            {
              "let": [
                [
                  "chest",
                  "upperBody(sk, p, skin, 0, facing)"
                ]
              ],
              "parts": [
                "p.pecs ? [...painted(chest.slice(0, 1), absOf(sk, p, skin, facing)), ...chest.slice(1)] : chest"
              ]
            },
            "lowerBody(sk, p, skin)",
            {
              "as": "side",
              "each": "SIDES",
              "let": [
                [
                  "j",
                  "sk[side]"
                ],
                [
                  "arm",
                  "armOf(side)"
                ],
                [
                  "leg",
                  "legOf(side)"
                ]
              ],
              "parts": [
                "as(segment(j.shoulder, j.elbow, p.upperArmRadius, skin, arm), 'upperArm')",
                "as(joint(j.elbow, p.forearmRadius * 0.85, skin, arm), 'forearm')",
                "as(segment(j.elbow, j.hand, p.forearmRadius, skin, arm), 'forearm')",
                {
                  "else": [
                    "as(ellipsoid(add(j.hand, apply(sk.torsoBasis, [-sideSign(side) * p.handInset, 0, 0])), sk.torsoBasis, [p.handRadius, p.handRadius, p.handRadius], skin, arm), 'hand')"
                  ],
                  "parts": [
                    {
                      "else": [
                        "as(segment(j.hand, add(j.hand, scale(normalize(sub(j.hand, j.elbow)), p.handLength)), p.handRadius, skin, arm, 2.8), 'hand')"
                      ],
                      "parts": [
                        {
                          "let": [
                            [
                              "d",
                              "normalize(sub(j.hand, j.elbow))"
                            ],
                            [
                              "fist",
                              "p.handLength / 2 + p.handRadius * 0.45"
                            ],
                            [
                              "reach",
                              "fist * 1.4"
                            ]
                          ],
                          "parts": [
                            "as({ ...segment(j.hand, add(j.hand, scale(d, p.handLength)), p.handRadius, skin, arm, 2.8), center: add(j.hand, scale(d, p.handLength / 2 + reach - fist)), radii: [p.handRadius * 0.58, reach, p.handRadius * 0.95] }, 'hand')"
                          ]
                        }
                      ],
                      "when": "j.open"
                    }
                  ],
                  "when": "p.handLength"
                },
                "thighOf(sk, side, p, 0, skin, leg).map(prim => as(prim, 'thigh'))",
                "as(joint(j.knee, p.shinRadius * 0.9, skin, leg), 'shin')",
                "shinOf(sk, side, p, 0, skin, leg).map(prim => as(prim, 'shin'))",
                "as(joint(j.ankle, p.shinRadius * 0.7, skin, leg), 'foot')",
                "as(foot(j.heel, j.toe, p.footRadius, footWidth, skin, leg), 'foot')"
              ]
            }
          ]
        },
        "human": {
          "about": "A humanoid's body by its look: bones where the flesh would be (look.bones: the skeleton), or the living flesh -- furred on a beast (look.beast), torn open on the dead (look.wounds).",
          "parts": [
            {
              "else": [
                {
                  "paint": "look.wounds ? woundsOf(sk, p, facing) : undefined",
                  "parts": [
                    {
                      "apply": "look.beast ? (prims => furred(prims, skin, facing)) : undefined",
                      "parts": [
                        {
                          "use": "flesh"
                        }
                      ]
                    }
                  ]
                }
              ],
              "parts": [
                {
                  "use": "skeleton"
                }
              ],
              "when": "look.bones"
            }
          ]
        },
        "skeleton": {
          "about": "A skeleton on the same rig as a living body, so every clip, weapon and garment works on it: a skull with dark sockets, nose and teeth; a ribcage of bands with the hollow dark behind them, a sternum and collarbones; a spine down to a pelvic bowl; limb bones with knobbed joints; bony hands and feet. Bone is a few pixels of ivory at this size: every bone stays two or three pixels thick (forearm and shin are one bone each -- a pair is too fine to read), and the skull is drawn large, as pixel-art skeletons are, so its sockets and teeth show. In the look's bone colour (look.boneColor, palettes.json bones).",
          "let": [
            [
              "bone",
              "BONES[look.boneColor ?? 'white'] ?? BONES.white"
            ],
            [
              "a",
              "p.head[0]"
            ],
            [
              "b",
              "p.head[1]"
            ],
            [
              "c",
              "p.head[2]"
            ],
            [
              "skull",
              "add(sk.head, apply(sk.headBasis, [0, p.craniumLift + 0.9, -0.2]))"
            ],
            [
              "across",
              "apply(sk.headBasis, [1, 0, 0])"
            ],
            [
              "up",
              "apply(sk.headBasis, [0, 1, 0])"
            ],
            [
              "ahead",
              "apply(sk.headBasis, [0, 0, 1])"
            ],
            [
              "toward",
              "(x, y) => normalize(apply(sk.headBasis, [x, y - p.craniumLift - 0.9, c]))"
            ],
            [
              "profile",
              "facing === 'left' || facing === 'right'"
            ],
            [
              "eyeY",
              "p.eyeHeight + b * 0.1"
            ],
            [
              "eyeX",
              "max(a * (profile ? 0.9 : 0.5), 1.7)"
            ],
            [
              "sockets",
              "[toward(-eyeX, eyeY), toward(eyeX, eyeY)]"
            ],
            [
              "socketWide",
              "cos(atan2(max(a * (profile ? 0.42 : 0.3), profile ? 1.6 : 1.2), c))"
            ],
            [
              "nose",
              "toward(0, eyeY - max(a * 0.4, 1.5))"
            ],
            [
              "noseWide",
              "cos(atan2(max(a * 0.13, 0.6), c))"
            ],
            [
              "teeth",
              "-b * 0.52"
            ],
            [
              "holes",
              {
                "cases": [
                  [
                    "sockets.some(d => dot(from, d) > socketWide) || dot(from, nose) > noseWide",
                    "HOLLOW.deep"
                  ],
                  [
                    "dot(v, ahead) > c * 0.3 && abs(y - teeth) < max(0.55, b * 0.09) && abs(x) < a * 0.6 && ((x / 1.1) % 1 + 1) % 1 < 0.4",
                    "HOLLOW.base"
                  ]
                ],
                "fn": [
                  "w",
                  "n"
                ],
                "let": [
                  [
                    "from",
                    "normalize(sub(w, skull))"
                  ],
                  [
                    "v",
                    "sub(w, sk.head)"
                  ],
                  [
                    "x",
                    "dot(v, across)"
                  ],
                  [
                    "y",
                    "dot(v, up)"
                  ]
                ]
              }
            ]
          ],
          "parts": [
            {
              "paint": "holes",
              "parts": [
                "ellipsoid(skull, sk.headBasis, [a * 1.25, b * 1.18, c * 1.12], bone, 'head', { exponent: p.headRoundness })",
                "ellipsoid(add(sk.head, apply(sk.headBasis, [0, -b * 0.62, c * 0.38])), sk.headBasis, [a * 0.9, b * 0.48, c * 0.6], bone, 'head', { exponent: [2.4, 2.6, 2] })"
              ]
            },
            {
              "let": [
                [
                  "neckTop",
                  "add(sk.head, apply(sk.headBasis, [0, -b * 0.55, -c * 0.25]))"
                ],
                [
                  "neckBase",
                  "add(sk.chest, apply(sk.torsoBasis, [0, p.torso[1] * 0.85, -p.torso[2] * 0.3]))"
                ]
              ],
              "parts": [
                "range(3).map(i => joint(lerp(neckBase, neckTop, (i + 0.5) / 3), 1.1, bone, 'torso'))"
              ]
            },
            {
              "let": [
                [
                  "lumbarTop",
                  "add(sk.chest, apply(sk.torsoBasis, [0, -p.torso[1] * 0.55, -p.torso[2] * 0.35]))"
                ],
                [
                  "sacrum",
                  "add(sk.pelvis, apply(sk.pelvisBasis, [0, p.pelvis[1] * 0.3, -p.pelvis[2] * 0.4]))"
                ]
              ],
              "parts": [
                "range(4).map(i => ellipsoid(lerp(lumbarTop, sacrum, (i + 0.5) / 4), sk.torsoBasis, [1.4, 0.9, 1.2], bone, 'torso'))"
              ]
            },
            {
              "let": [
                [
                  "ribsAt",
                  "add(sk.chest, apply(sk.torsoBasis, [0, p.torso[1] * 0.15, p.posture]))"
                ],
                [
                  "ribRadii",
                  "[p.torso[0] * 0.82, p.torso[1] * 0.78, p.torso[2] * 0.88]"
                ],
                [
                  "period",
                  "max(1.9, p.torso[1] * 0.3)"
                ],
                [
                  "sternumTop",
                  "add(ribsAt, apply(sk.torsoBasis, [0, ribRadii[1] * 0.75, ribRadii[2] * 0.75]))"
                ]
              ],
              "parts": [
                "ellipsoid(ribsAt, sk.torsoBasis, ribRadii, bone, 'torso', { exponent: p.torsoRoundness, keep: q => q[1] > -ribRadii[1] * 0.7 && (((q[1] + ribRadii[1]) / period) % 1) < 0.55 })",
                "ellipsoid(ribsAt, sk.torsoBasis, [ribRadii[0] * 0.8, ribRadii[1] * 0.8, ribRadii[2] * 0.75], HOLLOW, 'torso', { exponent: p.torsoRoundness, keep: q => q[1] > -ribRadii[1] * 0.55 })",
                "capsule(sternumTop, add(ribsAt, apply(sk.torsoBasis, [0, -ribRadii[1] * 0.2, ribRadii[2] * 0.95])), 0.8, bone, 'torso')",
                "SIDES.map(side => capsule(sternumTop, sk[side].shoulder, 0.75, bone, 'torso'))"
              ]
            },
            "ellipsoid(add(sk.pelvis, apply(sk.pelvisBasis, [0, p.pelvis[1] * 0.15, 0])), sk.pelvisBasis, [p.pelvis[0] * 0.95, p.pelvis[1] * 0.55, p.pelvis[2] * 0.62], bone, 'torso', { exponent: [2.4, 2.2, 2.2], keep: q => q[1] < p.pelvis[1] * 0.25 })",
            {
              "as": "side",
              "each": "SIDES",
              "let": [
                [
                  "j",
                  "sk[side]"
                ],
                [
                  "arm",
                  "armOf(side)"
                ],
                [
                  "leg",
                  "legOf(side)"
                ]
              ],
              "parts": [
                "as(joint(j.shoulder, max(1.5, p.upperArmRadius * 0.62), bone, arm), 'upperArm')",
                "as(capsule(j.shoulder, j.elbow, max(1.25, p.upperArmRadius * 0.5), bone, arm), 'upperArm')",
                "as(joint(j.elbow, max(1.4, p.forearmRadius * 0.68), bone, arm), 'forearm')",
                "as(capsule(j.elbow, j.hand, max(1.1, p.forearmRadius * 0.52), bone, arm), 'forearm')",
                "as(ellipsoid(fistCenter(sk, p, side), sk.torsoBasis, [p.handRadius * 0.6, p.handRadius * 0.7, p.handRadius * 0.6], bone, arm, { exponent: 2.6 }), 'hand')",
                "as(joint(j.hip, max(1.6, p.thighRadius * 0.55), bone, leg), 'thigh')",
                "as(capsule(j.hip, j.knee, max(1.35, p.thighRadius * 0.47), bone, leg), 'thigh')",
                "as(joint(j.knee, max(1.5, p.shinRadius * 0.68), bone, leg), 'shin')",
                "as(capsule(j.knee, j.ankle, max(1.15, p.shinRadius * 0.5), bone, leg), 'shin')",
                "as(joint(j.ankle, max(0.9, p.shinRadius * 0.4), bone, leg), 'foot')",
                "as(foot(j.heel, j.toe, p.footRadius * 0.75, footWidth * 0.75, bone, leg), 'foot')"
              ]
            }
          ]
        }
      },
      "version": 1
    },
    "emberHair": {
      "about": "Hair as data. A STYLE is a few numbers -- how far it stands off the skull (`volume`: 0.3 a buzz cut, 0.9 a short cut, 3 an afro), how low the fringe comes (`fringe`: 0 high off the brow, 0.35 a short cut's, 1 bangs to the eyebrows), how long it falls (`length`: to the nape, framing the face to the jaw, or falling to the shoulder, back or waist) -- and what it has besides: `sides` shaved (a crest left on top) or faded close, a bald `crown`, something on `top` (spikes, tufts, tuft, tall-tuft, crest, tall-crest, flat, quiff, beehive), a `tie` (ponytail, high-ponytail, bun, topknot, bunches, braid), a `texture` (curls, locks, rows). A style is drawn by its model's parameters (`model`, the `shell` unless it names another) in the look's hair colour (palettes.json hair). Ember's own styles (crop, short, long, ponytail) and each of the game's LPC styles as the nearest design; a look's style the game does not know is drawn as `default`, and the `none` styles are no hair at all. Skeletons and beasts have none.",
      "default": "short",
      "models": {
        "shell": {
          "about": "Hair from a style's numbers: a shell over the skull cut to its hairline, and what falls or stands off it. Sizes are set for the LPC head (10.05 x 8.7 x 9.15) and scaled to this one's (k); features of their own keep a few pixels on a small head (s), or a realist's spikes would be specks. The cap is at least most of a pixel thick, so a small head's hair still shows past the skull; volume past a short cut's grows faster (an afro must double a small head, not pad it), and long hair has body a short cut doesn't. Volume past a pixel or so grows up and back, off the face: inflated all round, a big head of hair would stand out in front of the face and the hairline cut leave a brim over the eyes. The hairline is above the brow at the front, lower round the back and sides (a small head's long hair comes lower, or front-on it is a band over a bare crown); a full head of hair (volume 1.4 and up: an afro, a mop) comes round the head, not just over it -- a dome cut off above the ears reads as a mushroom -- and stands round the face at the sides too, the face showing through a window in it; hair to the jaw or longer comes down over the ears, framing the face.",
          "let": [
            [
              "m",
              "hairDye(color)"
            ],
            [
              "a",
              "p.head[0]"
            ],
            [
              "b",
              "p.head[1]"
            ],
            [
              "c",
              "p.head[2]"
            ],
            [
              "k",
              "b / 8.7"
            ],
            [
              "s",
              "max(k, 0.6)"
            ],
            [
              "at",
              "v => add(sk.head, apply(sk.headBasis, v))"
            ],
            [
              "long",
              "length === 'shoulder' || length === 'back' || length === 'waist'"
            ],
            [
              "full",
              "k < 1 ? max(k * 1.3, 2) : k * 1.3"
            ],
            [
              "lift",
              "min(volume, 1) * max(k, 0.7) + max(0, volume - 1) * full + (long ? max(k, 0.7) : 0)"
            ],
            [
              "extra",
              "max(0, lift - 1.2)"
            ],
            [
              "center",
              "at([0, 0.5 * k + 0.35 * extra, -0.4 * k - 0.45 * extra])"
            ],
            [
              "radii",
              "[a + lift, b + lift - 0.25 * extra, c + lift - 0.45 * extra]"
            ],
            [
              "brow",
              "p.eyeHeight + b * (0.62 - 0.4 * fringe) - (k < 1 && long ? 0.8 : 0) - 0.35 * extra"
            ],
            [
              "bushy",
              "volume >= 1.4"
            ],
            [
              "nape",
              "length === 'nape' && !bushy ? -b * 0.5 : -b * 0.9"
            ],
            [
              "sideLine",
              "length === 'jaw' || long || bushy ? -b * 0.85 : brow - 3 * k"
            ],
            [
              "atSides",
              "q => abs(q[0]) > a * 0.8 && q[1] > sideLine && (bushy || q[2] < c * 0.2)"
            ],
            [
              "hairline",
              "q => q[1] > brow || (q[2] < -c * 0.15 && q[1] > nape) || atSides(q)"
            ],
            [
              "shaved",
              "sides === 'shaved' ? (q => hairline(q) && abs(q[0]) < a * 0.38) : hairline"
            ],
            [
              "faded",
              "sides === 'faded' ? (q => shaved(q) && q[1] > b * 0.25) : shaved"
            ],
            [
              "keep",
              "crown === 'bald' ? (q => faded(q) && q[1] < b * 0.3 && q[2] < c * 0.1) : faded"
            ],
            [
              "spike",
              {
                "fn": [
                  "dir",
                  "len",
                  "r"
                ],
                "let": [
                  [
                    "out",
                    "normalize(apply(sk.headBasis, dir))"
                  ],
                  [
                    "base",
                    "add(center, scale(out, b * 0.75))"
                  ]
                ],
                "return": "segment(base, add(base, scale(out, len)), r, m, 'hair')"
              }
            ],
            [
              "up",
              "apply(sk.headBasis, [0, 1, 0])"
            ],
            [
              "across",
              "apply(sk.headBasis, [1, 0, 0])"
            ],
            [
              "ahead",
              "apply(sk.headBasis, [0, 0, 1])"
            ],
            [
              "textured",
              {
                "cases": [
                  [
                    "texture === 'curls'",
                    "hash3(floor(dot(v, across) / 1.3), floor(dot(v, up) / 1.3), floor(dot(v, ahead) / 1.3)) % 4 === 0 ? m.deep : undefined"
                  ],
                  [
                    "texture === 'rows'",
                    "((dot(v, across) / 1.6) % 1 + 1) % 1 < 0.35 && dot(v, up) > 0 ? m.deep : undefined"
                  ]
                ],
                "fn": [
                  "w"
                ],
                "let": [
                  [
                    "v",
                    "sub(w, sk.head)"
                  ]
                ],
                "return": "((atan2(dot(v, ahead), dot(v, across)) * (a + lift) / 1.8) % 1 + 1) % 1 < 0.3 ? m.deep : undefined"
              }
            ]
          ],
          "params": {
            "color": "brown",
            "crown": null,
            "fringe": 0.35,
            "length": "nape",
            "sides": null,
            "texture": null,
            "tie": null,
            "top": null,
            "volume": 0.9
          },
          "parts": [
            {
              "paint": "texture ? textured : undefined",
              "parts": [
                {
                  "parts": [
                    "ellipsoid(center, sk.headBasis, inflate(p.head, 0.3 * max(k, 0.7)), m, 'hair', { exponent: p.headRoundness, keep: q => q[1] <= b * 0.3 && ((q[2] < -c * 0.15 && q[1] > -b * 0.5) || atSides(q)) })"
                  ],
                  "when": "sides === 'faded'"
                },
                "ellipsoid(center, sk.headBasis, radii, m, 'hair', { exponent: p.headRoundness, keep })",
                {
                  "parts": [
                    {
                      "let": [
                        [
                          "reach",
                          "dot(sub(sk.head, sk.chest), apply(sk.torsoBasis, [0, 1, 0]))"
                        ],
                        [
                          "end",
                          "length === 'shoulder' ? p.shoulderHeight - 0.5 : length === 'back' ? -p.torso[1] * 0.35 : -p.spine * 0.8"
                        ],
                        [
                          "behind",
                          "p.torso[2] + 1.2"
                        ]
                      ],
                      "parts": [
                        "ellipsoid(add(sk.chest, apply(sk.torsoBasis, [0, (reach + end) / 2, -behind])), sk.torsoBasis, [a + lift, (reach - end) / 2, 1.4], m, 'hair', { exponent: [2, 3.2, 2] })",
                        "[-1, 1].map(x => capsule(at([x * a * 0.9, -b * 0.1, -c * 0.05]), add(sk.chest, apply(sk.torsoBasis, [x * (p.neckRadius + 1.6), p.shoulderHeight + 0.6, p.torso[2] * 0.15])), max(1.3, 1.4 * k) + lift * 0.3, m, 'hair'))"
                      ]
                    }
                  ],
                  "when": "long"
                },
                {
                  "parts": [
                    "[-1, 1].map(x => ellipsoid(at([x * a * 0.82, -b * 0.45, -c * 0.15]), sk.headBasis, [max(1.6 * s, 1.3) + lift * 0.5, b * 0.55, c * 0.6], m, 'hair'))"
                  ],
                  "when": "length === 'jaw'"
                },
                {
                  "parts": [
                    "[[0, 0.5], [-0.6, 0.15], [0.6, 0.15], [-0.4, -0.45], [0.4, -0.45], [0, -0.1]].map(xz => spike([xz[0], 1, xz[1]], 6.5 * s, 1.6 * s))"
                  ],
                  "when": "top === 'spikes'"
                },
                {
                  "parts": [
                    "[[-0.45, 0.3], [0.35, 0.4], [0.1, -0.35], [-0.25, -0.1]].map(xz => spike([xz[0], 1, xz[1]], 3 * s, 1.4 * s))"
                  ],
                  "when": "top === 'tufts'"
                },
                {
                  "parts": [
                    "spike([0.1, 1, 0.6], (top === 'tuft' ? 2.5 : 4.5) * s, 1.3 * s)"
                  ],
                  "when": "top === 'tuft' || top === 'tall-tuft'"
                },
                {
                  "parts": [
                    {
                      "let": [
                        [
                          "tall",
                          "top === 'crest' ? 2.4 : 4.5"
                        ]
                      ],
                      "parts": [
                        "ellipsoid(at([0, b + lift + tall * s * 0.4, -c * 0.1]), sk.headBasis, [1.3 * s, tall * s, c * 0.85], m, 'hair')"
                      ]
                    }
                  ],
                  "when": "top === 'crest' || top === 'tall-crest'"
                },
                {
                  "parts": [
                    "ellipsoid(at([0, b * 0.85 + lift, -c * 0.05]), sk.headBasis, [a * 0.88, 2.2 * s, c * 0.82], m, 'hair', { exponent: [2.6, 6, 2.6] })"
                  ],
                  "when": "top === 'flat'"
                },
                {
                  "parts": [
                    "ellipsoid(at([0, b * 0.85 + lift + 0.8 * s, c * 0.55]), sk.headBasis, [a * 0.75, 3.2 * s, 3.8 * s], m, 'hair')"
                  ],
                  "when": "top === 'quiff'"
                },
                {
                  "parts": [
                    "ellipsoid(at([0, b * 1.25 + lift, -c * 0.15]), sk.headBasis, [a * 0.8, b * 0.8, c * 0.8], m, 'hair')"
                  ],
                  "when": "top === 'beehive'"
                },
                {
                  "parts": [
                    {
                      "let": [
                        [
                          "root",
                          "at([0, 2.5 * k, -c - 0.6 * k])"
                        ]
                      ],
                      "parts": [
                        "capsule(root, add(root, apply(sk.torsoBasis, [0, -10 * k, -2.2 * k])), 1.9 * k, m, 'hair')"
                      ]
                    }
                  ],
                  "when": "tie === 'ponytail'"
                },
                {
                  "parts": [
                    {
                      "let": [
                        [
                          "root",
                          "at([0, b * 0.75, -c * 0.85])"
                        ]
                      ],
                      "parts": [
                        "capsule(root, add(root, apply(sk.torsoBasis, [0, -12 * s, -2.6 * s])), 1.8 * s, m, 'hair')"
                      ]
                    }
                  ],
                  "when": "tie === 'high-ponytail'"
                },
                {
                  "parts": [
                    "ellipsoid(at([0, b * 0.25, -c - 1.4 * s]), sk.headBasis, [2.6 * s, 2.6 * s, 2.4 * s], m, 'hair')"
                  ],
                  "when": "tie === 'bun'"
                },
                {
                  "parts": [
                    "ellipsoid(at([0, b + lift + 1.6 * s, -c * 0.25]), sk.headBasis, [2.3 * s, 2.2 * s, 2.3 * s], m, 'hair')"
                  ],
                  "when": "tie === 'topknot'"
                },
                {
                  "parts": [
                    "[-1, 1].map(x => capsule(at([x * (a + 0.4 * s), b * 0.15, -c * 0.35]), add(at([x * (a + 0.4 * s), b * 0.15, -c * 0.35]), apply(sk.headBasis, [x * 2.2 * s, -8 * s, -0.8 * s])), 1.6 * s, m, 'hair'))"
                  ],
                  "when": "tie === 'bunches'"
                },
                {
                  "parts": [
                    "range(6).map(i => ellipsoid(add(at([0, -b * 0.4, -c - 0.4 * s]), apply(sk.torsoBasis, [0, -i * 2.2 * s, -0.3 * i * s])), sk.headBasis, [1.4 * s, 1.3 * s, 1.3 * s], m, 'hair'))"
                  ],
                  "when": "tie === 'braid'"
                }
              ]
            }
          ]
        }
      },
      "none": [
        "bald",
        "none"
      ],
      "styles": {
        "afro": {
          "fringe": 0.3,
          "length": "nape",
          "texture": "curls",
          "volume": 3
        },
        "balding": {
          "crown": "bald",
          "fringe": 0,
          "length": "nape",
          "volume": 0.6
        },
        "bangs": {
          "fringe": 1,
          "length": "nape",
          "volume": 1
        },
        "bangs_bun": {
          "fringe": 1,
          "length": "nape",
          "tie": "bun",
          "volume": 1
        },
        "bangslong": {
          "fringe": 1,
          "length": "back",
          "volume": 1
        },
        "bangslong2": {
          "fringe": 1,
          "length": "waist",
          "volume": 1
        },
        "bangsshort": {
          "fringe": 0.9,
          "length": "nape",
          "volume": 0.8
        },
        "bedhead": {
          "fringe": 0.5,
          "length": "nape",
          "top": "tufts",
          "volume": 1.2
        },
        "bob": {
          "fringe": 0.7,
          "length": "jaw",
          "volume": 1
        },
        "bob_side_part": {
          "fringe": 0.5,
          "length": "jaw",
          "volume": 1
        },
        "braid": {
          "fringe": 0.35,
          "length": "nape",
          "tie": "braid",
          "volume": 0.9
        },
        "braid2": {
          "fringe": 0.35,
          "length": "nape",
          "tie": "braid",
          "volume": 0.9
        },
        "bunches": {
          "fringe": 0.6,
          "length": "nape",
          "tie": "bunches",
          "volume": 0.9
        },
        "buzzcut": {
          "fringe": 0.1,
          "length": "nape",
          "volume": 0.3
        },
        "cornrows": {
          "fringe": 0.2,
          "length": "nape",
          "texture": "rows",
          "volume": 0.4
        },
        "cowlick": {
          "fringe": 0.35,
          "length": "nape",
          "top": "tuft",
          "volume": 0.9
        },
        "cowlick_tall": {
          "fringe": 0.35,
          "length": "nape",
          "top": "tall-tuft",
          "volume": 0.9
        },
        "crop": {
          "fringe": 0,
          "length": "nape",
          "volume": 0.5
        },
        "curly_long": {
          "fringe": 0.4,
          "length": "back",
          "texture": "curls",
          "volume": 1.4
        },
        "curly_short": {
          "fringe": 0.4,
          "length": "nape",
          "texture": "curls",
          "volume": 1.4
        },
        "curtains": {
          "fringe": 0.6,
          "length": "jaw",
          "volume": 1
        },
        "curtains_long": {
          "fringe": 0.6,
          "length": "shoulder",
          "volume": 1
        },
        "dreadlocks_long": {
          "fringe": 0.5,
          "length": "back",
          "texture": "locks",
          "volume": 1.2
        },
        "dreadlocks_short": {
          "fringe": 0.5,
          "length": "jaw",
          "texture": "locks",
          "volume": 1.2
        },
        "flat_top_fade": {
          "fringe": 0.2,
          "length": "nape",
          "sides": "faded",
          "top": "flat",
          "volume": 0.9
        },
        "flat_top_straight": {
          "fringe": 0.2,
          "length": "nape",
          "top": "flat",
          "volume": 0.9
        },
        "half_up": {
          "fringe": 0.4,
          "length": "shoulder",
          "tie": "bun",
          "volume": 1
        },
        "halfmessy": {
          "fringe": 0.5,
          "length": "jaw",
          "top": "tufts",
          "volume": 1.1
        },
        "high_and_tight": {
          "fringe": 0.15,
          "length": "nape",
          "sides": "faded",
          "volume": 0.7
        },
        "high_ponytail": {
          "fringe": 0.3,
          "length": "nape",
          "tie": "high-ponytail",
          "volume": 0.9
        },
        "idol": {
          "fringe": 0.2,
          "length": "nape",
          "top": "quiff",
          "volume": 0.9
        },
        "jewfro": {
          "fringe": 0.4,
          "length": "nape",
          "texture": "curls",
          "volume": 1.9
        },
        "lob": {
          "fringe": 0.5,
          "length": "shoulder",
          "volume": 1
        },
        "long": {
          "fringe": 0.35,
          "length": "shoulder",
          "volume": 0.9
        },
        "long_band": {
          "fringe": 0.3,
          "length": "back",
          "volume": 1
        },
        "long_center_part": {
          "fringe": 0.4,
          "length": "back",
          "volume": 1
        },
        "long_messy": {
          "fringe": 0.5,
          "length": "back",
          "top": "tufts",
          "volume": 1.2
        },
        "long_messy2": {
          "fringe": 0.6,
          "length": "back",
          "top": "tufts",
          "volume": 1.2
        },
        "long_tied": {
          "fringe": 0.35,
          "length": "nape",
          "tie": "ponytail",
          "volume": 0.9
        },
        "longhawk": {
          "fringe": 0.1,
          "length": "nape",
          "sides": "shaved",
          "top": "tall-crest",
          "volume": 0.4
        },
        "longknot": {
          "fringe": 0.35,
          "length": "shoulder",
          "tie": "topknot",
          "volume": 1
        },
        "loose": {
          "fringe": 0.4,
          "length": "back",
          "volume": 1.1
        },
        "messy1": {
          "fringe": 0.5,
          "length": "nape",
          "top": "tufts",
          "volume": 1.1
        },
        "messy2": {
          "fringe": 0.6,
          "length": "nape",
          "top": "tufts",
          "volume": 1.1
        },
        "messy3": {
          "fringe": 0.5,
          "length": "jaw",
          "top": "tufts",
          "volume": 1.2
        },
        "mop": {
          "fringe": 1,
          "length": "jaw",
          "volume": 1.4
        },
        "natural": {
          "fringe": 0.3,
          "length": "nape",
          "texture": "curls",
          "volume": 2.2
        },
        "page": {
          "fringe": 1,
          "length": "jaw",
          "volume": 1
        },
        "page2": {
          "fringe": 0.9,
          "length": "jaw",
          "volume": 1
        },
        "part2": {
          "fringe": 0.4,
          "length": "nape",
          "volume": 0.9
        },
        "parted": {
          "fringe": 0.4,
          "length": "nape",
          "volume": 0.9
        },
        "pixie": {
          "fringe": 0.7,
          "length": "nape",
          "volume": 0.8
        },
        "plain": {
          "fringe": 0.35,
          "length": "nape",
          "volume": 0.9
        },
        "ponytail": {
          "fringe": 0.35,
          "length": "nape",
          "tie": "ponytail",
          "volume": 0.9
        },
        "ponytail2": {
          "fringe": 0.35,
          "length": "nape",
          "tie": "ponytail",
          "volume": 0.9
        },
        "princess": {
          "fringe": 0.4,
          "length": "back",
          "tie": "topknot",
          "volume": 1
        },
        "sara": {
          "fringe": 0.5,
          "length": "back",
          "volume": 1.1
        },
        "short": {
          "fringe": 0.35,
          "length": "nape",
          "volume": 0.9
        },
        "shorthawk": {
          "fringe": 0.1,
          "length": "nape",
          "sides": "shaved",
          "top": "crest",
          "volume": 0.4
        },
        "shortknot": {
          "fringe": 0.35,
          "length": "nape",
          "tie": "topknot",
          "volume": 0.9
        },
        "shoulderl": {
          "fringe": 0.6,
          "length": "shoulder",
          "volume": 1
        },
        "shoulderr": {
          "fringe": 0.6,
          "length": "shoulder",
          "volume": 1
        },
        "single": {
          "fringe": 0.35,
          "length": "nape",
          "tie": "braid",
          "volume": 0.9
        },
        "spiked": {
          "fringe": 0.3,
          "length": "nape",
          "top": "spikes",
          "volume": 0.8
        },
        "spiked2": {
          "fringe": 0.4,
          "length": "nape",
          "top": "spikes",
          "volume": 0.8
        },
        "spiked_beehive": {
          "fringe": 0.3,
          "length": "nape",
          "top": "beehive",
          "volume": 0.9
        },
        "spiked_liberty": {
          "fringe": 0.2,
          "length": "nape",
          "sides": "faded",
          "top": "spikes",
          "volume": 0.6
        },
        "spiked_liberty2": {
          "fringe": 0.2,
          "length": "nape",
          "sides": "faded",
          "top": "spikes",
          "volume": 0.6
        },
        "spiked_porcupine": {
          "fringe": 0.3,
          "length": "nape",
          "top": "spikes",
          "volume": 0.8
        },
        "swoop": {
          "fringe": 0.7,
          "length": "nape",
          "volume": 1
        },
        "twists_fade": {
          "fringe": 0.3,
          "length": "nape",
          "sides": "faded",
          "texture": "locks",
          "volume": 1.1
        },
        "twists_straight": {
          "fringe": 0.3,
          "length": "nape",
          "texture": "locks",
          "volume": 1.1
        },
        "unkempt": {
          "fringe": 0.6,
          "length": "jaw",
          "top": "tufts",
          "volume": 1.2
        },
        "wavy": {
          "fringe": 0.5,
          "length": "back",
          "texture": "curls",
          "volume": 1.2
        },
        "xlong": {
          "fringe": 0.4,
          "length": "waist",
          "volume": 1
        }
      },
      "version": 1
    },
    "emberHumanoids": {
      "about": "The named Ember humanoids -- what `/ember appearance <name>` puts a player into -- and which one draws each race. Each is a record: a look (what it is and wears: skin, hair, eyes, clothes, bones/beast/wounds), a build (its proportions over the rig's default, LPC's; a BUILD may extend another and scale it whole), a style (styles.json), a posture over every clip (`shamble`, a zombie's), and the smallest frame it is drawn on (a body taller than the 64px frame allows needs more room). A build's `stance` is how it stands still, per view (front/back/side): its arms as angles (pitch, abduct, flex, radians) -- hanging close past the body, elbows soft, the hands by the thighs, ready but at ease, never held out like a mannequin's -- feet out from under the hips, `crouch` (px the knees let the hips down) and `lean` (the chest forward, radians; the head stays level). Every frame of every animation is generated from it. RACES: the first rule whose race (and sex, where it names one) an entity has picks its body; a race none names keeps its LPC body.",
      "bodyColors": {
        "about": "How an entity's body colour (its appearance.bodyColor: the game's LPC body colours) recolours its Ember body. A skeleton's bone takes it as is (palettes.json bones). A living human's skin -- a look whose skin is one of `skins` -- becomes the skin `skins` names for it (a zombie's dead flesh is its own). A beast's fur becomes the skin its beast's `furs` table names (a wolf: `wolf-<colour>`). A colour none names leaves the look's own.",
        "furs": {
          "wolf": {
            "black": "wolf-black",
            "brown": "wolf-brown",
            "gray": "wolf-gray",
            "white": "wolf-white"
          }
        },
        "skins": {
          "black": "black",
          "brown": "brown",
          "dark": "black",
          "light": "light",
          "olive": "olive",
          "tan": "olive",
          "white": "light"
        }
      },
      "builds": {
        "human-man": {
          "about": "The human man every human man is drawn as: a barbarian's build, some 8% taller than the slim man (about 59px) and far heavier -- broad shoulders under big deltoids and a heavy trapezius, a deep wide chest with slab pectorals tapering to a narrower waist, thick neck, arms, thighs and calves -- the head a touch smaller for the size; feet set wide under the weight.",
          "extends": "slim-man",
          "proportions": {
            "ankleHeight": 2.35,
            "deltoidRadius": 3.4,
            "eyeSpacing": 1.6,
            "footLength": 5.1,
            "footProfileWidth": 1.75,
            "footRadius": 1.5,
            "footWidth": 2.6,
            "forearm": 8.8,
            "forearmRadius": 2.85,
            "girdle": {
              "cut": 0,
              "drop": 1.4,
              "radii": [
                9.8,
                7.2,
                3.9
              ]
            },
            "handLength": 1.1,
            "handRadius": 3,
            "head": [
              3.75,
              3.7,
              3.65
            ],
            "headCenter": 5.1,
            "hipDrop": 1.9,
            "hipWidth": 3.1,
            "neck": 8.7,
            "neckRadius": 3.1,
            "pecs": 2.6,
            "pelvis": [
              5.2,
              4.7,
              4
            ],
            "shin": 14.85,
            "shinRadius": 3,
            "shoulderHeight": 2.6,
            "shoulderWidth": 7.8,
            "spine": 8.1,
            "stance": {
              "back": {
                "abduct": 0.089,
                "crouch": 0.6,
                "feetOut": 2.55,
                "flex": 0.967,
                "lean": 0.05,
                "pitch": -0.2
              },
              "front": {
                "abduct": 0.089,
                "crouch": 0.6,
                "feetOut": 2.55,
                "flex": 0.967,
                "lean": 0.05,
                "pitch": -0.2
              },
              "side": {
                "abduct": -0.053,
                "crouch": 0.6,
                "feetOut": 0.4,
                "feetSplit": 1.2,
                "flex": 0.946,
                "lean": 0.05,
                "pitch": -0.164
              }
            },
            "thigh": 14.85,
            "thighRadius": 3.9,
            "torso": [
              7.6,
              6.9,
              5.2
            ],
            "upperArm": 11.4,
            "upperArmRadius": 3.4
          }
        },
        "realist-woman": {
          "about": "The woman as drawn: 8% larger than her build (about 55px), the slim man's height, so she stands about his height beside the heavier human man. Scaled whole: every length and girth, not roundness, cloth or stance angles.",
          "extends": "woman",
          "scale": 1.08
        },
        "slim-man": {
          "about": "A slim adult man, drawn about 55px tall: the Ember Lord's.",
          "proportions": {
            "ankleHeight": 2.2,
            "clothThickness": 0.5,
            "craniumLift": 0.45,
            "deltoidRadius": 2.5,
            "earHeight": -0.7,
            "eyeHeight": 0.8,
            "eyeSpacing": 1.55,
            "footLength": 4.73,
            "footProfileWidth": 1.54,
            "footRadius": 1.32,
            "footWidth": 2.2,
            "forearm": 8.14,
            "forearmRadius": 2.1,
            "girdle": {
              "cut": 0,
              "drop": 1.6,
              "radii": [
                7.8,
                6.2,
                3.2
              ]
            },
            "handInset": 0,
            "handLength": 1,
            "handRadius": 2.6,
            "head": [
              3.65,
              3.6,
              3.55
            ],
            "headCenter": 4.9,
            "headRoundness": [
              2.2,
              2.3,
              2.1
            ],
            "hipDrop": 1.76,
            "hipWidth": 2.5,
            "neck": 8.14,
            "neckRadius": 2.4,
            "pelvis": [
              4.7,
              4.4,
              3.6
            ],
            "pelvisRoundness": [
              2.4,
              2,
              2
            ],
            "posture": 0.33,
            "profileEyeInset": 0.9,
            "shin": 13.75,
            "shinRadius": 2.4,
            "shoulderHeight": 2.7,
            "shoulderWidth": 6.2,
            "spine": 7.5,
            "stance": {
              "back": {
                "abduct": 0.083,
                "crouch": 0.6,
                "feetOut": 2.21,
                "flex": 0.964,
                "lean": 0.05,
                "pitch": -0.19
              },
              "front": {
                "abduct": 0.083,
                "crouch": 0.6,
                "feetOut": 2.21,
                "flex": 0.964,
                "lean": 0.05,
                "pitch": -0.19
              },
              "side": {
                "abduct": -0.049,
                "crouch": 0.6,
                "feetOut": 0.33,
                "feetSplit": 1.1,
                "flex": 0.941,
                "lean": 0.05,
                "pitch": -0.155
              }
            },
            "thigh": 13.75,
            "thighRadius": 3,
            "torso": [
              6.2,
              6,
              4.4
            ],
            "torsoRoundness": [
              2.2,
              2,
              2
            ],
            "upperArm": 10.56,
            "upperArmRadius": 2.5
          }
        },
        "wolfman": {
          "about": "The human man's rig and build -- every bone the same length -- under a wolf's head half again a man's (the wolf head is sized off `head`; the eyes follow it).",
          "extends": "human-man",
          "proportions": {
            "eyeHeight": 1.1,
            "eyeSpacing": 2.3,
            "head": [
              5.64,
              5.52,
              5.52
            ],
            "profileEyeInset": 1.3
          }
        },
        "woman": {
          "about": "A real adult woman's build beside the slim man's: about 92% of his height, narrower in the shoulders and ribcage; an hourglass -- a slim ribcage, a pelvis wider than it set low so it is widest at the hip joints and tapers up into the waist (tall and set low: its top at the waist turns down steeply, so the light doesn't catch a shelf there that reads as a belly), thighs set wide so the hips flare below the waist; slimmer arms, neck, hands and feet, and a bust. The same rig and clips: she walks, fights and dresses as he does.",
          "extends": "slim-man",
          "proportions": {
            "ankleHeight": 2,
            "bust": 2.55,
            "calf": 2,
            "deltoidRadius": 1.9,
            "eyeSpacing": 1.45,
            "footLength": 4.2,
            "footProfileWidth": 1.35,
            "footRadius": 1.15,
            "footWidth": 1.9,
            "forearm": 7.5,
            "forearmRadius": 1.6,
            "girdle": {
              "cut": 0,
              "drop": 1.5,
              "radii": [
                6.2,
                5.2,
                2.7
              ]
            },
            "handLength": 0.9,
            "handRadius": 2.1,
            "head": [
              3.45,
              3.45,
              3.4
            ],
            "headCenter": 4.6,
            "hipDrop": 1.7,
            "hipWidth": 3.2,
            "neck": 7.5,
            "neckRadius": 1.9,
            "pelvis": [
              5.6,
              5.1,
              3.8
            ],
            "pelvisLow": 2.1,
            "pelvisRoundness": [
              2.1,
              2,
              2
            ],
            "quad": 2.6,
            "shin": 12.65,
            "shinRadius": 1.75,
            "shoulderHeight": 2.4,
            "shoulderWidth": 5.1,
            "spine": 6.9,
            "stance": {
              "back": {
                "abduct": 0.175,
                "crouch": 0.56,
                "feetOut": 1.7,
                "flex": 0.925,
                "lean": 0.05,
                "pitch": -0.174
              },
              "front": {
                "abduct": 0.175,
                "crouch": 0.56,
                "feetOut": 1.7,
                "flex": 0.925,
                "lean": 0.05,
                "pitch": -0.174
              },
              "side": {
                "abduct": 0.063,
                "crouch": 0.56,
                "feetOut": 0.3,
                "feetSplit": 1,
                "flex": 0.947,
                "lean": 0.05,
                "pitch": -0.156
              }
            },
            "thigh": 12.65,
            "thighRadius": 2.85,
            "torso": [
              4.7,
              5.3,
              3.8
            ],
            "upperArm": 9.7,
            "upperArmRadius": 1.9,
            "waist": [
              3.3,
              2.7,
              2.9
            ],
            "waistHeight": 2.4
          }
        }
      },
      "humanoids": [
        {
          "about": "Ember's own man: a real adult's proportions -- about seven heads tall, elbows at the waist, wrists at the crotch, fingertips at mid-thigh -- with a barbarian's build, in Ember's own style, at LPC's camera. Bare, for judging the body; `realist-dressed` is him in clothes. Every human man is drawn as him (clothes, hair and skin come from the entity).",
          "build": "human-man",
          "frame": 80,
          "look": {
            "skin": "light"
          },
          "name": "realist",
          "style": "realist"
        },
        {
          "about": "The slim man, bare: the realist man as first drawn. The Ember Lord is one.",
          "build": "slim-man",
          "look": {
            "skin": "light"
          },
          "name": "male-slim",
          "style": "realist"
        },
        {
          "about": "The slim man dressed.",
          "build": "slim-man",
          "look": {
            "belt": {
              "dye": "black"
            },
            "hair": {
              "color": "brown",
              "style": "short"
            },
            "pants": {
              "dye": "brown"
            },
            "shirt": {
              "dye": "teal",
              "sleeves": "long"
            },
            "shoes": {
              "cut": "boots",
              "dye": "leather"
            },
            "skin": "light"
          },
          "name": "male-slim-dressed",
          "style": "realist"
        },
        {
          "about": "The realist woman, bare: every human woman is drawn as her (clothes, hair and skin come from the entity).",
          "build": "realist-woman",
          "look": {
            "eyes": "lash",
            "skin": "light"
          },
          "name": "realist-female",
          "style": "realist"
        },
        {
          "about": "The realist woman dressed.",
          "build": "realist-woman",
          "look": {
            "belt": {
              "dye": "black"
            },
            "eyes": "lash",
            "hair": {
              "color": "chestnut",
              "style": "long"
            },
            "pants": {
              "cut": "skirt",
              "dye": "brown"
            },
            "shirt": {
              "dye": "maroon",
              "neck": "scoop",
              "puffed": true,
              "sleeves": "short"
            },
            "shoes": {
              "dye": "leather"
            },
            "skin": "light"
          },
          "name": "realist-female-dressed",
          "style": "realist"
        },
        {
          "about": "The human man's skeleton: the same rig and proportions, bone where the flesh was, so it walks, fights and wears equipment as he does.",
          "build": "human-man",
          "frame": 80,
          "look": {
            "bones": true,
            "skin": "light"
          },
          "name": "skeleton",
          "style": "realist"
        },
        {
          "about": "The human man dead and risen: grey-green flesh torn open, sunken eyes, ragged shorts, the shamble -- hunched, arms reaching -- over his own walk, run and strike.",
          "build": "human-man",
          "frame": 80,
          "look": {
            "eyes": "zombie",
            "pants": {
              "cut": "shorts",
              "dye": "brown"
            },
            "skin": "zombie",
            "wounds": true
          },
          "name": "zombie",
          "posture": "shamble",
          "style": "realist"
        },
        {
          "about": "LPC's wolfman on the human man's rig and build: a wolf's head and fur (the game's wolf colours), a ruff and a tail; he walks, fights and dresses as the man does.",
          "build": "wolfman",
          "frame": 80,
          "look": {
            "beast": "wolf",
            "eyes": "wolf",
            "skin": "wolf-brown"
          },
          "name": "wolfman",
          "style": "realist"
        },
        {
          "about": "The human man dressed.",
          "build": "human-man",
          "frame": 80,
          "look": {
            "belt": {
              "dye": "black"
            },
            "hair": {
              "color": "brown",
              "style": "short"
            },
            "pants": {
              "dye": "brown"
            },
            "shirt": {
              "dye": "teal",
              "sleeves": "long"
            },
            "shoes": {
              "cut": "boots",
              "dye": "leather"
            },
            "skin": "light"
          },
          "name": "realist-dressed",
          "style": "realist"
        },
        {
          "about": "An LPC-style man, dressed for the road.",
          "look": {
            "belt": {
              "dye": "leather"
            },
            "hair": {
              "color": "brown",
              "style": "short"
            },
            "pants": {
              "dye": "brown"
            },
            "shirt": {
              "dye": "green",
              "sleeves": "short"
            },
            "shoes": {
              "cut": "boots",
              "dye": "leather"
            },
            "skin": "light"
          },
          "name": "wanderer"
        },
        {
          "about": "An LPC-style warden: broad in the shoulders and chest.",
          "look": {
            "belt": {
              "dye": "ochre"
            },
            "hair": {
              "color": "black",
              "style": "crop"
            },
            "pants": {
              "dye": "charcoal"
            },
            "shirt": {
              "dye": "maroon",
              "sleeves": "long",
              "tunic": true
            },
            "shoes": {
              "cut": "boots",
              "dye": "black"
            },
            "skin": "brown"
          },
          "name": "warden",
          "proportions": {
            "shoulderWidth": 10.2,
            "torso": [
              8.6,
              6.8,
              8.6
            ]
          }
        },
        {
          "about": "An LPC-style forager.",
          "look": {
            "hair": {
              "color": "blonde",
              "style": "long"
            },
            "pants": {
              "dye": "tan"
            },
            "shirt": {
              "dye": "blue",
              "sleeves": "long"
            },
            "shoes": {
              "dye": "brown"
            },
            "skin": "olive"
          },
          "name": "forager",
          "proportions": {
            "hipWidth": 4.4,
            "shoulderWidth": 9,
            "torso": [
              7.6,
              6.4,
              7.7
            ]
          }
        },
        {
          "about": "An LPC-style runner.",
          "look": {
            "hair": {
              "color": "red",
              "style": "ponytail"
            },
            "pants": {
              "cut": "shorts",
              "dye": "navy"
            },
            "shirt": {
              "dye": "white",
              "sleeves": "none"
            },
            "shoes": {
              "dye": "gray"
            },
            "skin": "black"
          },
          "name": "runner"
        }
      ],
      "races": [
        {
          "body": "skeleton",
          "race": "skeleton"
        },
        {
          "body": "zombie",
          "race": "zombie"
        },
        {
          "body": "wolfman",
          "race": "wolfman"
        },
        {
          "body": "realist-female",
          "race": "human",
          "sex": "female"
        },
        {
          "body": "realist",
          "race": "human"
        }
      ],
      "version": 1
    },
    "emberMarks": {
      "about": "Anatomy and faces as LPC paints them: pixel patterns stamped onto the render, pinned to the skeleton so they move with the pose. An eye is a few pixels and a muscle a few more: rendered from geometry they come out a different few pixels every frame, so they are painted on. Rows are characters: a letter names a colour (markLetters / eyeLetters, or a style's own colours), \".\" leaves the render alone.",
      "defaultEyes": "ember",
      "eyeLetters": {
        "#": "skin.outline",
        "a": "eye.ember",
        "about": "Colours eyes paint unless the eye style names its own: `skin.<step>` the face's skin ramp, `eye.<name>` palettes.json eye colours.",
        "c": "eye.glint",
        "g": "eye.wolf",
        "n": "skin.line",
        "w": "eye.white"
      },
      "eyePlacement": {
        "about": "Where the skeleton puts the eyes and when they show: both from the front once the head's forward is turned more than frontTurn toward the camera; the near eye alone in profile once it is turned more than profileTurn sideways; none from behind. They sit at the head's eyeSpacing and eyeHeight, faceDepth of its depth forward of its centre (in profile, set back by profileEyeInset and out toward the near cheek, cheek of its width). The head's actual turn, not the facing name, picks the pattern.",
        "cheek": 0.8,
        "faceDepth": 0.97,
        "frontTurn": 0.5,
        "profileTurn": 0.6
      },
      "eyeStyles": {
        "dot": {
          "about": "A head drawn at real proportions is a few pixels across: each eye is one dark pixel.",
          "center": {
            "x": 0.5,
            "y": 0.5
          },
          "colors": {
            "e": "eye.warmPupil",
            "i": "eye.warmPupil",
            "p": "eye.warmPupil"
          },
          "front": [
            [
              "e"
            ],
            [
              "e"
            ]
          ],
          "profile": [
            "e"
          ]
        },
        "ember": {
          "about": "Ember's own: a tall near-black eye with the fire's amber catch-light and a short brow slanted outward. No white and no cool glint, which is what makes an LPC eye read as LPC.",
          "center": {
            "x": 2,
            "y": 2
          },
          "colors": {
            "e": "eye.warmPupil",
            "i": "eye.warmPupil",
            "p": "eye.warmPupil"
          },
          "front": [
            [
              "nn..",
              ".ae.",
              ".ee.",
              ".ee."
            ],
            [
              "..nn",
              ".ae.",
              ".ee.",
              ".ee."
            ]
          ],
          "profile": [
            "nn..",
            "ae..",
            "ee..",
            "ee.."
          ]
        },
        "lash": {
          "about": "The realist's dot eye with a lash at its outer corner: a woman's face at this size.",
          "center": {
            "x": 1.5,
            "y": 1.5
          },
          "colors": {
            "e": "eye.warmPupil",
            "i": "eye.warmPupil",
            "p": "eye.warmPupil"
          },
          "front": [
            [
              "#..",
              ".e."
            ],
            [
              "..#",
              ".e."
            ]
          ],
          "profile": [
            "#..",
            ".e."
          ]
        },
        "lpc": {
          "about": "LPC's own eye, read off body/male/human/light.png: a brow, lashes, a cool glint at the corners, white, iris and pupil.",
          "center": {
            "x": 2,
            "y": 2.5
          },
          "colors": {
            "e": "eye.pupil",
            "i": "eye.iris",
            "p": "eye.pupil"
          },
          "front": [
            [
              ".nn.",
              "c##c",
              "w#iw",
              ".ppw"
            ],
            [
              ".nn.",
              "c##c",
              "wi#w",
              "wpp."
            ]
          ],
          "profile": [
            ".nn.",
            "##cc",
            "i#ww",
            "ppw."
          ]
        },
        "wolf": {
          "about": "A wolfman's: LPC's pale cyan glow, a pixel each, set in the dark of the fur.",
          "center": {
            "x": 0.5,
            "y": 0.5
          },
          "colors": {
            "e": "eye.wolf",
            "i": "eye.wolf",
            "p": "eye.wolf"
          },
          "front": [
            [
              "g"
            ],
            [
              "g"
            ]
          ],
          "profile": [
            "g"
          ]
        },
        "zombie": {
          "about": "A dead eye: sunk dark in its socket, a milky glint where a living one has its pupil.",
          "center": {
            "x": 1,
            "y": 0.5
          },
          "colors": {
            "e": "eye.warmPupil",
            "i": "eye.warmPupil",
            "p": "eye.warmPupil"
          },
          "front": [
            [
              "ew"
            ],
            [
              "we"
            ]
          ],
          "profile": [
            "we"
          ]
        }
      },
      "markLetters": {
        "B": "base",
        "D": "deep",
        "L": "light",
        "S": "shade",
        "about": "Muscle marks paint the skin's own ramp.",
        "n": "line"
      },
      "markSets": {
        "lpc-male": {
          "about": "LPC's muscle marks, read off the LPC male body (tools ember-markgen): collarbones, a lit deltoid cap, abdominals, a fist's knuckles, a knee -- modelled as bumps these melt into lumps at this size, and shading alone puts a highlight wherever the light falls rather than one per muscle. A mark's `at` is where LPC paints it (its top-left pixel) in the standing frame of its facing; its offset from the joint it is `on` is measured in Ember's standing pose at the default (LPC) proportions, so standing still it lands on LPC's pixel and any other pose carries it along with the joint -- which is why a style draws these only on the LPC-fitted body. It paints only bare skin of the parts round that joint (a shirt or an arm in front hides it), and is left off when the limb has swung more than `swungLimit` degrees from where it hung, or the torso turned more than `turnedLimit` from its standing turn (a pattern does not rotate). Front and back marks are written for the limb on the screen's left (`side: screenLeft`) and mirrored onto the other (mirrorSides); a facing in mirrorFacings is another's marks mirrored. Side-on, `near` and `far` are the limbs nearer and farther from the camera. Diagonal facings have none: they are shaded from the volumes alone.",
          "facings": {
            "back": [
              {
                "about": "The crown, lit, its outline softened at the corners.",
                "at": [
                  25,
                  16
                ],
                "on": "head",
                "rows": [
                  "..nSSBBBSSSn..",
                  "nSBBBBBBBBSSSn",
                  "SBBBBBBBBBBSSS"
                ]
              },
              {
                "about": "The ear.",
                "at": [
                  22,
                  24
                ],
                "on": "head",
                "rows": [
                  "nSBB",
                  "nDBB",
                  "SDSB",
                  "BSSB",
                  "SBSS"
                ],
                "side": "screenLeft"
              },
              {
                "about": "The nape in the head's shadow, down over the trapezius.",
                "at": [
                  24,
                  29
                ],
                "on": "neck",
                "rows": [
                  "DSSSBBBBBBSSSSSD",
                  "nSSSSSSSSSSSSSSn",
                  ".DSSSSSSSSSSSSD.",
                  ".nDSSSSSSSSSSDn.",
                  "DDnnSSSSSSSSnnSD",
                  "BBSSSSSSSSSSSSBB",
                  "BBBSSSSSSSSSSBBB",
                  "BBBBBSSSSSSBBBBB",
                  "BBBBBBBBBBBBBBBB"
                ]
              },
              {
                "about": "The deltoid, lit on its cap.",
                "at": [
                  20,
                  33
                ],
                "on": "shoulder",
                "rows": [
                  ".nSSD",
                  "nLLLB",
                  "BLLBB",
                  "BBBBB",
                  "SBBBB"
                ],
                "side": "screenLeft"
              },
              {
                "about": "The shoulder blades.",
                "at": [
                  23,
                  38
                ],
                "on": "chest",
                "rows": [
                  "..................",
                  "DS..............SD",
                  ".DS...S....S...SD.",
                  ".nDS..S....S..SDn."
                ]
              },
              {
                "about": "The back of the arm, where it leaves the shoulder blade.",
                "at": [
                  18,
                  38
                ],
                "on": "shoulder",
                "rows": [
                  ".SSDD",
                  "nSSSn",
                  "D.SD.",
                  "S.Sn."
                ],
                "side": "screenLeft"
              },
              {
                "about": "The lower back: the spine's valley between muscles in shade.",
                "at": [
                  24,
                  42
                ],
                "on": "pelvis",
                "rows": [
                  ".DDDSS....SSDDD.",
                  ".DSSSS....SSSSDn",
                  "nSSSSS....SSSSSn",
                  "nSSSS......SSSSn",
                  "DSDSS......SSDSD"
                ]
              },
              {
                "about": "The seat.",
                "at": [
                  23,
                  47
                ],
                "on": "pelvis",
                "rows": [
                  ".SSDSS......SSDSS.",
                  "...SnSS....SSnS...",
                  "D...DnDDSSDDnD...D",
                  "D...Sn......nS...D"
                ]
              },
              {
                "about": "The forearm, lit along its outer edge.",
                "at": [
                  18,
                  40
                ],
                "on": "elbow",
                "rows": [
                  "DBSD",
                  "SBSn",
                  "LLS.",
                  "BLD."
                ],
                "side": "screenLeft"
              },
              {
                "about": "The back of the hand.",
                "at": [
                  18,
                  44
                ],
                "on": "hand",
                "rows": [
                  "SBBS.",
                  "SLBBn",
                  "DBBBS",
                  "nBBBB",
                  ".DBSS"
                ],
                "side": "screenLeft"
              },
              {
                "about": "The calf, dark, its outline lined.",
                "at": [
                  21,
                  51
                ],
                "on": "knee",
                "rows": [
                  "..D..SD",
                  "..nSSSn",
                  "..nDDS.",
                  ".nnDDD.",
                  "nnDSSS.",
                  "nnS..S."
                ],
                "side": "screenLeft"
              },
              {
                "about": "The heel, lit.",
                "at": [
                  21,
                  57
                ],
                "on": "ankle",
                "rows": [
                  "DDLLBD.",
                  "DSLLBD.",
                  ".nSBDn."
                ],
                "side": "screenLeft"
              }
            ],
            "front": [
              {
                "about": "The crown, lit, its outline softened at the corners.",
                "at": [
                  25,
                  16
                ],
                "on": "head",
                "rows": [
                  "..nDSBBBSSDn..",
                  "nSBBBBBBBBSSDn",
                  "SBBBBBBBBBBBSS"
                ]
              },
              {
                "about": "The ear.",
                "at": [
                  22,
                  26
                ],
                "on": "head",
                "rows": [
                  "nDSB",
                  "BDSS",
                  "BDSS",
                  "BBDS",
                  ".BDS"
                ],
                "side": "screenLeft"
              },
              {
                "about": "Collarbones meeting at the sternum, the upper chest shaded under them.",
                "at": [
                  25,
                  33
                ],
                "on": "chest",
                "rows": [
                  "nSBBBBBBBBBBSn",
                  "SnnSBBBBBBSnnS",
                  "BSSnnnnnnnnSSB",
                  "BBSSSSSSSSSSBB",
                  "BBBSSSSSSSSBBB"
                ]
              },
              {
                "about": "The deltoid, lit on its cap.",
                "at": [
                  20,
                  33
                ],
                "on": "shoulder",
                "rows": [
                  ".nSSD",
                  "nLLLB",
                  "SLLLB",
                  "BLLBB",
                  "BBBBB"
                ],
                "side": "screenLeft"
              },
              {
                "about": "The armpit crease where the arm leaves the chest.",
                "at": [
                  19,
                  38
                ],
                "on": "shoulder",
                "rows": [
                  "DSSDSS.",
                  "SSDnDS.",
                  "SSSnnSS"
                ],
                "side": "screenLeft"
              },
              {
                "about": "The lower ribs: pecs lit along their bottom edge, flanks in shade.",
                "at": [
                  24,
                  41
                ],
                "on": "chest",
                "rows": [
                  "DSBLBBBBBBBBLBSD",
                  "nDSBLLBBBBLLBSDn",
                  ".DDDSBBBBBBSDDD."
                ]
              },
              {
                "about": "The abdomen: two pairs of lit blocks.",
                "at": [
                  25,
                  44
                ],
                "on": "pelvis",
                "rows": [
                  "SSSBBLLLLBBSSS",
                  "SSSBLLBBLLBSSS",
                  "SSSSBBBBBBSSSS"
                ]
              },
              {
                "about": "The lower belly in shade, the lines of the hips running in to the groin.",
                "at": [
                  24,
                  47
                ],
                "on": "pelvis",
                "rows": [
                  "SSDSSS....SSSDSS",
                  "SSDDSSSSSSSSDDSS",
                  "..SDnDSSSSDnDS..",
                  "...SSn....nSS..."
                ]
              },
              {
                "about": "The forearm, lit along its outer edge.",
                "at": [
                  18,
                  41
                ],
                "on": "elbow",
                "rows": [
                  "LBSD",
                  "LBS.",
                  "LLS.",
                  "BBD."
                ],
                "side": "screenLeft"
              },
              {
                "about": "The fist: knuckles lit, fingers lined.",
                "at": [
                  18,
                  45
                ],
                "on": "hand",
                "rows": [
                  "SBBS.",
                  "SLBBB",
                  "DBBnB",
                  "nBBnn",
                  ".DBSS"
                ],
                "side": "screenLeft"
              },
              {
                "about": "The knee: a stroke inside above it, the calf's outline below.",
                "at": [
                  23,
                  50
                ],
                "on": "knee",
                "rows": [
                  "D.....",
                  "D....n",
                  "D...D.",
                  "D...n.",
                  "nD....",
                  "n..D..",
                  "....n."
                ],
                "side": "screenLeft"
              },
              {
                "about": "The toes.",
                "at": [
                  21,
                  57
                ],
                "on": "ankle",
                "rows": [
                  ".SBBBSD",
                  "DBBBBBS",
                  "BBBBBBS",
                  "SBLDLL."
                ],
                "side": "screenLeft"
              }
            ],
            "left": [
              {
                "about": "The crown, lit, its outline softened at the corners.",
                "at": [
                  26,
                  16
                ],
                "on": "head",
                "rows": [
                  "..nDSBBBSDn...",
                  "nDBBBBBBBBSDn.",
                  "SBBBBBBBBBBSSn"
                ]
              },
              {
                "about": "The ear, and the angle of the jaw below it.",
                "at": [
                  34,
                  26
                ],
                "on": "head",
                "rows": [
                  "BBDDDBS",
                  "BSDBDSD",
                  "SSBBDSD",
                  "SBBBDD.",
                  "SSBDn..",
                  "SSnn..."
                ]
              },
              {
                "about": "The face, lit to its edge: a profile is not rimmed in shade like the back of the head.",
                "at": [
                  24,
                  19
                ],
                "on": "head",
                "rows": [
                  ".SBB.",
                  "nBBB.",
                  "DBBB.",
                  "SBBBB",
                  "BBBBB",
                  "BBBBB",
                  "BBBBB",
                  "BBBBB",
                  "BBBBB",
                  "SBBBS",
                  ".BBB.",
                  ".BBB.",
                  ".BBB.",
                  ".SBBB"
                ]
              },
              {
                "about": "Under the jaw: the chin's underside, the jaw's angle, a line and a band of shade on the chest below.",
                "at": [
                  25,
                  32
                ],
                "on": "neck",
                "rows": [
                  "SBBBBBBBBBSD",
                  ".DBBBBBBBSDn",
                  "..nSBBBBSDnn",
                  "nnnnnnnnnnSB",
                  "DDDSSSSSSBBB",
                  "SSSSSSSSBBBB"
                ]
              },
              {
                "about": "The near deltoid, lit on its cap.",
                "at": [
                  35,
                  33
                ],
                "on": "shoulder",
                "rows": [
                  "Dnn....",
                  "nnSSn..",
                  "SBLLLn.",
                  "BBLLLS.",
                  "BBBLLBn"
                ],
                "side": "near"
              },
              {
                "about": "The near arm, lit down its front.",
                "at": [
                  36,
                  39
                ],
                "on": "elbow",
                "rows": [
                  "SS....",
                  "DDS...",
                  "S.D...",
                  "S..L..",
                  "D..L.S",
                  "D.D..D",
                  ".DD..."
                ],
                "side": "near"
              },
              {
                "about": "The near hand.",
                "at": [
                  36,
                  46
                ],
                "on": "hand",
                "rows": [
                  "S....",
                  "n..LD",
                  "n...D",
                  "...D."
                ],
                "side": "near"
              },
              {
                "about": "Chest and belly: the pec lit along its bottom, the stomach below.",
                "at": [
                  25,
                  40
                ],
                "on": "chest",
                "rows": [
                  "SBBBBBBBBBB",
                  "SBBBBBLLBBB",
                  "nBBBLLLBBSS",
                  ".SBBSSDDSSD",
                  ".DLLBBBSSSD",
                  ".nBBLLBSSSD"
                ]
              },
              {
                "about": "The lower belly and the groin.",
                "at": [
                  26,
                  46
                ],
                "on": "pelvis",
                "rows": [
                  "n.....SSD.",
                  "nS...SSSD.",
                  "DSSSSSSSS.",
                  "SSDnnDSSS.",
                  "SSDD.nS..n"
                ]
              },
              {
                "about": "The near knee.",
                "at": [
                  31,
                  50
                ],
                "on": "knee",
                "rows": [
                  "nS..n..",
                  ".S..SSn",
                  ".n...Sn",
                  "..D...D",
                  "..nS.SD",
                  "...nSSS"
                ],
                "side": "near"
              },
              {
                "about": "The far knee.",
                "at": [
                  26,
                  51
                ],
                "on": "knee",
                "rows": [
                  "DSSDn",
                  "nSSSn",
                  ".DSSD",
                  ".nSSD",
                  ".nSSS",
                  "DS.SS"
                ],
                "side": "far"
              }
            ]
          },
          "frame": 64,
          "mirrorFacings": {
            "right": "left"
          },
          "mirrorSides": {
            "screenLeft": "screenRight"
          },
          "swungLimit": 35,
          "turnedLimit": 0.35
        }
      },
      "version": 1
    },
    "emberPalettes": {
      "about": "Ember's colours. A RAMP is a material: six colours, [light, base, shade, deep, line, outline] -- the shader picks one of the first four from the light (it never invents a colour, which keeps the result pixel art), `line` marks creases and limbs crossing the body, `outline` is drawn where the material meets the background. Ramps come in named groups; a SKIN SET (what a style draws skin with) is a list of groups. Garment and hair colours are single base colours that rampFrom turns into a ramp (shadows toward violet, highlights toward warm yellow, as LPC's cloth).",
      "dyes": {
        "about": "Cloth and leather dyes an Ember humanoid's outfit may name; an unknown name is gray.",
        "colors": {
          "black": "#2d2a30",
          "blue": "#3e63a0",
          "brown": "#7a5134",
          "charcoal": "#45454c",
          "forest": "#35583a",
          "gray": "#7b7c80",
          "green": "#55813f",
          "leather": "#6b4a30",
          "maroon": "#6e2a31",
          "navy": "#2b3a63",
          "ochre": "#b8873a",
          "orange": "#c06a2c",
          "purple": "#674a8f",
          "red": "#a8383b",
          "tan": "#a98557",
          "teal": "#2f7a7a",
          "white": "#d9d4c7",
          "yellow": "#d6b546"
        }
      },
      "eye": {
        "about": "Eye colours, sampled from the LPC sheets: `glint` the cyan catch-light at the corners of an LPC eye, `white`, `iris`, `pupil`; `ember` Ember's warm catch-light from the fire on `warmPupil`, a warm near-black; `wolf` a wolfman's eye, LPC's pale cyan glow.",
        "colors": {
          "ember": "#ffbf5a",
          "glint": "#50d4ec",
          "iris": "#5187b3",
          "pupil": "#293d4b",
          "warmPupil": "#24140f",
          "white": "#f2f8f9",
          "wolf": "#9cf3d9"
        }
      },
      "hair": {
        "about": "Hair colours: Ember's own and the rest of the game's (LPC's); an unknown name is brown.",
        "colors": {
          "black": "#2b2629",
          "blonde": "#d1a654",
          "blue": "#3a5a9a",
          "brown": "#5d3b25",
          "chestnut": "#7d4426",
          "gold": "#c9952f",
          "gray": "#8d8a8a",
          "green": "#3f7a3a",
          "lightbrown": "#8a5f3a",
          "orange": "#c0642a",
          "purple": "#6a4a8f",
          "red": "#a5452a",
          "white": "#d8d4cf"
        }
      },
      "ramps": {
        "bones": {
          "about": "A skeleton's bone by the game's skeleton body colours (LPC's beige, gray and green sheets); `white` unless named. Ivory with warm grey shadows -- the shared ramp's purple-ward shift turns pale bone pink. LPC's green skeleton is a vivid, toxic green, not a mossy bone.",
          "tones": {
            "beige": [
              "#f1ebd8",
              "#d9d0b4",
              "#aca186",
              "#7d735f",
              "#544c3f",
              "#281820"
            ],
            "gray": [
              "#f0f0f8",
              "#c9c9e0",
              "#a3abb9",
              "#727080",
              "#4d4b5c",
              "#1d131e"
            ],
            "green": [
              "#a8ff7a",
              "#38e83c",
              "#2f9a1d",
              "#2a6a22",
              "#1f4a1b",
              "#1d131e"
            ],
            "white": [
              "#f1ebd8",
              "#d9d0b4",
              "#aca186",
              "#7d735f",
              "#544c3f",
              "#281820"
            ]
          }
        },
        "lpc-skin": {
          "about": "Skin sampled from content/game/media/lpc/spritesheets/body/male/human/<tone>.png, so an LPC-style body sits beside the LPC art. `zombie` is dead flesh: a sickly grey-green, the game's zombie \"green\".",
          "tones": {
            "black": [
              "#714535",
              "#61382d",
              "#3b2924",
              "#2b2122",
              "#1c1418",
              "#070609"
            ],
            "brown": [
              "#c58050",
              "#a86431",
              "#7e4f32",
              "#644334",
              "#442826",
              "#120d0f"
            ],
            "light": [
              "#fbece6",
              "#fdd5b7",
              "#eaa377",
              "#d28560",
              "#9e3e37",
              "#281820"
            ],
            "olive": [
              "#d99f90",
              "#d98e60",
              "#a96b4c",
              "#905e51",
              "#5a3737",
              "#281821"
            ],
            "zombie": [
              "#d3d8ae",
              "#aab184",
              "#848c66",
              "#636a4b",
              "#454a33",
              "#281820"
            ]
          }
        },
        "painted-skin": {
          "about": "Skin for Ember's own (realist) style: picked, not sampled, and set apart from LPC by its shadows, which cool toward violet, and its outline, a deep plum rather than LPC's brown-black.",
          "tones": {
            "black": [
              "#8f5f4c",
              "#6b4337",
              "#4e2f2d",
              "#38222a",
              "#271822",
              "#110a14"
            ],
            "brown": [
              "#c98f63",
              "#a26a45",
              "#7b4d3c",
              "#5c3637",
              "#40242f",
              "#1a1022"
            ],
            "light": [
              "#f8dcc4",
              "#e9b892",
              "#c98a6c",
              "#9c6158",
              "#6e3d4a",
              "#25182b"
            ],
            "olive": [
              "#e6bf98",
              "#c99468",
              "#9f6c55",
              "#7a4d4c",
              "#553243",
              "#22162a"
            ],
            "zombie": [
              "#cdd3a6",
              "#a6ad80",
              "#808862",
              "#5f6648",
              "#424730",
              "#25182b"
            ]
          }
        },
        "wolf-fur": {
          "about": "A wolfman's fur in the game's four wolf colours, `wolf-<colour>`, ramps taken off LPC's wolfman sheets (its black is a blue-black, its white a cool grey-white). The same in both skin sets.",
          "tones": {
            "wolf-black": [
              "#2f4552",
              "#1b2c36",
              "#14212c",
              "#0d1621",
              "#0a0e1b",
              "#040510"
            ],
            "wolf-brown": [
              "#8a5b47",
              "#624135",
              "#4a3830",
              "#33251f",
              "#1e120e",
              "#100806"
            ],
            "wolf-gray": [
              "#8c9296",
              "#6a6e74",
              "#55585f",
              "#41424a",
              "#26262d",
              "#0f0f11"
            ],
            "wolf-white": [
              "#e6e9e9",
              "#c4c7c8",
              "#9ea5a9",
              "#7a8389",
              "#484e57",
              "#17171a"
            ]
          }
        }
      },
      "skins": {
        "lpc": [
          "lpc-skin",
          "wolf-fur"
        ],
        "painted": [
          "painted-skin",
          "wolf-fur"
        ]
      },
      "version": 1
    },
    "emberSpecies": {
      "about": "Species on rigs of their own (ember_sprite/species.ts): each brings its joints and legs, gaits generated from a few numbers, keyed clips, which of them plays each of the game's actions, and its bodies -- models of slot `species` hung on the posed joints. Angles in degrees, lengths in world pixels; y up, +z the way the body faces, +x its left.",
      "library": [],
      "models": {
        "centaur": {
          "about": "A centaur: a horse's barrel on four legs, a person's torso, arms and head rising from its chest, a long tail. Bare-chested with a leather band across the chest.",
          "let": [
            [
              "coatM",
              "rampFrom(coat)"
            ],
            [
              "skinM",
              "rampFrom(skin)"
            ],
            [
              "hairM",
              "rampFrom(hair)"
            ],
            [
              "hoofM",
              "rampFrom(hoof)"
            ],
            [
              "bandM",
              "rampFrom(band)"
            ],
            [
              "J",
              "sk.at"
            ],
            [
              "B",
              "sk.basis"
            ],
            [
              "chestC",
              "add(J.chest, apply(B.chest, [0, -4.4, -1]))"
            ],
            [
              "bellyC",
              "add(J.loin, apply(B.loin, [0, -4.4, 0]))"
            ],
            [
              "rumpC",
              "add(J.pelvis, apply(B.pelvis, [0, -3.4, -0.6]))"
            ],
            [
              "withers",
              "add(J.chest, apply(B.chest, [0, -0.5, 2.6]))"
            ],
            [
              "belly",
              "lerp(J.waist, J.torso, 0.35)"
            ],
            [
              "eyes",
              "(w, n) => [1, -1].some(s => distance(w, add(J.head, apply(B.head, [s * 1.2, 0.2, 2.6]))) < 0.55) ? hairM.deep : undefined"
            ],
            [
              "strap",
              "(w, n) => abs(dot(sub(w, J.torso), normalize(apply(B.torso, [-0.75, 1, 0])))) < 0.7 ? bandM.base : undefined"
            ],
            [
              "legs",
              "[['fl', 'legFL', 1], ['fr', 'legFR', 1], ['hl', 'legHL', 0], ['hr', 'legHR', 0]]"
            ],
            [
              "arms",
              "[['r', 'armR'], ['l', 'armL']]"
            ]
          ],
          "params": {
            "band": "#5a3a22",
            "coat": "#8a5a34",
            "hair": "#3a2416",
            "hoof": "#2f2420",
            "skin": "#d8a07a"
          },
          "parts": [
            "ellipsoid(chestC, B.chest, [5.6, 7.0, 7.4], coatM, 'torso')",
            "ellipsoid(bellyC, B.loin, [5.5, 6.3, 10.5], coatM, 'torso')",
            "ellipsoid(rumpC, B.pelvis, [5.8, 6.8, 7.0], coatM, 'torso')",
            "segment(withers, J.waist, 3.9, coatM, 'torso')",
            {
              "paint": "strap",
              "parts": [
                "ellipsoid(belly, B.waist, [3.9, 3.9, 3.1], skinM, 'torso')",
                "ellipsoid(J.torso, B.torso, [4.7, 4.7, 3.4], skinM, 'torso', { exponent: [2.6, 2.2, 2.2] })"
              ]
            },
            "joint(J.rShoulder, 2.2, skinM, 'torso')",
            "joint(J.lShoulder, 2.2, skinM, 'torso')",
            "segment(J.torso, J.neck, 1.8, skinM, 'torso')",
            {
              "paint": "eyes",
              "parts": [
                "ellipsoid(J.head, B.head, [2.8, 3.2, 2.9], skinM, 'head')"
              ]
            },
            "ellipsoid(add(J.head, apply(B.head, [0, 1.0, -0.5])), B.head, [3.1, 2.7, 3.2], hairM, 'hair', { keep: q => q[1] > -0.6 && q[2] < 1.8 })",
            "ellipsoid(add(J.head, apply(B.head, [0, -1.8, -2.1])), B.head, [2.7, 3.0, 1.4], hairM, 'hair')",
            {
              "as": "arm",
              "each": "arms",
              "let": [
                [
                  "s",
                  "arm[0]"
                ],
                [
                  "group",
                  "arm[1]"
                ]
              ],
              "parts": [
                "segment(J[s + 'Shoulder'], J[s + 'Elbow'], 1.75, skinM, group)",
                "as(segment(J[s + 'Elbow'], J[s + 'Hand'], 1.5, skinM, group), 'forearm')",
                "as(joint(J[s + 'Hand'], 1.45, skinM, group), 'hand')"
              ]
            },
            "segment(J.tail, J.tail2, 1.8, hairM, 'tail')",
            "segment(J.tail2, J.tailTip, 2.0, hairM, 'tail')",
            {
              "as": "leg",
              "each": "legs",
              "let": [
                [
                  "k",
                  "leg[0]"
                ],
                [
                  "group",
                  "leg[1]"
                ],
                [
                  "fore",
                  "leg[2] === 1"
                ],
                [
                  "top",
                  "J[k + (fore ? 'Shoulder' : 'Hip')]"
                ],
                [
                  "knee",
                  "J[k + (fore ? 'Elbow' : 'Stifle')]"
                ],
                [
                  "ankle",
                  "J[k + (fore ? 'Knee' : 'Hock')]"
                ],
                [
                  "hoofAt",
                  "J[k + 'Hoof']"
                ]
              ],
              "parts": [
                "segment(top, knee, fore ? 3.0 : 3.9, coatM, group)",
                "as(segment(knee, ankle, fore ? 1.8 : 2.0, coatM, group), 'shin')",
                "as(segment(ankle, hoofAt, 1.3, coatM, group), 'cannon')",
                "as(ellipsoid(hoofAt, B[k + 'Hoof'], [1.4, 1.2, 1.6], hoofM, group), 'foot')"
              ]
            }
          ]
        },
        "deer": {
          "about": "A deer: a barrel of chest, belly and haunch on four slender legs, a long neck, a narrow head with a dark muzzle and big ears, a pale belly, throat and rump, a short tail with a white underside. Antlers on a stag.",
          "let": [
            [
              "coatM",
              "rampFrom(coat)"
            ],
            [
              "paleM",
              "rampFrom(pale)"
            ],
            [
              "darkM",
              "rampFrom(dark)"
            ],
            [
              "hornM",
              "rampFrom('#cbb48a')"
            ],
            [
              "J",
              "sk.at"
            ],
            [
              "B",
              "sk.basis"
            ],
            [
              "chestC",
              "add(J.chest, apply(B.chest, [0, -4.3, -0.5]))"
            ],
            [
              "bellyC",
              "add(J.loin, apply(B.loin, [0, -4.0, 0]))"
            ],
            [
              "rumpC",
              "add(J.pelvis, apply(B.pelvis, [0, -3.3, -0.6]))"
            ],
            [
              "throat",
              "add(J.head, apply(B.head, [0, -2.0, -1.4]))"
            ],
            [
              "neckBase",
              "add(J.neck, apply(B.neck, [0, -3.0, -1.2]))"
            ],
            [
              "neckMid",
              "lerp(neckBase, throat, 0.45)"
            ],
            [
              "muzzleRoot",
              "add(J.head, apply(B.head, [0, -0.6, 1.2]))"
            ],
            [
              "eye",
              "s => add(J.head, apply(B.head, [s * 2.1, 0.6, 1.4]))"
            ],
            [
              "earTip",
              "(ear, s) => add(J[ear], apply(B[ear], [s * 2.8, 3.2, -0.9]))"
            ],
            [
              "underside",
              "(w, n) => n[1] < -0.55 ? paleM.base : undefined"
            ],
            [
              "rumpPatch",
              "(w, n) => dot(sub(w, rumpC), apply(B.pelvis, [0, 0, -1])) > 3.6 && dot(sub(w, rumpC), apply(B.pelvis, [0, 1, 0])) < 2.6 ? paleM.base : undefined"
            ],
            [
              "eyes",
              "(w, n) => distance(w, eye(1)) < 0.75 || distance(w, eye(-1)) < 0.75 ? darkM.deep : undefined"
            ],
            [
              "legs",
              "[['fl', 'legFL', 1], ['fr', 'legFR', 1], ['hl', 'legHL', 0], ['hr', 'legHR', 0]]"
            ]
          ],
          "params": {
            "antlers": false,
            "coat": "#9a6438",
            "dark": "#3b2a22",
            "pale": "#e6d7bf"
          },
          "parts": [
            {
              "paint": "(w, n) => underside(w, n) ?? rumpPatch(w, n)",
              "parts": [
                "ellipsoid(chestC, B.chest, [4.8, 6.7, 6.8], coatM, 'torso')",
                "ellipsoid(bellyC, B.loin, [5.0, 5.9, 10], coatM, 'torso')",
                "ellipsoid(rumpC, B.pelvis, [5, 6.2, 6.3], coatM, 'torso')"
              ]
            },
            {
              "paint": "(w, n) => n[1] < -0.3 ? paleM.base : undefined",
              "parts": [
                "segment(neckBase, neckMid, 3.6, coatM, 'torso')",
                "segment(neckMid, throat, 2.7, coatM, 'torso')"
              ]
            },
            {
              "paint": "eyes",
              "parts": [
                "ellipsoid(J.head, B.head, [2.6, 2.9, 3.4], coatM, 'head')"
              ]
            },
            "segment(muzzleRoot, J.nose, 1.8, coatM, 'head')",
            "joint(J.nose, 1.05, darkM, 'head')",
            "segment(J.earL, earTip('earL', 1), 1.3, coatM, 'head')",
            "segment(J.earR, earTip('earR', -1), 1.3, coatM, 'head')",
            {
              "parts": [
                {
                  "as": "s",
                  "each": "[1, -1]",
                  "let": [
                    [
                      "base",
                      "add(J.head, apply(B.head, [s * 1.2, 2.2, -0.4]))"
                    ],
                    [
                      "beam",
                      "add(base, apply(B.head, [s * 3.0, 6.2, -1.6]))"
                    ],
                    [
                      "top",
                      "add(beam, apply(B.head, [s * 0.8, 4.0, 2.0]))"
                    ],
                    [
                      "tine",
                      "add(beam, apply(B.head, [s * -0.6, 2.8, 2.8]))"
                    ],
                    [
                      "brow",
                      "add(base, apply(B.head, [s * 0.8, 2.8, 2.6]))"
                    ]
                  ],
                  "parts": [
                    "segment(base, beam, 0.85, hornM, 'head')",
                    "segment(beam, top, 0.75, hornM, 'head')",
                    "segment(beam, tine, 0.7, hornM, 'head')",
                    "segment(base, brow, 0.65, hornM, 'head')"
                  ]
                }
              ],
              "when": "antlers"
            },
            {
              "paint": "(w, n) => dot(n, apply(B.tail, [0, 0, -1])) > 0.2 || n[1] < -0.2 ? paleM.base : undefined",
              "parts": [
                "segment(J.tail, J.tailTip, 1.35, coatM, 'tail')"
              ]
            },
            {
              "as": "leg",
              "each": "legs",
              "let": [
                [
                  "k",
                  "leg[0]"
                ],
                [
                  "group",
                  "leg[1]"
                ],
                [
                  "fore",
                  "leg[2] === 1"
                ],
                [
                  "top",
                  "J[k + (fore ? 'Shoulder' : 'Hip')]"
                ],
                [
                  "knee",
                  "J[k + (fore ? 'Elbow' : 'Stifle')]"
                ],
                [
                  "ankle",
                  "J[k + (fore ? 'Knee' : 'Hock')]"
                ],
                [
                  "hoof",
                  "J[k + 'Hoof']"
                ]
              ],
              "parts": [
                "segment(top, knee, fore ? 2.6 : 3.4, coatM, group)",
                "as(segment(knee, ankle, fore ? 1.5 : 1.75, coatM, group), 'shin')",
                "as(segment(ankle, hoof, 1.05, coatM, group), 'cannon')",
                "as(ellipsoid(hoof, B[k + 'Hoof'], [1.05, 1.0, 1.3], darkM, group), 'foot')"
              ]
            }
          ]
        }
      },
      "races": [],
      "species": {
        "centaur": {
          "about": "A centaur: a horse's body with a person's torso, arms and head rising from its chest; it holds the game's weapons in its hands -- a sword in its right, a shield or a bow's grip in its left.",
          "actions": {
            "cast": "cast",
            "climb": "idle",
            "hurt": "hurt",
            "idle": "idle",
            "run": "run",
            "shoot": "shoot",
            "slash": "slash",
            "thrust": "thrust",
            "walk": "walk"
          },
          "bodies": {
            "centaur": {
              "about": "A chestnut centaur.",
              "model": "centaur",
              "scale": 1.15
            },
            "centaur-grey": {
              "about": "A dapple-grey centaur, fair-haired.",
              "model": "centaur",
              "params": {
                "coat": "#9a958c",
                "hair": "#d8c890",
                "skin": "#e8c0a0"
              },
              "scale": 1.15
            }
          },
          "clips": {
            "cast": {
              "about": "Both arms raised to the sky.",
              "frameMs": 90,
              "frames": 8,
              "keys": [
                {
                  "t": 0,
                  "turns": {
                    "lElbow": [
                      -15,
                      0,
                      0
                    ],
                    "rElbow": [
                      -15,
                      0,
                      0
                    ]
                  }
                },
                {
                  "pitch": -5,
                  "t": 0.45,
                  "turns": {
                    "lElbow": [
                      -20,
                      0,
                      0
                    ],
                    "lShoulder": [
                      -150,
                      0,
                      -20
                    ],
                    "neck": [
                      -15,
                      0,
                      0
                    ],
                    "rElbow": [
                      -20,
                      0,
                      0
                    ],
                    "rShoulder": [
                      -150,
                      0,
                      20
                    ],
                    "waist": [
                      -10,
                      0,
                      0
                    ]
                  }
                },
                {
                  "pitch": -5,
                  "t": 0.75,
                  "turns": {
                    "lElbow": [
                      -20,
                      0,
                      0
                    ],
                    "lShoulder": [
                      -150,
                      0,
                      -20
                    ],
                    "neck": [
                      -15,
                      0,
                      0
                    ],
                    "rElbow": [
                      -20,
                      0,
                      0
                    ],
                    "rShoulder": [
                      -150,
                      0,
                      20
                    ],
                    "waist": [
                      -10,
                      0,
                      0
                    ]
                  }
                },
                {
                  "t": 1,
                  "turns": {
                    "lElbow": [
                      -15,
                      0,
                      0
                    ],
                    "rElbow": [
                      -15,
                      0,
                      0
                    ]
                  }
                }
              ]
            },
            "hurt": {
              "about": "Falls: the forelegs buckle, it goes over onto its side, the arms flung out.",
              "frameMs": 70,
              "frames": 8,
              "keys": [
                {
                  "t": 0,
                  "turns": {
                    "lElbow": [
                      -15,
                      0,
                      0
                    ],
                    "rElbow": [
                      -15,
                      0,
                      0
                    ]
                  }
                },
                {
                  "feet": {
                    "fl": [
                      0,
                      0,
                      -1,
                      40
                    ],
                    "fr": [
                      0,
                      0,
                      -1,
                      40
                    ]
                  },
                  "pitch": 12,
                  "rise": -6,
                  "t": 0.35,
                  "turns": {
                    "lShoulder": [
                      -40,
                      0,
                      -20
                    ],
                    "rShoulder": [
                      -40,
                      0,
                      20
                    ],
                    "waist": [
                      20,
                      0,
                      0
                    ]
                  }
                },
                {
                  "feet": {
                    "fl": "free",
                    "fr": "free",
                    "hl": "free",
                    "hr": "free"
                  },
                  "rise": -16,
                  "roll": 65,
                  "side": 2,
                  "t": 0.75,
                  "turns": {
                    "lShoulder": [
                      -20,
                      0,
                      -30
                    ],
                    "rShoulder": [
                      -60,
                      0,
                      30
                    ],
                    "waist": [
                      10,
                      0,
                      -15
                    ]
                  }
                },
                {
                  "feet": {
                    "fl": "free",
                    "fr": "free",
                    "hl": "free",
                    "hr": "free"
                  },
                  "rise": -21,
                  "roll": 86,
                  "side": 3,
                  "t": 1,
                  "turns": {
                    "lShoulder": [
                      -10,
                      0,
                      -30
                    ],
                    "neck": [
                      0,
                      0,
                      -15
                    ],
                    "rShoulder": [
                      -80,
                      0,
                      30
                    ],
                    "waist": [
                      0,
                      0,
                      -20
                    ]
                  }
                }
              ]
            },
            "idle": {
              "about": "Standing at ease, breathing; it looks about, the tail swishes.",
              "frameMs": 110,
              "frames": 24,
              "keys": [
                {
                  "t": 0,
                  "turns": {
                    "lElbow": [
                      -15,
                      0,
                      0
                    ],
                    "rElbow": [
                      -15,
                      0,
                      0
                    ]
                  }
                },
                {
                  "rise": 0.3,
                  "t": 0.3,
                  "turns": {
                    "lElbow": [
                      -15,
                      0,
                      0
                    ],
                    "rElbow": [
                      -15,
                      0,
                      0
                    ],
                    "tail": [
                      0,
                      12,
                      0
                    ],
                    "torso": [
                      -2,
                      0,
                      0
                    ]
                  }
                },
                {
                  "t": 0.55,
                  "turns": {
                    "lElbow": [
                      -15,
                      0,
                      0
                    ],
                    "neck": [
                      0,
                      18,
                      0
                    ],
                    "rElbow": [
                      -15,
                      0,
                      0
                    ],
                    "tail": [
                      0,
                      -10,
                      0
                    ],
                    "waist": [
                      0,
                      8,
                      0
                    ]
                  }
                },
                {
                  "rise": 0.3,
                  "t": 0.8,
                  "turns": {
                    "lElbow": [
                      -15,
                      0,
                      0
                    ],
                    "neck": [
                      0,
                      18,
                      0
                    ],
                    "rElbow": [
                      -15,
                      0,
                      0
                    ],
                    "waist": [
                      0,
                      8,
                      0
                    ]
                  }
                },
                {
                  "t": 1,
                  "turns": {
                    "lElbow": [
                      -15,
                      0,
                      0
                    ],
                    "rElbow": [
                      -15,
                      0,
                      0
                    ]
                  }
                }
              ],
              "loop": true
            },
            "shoot": {
              "about": "A bow drawn and loosed: the bow arm out ahead, the string hand drawn back to the cheek.",
              "frameMs": 60,
              "frames": 10,
              "keys": [
                {
                  "t": 0,
                  "turns": {
                    "lElbow": [
                      -15,
                      0,
                      0
                    ],
                    "rElbow": [
                      -15,
                      0,
                      0
                    ]
                  }
                },
                {
                  "t": 0.4,
                  "turns": {
                    "lElbow": [
                      -5,
                      0,
                      0
                    ],
                    "lShoulder": [
                      -88,
                      0,
                      -8
                    ],
                    "rElbow": [
                      -120,
                      0,
                      0
                    ],
                    "rShoulder": [
                      -80,
                      0,
                      20
                    ],
                    "waist": [
                      0,
                      25,
                      0
                    ]
                  }
                },
                {
                  "t": 0.75,
                  "turns": {
                    "lElbow": [
                      -5,
                      0,
                      0
                    ],
                    "lShoulder": [
                      -88,
                      0,
                      -8
                    ],
                    "rElbow": [
                      -60,
                      0,
                      0
                    ],
                    "rShoulder": [
                      -60,
                      0,
                      25
                    ],
                    "waist": [
                      0,
                      25,
                      0
                    ]
                  }
                },
                {
                  "t": 1,
                  "turns": {
                    "lElbow": [
                      -15,
                      0,
                      0
                    ],
                    "rElbow": [
                      -15,
                      0,
                      0
                    ]
                  }
                }
              ]
            },
            "slash": {
              "about": "An overhead cut: the weapon raised behind the head, the body rocking back on its haunches, then brought down and through.",
              "frameMs": 50,
              "frames": 10,
              "keys": [
                {
                  "t": 0,
                  "turns": {
                    "lElbow": [
                      -15,
                      0,
                      0
                    ],
                    "rElbow": [
                      -15,
                      0,
                      0
                    ]
                  }
                },
                {
                  "pitch": -7,
                  "t": 0.4,
                  "turns": {
                    "lElbow": [
                      -30,
                      0,
                      0
                    ],
                    "lShoulder": [
                      -30,
                      0,
                      0
                    ],
                    "rElbow": [
                      -35,
                      0,
                      0
                    ],
                    "rHand": [
                      10,
                      0,
                      0
                    ],
                    "rShoulder": [
                      -170,
                      0,
                      12
                    ],
                    "waist": [
                      -12,
                      12,
                      0
                    ]
                  }
                },
                {
                  "feet": {
                    "fl": [
                      0,
                      0,
                      2.5
                    ]
                  },
                  "pitch": 4,
                  "t": 0.62,
                  "turns": {
                    "lElbow": [
                      -20,
                      0,
                      0
                    ],
                    "lShoulder": [
                      10,
                      0,
                      0
                    ],
                    "rElbow": [
                      -5,
                      0,
                      0
                    ],
                    "rHand": [
                      95,
                      0,
                      0
                    ],
                    "rShoulder": [
                      -55,
                      0,
                      0
                    ],
                    "waist": [
                      16,
                      -10,
                      0
                    ]
                  }
                },
                {
                  "feet": {
                    "fl": [
                      0,
                      0,
                      2.5
                    ]
                  },
                  "pitch": 2,
                  "t": 0.8,
                  "turns": {
                    "lElbow": [
                      -20,
                      0,
                      0
                    ],
                    "rElbow": [
                      -10,
                      0,
                      0
                    ],
                    "rHand": [
                      80,
                      0,
                      0
                    ],
                    "rShoulder": [
                      -25,
                      0,
                      -10
                    ],
                    "waist": [
                      12,
                      -14,
                      0
                    ]
                  }
                },
                {
                  "t": 1,
                  "turns": {
                    "lElbow": [
                      -15,
                      0,
                      0
                    ],
                    "rElbow": [
                      -15,
                      0,
                      0
                    ]
                  }
                }
              ]
            },
            "thrust": {
              "about": "A lunge: the body surges forward and the weapon drives out straight from the shoulder.",
              "frameMs": 50,
              "frames": 10,
              "keys": [
                {
                  "t": 0,
                  "turns": {
                    "lElbow": [
                      -15,
                      0,
                      0
                    ],
                    "rElbow": [
                      -15,
                      0,
                      0
                    ]
                  }
                },
                {
                  "shift": -1.5,
                  "t": 0.35,
                  "turns": {
                    "lElbow": [
                      -30,
                      0,
                      0
                    ],
                    "lShoulder": [
                      -40,
                      0,
                      0
                    ],
                    "rElbow": [
                      -95,
                      0,
                      0
                    ],
                    "rHand": [
                      95,
                      0,
                      0
                    ],
                    "rShoulder": [
                      -75,
                      0,
                      10
                    ],
                    "waist": [
                      -4,
                      18,
                      0
                    ]
                  }
                },
                {
                  "feet": {
                    "fl": [
                      0,
                      0,
                      3
                    ]
                  },
                  "pitch": 3,
                  "shift": 3,
                  "t": 0.6,
                  "turns": {
                    "lElbow": [
                      -20,
                      0,
                      0
                    ],
                    "lShoulder": [
                      -10,
                      0,
                      0
                    ],
                    "rElbow": [
                      -5,
                      0,
                      0
                    ],
                    "rHand": [
                      95,
                      0,
                      0
                    ],
                    "rShoulder": [
                      -85,
                      0,
                      0
                    ],
                    "waist": [
                      10,
                      -12,
                      0
                    ]
                  }
                },
                {
                  "feet": {
                    "fl": [
                      0,
                      0,
                      2
                    ]
                  },
                  "shift": 1.5,
                  "t": 0.8,
                  "turns": {
                    "rElbow": [
                      -25,
                      0,
                      0
                    ],
                    "rHand": [
                      95,
                      0,
                      0
                    ],
                    "rShoulder": [
                      -70,
                      0,
                      0
                    ],
                    "waist": [
                      6,
                      -8,
                      0
                    ]
                  }
                },
                {
                  "t": 1,
                  "turns": {
                    "lElbow": [
                      -15,
                      0,
                      0
                    ],
                    "rElbow": [
                      -15,
                      0,
                      0
                    ]
                  }
                }
              ]
            }
          },
          "frame": 128,
          "gaits": {
            "run": {
              "about": "A gallop; the person leans into it, arms tucked.",
              "duty": 0.3,
              "fold": {
                "fl": 105,
                "fr": 105,
                "hl": 45,
                "hr": 45
              },
              "frameMs": 60,
              "frames": 10,
              "lift": {
                "fl": 7,
                "fr": 7,
                "hl": 5,
                "hr": 5
              },
              "motion": [
                {
                  "amplitude": 1.6,
                  "axis": "rise",
                  "joint": "root",
                  "perCycle": 1,
                  "phase": 0.37
                },
                {
                  "amplitude": 5,
                  "axis": "pitch",
                  "joint": "root",
                  "perCycle": 1,
                  "phase": 0.68
                },
                {
                  "amplitude": 6,
                  "axis": "pitch",
                  "joint": "loin",
                  "perCycle": 1,
                  "phase": 0.65
                },
                {
                  "amplitude": 4,
                  "axis": "pitch",
                  "joint": "waist",
                  "offset": 14,
                  "perCycle": 1,
                  "phase": 0.2
                },
                {
                  "amplitude": 6,
                  "axis": "pitch",
                  "joint": "rShoulder",
                  "offset": -25,
                  "perCycle": 1
                },
                {
                  "amplitude": 6,
                  "axis": "pitch",
                  "joint": "lShoulder",
                  "offset": -25,
                  "perCycle": 1,
                  "phase": 0.5
                },
                {
                  "amplitude": 0,
                  "axis": "pitch",
                  "joint": "rElbow",
                  "offset": -60
                },
                {
                  "amplitude": 0,
                  "axis": "pitch",
                  "joint": "lElbow",
                  "offset": -60
                },
                {
                  "amplitude": 8,
                  "axis": "pitch",
                  "joint": "tail",
                  "offset": -40,
                  "perCycle": 1
                }
              ],
              "phases": {
                "fl": 0.38,
                "fr": 0.46,
                "hl": 0,
                "hr": 0.06
              },
              "reach": 2,
              "stride": 46
            },
            "walk": {
              "about": "A horse's four-beat walk; the person's arms swing a little, the torso riding steady.",
              "duty": 0.66,
              "fold": {
                "fl": 55,
                "fr": 55,
                "hl": 30,
                "hr": 30
              },
              "frameMs": 90,
              "frames": 12,
              "lift": {
                "fl": 3,
                "fr": 3,
                "hl": 2.5,
                "hr": 2.5
              },
              "motion": [
                {
                  "amplitude": 0.45,
                  "axis": "rise",
                  "joint": "root",
                  "perCycle": 2,
                  "phase": 0.25
                },
                {
                  "amplitude": 1.5,
                  "axis": "pitch",
                  "joint": "waist",
                  "perCycle": 2,
                  "phase": 0.6
                },
                {
                  "amplitude": 10,
                  "axis": "pitch",
                  "joint": "rShoulder",
                  "perCycle": 1,
                  "phase": 0
                },
                {
                  "amplitude": 10,
                  "axis": "pitch",
                  "joint": "lShoulder",
                  "perCycle": 1,
                  "phase": 0.5
                },
                {
                  "amplitude": 0,
                  "axis": "pitch",
                  "joint": "rElbow",
                  "offset": -15
                },
                {
                  "amplitude": 0,
                  "axis": "pitch",
                  "joint": "lElbow",
                  "offset": -15
                },
                {
                  "amplitude": 6,
                  "axis": "yaw",
                  "joint": "tail",
                  "perCycle": 1
                }
              ],
              "phases": {
                "fl": 0.25,
                "fr": 0.75,
                "hl": 0,
                "hr": 0.5
              },
              "reach": 1.5,
              "stride": 20
            }
          },
          "grips": {
            "L": {
              "grip": [
                0,
                0.55,
                0.83
              ],
              "hand": "lHand"
            },
            "R": {
              "grip": [
                0,
                0.55,
                0.83
              ],
              "hand": "rHand"
            },
            "torso": "torso"
          },
          "joints": [
            [
              "pelvis",
              null,
              [
                0,
                27,
                -12
              ]
            ],
            [
              "loin",
              "pelvis",
              [
                0,
                27.5,
                -2
              ]
            ],
            [
              "chest",
              "loin",
              [
                0,
                28,
                8
              ]
            ],
            [
              "waist",
              "chest",
              [
                0,
                32,
                11.5
              ]
            ],
            [
              "torso",
              "waist",
              [
                0,
                39.5,
                12
              ]
            ],
            [
              "neck",
              "torso",
              [
                0,
                45,
                12.2
              ]
            ],
            [
              "head",
              "neck",
              [
                0,
                49,
                12.6
              ]
            ],
            [
              "rShoulder",
              "torso",
              [
                -4.3,
                43.4,
                12
              ]
            ],
            [
              "rElbow",
              "rShoulder",
              [
                -4.9,
                37.4,
                11.4
              ]
            ],
            [
              "rHand",
              "rElbow",
              [
                -4.7,
                32.4,
                13.8
              ]
            ],
            [
              "lShoulder",
              "torso",
              [
                4.3,
                43.4,
                12
              ]
            ],
            [
              "lElbow",
              "lShoulder",
              [
                4.9,
                37.4,
                11.4
              ]
            ],
            [
              "lHand",
              "lElbow",
              [
                4.7,
                32.4,
                13.8
              ]
            ],
            [
              "tail",
              "pelvis",
              [
                0,
                28.5,
                -19
              ]
            ],
            [
              "tail2",
              "tail",
              [
                0,
                24,
                -22
              ]
            ],
            [
              "tailTip",
              "tail2",
              [
                0,
                18.5,
                -23
              ]
            ],
            [
              "flShoulder",
              "chest",
              [
                3.5,
                22,
                8.5
              ]
            ],
            [
              "flElbow",
              "flShoulder",
              [
                3.5,
                15,
                4.6
              ]
            ],
            [
              "flKnee",
              "flElbow",
              [
                3.3,
                7.6,
                6.8
              ]
            ],
            [
              "flHoof",
              "flKnee",
              [
                3.3,
                1.2,
                6.9
              ]
            ],
            [
              "frShoulder",
              "chest",
              [
                -3.5,
                22,
                8.5
              ]
            ],
            [
              "frElbow",
              "frShoulder",
              [
                -3.5,
                15,
                4.6
              ]
            ],
            [
              "frKnee",
              "frElbow",
              [
                -3.3,
                7.6,
                6.8
              ]
            ],
            [
              "frHoof",
              "frKnee",
              [
                -3.3,
                1.2,
                6.9
              ]
            ],
            [
              "hlHip",
              "pelvis",
              [
                3.7,
                23,
                -12
              ]
            ],
            [
              "hlStifle",
              "hlHip",
              [
                3.9,
                15.5,
                -8
              ]
            ],
            [
              "hlHock",
              "hlStifle",
              [
                3.5,
                9,
                -14.2
              ]
            ],
            [
              "hlHoof",
              "hlHock",
              [
                3.4,
                1.2,
                -13
              ]
            ],
            [
              "hrHip",
              "pelvis",
              [
                -3.7,
                23,
                -12
              ]
            ],
            [
              "hrStifle",
              "hrHip",
              [
                -3.9,
                15.5,
                -8
              ]
            ],
            [
              "hrHock",
              "hrStifle",
              [
                -3.5,
                9,
                -14.2
              ]
            ],
            [
              "hrHoof",
              "hrHock",
              [
                -3.4,
                1.2,
                -13
              ]
            ]
          ],
          "legs": {
            "fl": {
              "joints": [
                "flShoulder",
                "flElbow",
                "flKnee",
                "flHoof"
              ]
            },
            "fr": {
              "joints": [
                "frShoulder",
                "frElbow",
                "frKnee",
                "frHoof"
              ]
            },
            "hl": {
              "joints": [
                "hlHip",
                "hlStifle",
                "hlHock",
                "hlHoof"
              ]
            },
            "hr": {
              "joints": [
                "hrHip",
                "hrStifle",
                "hrHock",
                "hrHoof"
              ]
            }
          },
          "points": {
            "head": "head"
          },
          "raster": {
            "pitch": 20
          },
          "sideTurn": 10,
          "style": "realist"
        },
        "deer": {
          "about": "A deer, at the scale of LPC's: about 30px at the withers and 60px nose to tail. Walks a four-beat walk (left hind, left fore, right hind, right fore) and runs a bounding gallop.",
          "actions": {
            "cast": "attack",
            "climb": "idle",
            "hurt": "hurt",
            "idle": "idle",
            "run": "run",
            "shoot": "attack",
            "slash": "attack",
            "thrust": "attack",
            "walk": "walk"
          },
          "bodies": {
            "deer": {
              "about": "A doe, at LPC's deer's size.",
              "model": "deer",
              "scale": 1.22
            },
            "stag": {
              "about": "A stag: bigger and darker, with antlers.",
              "model": "deer",
              "params": {
                "antlers": true,
                "coat": "#80522e"
              },
              "scale": 1.32
            }
          },
          "clips": {
            "attack": {
              "about": "Rears on its hind legs, forelegs tucked, and strikes down with its forehooves.",
              "frameMs": 50,
              "frames": 10,
              "keys": [
                {
                  "t": 0
                },
                {
                  "feet": {
                    "fl": "free",
                    "fr": "free",
                    "hl": [
                      0,
                      0,
                      1.5
                    ],
                    "hr": [
                      0,
                      0,
                      1.5
                    ]
                  },
                  "pitch": -38,
                  "rise": 1,
                  "t": 0.35,
                  "turns": {
                    "flKnee": [
                      110,
                      0,
                      0
                    ],
                    "flShoulder": [
                      -55,
                      0,
                      0
                    ],
                    "frKnee": [
                      100,
                      0,
                      0
                    ],
                    "frShoulder": [
                      -45,
                      0,
                      0
                    ],
                    "neck": [
                      -20,
                      0,
                      0
                    ],
                    "tail": [
                      -30,
                      0,
                      0
                    ]
                  }
                },
                {
                  "feet": {
                    "fl": "free",
                    "fr": "free",
                    "hl": [
                      0,
                      0,
                      1.5
                    ],
                    "hr": [
                      0,
                      0,
                      1.5
                    ]
                  },
                  "pitch": -14,
                  "t": 0.6,
                  "turns": {
                    "flKnee": [
                      20,
                      0,
                      0
                    ],
                    "flShoulder": [
                      -70,
                      0,
                      0
                    ],
                    "frKnee": [
                      25,
                      0,
                      0
                    ],
                    "frShoulder": [
                      -62,
                      0,
                      0
                    ],
                    "neck": [
                      10,
                      0,
                      0
                    ]
                  }
                },
                {
                  "feet": {
                    "fl": [
                      0,
                      0,
                      6
                    ],
                    "fr": [
                      0,
                      0,
                      5
                    ]
                  },
                  "t": 0.78,
                  "turns": {
                    "neck": [
                      14,
                      0,
                      0
                    ]
                  }
                },
                {
                  "t": 1
                }
              ]
            },
            "graze": {
              "about": "Head down to the grass and up again.",
              "frameMs": 110,
              "frames": 16,
              "keys": [
                {
                  "t": 0
                },
                {
                  "feet": {
                    "fl": [
                      0,
                      0,
                      1
                    ],
                    "fr": [
                      0,
                      0,
                      -1
                    ]
                  },
                  "t": 0.3,
                  "turns": {
                    "head": [
                      20,
                      0,
                      0
                    ],
                    "neck": [
                      75,
                      0,
                      0
                    ]
                  }
                },
                {
                  "feet": {
                    "fl": [
                      0,
                      0,
                      1
                    ],
                    "fr": [
                      0,
                      0,
                      -1
                    ]
                  },
                  "t": 0.7,
                  "turns": {
                    "head": [
                      22,
                      0,
                      0
                    ],
                    "neck": [
                      78,
                      4,
                      0
                    ]
                  }
                },
                {
                  "t": 1
                }
              ]
            },
            "hurt": {
              "about": "Falls: the forelegs buckle, then it goes over onto its side and lies still.",
              "frameMs": 70,
              "frames": 8,
              "keys": [
                {
                  "t": 0
                },
                {
                  "feet": {
                    "fl": [
                      0,
                      0,
                      -1,
                      40
                    ],
                    "fr": [
                      0,
                      0,
                      -1,
                      40
                    ]
                  },
                  "pitch": 14,
                  "rise": -6,
                  "t": 0.35,
                  "turns": {
                    "neck": [
                      20,
                      0,
                      0
                    ]
                  }
                },
                {
                  "feet": {
                    "fl": "free",
                    "fr": "free",
                    "hl": "free",
                    "hr": "free"
                  },
                  "pitch": 4,
                  "rise": -16,
                  "roll": 65,
                  "side": 2,
                  "t": 0.75,
                  "turns": {
                    "neck": [
                      10,
                      0,
                      -20
                    ]
                  }
                },
                {
                  "feet": {
                    "fl": "free",
                    "fr": "free",
                    "hl": "free",
                    "hr": "free"
                  },
                  "rise": -21,
                  "roll": 86,
                  "side": 3,
                  "t": 1,
                  "turns": {
                    "head": [
                      0,
                      0,
                      -10
                    ],
                    "neck": [
                      0,
                      0,
                      -30
                    ]
                  }
                }
              ]
            },
            "idle": {
              "about": "Standing, breathing; an ear flicks, the head turns to look, the tail twitches.",
              "frameMs": 110,
              "frames": 24,
              "keys": [
                {
                  "t": 0
                },
                {
                  "rise": 0.3,
                  "t": 0.2
                },
                {
                  "rise": 0.3,
                  "t": 0.28,
                  "turns": {
                    "earL": [
                      0,
                      0,
                      25
                    ]
                  }
                },
                {
                  "rise": 0.2,
                  "t": 0.34
                },
                {
                  "t": 0.5,
                  "turns": {
                    "head": [
                      0,
                      14,
                      0
                    ],
                    "neck": [
                      -4,
                      10,
                      0
                    ]
                  }
                },
                {
                  "rise": 0.3,
                  "t": 0.72,
                  "turns": {
                    "head": [
                      0,
                      14,
                      0
                    ],
                    "neck": [
                      -4,
                      10,
                      0
                    ],
                    "tail": [
                      -30,
                      0,
                      0
                    ]
                  }
                },
                {
                  "rise": 0.2,
                  "t": 0.8,
                  "turns": {
                    "head": [
                      0,
                      7,
                      0
                    ],
                    "neck": [
                      -2,
                      5,
                      0
                    ]
                  }
                },
                {
                  "t": 1
                }
              ],
              "loop": true
            }
          },
          "frame": 128,
          "gaits": {
            "run": {
              "about": "A bounding gallop: the hind feet land together, then the fore; a moment of flight between; the back flexing and stretching, the body rocking and rising through it.",
              "duty": 0.3,
              "fold": {
                "fl": 105,
                "fr": 105,
                "hl": 45,
                "hr": 45
              },
              "frameMs": 60,
              "frames": 10,
              "lift": {
                "fl": 7,
                "fr": 7,
                "hl": 5,
                "hr": 5
              },
              "motion": [
                {
                  "amplitude": 1.6,
                  "axis": "rise",
                  "joint": "root",
                  "perCycle": 1,
                  "phase": 0.37
                },
                {
                  "amplitude": 5,
                  "axis": "pitch",
                  "joint": "root",
                  "perCycle": 1,
                  "phase": 0.68
                },
                {
                  "amplitude": 6,
                  "axis": "pitch",
                  "joint": "loin",
                  "perCycle": 1,
                  "phase": 0.65
                },
                {
                  "amplitude": 10,
                  "axis": "pitch",
                  "joint": "neck",
                  "offset": 12,
                  "perCycle": 1,
                  "phase": 0.9
                },
                {
                  "amplitude": 8,
                  "axis": "pitch",
                  "joint": "tail",
                  "offset": -25,
                  "perCycle": 1
                }
              ],
              "phases": {
                "fl": 0.38,
                "fr": 0.46,
                "hl": 0,
                "hr": 0.06
              },
              "reach": 2,
              "stride": 48
            },
            "walk": {
              "about": "A four-beat walk: each foot down two thirds of the time, landing in turn left hind, left fore, right hind, right fore; the body bobbing once a step and the head nodding with it.",
              "duty": 0.66,
              "fold": {
                "fl": 55,
                "fr": 55,
                "hl": 30,
                "hr": 30
              },
              "frameMs": 90,
              "frames": 12,
              "lift": {
                "fl": 3,
                "fr": 3,
                "hl": 2.5,
                "hr": 2.5
              },
              "motion": [
                {
                  "amplitude": 0.45,
                  "axis": "rise",
                  "joint": "root",
                  "perCycle": 2,
                  "phase": 0.25
                },
                {
                  "amplitude": 3,
                  "axis": "pitch",
                  "joint": "neck",
                  "perCycle": 2,
                  "phase": 0.1
                },
                {
                  "amplitude": 6,
                  "axis": "yaw",
                  "joint": "tail",
                  "perCycle": 1
                }
              ],
              "phases": {
                "fl": 0.25,
                "fr": 0.75,
                "hl": 0,
                "hr": 0.5
              },
              "reach": 1.5,
              "stride": 22
            }
          },
          "joints": [
            [
              "pelvis",
              null,
              [
                0,
                28.5,
                -12
              ]
            ],
            [
              "loin",
              "pelvis",
              [
                0,
                29,
                -2
              ]
            ],
            [
              "chest",
              "loin",
              [
                0,
                29.5,
                9
              ]
            ],
            [
              "neck",
              "chest",
              [
                0,
                30,
                14
              ]
            ],
            [
              "head",
              "neck",
              [
                0,
                41.5,
                22
              ]
            ],
            [
              "nose",
              "head",
              [
                0,
                38,
                28.8
              ]
            ],
            [
              "earL",
              "head",
              [
                1.8,
                43.9,
                20.4
              ]
            ],
            [
              "earR",
              "head",
              [
                -1.8,
                43.9,
                20.4
              ]
            ],
            [
              "tail",
              "pelvis",
              [
                0,
                30.2,
                -19
              ]
            ],
            [
              "tailTip",
              "tail",
              [
                0,
                27.6,
                -21.2
              ]
            ],
            [
              "flShoulder",
              "chest",
              [
                3.2,
                24.5,
                11.5
              ]
            ],
            [
              "flElbow",
              "flShoulder",
              [
                3.2,
                16.5,
                7
              ]
            ],
            [
              "flKnee",
              "flElbow",
              [
                3,
                8.6,
                9.5
              ]
            ],
            [
              "flHoof",
              "flKnee",
              [
                3,
                1,
                9.5
              ]
            ],
            [
              "frShoulder",
              "chest",
              [
                -3.2,
                24.5,
                11.5
              ]
            ],
            [
              "frElbow",
              "frShoulder",
              [
                -3.2,
                16.5,
                7
              ]
            ],
            [
              "frKnee",
              "frElbow",
              [
                -3,
                8.6,
                9.5
              ]
            ],
            [
              "frHoof",
              "frKnee",
              [
                -3,
                1,
                9.5
              ]
            ],
            [
              "hlHip",
              "pelvis",
              [
                3.4,
                25,
                -12
              ]
            ],
            [
              "hlStifle",
              "hlHip",
              [
                3.6,
                17,
                -8
              ]
            ],
            [
              "hlHock",
              "hlStifle",
              [
                3.2,
                10,
                -14.5
              ]
            ],
            [
              "hlHoof",
              "hlHock",
              [
                3,
                1,
                -13.5
              ]
            ],
            [
              "hrHip",
              "pelvis",
              [
                -3.4,
                25,
                -12
              ]
            ],
            [
              "hrStifle",
              "hrHip",
              [
                -3.6,
                17,
                -8
              ]
            ],
            [
              "hrHock",
              "hrStifle",
              [
                -3.2,
                10,
                -14.5
              ]
            ],
            [
              "hrHoof",
              "hrHock",
              [
                -3,
                1,
                -13.5
              ]
            ]
          ],
          "legs": {
            "fl": {
              "joints": [
                "flShoulder",
                "flElbow",
                "flKnee",
                "flHoof"
              ]
            },
            "fr": {
              "joints": [
                "frShoulder",
                "frElbow",
                "frKnee",
                "frHoof"
              ]
            },
            "hl": {
              "joints": [
                "hlHip",
                "hlStifle",
                "hlHock",
                "hlHoof"
              ]
            },
            "hr": {
              "joints": [
                "hrHip",
                "hrStifle",
                "hrHock",
                "hrHoof"
              ]
            }
          },
          "points": {
            "hands": [
              "flHoof",
              "frHoof"
            ],
            "head": "head"
          },
          "raster": {
            "pitch": 20
          },
          "sideTurn": 10,
          "style": "realist"
        }
      },
      "version": 1
    },
    "emberStyles": {
      "about": "How a humanoid is drawn, apart from what it is (its build) and what it wears: the raster's settings over the engine's own (raster.ts DEFAULT_RASTER, merged object by object), the skin set its skins are drawn in (palettes.json skins), the muscle marks it paints (marks.json markSets; none unless named), the eye style for a look that names none, and the clips it plays its own way (`natural`: clips.ts NATURAL_CLIPS) over the shared ones.",
      "default": "lpc",
      "styles": {
        "lpc": {
          "about": "Fitted to sit beside LPC art: its raster, its sampled skins, and the muscle marks painted on the LPC-fitted body.",
          "marks": "lpc-male",
          "raster": {},
          "skins": "lpc"
        },
        "realist": {
          "about": "Ember's own, for bodies at real human proportions: picked skins with cool shadows and a plum outline; chest, waist and hips one body (no seam where one swells past the next, creaseDepth); seams only where a limb segment clearly overlaps the next, not at every knee (jointLine); one key light from above-left cut into steps at fixed darkness -- a clean terminator down the whole body rather than LPC's share of every step per region and its rim of shade inside every outline; no LPC marks (they are calibrated to the LPC body and would land in the wrong places on any other). A real body walks and runs like one: LPC's gait, scaled to its long legs, shuffles.",
          "clips": "natural",
          "eyes": "dot",
          "raster": {
            "creaseDepth": 3,
            "jointLine": 2.5,
            "outline": "dark",
            "shading": {
              "facing": 0.1,
              "light": 1,
              "rim": 0,
              "thresholds": [
                0.04,
                0.24,
                0.55
              ]
            }
          },
          "skins": "painted"
        }
      },
      "version": 1
    },
    "ids": {
      "aliases": {
        "colors": {},
        "items": {
          "stairs-down": "stairs",
          "stairs-up": "stairs"
        },
        "races": {}
      },
      "retired": {
        "colors": {},
        "items": {
          "mossy-ruin": "Deleted in Sprite Lab with its wall material \"Mossy Ruin Wall\"; saved ones are set aside.",
          "sickle": "Removed from the item tables before the content migration; saved sickles are set aside, not converted.",
          "wall-ossuary": "Deleted in Sprite Lab with its wall material \"Ossuary Wall\"; saved ones are set aside."
        },
        "races": {}
      }
    },
    "items": [
      {
        "class": "armor",
        "id": "armor-leather",
        "metadata": [
          {
            "class": "armor",
            "color": "brown",
            "spriteId": null,
            "type": "armor-leather"
          }
        ],
        "protection": 0.1,
        "subClass": "armor",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 60
        },
        "weight": 0.1
      },
      {
        "class": "armor",
        "id": "armor-legion",
        "metadata": [
          {
            "class": "armor",
            "color": "brown",
            "spriteId": null,
            "type": "armor-legion"
          }
        ],
        "protection": 0.2,
        "subClass": "armor",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 240
        },
        "weight": 0.2
      },
      {
        "class": "armor",
        "id": "armor-plate",
        "protection": 0.3,
        "subClass": "armor",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 360
        },
        "weight": 0.3
      },
      {
        "characteristics": {
          "isAmmo": true,
          "stackable": true,
          "unsellable": true
        },
        "class": "resource",
        "id": "arrow",
        "metadata": [
          {
            "class": "resource",
            "color": "brown",
            "spriteId": null,
            "type": "arrow"
          }
        ],
        "subClass": "ammo",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 0.1
        }
      },
      {
        "class": "weapon",
        "id": "axe",
        "subClass": "weapon",
        "weight": 0.08
      },
      {
        "class": "bauldron",
        "id": "bauldron",
        "metadata": [
          {
            "class": "bauldron",
            "color": "brown",
            "spriteId": null,
            "type": "bauldron"
          }
        ],
        "protection": 0.05,
        "subClass": "bauldron",
        "weight": 0.05
      },
      {
        "class": "shirt",
        "id": "blouse",
        "protection": 0.01,
        "subClass": "shirt"
      },
      {
        "class": "shirt",
        "id": "blouse_longsleeve",
        "protection": 0.01,
        "subClass": "shirt"
      },
      {
        "class": "shoes",
        "id": "boots",
        "protection": 0.01,
        "subClass": "shoes"
      },
      {
        "class": "weapon",
        "id": "bow",
        "subClass": "weapon",
        "weight": 0.05
      },
      {
        "characteristics": {
          "placementAction": "use",
          "placementRange": 1,
          "useHasWorldEffect": true,
          "useable": true
        },
        "class": "structure",
        "id": "campfire",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": null,
            "type": "campfire"
          }
        ],
        "subClass": "structure"
      },
      {
        "class": "cape",
        "id": "cape-solid",
        "subClass": "cape"
      },
      {
        "class": "cape",
        "id": "cape-tattered",
        "subClass": "cape"
      },
      {
        "class": "cape",
        "id": "cape-trimmed",
        "subClass": "cape"
      },
      {
        "characteristics": {
          "stackable": true
        },
        "class": "key",
        "id": "castlekey",
        "metadata": [
          {
            "class": "key",
            "color": "gold",
            "spriteId": null,
            "type": "castlekey"
          }
        ],
        "subClass": "key"
      },
      {
        "characteristics": {
          "buildType": "entity",
          "buildable": true,
          "exclusiveReadiness": true,
          "placementAction": "build",
          "placementRange": 1,
          "stackable": false,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "chest-wood",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "container:140",
            "type": "chest-wood"
          }
        ],
        "sprite": "container:140",
        "subClass": "chest"
      },
      {
        "class": "resource",
        "id": "coal",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:161",
            "type": "coal"
          }
        ],
        "sprite": "ore:161",
        "subClass": "ore",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 3
        }
      },
      {
        "class": "resource",
        "id": "copper",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:180",
            "type": "copper"
          }
        ],
        "sprite": "ore:180",
        "subClass": "ore",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 9
        }
      },
      {
        "class": "shirt",
        "id": "corset",
        "protection": 0.01,
        "subClass": "shirt"
      },
      {
        "characteristics": {
          "unbuyable": true
        },
        "class": "weapon",
        "id": "crossbow",
        "subClass": "weapon"
      },
      {
        "class": "weapon",
        "id": "dagger",
        "metadata": [
          {
            "class": "weapon",
            "color": "brown",
            "spriteId": null,
            "type": "dagger"
          },
          {
            "class": "weapon",
            "color": "metal",
            "spriteId": null,
            "type": "dagger"
          }
        ],
        "subClass": "weapon",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 10
        }
      },
      {
        "characteristics": {
          "buildType": "entity",
          "buildable": true,
          "exclusiveReadiness": true,
          "stackable": false,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "door-wood",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "fence_medieval:478",
            "type": "door-wood"
          }
        ],
        "sprite": "fence_medieval:478",
        "subClass": "door"
      },
      {
        "characteristics": {
          "primaryUseable": true,
          "unbuyable": true,
          "useHasWorldEffect": true,
          "useable": true
        },
        "class": "resource",
        "id": "drumstick",
        "metadata": [
          {
            "class": "resource",
            "color": "brown",
            "spriteId": null,
            "type": "drumstick"
          }
        ],
        "subClass": "drumstick",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 10
        }
      },
      {
        "characteristics": {
          "unbuyable": true,
          "unsellable": true
        },
        "class": "resource",
        "id": "feather",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:72",
            "type": "feather"
          }
        ],
        "sprite": "ore:72",
        "subClass": "craftResource",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 10
        }
      },
      {
        "characteristics": {
          "unbuyable": true
        },
        "class": "weapon",
        "id": "flail",
        "subClass": "weapon"
      },
      {
        "characteristics": {
          "buildType": "floor",
          "buildable": true,
          "exclusiveReadiness": true,
          "stackable": true,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "floor-cobble",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "floors:225",
            "type": "floor-cobble"
          }
        ],
        "sprite": "floors:225",
        "subClass": "floor"
      },
      {
        "characteristics": {
          "buildType": "floor",
          "buildable": true,
          "exclusiveReadiness": true,
          "stackable": true,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "floor-stone",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "floors:129",
            "type": "floor-stone"
          }
        ],
        "sprite": "floors:129",
        "subClass": "floor"
      },
      {
        "characteristics": {
          "buildType": "floor",
          "buildable": true,
          "campfireFuel": true,
          "exclusiveReadiness": true,
          "stackable": true,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "floor-wood",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "floors:33",
            "type": "floor-wood"
          }
        ],
        "sprite": "floors:33",
        "subClass": "floor"
      },
      {
        "characteristics": {
          "unbuyable": true,
          "unsellable": true
        },
        "class": "resource",
        "id": "flower-single-blue",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "lpc-flowers-plants-fungi-wood:104",
            "type": "flower-single-blue"
          }
        ],
        "sprite": "lpc-flowers-plants-fungi-wood:104",
        "subClass": "flower"
      },
      {
        "characteristics": {
          "unbuyable": true,
          "unsellable": true
        },
        "class": "resource",
        "id": "flower-single-purple",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "lpc-flowers-plants-fungi-wood:103",
            "type": "flower-single-purple"
          }
        ],
        "sprite": "lpc-flowers-plants-fungi-wood:103",
        "subClass": "flower"
      },
      {
        "characteristics": {
          "unbuyable": true,
          "unsellable": true
        },
        "class": "resource",
        "id": "flower-single-red",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "lpc-flowers-plants-fungi-wood:105",
            "type": "flower-single-red"
          }
        ],
        "sprite": "lpc-flowers-plants-fungi-wood:105",
        "subClass": "flower"
      },
      {
        "characteristics": {
          "unbuyable": true,
          "unsellable": true
        },
        "class": "resource",
        "id": "flower-single-yellow",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "lpc-flowers-plants-fungi-wood:106",
            "type": "flower-single-yellow"
          }
        ],
        "sprite": "lpc-flowers-plants-fungi-wood:106",
        "subClass": "flower"
      },
      {
        "class": "resource",
        "id": "gold",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:182",
            "type": "gold"
          }
        ],
        "sprite": "ore:182",
        "subClass": "ore",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 15
        }
      },
      {
        "characteristics": {
          "unbuyable": true
        },
        "class": "weapon",
        "id": "halberd",
        "subClass": "weapon"
      },
      {
        "characteristics": {
          "unbuyable": true
        },
        "class": "resource",
        "id": "hide",
        "metadata": [
          {
            "class": "resource",
            "color": "brown",
            "spriteId": null,
            "type": "hide"
          }
        ],
        "subClass": "hide",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 2
        }
      },
      {
        "class": "resource",
        "id": "iron",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:179",
            "type": "iron"
          }
        ],
        "sprite": "ore:179",
        "subClass": "ore",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 6
        }
      },
      {
        "class": "pants",
        "id": "legion",
        "metadata": [
          {
            "class": "pants",
            "color": "brown",
            "spriteId": null,
            "type": "legion"
          }
        ],
        "protection": 0.1,
        "subClass": "pants",
        "weight": 0.1
      },
      {
        "class": "shirt",
        "id": "longsleeve",
        "protection": 0.01,
        "subClass": "shirt"
      },
      {
        "class": "shirt",
        "id": "longsleeve_laced",
        "protection": 0.01,
        "subClass": "shirt"
      },
      {
        "characteristics": {
          "unbuyable": true
        },
        "class": "weapon",
        "id": "longsword",
        "subClass": "weapon"
      },
      {
        "characteristics": {
          "unbuyable": true
        },
        "class": "weapon",
        "id": "mace",
        "subClass": "weapon"
      },
      {
        "class": "resource",
        "id": "metal-bar-copper",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:180",
            "type": "metal-bar-copper"
          }
        ],
        "sprite": "ore:180",
        "subClass": "metalBar",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 45
        }
      },
      {
        "class": "resource",
        "id": "metal-bar-gold",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:182",
            "type": "metal-bar-gold"
          }
        ],
        "sprite": "ore:182",
        "subClass": "metalBar",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 80
        }
      },
      {
        "class": "resource",
        "id": "metal-bar-iron",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:179",
            "type": "metal-bar-iron"
          }
        ],
        "sprite": "ore:179",
        "subClass": "metalBar",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 30
        }
      },
      {
        "class": "resource",
        "id": "metal-bar-silver",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:181",
            "type": "metal-bar-silver"
          }
        ],
        "sprite": "ore:181",
        "subClass": "metalBar",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 60
        }
      },
      {
        "characteristics": {
          "unbuyable": true,
          "useHasWorldEffect": true,
          "useable": true
        },
        "class": "resource",
        "id": "mushroom-purple",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "lpc-flowers-plants-fungi-wood:353",
            "type": "mushroom-purple"
          }
        ],
        "sprite": "lpc-flowers-plants-fungi-wood:353",
        "subClass": "mushroom"
      },
      {
        "characteristics": {
          "unbuyable": true,
          "useHasWorldEffect": true,
          "useable": true
        },
        "class": "resource",
        "id": "mushroom-red",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "lpc-flowers-plants-fungi-wood:355",
            "type": "mushroom-red"
          }
        ],
        "sprite": "lpc-flowers-plants-fungi-wood:355",
        "subClass": "mushroom"
      },
      {
        "characteristics": {
          "unbuyable": true,
          "useHasWorldEffect": true,
          "useable": true
        },
        "class": "resource",
        "id": "mushroom-yellow",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "lpc-flowers-plants-fungi-wood:354",
            "type": "mushroom-yellow"
          }
        ],
        "sprite": "lpc-flowers-plants-fungi-wood:354",
        "subClass": "mushroom"
      },
      {
        "characteristics": {
          "hasDurability": false
        },
        "class": "weapon",
        "id": "none",
        "subClass": "weapon"
      },
      {
        "class": "pants",
        "id": "pantaloons",
        "protection": 0.01,
        "subClass": "pants"
      },
      {
        "class": "pants",
        "id": "pants",
        "subClass": "pants"
      },
      {
        "class": "pants",
        "id": "pants-armor",
        "protection": 0.1,
        "subClass": "pants",
        "weight": 0.1
      },
      {
        "class": "resource",
        "id": "planks",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:25",
            "type": "planks"
          }
        ],
        "sprite": "ore:25",
        "subClass": "craftResource"
      },
      {
        "characteristics": {
          "buildType": "wall",
          "buildable": true,
          "exclusiveReadiness": true,
          "stackable": true,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "railing-wood",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "fence_medieval:1",
            "type": "railing-wood"
          }
        ],
        "sprite": "fence_medieval:1",
        "subClass": "wall"
      },
      {
        "characteristics": {
          "unbuyable": true
        },
        "class": "weapon",
        "id": "rapier",
        "subClass": "weapon"
      },
      {
        "characteristics": {
          "buildType": "roof",
          "buildable": true,
          "campfireFuel": true,
          "exclusiveReadiness": true,
          "stackable": true,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "roof-wood",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:807",
            "type": "roof-wood"
          }
        ],
        "sprite": "authored-terrain:807",
        "subClass": "roof"
      },
      {
        "characteristics": {
          "unbuyable": true
        },
        "class": "resource",
        "id": "rope",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:88",
            "type": "rope"
          }
        ],
        "sprite": "ore:88",
        "subClass": "craftResource"
      },
      {
        "characteristics": {
          "unbuyable": true
        },
        "class": "weapon",
        "id": "saber",
        "subClass": "weapon"
      },
      {
        "class": "shoes",
        "id": "sandals",
        "protection": 0.01,
        "subClass": "shoes"
      },
      {
        "class": "shirt",
        "id": "scoop_shirt",
        "protection": 0.01,
        "subClass": "shirt"
      },
      {
        "characteristics": {
          "unbuyable": true
        },
        "class": "weapon",
        "id": "scythe",
        "subClass": "weapon"
      },
      {
        "characteristics": {
          "noAutoReady": true,
          "placementAction": "use",
          "placementRange": 1,
          "unbuyable": true,
          "unsellable": true,
          "useHasWorldEffect": true,
          "useable": true
        },
        "class": "resource",
        "id": "seed",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          }
        ],
        "sprite": "item-art-1a07b84a0c63a7a63c4f:1",
        "subClass": "seed"
      },
      {
        "characteristics": {
          "noAutoReady": true,
          "placementAction": "use",
          "placementRange": 1,
          "unbuyable": true,
          "unsellable": true,
          "useHasWorldEffect": true,
          "useable": true
        },
        "class": "resource",
        "id": "grass-seed",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-08bd1c8b4020c28035f1:1",
            "type": "grass-seed"
          }
        ],
        "sprite": "item-art-08bd1c8b4020c28035f1:1",
        "subClass": "seed"
      },
      {
        "class": "resource",
        "id": "shard-metal",
        "metadata": [
          {
            "class": "resource",
            "color": "gray",
            "type": "shard-metal"
          }
        ],
        "subClass": "shard"
      },
      {
        "class": "shield",
        "id": "shield-crusader",
        "metadata": [
          {
            "class": "shield",
            "color": "white",
            "spriteId": null,
            "type": "shield-crusader"
          }
        ],
        "protection": 0.2,
        "subClass": "shield",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 120
        },
        "weight": 0.2
      },
      {
        "class": "shield",
        "id": "shield-kite",
        "metadata": [
          {
            "class": "shield",
            "color": "white",
            "spriteId": null,
            "type": "shield-kite"
          }
        ],
        "protection": 0.2,
        "subClass": "shield",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 120
        },
        "weight": 0.2
      },
      {
        "class": "shield",
        "id": "shield-kite_blue",
        "protection": 0.2,
        "subClass": "shield",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 120
        },
        "weight": 0.2
      },
      {
        "class": "shield",
        "id": "shield-kite_gray",
        "protection": 0.2,
        "subClass": "shield",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 120
        },
        "weight": 0.2
      },
      {
        "class": "shield",
        "id": "shield-kite_green",
        "protection": 0.2,
        "subClass": "shield",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 120
        },
        "weight": 0.2
      },
      {
        "class": "shield",
        "id": "shield-kite_red",
        "protection": 0.2,
        "subClass": "shield",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 120
        },
        "weight": 0.2
      },
      {
        "class": "shield",
        "id": "shield-round",
        "metadata": [
          {
            "class": "shield",
            "color": "brown",
            "spriteId": null,
            "type": "shield-round"
          }
        ],
        "protection": 0.1,
        "subClass": "shield",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 120
        },
        "weight": 0.1
      },
      {
        "class": "shield",
        "id": "shield-spartan",
        "protection": 0.15,
        "subClass": "shield",
        "weight": 0.15
      },
      {
        "class": "shoes",
        "id": "shoes",
        "protection": 0.01,
        "subClass": "shoes"
      },
      {
        "class": "shoes",
        "id": "shoes-armor",
        "protection": 0.1,
        "subClass": "shoes",
        "weight": 0.1
      },
      {
        "class": "resource",
        "id": "silver",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:181",
            "type": "silver"
          }
        ],
        "sprite": "ore:181",
        "subClass": "ore",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 12
        }
      },
      {
        "class": "pants",
        "id": "skirts",
        "protection": 0.01,
        "subClass": "pants"
      },
      {
        "class": "shirt",
        "id": "sleeveless",
        "protection": 0.01,
        "subClass": "shirt"
      },
      {
        "class": "shirt",
        "id": "sleeveless_laced",
        "protection": 0.01,
        "subClass": "shirt"
      },
      {
        "class": "shirt",
        "id": "sleeveless_striped",
        "protection": 0.01,
        "subClass": "shirt"
      },
      {
        "class": "shoes",
        "id": "slippers",
        "protection": 0.01,
        "subClass": "shoes",
        "weight": 0.01
      },
      {
        "characteristics": {
          "useHasWorldEffect": true,
          "useable": true
        },
        "class": "structure",
        "id": "snare-rabbit",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "snare-rabbit.png",
            "type": "snare-rabbit"
          }
        ],
        "sprite": "snare-rabbit.png",
        "subClass": "structure"
      },
      {
        "class": "weapon",
        "id": "spear",
        "subClass": "weapon",
        "trade": {
          "itemType": "shard-metal",
          "quantity": 20
        },
        "weight": 0.05
      },
      {
        "characteristics": {
          "unbuyable": true
        },
        "class": "weapon",
        "id": "staff",
        "subClass": "weapon",
        "weight": 0.05
      },
      {
        "class": "resource",
        "id": "stick",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:26",
            "type": "stick"
          }
        ],
        "sprite": "ore:26",
        "subClass": "craftResource"
      },
      {
        "characteristics": {
          "buildable": true,
          "exclusiveReadiness": true,
          "stackable": false,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "stool-small",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "furniture-blonde-wood:126",
            "type": "stool-small"
          }
        ],
        "sprite": "furniture-blonde-wood:126",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "unbuyable": true,
          "unsellable": true
        },
        "class": "resource",
        "id": "straw",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-b9ef00e25a4177065abd:1",
            "type": "straw"
          }
        ],
        "sprite": "item-art-b9ef00e25a4177065abd:1",
        "subClass": "straw"
      },
      {
        "characteristics": {
          "buildable": true,
          "exclusiveReadiness": true,
          "stackable": false,
          "useHasWorldEffect": true,
          "useable": false
        },
        "class": "structure",
        "id": "table-large-rough",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "furniture-blonde-wood:458",
            "type": "table-large-rough"
          }
        ],
        "sprite": "furniture-blonde-wood:458",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildable": true,
          "exclusiveReadiness": true,
          "stackable": false,
          "useHasWorldEffect": true,
          "useable": false
        },
        "class": "structure",
        "id": "table-mid-round",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "furniture-blonde-wood:124",
            "type": "table-mid-round"
          }
        ],
        "sprite": "furniture-blonde-wood:124",
        "subClass": "structure"
      },
      {
        "class": "shirt",
        "id": "tanktop",
        "protection": 0.01,
        "subClass": "shirt"
      },
      {
        "characteristics": {
          "useable": true
        },
        "class": "resource",
        "id": "torch",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": null,
            "type": "torch"
          }
        ],
        "subClass": "torch"
      },
      {
        "class": "shirt",
        "id": "tunic",
        "protection": 0.01,
        "subClass": "shirt"
      },
      {
        "characteristics": {
          "buildType": "wall",
          "buildable": true,
          "campfireFuel": true,
          "exclusiveReadiness": true,
          "stackable": true,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "wall-wood",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:643",
            "type": "wall-wood"
          }
        ],
        "sprite": "authored-terrain:643",
        "subClass": "wall"
      },
      {
        "characteristics": {
          "buildType": "wall",
          "buildable": true,
          "exclusiveReadiness": true,
          "stackable": true,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "wall2-wood",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "walls2:43",
            "type": "wall2-wood"
          }
        ],
        "sprite": "walls2:43",
        "subClass": "wall"
      },
      {
        "characteristics": {
          "buildType": "wall",
          "buildable": true,
          "exclusiveReadiness": true,
          "stackable": true,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "wall-stone",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "walls2:53",
            "type": "wall-stone"
          }
        ],
        "sprite": "walls2:53",
        "subClass": "wall"
      },
      {
        "characteristics": {
          "unbuyable": true
        },
        "class": "weapon",
        "id": "waraxe",
        "subClass": "weapon"
      },
      {
        "characteristics": {
          "unbuyable": true
        },
        "class": "weapon",
        "id": "warhammer",
        "subClass": "weapon",
        "weight": 0.1
      },
      {
        "class": "weapon",
        "id": "web",
        "metadata": [
          {
            "class": "weapon",
            "color": "white",
            "type": "web"
          }
        ],
        "subClass": "weapon"
      },
      {
        "class": "resource",
        "id": "webAmmo",
        "metadata": [
          {
            "class": "resource",
            "color": "white",
            "type": "webAmmo"
          }
        ],
        "subClass": "ammo"
      },
      {
        "characteristics": {
          "campfireFuel": true,
          "exclusiveReadiness": true,
          "primaryUseable": true,
          "unbuyable": true
        },
        "class": "resource",
        "id": "wood",
        "metadata": [
          {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          }
        ],
        "subClass": "wood"
      },
      {
        "characteristics": {
          "isAmmo": true,
          "stackable": true,
          "unbuyable": true,
          "unsellable": true
        },
        "class": "resource",
        "id": "ember-charge",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:180",
            "type": "ember-charge"
          }
        ],
        "sprite": "ore:180",
        "subClass": "ammo"
      },
      {
        "characteristics": {
          "stackable": true,
          "unbuyable": true,
          "unsellable": true
        },
        "class": "resource",
        "id": "spider-silk",
        "metadata": [
          {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:88",
            "type": "spider-silk"
          }
        ],
        "sprite": "ore:88",
        "subClass": "craftResource"
      },
      {
        "characteristics": {
          "buildable": true,
          "readyable": true,
          "unbuyable": true
        },
        "class": "structure",
        "id": "barrel1",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "container:60",
            "type": "barrel1"
          }
        ],
        "sprite": "container:60",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildable": true,
          "readyable": true,
          "unbuyable": true
        },
        "class": "structure",
        "id": "stackedBags",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "container:449",
            "type": "stackedBags"
          }
        ],
        "sprite": "container:449",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildable": true,
          "readyable": true,
          "unbuyable": true,
          "useable": false
        },
        "class": "structure",
        "id": "stool1",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "furniture-blond-wood:128",
            "type": "stool1"
          }
        ],
        "sprite": "furniture-blond-wood:128",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildable": true,
          "readyable": true,
          "unbuyable": true,
          "useable": false
        },
        "class": "structure",
        "id": "table-mid-rough",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "furniture-blonde-wood:141",
            "type": "table-mid-rough"
          }
        ],
        "sprite": "furniture-blonde-wood:141",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildable": true,
          "readyable": true,
          "unbuyable": true,
          "useable": false
        },
        "class": "structure",
        "id": "strawBed",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "build_atlas:684",
            "type": "strawBed"
          }
        ],
        "sprite": "build_atlas:684",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildable": true,
          "readyable": true,
          "unbuyable": true,
          "useable": false
        },
        "class": "structure",
        "id": "strawBedSmall",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "build_atlas:684",
            "type": "strawBedSmall"
          }
        ],
        "sprite": "build_atlas:684",
        "subClass": "structure"
      },
      {
        "class": "weapon",
        "id": "iron-pickaxe",
        "metadata": [
          {
            "class": "weapon",
            "color": "na",
            "spriteId": "item-art-b1d5a86cbcd21ed656d3:1",
            "type": "iron-pickaxe"
          }
        ],
        "sprite": "item-art-b1d5a86cbcd21ed656d3:1",
        "subClass": "weapon",
        "weight": 0.08
      },
      {
        "characteristics": {
          "buildType": "entity",
          "buildable": true,
          "deactivateAfterPlacement": true,
          "exclusiveReadiness": true,
          "placementAction": "build",
          "stackable": false,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "stairs",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "stairs-icon:1",
            "type": "stairs"
          }
        ],
        "sprite": "stairs-icon:1",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildType": "entity",
          "buildable": false,
          "stackable": false
        },
        "class": "structure",
        "id": "floor-opening",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:3",
            "type": "floor-opening"
          }
        ],
        "sprite": "authored-terrain:3",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildType": "wall",
          "buildable": true,
          "exclusiveReadiness": true,
          "stackable": true,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "timber-frame-wall",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:50",
            "type": "timber-frame-wall"
          }
        ],
        "sprite": "authored-terrain:50",
        "subClass": "wall"
      },
      {
        "characteristics": {
          "buildType": "roof",
          "buildable": true,
          "exclusiveReadiness": true,
          "stackable": true,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "thatch-roof",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:378",
            "type": "thatch-roof"
          }
        ],
        "sprite": "authored-terrain:378",
        "subClass": "roof"
      },
      {
        "characteristics": {
          "buildType": "wall",
          "buildable": true,
          "exclusiveReadiness": true,
          "ornament": "window",
          "stackable": true,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "window-frame",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:419",
            "type": "window-frame"
          }
        ],
        "sprite": "authored-terrain:419",
        "subClass": "window"
      },
      {
        "characteristics": {
          "buildType": "roof",
          "buildable": true,
          "exclusiveReadiness": true,
          "ornament": "chimney",
          "stackable": true,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "chimney-stack",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:421",
            "type": "chimney-stack"
          }
        ],
        "sprite": "authored-terrain:421",
        "subClass": "chimney"
      },
      {
        "characteristics": {
          "buildType": "roof",
          "buildable": true,
          "exclusiveReadiness": true,
          "ornament": "dormer",
          "stackable": true,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "dormer-window",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:424",
            "type": "dormer-window"
          }
        ],
        "sprite": "authored-terrain:424",
        "subClass": "dormer"
      },
      {
        "characteristics": {
          "buildType": "entity",
          "buildable": true,
          "placementAction": "build",
          "placementRange": 1,
          "stackable": true
        },
        "class": "structure",
        "id": "grove-oak-a",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "item-art-887e0636d4bbe2a4f448:1",
            "type": "grove-oak-a"
          }
        ],
        "sprite": "item-art-887e0636d4bbe2a4f448:1",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildType": "entity",
          "buildable": true,
          "placementAction": "build",
          "placementRange": 1,
          "stackable": true
        },
        "class": "structure",
        "id": "grove-oak-b",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "item-art-f728e0bbaefbd1982b2d:1",
            "type": "grove-oak-b"
          }
        ],
        "sprite": "item-art-f728e0bbaefbd1982b2d:1",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildType": "entity",
          "buildable": true,
          "placementAction": "build",
          "placementRange": 1,
          "stackable": true
        },
        "class": "structure",
        "id": "grove-spruce-a",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "item-art-35c925e4db81912bfe38:1",
            "type": "grove-spruce-a"
          }
        ],
        "sprite": "item-art-35c925e4db81912bfe38:1",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildType": "entity",
          "buildable": true,
          "placementAction": "build",
          "placementRange": 1,
          "stackable": true
        },
        "class": "structure",
        "id": "grove-spruce-b",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "item-art-99ea85dcdc93fac8db18:1",
            "type": "grove-spruce-b"
          }
        ],
        "sprite": "item-art-99ea85dcdc93fac8db18:1",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildType": "entity",
          "buildable": true,
          "placementAction": "build",
          "placementRange": 1,
          "stackable": true
        },
        "class": "structure",
        "id": "grove-round-a",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "item-art-bb4afa7ce4e3c1ba55ba:1",
            "type": "grove-round-a"
          }
        ],
        "sprite": "item-art-bb4afa7ce4e3c1ba55ba:1",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildType": "entity",
          "buildable": true,
          "placementAction": "build",
          "placementRange": 1,
          "stackable": true
        },
        "class": "structure",
        "id": "grove-round-b",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "item-art-e46e4dec4aea45bf9d8e:1",
            "type": "grove-round-b"
          }
        ],
        "sprite": "item-art-e46e4dec4aea45bf9d8e:1",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildType": "entity",
          "buildable": true,
          "placementAction": "build",
          "placementRange": 1,
          "stackable": true
        },
        "class": "structure",
        "id": "grove-low-a",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "item-art-32902d50537ebad17e79:1",
            "type": "grove-low-a"
          }
        ],
        "sprite": "item-art-32902d50537ebad17e79:1",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildType": "entity",
          "buildable": true,
          "placementAction": "build",
          "placementRange": 1,
          "stackable": true
        },
        "class": "structure",
        "id": "grove-low-b",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "item-art-5902c8b486e89c8f8e57:1",
            "type": "grove-low-b"
          }
        ],
        "sprite": "item-art-5902c8b486e89c8f8e57:1",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildType": "entity",
          "buildable": true,
          "placementAction": "build",
          "placementRange": 1,
          "stackable": true
        },
        "class": "structure",
        "id": "meadow-grass-a",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "item-art-ebdd046fea0f3ab21669:1",
            "type": "meadow-grass-a"
          }
        ],
        "sprite": "item-art-ebdd046fea0f3ab21669:1",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildType": "entity",
          "buildable": true,
          "placementAction": "build",
          "placementRange": 1,
          "stackable": true
        },
        "class": "structure",
        "id": "meadow-grass-b",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "item-art-4d6c318ef966e097227a:1",
            "type": "meadow-grass-b"
          }
        ],
        "sprite": "item-art-4d6c318ef966e097227a:1",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildType": "entity",
          "buildable": true,
          "placementAction": "build",
          "placementRange": 1,
          "stackable": true
        },
        "class": "structure",
        "id": "meadow-grass-c",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "item-art-721c3f8a8d4621a46f90:1",
            "type": "meadow-grass-c"
          }
        ],
        "sprite": "item-art-721c3f8a8d4621a46f90:1",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildType": "entity",
          "buildable": true,
          "placementAction": "build",
          "placementRange": 1,
          "stackable": true
        },
        "class": "structure",
        "id": "meadow-grass-d",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "item-art-7fc02d2406eaa57e3be0:1",
            "type": "meadow-grass-d"
          }
        ],
        "sprite": "item-art-7fc02d2406eaa57e3be0:1",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildType": "entity",
          "buildable": true,
          "placementAction": "build",
          "placementRange": 1,
          "stackable": true
        },
        "class": "structure",
        "id": "meadow-grass-e",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "item-art-a7225776548a58ab4e04:1",
            "type": "meadow-grass-e"
          }
        ],
        "sprite": "item-art-a7225776548a58ab4e04:1",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildType": "entity",
          "buildable": true,
          "placementAction": "build",
          "placementRange": 1,
          "stackable": true
        },
        "class": "structure",
        "id": "meadow-grass-f",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "item-art-d9ecaed5ff4485611809:1",
            "type": "meadow-grass-f"
          }
        ],
        "sprite": "item-art-d9ecaed5ff4485611809:1",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildType": "entity",
          "buildable": true,
          "placementAction": "build",
          "placementRange": 1,
          "stackable": true
        },
        "class": "structure",
        "id": "meadow-sprout",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "item-art-af19df691fc7aa944194:1",
            "type": "meadow-sprout"
          }
        ],
        "sprite": "item-art-af19df691fc7aa944194:1",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildType": "entity",
          "buildable": false,
          "stackable": true
        },
        "class": "structure",
        "id": "hatch-wood",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "hatch-wood:1",
            "type": "hatch-wood"
          }
        ],
        "sprite": "hatch-wood:1",
        "subClass": "structure"
      },
      {
        "characteristics": {
          "buildType": "wall",
          "buildable": true,
          "exclusiveReadiness": true,
          "stackable": true,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "castle-footing",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:824",
            "type": "castle-footing"
          }
        ],
        "sprite": "authored-terrain:824",
        "subClass": "wall"
      },
      {
        "characteristics": {
          "buildType": "wall",
          "buildable": true,
          "exclusiveReadiness": true,
          "stackable": true,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "castle-wall",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:872",
            "type": "castle-wall"
          }
        ],
        "sprite": "authored-terrain:872",
        "subClass": "wall"
      },
      {
        "characteristics": {
          "buildType": "wall",
          "buildable": true,
          "exclusiveReadiness": true,
          "stackable": true,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "castle-merlons",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:924",
            "type": "castle-merlons"
          }
        ],
        "sprite": "authored-terrain:924",
        "subClass": "wall"
      },
      {
        "characteristics": {
          "buildType": "wall",
          "buildable": true,
          "exclusiveReadiness": true,
          "ornament": "arrow-slit",
          "stackable": true,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "arrow-slit",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:899",
            "type": "arrow-slit"
          }
        ],
        "sprite": "authored-terrain:899",
        "subClass": "window"
      },
      {
        "characteristics": {
          "buildType": "wall",
          "buildable": true,
          "exclusiveReadiness": true,
          "stackable": true,
          "useHasWorldEffect": true
        },
        "class": "structure",
        "id": "tower-render",
        "metadata": [
          {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:927",
            "type": "tower-render"
          }
        ],
        "sprite": "authored-terrain:927",
        "subClass": "wall"
      }
    ],
    "maps": {
      "collisionOverrides": {},
      "generatorInputs": [
        {
          "file": "maps/sources/housetemplate.tmj",
          "id": "house-template"
        }
      ],
      "historical": [
        {
          "file": "maps/archive/exports/r1.json",
          "note": "Earlier JSON export superseded by the room in maps/rooms; never loaded."
        },
        {
          "file": "maps/archive/exports/r2.json",
          "note": "Earlier JSON export superseded by the room in maps/rooms; never loaded."
        },
        {
          "file": "maps/archive/exports/r4.json",
          "note": "Earlier JSON export superseded by the room in maps/rooms; never loaded."
        },
        {
          "file": "maps/archive/exports/room1.json",
          "note": "Earlier JSON export superseded by the room in maps/rooms; never loaded."
        },
        {
          "file": "maps/archive/exports/room2.json",
          "note": "Earlier JSON export superseded by the room in maps/rooms; never loaded."
        },
        {
          "file": "maps/archive/exports/room3.json",
          "note": "Earlier JSON export superseded by the room in maps/rooms; never loaded."
        },
        {
          "file": "maps/archive/exports/room4.json",
          "note": "Earlier JSON export superseded by the room in maps/rooms; never loaded."
        },
        {
          "file": "maps/archive/exports/wave1.json",
          "note": "Earlier JSON export superseded by the room in maps/rooms; never loaded."
        },
        {
          "file": "maps/archive/exports/wave2.json",
          "note": "Earlier JSON export superseded by the room in maps/rooms; never loaded."
        },
        {
          "file": "maps/archive/map.png",
          "note": "Retired world bitmap; no reader."
        },
        {
          "file": "maps/archive/map2.png",
          "note": "Retired world bitmap; no reader."
        },
        {
          "file": "maps/archive/rooms/room-1-3.tmj",
          "note": "Older copy of a generated grid room; never loaded."
        },
        {
          "file": "maps/archive/rooms/room-7-5.tmj",
          "note": "Older copy of a generated grid room; never loaded."
        },
        {
          "file": "maps/archive/sources/atlas.tsx",
          "note": "Archived Tiled source; its tileset and exports are historical."
        },
        {
          "file": "maps/archive/sources/housetemplate2.tmj",
          "note": "Archived Tiled source; its tileset and exports are historical."
        },
        {
          "file": "maps/archive/sources/room1.tmx",
          "note": "Archived Tiled source; its tileset and exports are historical."
        },
        {
          "file": "maps/archive/sources/room2.tmx",
          "note": "Archived Tiled source; its tileset and exports are historical."
        },
        {
          "file": "maps/archive/sources/room3.tmx",
          "note": "Archived Tiled source; its tileset and exports are historical."
        },
        {
          "file": "maps/archive/sources/room4.tmx",
          "note": "Archived Tiled source; its tileset and exports are historical."
        },
        {
          "file": "maps/archive/wall-test.json",
          "note": "Retired room-definition experiment; not a Tiled map and never loaded."
        },
        {
          "file": "maps/sources/blank.tmx",
          "note": "Tiled source with no shipped room (roomId lab2)."
        },
        {
          "file": "maps/sources/openworld.tmx",
          "note": "Tiled source with no shipped room (roomId wilderness)."
        }
      ],
      "rooms": [
        {
          "file": "maps/rooms/cave-0-0.tmj",
          "id": "cave-0-0"
        },
        {
          "file": "maps/rooms/dome1.tmj",
          "id": "dome1",
          "provenance": "maps/sources/dome1.tmx"
        },
        {
          "file": "maps/rooms/dome2-lobby.tmj",
          "id": "dome2-lobby",
          "provenance": "maps/sources/dome2-lobby.tmx"
        },
        {
          "file": "maps/rooms/dome2.tmj",
          "id": "dome2",
          "provenance": "maps/sources/dome2.tmx"
        },
        {
          "file": "maps/rooms/dungeon-0-0.tmj",
          "id": "dungeon-0-0"
        },
        {
          "file": "maps/rooms/experiment.tmj",
          "id": "experiment",
          "provenance": "maps/sources/experiment.tmx"
        },
        {
          "file": "maps/rooms/house-0-0.tmj",
          "id": "house-0-0"
        },
        {
          "file": "maps/rooms/house-0-1.tmj",
          "id": "house-0-1"
        },
        {
          "file": "maps/rooms/lab.tmj",
          "id": "lab",
          "provenance": "maps/sources/lab.tmx"
        },
        {
          "file": "maps/rooms/lab1.tmj",
          "id": "lab1",
          "provenance": "maps/sources/lab1.tmx"
        },
        {
          "file": "maps/rooms/lab2.tmj",
          "id": "lab2",
          "provenance": "maps/sources/lab2.tmx"
        },
        {
          "file": "maps/rooms/lab3.tmj",
          "id": "lab3",
          "provenance": "maps/sources/lab3.tmx"
        },
        {
          "file": "maps/rooms/lpc.tmj",
          "id": "lpc",
          "provenance": "maps/sources/lpc.tmx"
        },
        {
          "file": "maps/rooms/playground.tmj",
          "id": "playground"
        },
        {
          "file": "maps/rooms/playground2.tmj",
          "id": "playground2"
        },
        {
          "file": "maps/rooms/r1.tmj",
          "id": "battleRoyale",
          "provenance": "maps/sources/r1.tmx"
        },
        {
          "file": "maps/rooms/r2.tmj",
          "id": "zombies",
          "provenance": "maps/sources/r2.tmx"
        },
        {
          "file": "maps/rooms/r3.tmj",
          "id": "lobby",
          "provenance": "maps/sources/r3.tmx"
        },
        {
          "file": "maps/rooms/r4.tmj",
          "id": "captureTheFlag",
          "provenance": "maps/sources/r4.tmx"
        },
        {
          "file": "maps/rooms/room-0-0.tmj",
          "id": "room-0-0"
        },
        {
          "file": "maps/rooms/room-0-1.tmj",
          "id": "room-0-1"
        },
        {
          "file": "maps/rooms/room-0-10.tmj",
          "id": "room-0-10"
        },
        {
          "file": "maps/rooms/room-0-11.tmj",
          "id": "room-0-11"
        },
        {
          "file": "maps/rooms/room-0-12.tmj",
          "id": "room-0-12"
        },
        {
          "file": "maps/rooms/room-0-13.tmj",
          "id": "room-0-13"
        },
        {
          "file": "maps/rooms/room-0-14.tmj",
          "id": "room-0-14"
        },
        {
          "file": "maps/rooms/room-0-15.tmj",
          "id": "room-0-15"
        },
        {
          "file": "maps/rooms/room-0-2.tmj",
          "id": "room-0-2"
        },
        {
          "file": "maps/rooms/room-0-3.tmj",
          "id": "room-0-3"
        },
        {
          "file": "maps/rooms/room-0-4.tmj",
          "id": "room-0-4"
        },
        {
          "file": "maps/rooms/room-0-5.tmj",
          "id": "room-0-5"
        },
        {
          "file": "maps/rooms/room-0-6.tmj",
          "id": "room-0-6"
        },
        {
          "file": "maps/rooms/room-0-7.tmj",
          "id": "room-0-7"
        },
        {
          "file": "maps/rooms/room-0-8.tmj",
          "id": "room-0-8"
        },
        {
          "file": "maps/rooms/room-0-9.tmj",
          "id": "room-0-9"
        },
        {
          "file": "maps/rooms/room-1-0.tmj",
          "id": "room-1-0"
        },
        {
          "file": "maps/rooms/room-1-1.tmj",
          "id": "room-1-1"
        },
        {
          "file": "maps/rooms/room-1-10.tmj",
          "id": "room-1-10"
        },
        {
          "file": "maps/rooms/room-1-11.tmj",
          "id": "room-1-11"
        },
        {
          "file": "maps/rooms/room-1-12.tmj",
          "id": "room-1-12"
        },
        {
          "file": "maps/rooms/room-1-13.tmj",
          "id": "room-1-13"
        },
        {
          "file": "maps/rooms/room-1-14.tmj",
          "id": "room-1-14"
        },
        {
          "file": "maps/rooms/room-1-15.tmj",
          "id": "room-1-15"
        },
        {
          "file": "maps/rooms/room-1-2.tmj",
          "id": "room-1-2"
        },
        {
          "file": "maps/rooms/room-1-3.tmj",
          "id": "room-1-3"
        },
        {
          "file": "maps/rooms/room-1-4.tmj",
          "id": "room-1-4"
        },
        {
          "file": "maps/rooms/room-1-5.tmj",
          "id": "room-1-5"
        },
        {
          "file": "maps/rooms/room-1-6.tmj",
          "id": "room-1-6"
        },
        {
          "file": "maps/rooms/room-1-7.tmj",
          "id": "room-1-7"
        },
        {
          "file": "maps/rooms/room-1-8.tmj",
          "id": "room-1-8"
        },
        {
          "file": "maps/rooms/room-1-9.tmj",
          "id": "room-1-9"
        },
        {
          "file": "maps/rooms/room-10-0.tmj",
          "id": "room-10-0"
        },
        {
          "file": "maps/rooms/room-10-1.tmj",
          "id": "room-10-1"
        },
        {
          "file": "maps/rooms/room-10-10.tmj",
          "id": "room-10-10"
        },
        {
          "file": "maps/rooms/room-10-11.tmj",
          "id": "room-10-11"
        },
        {
          "file": "maps/rooms/room-10-12.tmj",
          "id": "room-10-12"
        },
        {
          "file": "maps/rooms/room-10-13.tmj",
          "id": "room-10-13"
        },
        {
          "file": "maps/rooms/room-10-14.tmj",
          "id": "room-10-14"
        },
        {
          "file": "maps/rooms/room-10-15.tmj",
          "id": "room-10-15"
        },
        {
          "file": "maps/rooms/room-10-2.tmj",
          "id": "room-10-2"
        },
        {
          "file": "maps/rooms/room-10-3.tmj",
          "id": "room-10-3"
        },
        {
          "file": "maps/rooms/room-10-4.tmj",
          "id": "room-10-4"
        },
        {
          "file": "maps/rooms/room-10-5.tmj",
          "id": "room-10-5"
        },
        {
          "file": "maps/rooms/room-10-6.tmj",
          "id": "room-10-6"
        },
        {
          "file": "maps/rooms/room-10-7.tmj",
          "id": "room-10-7"
        },
        {
          "file": "maps/rooms/room-10-8.tmj",
          "id": "room-10-8"
        },
        {
          "file": "maps/rooms/room-10-9.tmj",
          "id": "room-10-9"
        },
        {
          "file": "maps/rooms/room-11-0.tmj",
          "id": "room-11-0"
        },
        {
          "file": "maps/rooms/room-11-1.tmj",
          "id": "room-11-1"
        },
        {
          "file": "maps/rooms/room-11-10.tmj",
          "id": "room-11-10"
        },
        {
          "file": "maps/rooms/room-11-11.tmj",
          "id": "room-11-11"
        },
        {
          "file": "maps/rooms/room-11-12.tmj",
          "id": "room-11-12"
        },
        {
          "file": "maps/rooms/room-11-13.tmj",
          "id": "room-11-13"
        },
        {
          "file": "maps/rooms/room-11-14.tmj",
          "id": "room-11-14"
        },
        {
          "file": "maps/rooms/room-11-15.tmj",
          "id": "room-11-15"
        },
        {
          "file": "maps/rooms/room-11-2.tmj",
          "id": "room-11-2"
        },
        {
          "file": "maps/rooms/room-11-3.tmj",
          "id": "room-11-3"
        },
        {
          "file": "maps/rooms/room-11-4.tmj",
          "id": "room-11-4"
        },
        {
          "file": "maps/rooms/room-11-5.tmj",
          "id": "room-11-5"
        },
        {
          "file": "maps/rooms/room-11-6.tmj",
          "id": "room-11-6"
        },
        {
          "file": "maps/rooms/room-11-7.tmj",
          "id": "room-11-7"
        },
        {
          "file": "maps/rooms/room-11-8.tmj",
          "id": "room-11-8"
        },
        {
          "file": "maps/rooms/room-11-9.tmj",
          "id": "room-11-9"
        },
        {
          "file": "maps/rooms/room-12-0.tmj",
          "id": "room-12-0"
        },
        {
          "file": "maps/rooms/room-12-1.tmj",
          "id": "room-12-1"
        },
        {
          "file": "maps/rooms/room-12-10.tmj",
          "id": "room-12-10"
        },
        {
          "file": "maps/rooms/room-12-11.tmj",
          "id": "room-12-11"
        },
        {
          "file": "maps/rooms/room-12-12.tmj",
          "id": "room-12-12"
        },
        {
          "file": "maps/rooms/room-12-13.tmj",
          "id": "room-12-13"
        },
        {
          "file": "maps/rooms/room-12-14.tmj",
          "id": "room-12-14"
        },
        {
          "file": "maps/rooms/room-12-15.tmj",
          "id": "room-12-15"
        },
        {
          "file": "maps/rooms/room-12-2.tmj",
          "id": "room-12-2"
        },
        {
          "file": "maps/rooms/room-12-3.tmj",
          "id": "room-12-3"
        },
        {
          "file": "maps/rooms/room-12-4.tmj",
          "id": "room-12-4"
        },
        {
          "file": "maps/rooms/room-12-5.tmj",
          "id": "room-12-5"
        },
        {
          "file": "maps/rooms/room-12-6.tmj",
          "id": "room-12-6"
        },
        {
          "file": "maps/rooms/room-12-7.tmj",
          "id": "room-12-7"
        },
        {
          "file": "maps/rooms/room-12-8.tmj",
          "id": "room-12-8"
        },
        {
          "file": "maps/rooms/room-12-9.tmj",
          "id": "room-12-9"
        },
        {
          "file": "maps/rooms/room-13-0.tmj",
          "id": "room-13-0"
        },
        {
          "file": "maps/rooms/room-13-1.tmj",
          "id": "room-13-1"
        },
        {
          "file": "maps/rooms/room-13-10.tmj",
          "id": "room-13-10"
        },
        {
          "file": "maps/rooms/room-13-11.tmj",
          "id": "room-13-11"
        },
        {
          "file": "maps/rooms/room-13-12.tmj",
          "id": "room-13-12"
        },
        {
          "file": "maps/rooms/room-13-13.tmj",
          "id": "room-13-13"
        },
        {
          "file": "maps/rooms/room-13-14.tmj",
          "id": "room-13-14"
        },
        {
          "file": "maps/rooms/room-13-15.tmj",
          "id": "room-13-15"
        },
        {
          "file": "maps/rooms/room-13-2.tmj",
          "id": "room-13-2"
        },
        {
          "file": "maps/rooms/room-13-3.tmj",
          "id": "room-13-3"
        },
        {
          "file": "maps/rooms/room-13-4.tmj",
          "id": "room-13-4"
        },
        {
          "file": "maps/rooms/room-13-5.tmj",
          "id": "room-13-5"
        },
        {
          "file": "maps/rooms/room-13-6.tmj",
          "id": "room-13-6"
        },
        {
          "file": "maps/rooms/room-13-7.tmj",
          "id": "room-13-7"
        },
        {
          "file": "maps/rooms/room-13-8.tmj",
          "id": "room-13-8"
        },
        {
          "file": "maps/rooms/room-13-9.tmj",
          "id": "room-13-9"
        },
        {
          "file": "maps/rooms/room-14-0.tmj",
          "id": "room-14-0"
        },
        {
          "file": "maps/rooms/room-14-1.tmj",
          "id": "room-14-1"
        },
        {
          "file": "maps/rooms/room-14-10.tmj",
          "id": "room-14-10"
        },
        {
          "file": "maps/rooms/room-14-11.tmj",
          "id": "room-14-11"
        },
        {
          "file": "maps/rooms/room-14-12.tmj",
          "id": "room-14-12"
        },
        {
          "file": "maps/rooms/room-14-13.tmj",
          "id": "room-14-13"
        },
        {
          "file": "maps/rooms/room-14-14.tmj",
          "id": "room-14-14"
        },
        {
          "file": "maps/rooms/room-14-15.tmj",
          "id": "room-14-15"
        },
        {
          "file": "maps/rooms/room-14-2.tmj",
          "id": "room-14-2"
        },
        {
          "file": "maps/rooms/room-14-3.tmj",
          "id": "room-14-3"
        },
        {
          "file": "maps/rooms/room-14-4.tmj",
          "id": "room-14-4"
        },
        {
          "file": "maps/rooms/room-14-5.tmj",
          "id": "room-14-5"
        },
        {
          "file": "maps/rooms/room-14-6.tmj",
          "id": "room-14-6"
        },
        {
          "file": "maps/rooms/room-14-7.tmj",
          "id": "room-14-7"
        },
        {
          "file": "maps/rooms/room-14-8.tmj",
          "id": "room-14-8"
        },
        {
          "file": "maps/rooms/room-14-9.tmj",
          "id": "room-14-9"
        },
        {
          "file": "maps/rooms/room-15-0.tmj",
          "id": "room-15-0"
        },
        {
          "file": "maps/rooms/room-15-1.tmj",
          "id": "room-15-1"
        },
        {
          "file": "maps/rooms/room-15-10.tmj",
          "id": "room-15-10"
        },
        {
          "file": "maps/rooms/room-15-11.tmj",
          "id": "room-15-11"
        },
        {
          "file": "maps/rooms/room-15-12.tmj",
          "id": "room-15-12"
        },
        {
          "file": "maps/rooms/room-15-13.tmj",
          "id": "room-15-13"
        },
        {
          "file": "maps/rooms/room-15-14.tmj",
          "id": "room-15-14"
        },
        {
          "file": "maps/rooms/room-15-15.tmj",
          "id": "room-15-15"
        },
        {
          "file": "maps/rooms/room-15-2.tmj",
          "id": "room-15-2"
        },
        {
          "file": "maps/rooms/room-15-3.tmj",
          "id": "room-15-3"
        },
        {
          "file": "maps/rooms/room-15-4.tmj",
          "id": "room-15-4"
        },
        {
          "file": "maps/rooms/room-15-5.tmj",
          "id": "room-15-5"
        },
        {
          "file": "maps/rooms/room-15-6.tmj",
          "id": "room-15-6"
        },
        {
          "file": "maps/rooms/room-15-7.tmj",
          "id": "room-15-7"
        },
        {
          "file": "maps/rooms/room-15-8.tmj",
          "id": "room-15-8"
        },
        {
          "file": "maps/rooms/room-15-9.tmj",
          "id": "room-15-9"
        },
        {
          "file": "maps/rooms/room-2-0.tmj",
          "id": "room-2-0"
        },
        {
          "file": "maps/rooms/room-2-1.tmj",
          "id": "room-2-1"
        },
        {
          "file": "maps/rooms/room-2-10.tmj",
          "id": "room-2-10"
        },
        {
          "file": "maps/rooms/room-2-11.tmj",
          "id": "room-2-11"
        },
        {
          "file": "maps/rooms/room-2-12.tmj",
          "id": "room-2-12"
        },
        {
          "file": "maps/rooms/room-2-13.tmj",
          "id": "room-2-13"
        },
        {
          "file": "maps/rooms/room-2-14.tmj",
          "id": "room-2-14"
        },
        {
          "file": "maps/rooms/room-2-15.tmj",
          "id": "room-2-15"
        },
        {
          "file": "maps/rooms/room-2-2.tmj",
          "id": "room-2-2"
        },
        {
          "file": "maps/rooms/room-2-3.tmj",
          "id": "room-2-3"
        },
        {
          "file": "maps/rooms/room-2-4.tmj",
          "id": "room-2-4"
        },
        {
          "file": "maps/rooms/room-2-5.tmj",
          "id": "room-2-5"
        },
        {
          "file": "maps/rooms/room-2-6.tmj",
          "id": "room-2-6"
        },
        {
          "file": "maps/rooms/room-2-7.tmj",
          "id": "room-2-7"
        },
        {
          "file": "maps/rooms/room-2-8.tmj",
          "id": "room-2-8"
        },
        {
          "file": "maps/rooms/room-2-9.tmj",
          "id": "room-2-9"
        },
        {
          "file": "maps/rooms/room-3-0.tmj",
          "id": "room-3-0"
        },
        {
          "file": "maps/rooms/room-3-1.tmj",
          "id": "room-3-1"
        },
        {
          "file": "maps/rooms/room-3-10.tmj",
          "id": "room-3-10"
        },
        {
          "file": "maps/rooms/room-3-11.tmj",
          "id": "room-3-11"
        },
        {
          "file": "maps/rooms/room-3-12.tmj",
          "id": "room-3-12"
        },
        {
          "file": "maps/rooms/room-3-13.tmj",
          "id": "room-3-13"
        },
        {
          "file": "maps/rooms/room-3-14.tmj",
          "id": "room-3-14"
        },
        {
          "file": "maps/rooms/room-3-15.tmj",
          "id": "room-3-15"
        },
        {
          "file": "maps/rooms/room-3-2.tmj",
          "id": "room-3-2"
        },
        {
          "file": "maps/rooms/room-3-3.tmj",
          "id": "room-3-3"
        },
        {
          "file": "maps/rooms/room-3-4.tmj",
          "id": "room-3-4"
        },
        {
          "file": "maps/rooms/room-3-5.tmj",
          "id": "room-3-5"
        },
        {
          "file": "maps/rooms/room-3-6.tmj",
          "id": "room-3-6"
        },
        {
          "file": "maps/rooms/room-3-7.tmj",
          "id": "room-3-7"
        },
        {
          "file": "maps/rooms/room-3-8.tmj",
          "id": "room-3-8"
        },
        {
          "file": "maps/rooms/room-3-9.tmj",
          "id": "room-3-9"
        },
        {
          "file": "maps/rooms/room-4-0.tmj",
          "id": "room-4-0"
        },
        {
          "file": "maps/rooms/room-4-1.tmj",
          "id": "room-4-1"
        },
        {
          "file": "maps/rooms/room-4-10.tmj",
          "id": "room-4-10"
        },
        {
          "file": "maps/rooms/room-4-11.tmj",
          "id": "room-4-11"
        },
        {
          "file": "maps/rooms/room-4-12.tmj",
          "id": "room-4-12"
        },
        {
          "file": "maps/rooms/room-4-13.tmj",
          "id": "room-4-13"
        },
        {
          "file": "maps/rooms/room-4-14.tmj",
          "id": "room-4-14"
        },
        {
          "file": "maps/rooms/room-4-15.tmj",
          "id": "room-4-15"
        },
        {
          "file": "maps/rooms/room-4-2.tmj",
          "id": "room-4-2"
        },
        {
          "file": "maps/rooms/room-4-3.tmj",
          "id": "room-4-3"
        },
        {
          "file": "maps/rooms/room-4-4.tmj",
          "id": "room-4-4"
        },
        {
          "file": "maps/rooms/room-4-5.tmj",
          "id": "room-4-5"
        },
        {
          "file": "maps/rooms/room-4-6.tmj",
          "id": "room-4-6"
        },
        {
          "file": "maps/rooms/room-4-7.tmj",
          "id": "room-4-7"
        },
        {
          "file": "maps/rooms/room-4-8.tmj",
          "id": "room-4-8"
        },
        {
          "file": "maps/rooms/room-4-9.tmj",
          "id": "room-4-9"
        },
        {
          "file": "maps/rooms/room-5-0.tmj",
          "id": "room-5-0"
        },
        {
          "file": "maps/rooms/room-5-1.tmj",
          "id": "room-5-1"
        },
        {
          "file": "maps/rooms/room-5-10.tmj",
          "id": "room-5-10"
        },
        {
          "file": "maps/rooms/room-5-11.tmj",
          "id": "room-5-11"
        },
        {
          "file": "maps/rooms/room-5-12.tmj",
          "id": "room-5-12"
        },
        {
          "file": "maps/rooms/room-5-13.tmj",
          "id": "room-5-13"
        },
        {
          "file": "maps/rooms/room-5-14.tmj",
          "id": "room-5-14"
        },
        {
          "file": "maps/rooms/room-5-15.tmj",
          "id": "room-5-15"
        },
        {
          "file": "maps/rooms/room-5-2.tmj",
          "id": "room-5-2"
        },
        {
          "file": "maps/rooms/room-5-3.tmj",
          "id": "room-5-3"
        },
        {
          "file": "maps/rooms/room-5-4.tmj",
          "id": "room-5-4"
        },
        {
          "file": "maps/rooms/room-5-5.tmj",
          "id": "room-5-5"
        },
        {
          "file": "maps/rooms/room-5-6.tmj",
          "id": "room-5-6"
        },
        {
          "file": "maps/rooms/room-5-7.tmj",
          "id": "room-5-7"
        },
        {
          "file": "maps/rooms/room-5-8.tmj",
          "id": "room-5-8"
        },
        {
          "file": "maps/rooms/room-5-9.tmj",
          "id": "room-5-9"
        },
        {
          "file": "maps/rooms/room-6-0.tmj",
          "id": "room-6-0"
        },
        {
          "file": "maps/rooms/room-6-1.tmj",
          "id": "room-6-1"
        },
        {
          "file": "maps/rooms/room-6-10.tmj",
          "id": "room-6-10"
        },
        {
          "file": "maps/rooms/room-6-11.tmj",
          "id": "room-6-11"
        },
        {
          "file": "maps/rooms/room-6-12.tmj",
          "id": "room-6-12"
        },
        {
          "file": "maps/rooms/room-6-13.tmj",
          "id": "room-6-13"
        },
        {
          "file": "maps/rooms/room-6-14.tmj",
          "id": "room-6-14"
        },
        {
          "file": "maps/rooms/room-6-15.tmj",
          "id": "room-6-15"
        },
        {
          "file": "maps/rooms/room-6-2.tmj",
          "id": "room-6-2"
        },
        {
          "file": "maps/rooms/room-6-3.tmj",
          "id": "room-6-3"
        },
        {
          "file": "maps/rooms/room-6-4.tmj",
          "id": "room-6-4"
        },
        {
          "file": "maps/rooms/room-6-5.tmj",
          "id": "room-6-5"
        },
        {
          "file": "maps/rooms/room-6-6.tmj",
          "id": "room-6-6"
        },
        {
          "file": "maps/rooms/room-6-7.tmj",
          "id": "room-6-7"
        },
        {
          "file": "maps/rooms/room-6-8.tmj",
          "id": "room-6-8"
        },
        {
          "file": "maps/rooms/room-6-9.tmj",
          "id": "room-6-9"
        },
        {
          "file": "maps/rooms/room-7-0.tmj",
          "id": "room-7-0"
        },
        {
          "file": "maps/rooms/room-7-1.tmj",
          "id": "room-7-1"
        },
        {
          "file": "maps/rooms/room-7-10.tmj",
          "id": "room-7-10"
        },
        {
          "file": "maps/rooms/room-7-11.tmj",
          "id": "room-7-11"
        },
        {
          "file": "maps/rooms/room-7-12.tmj",
          "id": "room-7-12"
        },
        {
          "file": "maps/rooms/room-7-13.tmj",
          "id": "room-7-13"
        },
        {
          "file": "maps/rooms/room-7-14.tmj",
          "id": "room-7-14"
        },
        {
          "file": "maps/rooms/room-7-15.tmj",
          "id": "room-7-15"
        },
        {
          "file": "maps/rooms/room-7-2.tmj",
          "id": "room-7-2"
        },
        {
          "file": "maps/rooms/room-7-3.tmj",
          "id": "room-7-3"
        },
        {
          "file": "maps/rooms/room-7-4.tmj",
          "id": "room-7-4"
        },
        {
          "file": "maps/rooms/room-7-5.tmj",
          "id": "room-7-5"
        },
        {
          "file": "maps/rooms/room-7-6.tmj",
          "id": "room-7-6"
        },
        {
          "file": "maps/rooms/room-7-7.tmj",
          "id": "room-7-7"
        },
        {
          "file": "maps/rooms/room-7-8.tmj",
          "id": "room-7-8"
        },
        {
          "file": "maps/rooms/room-7-9.tmj",
          "id": "room-7-9"
        },
        {
          "file": "maps/rooms/room-8-0.tmj",
          "id": "room-8-0"
        },
        {
          "file": "maps/rooms/room-8-1.tmj",
          "id": "room-8-1"
        },
        {
          "file": "maps/rooms/room-8-10.tmj",
          "id": "room-8-10"
        },
        {
          "file": "maps/rooms/room-8-11.tmj",
          "id": "room-8-11"
        },
        {
          "file": "maps/rooms/room-8-12.tmj",
          "id": "room-8-12"
        },
        {
          "file": "maps/rooms/room-8-13.tmj",
          "id": "room-8-13"
        },
        {
          "file": "maps/rooms/room-8-14.tmj",
          "id": "room-8-14"
        },
        {
          "file": "maps/rooms/room-8-15.tmj",
          "id": "room-8-15"
        },
        {
          "file": "maps/rooms/room-8-2.tmj",
          "id": "room-8-2"
        },
        {
          "file": "maps/rooms/room-8-3.tmj",
          "id": "room-8-3"
        },
        {
          "file": "maps/rooms/room-8-4.tmj",
          "id": "room-8-4"
        },
        {
          "file": "maps/rooms/room-8-5.tmj",
          "id": "room-8-5"
        },
        {
          "file": "maps/rooms/room-8-6.tmj",
          "id": "room-8-6"
        },
        {
          "file": "maps/rooms/room-8-7.tmj",
          "id": "room-8-7"
        },
        {
          "file": "maps/rooms/room-8-8.tmj",
          "id": "room-8-8"
        },
        {
          "file": "maps/rooms/room-8-9.tmj",
          "id": "room-8-9"
        },
        {
          "file": "maps/rooms/room-9-0.tmj",
          "id": "room-9-0"
        },
        {
          "file": "maps/rooms/room-9-1.tmj",
          "id": "room-9-1"
        },
        {
          "file": "maps/rooms/room-9-10.tmj",
          "id": "room-9-10"
        },
        {
          "file": "maps/rooms/room-9-11.tmj",
          "id": "room-9-11"
        },
        {
          "file": "maps/rooms/room-9-12.tmj",
          "id": "room-9-12"
        },
        {
          "file": "maps/rooms/room-9-13.tmj",
          "id": "room-9-13"
        },
        {
          "file": "maps/rooms/room-9-14.tmj",
          "id": "room-9-14"
        },
        {
          "file": "maps/rooms/room-9-15.tmj",
          "id": "room-9-15"
        },
        {
          "file": "maps/rooms/room-9-2.tmj",
          "id": "room-9-2"
        },
        {
          "file": "maps/rooms/room-9-3.tmj",
          "id": "room-9-3"
        },
        {
          "file": "maps/rooms/room-9-4.tmj",
          "id": "room-9-4"
        },
        {
          "file": "maps/rooms/room-9-5.tmj",
          "id": "room-9-5"
        },
        {
          "file": "maps/rooms/room-9-6.tmj",
          "id": "room-9-6"
        },
        {
          "file": "maps/rooms/room-9-7.tmj",
          "id": "room-9-7"
        },
        {
          "file": "maps/rooms/room-9-8.tmj",
          "id": "room-9-8"
        },
        {
          "file": "maps/rooms/room-9-9.tmj",
          "id": "room-9-9"
        },
        {
          "file": "maps/rooms/shadow-trials.tmj",
          "id": "shadowTrials",
          "provenance": "maps/sources/shadow-trials.tmx"
        },
        {
          "file": "maps/rooms/test.tmj",
          "id": "test",
          "provenance": "maps/sources/test.tmx"
        },
        {
          "file": "maps/rooms/test2.tmj",
          "id": "test2",
          "provenance": "maps/sources/test2.tmx"
        },
        {
          "file": "maps/rooms/test3.tmj",
          "id": "test3"
        },
        {
          "file": "maps/rooms/test4.tmj",
          "id": "test4"
        },
        {
          "file": "maps/rooms/tutorial1.tmj",
          "id": "tutorial1",
          "provenance": "maps/sources/tutorial1.tmx"
        },
        {
          "file": "maps/rooms/tutorial2.tmj",
          "id": "tutorial2",
          "provenance": "maps/sources/tutorial2.tmx"
        },
        {
          "file": "maps/rooms/tutorial3.tmj",
          "id": "tutorial3",
          "provenance": "maps/sources/tutorial3.tmx"
        },
        {
          "file": "maps/rooms/tutorial4.tmj",
          "id": "tutorial4",
          "provenance": "maps/sources/tutorial4.tmx"
        },
        {
          "file": "maps/rooms/wave1.tmj",
          "id": "wave1",
          "provenance": "maps/sources/wave1.tmx"
        },
        {
          "file": "maps/rooms/wave2.tmj",
          "id": "wave2",
          "provenance": "maps/sources/wave2.tmx"
        }
      ],
      "templates": [
        {
          "file": "maps/templates/ruins.tmj",
          "id": "ruins"
        },
        {
          "file": "maps/templates/settlement.tmj",
          "id": "settlement"
        },
        {
          "file": "maps/templates/geo.tmj",
          "id": "geo"
        },
        {
          "file": "maps/templates/caves.tmj",
          "id": "caves"
        },
        {
          "file": "maps/templates/item.tmj",
          "id": "item"
        }
      ],
      "tilesets": [
        {
          "file": "maps/tilesets/authored-terrain.tsx",
          "format": "tsx",
          "id": "authored-terrain"
        },
        {
          "file": "maps/tilesets/beach-desert.tsx",
          "format": "tsx",
          "id": "beach-desert"
        },
        {
          "file": "maps/tilesets/bonecaller-stones.json",
          "format": "json",
          "id": "bonecaller-stones"
        },
        {
          "file": "maps/tilesets/build_atlas.tsx",
          "format": "tsx",
          "id": "build_atlas"
        },
        {
          "file": "maps/tilesets/container.tsx",
          "format": "tsx",
          "id": "container",
          "legacyOmittedTiles": [
            46,
            47,
            62,
            63
          ]
        },
        {
          "file": "maps/tilesets/cottage.tsx",
          "format": "tsx",
          "id": "cottage"
        },
        {
          "file": "maps/tilesets/decorations-medieval.tsx",
          "format": "tsx",
          "id": "decorations-medieval"
        },
        {
          "file": "maps/tilesets/fence_medieval.tsx",
          "format": "tsx",
          "id": "fence_medieval"
        },
        {
          "file": "maps/tilesets/floors.tsx",
          "format": "tsx",
          "id": "floors"
        },
        {
          "file": "maps/tilesets/furniture-blonde-wood.tsx",
          "format": "tsx",
          "id": "furniture-blonde-wood"
        },
        {
          "file": "maps/tilesets/jungle-ruins.tsx",
          "format": "tsx",
          "id": "jungle-ruins"
        },
        {
          "file": "maps/tilesets/lpc-flowers-plants-fungi-wood.tsx",
          "format": "tsx",
          "id": "lpc-flowers-plants-fungi-wood"
        },
        {
          "file": "maps/tilesets/lpc-terrain.tsx",
          "format": "tsx",
          "id": "lpc-terrain"
        },
        {
          "file": "maps/tilesets/map-atlas.tsx",
          "format": "tsx",
          "id": "map-atlas"
        },
        {
          "file": "maps/tilesets/mountains-v6.tsx",
          "format": "tsx",
          "id": "mountains-v6"
        },
        {
          "file": "maps/tilesets/ore.tsx",
          "format": "tsx",
          "id": "ore"
        },
        {
          "file": "maps/tilesets/plants.tsx",
          "format": "tsx",
          "id": "plants"
        },
        {
          "file": "maps/tilesets/roofs.tsx",
          "format": "tsx",
          "id": "roofs"
        },
        {
          "file": "maps/tilesets/walls.tsx",
          "format": "tsx",
          "id": "walls"
        },
        {
          "file": "maps/tilesets/walls2.tsx",
          "format": "tsx",
          "id": "walls2"
        },
        {
          "file": "maps/tilesets/forest-grass.tsx",
          "format": "tsx",
          "id": "forest-grass"
        },
        {
          "file": "maps/tilesets/forest-dirt.tsx",
          "format": "tsx",
          "id": "forest-dirt"
        }
      ],
      "world": "maps/world/world_meta.json"
    },
    "preload": [
      "lpc/spritesheets/bauldron/female/brown.png.json",
      "lpc/spritesheets/bauldron/male/brown.png.json",
      "lpc/spritesheets/body/female/deer/brown.png.json",
      "lpc/spritesheets/body/female/human/black.png.json",
      "lpc/spritesheets/body/female/human/brown.png.json",
      "lpc/spritesheets/body/female/human/dark.png.json",
      "lpc/spritesheets/body/female/human/light.png.json",
      "lpc/spritesheets/body/female/human/olive.png.json",
      "lpc/spritesheets/body/female/human/tanned.png.json",
      "lpc/spritesheets/body/female/human/white.png.json",
      "lpc/spritesheets/body/female/orcs/gray.png.json",
      "lpc/spritesheets/body/female/orcs/green_1.png.json",
      "lpc/spritesheets/body/female/orcs/green_3.png.json",
      "lpc/spritesheets/body/female/reptiles/blue_unwinged.png.json",
      "lpc/spritesheets/body/female/reptiles/blue_winged.png.json",
      "lpc/spritesheets/body/female/reptiles/green_unwinged.png.json",
      "lpc/spritesheets/body/female/reptiles/green_winged.png.json",
      "lpc/spritesheets/body/female/reptiles/lightgreen_unwinged.png.json",
      "lpc/spritesheets/body/female/reptiles/lightgreen_winged.png.json",
      "lpc/spritesheets/body/female/wolf/black.png.json",
      "lpc/spritesheets/body/female/wolf/brown.png.json",
      "lpc/spritesheets/body/female/wolf/gray.png.json",
      "lpc/spritesheets/body/female/wolf/head/black.png.json",
      "lpc/spritesheets/body/female/wolf/head/brown.png.json",
      "lpc/spritesheets/body/female/wolf/head/gray.png.json",
      "lpc/spritesheets/body/female/wolf/head/white.png.json",
      "lpc/spritesheets/body/female/wolf/white.png.json",
      "lpc/spritesheets/body/male/chicken/white.png.json",
      "lpc/spritesheets/body/male/horse/burdened/brown.png.json",
      "lpc/spritesheets/body/male/human/black.png.json",
      "lpc/spritesheets/body/male/human/brown.png.json",
      "lpc/spritesheets/body/male/human/dark.png.json",
      "lpc/spritesheets/body/male/human/light.png.json",
      "lpc/spritesheets/body/male/human/olive.png.json",
      "lpc/spritesheets/body/male/human/tanned.png.json",
      "lpc/spritesheets/body/male/human/white.png.json",
      "lpc/spritesheets/body/male/orcs/gray.png.json",
      "lpc/spritesheets/body/male/orcs/green_1.png.json",
      "lpc/spritesheets/body/male/orcs/green_3.png.json",
      "lpc/spritesheets/body/male/rabbit/white.png.json",
      "lpc/spritesheets/body/male/redspider/red.png.json",
      "lpc/spritesheets/body/male/reptiles/blue_unwinged.png.json",
      "lpc/spritesheets/body/male/reptiles/blue_winged.png.json",
      "lpc/spritesheets/body/male/reptiles/green_unwinged.png.json",
      "lpc/spritesheets/body/male/reptiles/green_winged.png.json",
      "lpc/spritesheets/body/male/reptiles/lightgreen_unwinged.png.json",
      "lpc/spritesheets/body/male/reptiles/lightgreen_winged.png.json",
      "lpc/spritesheets/body/male/slime/green.png.json",
      "lpc/spritesheets/body/male/snake/green.png.json",
      "lpc/spritesheets/body/male/special/zombie.png.json",
      "lpc/spritesheets/body/male/wasp/yellow.png.json",
      "lpc/spritesheets/body/male/wolf/black.png.json",
      "lpc/spritesheets/body/male/wolf/brown.png.json",
      "lpc/spritesheets/body/male/wolf/gray.png.json",
      "lpc/spritesheets/body/male/wolf/head/black.png.json",
      "lpc/spritesheets/body/male/wolf/head/brown.png.json",
      "lpc/spritesheets/body/male/wolf/head/gray.png.json",
      "lpc/spritesheets/body/male/wolf/head/white.png.json",
      "lpc/spritesheets/body/male/wolf/white.png.json",
      "lpc/spritesheets/body/skeleton/beige.png.json",
      "lpc/spritesheets/body/skeleton/gray.png.json",
      "lpc/spritesheets/body/skeleton/green.png.json",
      "lpc/spritesheets/cape/solid/male/black.png.json",
      "lpc/spritesheets/cape/solid/male/blue.png.json",
      "lpc/spritesheets/cape/solid/male/brown.png.json",
      "lpc/spritesheets/cape/solid/male/gray.png.json",
      "lpc/spritesheets/cape/solid/male/green.png.json",
      "lpc/spritesheets/cape/solid/male/maroon.png.json",
      "lpc/spritesheets/cape/solid/male/red.png.json",
      "lpc/spritesheets/cape/solid/male/white.png.json",
      "lpc/spritesheets/cape/solid/male/yellow.png.json",
      "lpc/spritesheets/cape/solid_behind/black.png.json",
      "lpc/spritesheets/cape/solid_behind/blue.png.json",
      "lpc/spritesheets/cape/solid_behind/brown.png.json",
      "lpc/spritesheets/cape/solid_behind/gray.png.json",
      "lpc/spritesheets/cape/solid_behind/green.png.json",
      "lpc/spritesheets/cape/solid_behind/maroon.png.json",
      "lpc/spritesheets/cape/solid_behind/red.png.json",
      "lpc/spritesheets/cape/solid_behind/white.png.json",
      "lpc/spritesheets/cape/solid_behind/yellow.png.json",
      "lpc/spritesheets/cape/tattered/female/black.png.json",
      "lpc/spritesheets/cape/tattered/female/blue.png.json",
      "lpc/spritesheets/cape/tattered/female/brown.png.json",
      "lpc/spritesheets/cape/tattered/female/gray.png.json",
      "lpc/spritesheets/cape/tattered/female/green.png.json",
      "lpc/spritesheets/cape/tattered/female/maroon.png.json",
      "lpc/spritesheets/cape/tattered/female/red.png.json",
      "lpc/spritesheets/cape/tattered/female/white.png.json",
      "lpc/spritesheets/cape/tattered/female/yellow.png.json",
      "lpc/spritesheets/cape/tattered_behind/black.png.json",
      "lpc/spritesheets/cape/tattered_behind/blue.png.json",
      "lpc/spritesheets/cape/tattered_behind/brown.png.json",
      "lpc/spritesheets/cape/tattered_behind/gray.png.json",
      "lpc/spritesheets/cape/tattered_behind/green.png.json",
      "lpc/spritesheets/cape/tattered_behind/maroon.png.json",
      "lpc/spritesheets/cape/tattered_behind/red.png.json",
      "lpc/spritesheets/cape/tattered_behind/white.png.json",
      "lpc/spritesheets/cape/tattered_behind/yellow.png.json",
      "lpc/spritesheets/cape/trimmed/female/white_blue.png.json",
      "lpc/spritesheets/cape/trimmed_behind/white_blue.png.json",
      "lpc/spritesheets/eyes/female/blue.png.json",
      "lpc/spritesheets/eyes/female/brown.png.json",
      "lpc/spritesheets/eyes/female/cyclope.png.json",
      "lpc/spritesheets/eyes/female/gray.png.json",
      "lpc/spritesheets/eyes/female/green.png.json",
      "lpc/spritesheets/eyes/female/orange.png.json",
      "lpc/spritesheets/eyes/female/purple.png.json",
      "lpc/spritesheets/eyes/female/red.png.json",
      "lpc/spritesheets/eyes/female/yellow.png.json",
      "lpc/spritesheets/eyes/male/blue.png.json",
      "lpc/spritesheets/eyes/male/brown.png.json",
      "lpc/spritesheets/eyes/male/cyclope.png.json",
      "lpc/spritesheets/eyes/male/gray.png.json",
      "lpc/spritesheets/eyes/male/green.png.json",
      "lpc/spritesheets/eyes/male/orange.png.json",
      "lpc/spritesheets/eyes/male/purple.png.json",
      "lpc/spritesheets/eyes/male/red.png.json",
      "lpc/spritesheets/eyes/male/yellow.png.json",
      "lpc/spritesheets/feet/armor/female/4.png.json",
      "lpc/spritesheets/feet/armor/female/5.png.json",
      "lpc/spritesheets/feet/armor/female/6.png.json",
      "lpc/spritesheets/feet/armor/female/7.png.json",
      "lpc/spritesheets/feet/armor/female/8.png.json",
      "lpc/spritesheets/feet/armor/female/9.png.json",
      "lpc/spritesheets/feet/armor/male/4.png.json",
      "lpc/spritesheets/feet/armor/male/5.png.json",
      "lpc/spritesheets/feet/armor/male/6.png.json",
      "lpc/spritesheets/feet/armor/male/7.png.json",
      "lpc/spritesheets/feet/armor/male/8.png.json",
      "lpc/spritesheets/feet/armor/male/9.png.json",
      "lpc/spritesheets/feet/boots/female/black.png.json",
      "lpc/spritesheets/feet/boots/female/blue.png.json",
      "lpc/spritesheets/feet/boots/female/brown.png.json",
      "lpc/spritesheets/feet/boots/female/gray.png.json",
      "lpc/spritesheets/feet/boots/female/green.png.json",
      "lpc/spritesheets/feet/boots/female/maroon.png.json",
      "lpc/spritesheets/feet/boots/female/orange.png.json",
      "lpc/spritesheets/feet/boots/female/purple.png.json",
      "lpc/spritesheets/feet/boots/female/red.png.json",
      "lpc/spritesheets/feet/boots/female/tan.png.json",
      "lpc/spritesheets/feet/boots/female/teal.png.json",
      "lpc/spritesheets/feet/boots/female/white.png.json",
      "lpc/spritesheets/feet/boots/female/yellow.png.json",
      "lpc/spritesheets/feet/boots/male/black.png.json",
      "lpc/spritesheets/feet/boots/male/blue.png.json",
      "lpc/spritesheets/feet/boots/male/brown.png.json",
      "lpc/spritesheets/feet/boots/male/gray.png.json",
      "lpc/spritesheets/feet/boots/male/green.png.json",
      "lpc/spritesheets/feet/boots/male/maroon.png.json",
      "lpc/spritesheets/feet/boots/male/orange.png.json",
      "lpc/spritesheets/feet/boots/male/purple.png.json",
      "lpc/spritesheets/feet/boots/male/red.png.json",
      "lpc/spritesheets/feet/boots/male/tan.png.json",
      "lpc/spritesheets/feet/boots/male/teal.png.json",
      "lpc/spritesheets/feet/boots/male/white.png.json",
      "lpc/spritesheets/feet/boots/male/yellow.png.json",
      "lpc/spritesheets/feet/sandals/female/brown.png.json",
      "lpc/spritesheets/feet/sandals/male/brown.png.json",
      "lpc/spritesheets/feet/shoes/female/black.png.json",
      "lpc/spritesheets/feet/shoes/female/brown.png.json",
      "lpc/spritesheets/feet/shoes/female/maroon.png.json",
      "lpc/spritesheets/feet/shoes/male/black.png.json",
      "lpc/spritesheets/feet/shoes/male/brown.png.json",
      "lpc/spritesheets/feet/shoes/male/maroon.png.json",
      "lpc/spritesheets/feet/slippers/female/black.png.json",
      "lpc/spritesheets/feet/slippers/female/brown.png.json",
      "lpc/spritesheets/feet/slippers/female/gray.png.json",
      "lpc/spritesheets/hair/afro/female/black.png.json",
      "lpc/spritesheets/hair/afro/female/blonde.png.json",
      "lpc/spritesheets/hair/afro/female/blue.png.json",
      "lpc/spritesheets/hair/afro/female/dark_brown.png.json",
      "lpc/spritesheets/hair/afro/female/gold.png.json",
      "lpc/spritesheets/hair/afro/female/gray.png.json",
      "lpc/spritesheets/hair/afro/female/green.png.json",
      "lpc/spritesheets/hair/afro/female/light_brown.png.json",
      "lpc/spritesheets/hair/afro/female/orange.png.json",
      "lpc/spritesheets/hair/afro/female/purple.png.json",
      "lpc/spritesheets/hair/afro/female/red.png.json",
      "lpc/spritesheets/hair/afro/female/white.png.json",
      "lpc/spritesheets/hair/afro/male/black.png.json",
      "lpc/spritesheets/hair/afro/male/blonde.png.json",
      "lpc/spritesheets/hair/afro/male/blue.png.json",
      "lpc/spritesheets/hair/afro/male/dark_brown.png.json",
      "lpc/spritesheets/hair/afro/male/gold.png.json",
      "lpc/spritesheets/hair/afro/male/gray.png.json",
      "lpc/spritesheets/hair/afro/male/green.png.json",
      "lpc/spritesheets/hair/afro/male/light_brown.png.json",
      "lpc/spritesheets/hair/afro/male/orange.png.json",
      "lpc/spritesheets/hair/afro/male/purple.png.json",
      "lpc/spritesheets/hair/afro/male/red.png.json",
      "lpc/spritesheets/hair/afro/male/white.png.json",
      "lpc/spritesheets/hair/balding/male/black.png.json",
      "lpc/spritesheets/hair/balding/male/blonde.png.json",
      "lpc/spritesheets/hair/balding/male/blue.png.json",
      "lpc/spritesheets/hair/balding/male/dark_brown.png.json",
      "lpc/spritesheets/hair/balding/male/gold.png.json",
      "lpc/spritesheets/hair/balding/male/gray.png.json",
      "lpc/spritesheets/hair/balding/male/green.png.json",
      "lpc/spritesheets/hair/balding/male/light_brown.png.json",
      "lpc/spritesheets/hair/balding/male/orange.png.json",
      "lpc/spritesheets/hair/balding/male/purple.png.json",
      "lpc/spritesheets/hair/balding/male/red.png.json",
      "lpc/spritesheets/hair/balding/male/white.png.json",
      "lpc/spritesheets/hair/bangs/female/black.png.json",
      "lpc/spritesheets/hair/bangs/female/blonde.png.json",
      "lpc/spritesheets/hair/bangs/female/blue.png.json",
      "lpc/spritesheets/hair/bangs/female/dark_brown.png.json",
      "lpc/spritesheets/hair/bangs/female/gold.png.json",
      "lpc/spritesheets/hair/bangs/female/gray.png.json",
      "lpc/spritesheets/hair/bangs/female/green.png.json",
      "lpc/spritesheets/hair/bangs/female/light_brown.png.json",
      "lpc/spritesheets/hair/bangs/female/orange.png.json",
      "lpc/spritesheets/hair/bangs/female/purple.png.json",
      "lpc/spritesheets/hair/bangs/female/red.png.json",
      "lpc/spritesheets/hair/bangs/female/white.png.json",
      "lpc/spritesheets/hair/bangs/male/black.png.json",
      "lpc/spritesheets/hair/bangs/male/blonde.png.json",
      "lpc/spritesheets/hair/bangs/male/blue.png.json",
      "lpc/spritesheets/hair/bangs/male/dark_brown.png.json",
      "lpc/spritesheets/hair/bangs/male/gold.png.json",
      "lpc/spritesheets/hair/bangs/male/gray.png.json",
      "lpc/spritesheets/hair/bangs/male/green.png.json",
      "lpc/spritesheets/hair/bangs/male/light_brown.png.json",
      "lpc/spritesheets/hair/bangs/male/orange.png.json",
      "lpc/spritesheets/hair/bangs/male/purple.png.json",
      "lpc/spritesheets/hair/bangs/male/red.png.json",
      "lpc/spritesheets/hair/bangs/male/white.png.json",
      "lpc/spritesheets/hair/bangs_bun/female/black.png.json",
      "lpc/spritesheets/hair/bangs_bun/female/blonde.png.json",
      "lpc/spritesheets/hair/bangs_bun/female/blue.png.json",
      "lpc/spritesheets/hair/bangs_bun/female/dark_brown.png.json",
      "lpc/spritesheets/hair/bangs_bun/female/gold.png.json",
      "lpc/spritesheets/hair/bangs_bun/female/gray.png.json",
      "lpc/spritesheets/hair/bangs_bun/female/green.png.json",
      "lpc/spritesheets/hair/bangs_bun/female/light_brown.png.json",
      "lpc/spritesheets/hair/bangs_bun/female/orange.png.json",
      "lpc/spritesheets/hair/bangs_bun/female/purple.png.json",
      "lpc/spritesheets/hair/bangs_bun/female/red.png.json",
      "lpc/spritesheets/hair/bangs_bun/female/white.png.json",
      "lpc/spritesheets/hair/bangs_bun/male/black.png.json",
      "lpc/spritesheets/hair/bangs_bun/male/blonde.png.json",
      "lpc/spritesheets/hair/bangs_bun/male/blue.png.json",
      "lpc/spritesheets/hair/bangs_bun/male/dark_brown.png.json",
      "lpc/spritesheets/hair/bangs_bun/male/gold.png.json",
      "lpc/spritesheets/hair/bangs_bun/male/gray.png.json",
      "lpc/spritesheets/hair/bangs_bun/male/green.png.json",
      "lpc/spritesheets/hair/bangs_bun/male/light_brown.png.json",
      "lpc/spritesheets/hair/bangs_bun/male/orange.png.json",
      "lpc/spritesheets/hair/bangs_bun/male/purple.png.json",
      "lpc/spritesheets/hair/bangs_bun/male/red.png.json",
      "lpc/spritesheets/hair/bangs_bun/male/white.png.json",
      "lpc/spritesheets/hair/bangslong/female/black.png.json",
      "lpc/spritesheets/hair/bangslong/female/blonde.png.json",
      "lpc/spritesheets/hair/bangslong/female/blue.png.json",
      "lpc/spritesheets/hair/bangslong/female/dark_brown.png.json",
      "lpc/spritesheets/hair/bangslong/female/gold.png.json",
      "lpc/spritesheets/hair/bangslong/female/gray.png.json",
      "lpc/spritesheets/hair/bangslong/female/green.png.json",
      "lpc/spritesheets/hair/bangslong/female/light_brown.png.json",
      "lpc/spritesheets/hair/bangslong/female/orange.png.json",
      "lpc/spritesheets/hair/bangslong/female/purple.png.json",
      "lpc/spritesheets/hair/bangslong/female/red.png.json",
      "lpc/spritesheets/hair/bangslong/female/white.png.json",
      "lpc/spritesheets/hair/bangslong/male/black.png.json",
      "lpc/spritesheets/hair/bangslong/male/blonde.png.json",
      "lpc/spritesheets/hair/bangslong/male/blue.png.json",
      "lpc/spritesheets/hair/bangslong/male/dark_brown.png.json",
      "lpc/spritesheets/hair/bangslong/male/gold.png.json",
      "lpc/spritesheets/hair/bangslong/male/gray.png.json",
      "lpc/spritesheets/hair/bangslong/male/green.png.json",
      "lpc/spritesheets/hair/bangslong/male/light_brown.png.json",
      "lpc/spritesheets/hair/bangslong/male/orange.png.json",
      "lpc/spritesheets/hair/bangslong/male/purple.png.json",
      "lpc/spritesheets/hair/bangslong/male/red.png.json",
      "lpc/spritesheets/hair/bangslong/male/white.png.json",
      "lpc/spritesheets/hair/bangslong2/female/black.png.json",
      "lpc/spritesheets/hair/bangslong2/female/blonde.png.json",
      "lpc/spritesheets/hair/bangslong2/female/blue.png.json",
      "lpc/spritesheets/hair/bangslong2/female/dark_brown.png.json",
      "lpc/spritesheets/hair/bangslong2/female/gold.png.json",
      "lpc/spritesheets/hair/bangslong2/female/gray.png.json",
      "lpc/spritesheets/hair/bangslong2/female/green.png.json",
      "lpc/spritesheets/hair/bangslong2/female/light_brown.png.json",
      "lpc/spritesheets/hair/bangslong2/female/orange.png.json",
      "lpc/spritesheets/hair/bangslong2/female/purple.png.json",
      "lpc/spritesheets/hair/bangslong2/female/red.png.json",
      "lpc/spritesheets/hair/bangslong2/female/white.png.json",
      "lpc/spritesheets/hair/bangslong2/male/black.png.json",
      "lpc/spritesheets/hair/bangslong2/male/blonde.png.json",
      "lpc/spritesheets/hair/bangslong2/male/blue.png.json",
      "lpc/spritesheets/hair/bangslong2/male/dark_brown.png.json",
      "lpc/spritesheets/hair/bangslong2/male/gold.png.json",
      "lpc/spritesheets/hair/bangslong2/male/gray.png.json",
      "lpc/spritesheets/hair/bangslong2/male/green.png.json",
      "lpc/spritesheets/hair/bangslong2/male/light_brown.png.json",
      "lpc/spritesheets/hair/bangslong2/male/orange.png.json",
      "lpc/spritesheets/hair/bangslong2/male/purple.png.json",
      "lpc/spritesheets/hair/bangslong2/male/red.png.json",
      "lpc/spritesheets/hair/bangslong2/male/white.png.json",
      "lpc/spritesheets/hair/bangsshort/female/black.png.json",
      "lpc/spritesheets/hair/bangsshort/female/blonde.png.json",
      "lpc/spritesheets/hair/bangsshort/female/blue.png.json",
      "lpc/spritesheets/hair/bangsshort/female/dark_brown.png.json",
      "lpc/spritesheets/hair/bangsshort/female/gold.png.json",
      "lpc/spritesheets/hair/bangsshort/female/gray.png.json",
      "lpc/spritesheets/hair/bangsshort/female/green.png.json",
      "lpc/spritesheets/hair/bangsshort/female/light_brown.png.json",
      "lpc/spritesheets/hair/bangsshort/female/orange.png.json",
      "lpc/spritesheets/hair/bangsshort/female/purple.png.json",
      "lpc/spritesheets/hair/bangsshort/female/red.png.json",
      "lpc/spritesheets/hair/bangsshort/female/white.png.json",
      "lpc/spritesheets/hair/bangsshort/male/black.png.json",
      "lpc/spritesheets/hair/bangsshort/male/blonde.png.json",
      "lpc/spritesheets/hair/bangsshort/male/blue.png.json",
      "lpc/spritesheets/hair/bangsshort/male/dark_brown.png.json",
      "lpc/spritesheets/hair/bangsshort/male/gold.png.json",
      "lpc/spritesheets/hair/bangsshort/male/gray.png.json",
      "lpc/spritesheets/hair/bangsshort/male/green.png.json",
      "lpc/spritesheets/hair/bangsshort/male/light_brown.png.json",
      "lpc/spritesheets/hair/bangsshort/male/orange.png.json",
      "lpc/spritesheets/hair/bangsshort/male/purple.png.json",
      "lpc/spritesheets/hair/bangsshort/male/red.png.json",
      "lpc/spritesheets/hair/bangsshort/male/white.png.json",
      "lpc/spritesheets/hair/bedhead/female/black.png.json",
      "lpc/spritesheets/hair/bedhead/female/blonde.png.json",
      "lpc/spritesheets/hair/bedhead/female/blue.png.json",
      "lpc/spritesheets/hair/bedhead/female/dark_brown.png.json",
      "lpc/spritesheets/hair/bedhead/female/gold.png.json",
      "lpc/spritesheets/hair/bedhead/female/gray.png.json",
      "lpc/spritesheets/hair/bedhead/female/green.png.json",
      "lpc/spritesheets/hair/bedhead/female/light_brown.png.json",
      "lpc/spritesheets/hair/bedhead/female/orange.png.json",
      "lpc/spritesheets/hair/bedhead/female/purple.png.json",
      "lpc/spritesheets/hair/bedhead/female/red.png.json",
      "lpc/spritesheets/hair/bedhead/female/white.png.json",
      "lpc/spritesheets/hair/bedhead/male/black.png.json",
      "lpc/spritesheets/hair/bedhead/male/blonde.png.json",
      "lpc/spritesheets/hair/bedhead/male/blue.png.json",
      "lpc/spritesheets/hair/bedhead/male/dark_brown.png.json",
      "lpc/spritesheets/hair/bedhead/male/gold.png.json",
      "lpc/spritesheets/hair/bedhead/male/gray.png.json",
      "lpc/spritesheets/hair/bedhead/male/green.png.json",
      "lpc/spritesheets/hair/bedhead/male/light_brown.png.json",
      "lpc/spritesheets/hair/bedhead/male/orange.png.json",
      "lpc/spritesheets/hair/bedhead/male/purple.png.json",
      "lpc/spritesheets/hair/bedhead/male/red.png.json",
      "lpc/spritesheets/hair/bedhead/male/white.png.json",
      "lpc/spritesheets/hair/bob/female/black.png.json",
      "lpc/spritesheets/hair/bob/female/blonde.png.json",
      "lpc/spritesheets/hair/bob/female/blue.png.json",
      "lpc/spritesheets/hair/bob/female/dark_brown.png.json",
      "lpc/spritesheets/hair/bob/female/gold.png.json",
      "lpc/spritesheets/hair/bob/female/gray.png.json",
      "lpc/spritesheets/hair/bob/female/green.png.json",
      "lpc/spritesheets/hair/bob/female/light_brown.png.json",
      "lpc/spritesheets/hair/bob/female/orange.png.json",
      "lpc/spritesheets/hair/bob/female/purple.png.json",
      "lpc/spritesheets/hair/bob/female/red.png.json",
      "lpc/spritesheets/hair/bob/female/white.png.json",
      "lpc/spritesheets/hair/bob_side_part/female/black.png.json",
      "lpc/spritesheets/hair/bob_side_part/female/blonde.png.json",
      "lpc/spritesheets/hair/bob_side_part/female/blue.png.json",
      "lpc/spritesheets/hair/bob_side_part/female/dark_brown.png.json",
      "lpc/spritesheets/hair/bob_side_part/female/gold.png.json",
      "lpc/spritesheets/hair/bob_side_part/female/gray.png.json",
      "lpc/spritesheets/hair/bob_side_part/female/green.png.json",
      "lpc/spritesheets/hair/bob_side_part/female/light_brown.png.json",
      "lpc/spritesheets/hair/bob_side_part/female/orange.png.json",
      "lpc/spritesheets/hair/bob_side_part/female/purple.png.json",
      "lpc/spritesheets/hair/bob_side_part/female/red.png.json",
      "lpc/spritesheets/hair/bob_side_part/female/white.png.json",
      "lpc/spritesheets/hair/braid/female/black.png.json",
      "lpc/spritesheets/hair/braid/female/blonde.png.json",
      "lpc/spritesheets/hair/braid/female/blue.png.json",
      "lpc/spritesheets/hair/braid/female/dark_brown.png.json",
      "lpc/spritesheets/hair/braid/female/gold.png.json",
      "lpc/spritesheets/hair/braid/female/gray.png.json",
      "lpc/spritesheets/hair/braid/female/green.png.json",
      "lpc/spritesheets/hair/braid/female/light_brown.png.json",
      "lpc/spritesheets/hair/braid/female/orange.png.json",
      "lpc/spritesheets/hair/braid/female/purple.png.json",
      "lpc/spritesheets/hair/braid/female/red.png.json",
      "lpc/spritesheets/hair/braid/female/white.png.json",
      "lpc/spritesheets/hair/braid2/female/black.png.json",
      "lpc/spritesheets/hair/braid2/female/blonde.png.json",
      "lpc/spritesheets/hair/braid2/female/blue.png.json",
      "lpc/spritesheets/hair/braid2/female/dark_brown.png.json",
      "lpc/spritesheets/hair/braid2/female/gold.png.json",
      "lpc/spritesheets/hair/braid2/female/gray.png.json",
      "lpc/spritesheets/hair/braid2/female/green.png.json",
      "lpc/spritesheets/hair/braid2/female/light_brown.png.json",
      "lpc/spritesheets/hair/braid2/female/orange.png.json",
      "lpc/spritesheets/hair/braid2/female/purple.png.json",
      "lpc/spritesheets/hair/braid2/female/red.png.json",
      "lpc/spritesheets/hair/braid2/female/white.png.json",
      "lpc/spritesheets/hair/bunches/female/black.png.json",
      "lpc/spritesheets/hair/bunches/female/blonde.png.json",
      "lpc/spritesheets/hair/bunches/female/blue.png.json",
      "lpc/spritesheets/hair/bunches/female/dark_brown.png.json",
      "lpc/spritesheets/hair/bunches/female/gold.png.json",
      "lpc/spritesheets/hair/bunches/female/gray.png.json",
      "lpc/spritesheets/hair/bunches/female/green.png.json",
      "lpc/spritesheets/hair/bunches/female/light_brown.png.json",
      "lpc/spritesheets/hair/bunches/female/orange.png.json",
      "lpc/spritesheets/hair/bunches/female/purple.png.json",
      "lpc/spritesheets/hair/bunches/female/red.png.json",
      "lpc/spritesheets/hair/bunches/female/white.png.json",
      "lpc/spritesheets/hair/buzzcut/female/black.png.json",
      "lpc/spritesheets/hair/buzzcut/female/blonde.png.json",
      "lpc/spritesheets/hair/buzzcut/female/blue.png.json",
      "lpc/spritesheets/hair/buzzcut/female/dark_brown.png.json",
      "lpc/spritesheets/hair/buzzcut/female/gold.png.json",
      "lpc/spritesheets/hair/buzzcut/female/gray.png.json",
      "lpc/spritesheets/hair/buzzcut/female/green.png.json",
      "lpc/spritesheets/hair/buzzcut/female/light_brown.png.json",
      "lpc/spritesheets/hair/buzzcut/female/orange.png.json",
      "lpc/spritesheets/hair/buzzcut/female/purple.png.json",
      "lpc/spritesheets/hair/buzzcut/female/red.png.json",
      "lpc/spritesheets/hair/buzzcut/female/white.png.json",
      "lpc/spritesheets/hair/buzzcut/male/black.png.json",
      "lpc/spritesheets/hair/buzzcut/male/blonde.png.json",
      "lpc/spritesheets/hair/buzzcut/male/blue.png.json",
      "lpc/spritesheets/hair/buzzcut/male/dark_brown.png.json",
      "lpc/spritesheets/hair/buzzcut/male/gold.png.json",
      "lpc/spritesheets/hair/buzzcut/male/gray.png.json",
      "lpc/spritesheets/hair/buzzcut/male/green.png.json",
      "lpc/spritesheets/hair/buzzcut/male/light_brown.png.json",
      "lpc/spritesheets/hair/buzzcut/male/orange.png.json",
      "lpc/spritesheets/hair/buzzcut/male/purple.png.json",
      "lpc/spritesheets/hair/buzzcut/male/red.png.json",
      "lpc/spritesheets/hair/buzzcut/male/white.png.json",
      "lpc/spritesheets/hair/cornrows/female/black.png.json",
      "lpc/spritesheets/hair/cornrows/female/blonde.png.json",
      "lpc/spritesheets/hair/cornrows/female/blue.png.json",
      "lpc/spritesheets/hair/cornrows/female/dark_brown.png.json",
      "lpc/spritesheets/hair/cornrows/female/gold.png.json",
      "lpc/spritesheets/hair/cornrows/female/gray.png.json",
      "lpc/spritesheets/hair/cornrows/female/green.png.json",
      "lpc/spritesheets/hair/cornrows/female/light_brown.png.json",
      "lpc/spritesheets/hair/cornrows/female/orange.png.json",
      "lpc/spritesheets/hair/cornrows/female/purple.png.json",
      "lpc/spritesheets/hair/cornrows/female/red.png.json",
      "lpc/spritesheets/hair/cornrows/female/white.png.json",
      "lpc/spritesheets/hair/cornrows/male/black.png.json",
      "lpc/spritesheets/hair/cornrows/male/blonde.png.json",
      "lpc/spritesheets/hair/cornrows/male/blue.png.json",
      "lpc/spritesheets/hair/cornrows/male/dark_brown.png.json",
      "lpc/spritesheets/hair/cornrows/male/gold.png.json",
      "lpc/spritesheets/hair/cornrows/male/gray.png.json",
      "lpc/spritesheets/hair/cornrows/male/green.png.json",
      "lpc/spritesheets/hair/cornrows/male/light_brown.png.json",
      "lpc/spritesheets/hair/cornrows/male/orange.png.json",
      "lpc/spritesheets/hair/cornrows/male/purple.png.json",
      "lpc/spritesheets/hair/cornrows/male/red.png.json",
      "lpc/spritesheets/hair/cornrows/male/white.png.json",
      "lpc/spritesheets/hair/cowlick/female/black.png.json",
      "lpc/spritesheets/hair/cowlick/female/blonde.png.json",
      "lpc/spritesheets/hair/cowlick/female/blue.png.json",
      "lpc/spritesheets/hair/cowlick/female/dark_brown.png.json",
      "lpc/spritesheets/hair/cowlick/female/gold.png.json",
      "lpc/spritesheets/hair/cowlick/female/gray.png.json",
      "lpc/spritesheets/hair/cowlick/female/green.png.json",
      "lpc/spritesheets/hair/cowlick/female/light_brown.png.json",
      "lpc/spritesheets/hair/cowlick/female/orange.png.json",
      "lpc/spritesheets/hair/cowlick/female/purple.png.json",
      "lpc/spritesheets/hair/cowlick/female/red.png.json",
      "lpc/spritesheets/hair/cowlick/female/white.png.json",
      "lpc/spritesheets/hair/cowlick/male/black.png.json",
      "lpc/spritesheets/hair/cowlick/male/blonde.png.json",
      "lpc/spritesheets/hair/cowlick/male/blue.png.json",
      "lpc/spritesheets/hair/cowlick/male/dark_brown.png.json",
      "lpc/spritesheets/hair/cowlick/male/gold.png.json",
      "lpc/spritesheets/hair/cowlick/male/gray.png.json",
      "lpc/spritesheets/hair/cowlick/male/green.png.json",
      "lpc/spritesheets/hair/cowlick/male/light_brown.png.json",
      "lpc/spritesheets/hair/cowlick/male/orange.png.json",
      "lpc/spritesheets/hair/cowlick/male/purple.png.json",
      "lpc/spritesheets/hair/cowlick/male/red.png.json",
      "lpc/spritesheets/hair/cowlick/male/white.png.json",
      "lpc/spritesheets/hair/cowlick_tall/female/black.png.json",
      "lpc/spritesheets/hair/cowlick_tall/female/blonde.png.json",
      "lpc/spritesheets/hair/cowlick_tall/female/blue.png.json",
      "lpc/spritesheets/hair/cowlick_tall/female/dark_brown.png.json",
      "lpc/spritesheets/hair/cowlick_tall/female/gold.png.json",
      "lpc/spritesheets/hair/cowlick_tall/female/gray.png.json",
      "lpc/spritesheets/hair/cowlick_tall/female/green.png.json",
      "lpc/spritesheets/hair/cowlick_tall/female/light_brown.png.json",
      "lpc/spritesheets/hair/cowlick_tall/female/orange.png.json",
      "lpc/spritesheets/hair/cowlick_tall/female/purple.png.json",
      "lpc/spritesheets/hair/cowlick_tall/female/red.png.json",
      "lpc/spritesheets/hair/cowlick_tall/female/white.png.json",
      "lpc/spritesheets/hair/cowlick_tall/male/black.png.json",
      "lpc/spritesheets/hair/cowlick_tall/male/blonde.png.json",
      "lpc/spritesheets/hair/cowlick_tall/male/blue.png.json",
      "lpc/spritesheets/hair/cowlick_tall/male/dark_brown.png.json",
      "lpc/spritesheets/hair/cowlick_tall/male/gold.png.json",
      "lpc/spritesheets/hair/cowlick_tall/male/gray.png.json",
      "lpc/spritesheets/hair/cowlick_tall/male/green.png.json",
      "lpc/spritesheets/hair/cowlick_tall/male/light_brown.png.json",
      "lpc/spritesheets/hair/cowlick_tall/male/orange.png.json",
      "lpc/spritesheets/hair/cowlick_tall/male/purple.png.json",
      "lpc/spritesheets/hair/cowlick_tall/male/red.png.json",
      "lpc/spritesheets/hair/cowlick_tall/male/white.png.json",
      "lpc/spritesheets/hair/curly_long/female/black.png.json",
      "lpc/spritesheets/hair/curly_long/female/blonde.png.json",
      "lpc/spritesheets/hair/curly_long/female/blue.png.json",
      "lpc/spritesheets/hair/curly_long/female/dark_brown.png.json",
      "lpc/spritesheets/hair/curly_long/female/gold.png.json",
      "lpc/spritesheets/hair/curly_long/female/gray.png.json",
      "lpc/spritesheets/hair/curly_long/female/green.png.json",
      "lpc/spritesheets/hair/curly_long/female/light_brown.png.json",
      "lpc/spritesheets/hair/curly_long/female/orange.png.json",
      "lpc/spritesheets/hair/curly_long/female/purple.png.json",
      "lpc/spritesheets/hair/curly_long/female/red.png.json",
      "lpc/spritesheets/hair/curly_long/female/white.png.json",
      "lpc/spritesheets/hair/curly_short/female/black.png.json",
      "lpc/spritesheets/hair/curly_short/female/blonde.png.json",
      "lpc/spritesheets/hair/curly_short/female/blue.png.json",
      "lpc/spritesheets/hair/curly_short/female/dark_brown.png.json",
      "lpc/spritesheets/hair/curly_short/female/gold.png.json",
      "lpc/spritesheets/hair/curly_short/female/gray.png.json",
      "lpc/spritesheets/hair/curly_short/female/green.png.json",
      "lpc/spritesheets/hair/curly_short/female/light_brown.png.json",
      "lpc/spritesheets/hair/curly_short/female/orange.png.json",
      "lpc/spritesheets/hair/curly_short/female/purple.png.json",
      "lpc/spritesheets/hair/curly_short/female/red.png.json",
      "lpc/spritesheets/hair/curly_short/female/white.png.json",
      "lpc/spritesheets/hair/curly_short/male/black.png.json",
      "lpc/spritesheets/hair/curly_short/male/blonde.png.json",
      "lpc/spritesheets/hair/curly_short/male/blue.png.json",
      "lpc/spritesheets/hair/curly_short/male/dark_brown.png.json",
      "lpc/spritesheets/hair/curly_short/male/gold.png.json",
      "lpc/spritesheets/hair/curly_short/male/gray.png.json",
      "lpc/spritesheets/hair/curly_short/male/green.png.json",
      "lpc/spritesheets/hair/curly_short/male/light_brown.png.json",
      "lpc/spritesheets/hair/curly_short/male/orange.png.json",
      "lpc/spritesheets/hair/curly_short/male/purple.png.json",
      "lpc/spritesheets/hair/curly_short/male/red.png.json",
      "lpc/spritesheets/hair/curly_short/male/white.png.json",
      "lpc/spritesheets/hair/curtains/female/black.png.json",
      "lpc/spritesheets/hair/curtains/female/blonde.png.json",
      "lpc/spritesheets/hair/curtains/female/blue.png.json",
      "lpc/spritesheets/hair/curtains/female/dark_brown.png.json",
      "lpc/spritesheets/hair/curtains/female/gold.png.json",
      "lpc/spritesheets/hair/curtains/female/gray.png.json",
      "lpc/spritesheets/hair/curtains/female/green.png.json",
      "lpc/spritesheets/hair/curtains/female/light_brown.png.json",
      "lpc/spritesheets/hair/curtains/female/orange.png.json",
      "lpc/spritesheets/hair/curtains/female/purple.png.json",
      "lpc/spritesheets/hair/curtains/female/red.png.json",
      "lpc/spritesheets/hair/curtains/female/white.png.json",
      "lpc/spritesheets/hair/curtains/male/black.png.json",
      "lpc/spritesheets/hair/curtains/male/blonde.png.json",
      "lpc/spritesheets/hair/curtains/male/blue.png.json",
      "lpc/spritesheets/hair/curtains/male/dark_brown.png.json",
      "lpc/spritesheets/hair/curtains/male/gold.png.json",
      "lpc/spritesheets/hair/curtains/male/gray.png.json",
      "lpc/spritesheets/hair/curtains/male/green.png.json",
      "lpc/spritesheets/hair/curtains/male/light_brown.png.json",
      "lpc/spritesheets/hair/curtains/male/orange.png.json",
      "lpc/spritesheets/hair/curtains/male/purple.png.json",
      "lpc/spritesheets/hair/curtains/male/red.png.json",
      "lpc/spritesheets/hair/curtains/male/white.png.json",
      "lpc/spritesheets/hair/curtains_long/female/black.png.json",
      "lpc/spritesheets/hair/curtains_long/female/blonde.png.json",
      "lpc/spritesheets/hair/curtains_long/female/blue.png.json",
      "lpc/spritesheets/hair/curtains_long/female/dark_brown.png.json",
      "lpc/spritesheets/hair/curtains_long/female/gold.png.json",
      "lpc/spritesheets/hair/curtains_long/female/gray.png.json",
      "lpc/spritesheets/hair/curtains_long/female/green.png.json",
      "lpc/spritesheets/hair/curtains_long/female/light_brown.png.json",
      "lpc/spritesheets/hair/curtains_long/female/orange.png.json",
      "lpc/spritesheets/hair/curtains_long/female/purple.png.json",
      "lpc/spritesheets/hair/curtains_long/female/red.png.json",
      "lpc/spritesheets/hair/curtains_long/female/white.png.json",
      "lpc/spritesheets/hair/curtains_long/male/black.png.json",
      "lpc/spritesheets/hair/curtains_long/male/blonde.png.json",
      "lpc/spritesheets/hair/curtains_long/male/blue.png.json",
      "lpc/spritesheets/hair/curtains_long/male/dark_brown.png.json",
      "lpc/spritesheets/hair/curtains_long/male/gold.png.json",
      "lpc/spritesheets/hair/curtains_long/male/gray.png.json",
      "lpc/spritesheets/hair/curtains_long/male/green.png.json",
      "lpc/spritesheets/hair/curtains_long/male/light_brown.png.json",
      "lpc/spritesheets/hair/curtains_long/male/orange.png.json",
      "lpc/spritesheets/hair/curtains_long/male/purple.png.json",
      "lpc/spritesheets/hair/curtains_long/male/red.png.json",
      "lpc/spritesheets/hair/curtains_long/male/white.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/female/black.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/female/blonde.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/female/blue.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/female/dark_brown.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/female/gold.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/female/gray.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/female/green.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/female/light_brown.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/female/orange.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/female/purple.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/female/red.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/female/white.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/male/black.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/male/blonde.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/male/blue.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/male/dark_brown.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/male/gold.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/male/gray.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/male/green.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/male/light_brown.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/male/orange.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/male/purple.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/male/red.png.json",
      "lpc/spritesheets/hair/dreadlocks_long/male/white.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/female/black.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/female/blonde.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/female/blue.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/female/dark_brown.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/female/gold.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/female/gray.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/female/green.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/female/light_brown.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/female/orange.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/female/purple.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/female/red.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/female/white.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/male/black.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/male/blonde.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/male/blue.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/male/dark_brown.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/male/gold.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/male/gray.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/male/green.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/male/light_brown.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/male/orange.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/male/purple.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/male/red.png.json",
      "lpc/spritesheets/hair/dreadlocks_short/male/white.png.json",
      "lpc/spritesheets/hair/flat_top_fade/female/black.png.json",
      "lpc/spritesheets/hair/flat_top_fade/female/blonde.png.json",
      "lpc/spritesheets/hair/flat_top_fade/female/blue.png.json",
      "lpc/spritesheets/hair/flat_top_fade/female/dark_brown.png.json",
      "lpc/spritesheets/hair/flat_top_fade/female/gold.png.json",
      "lpc/spritesheets/hair/flat_top_fade/female/gray.png.json",
      "lpc/spritesheets/hair/flat_top_fade/female/green.png.json",
      "lpc/spritesheets/hair/flat_top_fade/female/light_brown.png.json",
      "lpc/spritesheets/hair/flat_top_fade/female/orange.png.json",
      "lpc/spritesheets/hair/flat_top_fade/female/purple.png.json",
      "lpc/spritesheets/hair/flat_top_fade/female/red.png.json",
      "lpc/spritesheets/hair/flat_top_fade/female/white.png.json",
      "lpc/spritesheets/hair/flat_top_fade/male/black.png.json",
      "lpc/spritesheets/hair/flat_top_fade/male/blonde.png.json",
      "lpc/spritesheets/hair/flat_top_fade/male/blue.png.json",
      "lpc/spritesheets/hair/flat_top_fade/male/dark_brown.png.json",
      "lpc/spritesheets/hair/flat_top_fade/male/gold.png.json",
      "lpc/spritesheets/hair/flat_top_fade/male/gray.png.json",
      "lpc/spritesheets/hair/flat_top_fade/male/green.png.json",
      "lpc/spritesheets/hair/flat_top_fade/male/light_brown.png.json",
      "lpc/spritesheets/hair/flat_top_fade/male/orange.png.json",
      "lpc/spritesheets/hair/flat_top_fade/male/purple.png.json",
      "lpc/spritesheets/hair/flat_top_fade/male/red.png.json",
      "lpc/spritesheets/hair/flat_top_fade/male/white.png.json",
      "lpc/spritesheets/hair/flat_top_straight/female/black.png.json",
      "lpc/spritesheets/hair/flat_top_straight/female/blonde.png.json",
      "lpc/spritesheets/hair/flat_top_straight/female/blue.png.json",
      "lpc/spritesheets/hair/flat_top_straight/female/dark_brown.png.json",
      "lpc/spritesheets/hair/flat_top_straight/female/gold.png.json",
      "lpc/spritesheets/hair/flat_top_straight/female/gray.png.json",
      "lpc/spritesheets/hair/flat_top_straight/female/green.png.json",
      "lpc/spritesheets/hair/flat_top_straight/female/light_brown.png.json",
      "lpc/spritesheets/hair/flat_top_straight/female/orange.png.json",
      "lpc/spritesheets/hair/flat_top_straight/female/purple.png.json",
      "lpc/spritesheets/hair/flat_top_straight/female/red.png.json",
      "lpc/spritesheets/hair/flat_top_straight/female/white.png.json",
      "lpc/spritesheets/hair/flat_top_straight/male/black.png.json",
      "lpc/spritesheets/hair/flat_top_straight/male/blonde.png.json",
      "lpc/spritesheets/hair/flat_top_straight/male/blue.png.json",
      "lpc/spritesheets/hair/flat_top_straight/male/dark_brown.png.json",
      "lpc/spritesheets/hair/flat_top_straight/male/gold.png.json",
      "lpc/spritesheets/hair/flat_top_straight/male/gray.png.json",
      "lpc/spritesheets/hair/flat_top_straight/male/green.png.json",
      "lpc/spritesheets/hair/flat_top_straight/male/light_brown.png.json",
      "lpc/spritesheets/hair/flat_top_straight/male/orange.png.json",
      "lpc/spritesheets/hair/flat_top_straight/male/purple.png.json",
      "lpc/spritesheets/hair/flat_top_straight/male/red.png.json",
      "lpc/spritesheets/hair/flat_top_straight/male/white.png.json",
      "lpc/spritesheets/hair/half_up/female/black.png.json",
      "lpc/spritesheets/hair/half_up/female/blonde.png.json",
      "lpc/spritesheets/hair/half_up/female/blue.png.json",
      "lpc/spritesheets/hair/half_up/female/dark_brown.png.json",
      "lpc/spritesheets/hair/half_up/female/gold.png.json",
      "lpc/spritesheets/hair/half_up/female/gray.png.json",
      "lpc/spritesheets/hair/half_up/female/green.png.json",
      "lpc/spritesheets/hair/half_up/female/light_brown.png.json",
      "lpc/spritesheets/hair/half_up/female/orange.png.json",
      "lpc/spritesheets/hair/half_up/female/purple.png.json",
      "lpc/spritesheets/hair/half_up/female/red.png.json",
      "lpc/spritesheets/hair/half_up/female/white.png.json",
      "lpc/spritesheets/hair/half_up/male/black.png.json",
      "lpc/spritesheets/hair/half_up/male/blonde.png.json",
      "lpc/spritesheets/hair/half_up/male/blue.png.json",
      "lpc/spritesheets/hair/half_up/male/dark_brown.png.json",
      "lpc/spritesheets/hair/half_up/male/gold.png.json",
      "lpc/spritesheets/hair/half_up/male/gray.png.json",
      "lpc/spritesheets/hair/half_up/male/green.png.json",
      "lpc/spritesheets/hair/half_up/male/light_brown.png.json",
      "lpc/spritesheets/hair/half_up/male/orange.png.json",
      "lpc/spritesheets/hair/half_up/male/purple.png.json",
      "lpc/spritesheets/hair/half_up/male/red.png.json",
      "lpc/spritesheets/hair/half_up/male/white.png.json",
      "lpc/spritesheets/hair/halfmessy/female/black.png.json",
      "lpc/spritesheets/hair/halfmessy/female/blonde.png.json",
      "lpc/spritesheets/hair/halfmessy/female/blue.png.json",
      "lpc/spritesheets/hair/halfmessy/female/dark_brown.png.json",
      "lpc/spritesheets/hair/halfmessy/female/gold.png.json",
      "lpc/spritesheets/hair/halfmessy/female/gray.png.json",
      "lpc/spritesheets/hair/halfmessy/female/green.png.json",
      "lpc/spritesheets/hair/halfmessy/female/light_brown.png.json",
      "lpc/spritesheets/hair/halfmessy/female/orange.png.json",
      "lpc/spritesheets/hair/halfmessy/female/purple.png.json",
      "lpc/spritesheets/hair/halfmessy/female/red.png.json",
      "lpc/spritesheets/hair/halfmessy/female/white.png.json",
      "lpc/spritesheets/hair/halfmessy/male/black.png.json",
      "lpc/spritesheets/hair/halfmessy/male/blonde.png.json",
      "lpc/spritesheets/hair/halfmessy/male/blue.png.json",
      "lpc/spritesheets/hair/halfmessy/male/dark_brown.png.json",
      "lpc/spritesheets/hair/halfmessy/male/gold.png.json",
      "lpc/spritesheets/hair/halfmessy/male/gray.png.json",
      "lpc/spritesheets/hair/halfmessy/male/green.png.json",
      "lpc/spritesheets/hair/halfmessy/male/light_brown.png.json",
      "lpc/spritesheets/hair/halfmessy/male/orange.png.json",
      "lpc/spritesheets/hair/halfmessy/male/purple.png.json",
      "lpc/spritesheets/hair/halfmessy/male/red.png.json",
      "lpc/spritesheets/hair/halfmessy/male/white.png.json",
      "lpc/spritesheets/hair/high_and_tight/female/black.png.json",
      "lpc/spritesheets/hair/high_and_tight/female/blonde.png.json",
      "lpc/spritesheets/hair/high_and_tight/female/blue.png.json",
      "lpc/spritesheets/hair/high_and_tight/female/dark_brown.png.json",
      "lpc/spritesheets/hair/high_and_tight/female/gold.png.json",
      "lpc/spritesheets/hair/high_and_tight/female/gray.png.json",
      "lpc/spritesheets/hair/high_and_tight/female/green.png.json",
      "lpc/spritesheets/hair/high_and_tight/female/light_brown.png.json",
      "lpc/spritesheets/hair/high_and_tight/female/orange.png.json",
      "lpc/spritesheets/hair/high_and_tight/female/purple.png.json",
      "lpc/spritesheets/hair/high_and_tight/female/red.png.json",
      "lpc/spritesheets/hair/high_and_tight/female/white.png.json",
      "lpc/spritesheets/hair/high_and_tight/male/black.png.json",
      "lpc/spritesheets/hair/high_and_tight/male/blonde.png.json",
      "lpc/spritesheets/hair/high_and_tight/male/blue.png.json",
      "lpc/spritesheets/hair/high_and_tight/male/dark_brown.png.json",
      "lpc/spritesheets/hair/high_and_tight/male/gold.png.json",
      "lpc/spritesheets/hair/high_and_tight/male/gray.png.json",
      "lpc/spritesheets/hair/high_and_tight/male/green.png.json",
      "lpc/spritesheets/hair/high_and_tight/male/light_brown.png.json",
      "lpc/spritesheets/hair/high_and_tight/male/orange.png.json",
      "lpc/spritesheets/hair/high_and_tight/male/purple.png.json",
      "lpc/spritesheets/hair/high_and_tight/male/red.png.json",
      "lpc/spritesheets/hair/high_and_tight/male/white.png.json",
      "lpc/spritesheets/hair/high_ponytail/female/black.png.json",
      "lpc/spritesheets/hair/high_ponytail/female/blonde.png.json",
      "lpc/spritesheets/hair/high_ponytail/female/blue.png.json",
      "lpc/spritesheets/hair/high_ponytail/female/dark_brown.png.json",
      "lpc/spritesheets/hair/high_ponytail/female/gold.png.json",
      "lpc/spritesheets/hair/high_ponytail/female/gray.png.json",
      "lpc/spritesheets/hair/high_ponytail/female/green.png.json",
      "lpc/spritesheets/hair/high_ponytail/female/light_brown.png.json",
      "lpc/spritesheets/hair/high_ponytail/female/orange.png.json",
      "lpc/spritesheets/hair/high_ponytail/female/purple.png.json",
      "lpc/spritesheets/hair/high_ponytail/female/red.png.json",
      "lpc/spritesheets/hair/high_ponytail/female/white.png.json",
      "lpc/spritesheets/hair/high_ponytail/male/black.png.json",
      "lpc/spritesheets/hair/high_ponytail/male/blonde.png.json",
      "lpc/spritesheets/hair/high_ponytail/male/blue.png.json",
      "lpc/spritesheets/hair/high_ponytail/male/dark_brown.png.json",
      "lpc/spritesheets/hair/high_ponytail/male/gold.png.json",
      "lpc/spritesheets/hair/high_ponytail/male/gray.png.json",
      "lpc/spritesheets/hair/high_ponytail/male/green.png.json",
      "lpc/spritesheets/hair/high_ponytail/male/light_brown.png.json",
      "lpc/spritesheets/hair/high_ponytail/male/orange.png.json",
      "lpc/spritesheets/hair/high_ponytail/male/purple.png.json",
      "lpc/spritesheets/hair/high_ponytail/male/red.png.json",
      "lpc/spritesheets/hair/high_ponytail/male/white.png.json",
      "lpc/spritesheets/hair/idol/female/black.png.json",
      "lpc/spritesheets/hair/idol/female/blonde.png.json",
      "lpc/spritesheets/hair/idol/female/blue.png.json",
      "lpc/spritesheets/hair/idol/female/dark_brown.png.json",
      "lpc/spritesheets/hair/idol/female/gold.png.json",
      "lpc/spritesheets/hair/idol/female/gray.png.json",
      "lpc/spritesheets/hair/idol/female/green.png.json",
      "lpc/spritesheets/hair/idol/female/light_brown.png.json",
      "lpc/spritesheets/hair/idol/female/orange.png.json",
      "lpc/spritesheets/hair/idol/female/purple.png.json",
      "lpc/spritesheets/hair/idol/female/red.png.json",
      "lpc/spritesheets/hair/idol/female/white.png.json",
      "lpc/spritesheets/hair/idol/male/black.png.json",
      "lpc/spritesheets/hair/idol/male/blonde.png.json",
      "lpc/spritesheets/hair/idol/male/blue.png.json",
      "lpc/spritesheets/hair/idol/male/dark_brown.png.json",
      "lpc/spritesheets/hair/idol/male/gold.png.json",
      "lpc/spritesheets/hair/idol/male/gray.png.json",
      "lpc/spritesheets/hair/idol/male/green.png.json",
      "lpc/spritesheets/hair/idol/male/light_brown.png.json",
      "lpc/spritesheets/hair/idol/male/orange.png.json",
      "lpc/spritesheets/hair/idol/male/purple.png.json",
      "lpc/spritesheets/hair/idol/male/red.png.json",
      "lpc/spritesheets/hair/idol/male/white.png.json",
      "lpc/spritesheets/hair/jewfro/female/black.png.json",
      "lpc/spritesheets/hair/jewfro/female/blonde.png.json",
      "lpc/spritesheets/hair/jewfro/female/blue.png.json",
      "lpc/spritesheets/hair/jewfro/female/dark_brown.png.json",
      "lpc/spritesheets/hair/jewfro/female/gold.png.json",
      "lpc/spritesheets/hair/jewfro/female/gray.png.json",
      "lpc/spritesheets/hair/jewfro/female/green.png.json",
      "lpc/spritesheets/hair/jewfro/female/light_brown.png.json",
      "lpc/spritesheets/hair/jewfro/female/orange.png.json",
      "lpc/spritesheets/hair/jewfro/female/purple.png.json",
      "lpc/spritesheets/hair/jewfro/female/red.png.json",
      "lpc/spritesheets/hair/jewfro/female/white.png.json",
      "lpc/spritesheets/hair/jewfro/male/black.png.json",
      "lpc/spritesheets/hair/jewfro/male/blonde.png.json",
      "lpc/spritesheets/hair/jewfro/male/blue.png.json",
      "lpc/spritesheets/hair/jewfro/male/dark_brown.png.json",
      "lpc/spritesheets/hair/jewfro/male/gold.png.json",
      "lpc/spritesheets/hair/jewfro/male/gray.png.json",
      "lpc/spritesheets/hair/jewfro/male/green.png.json",
      "lpc/spritesheets/hair/jewfro/male/light_brown.png.json",
      "lpc/spritesheets/hair/jewfro/male/orange.png.json",
      "lpc/spritesheets/hair/jewfro/male/purple.png.json",
      "lpc/spritesheets/hair/jewfro/male/red.png.json",
      "lpc/spritesheets/hair/jewfro/male/white.png.json",
      "lpc/spritesheets/hair/lob/female/black.png.json",
      "lpc/spritesheets/hair/lob/female/blonde.png.json",
      "lpc/spritesheets/hair/lob/female/blue.png.json",
      "lpc/spritesheets/hair/lob/female/dark_brown.png.json",
      "lpc/spritesheets/hair/lob/female/gold.png.json",
      "lpc/spritesheets/hair/lob/female/gray.png.json",
      "lpc/spritesheets/hair/lob/female/green.png.json",
      "lpc/spritesheets/hair/lob/female/light_brown.png.json",
      "lpc/spritesheets/hair/lob/female/orange.png.json",
      "lpc/spritesheets/hair/lob/female/purple.png.json",
      "lpc/spritesheets/hair/lob/female/red.png.json",
      "lpc/spritesheets/hair/lob/female/white.png.json",
      "lpc/spritesheets/hair/lob/male/black.png.json",
      "lpc/spritesheets/hair/lob/male/blonde.png.json",
      "lpc/spritesheets/hair/lob/male/blue.png.json",
      "lpc/spritesheets/hair/lob/male/dark_brown.png.json",
      "lpc/spritesheets/hair/lob/male/gold.png.json",
      "lpc/spritesheets/hair/lob/male/gray.png.json",
      "lpc/spritesheets/hair/lob/male/green.png.json",
      "lpc/spritesheets/hair/lob/male/light_brown.png.json",
      "lpc/spritesheets/hair/lob/male/orange.png.json",
      "lpc/spritesheets/hair/lob/male/purple.png.json",
      "lpc/spritesheets/hair/lob/male/red.png.json",
      "lpc/spritesheets/hair/lob/male/white.png.json",
      "lpc/spritesheets/hair/long/female/black.png.json",
      "lpc/spritesheets/hair/long/female/blonde.png.json",
      "lpc/spritesheets/hair/long/female/blue.png.json",
      "lpc/spritesheets/hair/long/female/dark_brown.png.json",
      "lpc/spritesheets/hair/long/female/gold.png.json",
      "lpc/spritesheets/hair/long/female/gray.png.json",
      "lpc/spritesheets/hair/long/female/green.png.json",
      "lpc/spritesheets/hair/long/female/light_brown.png.json",
      "lpc/spritesheets/hair/long/female/orange.png.json",
      "lpc/spritesheets/hair/long/female/purple.png.json",
      "lpc/spritesheets/hair/long/female/red.png.json",
      "lpc/spritesheets/hair/long/female/white.png.json",
      "lpc/spritesheets/hair/long/male/black.png.json",
      "lpc/spritesheets/hair/long/male/blonde.png.json",
      "lpc/spritesheets/hair/long/male/blue.png.json",
      "lpc/spritesheets/hair/long/male/dark_brown.png.json",
      "lpc/spritesheets/hair/long/male/gold.png.json",
      "lpc/spritesheets/hair/long/male/gray.png.json",
      "lpc/spritesheets/hair/long/male/green.png.json",
      "lpc/spritesheets/hair/long/male/light_brown.png.json",
      "lpc/spritesheets/hair/long/male/orange.png.json",
      "lpc/spritesheets/hair/long/male/purple.png.json",
      "lpc/spritesheets/hair/long/male/red.png.json",
      "lpc/spritesheets/hair/long/male/white.png.json",
      "lpc/spritesheets/hair/long_band/female/black.png.json",
      "lpc/spritesheets/hair/long_band/female/blonde.png.json",
      "lpc/spritesheets/hair/long_band/female/blue.png.json",
      "lpc/spritesheets/hair/long_band/female/dark_brown.png.json",
      "lpc/spritesheets/hair/long_band/female/gold.png.json",
      "lpc/spritesheets/hair/long_band/female/gray.png.json",
      "lpc/spritesheets/hair/long_band/female/green.png.json",
      "lpc/spritesheets/hair/long_band/female/light_brown.png.json",
      "lpc/spritesheets/hair/long_band/female/orange.png.json",
      "lpc/spritesheets/hair/long_band/female/purple.png.json",
      "lpc/spritesheets/hair/long_band/female/red.png.json",
      "lpc/spritesheets/hair/long_band/female/white.png.json",
      "lpc/spritesheets/hair/long_center_part/female/black.png.json",
      "lpc/spritesheets/hair/long_center_part/female/blonde.png.json",
      "lpc/spritesheets/hair/long_center_part/female/blue.png.json",
      "lpc/spritesheets/hair/long_center_part/female/dark_brown.png.json",
      "lpc/spritesheets/hair/long_center_part/female/gold.png.json",
      "lpc/spritesheets/hair/long_center_part/female/gray.png.json",
      "lpc/spritesheets/hair/long_center_part/female/green.png.json",
      "lpc/spritesheets/hair/long_center_part/female/light_brown.png.json",
      "lpc/spritesheets/hair/long_center_part/female/orange.png.json",
      "lpc/spritesheets/hair/long_center_part/female/purple.png.json",
      "lpc/spritesheets/hair/long_center_part/female/red.png.json",
      "lpc/spritesheets/hair/long_center_part/female/white.png.json",
      "lpc/spritesheets/hair/long_center_part/male/black.png.json",
      "lpc/spritesheets/hair/long_center_part/male/blonde.png.json",
      "lpc/spritesheets/hair/long_center_part/male/blue.png.json",
      "lpc/spritesheets/hair/long_center_part/male/dark_brown.png.json",
      "lpc/spritesheets/hair/long_center_part/male/gold.png.json",
      "lpc/spritesheets/hair/long_center_part/male/gray.png.json",
      "lpc/spritesheets/hair/long_center_part/male/green.png.json",
      "lpc/spritesheets/hair/long_center_part/male/light_brown.png.json",
      "lpc/spritesheets/hair/long_center_part/male/orange.png.json",
      "lpc/spritesheets/hair/long_center_part/male/purple.png.json",
      "lpc/spritesheets/hair/long_center_part/male/red.png.json",
      "lpc/spritesheets/hair/long_center_part/male/white.png.json",
      "lpc/spritesheets/hair/long_messy/female/black.png.json",
      "lpc/spritesheets/hair/long_messy/female/blonde.png.json",
      "lpc/spritesheets/hair/long_messy/female/blue.png.json",
      "lpc/spritesheets/hair/long_messy/female/dark_brown.png.json",
      "lpc/spritesheets/hair/long_messy/female/gold.png.json",
      "lpc/spritesheets/hair/long_messy/female/gray.png.json",
      "lpc/spritesheets/hair/long_messy/female/green.png.json",
      "lpc/spritesheets/hair/long_messy/female/light_brown.png.json",
      "lpc/spritesheets/hair/long_messy/female/orange.png.json",
      "lpc/spritesheets/hair/long_messy/female/purple.png.json",
      "lpc/spritesheets/hair/long_messy/female/red.png.json",
      "lpc/spritesheets/hair/long_messy/female/white.png.json",
      "lpc/spritesheets/hair/long_messy/male/black.png.json",
      "lpc/spritesheets/hair/long_messy/male/blonde.png.json",
      "lpc/spritesheets/hair/long_messy/male/blue.png.json",
      "lpc/spritesheets/hair/long_messy/male/dark_brown.png.json",
      "lpc/spritesheets/hair/long_messy/male/gold.png.json",
      "lpc/spritesheets/hair/long_messy/male/gray.png.json",
      "lpc/spritesheets/hair/long_messy/male/green.png.json",
      "lpc/spritesheets/hair/long_messy/male/light_brown.png.json",
      "lpc/spritesheets/hair/long_messy/male/orange.png.json",
      "lpc/spritesheets/hair/long_messy/male/purple.png.json",
      "lpc/spritesheets/hair/long_messy/male/red.png.json",
      "lpc/spritesheets/hair/long_messy/male/white.png.json",
      "lpc/spritesheets/hair/long_messy2/female/black.png.json",
      "lpc/spritesheets/hair/long_messy2/female/blonde.png.json",
      "lpc/spritesheets/hair/long_messy2/female/blue.png.json",
      "lpc/spritesheets/hair/long_messy2/female/dark_brown.png.json",
      "lpc/spritesheets/hair/long_messy2/female/gold.png.json",
      "lpc/spritesheets/hair/long_messy2/female/gray.png.json",
      "lpc/spritesheets/hair/long_messy2/female/green.png.json",
      "lpc/spritesheets/hair/long_messy2/female/light_brown.png.json",
      "lpc/spritesheets/hair/long_messy2/female/orange.png.json",
      "lpc/spritesheets/hair/long_messy2/female/purple.png.json",
      "lpc/spritesheets/hair/long_messy2/female/red.png.json",
      "lpc/spritesheets/hair/long_messy2/female/white.png.json",
      "lpc/spritesheets/hair/long_messy2/male/black.png.json",
      "lpc/spritesheets/hair/long_messy2/male/blonde.png.json",
      "lpc/spritesheets/hair/long_messy2/male/blue.png.json",
      "lpc/spritesheets/hair/long_messy2/male/dark_brown.png.json",
      "lpc/spritesheets/hair/long_messy2/male/gold.png.json",
      "lpc/spritesheets/hair/long_messy2/male/gray.png.json",
      "lpc/spritesheets/hair/long_messy2/male/green.png.json",
      "lpc/spritesheets/hair/long_messy2/male/light_brown.png.json",
      "lpc/spritesheets/hair/long_messy2/male/orange.png.json",
      "lpc/spritesheets/hair/long_messy2/male/purple.png.json",
      "lpc/spritesheets/hair/long_messy2/male/red.png.json",
      "lpc/spritesheets/hair/long_messy2/male/white.png.json",
      "lpc/spritesheets/hair/long_tied/female/black.png.json",
      "lpc/spritesheets/hair/long_tied/female/blonde.png.json",
      "lpc/spritesheets/hair/long_tied/female/blue.png.json",
      "lpc/spritesheets/hair/long_tied/female/dark_brown.png.json",
      "lpc/spritesheets/hair/long_tied/female/gold.png.json",
      "lpc/spritesheets/hair/long_tied/female/gray.png.json",
      "lpc/spritesheets/hair/long_tied/female/green.png.json",
      "lpc/spritesheets/hair/long_tied/female/light_brown.png.json",
      "lpc/spritesheets/hair/long_tied/female/orange.png.json",
      "lpc/spritesheets/hair/long_tied/female/purple.png.json",
      "lpc/spritesheets/hair/long_tied/female/red.png.json",
      "lpc/spritesheets/hair/long_tied/female/white.png.json",
      "lpc/spritesheets/hair/long_tied/male/black.png.json",
      "lpc/spritesheets/hair/long_tied/male/blonde.png.json",
      "lpc/spritesheets/hair/long_tied/male/blue.png.json",
      "lpc/spritesheets/hair/long_tied/male/dark_brown.png.json",
      "lpc/spritesheets/hair/long_tied/male/gold.png.json",
      "lpc/spritesheets/hair/long_tied/male/gray.png.json",
      "lpc/spritesheets/hair/long_tied/male/green.png.json",
      "lpc/spritesheets/hair/long_tied/male/light_brown.png.json",
      "lpc/spritesheets/hair/long_tied/male/orange.png.json",
      "lpc/spritesheets/hair/long_tied/male/purple.png.json",
      "lpc/spritesheets/hair/long_tied/male/red.png.json",
      "lpc/spritesheets/hair/long_tied/male/white.png.json",
      "lpc/spritesheets/hair/longhawk/female/black.png.json",
      "lpc/spritesheets/hair/longhawk/female/blonde.png.json",
      "lpc/spritesheets/hair/longhawk/female/blue.png.json",
      "lpc/spritesheets/hair/longhawk/female/dark_brown.png.json",
      "lpc/spritesheets/hair/longhawk/female/gold.png.json",
      "lpc/spritesheets/hair/longhawk/female/gray.png.json",
      "lpc/spritesheets/hair/longhawk/female/green.png.json",
      "lpc/spritesheets/hair/longhawk/female/light_brown.png.json",
      "lpc/spritesheets/hair/longhawk/female/orange.png.json",
      "lpc/spritesheets/hair/longhawk/female/purple.png.json",
      "lpc/spritesheets/hair/longhawk/female/red.png.json",
      "lpc/spritesheets/hair/longhawk/female/white.png.json",
      "lpc/spritesheets/hair/longhawk/male/black.png.json",
      "lpc/spritesheets/hair/longhawk/male/blonde.png.json",
      "lpc/spritesheets/hair/longhawk/male/blue.png.json",
      "lpc/spritesheets/hair/longhawk/male/dark_brown.png.json",
      "lpc/spritesheets/hair/longhawk/male/gold.png.json",
      "lpc/spritesheets/hair/longhawk/male/gray.png.json",
      "lpc/spritesheets/hair/longhawk/male/green.png.json",
      "lpc/spritesheets/hair/longhawk/male/light_brown.png.json",
      "lpc/spritesheets/hair/longhawk/male/orange.png.json",
      "lpc/spritesheets/hair/longhawk/male/purple.png.json",
      "lpc/spritesheets/hair/longhawk/male/red.png.json",
      "lpc/spritesheets/hair/longhawk/male/white.png.json",
      "lpc/spritesheets/hair/longknot/female/black.png.json",
      "lpc/spritesheets/hair/longknot/female/blonde.png.json",
      "lpc/spritesheets/hair/longknot/female/blue.png.json",
      "lpc/spritesheets/hair/longknot/female/dark_brown.png.json",
      "lpc/spritesheets/hair/longknot/female/gold.png.json",
      "lpc/spritesheets/hair/longknot/female/gray.png.json",
      "lpc/spritesheets/hair/longknot/female/green.png.json",
      "lpc/spritesheets/hair/longknot/female/light_brown.png.json",
      "lpc/spritesheets/hair/longknot/female/orange.png.json",
      "lpc/spritesheets/hair/longknot/female/purple.png.json",
      "lpc/spritesheets/hair/longknot/female/red.png.json",
      "lpc/spritesheets/hair/longknot/female/white.png.json",
      "lpc/spritesheets/hair/longknot/male/black.png.json",
      "lpc/spritesheets/hair/longknot/male/blonde.png.json",
      "lpc/spritesheets/hair/longknot/male/blue.png.json",
      "lpc/spritesheets/hair/longknot/male/dark_brown.png.json",
      "lpc/spritesheets/hair/longknot/male/gold.png.json",
      "lpc/spritesheets/hair/longknot/male/gray.png.json",
      "lpc/spritesheets/hair/longknot/male/green.png.json",
      "lpc/spritesheets/hair/longknot/male/light_brown.png.json",
      "lpc/spritesheets/hair/longknot/male/orange.png.json",
      "lpc/spritesheets/hair/longknot/male/purple.png.json",
      "lpc/spritesheets/hair/longknot/male/red.png.json",
      "lpc/spritesheets/hair/longknot/male/white.png.json",
      "lpc/spritesheets/hair/loose/female/black.png.json",
      "lpc/spritesheets/hair/loose/female/blonde.png.json",
      "lpc/spritesheets/hair/loose/female/blue.png.json",
      "lpc/spritesheets/hair/loose/female/dark_brown.png.json",
      "lpc/spritesheets/hair/loose/female/gold.png.json",
      "lpc/spritesheets/hair/loose/female/gray.png.json",
      "lpc/spritesheets/hair/loose/female/green.png.json",
      "lpc/spritesheets/hair/loose/female/light_brown.png.json",
      "lpc/spritesheets/hair/loose/female/orange.png.json",
      "lpc/spritesheets/hair/loose/female/purple.png.json",
      "lpc/spritesheets/hair/loose/female/red.png.json",
      "lpc/spritesheets/hair/loose/female/white.png.json",
      "lpc/spritesheets/hair/loose/male/black.png.json",
      "lpc/spritesheets/hair/loose/male/blonde.png.json",
      "lpc/spritesheets/hair/loose/male/blue.png.json",
      "lpc/spritesheets/hair/loose/male/dark_brown.png.json",
      "lpc/spritesheets/hair/loose/male/gold.png.json",
      "lpc/spritesheets/hair/loose/male/gray.png.json",
      "lpc/spritesheets/hair/loose/male/green.png.json",
      "lpc/spritesheets/hair/loose/male/light_brown.png.json",
      "lpc/spritesheets/hair/loose/male/orange.png.json",
      "lpc/spritesheets/hair/loose/male/purple.png.json",
      "lpc/spritesheets/hair/loose/male/red.png.json",
      "lpc/spritesheets/hair/loose/male/white.png.json",
      "lpc/spritesheets/hair/messy1/female/black.png.json",
      "lpc/spritesheets/hair/messy1/female/blonde.png.json",
      "lpc/spritesheets/hair/messy1/female/blue.png.json",
      "lpc/spritesheets/hair/messy1/female/dark_brown.png.json",
      "lpc/spritesheets/hair/messy1/female/gold.png.json",
      "lpc/spritesheets/hair/messy1/female/gray.png.json",
      "lpc/spritesheets/hair/messy1/female/green.png.json",
      "lpc/spritesheets/hair/messy1/female/light_brown.png.json",
      "lpc/spritesheets/hair/messy1/female/orange.png.json",
      "lpc/spritesheets/hair/messy1/female/purple.png.json",
      "lpc/spritesheets/hair/messy1/female/red.png.json",
      "lpc/spritesheets/hair/messy1/female/white.png.json",
      "lpc/spritesheets/hair/messy1/male/black.png.json",
      "lpc/spritesheets/hair/messy1/male/blonde.png.json",
      "lpc/spritesheets/hair/messy1/male/blue.png.json",
      "lpc/spritesheets/hair/messy1/male/dark_brown.png.json",
      "lpc/spritesheets/hair/messy1/male/gold.png.json",
      "lpc/spritesheets/hair/messy1/male/gray.png.json",
      "lpc/spritesheets/hair/messy1/male/green.png.json",
      "lpc/spritesheets/hair/messy1/male/light_brown.png.json",
      "lpc/spritesheets/hair/messy1/male/orange.png.json",
      "lpc/spritesheets/hair/messy1/male/purple.png.json",
      "lpc/spritesheets/hair/messy1/male/red.png.json",
      "lpc/spritesheets/hair/messy1/male/white.png.json",
      "lpc/spritesheets/hair/messy2/female/black.png.json",
      "lpc/spritesheets/hair/messy2/female/blonde.png.json",
      "lpc/spritesheets/hair/messy2/female/blue.png.json",
      "lpc/spritesheets/hair/messy2/female/dark_brown.png.json",
      "lpc/spritesheets/hair/messy2/female/gold.png.json",
      "lpc/spritesheets/hair/messy2/female/gray.png.json",
      "lpc/spritesheets/hair/messy2/female/green.png.json",
      "lpc/spritesheets/hair/messy2/female/light_brown.png.json",
      "lpc/spritesheets/hair/messy2/female/orange.png.json",
      "lpc/spritesheets/hair/messy2/female/purple.png.json",
      "lpc/spritesheets/hair/messy2/female/red.png.json",
      "lpc/spritesheets/hair/messy2/female/white.png.json",
      "lpc/spritesheets/hair/messy2/male/black.png.json",
      "lpc/spritesheets/hair/messy2/male/blonde.png.json",
      "lpc/spritesheets/hair/messy2/male/blue.png.json",
      "lpc/spritesheets/hair/messy2/male/dark_brown.png.json",
      "lpc/spritesheets/hair/messy2/male/gold.png.json",
      "lpc/spritesheets/hair/messy2/male/gray.png.json",
      "lpc/spritesheets/hair/messy2/male/green.png.json",
      "lpc/spritesheets/hair/messy2/male/light_brown.png.json",
      "lpc/spritesheets/hair/messy2/male/orange.png.json",
      "lpc/spritesheets/hair/messy2/male/purple.png.json",
      "lpc/spritesheets/hair/messy2/male/red.png.json",
      "lpc/spritesheets/hair/messy2/male/white.png.json",
      "lpc/spritesheets/hair/messy3/female/black.png.json",
      "lpc/spritesheets/hair/messy3/female/blonde.png.json",
      "lpc/spritesheets/hair/messy3/female/blue.png.json",
      "lpc/spritesheets/hair/messy3/female/dark_brown.png.json",
      "lpc/spritesheets/hair/messy3/female/gold.png.json",
      "lpc/spritesheets/hair/messy3/female/gray.png.json",
      "lpc/spritesheets/hair/messy3/female/green.png.json",
      "lpc/spritesheets/hair/messy3/female/light_brown.png.json",
      "lpc/spritesheets/hair/messy3/female/orange.png.json",
      "lpc/spritesheets/hair/messy3/female/purple.png.json",
      "lpc/spritesheets/hair/messy3/female/red.png.json",
      "lpc/spritesheets/hair/messy3/female/white.png.json",
      "lpc/spritesheets/hair/messy3/male/black.png.json",
      "lpc/spritesheets/hair/messy3/male/blonde.png.json",
      "lpc/spritesheets/hair/messy3/male/blue.png.json",
      "lpc/spritesheets/hair/messy3/male/dark_brown.png.json",
      "lpc/spritesheets/hair/messy3/male/gold.png.json",
      "lpc/spritesheets/hair/messy3/male/gray.png.json",
      "lpc/spritesheets/hair/messy3/male/green.png.json",
      "lpc/spritesheets/hair/messy3/male/light_brown.png.json",
      "lpc/spritesheets/hair/messy3/male/orange.png.json",
      "lpc/spritesheets/hair/messy3/male/purple.png.json",
      "lpc/spritesheets/hair/messy3/male/red.png.json",
      "lpc/spritesheets/hair/messy3/male/white.png.json",
      "lpc/spritesheets/hair/mop/female/black.png.json",
      "lpc/spritesheets/hair/mop/female/blonde.png.json",
      "lpc/spritesheets/hair/mop/female/blue.png.json",
      "lpc/spritesheets/hair/mop/female/dark_brown.png.json",
      "lpc/spritesheets/hair/mop/female/gold.png.json",
      "lpc/spritesheets/hair/mop/female/gray.png.json",
      "lpc/spritesheets/hair/mop/female/green.png.json",
      "lpc/spritesheets/hair/mop/female/light_brown.png.json",
      "lpc/spritesheets/hair/mop/female/orange.png.json",
      "lpc/spritesheets/hair/mop/female/purple.png.json",
      "lpc/spritesheets/hair/mop/female/red.png.json",
      "lpc/spritesheets/hair/mop/female/white.png.json",
      "lpc/spritesheets/hair/mop/male/black.png.json",
      "lpc/spritesheets/hair/mop/male/blonde.png.json",
      "lpc/spritesheets/hair/mop/male/blue.png.json",
      "lpc/spritesheets/hair/mop/male/dark_brown.png.json",
      "lpc/spritesheets/hair/mop/male/gold.png.json",
      "lpc/spritesheets/hair/mop/male/gray.png.json",
      "lpc/spritesheets/hair/mop/male/green.png.json",
      "lpc/spritesheets/hair/mop/male/light_brown.png.json",
      "lpc/spritesheets/hair/mop/male/orange.png.json",
      "lpc/spritesheets/hair/mop/male/purple.png.json",
      "lpc/spritesheets/hair/mop/male/red.png.json",
      "lpc/spritesheets/hair/mop/male/white.png.json",
      "lpc/spritesheets/hair/natural/female/black.png.json",
      "lpc/spritesheets/hair/natural/female/blonde.png.json",
      "lpc/spritesheets/hair/natural/female/blue.png.json",
      "lpc/spritesheets/hair/natural/female/dark_brown.png.json",
      "lpc/spritesheets/hair/natural/female/gold.png.json",
      "lpc/spritesheets/hair/natural/female/gray.png.json",
      "lpc/spritesheets/hair/natural/female/green.png.json",
      "lpc/spritesheets/hair/natural/female/light_brown.png.json",
      "lpc/spritesheets/hair/natural/female/orange.png.json",
      "lpc/spritesheets/hair/natural/female/purple.png.json",
      "lpc/spritesheets/hair/natural/female/red.png.json",
      "lpc/spritesheets/hair/natural/female/white.png.json",
      "lpc/spritesheets/hair/natural/male/black.png.json",
      "lpc/spritesheets/hair/natural/male/blonde.png.json",
      "lpc/spritesheets/hair/natural/male/blue.png.json",
      "lpc/spritesheets/hair/natural/male/dark_brown.png.json",
      "lpc/spritesheets/hair/natural/male/gold.png.json",
      "lpc/spritesheets/hair/natural/male/gray.png.json",
      "lpc/spritesheets/hair/natural/male/green.png.json",
      "lpc/spritesheets/hair/natural/male/light_brown.png.json",
      "lpc/spritesheets/hair/natural/male/orange.png.json",
      "lpc/spritesheets/hair/natural/male/purple.png.json",
      "lpc/spritesheets/hair/natural/male/red.png.json",
      "lpc/spritesheets/hair/natural/male/white.png.json",
      "lpc/spritesheets/hair/page/female/black.png.json",
      "lpc/spritesheets/hair/page/female/blonde.png.json",
      "lpc/spritesheets/hair/page/female/blue.png.json",
      "lpc/spritesheets/hair/page/female/dark_brown.png.json",
      "lpc/spritesheets/hair/page/female/gold.png.json",
      "lpc/spritesheets/hair/page/female/gray.png.json",
      "lpc/spritesheets/hair/page/female/green.png.json",
      "lpc/spritesheets/hair/page/female/light_brown.png.json",
      "lpc/spritesheets/hair/page/female/orange.png.json",
      "lpc/spritesheets/hair/page/female/purple.png.json",
      "lpc/spritesheets/hair/page/female/red.png.json",
      "lpc/spritesheets/hair/page/female/white.png.json",
      "lpc/spritesheets/hair/page/male/black.png.json",
      "lpc/spritesheets/hair/page/male/blonde.png.json",
      "lpc/spritesheets/hair/page/male/blue.png.json",
      "lpc/spritesheets/hair/page/male/dark_brown.png.json",
      "lpc/spritesheets/hair/page/male/gold.png.json",
      "lpc/spritesheets/hair/page/male/gray.png.json",
      "lpc/spritesheets/hair/page/male/green.png.json",
      "lpc/spritesheets/hair/page/male/light_brown.png.json",
      "lpc/spritesheets/hair/page/male/orange.png.json",
      "lpc/spritesheets/hair/page/male/purple.png.json",
      "lpc/spritesheets/hair/page/male/red.png.json",
      "lpc/spritesheets/hair/page/male/white.png.json",
      "lpc/spritesheets/hair/page2/female/black.png.json",
      "lpc/spritesheets/hair/page2/female/blonde.png.json",
      "lpc/spritesheets/hair/page2/female/blue.png.json",
      "lpc/spritesheets/hair/page2/female/dark_brown.png.json",
      "lpc/spritesheets/hair/page2/female/gold.png.json",
      "lpc/spritesheets/hair/page2/female/gray.png.json",
      "lpc/spritesheets/hair/page2/female/green.png.json",
      "lpc/spritesheets/hair/page2/female/light_brown.png.json",
      "lpc/spritesheets/hair/page2/female/orange.png.json",
      "lpc/spritesheets/hair/page2/female/purple.png.json",
      "lpc/spritesheets/hair/page2/female/red.png.json",
      "lpc/spritesheets/hair/page2/female/white.png.json",
      "lpc/spritesheets/hair/page2/male/black.png.json",
      "lpc/spritesheets/hair/page2/male/blonde.png.json",
      "lpc/spritesheets/hair/page2/male/blue.png.json",
      "lpc/spritesheets/hair/page2/male/dark_brown.png.json",
      "lpc/spritesheets/hair/page2/male/gold.png.json",
      "lpc/spritesheets/hair/page2/male/gray.png.json",
      "lpc/spritesheets/hair/page2/male/green.png.json",
      "lpc/spritesheets/hair/page2/male/light_brown.png.json",
      "lpc/spritesheets/hair/page2/male/orange.png.json",
      "lpc/spritesheets/hair/page2/male/purple.png.json",
      "lpc/spritesheets/hair/page2/male/red.png.json",
      "lpc/spritesheets/hair/page2/male/white.png.json",
      "lpc/spritesheets/hair/part2/female/black.png.json",
      "lpc/spritesheets/hair/part2/female/blonde.png.json",
      "lpc/spritesheets/hair/part2/female/blue.png.json",
      "lpc/spritesheets/hair/part2/female/dark_brown.png.json",
      "lpc/spritesheets/hair/part2/female/gold.png.json",
      "lpc/spritesheets/hair/part2/female/gray.png.json",
      "lpc/spritesheets/hair/part2/female/green.png.json",
      "lpc/spritesheets/hair/part2/female/light_brown.png.json",
      "lpc/spritesheets/hair/part2/female/orange.png.json",
      "lpc/spritesheets/hair/part2/female/purple.png.json",
      "lpc/spritesheets/hair/part2/female/red.png.json",
      "lpc/spritesheets/hair/part2/female/white.png.json",
      "lpc/spritesheets/hair/part2/male/black.png.json",
      "lpc/spritesheets/hair/part2/male/blonde.png.json",
      "lpc/spritesheets/hair/part2/male/blue.png.json",
      "lpc/spritesheets/hair/part2/male/dark_brown.png.json",
      "lpc/spritesheets/hair/part2/male/gold.png.json",
      "lpc/spritesheets/hair/part2/male/gray.png.json",
      "lpc/spritesheets/hair/part2/male/green.png.json",
      "lpc/spritesheets/hair/part2/male/light_brown.png.json",
      "lpc/spritesheets/hair/part2/male/orange.png.json",
      "lpc/spritesheets/hair/part2/male/purple.png.json",
      "lpc/spritesheets/hair/part2/male/red.png.json",
      "lpc/spritesheets/hair/part2/male/white.png.json",
      "lpc/spritesheets/hair/parted/female/black.png.json",
      "lpc/spritesheets/hair/parted/female/blonde.png.json",
      "lpc/spritesheets/hair/parted/female/blue.png.json",
      "lpc/spritesheets/hair/parted/female/dark_brown.png.json",
      "lpc/spritesheets/hair/parted/female/gold.png.json",
      "lpc/spritesheets/hair/parted/female/gray.png.json",
      "lpc/spritesheets/hair/parted/female/green.png.json",
      "lpc/spritesheets/hair/parted/female/light_brown.png.json",
      "lpc/spritesheets/hair/parted/female/orange.png.json",
      "lpc/spritesheets/hair/parted/female/purple.png.json",
      "lpc/spritesheets/hair/parted/female/red.png.json",
      "lpc/spritesheets/hair/parted/female/white.png.json",
      "lpc/spritesheets/hair/parted/male/black.png.json",
      "lpc/spritesheets/hair/parted/male/blonde.png.json",
      "lpc/spritesheets/hair/parted/male/blue.png.json",
      "lpc/spritesheets/hair/parted/male/dark_brown.png.json",
      "lpc/spritesheets/hair/parted/male/gold.png.json",
      "lpc/spritesheets/hair/parted/male/gray.png.json",
      "lpc/spritesheets/hair/parted/male/green.png.json",
      "lpc/spritesheets/hair/parted/male/light_brown.png.json",
      "lpc/spritesheets/hair/parted/male/orange.png.json",
      "lpc/spritesheets/hair/parted/male/purple.png.json",
      "lpc/spritesheets/hair/parted/male/red.png.json",
      "lpc/spritesheets/hair/parted/male/white.png.json",
      "lpc/spritesheets/hair/pixie/female/black.png.json",
      "lpc/spritesheets/hair/pixie/female/blonde.png.json",
      "lpc/spritesheets/hair/pixie/female/blue.png.json",
      "lpc/spritesheets/hair/pixie/female/dark_brown.png.json",
      "lpc/spritesheets/hair/pixie/female/gold.png.json",
      "lpc/spritesheets/hair/pixie/female/gray.png.json",
      "lpc/spritesheets/hair/pixie/female/green.png.json",
      "lpc/spritesheets/hair/pixie/female/light_brown.png.json",
      "lpc/spritesheets/hair/pixie/female/orange.png.json",
      "lpc/spritesheets/hair/pixie/female/purple.png.json",
      "lpc/spritesheets/hair/pixie/female/red.png.json",
      "lpc/spritesheets/hair/pixie/female/white.png.json",
      "lpc/spritesheets/hair/pixie/male/black.png.json",
      "lpc/spritesheets/hair/pixie/male/blonde.png.json",
      "lpc/spritesheets/hair/pixie/male/blue.png.json",
      "lpc/spritesheets/hair/pixie/male/dark_brown.png.json",
      "lpc/spritesheets/hair/pixie/male/gold.png.json",
      "lpc/spritesheets/hair/pixie/male/gray.png.json",
      "lpc/spritesheets/hair/pixie/male/green.png.json",
      "lpc/spritesheets/hair/pixie/male/light_brown.png.json",
      "lpc/spritesheets/hair/pixie/male/orange.png.json",
      "lpc/spritesheets/hair/pixie/male/purple.png.json",
      "lpc/spritesheets/hair/pixie/male/red.png.json",
      "lpc/spritesheets/hair/pixie/male/white.png.json",
      "lpc/spritesheets/hair/plain/female/black.png.json",
      "lpc/spritesheets/hair/plain/female/blonde.png.json",
      "lpc/spritesheets/hair/plain/female/blue.png.json",
      "lpc/spritesheets/hair/plain/female/dark_brown.png.json",
      "lpc/spritesheets/hair/plain/female/gold.png.json",
      "lpc/spritesheets/hair/plain/female/gray.png.json",
      "lpc/spritesheets/hair/plain/female/green.png.json",
      "lpc/spritesheets/hair/plain/female/light_brown.png.json",
      "lpc/spritesheets/hair/plain/female/orange.png.json",
      "lpc/spritesheets/hair/plain/female/purple.png.json",
      "lpc/spritesheets/hair/plain/female/red.png.json",
      "lpc/spritesheets/hair/plain/female/white.png.json",
      "lpc/spritesheets/hair/plain/male/black.png.json",
      "lpc/spritesheets/hair/plain/male/blonde.png.json",
      "lpc/spritesheets/hair/plain/male/blue.png.json",
      "lpc/spritesheets/hair/plain/male/dark_brown.png.json",
      "lpc/spritesheets/hair/plain/male/gold.png.json",
      "lpc/spritesheets/hair/plain/male/gray.png.json",
      "lpc/spritesheets/hair/plain/male/green.png.json",
      "lpc/spritesheets/hair/plain/male/light_brown.png.json",
      "lpc/spritesheets/hair/plain/male/orange.png.json",
      "lpc/spritesheets/hair/plain/male/purple.png.json",
      "lpc/spritesheets/hair/plain/male/red.png.json",
      "lpc/spritesheets/hair/plain/male/white.png.json",
      "lpc/spritesheets/hair/ponytail/female/black.png.json",
      "lpc/spritesheets/hair/ponytail/female/blonde.png.json",
      "lpc/spritesheets/hair/ponytail/female/blue.png.json",
      "lpc/spritesheets/hair/ponytail/female/dark_brown.png.json",
      "lpc/spritesheets/hair/ponytail/female/gold.png.json",
      "lpc/spritesheets/hair/ponytail/female/gray.png.json",
      "lpc/spritesheets/hair/ponytail/female/green.png.json",
      "lpc/spritesheets/hair/ponytail/female/light_brown.png.json",
      "lpc/spritesheets/hair/ponytail/female/orange.png.json",
      "lpc/spritesheets/hair/ponytail/female/purple.png.json",
      "lpc/spritesheets/hair/ponytail/female/red.png.json",
      "lpc/spritesheets/hair/ponytail/female/white.png.json",
      "lpc/spritesheets/hair/ponytail/male/black.png.json",
      "lpc/spritesheets/hair/ponytail/male/blonde.png.json",
      "lpc/spritesheets/hair/ponytail/male/blue.png.json",
      "lpc/spritesheets/hair/ponytail/male/dark_brown.png.json",
      "lpc/spritesheets/hair/ponytail/male/gold.png.json",
      "lpc/spritesheets/hair/ponytail/male/gray.png.json",
      "lpc/spritesheets/hair/ponytail/male/green.png.json",
      "lpc/spritesheets/hair/ponytail/male/light_brown.png.json",
      "lpc/spritesheets/hair/ponytail/male/orange.png.json",
      "lpc/spritesheets/hair/ponytail/male/purple.png.json",
      "lpc/spritesheets/hair/ponytail/male/red.png.json",
      "lpc/spritesheets/hair/ponytail/male/white.png.json",
      "lpc/spritesheets/hair/ponytail2/female/black.png.json",
      "lpc/spritesheets/hair/ponytail2/female/blonde.png.json",
      "lpc/spritesheets/hair/ponytail2/female/blue.png.json",
      "lpc/spritesheets/hair/ponytail2/female/dark_brown.png.json",
      "lpc/spritesheets/hair/ponytail2/female/gold.png.json",
      "lpc/spritesheets/hair/ponytail2/female/gray.png.json",
      "lpc/spritesheets/hair/ponytail2/female/green.png.json",
      "lpc/spritesheets/hair/ponytail2/female/light_brown.png.json",
      "lpc/spritesheets/hair/ponytail2/female/orange.png.json",
      "lpc/spritesheets/hair/ponytail2/female/purple.png.json",
      "lpc/spritesheets/hair/ponytail2/female/red.png.json",
      "lpc/spritesheets/hair/ponytail2/female/white.png.json",
      "lpc/spritesheets/hair/ponytail2/male/black.png.json",
      "lpc/spritesheets/hair/ponytail2/male/blonde.png.json",
      "lpc/spritesheets/hair/ponytail2/male/blue.png.json",
      "lpc/spritesheets/hair/ponytail2/male/dark_brown.png.json",
      "lpc/spritesheets/hair/ponytail2/male/gold.png.json",
      "lpc/spritesheets/hair/ponytail2/male/gray.png.json",
      "lpc/spritesheets/hair/ponytail2/male/green.png.json",
      "lpc/spritesheets/hair/ponytail2/male/light_brown.png.json",
      "lpc/spritesheets/hair/ponytail2/male/orange.png.json",
      "lpc/spritesheets/hair/ponytail2/male/purple.png.json",
      "lpc/spritesheets/hair/ponytail2/male/red.png.json",
      "lpc/spritesheets/hair/ponytail2/male/white.png.json",
      "lpc/spritesheets/hair/princess/female/black.png.json",
      "lpc/spritesheets/hair/princess/female/blonde.png.json",
      "lpc/spritesheets/hair/princess/female/blue.png.json",
      "lpc/spritesheets/hair/princess/female/dark_brown.png.json",
      "lpc/spritesheets/hair/princess/female/gold.png.json",
      "lpc/spritesheets/hair/princess/female/gray.png.json",
      "lpc/spritesheets/hair/princess/female/green.png.json",
      "lpc/spritesheets/hair/princess/female/light_brown.png.json",
      "lpc/spritesheets/hair/princess/female/orange.png.json",
      "lpc/spritesheets/hair/princess/female/purple.png.json",
      "lpc/spritesheets/hair/princess/female/red.png.json",
      "lpc/spritesheets/hair/princess/female/white.png.json",
      "lpc/spritesheets/hair/sara/female/black.png.json",
      "lpc/spritesheets/hair/sara/female/blonde.png.json",
      "lpc/spritesheets/hair/sara/female/blue.png.json",
      "lpc/spritesheets/hair/sara/female/dark_brown.png.json",
      "lpc/spritesheets/hair/sara/female/gold.png.json",
      "lpc/spritesheets/hair/sara/female/gray.png.json",
      "lpc/spritesheets/hair/sara/female/green.png.json",
      "lpc/spritesheets/hair/sara/female/light_brown.png.json",
      "lpc/spritesheets/hair/sara/female/orange.png.json",
      "lpc/spritesheets/hair/sara/female/purple.png.json",
      "lpc/spritesheets/hair/sara/female/red.png.json",
      "lpc/spritesheets/hair/sara/female/white.png.json",
      "lpc/spritesheets/hair/shorthawk/female/black.png.json",
      "lpc/spritesheets/hair/shorthawk/female/blonde.png.json",
      "lpc/spritesheets/hair/shorthawk/female/blue.png.json",
      "lpc/spritesheets/hair/shorthawk/female/dark_brown.png.json",
      "lpc/spritesheets/hair/shorthawk/female/gold.png.json",
      "lpc/spritesheets/hair/shorthawk/female/gray.png.json",
      "lpc/spritesheets/hair/shorthawk/female/green.png.json",
      "lpc/spritesheets/hair/shorthawk/female/light_brown.png.json",
      "lpc/spritesheets/hair/shorthawk/female/orange.png.json",
      "lpc/spritesheets/hair/shorthawk/female/purple.png.json",
      "lpc/spritesheets/hair/shorthawk/female/red.png.json",
      "lpc/spritesheets/hair/shorthawk/female/white.png.json",
      "lpc/spritesheets/hair/shorthawk/male/black.png.json",
      "lpc/spritesheets/hair/shorthawk/male/blonde.png.json",
      "lpc/spritesheets/hair/shorthawk/male/blue.png.json",
      "lpc/spritesheets/hair/shorthawk/male/dark_brown.png.json",
      "lpc/spritesheets/hair/shorthawk/male/gold.png.json",
      "lpc/spritesheets/hair/shorthawk/male/gray.png.json",
      "lpc/spritesheets/hair/shorthawk/male/green.png.json",
      "lpc/spritesheets/hair/shorthawk/male/light_brown.png.json",
      "lpc/spritesheets/hair/shorthawk/male/orange.png.json",
      "lpc/spritesheets/hair/shorthawk/male/purple.png.json",
      "lpc/spritesheets/hair/shorthawk/male/red.png.json",
      "lpc/spritesheets/hair/shorthawk/male/white.png.json",
      "lpc/spritesheets/hair/shortknot/female/black.png.json",
      "lpc/spritesheets/hair/shortknot/female/blonde.png.json",
      "lpc/spritesheets/hair/shortknot/female/blue.png.json",
      "lpc/spritesheets/hair/shortknot/female/dark_brown.png.json",
      "lpc/spritesheets/hair/shortknot/female/gold.png.json",
      "lpc/spritesheets/hair/shortknot/female/gray.png.json",
      "lpc/spritesheets/hair/shortknot/female/green.png.json",
      "lpc/spritesheets/hair/shortknot/female/light_brown.png.json",
      "lpc/spritesheets/hair/shortknot/female/orange.png.json",
      "lpc/spritesheets/hair/shortknot/female/purple.png.json",
      "lpc/spritesheets/hair/shortknot/female/red.png.json",
      "lpc/spritesheets/hair/shortknot/female/white.png.json",
      "lpc/spritesheets/hair/shortknot/male/black.png.json",
      "lpc/spritesheets/hair/shortknot/male/blonde.png.json",
      "lpc/spritesheets/hair/shortknot/male/blue.png.json",
      "lpc/spritesheets/hair/shortknot/male/dark_brown.png.json",
      "lpc/spritesheets/hair/shortknot/male/gold.png.json",
      "lpc/spritesheets/hair/shortknot/male/gray.png.json",
      "lpc/spritesheets/hair/shortknot/male/green.png.json",
      "lpc/spritesheets/hair/shortknot/male/light_brown.png.json",
      "lpc/spritesheets/hair/shortknot/male/orange.png.json",
      "lpc/spritesheets/hair/shortknot/male/purple.png.json",
      "lpc/spritesheets/hair/shortknot/male/red.png.json",
      "lpc/spritesheets/hair/shortknot/male/white.png.json",
      "lpc/spritesheets/hair/shoulderl/female/black.png.json",
      "lpc/spritesheets/hair/shoulderl/female/blonde.png.json",
      "lpc/spritesheets/hair/shoulderl/female/blue.png.json",
      "lpc/spritesheets/hair/shoulderl/female/dark_brown.png.json",
      "lpc/spritesheets/hair/shoulderl/female/gold.png.json",
      "lpc/spritesheets/hair/shoulderl/female/gray.png.json",
      "lpc/spritesheets/hair/shoulderl/female/green.png.json",
      "lpc/spritesheets/hair/shoulderl/female/light_brown.png.json",
      "lpc/spritesheets/hair/shoulderl/female/orange.png.json",
      "lpc/spritesheets/hair/shoulderl/female/purple.png.json",
      "lpc/spritesheets/hair/shoulderl/female/red.png.json",
      "lpc/spritesheets/hair/shoulderl/female/white.png.json",
      "lpc/spritesheets/hair/shoulderr/female/black.png.json",
      "lpc/spritesheets/hair/shoulderr/female/blonde.png.json",
      "lpc/spritesheets/hair/shoulderr/female/blue.png.json",
      "lpc/spritesheets/hair/shoulderr/female/dark_brown.png.json",
      "lpc/spritesheets/hair/shoulderr/female/gold.png.json",
      "lpc/spritesheets/hair/shoulderr/female/gray.png.json",
      "lpc/spritesheets/hair/shoulderr/female/green.png.json",
      "lpc/spritesheets/hair/shoulderr/female/light_brown.png.json",
      "lpc/spritesheets/hair/shoulderr/female/orange.png.json",
      "lpc/spritesheets/hair/shoulderr/female/purple.png.json",
      "lpc/spritesheets/hair/shoulderr/female/red.png.json",
      "lpc/spritesheets/hair/shoulderr/female/white.png.json",
      "lpc/spritesheets/hair/single/female/black.png.json",
      "lpc/spritesheets/hair/single/female/blonde.png.json",
      "lpc/spritesheets/hair/single/female/blue.png.json",
      "lpc/spritesheets/hair/single/female/dark_brown.png.json",
      "lpc/spritesheets/hair/single/female/gold.png.json",
      "lpc/spritesheets/hair/single/female/gray.png.json",
      "lpc/spritesheets/hair/single/female/green.png.json",
      "lpc/spritesheets/hair/single/female/light_brown.png.json",
      "lpc/spritesheets/hair/single/female/orange.png.json",
      "lpc/spritesheets/hair/single/female/purple.png.json",
      "lpc/spritesheets/hair/single/female/red.png.json",
      "lpc/spritesheets/hair/single/female/white.png.json",
      "lpc/spritesheets/hair/single/male/black.png.json",
      "lpc/spritesheets/hair/single/male/blonde.png.json",
      "lpc/spritesheets/hair/single/male/blue.png.json",
      "lpc/spritesheets/hair/single/male/dark_brown.png.json",
      "lpc/spritesheets/hair/single/male/gold.png.json",
      "lpc/spritesheets/hair/single/male/gray.png.json",
      "lpc/spritesheets/hair/single/male/green.png.json",
      "lpc/spritesheets/hair/single/male/light_brown.png.json",
      "lpc/spritesheets/hair/single/male/orange.png.json",
      "lpc/spritesheets/hair/single/male/purple.png.json",
      "lpc/spritesheets/hair/single/male/red.png.json",
      "lpc/spritesheets/hair/single/male/white.png.json",
      "lpc/spritesheets/hair/spiked/female/black.png.json",
      "lpc/spritesheets/hair/spiked/female/blonde.png.json",
      "lpc/spritesheets/hair/spiked/female/blue.png.json",
      "lpc/spritesheets/hair/spiked/female/dark_brown.png.json",
      "lpc/spritesheets/hair/spiked/female/gold.png.json",
      "lpc/spritesheets/hair/spiked/female/gray.png.json",
      "lpc/spritesheets/hair/spiked/female/green.png.json",
      "lpc/spritesheets/hair/spiked/female/light_brown.png.json",
      "lpc/spritesheets/hair/spiked/female/orange.png.json",
      "lpc/spritesheets/hair/spiked/female/purple.png.json",
      "lpc/spritesheets/hair/spiked/female/red.png.json",
      "lpc/spritesheets/hair/spiked/female/white.png.json",
      "lpc/spritesheets/hair/spiked/male/black.png.json",
      "lpc/spritesheets/hair/spiked/male/blonde.png.json",
      "lpc/spritesheets/hair/spiked/male/blue.png.json",
      "lpc/spritesheets/hair/spiked/male/dark_brown.png.json",
      "lpc/spritesheets/hair/spiked/male/gold.png.json",
      "lpc/spritesheets/hair/spiked/male/gray.png.json",
      "lpc/spritesheets/hair/spiked/male/green.png.json",
      "lpc/spritesheets/hair/spiked/male/light_brown.png.json",
      "lpc/spritesheets/hair/spiked/male/orange.png.json",
      "lpc/spritesheets/hair/spiked/male/purple.png.json",
      "lpc/spritesheets/hair/spiked/male/red.png.json",
      "lpc/spritesheets/hair/spiked/male/white.png.json",
      "lpc/spritesheets/hair/spiked2/female/black.png.json",
      "lpc/spritesheets/hair/spiked2/female/blonde.png.json",
      "lpc/spritesheets/hair/spiked2/female/blue.png.json",
      "lpc/spritesheets/hair/spiked2/female/dark_brown.png.json",
      "lpc/spritesheets/hair/spiked2/female/gold.png.json",
      "lpc/spritesheets/hair/spiked2/female/gray.png.json",
      "lpc/spritesheets/hair/spiked2/female/green.png.json",
      "lpc/spritesheets/hair/spiked2/female/light_brown.png.json",
      "lpc/spritesheets/hair/spiked2/female/orange.png.json",
      "lpc/spritesheets/hair/spiked2/female/purple.png.json",
      "lpc/spritesheets/hair/spiked2/female/red.png.json",
      "lpc/spritesheets/hair/spiked2/female/white.png.json",
      "lpc/spritesheets/hair/spiked2/male/black.png.json",
      "lpc/spritesheets/hair/spiked2/male/blonde.png.json",
      "lpc/spritesheets/hair/spiked2/male/blue.png.json",
      "lpc/spritesheets/hair/spiked2/male/dark_brown.png.json",
      "lpc/spritesheets/hair/spiked2/male/gold.png.json",
      "lpc/spritesheets/hair/spiked2/male/gray.png.json",
      "lpc/spritesheets/hair/spiked2/male/green.png.json",
      "lpc/spritesheets/hair/spiked2/male/light_brown.png.json",
      "lpc/spritesheets/hair/spiked2/male/orange.png.json",
      "lpc/spritesheets/hair/spiked2/male/purple.png.json",
      "lpc/spritesheets/hair/spiked2/male/red.png.json",
      "lpc/spritesheets/hair/spiked2/male/white.png.json",
      "lpc/spritesheets/hair/spiked_beehive/female/black.png.json",
      "lpc/spritesheets/hair/spiked_beehive/female/blonde.png.json",
      "lpc/spritesheets/hair/spiked_beehive/female/blue.png.json",
      "lpc/spritesheets/hair/spiked_beehive/female/dark_brown.png.json",
      "lpc/spritesheets/hair/spiked_beehive/female/gold.png.json",
      "lpc/spritesheets/hair/spiked_beehive/female/gray.png.json",
      "lpc/spritesheets/hair/spiked_beehive/female/green.png.json",
      "lpc/spritesheets/hair/spiked_beehive/female/light_brown.png.json",
      "lpc/spritesheets/hair/spiked_beehive/female/orange.png.json",
      "lpc/spritesheets/hair/spiked_beehive/female/purple.png.json",
      "lpc/spritesheets/hair/spiked_beehive/female/red.png.json",
      "lpc/spritesheets/hair/spiked_beehive/female/white.png.json",
      "lpc/spritesheets/hair/spiked_beehive/male/black.png.json",
      "lpc/spritesheets/hair/spiked_beehive/male/blonde.png.json",
      "lpc/spritesheets/hair/spiked_beehive/male/blue.png.json",
      "lpc/spritesheets/hair/spiked_beehive/male/dark_brown.png.json",
      "lpc/spritesheets/hair/spiked_beehive/male/gold.png.json",
      "lpc/spritesheets/hair/spiked_beehive/male/gray.png.json",
      "lpc/spritesheets/hair/spiked_beehive/male/green.png.json",
      "lpc/spritesheets/hair/spiked_beehive/male/light_brown.png.json",
      "lpc/spritesheets/hair/spiked_beehive/male/orange.png.json",
      "lpc/spritesheets/hair/spiked_beehive/male/purple.png.json",
      "lpc/spritesheets/hair/spiked_beehive/male/red.png.json",
      "lpc/spritesheets/hair/spiked_beehive/male/white.png.json",
      "lpc/spritesheets/hair/spiked_liberty/female/black.png.json",
      "lpc/spritesheets/hair/spiked_liberty/female/blonde.png.json",
      "lpc/spritesheets/hair/spiked_liberty/female/blue.png.json",
      "lpc/spritesheets/hair/spiked_liberty/female/dark_brown.png.json",
      "lpc/spritesheets/hair/spiked_liberty/female/gold.png.json",
      "lpc/spritesheets/hair/spiked_liberty/female/gray.png.json",
      "lpc/spritesheets/hair/spiked_liberty/female/green.png.json",
      "lpc/spritesheets/hair/spiked_liberty/female/light_brown.png.json",
      "lpc/spritesheets/hair/spiked_liberty/female/orange.png.json",
      "lpc/spritesheets/hair/spiked_liberty/female/purple.png.json",
      "lpc/spritesheets/hair/spiked_liberty/female/red.png.json",
      "lpc/spritesheets/hair/spiked_liberty/female/white.png.json",
      "lpc/spritesheets/hair/spiked_liberty/male/black.png.json",
      "lpc/spritesheets/hair/spiked_liberty/male/blonde.png.json",
      "lpc/spritesheets/hair/spiked_liberty/male/blue.png.json",
      "lpc/spritesheets/hair/spiked_liberty/male/dark_brown.png.json",
      "lpc/spritesheets/hair/spiked_liberty/male/gold.png.json",
      "lpc/spritesheets/hair/spiked_liberty/male/gray.png.json",
      "lpc/spritesheets/hair/spiked_liberty/male/green.png.json",
      "lpc/spritesheets/hair/spiked_liberty/male/light_brown.png.json",
      "lpc/spritesheets/hair/spiked_liberty/male/orange.png.json",
      "lpc/spritesheets/hair/spiked_liberty/male/purple.png.json",
      "lpc/spritesheets/hair/spiked_liberty/male/red.png.json",
      "lpc/spritesheets/hair/spiked_liberty/male/white.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/female/black.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/female/blonde.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/female/blue.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/female/dark_brown.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/female/gold.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/female/gray.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/female/green.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/female/light_brown.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/female/orange.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/female/purple.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/female/red.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/female/white.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/male/black.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/male/blonde.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/male/blue.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/male/dark_brown.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/male/gold.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/male/gray.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/male/green.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/male/light_brown.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/male/orange.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/male/purple.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/male/red.png.json",
      "lpc/spritesheets/hair/spiked_liberty2/male/white.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/female/black.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/female/blonde.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/female/blue.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/female/dark_brown.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/female/gold.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/female/gray.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/female/green.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/female/light_brown.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/female/orange.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/female/purple.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/female/red.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/female/white.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/male/black.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/male/blonde.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/male/blue.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/male/dark_brown.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/male/gold.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/male/gray.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/male/green.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/male/light_brown.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/male/orange.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/male/purple.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/male/red.png.json",
      "lpc/spritesheets/hair/spiked_porcupine/male/white.png.json",
      "lpc/spritesheets/hair/swoop/female/black.png.json",
      "lpc/spritesheets/hair/swoop/female/blonde.png.json",
      "lpc/spritesheets/hair/swoop/female/blue.png.json",
      "lpc/spritesheets/hair/swoop/female/dark_brown.png.json",
      "lpc/spritesheets/hair/swoop/female/gold.png.json",
      "lpc/spritesheets/hair/swoop/female/gray.png.json",
      "lpc/spritesheets/hair/swoop/female/green.png.json",
      "lpc/spritesheets/hair/swoop/female/light_brown.png.json",
      "lpc/spritesheets/hair/swoop/female/orange.png.json",
      "lpc/spritesheets/hair/swoop/female/purple.png.json",
      "lpc/spritesheets/hair/swoop/female/red.png.json",
      "lpc/spritesheets/hair/swoop/female/white.png.json",
      "lpc/spritesheets/hair/swoop/male/black.png.json",
      "lpc/spritesheets/hair/swoop/male/blonde.png.json",
      "lpc/spritesheets/hair/swoop/male/blue.png.json",
      "lpc/spritesheets/hair/swoop/male/dark_brown.png.json",
      "lpc/spritesheets/hair/swoop/male/gold.png.json",
      "lpc/spritesheets/hair/swoop/male/gray.png.json",
      "lpc/spritesheets/hair/swoop/male/green.png.json",
      "lpc/spritesheets/hair/swoop/male/light_brown.png.json",
      "lpc/spritesheets/hair/swoop/male/orange.png.json",
      "lpc/spritesheets/hair/swoop/male/purple.png.json",
      "lpc/spritesheets/hair/swoop/male/red.png.json",
      "lpc/spritesheets/hair/swoop/male/white.png.json",
      "lpc/spritesheets/hair/twists_fade/female/black.png.json",
      "lpc/spritesheets/hair/twists_fade/female/blonde.png.json",
      "lpc/spritesheets/hair/twists_fade/female/blue.png.json",
      "lpc/spritesheets/hair/twists_fade/female/dark_brown.png.json",
      "lpc/spritesheets/hair/twists_fade/female/gold.png.json",
      "lpc/spritesheets/hair/twists_fade/female/gray.png.json",
      "lpc/spritesheets/hair/twists_fade/female/green.png.json",
      "lpc/spritesheets/hair/twists_fade/female/light_brown.png.json",
      "lpc/spritesheets/hair/twists_fade/female/orange.png.json",
      "lpc/spritesheets/hair/twists_fade/female/purple.png.json",
      "lpc/spritesheets/hair/twists_fade/female/red.png.json",
      "lpc/spritesheets/hair/twists_fade/female/white.png.json",
      "lpc/spritesheets/hair/twists_fade/male/black.png.json",
      "lpc/spritesheets/hair/twists_fade/male/blonde.png.json",
      "lpc/spritesheets/hair/twists_fade/male/blue.png.json",
      "lpc/spritesheets/hair/twists_fade/male/dark_brown.png.json",
      "lpc/spritesheets/hair/twists_fade/male/gold.png.json",
      "lpc/spritesheets/hair/twists_fade/male/gray.png.json",
      "lpc/spritesheets/hair/twists_fade/male/green.png.json",
      "lpc/spritesheets/hair/twists_fade/male/light_brown.png.json",
      "lpc/spritesheets/hair/twists_fade/male/orange.png.json",
      "lpc/spritesheets/hair/twists_fade/male/purple.png.json",
      "lpc/spritesheets/hair/twists_fade/male/red.png.json",
      "lpc/spritesheets/hair/twists_fade/male/white.png.json",
      "lpc/spritesheets/hair/twists_straight/female/black.png.json",
      "lpc/spritesheets/hair/twists_straight/female/blonde.png.json",
      "lpc/spritesheets/hair/twists_straight/female/blue.png.json",
      "lpc/spritesheets/hair/twists_straight/female/dark_brown.png.json",
      "lpc/spritesheets/hair/twists_straight/female/gold.png.json",
      "lpc/spritesheets/hair/twists_straight/female/gray.png.json",
      "lpc/spritesheets/hair/twists_straight/female/green.png.json",
      "lpc/spritesheets/hair/twists_straight/female/light_brown.png.json",
      "lpc/spritesheets/hair/twists_straight/female/orange.png.json",
      "lpc/spritesheets/hair/twists_straight/female/purple.png.json",
      "lpc/spritesheets/hair/twists_straight/female/red.png.json",
      "lpc/spritesheets/hair/twists_straight/female/white.png.json",
      "lpc/spritesheets/hair/twists_straight/male/black.png.json",
      "lpc/spritesheets/hair/twists_straight/male/blonde.png.json",
      "lpc/spritesheets/hair/twists_straight/male/blue.png.json",
      "lpc/spritesheets/hair/twists_straight/male/dark_brown.png.json",
      "lpc/spritesheets/hair/twists_straight/male/gold.png.json",
      "lpc/spritesheets/hair/twists_straight/male/gray.png.json",
      "lpc/spritesheets/hair/twists_straight/male/green.png.json",
      "lpc/spritesheets/hair/twists_straight/male/light_brown.png.json",
      "lpc/spritesheets/hair/twists_straight/male/orange.png.json",
      "lpc/spritesheets/hair/twists_straight/male/purple.png.json",
      "lpc/spritesheets/hair/twists_straight/male/red.png.json",
      "lpc/spritesheets/hair/twists_straight/male/white.png.json",
      "lpc/spritesheets/hair/unkempt/female/black.png.json",
      "lpc/spritesheets/hair/unkempt/female/blonde.png.json",
      "lpc/spritesheets/hair/unkempt/female/blue.png.json",
      "lpc/spritesheets/hair/unkempt/female/dark_brown.png.json",
      "lpc/spritesheets/hair/unkempt/female/gold.png.json",
      "lpc/spritesheets/hair/unkempt/female/gray.png.json",
      "lpc/spritesheets/hair/unkempt/female/green.png.json",
      "lpc/spritesheets/hair/unkempt/female/light_brown.png.json",
      "lpc/spritesheets/hair/unkempt/female/orange.png.json",
      "lpc/spritesheets/hair/unkempt/female/purple.png.json",
      "lpc/spritesheets/hair/unkempt/female/red.png.json",
      "lpc/spritesheets/hair/unkempt/female/white.png.json",
      "lpc/spritesheets/hair/unkempt/male/black.png.json",
      "lpc/spritesheets/hair/unkempt/male/blonde.png.json",
      "lpc/spritesheets/hair/unkempt/male/blue.png.json",
      "lpc/spritesheets/hair/unkempt/male/dark_brown.png.json",
      "lpc/spritesheets/hair/unkempt/male/gold.png.json",
      "lpc/spritesheets/hair/unkempt/male/gray.png.json",
      "lpc/spritesheets/hair/unkempt/male/green.png.json",
      "lpc/spritesheets/hair/unkempt/male/light_brown.png.json",
      "lpc/spritesheets/hair/unkempt/male/orange.png.json",
      "lpc/spritesheets/hair/unkempt/male/purple.png.json",
      "lpc/spritesheets/hair/unkempt/male/red.png.json",
      "lpc/spritesheets/hair/unkempt/male/white.png.json",
      "lpc/spritesheets/hair/wavy/female/black.png.json",
      "lpc/spritesheets/hair/wavy/female/blonde.png.json",
      "lpc/spritesheets/hair/wavy/female/blue.png.json",
      "lpc/spritesheets/hair/wavy/female/dark_brown.png.json",
      "lpc/spritesheets/hair/wavy/female/gold.png.json",
      "lpc/spritesheets/hair/wavy/female/gray.png.json",
      "lpc/spritesheets/hair/wavy/female/green.png.json",
      "lpc/spritesheets/hair/wavy/female/light_brown.png.json",
      "lpc/spritesheets/hair/wavy/female/orange.png.json",
      "lpc/spritesheets/hair/wavy/female/purple.png.json",
      "lpc/spritesheets/hair/wavy/female/red.png.json",
      "lpc/spritesheets/hair/wavy/female/white.png.json",
      "lpc/spritesheets/hair/wavy/male/black.png.json",
      "lpc/spritesheets/hair/wavy/male/blonde.png.json",
      "lpc/spritesheets/hair/wavy/male/blue.png.json",
      "lpc/spritesheets/hair/wavy/male/dark_brown.png.json",
      "lpc/spritesheets/hair/wavy/male/gold.png.json",
      "lpc/spritesheets/hair/wavy/male/gray.png.json",
      "lpc/spritesheets/hair/wavy/male/green.png.json",
      "lpc/spritesheets/hair/wavy/male/light_brown.png.json",
      "lpc/spritesheets/hair/wavy/male/orange.png.json",
      "lpc/spritesheets/hair/wavy/male/purple.png.json",
      "lpc/spritesheets/hair/wavy/male/red.png.json",
      "lpc/spritesheets/hair/wavy/male/white.png.json",
      "lpc/spritesheets/hair/xlong/female/black.png.json",
      "lpc/spritesheets/hair/xlong/female/blonde.png.json",
      "lpc/spritesheets/hair/xlong/female/blue.png.json",
      "lpc/spritesheets/hair/xlong/female/dark_brown.png.json",
      "lpc/spritesheets/hair/xlong/female/gold.png.json",
      "lpc/spritesheets/hair/xlong/female/gray.png.json",
      "lpc/spritesheets/hair/xlong/female/green.png.json",
      "lpc/spritesheets/hair/xlong/female/light_brown.png.json",
      "lpc/spritesheets/hair/xlong/female/orange.png.json",
      "lpc/spritesheets/hair/xlong/female/purple.png.json",
      "lpc/spritesheets/hair/xlong/female/red.png.json",
      "lpc/spritesheets/hair/xlong/female/white.png.json",
      "lpc/spritesheets/head/nose/big/female/darkelf.png.json",
      "lpc/spritesheets/head/nose/big/female/light.png.json",
      "lpc/spritesheets/head/nose/big/female/tanned.png.json",
      "lpc/spritesheets/head/nose/big/male/darkelf.png.json",
      "lpc/spritesheets/head/nose/big/male/light.png.json",
      "lpc/spritesheets/head/nose/big/male/tanned.png.json",
      "lpc/spritesheets/head/nose/button/female/darkelf.png.json",
      "lpc/spritesheets/head/nose/button/female/light.png.json",
      "lpc/spritesheets/head/nose/button/female/tanned.png.json",
      "lpc/spritesheets/head/nose/button/male/darkelf.png.json",
      "lpc/spritesheets/head/nose/button/male/light.png.json",
      "lpc/spritesheets/head/nose/button/male/tanned.png.json",
      "lpc/spritesheets/head/nose/straight/female/darkelf.png.json",
      "lpc/spritesheets/head/nose/straight/female/light.png.json",
      "lpc/spritesheets/head/nose/straight/female/tanned.png.json",
      "lpc/spritesheets/head/nose/straight/male/darkelf.png.json",
      "lpc/spritesheets/head/nose/straight/male/light.png.json",
      "lpc/spritesheets/head/nose/straight/male/tanned.png.json",
      "lpc/spritesheets/legs/armour/female/10.png.json",
      "lpc/spritesheets/legs/armour/female/11.png.json",
      "lpc/spritesheets/legs/armour/female/7.png.json",
      "lpc/spritesheets/legs/armour/female/8.png.json",
      "lpc/spritesheets/legs/armour/female/9.png.json",
      "lpc/spritesheets/legs/armour/male/10.png.json",
      "lpc/spritesheets/legs/armour/male/11.png.json",
      "lpc/spritesheets/legs/armour/male/7.png.json",
      "lpc/spritesheets/legs/armour/male/8.png.json",
      "lpc/spritesheets/legs/armour/male/9.png.json",
      "lpc/spritesheets/legs/pantaloons/male/black.png.json",
      "lpc/spritesheets/legs/pantaloons/male/blue.png.json",
      "lpc/spritesheets/legs/pantaloons/male/brown.png.json",
      "lpc/spritesheets/legs/pantaloons/male/gray.png.json",
      "lpc/spritesheets/legs/pantaloons/male/green.png.json",
      "lpc/spritesheets/legs/pantaloons/male/maroon.png.json",
      "lpc/spritesheets/legs/pantaloons/male/orange.png.json",
      "lpc/spritesheets/legs/pantaloons/male/purple.png.json",
      "lpc/spritesheets/legs/pantaloons/male/red.png.json",
      "lpc/spritesheets/legs/pantaloons/male/tan.png.json",
      "lpc/spritesheets/legs/pantaloons/male/white.png.json",
      "lpc/spritesheets/legs/pantaloons/male/yellow.png.json",
      "lpc/spritesheets/legs/pants/female/black.png.json",
      "lpc/spritesheets/legs/pants/female/blue.png.json",
      "lpc/spritesheets/legs/pants/female/brown.png.json",
      "lpc/spritesheets/legs/pants/female/gray.png.json",
      "lpc/spritesheets/legs/pants/female/green.png.json",
      "lpc/spritesheets/legs/pants/female/maroon.png.json",
      "lpc/spritesheets/legs/pants/female/orange.png.json",
      "lpc/spritesheets/legs/pants/female/purple.png.json",
      "lpc/spritesheets/legs/pants/female/red.png.json",
      "lpc/spritesheets/legs/pants/female/tan.png.json",
      "lpc/spritesheets/legs/pants/female/white.png.json",
      "lpc/spritesheets/legs/pants/female/yellow.png.json",
      "lpc/spritesheets/legs/pants/male/black.png.json",
      "lpc/spritesheets/legs/pants/male/blue.png.json",
      "lpc/spritesheets/legs/pants/male/brown.png.json",
      "lpc/spritesheets/legs/pants/male/gray.png.json",
      "lpc/spritesheets/legs/pants/male/green.png.json",
      "lpc/spritesheets/legs/pants/male/maroon.png.json",
      "lpc/spritesheets/legs/pants/male/orange.png.json",
      "lpc/spritesheets/legs/pants/male/purple.png.json",
      "lpc/spritesheets/legs/pants/male/red.png.json",
      "lpc/spritesheets/legs/pants/male/tan.png.json",
      "lpc/spritesheets/legs/pants/male/white.png.json",
      "lpc/spritesheets/legs/pants/male/yellow.png.json",
      "lpc/spritesheets/legs/skirts/female/black.png.json",
      "lpc/spritesheets/legs/skirts/female/brown.png.json",
      "lpc/spritesheets/legs/skirts/female/legion.png.json",
      "lpc/spritesheets/legs/skirts/female/white.png.json",
      "lpc/spritesheets/legs/skirts/male/black.png.json",
      "lpc/spritesheets/legs/skirts/male/brown.png.json",
      "lpc/spritesheets/legs/skirts/male/legion.png.json",
      "lpc/spritesheets/legs/skirts/male/white.png.json",
      "lpc/spritesheets/shield/female/crusader.png.json",
      "lpc/spritesheets/shield/female/kite_blue_blue.png.json",
      "lpc/spritesheets/shield/female/kite_blue_gray.png.json",
      "lpc/spritesheets/shield/female/kite_gray.png.json",
      "lpc/spritesheets/shield/female/kite_gray_blue.png.json",
      "lpc/spritesheets/shield/female/kite_gray_gray.png.json",
      "lpc/spritesheets/shield/female/kite_gray_green.png.json",
      "lpc/spritesheets/shield/female/kite_gray_orange.png.json",
      "lpc/spritesheets/shield/female/kite_green_gray.png.json",
      "lpc/spritesheets/shield/female/kite_orange.png.json",
      "lpc/spritesheets/shield/female/kite_red_gray.png.json",
      "lpc/spritesheets/shield/female/round_black.png.json",
      "lpc/spritesheets/shield/female/round_brown.png.json",
      "lpc/spritesheets/shield/female/round_gold.png.json",
      "lpc/spritesheets/shield/female/round_green.png.json",
      "lpc/spritesheets/shield/female/round_silver.png.json",
      "lpc/spritesheets/shield/female/round_yellow.png.json",
      "lpc/spritesheets/shield/female/spartan.png.json",
      "lpc/spritesheets/shield/male/crusader.png.json",
      "lpc/spritesheets/shield/male/kite_blue_blue.png.json",
      "lpc/spritesheets/shield/male/kite_blue_gray.png.json",
      "lpc/spritesheets/shield/male/kite_gray.png.json",
      "lpc/spritesheets/shield/male/kite_gray_blue.png.json",
      "lpc/spritesheets/shield/male/kite_gray_gray.png.json",
      "lpc/spritesheets/shield/male/kite_gray_green.png.json",
      "lpc/spritesheets/shield/male/kite_gray_orange.png.json",
      "lpc/spritesheets/shield/male/kite_green_gray.png.json",
      "lpc/spritesheets/shield/male/kite_orange.png.json",
      "lpc/spritesheets/shield/male/kite_red_gray.png.json",
      "lpc/spritesheets/shield/male/round_black.png.json",
      "lpc/spritesheets/shield/male/round_brown.png.json",
      "lpc/spritesheets/shield/male/round_gold.png.json",
      "lpc/spritesheets/shield/male/round_green.png.json",
      "lpc/spritesheets/shield/male/round_silver.png.json",
      "lpc/spritesheets/shield/male/round_yellow.png.json",
      "lpc/spritesheets/shield/male/spartan.png.json",
      "lpc/spritesheets/spike/spikes1.png.json",
      "lpc/spritesheets/torso/armour/leather/female/blue.png.json",
      "lpc/spritesheets/torso/armour/leather/female/brown.png.json",
      "lpc/spritesheets/torso/armour/leather/female/green.png.json",
      "lpc/spritesheets/torso/armour/leather/male/blue.png.json",
      "lpc/spritesheets/torso/armour/leather/male/brown.png.json",
      "lpc/spritesheets/torso/armour/leather/male/green.png.json",
      "lpc/spritesheets/torso/armour/legion/female/bronze.png.json",
      "lpc/spritesheets/torso/armour/legion/female/gold.png.json",
      "lpc/spritesheets/torso/armour/legion/female/steel.png.json",
      "lpc/spritesheets/torso/armour/legion/male/bronze.png.json",
      "lpc/spritesheets/torso/armour/legion/male/gold.png.json",
      "lpc/spritesheets/torso/armour/legion/male/steel.png.json",
      "lpc/spritesheets/torso/armour/plate/female/11.png.json",
      "lpc/spritesheets/torso/armour/plate/female/12.png.json",
      "lpc/spritesheets/torso/armour/plate/female/14.png.json",
      "lpc/spritesheets/torso/armour/plate/female/16.png.json",
      "lpc/spritesheets/torso/armour/plate/female/special.png.json",
      "lpc/spritesheets/torso/armour/plate/male/11.png.json",
      "lpc/spritesheets/torso/armour/plate/male/12.png.json",
      "lpc/spritesheets/torso/armour/plate/male/14.png.json",
      "lpc/spritesheets/torso/armour/plate/male/16.png.json",
      "lpc/spritesheets/torso/armour/plate/male/special.png.json",
      "lpc/spritesheets/torso/clothes/blouse/female/black.png.json",
      "lpc/spritesheets/torso/clothes/blouse/female/blue.png.json",
      "lpc/spritesheets/torso/clothes/blouse/female/gray.png.json",
      "lpc/spritesheets/torso/clothes/blouse/female/green.png.json",
      "lpc/spritesheets/torso/clothes/blouse/female/maroon.png.json",
      "lpc/spritesheets/torso/clothes/blouse/female/orange.png.json",
      "lpc/spritesheets/torso/clothes/blouse/female/purple.png.json",
      "lpc/spritesheets/torso/clothes/blouse/female/red.png.json",
      "lpc/spritesheets/torso/clothes/blouse/female/tan.png.json",
      "lpc/spritesheets/torso/clothes/blouse/female/teal.png.json",
      "lpc/spritesheets/torso/clothes/blouse/female/white.png.json",
      "lpc/spritesheets/torso/clothes/blouse/female/yellow.png.json",
      "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/black.png.json",
      "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/blue.png.json",
      "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/gray.png.json",
      "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/green.png.json",
      "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/maroon.png.json",
      "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/orange.png.json",
      "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/purple.png.json",
      "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/red.png.json",
      "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/tan.png.json",
      "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/teal.png.json",
      "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/white.png.json",
      "lpc/spritesheets/torso/clothes/blouse_longsleeve/female/yellow.png.json",
      "lpc/spritesheets/torso/clothes/corset/female/black.png.json",
      "lpc/spritesheets/torso/clothes/corset/female/blue.png.json",
      "lpc/spritesheets/torso/clothes/corset/female/gray.png.json",
      "lpc/spritesheets/torso/clothes/corset/female/green.png.json",
      "lpc/spritesheets/torso/clothes/corset/female/leather.png.json",
      "lpc/spritesheets/torso/clothes/corset/female/maroon.png.json",
      "lpc/spritesheets/torso/clothes/corset/female/orange.png.json",
      "lpc/spritesheets/torso/clothes/corset/female/purple.png.json",
      "lpc/spritesheets/torso/clothes/corset/female/red.png.json",
      "lpc/spritesheets/torso/clothes/corset/female/tan.png.json",
      "lpc/spritesheets/torso/clothes/corset/female/teal.png.json",
      "lpc/spritesheets/torso/clothes/corset/female/white.png.json",
      "lpc/spritesheets/torso/clothes/corset/female/yellow.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve/female/black.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve/female/blue.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve/female/green.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve/female/maroon.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve/female/purple.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve/female/red.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve/female/teal.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve/female/white.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve/female/yellow.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve/male/black.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve/male/blue.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve/male/green.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve/male/maroon.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve/male/purple.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve/male/red.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve/male/teal.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve/male/white.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve/male/yellow.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve_laced/male/black.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve_laced/male/blue.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve_laced/male/gray.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve_laced/male/green.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve_laced/male/maroon.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve_laced/male/orange.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve_laced/male/purple.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve_laced/male/red.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve_laced/male/tan.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve_laced/male/teal.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve_laced/male/white.png.json",
      "lpc/spritesheets/torso/clothes/longsleeve_laced/male/yellow.png.json",
      "lpc/spritesheets/torso/clothes/scoop_shirt/female/black.png.json",
      "lpc/spritesheets/torso/clothes/scoop_shirt/female/blue.png.json",
      "lpc/spritesheets/torso/clothes/scoop_shirt/female/gray.png.json",
      "lpc/spritesheets/torso/clothes/scoop_shirt/female/green.png.json",
      "lpc/spritesheets/torso/clothes/scoop_shirt/female/maroon.png.json",
      "lpc/spritesheets/torso/clothes/scoop_shirt/female/orange.png.json",
      "lpc/spritesheets/torso/clothes/scoop_shirt/female/purple.png.json",
      "lpc/spritesheets/torso/clothes/scoop_shirt/female/red.png.json",
      "lpc/spritesheets/torso/clothes/scoop_shirt/female/teal.png.json",
      "lpc/spritesheets/torso/clothes/scoop_shirt/female/white.png.json",
      "lpc/spritesheets/torso/clothes/scoop_shirt/female/yellow.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless/male/black.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless/male/blue.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless/male/brown.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless/male/gray.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless/male/green.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless/male/maroon.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless/male/orange.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless/male/purple.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless/male/red.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless/male/tan.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless/male/teal.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless/male/white.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless/male/yellow.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_laced/male/black.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_laced/male/blue.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_laced/male/brown.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_laced/male/gray.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_laced/male/green.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_laced/male/maroon.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_laced/male/orange.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_laced/male/purple.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_laced/male/red.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_laced/male/tan.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_laced/male/teal.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_laced/male/white.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_laced/male/yellow.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_striped/male/black.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_striped/male/blue.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_striped/male/brown.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_striped/male/gray.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_striped/male/green.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_striped/male/maroon.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_striped/male/orange.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_striped/male/purple.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_striped/male/red.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_striped/male/tan.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_striped/male/teal.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_striped/male/white.png.json",
      "lpc/spritesheets/torso/clothes/sleeveless_striped/male/yellow.png.json",
      "lpc/spritesheets/torso/clothes/tanktop/female/black.png.json",
      "lpc/spritesheets/torso/clothes/tanktop/female/blue.png.json",
      "lpc/spritesheets/torso/clothes/tanktop/female/gray.png.json",
      "lpc/spritesheets/torso/clothes/tanktop/female/green.png.json",
      "lpc/spritesheets/torso/clothes/tanktop/female/maroon.png.json",
      "lpc/spritesheets/torso/clothes/tanktop/female/orange.png.json",
      "lpc/spritesheets/torso/clothes/tanktop/female/purple.png.json",
      "lpc/spritesheets/torso/clothes/tanktop/female/red.png.json",
      "lpc/spritesheets/torso/clothes/tanktop/female/tan.png.json",
      "lpc/spritesheets/torso/clothes/tanktop/female/teal.png.json",
      "lpc/spritesheets/torso/clothes/tanktop/female/white.png.json",
      "lpc/spritesheets/torso/clothes/tanktop/female/yellow.png.json",
      "lpc/spritesheets/torso/clothes/tunic/female/brown.png.json",
      "lpc/spritesheets/torso/clothes/tunic/female/maroon.png.json",
      "lpc/spritesheets/torso/clothes/tunic/female/teal.png.json",
      "lpc/spritesheets/torso/clothes/tunic/female/white.png.json",
      "lpc/spritesheets/weapon/bow/normal.png.json",
      "lpc/spritesheets/weapon/slash/female/axe_2.png.json",
      "lpc/spritesheets/weapon/slash/female/dagger.png.json",
      "lpc/spritesheets/weapon/slash/female/dagger_brown.png.json",
      "lpc/spritesheets/weapon/slash/female/warhammer.png.json",
      "lpc/spritesheets/weapon/slash/male/axe_2.png.json",
      "lpc/spritesheets/weapon/slash/male/dagger.png.json",
      "lpc/spritesheets/weapon/slash/male/dagger_brown.png.json",
      "lpc/spritesheets/weapon/slash/male/warhammer.png.json",
      "lpc/spritesheets/weapon/slash_oversize/female/flail.png.json",
      "lpc/spritesheets/weapon/slash_oversize/female/halberd.png.json",
      "lpc/spritesheets/weapon/slash_oversize/female/universal/flail.png.json",
      "lpc/spritesheets/weapon/slash_oversize/female/universal/halberd.png.json",
      "lpc/spritesheets/weapon/slash_oversize/female/universal/waraxe.png.json",
      "lpc/spritesheets/weapon/slash_oversize/female/waraxe.png.json",
      "lpc/spritesheets/weapon/slash_oversize/male/flail.png.json",
      "lpc/spritesheets/weapon/slash_oversize/male/halberd.png.json",
      "lpc/spritesheets/weapon/slash_oversize/male/universal/flail.png.json",
      "lpc/spritesheets/weapon/slash_oversize/male/universal/halberd.png.json",
      "lpc/spritesheets/weapon/slash_oversize/male/universal/waraxe.png.json",
      "lpc/spritesheets/weapon/slash_oversize/male/waraxe.png.json",
      "lpc/spritesheets/weapon/slash_oversize_layered/all/longsword.png.json",
      "lpc/spritesheets/weapon/slash_oversize_layered/all/mace.png.json",
      "lpc/spritesheets/weapon/slash_oversize_layered/all/rapier.png.json",
      "lpc/spritesheets/weapon/slash_oversize_layered/all/saber.png.json",
      "lpc/spritesheets/weapon/slash_oversize_layered/all/scythe.png.json",
      "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/longsword.png.json",
      "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/mace.png.json",
      "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/rapier.png.json",
      "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/saber.png.json",
      "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/scythe.png.json",
      "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/longsword.png.json",
      "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/mace.png.json",
      "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/rapier.png.json",
      "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/saber.png.json",
      "lpc/spritesheets/weapon/slash_oversize_layered/all/universal/scythe.png.json",
      "lpc/spritesheets/weapon/thrust/female/crossbow.png.json",
      "lpc/spritesheets/weapon/thrust/female/simple_staff.png.json",
      "lpc/spritesheets/weapon/thrust/female/spear_2.png.json",
      "lpc/spritesheets/weapon/thrust/female/spear_black.png.json",
      "lpc/spritesheets/weapon/thrust/female/spear_green.png.json",
      "lpc/spritesheets/weapon/thrust/female/spear_metal.png.json",
      "lpc/spritesheets/weapon/thrust/female/spear_purple.png.json",
      "lpc/spritesheets/weapon/thrust/male/crossbow.png.json",
      "lpc/spritesheets/weapon/thrust/male/simple_staff.png.json",
      "lpc/spritesheets/weapon/thrust/male/spear_2.png.json",
      "lpc/spritesheets/weapon/thrust/male/spear_black.png.json",
      "lpc/spritesheets/weapon/thrust/male/spear_green.png.json",
      "lpc/spritesheets/weapon/thrust/male/spear_metal.png.json",
      "lpc/spritesheets/weapon/thrust/male/spear_purple.png.json",
      "lpc/spritesheets/authored/wild-hare.png.json",
      "lpc/spritesheets/authored/rage-slime.png.json",
      "lpc/spritesheets/authored/lpc-viper.png.json",
      "lpc/spritesheets/authored/lpc-chicken.png.json",
      "lpc/spritesheets/authored/iron-pickaxe/male.png.json",
      "lpc/spritesheets/authored/iron-pickaxe/female.png.json",
      "lpc/spritesheets/authored/thistle.png.json"
    ],
    "presentation": {
      "classToTypes": {
        "armor": [
          "armor-leather",
          "armor-legion",
          "armor-plate"
        ],
        "bauldron": [
          "bauldron"
        ],
        "cape": [
          "cape-solid",
          "cape-tattered",
          "cape-trimmed"
        ],
        "key": [
          "castlekey"
        ],
        "pants": [
          "legion",
          "pantaloons",
          "pants",
          "pants-armor",
          "skirts"
        ],
        "resource": [
          "arrow",
          "webAmmo",
          "ember-charge",
          "coal",
          "copper",
          "gold",
          "iron",
          "silver",
          "drumstick",
          "feather",
          "planks",
          "rope",
          "stick",
          "spider-silk",
          "flower-single-blue",
          "flower-single-purple",
          "flower-single-red",
          "flower-single-yellow",
          "hide",
          "metal-bar-copper",
          "metal-bar-gold",
          "metal-bar-iron",
          "metal-bar-silver",
          "mushroom-purple",
          "mushroom-red",
          "mushroom-yellow",
          "seed",
          "shard-metal",
          "straw",
          "torch",
          "wood",
          "shard-metal"
        ],
        "shield": [
          "shield-crusader",
          "shield-kite",
          "shield-kite_blue",
          "shield-kite_gray",
          "shield-kite_green",
          "shield-kite_red",
          "shield-round",
          "shield-spartan"
        ],
        "shirt": [
          "blouse",
          "blouse_longsleeve",
          "corset",
          "longsleeve",
          "longsleeve_laced",
          "scoop_shirt",
          "sleeveless",
          "sleeveless_laced",
          "sleeveless_striped",
          "tanktop",
          "tunic"
        ],
        "shoes": [
          "boots",
          "sandals",
          "shoes",
          "shoes-armor",
          "slippers"
        ],
        "structure": [
          "campfire",
          "snare-rabbit",
          "stool-small",
          "table-large-rough",
          "table-mid-round",
          "barrel1",
          "stackedBags",
          "stool1",
          "table-mid-rough",
          "strawBed",
          "strawBedSmall",
          "chest-wood",
          "door-wood",
          "floor-wood",
          "floor-stone",
          "floor-cobble",
          "roof-wood",
          "wall-wood",
          "wall2-wood",
          "wall-stone",
          "railing-wood",
          "stairs",
          "floor-opening",
          "hatch-wood"
        ],
        "weapon": [
          "axe",
          "bow",
          "crossbow",
          "dagger",
          "flail",
          "halberd",
          "longsword",
          "mace",
          "none",
          "rapier",
          "saber",
          "scythe",
          "spear",
          "staff",
          "waraxe",
          "warhammer",
          "web"
        ]
      },
      "crafting": {
        "byClass": {
          "resource": "materials",
          "structure": "camp",
          "weapon": "weapons"
        },
        "defaultGroup": "materials",
        "entries": {
          "arrow": {
            "description": "Ammunition for the bow."
          },
          "arrow-slit": {
            "description": "A narrow opening to shoot through.",
            "family": "window",
            "variant": "Arrow slit"
          },
          "axe": {
            "description": "Chops trees, and swings hard in a fight."
          },
          "bow": {
            "description": "Strike from range. Needs arrows."
          },
          "campfire": {
            "description": "Set it down and feed it wood. While it burns, the Lord stays warm."
          },
          "castle-footing": {
            "description": "The base course a castle wall stands on."
          },
          "castle-merlons": {
            "description": "Battlements along a wall top."
          },
          "castle-wall": {
            "description": "A tall wall for a keep.",
            "family": "wall",
            "variant": "Castle"
          },
          "chest-wood": {
            "description": "Storage that stays at camp while you head out."
          },
          "chimney-stack": {
            "description": "Carries smoke up off the roof."
          },
          "dagger:brown": {
            "description": "A sharpened wooden blade. Quick to make.",
            "family": "dagger",
            "variant": "Wood"
          },
          "dagger:metal": {
            "description": "An iron blade that bites harder than wood.",
            "family": "dagger",
            "variant": "Iron"
          },
          "door-wood": {
            "description": "A way in and out of a walled room."
          },
          "dormer-window": {
            "description": "A window set into the roof.",
            "family": "window",
            "variant": "Dormer"
          },
          "ember-charge": {
            "description": "Shot for the Ember Core."
          },
          "floor-wood": {
            "description": "Boards for a room, or the floor of an upper storey."
          },
          "hatch-wood": {
            "description": "A trapdoor through an upper floor."
          },
          "iron-pickaxe": {
            "description": "Breaks rock and ore in the mine."
          },
          "longsword": {
            "description": "A long, balanced blade."
          },
          "metal-bar-copper": {
            "description": "Smelted copper.",
            "family": "metal-bar",
            "variant": "Copper"
          },
          "metal-bar-gold": {
            "description": "Smelted gold.",
            "family": "metal-bar",
            "variant": "Gold"
          },
          "metal-bar-iron": {
            "description": "Smelted iron for tools and weapons.",
            "family": "metal-bar",
            "variant": "Iron"
          },
          "metal-bar-silver": {
            "description": "Smelted silver.",
            "family": "metal-bar",
            "variant": "Silver"
          },
          "planks": {
            "description": "Walls, floors, roofs and chests. Every building starts here."
          },
          "roof-wood": {
            "description": "Closes a room off from the sky.",
            "family": "roof",
            "variant": "Wood"
          },
          "rope": {
            "description": "For snares and bowstrings."
          },
          "shard-metal": {
            "description": "Small iron pieces for blades and arrowheads."
          },
          "snare-rabbit": {
            "description": "Set it in the grass to catch rabbits."
          },
          "spear": {
            "description": "Long reach: keeps raiders at arm’s length."
          },
          "stairs": {
            "description": "Climb to the storey above."
          },
          "stick": {
            "description": "Handles, shafts and arrows. Most tools start here."
          },
          "thatch-roof": {
            "description": "A roof of bundled thatch.",
            "family": "roof",
            "variant": "Thatch"
          },
          "timber-frame-wall": {
            "description": "A framed wall in the timber style.",
            "family": "wall",
            "variant": "Timber frame"
          },
          "tower-render": {
            "description": "Rendered stone for a tower face."
          },
          "wall-stone": {
            "description": "A heavier wall that takes longer to break.",
            "family": "wall",
            "variant": "Stone"
          },
          "wall-wood": {
            "description": "Blocks raiders until they hack their way through.",
            "family": "wall",
            "variant": "Wood"
          },
          "waraxe": {
            "description": "A heavy axe made for fighting."
          },
          "window-frame": {
            "description": "Lets light into a room.",
            "family": "window",
            "variant": "Window"
          }
        },
        "families": {
          "dagger": "Dagger",
          "metal-bar": "Bar",
          "roof": "Roof tile",
          "wall": "Wall",
          "window": "Window"
        },
        "groups": [
          "camp",
          "hunting",
          "weapons",
          "materials"
        ],
        "labels": {
          "camp": "Camp",
          "hunting": "Hunting",
          "materials": "Materials",
          "weapons": "Weapons"
        },
        "overrides": {
          "arrow": "hunting",
          "bow": "hunting",
          "ember-charge": "weapons",
          "snare-rabbit": "hunting"
        },
        "sourceHints": {
          "coal": "Mine ore veins",
          "copper": "Mine ore veins",
          "feather": "Hunt chickens",
          "gold": "Mine ore veins",
          "iron": "Mine ore veins",
          "shard-metal": "Dropped by snakes and slimes",
          "silver": "Mine ore veins",
          "spider-silk": "Hunt spiders outside camp",
          "straw": "Cut long grass",
          "wood": "Chop trees"
        },
        "undisclosedSources": [
          "shard-metal"
        ]
      },
      "displayNames": {
        "armor-leather": "Armor, leather",
        "armor-legion": "Armor, legion",
        "armor-plate": "Armor, plate",
        "arrow": "Arrow",
        "arrow-slit": "Window, arrow slit",
        "axe": "Axe",
        "barrel1": "Barrel",
        "bauldron": "Pauldrons",
        "blouse": "Blouse",
        "blouse_longsleeve": "Blouse, long-sleeved",
        "boots": "Boots",
        "bow": "Bow",
        "campfire": "Campfire",
        "cape-solid": "Cape",
        "cape-tattered": "Cape, tattered",
        "cape-trimmed": "Cape, trimmed",
        "castle-footing": "Footing, castle",
        "castle-merlons": "Battlements, castle",
        "castle-wall": "Wall, castle",
        "castlekey": "Castle key",
        "chest-wood": "Chest, wood",
        "chimney-stack": "Chimney",
        "coal": "Coal",
        "copper": "Ore, copper",
        "corset": "Corset",
        "crossbow": "Crossbow",
        "dagger": "Dagger",
        "dagger:brown": "Dagger, wood",
        "dagger:metal": "Dagger, iron",
        "door-wood": "Door, wood",
        "dormer-window": "Window, dormer",
        "drumstick": "Drumstick",
        "ember-charge": "Ember charge",
        "feather": "Feather",
        "flail": "Flail",
        "floor-cobble": "Floor tile, cobblestone",
        "floor-opening": "Floor opening",
        "floor-stone": "Floor tile, stone",
        "floor-wood": "Floor tile, wood",
        "flower-single-blue": "Flower, blue",
        "flower-single-purple": "Flower, purple",
        "flower-single-red": "Flower, red",
        "flower-single-yellow": "Flower, yellow",
        "gold": "Ore, gold",
        "grass-seed": "Seed, grass",
        "grove-low-a": "Tree, low A",
        "grove-low-b": "Tree, low B",
        "grove-oak-a": "Tree, oak A",
        "grove-oak-b": "Tree, oak B",
        "grove-round-a": "Tree, round A",
        "grove-round-b": "Tree, round B",
        "grove-spruce-a": "Tree, spruce A",
        "grove-spruce-b": "Tree, spruce B",
        "halberd": "Halberd",
        "hatch-wood": "Hatch, wood",
        "hide": "Hide",
        "iron": "Ore, iron",
        "iron-pickaxe": "Pickaxe, iron",
        "legion": "Pants, legion",
        "longsleeve": "Shirt, long-sleeved",
        "longsleeve_laced": "Shirt, laced long-sleeved",
        "longsword": "Longsword",
        "mace": "Mace",
        "meadow-grass-a": "Grass, meadow A",
        "meadow-grass-b": "Grass, meadow B",
        "meadow-grass-c": "Grass, meadow C",
        "meadow-grass-d": "Grass, meadow D",
        "meadow-grass-e": "Grass, meadow E",
        "meadow-grass-f": "Grass, meadow F",
        "meadow-sprout": "Grass, sprout",
        "metal-bar-copper": "Bar, copper",
        "metal-bar-gold": "Bar, gold",
        "metal-bar-iron": "Bar, iron",
        "metal-bar-silver": "Bar, silver",
        "mushroom-purple": "Mushroom, purple",
        "mushroom-red": "Mushroom, red",
        "mushroom-yellow": "Mushroom, yellow",
        "none": "Bare hands",
        "pantaloons": "Pantaloons",
        "pants": "Pants",
        "pants-armor": "Pants, armored",
        "planks": "Plank",
        "railing-wood": "Railing, wood",
        "rapier": "Rapier",
        "roof-wood": "Roof tile, wood",
        "rope": "Rope",
        "saber": "Saber",
        "sandals": "Sandals",
        "scoop_shirt": "Shirt, scoop-neck",
        "scythe": "Scythe",
        "seed": "Seed, tree",
        "shard-metal": "Metal shard",
        "shield-crusader": "Shield, crusader",
        "shield-kite": "Shield, kite",
        "shield-kite_blue": "Shield, blue kite",
        "shield-kite_gray": "Shield, gray kite",
        "shield-kite_green": "Shield, green kite",
        "shield-kite_red": "Shield, red kite",
        "shield-round": "Shield, round",
        "shield-spartan": "Shield, spartan",
        "shoes": "Shoes",
        "shoes-armor": "Shoes, armored",
        "silver": "Ore, silver",
        "skirts": "Skirt",
        "sleeveless": "Shirt, sleeveless",
        "sleeveless_laced": "Shirt, laced sleeveless",
        "sleeveless_striped": "Shirt, striped sleeveless",
        "slippers": "Slippers",
        "snare-rabbit": "Rabbit snare",
        "spear": "Spear",
        "spider-silk": "Spider silk",
        "stackedBags": "Sacks",
        "staff": "Staff",
        "stairs": "Ladder",
        "stick": "Stick",
        "stool-small": "Stool, small",
        "stool1": "Stool",
        "straw": "Straw",
        "strawBed": "Bed, straw",
        "strawBedSmall": "Bed, small straw",
        "table-large-rough": "Table, large rough",
        "table-mid-rough": "Table, rough",
        "table-mid-round": "Table, round",
        "tanktop": "Tank top",
        "thatch-roof": "Roof tile, thatch",
        "timber-frame-wall": "Wall, timber frame",
        "torch": "Torch",
        "tower-render": "Wall, rendered tower",
        "tunic": "Tunic",
        "wall-stone": "Wall, stone",
        "wall-wood": "Wall, wood",
        "wall2-wood": "Wall, palisade",
        "waraxe": "War axe",
        "warhammer": "Warhammer",
        "web": "Web",
        "webAmmo": "Web shot",
        "window-frame": "Window",
        "wood": "Wood"
      },
      "sheets": [
        {
          "file": "furniture-blonde-wood.json",
          "id": "furniture-blonde-wood"
        },
        {
          "file": "fence_medieval.json",
          "id": "fence_medieval"
        },
        {
          "file": "container.json",
          "id": "container"
        },
        {
          "file": "walls.json",
          "id": "walls"
        },
        {
          "file": "walls2.json",
          "id": "walls2"
        },
        {
          "file": "floors.json",
          "id": "floors"
        },
        {
          "file": "cottage.json",
          "id": "cottage"
        },
        {
          "file": "roofs.json",
          "id": "roofs"
        },
        {
          "file": "ore.json",
          "id": "ore"
        },
        {
          "file": "decorations-medieval.json",
          "id": "decorations-medieval"
        },
        {
          "file": "jungle-ruins.json",
          "id": "jungle-ruins"
        },
        {
          "file": "mountains-v6.json",
          "id": "mountains-v6"
        },
        {
          "file": "lpc-flowers-plants-fungi-wood.json",
          "id": "lpc-flowers-plants-fungi-wood"
        },
        {
          "file": "lpc-terrain.json",
          "id": "lpc-terrain"
        },
        {
          "file": "beach-desert.json",
          "id": "beach-desert"
        },
        {
          "file": "map-atlas.json",
          "id": "map-atlas"
        },
        {
          "file": "plants.json",
          "id": "plants"
        },
        {
          "file": "build_atlas.json",
          "id": "build_atlas"
        },
        {
          "file": "humanoid.json",
          "id": "humanoid"
        },
        {
          "file": "authored-terrain.json",
          "id": "authored-terrain"
        },
        {
          "file": "item-art-b1d5a86cbcd21ed656d3.json",
          "id": "item-art-b1d5a86cbcd21ed656d3"
        },
        {
          "file": "forest-grass.json",
          "id": "forest-grass"
        },
        {
          "file": "forest-dirt.json",
          "id": "forest-dirt"
        },
        {
          "file": "stairs-icon.json",
          "id": "stairs-icon"
        },
        {
          "file": "item-art-887e0636d4bbe2a4f448.json",
          "id": "item-art-887e0636d4bbe2a4f448"
        },
        {
          "file": "item-art-f728e0bbaefbd1982b2d.json",
          "id": "item-art-f728e0bbaefbd1982b2d"
        },
        {
          "file": "item-art-35c925e4db81912bfe38.json",
          "id": "item-art-35c925e4db81912bfe38"
        },
        {
          "file": "item-art-99ea85dcdc93fac8db18.json",
          "id": "item-art-99ea85dcdc93fac8db18"
        },
        {
          "file": "item-art-bb4afa7ce4e3c1ba55ba.json",
          "id": "item-art-bb4afa7ce4e3c1ba55ba"
        },
        {
          "file": "item-art-e46e4dec4aea45bf9d8e.json",
          "id": "item-art-e46e4dec4aea45bf9d8e"
        },
        {
          "file": "item-art-32902d50537ebad17e79.json",
          "id": "item-art-32902d50537ebad17e79"
        },
        {
          "file": "item-art-5902c8b486e89c8f8e57.json",
          "id": "item-art-5902c8b486e89c8f8e57"
        },
        {
          "file": "item-art-ebdd046fea0f3ab21669.json",
          "id": "item-art-ebdd046fea0f3ab21669"
        },
        {
          "file": "item-art-4d6c318ef966e097227a.json",
          "id": "item-art-4d6c318ef966e097227a"
        },
        {
          "file": "item-art-721c3f8a8d4621a46f90.json",
          "id": "item-art-721c3f8a8d4621a46f90"
        },
        {
          "file": "item-art-7fc02d2406eaa57e3be0.json",
          "id": "item-art-7fc02d2406eaa57e3be0"
        },
        {
          "file": "item-art-a7225776548a58ab4e04.json",
          "id": "item-art-a7225776548a58ab4e04"
        },
        {
          "file": "item-art-d9ecaed5ff4485611809.json",
          "id": "item-art-d9ecaed5ff4485611809"
        },
        {
          "file": "item-art-af19df691fc7aa944194.json",
          "id": "item-art-af19df691fc7aa944194"
        },
        {
          "file": "item-art-b9ef00e25a4177065abd.json",
          "id": "item-art-b9ef00e25a4177065abd"
        },
        {
          "file": "hatch-wood.json",
          "id": "hatch-wood"
        },
        {
          "file": "item-art-1a07b84a0c63a7a63c4f.json",
          "id": "item-art-1a07b84a0c63a7a63c4f"
        },
        {
          "file": "item-art-08bd1c8b4020c28035f1.json",
          "id": "item-art-08bd1c8b4020c28035f1"
        }
      ],
      "subClasses": {
        "ammo": [
          "arrow",
          "webAmmo",
          "ember-charge"
        ],
        "armor": [
          "armor-leather",
          "armor-legion",
          "armor-plate"
        ],
        "bauldron": [
          "bauldron"
        ],
        "cape": [
          "cape-solid",
          "cape-tattered",
          "cape-trimmed"
        ],
        "chest": [
          "chest-wood"
        ],
        "craftResource": [
          "feather",
          "planks",
          "rope",
          "stick",
          "spider-silk"
        ],
        "door": [
          "door-wood"
        ],
        "drumstick": [
          "drumstick"
        ],
        "floor": [
          "floor-wood",
          "floor-stone",
          "floor-cobble"
        ],
        "flower": [
          "flower-single-blue",
          "flower-single-purple",
          "flower-single-red",
          "flower-single-yellow"
        ],
        "hide": [
          "hide"
        ],
        "key": [
          "castlekey"
        ],
        "metalBar": [
          "metal-bar-copper",
          "metal-bar-gold",
          "metal-bar-iron",
          "metal-bar-silver"
        ],
        "mushroom": [
          "mushroom-purple",
          "mushroom-red",
          "mushroom-yellow"
        ],
        "ore": [
          "coal",
          "copper",
          "gold",
          "iron",
          "silver"
        ],
        "pants": [
          "legion",
          "pantaloons",
          "pants",
          "pants-armor",
          "skirts"
        ],
        "resource": [
          "shard-metal"
        ],
        "roof": [
          "roof-wood"
        ],
        "seed": [
          "seed"
        ],
        "shard": [
          "shard-metal"
        ],
        "shield": [
          "shield-crusader",
          "shield-kite",
          "shield-kite_blue",
          "shield-kite_gray",
          "shield-kite_green",
          "shield-kite_red",
          "shield-round",
          "shield-spartan"
        ],
        "shirt": [
          "blouse",
          "blouse_longsleeve",
          "corset",
          "longsleeve",
          "longsleeve_laced",
          "scoop_shirt",
          "sleeveless",
          "sleeveless_laced",
          "sleeveless_striped",
          "tanktop",
          "tunic"
        ],
        "shoes": [
          "boots",
          "sandals",
          "shoes",
          "shoes-armor",
          "slippers"
        ],
        "straw": [
          "straw"
        ],
        "structure": [
          "campfire",
          "snare-rabbit",
          "stool-small",
          "table-large-rough",
          "table-mid-round",
          "barrel1",
          "stackedBags",
          "stool1",
          "table-mid-rough",
          "strawBed",
          "strawBedSmall",
          "stairs",
          "floor-opening",
          "hatch-wood"
        ],
        "torch": [
          "torch"
        ],
        "wall": [
          "wall-wood",
          "wall2-wood",
          "wall-stone",
          "railing-wood"
        ],
        "weapon": [
          "axe",
          "bow",
          "crossbow",
          "dagger",
          "flail",
          "halberd",
          "longsword",
          "mace",
          "none",
          "rapier",
          "saber",
          "scythe",
          "spear",
          "staff",
          "waraxe",
          "warhammer",
          "web"
        ],
        "wood": [
          "wood"
        ]
      }
    },
    "profiles": {
      "drops": {
        "chicken": [
          {
            "metadata": {
              "class": "resource",
              "color": "brown",
              "type": "drumstick"
            },
            "quantity": 1
          },
          {
            "quantity": 10,
            "reference": {
              "item": "feather"
            }
          }
        ],
        "deer": [
          {
            "metadata": {
              "class": "resource",
              "color": "brown",
              "type": "hide"
            },
            "quantity": 3
          },
          {
            "metadata": {
              "class": "resource",
              "color": "brown",
              "type": "drumstick"
            },
            "quantity": 3
          }
        ],
        "human": [
          {
            "probability": 0.2,
            "quantity": 10,
            "reference": {
              "item": "shard-metal"
            }
          }
        ],
        "rabbit": [
          {
            "metadata": {
              "class": "resource",
              "color": "brown",
              "type": "hide"
            },
            "quantity": 1
          },
          {
            "metadata": {
              "class": "resource",
              "color": "brown",
              "type": "drumstick"
            },
            "quantity": 2
          }
        ],
        "redspider": [
          {
            "probability": 1,
            "quantity": 1,
            "reference": {
              "item": "spider-silk"
            }
          }
        ],
        "skeleton": [
          {
            "probability": 0.6,
            "quantity": 2,
            "reference": {
              "item": "shard-metal"
            }
          }
        ],
        "slime": [
          {
            "probability": 0.35,
            "quantity": 1,
            "reference": {
              "item": "shard-metal"
            }
          }
        ],
        "snake": [
          {
            "probability": 0.25,
            "quantity": 1,
            "reference": {
              "item": "shard-metal"
            }
          }
        ],
        "wolfman": [
          {
            "probability": 1,
            "quantity": 8,
            "reference": {
              "item": "shard-metal"
            }
          },
          {
            "probability": 0.5,
            "quantity": 1,
            "reference": {
              "item": "shard-metal"
            }
          },
          {
            "metadata": {
              "class": "resource",
              "color": "brown",
              "type": "hide"
            },
            "probability": 0.5,
            "quantity": 2
          }
        ]
      },
      "effects": {
        "torch": {
          "clockDuration": 50,
          "effect": "light"
        }
      },
      "encounters": {
        "emberWildlife": {
          "defaultEnemy": "snake",
          "enemyWeights": [
            {
              "race": "slime",
              "weight": 0.55
            },
            {
              "race": "snake",
              "weight": 0.35
            },
            {
              "race": "redspider",
              "weight": 0.1
            }
          ],
          "specs": {
            "chicken": {
              "brainProps": {
                "peckWander": true
              },
              "flags": {
                "devKillable": true,
                "dropsLootOnDeath": true,
                "isChicken": true,
                "noContactPush": true,
                "nonAggro": true
              },
              "hp": 2,
              "immoveable": false,
              "probability": 1,
              "race": "chicken",
              "sex": "male"
            },
            "rabbit": {
              "flags": {
                "devKillable": true,
                "dropsLootOnDeath": true,
                "isRabbit": true,
                "nonAggro": true
              },
              "hp": 2,
              "immoveable": false,
              "probability": 1,
              "race": "rabbit"
            },
            "redspider": {
              "bodyColor": "red",
              "brainProps": {
                "avoidEntities": true,
                "leashRange": {
                  "baseline": "tileSize",
                  "multiplier": 5
                },
                "psychProfile": {
                  "hostility": 80
                },
                "randomWander": false,
                "scanPlayersOnly": false,
                "scanner": true,
                "seeker": "astar",
                "targetLocationMaxDistance": {
                  "baseline": "tileSize",
                  "multiplier": 9
                },
                "targetLocationThresholdDistance": 16,
                "v2": true
              },
              "faction": "wild",
              "flags": {
                "devKillable": true,
                "dropsLootOnDeath": true,
                "isWildEnemy": true,
                "nonAggro": false,
                "patrolWander": true
              },
              "hp": 4,
              "immoveable": false,
              "probability": 1,
              "race": "redspider",
              "sex": "male",
              "speed": 70
            },
            "slime": {
              "bodyColor": "green",
              "brainProps": {
                "avoidEntities": true,
                "leashRange": {
                  "baseline": "tileSize",
                  "multiplier": 5
                },
                "psychProfile": {
                  "hostility": 80
                },
                "randomWander": false,
                "scanPlayersOnly": false,
                "scanner": true,
                "seeker": "astar",
                "targetLocationMaxDistance": {
                  "baseline": "tileSize",
                  "multiplier": 9
                },
                "targetLocationThresholdDistance": 16,
                "v2": true
              },
              "faction": "wild",
              "flags": {
                "devKillable": true,
                "dropsLootOnDeath": true,
                "isWildEnemy": true,
                "nonAggro": false,
                "patrolWander": true
              },
              "hp": 4,
              "immoveable": false,
              "probability": 1,
              "race": "slime",
              "sex": "male",
              "speed": 70
            },
            "snake": {
              "bodyColor": "green",
              "brainProps": {
                "avoidEntities": true,
                "leashRange": {
                  "baseline": "tileSize",
                  "multiplier": 5
                },
                "psychProfile": {
                  "hostility": 80
                },
                "randomWander": false,
                "scanPlayersOnly": false,
                "scanner": true,
                "seeker": "astar",
                "targetLocationMaxDistance": {
                  "baseline": "tileSize",
                  "multiplier": 9
                },
                "targetLocationThresholdDistance": 16,
                "v2": true
              },
              "faction": "wild",
              "flags": {
                "devKillable": true,
                "dropsLootOnDeath": true,
                "isWildEnemy": true,
                "nonAggro": false,
                "patrolWander": true
              },
              "hp": 4,
              "immoveable": false,
              "probability": 1,
              "race": "snake",
              "sex": "male",
              "speed": 70
            }
          }
        }
      },
      "factions": {
        "chicken": "none",
        "deer": "wild",
        "rabbit": "wild",
        "redspider": "wild",
        "skeleton": "undead",
        "wasp": "wild"
      },
      "itemDrops": {
        "armor-leather": [
          {
            "quantity": 3,
            "reference": {
              "item": "shard-metal"
            }
          }
        ],
        "armor-legion": [
          {
            "quantity": 2,
            "reference": {
              "item": "shard-metal"
            }
          }
        ],
        "armor-plate": [
          {
            "quantity": 3,
            "reference": {
              "item": "shard-metal"
            }
          }
        ],
        "axe": [
          {
            "quantity": 2,
            "reference": {
              "item": "shard-metal"
            }
          }
        ],
        "dagger": [
          {
            "quantity": 1,
            "reference": {
              "item": "shard-metal"
            }
          }
        ],
        "spear": [
          {
            "quantity": 1,
            "reference": {
              "item": "shard-metal"
            }
          }
        ]
      },
      "npcSpecs": {
        "bee": {
          "brainProps": {
            "randomWander": true,
            "scanPlayersOnly": false,
            "scanner": true,
            "seeker": "brute"
          },
          "npc": {
            "angle": 0,
            "clickable": true,
            "faction": "none",
            "hp": 1,
            "name": "bee",
            "persistable": false,
            "portable": false,
            "speed": {
              "baseline": "speed",
              "multiplier": 0.1
            },
            "spriteId": "bee",
            "strikeable": false,
            "type": "marker"
          }
        }
      },
      "population": {
        "chicken": {
          "hp": {
            "baseline": "hp"
          },
          "maxSpeed": {
            "baseline": "speed",
            "pctOfMax": 0.05
          },
          "psych": {
            "chronotype": "diurnal",
            "hostility": {
              "baseline": "hostility"
            }
          }
        },
        "deer": {
          "hp": {
            "baseline": "hp",
            "pctOfMax": 0.1
          },
          "maxSpeed": {
            "baseline": "speed",
            "pctOfMax": 1
          },
          "psych": {
            "hostility": {
              "baseline": "hostility"
            }
          }
        },
        "rabbit": {
          "hp": {
            "baseline": "hp"
          },
          "maxSpeed": {
            "baseline": "speed",
            "pctOfMax": 0.7
          },
          "psych": {
            "chronotype": "diurnal",
            "hostility": {
              "baseline": "hostility"
            }
          }
        },
        "redspider": {
          "hp": {
            "baseline": "hp"
          },
          "maxSpeed": {
            "baseline": "speed",
            "pctOfMax": 0.05
          },
          "psych": {
            "attackPattern": "v2",
            "chronotype": "diurnal",
            "closeOnStun": true,
            "hostility": {
              "baseline": "hostility",
              "pctOfMax": 0.2
            }
          }
        },
        "skeleton": {
          "hp": {
            "baseline": "hp",
            "pctOfMax": 0.3
          },
          "maxSpeed": {
            "baseline": "speed"
          },
          "preSpawnEffect": {
            "durationMs": 900,
            "type": "ground-rupture"
          },
          "psych": {
            "attackPattern": "v2",
            "chronotype": "nocturnal",
            "hostility": {
              "baseline": "hostility",
              "pctOfMax": 0.5
            }
          },
          "scanDistanceTiles": 6
        },
        "slime": {
          "hp": {
            "baseline": "hp"
          },
          "maxSpeed": {
            "baseline": "speed",
            "multiplier": 0.15,
            "pctOfMax": 0
          },
          "psych": {
            "chronotype": "diurnal",
            "hostility": {
              "baseline": "hostility",
              "pctOfMax": 0.1
            }
          }
        },
        "snake": {
          "hp": 1,
          "maxSpeed": {
            "baseline": "speed",
            "multiplier": 0.4,
            "pctOfMax": 0
          },
          "psych": {
            "chronotype": "diurnal",
            "hostility": {
              "baseline": "hostility",
              "pctOfMax": 0.6
            }
          }
        },
        "spikes1": {
          "hp": {
            "baseline": "hp"
          },
          "maxSpeed": 0,
          "psych": {
            "chronotype": "diurnal",
            "hostility": {
              "baseline": "hostility",
              "pctOfMax": 1
            }
          }
        },
        "wasp": {
          "hp": {
            "baseline": "hp"
          },
          "maxSpeed": {
            "baseline": "speed",
            "pctOfMax": 0.05
          },
          "psych": {
            "attackPattern": "swoop",
            "chronotype": "diurnal",
            "hostility": {
              "baseline": "hostility",
              "pctOfMax": 0.2
            }
          }
        },
        "zombie": {
          "hp": {
            "baseline": "hp",
            "pctOfMax": 0.3
          },
          "maxSpeed": 5,
          "preSpawnEffect": {
            "durationMs": 900,
            "type": "ground-rupture"
          },
          "psych": {
            "attackPattern": "v2",
            "chronotype": "nocturnal",
            "hostility": {
              "baseline": "hostility",
              "pctOfMax": 0.5
            }
          },
          "scanDistanceTiles": 6
        }
      },
      "populationDefault": {
        "hp": {
          "baseline": "hp"
        },
        "maxSpeed": {
          "baseline": "speed",
          "pctOfMax": 0
        },
        "psych": {
          "aggroResponse": "default",
          "attackPattern": "default",
          "chronotype": "diurnal",
          "closeOnStun": false,
          "hostility": {
            "baseline": "hostility",
            "pctOfMax": 0.25
          }
        }
      },
      "weapons": {
        "axe": {
          "baseDamage": 3,
          "bulletSpeed": 500,
          "bulletSpriteId": "none",
          "equipOrder": 0,
          "firingLatchMs": 500,
          "manaCost": 1,
          "maxDistance": 32,
          "maxEntitiesHit": 2,
          "maxParticles": 2,
          "slotVisible": true
        },
        "bomb": {
          "equipOrder": 3,
          "slotVisible": true
        },
        "bow": {
          "attackRange": 128,
          "baseDamage": 1,
          "bulletSpeed": 500,
          "bulletSpriteId": "arrow-brown.png",
          "bulletType": "arrow",
          "equipOrder": 0,
          "firingLatchMs": 400,
          "manaCost": 1,
          "maxDistance": 160,
          "maxParticles": 1,
          "slotVisible": true
        },
        "crossbow": {
          "attackRange": 128,
          "baseDamage": 1,
          "bulletSpeed": 500,
          "bulletSpriteId": "arrow-brown.png",
          "equipOrder": 0,
          "firingLatchMs": 400,
          "manaCost": 1,
          "maxDistance": 160,
          "maxParticles": 1,
          "slotVisible": true
        },
        "dagger": {
          "baseDamage": 1,
          "bulletSpeed": 500,
          "bulletSpriteId": "none",
          "equipOrder": 0,
          "firingLatchMs": 450,
          "manaCost": 1,
          "maxDistance": 32,
          "maxParticles": 1,
          "pushStrength": 0,
          "slotVisible": true
        },
        "emp": {
          "duration": 3000,
          "equipOrder": 2,
          "manaCost": 6,
          "maxDistance": {
            "baseline": "tileSize",
            "multiplier": 8
          },
          "slotVisible": true
        },
        "flail": {
          "attackRange": 64,
          "baseDamage": 0.75,
          "bulletSpeed": 500,
          "bulletSpriteId": "none",
          "equipOrder": 0,
          "firingLatchMs": 250,
          "manaCost": 3,
          "maxDistance": 45,
          "maxEntitiesHit": 3,
          "maxParticles": 2,
          "pushStrength": 1,
          "slotVisible": true
        },
        "halberd": {
          "baseDamage": 1,
          "bulletSpeed": 150,
          "bulletSpriteId": "none",
          "equipOrder": 0,
          "firingLatchMs": 500,
          "manaCost": 1,
          "maxDistance": 20,
          "maxParticles": 1,
          "slotVisible": true
        },
        "iron-pickaxe": {
          "baseDamage": 1,
          "bulletSpeed": 150,
          "bulletSpriteId": "none",
          "equipOrder": 0,
          "firingLatchMs": 500,
          "manaCost": 1,
          "maxDistance": 20,
          "maxEntitiesHit": 1,
          "maxParticles": 1,
          "slotVisible": true
        },
        "longsword": {
          "attackRange": 64,
          "baseDamage": 2,
          "bulletSpeed": 500,
          "bulletSpriteId": "none",
          "equipOrder": 0,
          "firingLatchMs": 550,
          "manaCost": 3,
          "maxDistance": 50,
          "maxParticles": 2,
          "pushStrength": 1,
          "slotVisible": true
        },
        "mace": {
          "baseDamage": 1,
          "bulletSpeed": 150,
          "bulletSpriteId": "none",
          "equipOrder": 0,
          "firingLatchMs": 500,
          "manaCost": 1,
          "maxDistance": 20,
          "maxParticles": 1,
          "slotVisible": true
        },
        "none": {
          "baseDamage": 1,
          "bulletSpeed": 200,
          "bulletSpriteId": "none",
          "equipOrder": 0,
          "firingLatchMs": 400,
          "manaCost": 1,
          "maxDistance": 25,
          "maxParticles": 1,
          "slotVisible": true
        },
        "rapier": {
          "baseDamage": 1,
          "bulletSpeed": 150,
          "bulletSpriteId": "none",
          "equipOrder": 0,
          "firingLatchMs": 500,
          "manaCost": 1,
          "maxDistance": 20,
          "maxParticles": 1,
          "slotVisible": true
        },
        "saber": {
          "baseDamage": 1.5,
          "bulletSpeed": 500,
          "bulletSpriteId": "none",
          "equipOrder": 0,
          "firingLatchMs": 500,
          "manaCost": 3,
          "maxDistance": 40,
          "maxParticles": 2,
          "slotVisible": true
        },
        "scythe": {
          "baseDamage": 1,
          "bulletSpeed": 150,
          "bulletSpriteId": "none",
          "equipOrder": 0,
          "firingLatchMs": 500,
          "manaCost": 1,
          "maxDistance": 20,
          "maxParticles": 1,
          "slotVisible": true
        },
        "spear": {
          "baseDamage": 1,
          "bulletSpeed": 150,
          "bulletSpriteId": "none",
          "equipOrder": 0,
          "firingLatchMs": 525,
          "manaCost": 1,
          "maxDistance": 50,
          "maxParticles": 3,
          "slotVisible": true
        },
        "staff": {
          "slotVisible": true
        },
        "waraxe": {
          "attackRange": 64,
          "baseDamage": 1,
          "bulletSpeed": 500,
          "bulletSpriteId": "none",
          "equipOrder": 0,
          "firingLatchMs": 550,
          "manaCost": 1,
          "maxDistance": 40,
          "maxParticles": 2,
          "pushStrength": 2,
          "slotVisible": true
        },
        "warhammer": {
          "baseDamage": 5,
          "bulletSpeed": 150,
          "bulletSpriteId": "none",
          "equipOrder": 0,
          "firingLatchMs": 600,
          "manaCost": 1,
          "maxDistance": 20,
          "maxParticles": 1,
          "pushStrength": 2,
          "slotVisible": true
        },
        "web": {
          "attackRange": 128,
          "baseDamage": 0,
          "bulletSpeed": 500,
          "bulletSpriteId": "web-white.png",
          "bulletType": "webAmmo",
          "equipOrder": 0,
          "firingLatchMs": 400,
          "manaCost": 1,
          "maxDistance": 160,
          "maxParticles": 1,
          "pushStrength": 0,
          "slotVisible": true
        }
      }
    },
    "recipes": [
      {
        "ingredients": [
          {
            "quantity": 5,
            "reference": {
              "item": "iron"
            }
          }
        ],
        "output": {
          "item": "metal-bar-iron"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 5,
            "reference": {
              "item": "silver"
            }
          }
        ],
        "output": {
          "item": "metal-bar-silver"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 5,
            "reference": {
              "item": "copper"
            }
          }
        ],
        "output": {
          "item": "metal-bar-copper"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 5,
            "reference": {
              "item": "gold"
            }
          }
        ],
        "output": {
          "item": "metal-bar-gold"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 1,
            "reference": {
              "item": "iron"
            }
          }
        ],
        "output": {
          "item": "shard-metal"
        },
        "quantity": 5
      },
      {
        "ingredients": [
          {
            "quantity": 1,
            "reference": {
              "item": "wood"
            }
          }
        ],
        "output": {
          "item": "stick"
        },
        "quantity": 5
      },
      {
        "ingredients": [
          {
            "quantity": 3,
            "reference": {
              "item": "straw"
            }
          }
        ],
        "output": {
          "item": "rope"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 1,
            "reference": {
              "item": "wood"
            }
          }
        ],
        "output": {
          "item": "planks"
        },
        "quantity": 4
      },
      {
        "ingredients": [
          {
            "quantity": 3,
            "reference": {
              "item": "planks"
            }
          }
        ],
        "output": {
          "item": "wall-wood"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 3,
            "reference": {
              "item": "planks"
            }
          }
        ],
        "output": {
          "item": "wall-stone"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 3,
            "reference": {
              "item": "planks"
            }
          }
        ],
        "output": {
          "item": "floor-wood"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 3,
            "reference": {
              "item": "planks"
            }
          }
        ],
        "output": {
          "item": "door-wood"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 5,
            "reference": {
              "item": "planks"
            }
          }
        ],
        "output": {
          "item": "chest-wood"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 4,
            "reference": {
              "item": "planks"
            }
          }
        ],
        "output": {
          "item": "roof-wood"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 2,
            "reference": {
              "item": "wood"
            }
          }
        ],
        "output": {
          "item": "campfire"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 5,
            "reference": {
              "item": "stick"
            }
          },
          {
            "quantity": 5,
            "reference": {
              "item": "shard-metal"
            }
          }
        ],
        "output": {
          "color": "metal",
          "item": "dagger"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 5,
            "reference": {
              "item": "stick"
            }
          }
        ],
        "output": {
          "color": "brown",
          "item": "dagger"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 2,
            "reference": {
              "item": "stick"
            }
          },
          {
            "quantity": 3,
            "reference": {
              "item": "feather"
            }
          },
          {
            "quantity": 2,
            "reference": {
              "item": "shard-metal"
            }
          }
        ],
        "output": {
          "item": "arrow"
        },
        "quantity": 10
      },
      {
        "ingredients": [
          {
            "quantity": 3,
            "reference": {
              "item": "metal-bar-iron"
            }
          },
          {
            "quantity": 2,
            "reference": {
              "item": "stick"
            }
          }
        ],
        "output": {
          "item": "axe"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 5,
            "reference": {
              "item": "stick"
            }
          },
          {
            "quantity": 3,
            "reference": {
              "item": "shard-metal"
            }
          }
        ],
        "output": {
          "item": "iron-pickaxe"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 10,
            "reference": {
              "item": "wood"
            }
          },
          {
            "quantity": 3,
            "reference": {
              "item": "shard-metal"
            }
          }
        ],
        "output": {
          "item": "spear"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 3,
            "reference": {
              "item": "metal-bar-iron"
            }
          },
          {
            "quantity": 1,
            "reference": {
              "item": "planks"
            }
          }
        ],
        "output": {
          "item": "longsword"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 4,
            "reference": {
              "item": "metal-bar-iron"
            }
          },
          {
            "quantity": 2,
            "reference": {
              "item": "planks"
            }
          }
        ],
        "output": {
          "item": "waraxe"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 15,
            "reference": {
              "item": "stick"
            }
          },
          {
            "quantity": 5,
            "reference": {
              "item": "shard-metal"
            }
          },
          {
            "quantity": 2,
            "reference": {
              "item": "rope"
            }
          }
        ],
        "output": {
          "item": "bow"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 3,
            "reference": {
              "item": "stick"
            }
          },
          {
            "quantity": 1,
            "reference": {
              "item": "rope"
            }
          }
        ],
        "output": {
          "item": "snare-rabbit"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 1,
            "reference": {
              "item": "copper"
            }
          },
          {
            "quantity": 2,
            "reference": {
              "item": "coal"
            }
          },
          {
            "quantity": 1,
            "reference": {
              "item": "spider-silk"
            }
          }
        ],
        "output": {
          "item": "ember-charge"
        },
        "quantity": 9
      },
      {
        "ingredients": [
          {
            "quantity": 4,
            "reference": {
              "item": "planks"
            }
          }
        ],
        "output": {
          "item": "stairs"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 4,
            "reference": {
              "item": "planks"
            }
          }
        ],
        "output": {
          "item": "thatch-roof"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 3,
            "reference": {
              "item": "planks"
            }
          }
        ],
        "output": {
          "item": "timber-frame-wall"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 2,
            "reference": {
              "item": "planks"
            }
          }
        ],
        "output": {
          "item": "window-frame"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 3,
            "reference": {
              "item": "planks"
            }
          }
        ],
        "output": {
          "item": "chimney-stack"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 2,
            "reference": {
              "item": "planks"
            }
          }
        ],
        "output": {
          "item": "dormer-window"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 2,
            "reference": {
              "item": "planks"
            }
          }
        ],
        "output": {
          "item": "hatch-wood"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 5,
            "reference": {
              "item": "planks"
            }
          }
        ],
        "output": {
          "item": "castle-footing"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 5,
            "reference": {
              "item": "planks"
            }
          }
        ],
        "output": {
          "item": "castle-wall"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 3,
            "reference": {
              "item": "planks"
            }
          }
        ],
        "output": {
          "item": "castle-merlons"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 2,
            "reference": {
              "item": "planks"
            }
          }
        ],
        "output": {
          "item": "arrow-slit"
        },
        "quantity": 1
      },
      {
        "ingredients": [
          {
            "quantity": 4,
            "reference": {
              "item": "planks"
            }
          }
        ],
        "output": {
          "item": "tower-render"
        },
        "quantity": 1
      }
    ],
    "registry": {
      "armor": {
        "armor-leather": {
          "colors": [
            "blue",
            "brown",
            "green"
          ],
          "layers": [
            {
              "path": "torso/armour/leather/{sex}/{variant}.png",
              "z": 60
            }
          ],
          "variants": {
            "blue": "blue",
            "brown": "brown",
            "green": "green"
          }
        },
        "armor-legion": {
          "colors": [
            "brown",
            "gray",
            "gold"
          ],
          "layers": [
            {
              "path": "torso/armour/legion/{sex}/{variant}.png",
              "z": 60
            }
          ],
          "variants": {
            "brown": "bronze",
            "gold": "gold",
            "gray": "steel"
          }
        },
        "armor-plate": {
          "colors": [
            "gray",
            "metal",
            "yellow",
            "gold",
            "orange",
            "tan"
          ],
          "layers": [
            {
              "path": "torso/armour/plate/{sex}/{variant}.png",
              "z": 60
            }
          ],
          "variants": {
            "gold": "14",
            "gray": "11",
            "metal": "12",
            "orange": "16",
            "tan": "special",
            "yellow": "12"
          }
        }
      },
      "bauldron": {
        "bauldron": {
          "colors": [
            "brown"
          ],
          "layers": [
            {
              "path": "bauldron/{sex}/brown.png",
              "z": 65
            }
          ]
        }
      },
      "body": {
        "bee": {
          "colors": [
            "yellow"
          ],
          "groundAnchor": {
            "x": 32,
            "y": 60
          },
          "layers": [
            {
              "path": "body/{sex}/bee/yellow.png",
              "z": 10
            }
          ]
        },
        "chicken": {
          "colors": [
            "white"
          ],
          "groundAnchor": {
            "x": 16,
            "y": 29
          },
          "layers": [
            {
              "path": "authored/lpc-chicken.png",
              "z": 10
            }
          ],
          "shadow": {
            "feetY": 45
          }
        },
        "deer": {
          "colors": [
            "brown"
          ],
          "groundAnchor": {
            "x": 64,
            "y": 87
          },
          "layers": [
            {
              "path": "body/{sex}/deer/brown.png",
              "z": 10
            }
          ],
          "shadow": {
            "feetY": 55
          }
        },
        "horse": {
          "colors": [
            "brown"
          ],
          "groundAnchor": {
            "x": 64,
            "y": 92
          },
          "layers": [
            {
              "path": "body/{sex}/horse/burdened/brown.png",
              "z": 10
            }
          ]
        },
        "human": {
          "colors": [
            "white",
            "black",
            "olive",
            "brown",
            "light",
            "dark",
            "tan"
          ],
          "groundAnchor": {
            "x": 32,
            "y": 60
          },
          "layers": [
            {
              "path": "body/{sex}/human/{variant}.png",
              "z": 10
            }
          ],
          "variants": {
            "black": "black",
            "brown": "brown",
            "dark": "dark",
            "light": "light",
            "olive": "olive",
            "tan": "tanned",
            "white": "white"
          }
        },
        "lpc-chicken": {
          "colors": [
            "white"
          ],
          "groundAnchor": {
            "x": 16,
            "y": 29
          },
          "layers": [
            {
              "path": "authored/lpc-chicken.png",
              "z": 10
            }
          ],
          "shadow": {
            "feetY": 45
          }
        },
        "lpc-viper": {
          "colors": [
            "green"
          ],
          "groundAnchor": {
            "x": 32,
            "y": 44
          },
          "layers": [
            {
              "path": "authored/lpc-viper.png",
              "z": 10
            }
          ],
          "shadow": {
            "feetY": 44
          }
        },
        "orc": {
          "colors": [
            "gray",
            "green",
            "lightgreen"
          ],
          "groundAnchor": {
            "x": 32,
            "y": 60
          },
          "layers": [
            {
              "path": "body/{sex}/orcs/{variant}.png",
              "z": 10
            }
          ],
          "variants": {
            "gray": "gray",
            "green": "green_1",
            "lightgreen": "green_3"
          }
        },
        "rabbit": {
          "colors": [
            "white"
          ],
          "groundAnchor": {
            "x": 36,
            "y": 50
          },
          "layers": [
            {
              "path": "authored/wild-hare.png",
              "z": 10
            }
          ],
          "shadow": {
            "feetY": 46
          }
        },
        "rage-slime": {
          "colors": [
            "green"
          ],
          "groundAnchor": {
            "x": 32,
            "y": 44
          },
          "layers": [
            {
              "path": "authored/rage-slime.png",
              "z": 10
            }
          ],
          "shadow": {
            "feetY": 44
          }
        },
        "redspider": {
          "colors": [
            "red"
          ],
          "groundAnchor": {
            "x": 32,
            "y": 49
          },
          "layers": [
            {
              "path": "body/{sex}/redspider/red.png",
              "z": 10
            }
          ],
          "shadow": {
            "feetY": 49
          }
        },
        "reptile": {
          "colors": [
            "green",
            "lightgreen",
            "blue"
          ],
          "groundAnchor": {
            "x": 32,
            "y": 60
          },
          "layers": [
            {
              "path": "body/{sex}/reptiles/{variant}_unwinged.png",
              "z": 10
            }
          ],
          "variants": {
            "blue": "blue",
            "green": "green",
            "lightgreen": "lightgreen"
          }
        },
        "reptile-winged": {
          "colors": [
            "green",
            "lightgreen",
            "blue"
          ],
          "groundAnchor": {
            "x": 32,
            "y": 60
          },
          "layers": [
            {
              "path": "body/{sex}/reptiles/{variant}_winged.png",
              "z": 10
            }
          ],
          "variants": {
            "blue": "blue",
            "green": "green",
            "lightgreen": "lightgreen"
          }
        },
        "skeleton": {
          "colors": [
            "white",
            "gray",
            "green"
          ],
          "groundAnchor": {
            "x": 32,
            "y": 60
          },
          "layers": [
            {
              "path": "body/skeleton/{variant}.png",
              "z": 10
            }
          ],
          "variants": {
            "gray": "gray",
            "green": "green",
            "white": "beige"
          }
        },
        "slime": {
          "colors": [
            "green"
          ],
          "groundAnchor": {
            "x": 32,
            "y": 49.4
          },
          "layers": [
            {
              "path": "authored/rage-slime.png",
              "z": 10
            }
          ],
          "shadow": {
            "feetY": 49.4
          }
        },
        "snake": {
          "colors": [
            "green"
          ],
          "groundAnchor": {
            "x": 32,
            "y": 44
          },
          "layers": [
            {
              "path": "authored/lpc-viper.png",
              "z": 10
            }
          ],
          "shadow": {
            "feetY": 44
          }
        },
        "spikes1": {
          "colors": [
            "white"
          ],
          "groundAnchor": {
            "x": 16,
            "y": 44
          },
          "layers": [
            {
              "path": "spike/spikes1.png",
              "z": 10
            }
          ]
        },
        "thistle": {
          "colors": [
            "white"
          ],
          "groundAnchor": {
            "x": 36,
            "y": 50
          },
          "layers": [
            {
              "path": "authored/thistle.png",
              "z": 10
            }
          ],
          "shadow": {
            "feetY": 46
          }
        },
        "wasp": {
          "colors": [
            "yellow"
          ],
          "groundAnchor": {
            "x": 16,
            "y": 44
          },
          "layers": [
            {
              "path": "body/{sex}/wasp/yellow.png",
              "z": 10
            }
          ]
        },
        "wild-hare": {
          "colors": [
            "white"
          ],
          "groundAnchor": {
            "x": 36,
            "y": 50
          },
          "layers": [
            {
              "path": "authored/wild-hare.png",
              "z": 10
            }
          ],
          "shadow": {
            "feetY": 46
          }
        },
        "wolfman": {
          "colors": [
            "brown",
            "black",
            "gray",
            "white"
          ],
          "groundAnchor": {
            "x": 32,
            "y": 60
          },
          "layers": [
            {
              "path": "body/{sex}/wolf/{variant}.png",
              "z": 10
            },
            {
              "path": "body/{sex}/wolf/head/{variant}.png",
              "z": 100
            }
          ],
          "variants": {
            "black": "black",
            "brown": "brown",
            "gray": "gray",
            "white": "white"
          }
        },
        "zombie": {
          "colors": [
            "green"
          ],
          "groundAnchor": {
            "x": 32,
            "y": 60
          },
          "layers": [
            {
              "path": "body/{sex}/special/zombie.png",
              "z": 10
            }
          ]
        }
      },
      "cape": {
        "cape-solid": {
          "colors": [
            "black",
            "blue",
            "brown",
            "gray",
            "green",
            "maroon",
            "red",
            "white",
            "yellow"
          ],
          "layers": [
            {
              "path": "cape/solid/{sex}/{variant}.png",
              "z": 85
            },
            {
              "path": "cape/solid_behind/{variant}.png",
              "z": 5
            }
          ],
          "variants": {
            "black": "black",
            "blue": "blue",
            "brown": "brown",
            "gray": "gray",
            "green": "green",
            "maroon": "maroon",
            "red": "red",
            "white": "white",
            "yellow": "yellow"
          }
        },
        "cape-tattered": {
          "colors": [
            "black",
            "blue",
            "brown",
            "gray",
            "green",
            "maroon",
            "red",
            "white",
            "yellow"
          ],
          "layers": [
            {
              "path": "cape/tattered/{sex}/{variant}.png",
              "z": 85
            },
            {
              "path": "cape/tattered_behind/{variant}.png",
              "z": 5
            }
          ],
          "variants": {
            "black": "black",
            "blue": "blue",
            "brown": "brown",
            "gray": "gray",
            "green": "green",
            "maroon": "maroon",
            "red": "red",
            "white": "white",
            "yellow": "yellow"
          }
        },
        "cape-trimmed": {
          "colors": [
            "white"
          ],
          "layers": [
            {
              "path": "cape/trimmed/{sex}/white_blue.png",
              "z": 85
            },
            {
              "path": "cape/trimmed_behind/white_blue.png",
              "z": 5
            }
          ]
        }
      },
      "eyes": {
        "cyclops": {
          "colors": [
            "red"
          ],
          "layers": [
            {
              "path": "eyes/{sex}/cyclope.png",
              "z": 20
            }
          ]
        },
        "normal": {
          "colors": [
            "blue",
            "brown",
            "gray",
            "green",
            "orange",
            "purple",
            "red",
            "yellow"
          ],
          "layers": [
            {
              "path": "eyes/{sex}/{variant}.png",
              "z": 20
            }
          ],
          "variants": {
            "blue": "blue",
            "brown": "brown",
            "gray": "gray",
            "green": "green",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "yellow": "yellow"
          }
        }
      },
      "hair": {
        "afro": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/afro/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "balding": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/balding/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "bangs": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/bangs/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "bangs_bun": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/bangs_bun/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "bangslong": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/bangslong/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "bangslong2": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/bangslong2/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "bangsshort": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/bangsshort/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "bedhead": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/bedhead/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "bob": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/bob/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "bob_side_part": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/bob_side_part/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "braid": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/braid/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "braid2": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/braid2/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "bunches": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/bunches/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "buzzcut": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/buzzcut/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "cornrows": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/cornrows/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "cowlick": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/cowlick/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "cowlick_tall": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/cowlick_tall/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "curly_long": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/curly_long/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "curly_short": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/curly_short/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "curtains": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/curtains/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "curtains_long": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/curtains_long/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "dreadlocks_long": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/dreadlocks_long/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "dreadlocks_short": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/dreadlocks_short/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "flat_top_fade": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/flat_top_fade/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "flat_top_straight": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/flat_top_straight/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "half_up": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/half_up/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "halfmessy": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/halfmessy/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "high_and_tight": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/high_and_tight/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "high_ponytail": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/high_ponytail/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "idol": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/idol/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "jewfro": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/jewfro/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "lob": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/lob/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "long": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/long/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "long_band": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/long_band/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "long_center_part": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/long_center_part/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "long_messy": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/long_messy/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "long_messy2": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/long_messy2/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "long_tied": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/long_tied/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "longhawk": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/longhawk/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "longknot": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/longknot/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "loose": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/loose/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "messy1": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/messy1/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "messy2": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/messy2/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "messy3": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/messy3/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "mop": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/mop/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "natural": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/natural/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "page": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/page/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "page2": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/page2/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "part2": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/part2/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "parted": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/parted/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "pixie": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/pixie/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "plain": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/plain/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "ponytail": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/ponytail/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "ponytail2": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/ponytail2/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "princess": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/princess/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "sara": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/sara/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "shorthawk": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/shorthawk/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "shortknot": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/shortknot/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "shoulderl": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/shoulderl/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "shoulderr": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/shoulderr/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "single": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/single/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "spiked": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/spiked/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "spiked2": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/spiked2/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "spiked_beehive": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/spiked_beehive/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "spiked_liberty": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/spiked_liberty/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "spiked_liberty2": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/spiked_liberty2/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "spiked_porcupine": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/spiked_porcupine/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "swoop": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/swoop/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "twists_fade": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/twists_fade/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "twists_straight": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/twists_straight/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "unkempt": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/unkempt/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "wavy": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/wavy/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        },
        "xlong": {
          "colors": [
            "white",
            "blonde",
            "gold",
            "green",
            "blue",
            "red",
            "orange",
            "purple",
            "brown",
            "lightbrown",
            "gray",
            "black"
          ],
          "layers": [
            {
              "path": "hair/xlong/{sex}/{variant}.png",
              "z": 120
            }
          ],
          "variants": {
            "black": "black",
            "blonde": "blonde",
            "blue": "blue",
            "brown": "dark_brown",
            "gold": "gold",
            "gray": "gray",
            "green": "green",
            "lightbrown": "light_brown",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "white": "white"
          }
        }
      },
      "nose": {
        "big": {
          "colors": [
            "white",
            "tan",
            "gray"
          ],
          "layers": [
            {
              "path": "head/nose/big/{sex}/{variant}.png",
              "z": 20
            }
          ],
          "variants": {
            "gray": "darkelf",
            "tan": "tanned",
            "white": "light"
          }
        },
        "button": {
          "colors": [
            "white",
            "tan",
            "gray"
          ],
          "layers": [
            {
              "path": "head/nose/button/{sex}/{variant}.png",
              "z": 20
            }
          ],
          "variants": {
            "gray": "darkelf",
            "tan": "tanned",
            "white": "light"
          }
        },
        "straight": {
          "colors": [
            "white",
            "tan",
            "gray"
          ],
          "layers": [
            {
              "path": "head/nose/straight/{sex}/{variant}.png",
              "z": 20
            }
          ],
          "variants": {
            "gray": "darkelf",
            "tan": "tanned",
            "white": "light"
          }
        }
      },
      "pants": {
        "legion": {
          "colors": [
            "brown"
          ],
          "layers": [
            {
              "path": "legs/skirts/{sex}/legion.png",
              "z": 20
            }
          ]
        },
        "pantaloons": {
          "colors": [
            "black",
            "blue",
            "brown",
            "gray",
            "green",
            "maroon",
            "orange",
            "purple",
            "red",
            "tan",
            "white",
            "yellow"
          ],
          "layers": [
            {
              "path": "legs/pantaloons/{sex}/{variant}.png",
              "z": 20
            }
          ],
          "variants": {
            "black": "black",
            "blue": "blue",
            "brown": "brown",
            "gray": "gray",
            "green": "green",
            "maroon": "maroon",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "tan": "tan",
            "white": "white",
            "yellow": "yellow"
          }
        },
        "pants": {
          "colors": [
            "black",
            "blue",
            "brown",
            "gray",
            "green",
            "maroon",
            "orange",
            "purple",
            "red",
            "tan",
            "white",
            "yellow"
          ],
          "layers": [
            {
              "path": "legs/pants/{sex}/{variant}.png",
              "z": 20
            }
          ],
          "variants": {
            "black": "black",
            "blue": "blue",
            "brown": "brown",
            "gray": "gray",
            "green": "green",
            "maroon": "maroon",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "tan": "tan",
            "white": "white",
            "yellow": "yellow"
          }
        },
        "pants-armor": {
          "colors": [
            "gray",
            "metal",
            "yellow",
            "gold",
            "tan",
            "orange"
          ],
          "layers": [
            {
              "path": "legs/armour/{sex}/{variant}.png",
              "z": 20
            }
          ],
          "variants": {
            "gold": "8",
            "gray": "7",
            "metal": "8",
            "orange": "11",
            "tan": "10",
            "yellow": "9"
          }
        },
        "skirts": {
          "colors": [
            "brown",
            "black",
            "white"
          ],
          "layers": [
            {
              "path": "legs/skirts/{sex}/{variant}.png",
              "z": 20
            }
          ],
          "variants": {
            "black": "black",
            "brown": "brown",
            "white": "white"
          }
        }
      },
      "shield": {
        "shield-crusader": {
          "colors": [
            "white"
          ],
          "layers": [
            {
              "path": "shield/{sex}/crusader.png",
              "z": 141
            }
          ]
        },
        "shield-kite": {
          "colors": [
            "gray",
            "orange"
          ],
          "layers": [
            {
              "path": "shield/{sex}/kite_{variant}.png",
              "z": 141
            }
          ],
          "variants": {
            "gray": "gray",
            "orange": "orange"
          }
        },
        "shield-kite_blue": {
          "colors": [
            "blue",
            "gray"
          ],
          "layers": [
            {
              "path": "shield/{sex}/kite_blue_{variant}.png",
              "z": 141
            }
          ],
          "variants": {
            "blue": "blue",
            "gray": "gray"
          }
        },
        "shield-kite_gray": {
          "colors": [
            "blue",
            "gray",
            "green",
            "orange"
          ],
          "layers": [
            {
              "path": "shield/{sex}/kite_gray_{variant}.png",
              "z": 141
            }
          ],
          "variants": {
            "blue": "blue",
            "gray": "gray",
            "green": "green",
            "orange": "orange"
          }
        },
        "shield-kite_green": {
          "colors": [
            "gray"
          ],
          "layers": [
            {
              "path": "shield/{sex}/kite_green_gray.png",
              "z": 141
            }
          ]
        },
        "shield-kite_red": {
          "colors": [
            "gray"
          ],
          "layers": [
            {
              "path": "shield/{sex}/kite_red_gray.png",
              "z": 141
            }
          ]
        },
        "shield-round": {
          "colors": [
            "black",
            "brown",
            "gold",
            "green",
            "silver",
            "yellow"
          ],
          "layers": [
            {
              "path": "shield/{sex}/round_{variant}.png",
              "z": 141
            }
          ],
          "variants": {
            "black": "black",
            "brown": "brown",
            "gold": "gold",
            "green": "green",
            "silver": "silver",
            "yellow": "yellow"
          }
        },
        "shield-spartan": {
          "colors": [
            "brown"
          ],
          "layers": [
            {
              "path": "shield/{sex}/spartan.png",
              "z": 141
            }
          ]
        }
      },
      "shirt": {
        "blouse": {
          "colors": [
            "black",
            "blue",
            "green",
            "maroon",
            "purple",
            "red",
            "teal",
            "white",
            "yellow",
            "tan",
            "gray",
            "orange"
          ],
          "layers": [
            {
              "path": "torso/clothes/blouse/{sex}/{variant}.png",
              "z": 35
            }
          ],
          "variants": {
            "black": "black",
            "blue": "blue",
            "gray": "gray",
            "green": "green",
            "maroon": "maroon",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "tan": "tan",
            "teal": "teal",
            "white": "white",
            "yellow": "yellow"
          }
        },
        "blouse_longsleeve": {
          "colors": [
            "black",
            "blue",
            "green",
            "maroon",
            "purple",
            "red",
            "teal",
            "white",
            "yellow",
            "tan",
            "gray",
            "orange"
          ],
          "layers": [
            {
              "path": "torso/clothes/blouse_longsleeve/{sex}/{variant}.png",
              "z": 35
            }
          ],
          "variants": {
            "black": "black",
            "blue": "blue",
            "gray": "gray",
            "green": "green",
            "maroon": "maroon",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "tan": "tan",
            "teal": "teal",
            "white": "white",
            "yellow": "yellow"
          }
        },
        "corset": {
          "colors": [
            "black",
            "blue",
            "green",
            "maroon",
            "purple",
            "red",
            "teal",
            "white",
            "yellow",
            "brown",
            "tan",
            "gray",
            "orange"
          ],
          "layers": [
            {
              "path": "torso/clothes/corset/{sex}/{variant}.png",
              "z": 35
            }
          ],
          "variants": {
            "black": "black",
            "blue": "blue",
            "brown": "leather",
            "gray": "gray",
            "green": "green",
            "maroon": "maroon",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "tan": "tan",
            "teal": "teal",
            "white": "white",
            "yellow": "yellow"
          }
        },
        "longsleeve": {
          "colors": [
            "black",
            "blue",
            "green",
            "maroon",
            "purple",
            "red",
            "teal",
            "white",
            "yellow"
          ],
          "layers": [
            {
              "path": "torso/clothes/longsleeve/{sex}/{variant}.png",
              "z": 35
            }
          ],
          "variants": {
            "black": "black",
            "blue": "blue",
            "green": "green",
            "maroon": "maroon",
            "purple": "purple",
            "red": "red",
            "teal": "teal",
            "white": "white",
            "yellow": "yellow"
          }
        },
        "longsleeve_laced": {
          "colors": [
            "black",
            "blue",
            "green",
            "maroon",
            "purple",
            "red",
            "teal",
            "white",
            "yellow",
            "tan",
            "gray",
            "orange"
          ],
          "layers": [
            {
              "path": "torso/clothes/longsleeve_laced/{sex}/{variant}.png",
              "z": 35
            }
          ],
          "variants": {
            "black": "black",
            "blue": "blue",
            "gray": "gray",
            "green": "green",
            "maroon": "maroon",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "tan": "tan",
            "teal": "teal",
            "white": "white",
            "yellow": "yellow"
          }
        },
        "scoop_shirt": {
          "colors": [
            "black",
            "blue",
            "green",
            "maroon",
            "purple",
            "red",
            "teal",
            "white",
            "yellow",
            "gray",
            "orange"
          ],
          "layers": [
            {
              "path": "torso/clothes/scoop_shirt/{sex}/{variant}.png",
              "z": 35
            }
          ],
          "variants": {
            "black": "black",
            "blue": "blue",
            "gray": "gray",
            "green": "green",
            "maroon": "maroon",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "teal": "teal",
            "white": "white",
            "yellow": "yellow"
          }
        },
        "sleeveless": {
          "colors": [
            "black",
            "blue",
            "green",
            "maroon",
            "purple",
            "red",
            "teal",
            "white",
            "yellow",
            "brown",
            "tan",
            "gray",
            "orange"
          ],
          "layers": [
            {
              "path": "torso/clothes/sleeveless/{sex}/{variant}.png",
              "z": 35
            }
          ],
          "variants": {
            "black": "black",
            "blue": "blue",
            "brown": "brown",
            "gray": "gray",
            "green": "green",
            "maroon": "maroon",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "tan": "tan",
            "teal": "teal",
            "white": "white",
            "yellow": "yellow"
          }
        },
        "sleeveless_laced": {
          "colors": [
            "black",
            "blue",
            "green",
            "maroon",
            "purple",
            "red",
            "teal",
            "white",
            "yellow",
            "brown",
            "tan",
            "gray",
            "orange"
          ],
          "layers": [
            {
              "path": "torso/clothes/sleeveless_laced/{sex}/{variant}.png",
              "z": 35
            }
          ],
          "variants": {
            "black": "black",
            "blue": "blue",
            "brown": "brown",
            "gray": "gray",
            "green": "green",
            "maroon": "maroon",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "tan": "tan",
            "teal": "teal",
            "white": "white",
            "yellow": "yellow"
          }
        },
        "sleeveless_striped": {
          "colors": [
            "black",
            "blue",
            "green",
            "maroon",
            "purple",
            "red",
            "teal",
            "white",
            "yellow",
            "brown",
            "tan",
            "gray",
            "orange"
          ],
          "layers": [
            {
              "path": "torso/clothes/sleeveless_striped/{sex}/{variant}.png",
              "z": 35
            }
          ],
          "variants": {
            "black": "black",
            "blue": "blue",
            "brown": "brown",
            "gray": "gray",
            "green": "green",
            "maroon": "maroon",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "tan": "tan",
            "teal": "teal",
            "white": "white",
            "yellow": "yellow"
          }
        },
        "tanktop": {
          "colors": [
            "black",
            "blue",
            "green",
            "maroon",
            "purple",
            "red",
            "teal",
            "white",
            "yellow",
            "tan",
            "gray",
            "orange"
          ],
          "layers": [
            {
              "path": "torso/clothes/tanktop/{sex}/{variant}.png",
              "z": 35
            }
          ],
          "variants": {
            "black": "black",
            "blue": "blue",
            "gray": "gray",
            "green": "green",
            "maroon": "maroon",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "tan": "tan",
            "teal": "teal",
            "white": "white",
            "yellow": "yellow"
          }
        },
        "tunic": {
          "colors": [
            "brown",
            "maroon",
            "teal",
            "white"
          ],
          "layers": [
            {
              "path": "torso/clothes/tunic/{sex}/{variant}.png",
              "z": 35
            }
          ],
          "variants": {
            "brown": "brown",
            "maroon": "maroon",
            "teal": "teal",
            "white": "white"
          }
        }
      },
      "shoes": {
        "boots": {
          "colors": [
            "black",
            "blue",
            "brown",
            "gray",
            "green",
            "maroon",
            "orange",
            "purple",
            "red",
            "tan",
            "teal",
            "white",
            "yellow"
          ],
          "layers": [
            {
              "path": "feet/boots/{sex}/{variant}.png",
              "z": 25
            }
          ],
          "variants": {
            "black": "black",
            "blue": "blue",
            "brown": "brown",
            "gray": "gray",
            "green": "green",
            "maroon": "maroon",
            "orange": "orange",
            "purple": "purple",
            "red": "red",
            "tan": "tan",
            "teal": "teal",
            "white": "white",
            "yellow": "yellow"
          }
        },
        "sandals": {
          "colors": [
            "brown"
          ],
          "layers": [
            {
              "path": "feet/sandals/{sex}/brown.png",
              "z": 15
            }
          ]
        },
        "shoes": {
          "colors": [
            "black",
            "brown",
            "maroon"
          ],
          "layers": [
            {
              "path": "feet/shoes/{sex}/{variant}.png",
              "z": 15
            }
          ],
          "variants": {
            "black": "black",
            "brown": "brown",
            "maroon": "maroon"
          }
        },
        "shoes-armor": {
          "colors": [
            "gray",
            "metal",
            "yellow",
            "gold",
            "tan",
            "orange"
          ],
          "layers": [
            {
              "path": "feet/armor/{sex}/{variant}.png",
              "z": 15
            }
          ],
          "variants": {
            "gold": "7",
            "gray": "4",
            "metal": "5",
            "orange": "9",
            "tan": "8",
            "yellow": "6"
          }
        },
        "slippers": {
          "colors": [
            "black",
            "brown",
            "gray"
          ],
          "layers": [
            {
              "path": "feet/slippers/{sex}/{variant}.png",
              "z": 15
            }
          ],
          "variants": {
            "black": "black",
            "brown": "brown",
            "gray": "gray"
          }
        }
      },
      "weapon": {
        "axe": {
          "colors": [
            "metal"
          ],
          "layers": [
            {
              "path": "weapon/slash/{sex}/axe_2.png",
              "z": 140
            }
          ]
        },
        "bow": {
          "colors": [
            "brown"
          ],
          "layers": [
            {
              "path": "weapon/bow/normal.png",
              "z": 140
            }
          ]
        },
        "crossbow": {
          "colors": [
            "brown"
          ],
          "layers": [
            {
              "path": "weapon/thrust/{sex}/crossbow.png",
              "z": 140
            }
          ]
        },
        "dagger": {
          "colors": [
            "metal",
            "brown"
          ],
          "layers": [
            {
              "path": "weapon/slash/{sex}/{variant}.png",
              "z": 140
            }
          ],
          "variants": {
            "brown": "dagger_brown",
            "metal": "dagger"
          }
        },
        "flail": {
          "colors": [
            "metal"
          ],
          "layers": [
            {
              "path": "weapon/slash_oversize/{sex}/universal/flail.png",
              "z": 140
            },
            {
              "path": "weapon/slash_oversize/{sex}/flail.png",
              "type": "oversize",
              "z": 150
            }
          ]
        },
        "halberd": {
          "colors": [
            "metal"
          ],
          "layers": [
            {
              "path": "weapon/slash_oversize/{sex}/universal/halberd.png",
              "z": 140
            },
            {
              "path": "weapon/slash_oversize/{sex}/halberd.png",
              "type": "oversize",
              "z": 150
            }
          ]
        },
        "iron-pickaxe": {
          "colors": [
            "na"
          ],
          "layers": [
            {
              "path": "authored/iron-pickaxe/{sex}.png",
              "z": 140
            }
          ]
        },
        "longsword": {
          "colors": [
            "metal"
          ],
          "layers": [
            {
              "path": "weapon/slash_oversize_layered/all/universal/behind/longsword.png",
              "z": 9
            },
            {
              "path": "weapon/slash_oversize_layered/all/universal/longsword.png",
              "z": 140
            },
            {
              "path": "weapon/slash_oversize_layered/all/longsword.png",
              "type": "oversize",
              "z": 150
            }
          ]
        },
        "mace": {
          "colors": [
            "metal"
          ],
          "layers": [
            {
              "path": "weapon/slash_oversize_layered/all/universal/behind/mace.png",
              "z": 9
            },
            {
              "path": "weapon/slash_oversize_layered/all/universal/mace.png",
              "z": 140
            },
            {
              "path": "weapon/slash_oversize_layered/all/mace.png",
              "type": "oversize",
              "z": 150
            }
          ]
        },
        "none": {
          "colors": [],
          "layers": []
        },
        "rapier": {
          "colors": [
            "metal"
          ],
          "layers": [
            {
              "path": "weapon/slash_oversize_layered/all/universal/behind/rapier.png",
              "z": 9
            },
            {
              "path": "weapon/slash_oversize_layered/all/universal/rapier.png",
              "z": 140
            },
            {
              "path": "weapon/slash_oversize_layered/all/rapier.png",
              "type": "oversize",
              "z": 150
            }
          ]
        },
        "saber": {
          "colors": [
            "metal"
          ],
          "layers": [
            {
              "path": "weapon/slash_oversize_layered/all/universal/behind/saber.png",
              "z": 9
            },
            {
              "path": "weapon/slash_oversize_layered/all/universal/saber.png",
              "z": 140
            },
            {
              "path": "weapon/slash_oversize_layered/all/saber.png",
              "type": "oversize",
              "z": 150
            }
          ]
        },
        "scythe": {
          "colors": [
            "metal"
          ],
          "layers": [
            {
              "path": "weapon/slash_oversize_layered/all/universal/behind/scythe.png",
              "z": 9
            },
            {
              "path": "weapon/slash_oversize_layered/all/universal/scythe.png",
              "z": 140
            },
            {
              "path": "weapon/slash_oversize_layered/all/scythe.png",
              "type": "oversize",
              "z": 150
            }
          ]
        },
        "spear": {
          "colors": [
            "brown",
            "black",
            "green",
            "metal",
            "purple"
          ],
          "layers": [
            {
              "path": "weapon/thrust/{sex}/spear_{variant}.png",
              "z": 140
            }
          ],
          "variants": {
            "black": "black",
            "brown": "2",
            "green": "green",
            "metal": "metal",
            "purple": "purple"
          }
        },
        "staff": {
          "colors": [
            "brown"
          ],
          "layers": [
            {
              "path": "weapon/thrust/{sex}/simple_staff.png",
              "z": 140
            }
          ]
        },
        "waraxe": {
          "colors": [
            "metal"
          ],
          "layers": [
            {
              "path": "weapon/slash_oversize/{sex}/universal/waraxe.png",
              "z": 140
            },
            {
              "path": "weapon/slash_oversize/{sex}/waraxe.png",
              "type": "oversize",
              "z": 150
            }
          ]
        },
        "warhammer": {
          "colors": [
            "metal"
          ],
          "layers": [
            {
              "path": "weapon/slash/{sex}/warhammer.png",
              "z": 140
            }
          ]
        },
        "web": {
          "colors": [
            "white"
          ],
          "layers": []
        }
      }
    },
    "sprites": {
      "creatures": {
        "lpc-chicken": {
          "template": "chicken"
        },
        "lpc-viper": {
          "template": "snake"
        },
        "rage-slime": {
          "template": "snake"
        },
        "thistle": {
          "template": "rabbit"
        },
        "wild-hare": {
          "template": "rabbit"
        }
      },
      "dimensions": {
        "chicken": {
          "h": 32,
          "w": 32
        },
        "deer": {
          "h": 128,
          "w": 128
        },
        "horse": {
          "h": 128,
          "w": 128
        },
        "lpc-chicken": {
          "h": 32,
          "w": 32
        },
        "lpc-viper": {
          "h": 64,
          "w": 64
        },
        "rabbit": {
          "h": 72,
          "w": 72
        },
        "rage-slime": {
          "h": 64,
          "w": 64
        },
        "redspider": {
          "h": 64,
          "w": 64
        },
        "slime": {
          "h": 64,
          "w": 64
        },
        "snake": {
          "h": 64,
          "w": 64
        },
        "spikes1": {
          "h": 32,
          "w": 32
        },
        "thistle": {
          "h": 72,
          "w": 72
        },
        "wasp": {
          "h": 32,
          "w": 32
        },
        "wild-hare": {
          "h": 72,
          "w": 72
        }
      },
      "registration": {
        "ArmorTypes": [
          "armor-plate",
          "armor-leather",
          "armor-legion"
        ],
        "CapeTypes": [
          "cape-solid",
          "cape-tattered",
          "cape-trimmed"
        ],
        "DefaultAttackActionType": {
          "lpc-viper": "thrust",
          "rage-slime": "thrust",
          "redspider": "thrust",
          "skeleton": "thrust",
          "slime": "thrust",
          "snake": "thrust",
          "spikes1": "thrust",
          "wasp": "thrust",
          "zombie": "slash"
        },
        "EyeTypes": [
          "normal",
          "cyclops"
        ],
        "HairTypes": [
          "afro",
          "balding",
          "bangs",
          "bangs_bun",
          "bangslong",
          "bangslong2",
          "bangsshort",
          "bedhead",
          "bob",
          "bob_side_part",
          "braid",
          "braid2",
          "bunches",
          "buzzcut",
          "cornrows",
          "cowlick",
          "cowlick_tall",
          "curly_long",
          "curly_short",
          "curtains",
          "curtains_long",
          "dreadlocks_long",
          "dreadlocks_short",
          "flat_top_fade",
          "flat_top_straight",
          "half_up",
          "halfmessy",
          "high_and_tight",
          "high_ponytail",
          "idol",
          "jewfro",
          "lob",
          "long",
          "long_band",
          "long_center_part",
          "long_messy",
          "long_messy2",
          "long_tied",
          "longhawk",
          "longknot",
          "loose",
          "messy1",
          "messy2",
          "messy3",
          "mop",
          "natural",
          "page",
          "page2",
          "part2",
          "parted",
          "pixie",
          "plain",
          "ponytail",
          "ponytail2",
          "princess",
          "sara",
          "shorthawk",
          "shortknot",
          "shoulderl",
          "shoulderr",
          "single",
          "spiked",
          "spiked2",
          "spiked_beehive",
          "spiked_liberty",
          "spiked_liberty2",
          "spiked_porcupine",
          "swoop",
          "twists_fade",
          "twists_straight",
          "unkempt",
          "wavy",
          "xlong"
        ],
        "HumanoidRaceTypes": [
          "human",
          "reptile",
          "reptile-winged",
          "orc",
          "skeleton",
          "wolfman",
          "zombie"
        ],
        "NoseTypes": [
          "button",
          "big",
          "straight"
        ],
        "PantsTypes": [
          "pants-armor",
          "pants",
          "pantaloons",
          "legion",
          "skirts"
        ],
        "RaceEyes": {
          "human": [
            "normal"
          ],
          "orc": [
            "normal"
          ],
          "skeleton": [
            "normal"
          ],
          "zombie": [
            "normal"
          ]
        },
        "RaceNoses": {
          "human": [
            "big",
            "button",
            "straight"
          ],
          "orc": [
            "big",
            "button",
            "straight"
          ],
          "reptile": [],
          "reptile-winged": [],
          "skeleton": [
            "big",
            "button",
            "straight"
          ],
          "wolfman": [],
          "zombie": [
            "big",
            "button",
            "straight"
          ]
        },
        "RaceSexes": {
          "bee": [
            "male"
          ],
          "chicken": [
            "male"
          ],
          "deer": [
            "female"
          ],
          "horse": [
            "male"
          ],
          "human": [
            "male",
            "female"
          ],
          "lpc-chicken": [
            "male"
          ],
          "lpc-viper": [
            "male"
          ],
          "orc": [
            "male",
            "female"
          ],
          "rabbit": [
            "male"
          ],
          "rage-slime": [
            "male"
          ],
          "redspider": [
            "male"
          ],
          "reptile": [
            "male",
            "female"
          ],
          "reptile-winged": [
            "male",
            "female"
          ],
          "skeleton": [
            "male"
          ],
          "slime": [
            "male"
          ],
          "snake": [
            "male"
          ],
          "spikes1": [
            "male"
          ],
          "thistle": [
            "male"
          ],
          "wasp": [
            "male"
          ],
          "wild-hare": [
            "male"
          ],
          "wolfman": [
            "male",
            "female"
          ],
          "zombie": [
            "male"
          ]
        },
        "RaceTypes": [
          "human",
          "reptile",
          "reptile-winged",
          "orc",
          "skeleton",
          "wolfman",
          "zombie",
          "horse",
          "snake",
          "deer",
          "slime",
          "rabbit",
          "chicken",
          "bee",
          "wasp",
          "redspider",
          "spikes1",
          "wild-hare",
          "rage-slime",
          "lpc-viper",
          "lpc-chicken",
          "thistle"
        ],
        "RaceWeapons": {
          "human": [
            "spear",
            "bow",
            "staff",
            "axe",
            "warhammer",
            "none",
            "iron-pickaxe"
          ],
          "orc": [
            "spear",
            "bow",
            "staff",
            "axe",
            "warhammer",
            "none",
            "iron-pickaxe"
          ],
          "reptile": [
            "spear",
            "bow",
            "staff",
            "axe",
            "warhammer",
            "none",
            "iron-pickaxe"
          ],
          "reptile-winged": [
            "spear",
            "bow",
            "staff",
            "axe",
            "warhammer",
            "none",
            "iron-pickaxe"
          ],
          "skeleton": [
            "spear",
            "bow",
            "staff",
            "axe",
            "warhammer",
            "none",
            "iron-pickaxe"
          ],
          "wolfman": [
            "spear",
            "bow",
            "staff",
            "axe",
            "warhammer",
            "none",
            "iron-pickaxe"
          ],
          "zombie": [
            "spear",
            "bow",
            "staff",
            "axe",
            "warhammer",
            "none",
            "iron-pickaxe"
          ]
        },
        "SexCapes": {
          "female": [
            "cape-tattered",
            "cape-trimmed"
          ],
          "male": [
            "cape-solid"
          ]
        },
        "SexHair": {
          "female": [
            "afro",
            "bangs",
            "bangs_bun",
            "bangslong",
            "bangslong2",
            "bangsshort",
            "bedhead",
            "bob",
            "bob_side_part",
            "braid",
            "braid2",
            "bunches",
            "buzzcut",
            "cornrows",
            "cowlick",
            "cowlick_tall",
            "curly_long",
            "curly_short",
            "curtains",
            "curtains_long",
            "dreadlocks_long",
            "dreadlocks_short",
            "flat_top_fade",
            "flat_top_straight",
            "half_up",
            "halfmessy",
            "high_and_tight",
            "high_ponytail",
            "idol",
            "jewfro",
            "lob",
            "long",
            "long_band",
            "long_center_part",
            "long_messy",
            "long_messy2",
            "long_tied",
            "longhawk",
            "longknot",
            "loose",
            "messy1",
            "messy2",
            "messy3",
            "mop",
            "natural",
            "page",
            "page2",
            "part2",
            "parted",
            "pixie",
            "plain",
            "ponytail",
            "ponytail2",
            "princess",
            "sara",
            "shorthawk",
            "shortknot",
            "shoulderl",
            "shoulderr",
            "single",
            "spiked",
            "spiked2",
            "spiked_beehive",
            "spiked_liberty",
            "spiked_liberty2",
            "spiked_porcupine",
            "swoop",
            "twists_fade",
            "twists_straight",
            "unkempt",
            "wavy",
            "xlong"
          ],
          "male": [
            "afro",
            "balding",
            "bangs",
            "bangs_bun",
            "bangslong",
            "bangslong2",
            "bangsshort",
            "bedhead",
            "buzzcut",
            "cornrows",
            "cowlick",
            "cowlick_tall",
            "curly_short",
            "curtains",
            "curtains_long",
            "dreadlocks_long",
            "dreadlocks_short",
            "flat_top_fade",
            "flat_top_straight",
            "half_up",
            "halfmessy",
            "high_and_tight",
            "high_ponytail",
            "idol",
            "jewfro",
            "lob",
            "long",
            "long_center_part",
            "long_messy",
            "long_messy2",
            "long_tied",
            "longhawk",
            "longknot",
            "loose",
            "messy1",
            "messy2",
            "messy3",
            "mop",
            "natural",
            "page",
            "page2",
            "part2",
            "parted",
            "pixie",
            "plain",
            "ponytail",
            "ponytail2",
            "shorthawk",
            "shortknot",
            "single",
            "spiked",
            "spiked2",
            "spiked_beehive",
            "spiked_liberty",
            "spiked_liberty2",
            "spiked_porcupine",
            "swoop",
            "twists_fade",
            "twists_straight",
            "unkempt",
            "wavy"
          ]
        },
        "SexPants": {
          "female": [
            "pants-armor",
            "pants",
            "legion",
            "skirts"
          ],
          "male": [
            "pants-armor",
            "pants",
            "pantaloons",
            "legion",
            "skirts"
          ]
        },
        "SexShirts": {
          "female": [
            "blouse",
            "blouse_longsleeve",
            "corset",
            "longsleeve",
            "scoop_shirt",
            "tanktop",
            "tunic"
          ],
          "male": [
            "longsleeve",
            "longsleeve_laced",
            "sleeveless",
            "sleeveless_laced",
            "sleeveless_striped"
          ]
        },
        "SexShoes": {
          "female": [
            "shoes-armor",
            "boots",
            "sandals",
            "shoes",
            "slippers"
          ],
          "male": [
            "shoes-armor",
            "boots",
            "sandals",
            "shoes"
          ]
        },
        "ShieldTypes": [
          "shield-crusader",
          "shield-spartan",
          "shield-round",
          "shield-kite",
          "shield-kite_blue",
          "shield-kite_gray",
          "shield-kite_green",
          "shield-kite_red"
        ],
        "ShirtTypes": [
          "blouse",
          "blouse_longsleeve",
          "corset",
          "longsleeve",
          "longsleeve_laced",
          "scoop_shirt",
          "sleeveless",
          "sleeveless_laced",
          "sleeveless_striped",
          "tanktop",
          "tunic"
        ],
        "ShoeTypes": [
          "boots",
          "shoes",
          "shoes-armor",
          "slippers",
          "sandals"
        ],
        "WeaponAction": {
          "axe": "slash",
          "bow": "shoot",
          "crossbow": "thrust",
          "dagger": "slash",
          "flail": "slash",
          "halberd": "slash",
          "iron-pickaxe": "slash",
          "longsword": "slash",
          "mace": "slash",
          "none": "slash",
          "rapier": "slash",
          "saber": "slash",
          "scythe": "slash",
          "spear": "thrust",
          "staff": "thrust",
          "waraxe": "slash",
          "warhammer": "slash",
          "web": "shoot"
        },
        "WeaponAmmo": {
          "bow": "arrow",
          "crossbow": "arrow",
          "web": "webAmmo"
        },
        "WeaponTypes": [
          "dagger",
          "spear",
          "bow",
          "crossbow",
          "staff",
          "axe",
          "warhammer",
          "longsword",
          "mace",
          "rapier",
          "saber",
          "scythe",
          "flail",
          "halberd",
          "waraxe",
          "web",
          "none",
          "iron-pickaxe"
        ]
      },
      "version": 1,
      "weapons": {
        "iron-pickaxe": "axe"
      }
    },
    "tiles": {
      "damageDefaults": {
        "bonecaller-stone": 0,
        "castle-footing": 1,
        "castle-merlons": 1,
        "castle-wall": 1,
        "chest-wood": 1,
        "door-wood": 1,
        "floor-cobble": 1,
        "floor-opening": 0,
        "floor-stone": 1,
        "floor-wood": 1,
        "grassSprout": 1,
        "grove-low-a": 1,
        "grove-low-b": 1,
        "grove-oak-a": 1,
        "grove-oak-b": 1,
        "grove-round-a": 1,
        "grove-round-b": 1,
        "grove-spruce-a": 1,
        "grove-spruce-b": 1,
        "meadow-grass-a": 1,
        "meadow-grass-b": 1,
        "meadow-grass-c": 1,
        "meadow-grass-d": 1,
        "meadow-grass-e": 1,
        "meadow-grass-f": 1,
        "meadow-sprout": 1,
        "ore-coal": 6,
        "railing-wood": 1,
        "roof-wood": 1,
        "sapling": 1,
        "stairs-down": 1,
        "stairs-up": 1,
        "table-mid-round": 1,
        "tallGrass": 1,
        "tallReeds": 1,
        "testore": 6,
        "thatch-roof": 1,
        "timber-frame-wall": 1,
        "tower-render": 1,
        "tree1Small": 1,
        "tree2Small": 1,
        "wall-stone": 1,
        "wall-wood": 1,
        "wall2-wood": 1
      },
      "damageSpecifics": {
        "castle-footing": [
          {
            "damage": 1,
            "weaponType": "dagger"
          },
          {
            "damage": 1,
            "weaponType": "saber"
          },
          {
            "damage": 1,
            "weaponType": "spear"
          },
          {
            "damage": 1,
            "weaponType": "longsword"
          },
          {
            "damage": 2,
            "weaponType": "mace"
          },
          {
            "damage": 2,
            "weaponType": "axe"
          },
          {
            "damage": 2,
            "weaponType": "waraxe"
          },
          {
            "damage": 6,
            "weaponType": "warhammer"
          },
          {
            "damage": 4,
            "weaponType": "iron-pickaxe"
          }
        ],
        "castle-merlons": [
          {
            "damage": 1,
            "weaponType": "dagger"
          },
          {
            "damage": 1,
            "weaponType": "saber"
          },
          {
            "damage": 1,
            "weaponType": "spear"
          },
          {
            "damage": 1,
            "weaponType": "longsword"
          },
          {
            "damage": 2,
            "weaponType": "mace"
          },
          {
            "damage": 2,
            "weaponType": "axe"
          },
          {
            "damage": 2,
            "weaponType": "waraxe"
          },
          {
            "damage": 6,
            "weaponType": "warhammer"
          },
          {
            "damage": 4,
            "weaponType": "iron-pickaxe"
          }
        ],
        "castle-wall": [
          {
            "damage": 1,
            "weaponType": "dagger"
          },
          {
            "damage": 1,
            "weaponType": "saber"
          },
          {
            "damage": 1,
            "weaponType": "spear"
          },
          {
            "damage": 1,
            "weaponType": "longsword"
          },
          {
            "damage": 2,
            "weaponType": "mace"
          },
          {
            "damage": 2,
            "weaponType": "axe"
          },
          {
            "damage": 2,
            "weaponType": "waraxe"
          },
          {
            "damage": 6,
            "weaponType": "warhammer"
          },
          {
            "damage": 4,
            "weaponType": "iron-pickaxe"
          }
        ],
        "grassSprout": [
          {
            "damage": 0,
            "weaponType": "bow"
          },
          {
            "damage": 0,
            "weaponType": "crossbow"
          },
          {
            "damage": 0,
            "weaponType": "web"
          }
        ],
        "grove-low-a": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "grove-low-b": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "grove-oak-a": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "grove-oak-b": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "grove-round-a": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "grove-round-b": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "grove-spruce-a": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "grove-spruce-b": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "meadow-grass-a": [
          {
            "damage": 0,
            "weaponType": "bow"
          },
          {
            "damage": 0,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "longsword"
          },
          {
            "damage": 0,
            "weaponType": "crossbow"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          }
        ],
        "meadow-grass-b": [
          {
            "damage": 0,
            "weaponType": "bow"
          },
          {
            "damage": 0,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "longsword"
          },
          {
            "damage": 0,
            "weaponType": "crossbow"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          }
        ],
        "meadow-grass-c": [
          {
            "damage": 0,
            "weaponType": "bow"
          },
          {
            "damage": 0,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "longsword"
          },
          {
            "damage": 0,
            "weaponType": "crossbow"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          }
        ],
        "meadow-grass-d": [
          {
            "damage": 0,
            "weaponType": "bow"
          },
          {
            "damage": 0,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "longsword"
          },
          {
            "damage": 0,
            "weaponType": "crossbow"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          }
        ],
        "meadow-grass-e": [
          {
            "damage": 0,
            "weaponType": "bow"
          },
          {
            "damage": 0,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "longsword"
          },
          {
            "damage": 0,
            "weaponType": "crossbow"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          }
        ],
        "meadow-grass-f": [
          {
            "damage": 0,
            "weaponType": "bow"
          },
          {
            "damage": 0,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "longsword"
          },
          {
            "damage": 0,
            "weaponType": "crossbow"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          }
        ],
        "meadow-sprout": [
          {
            "damage": 0,
            "weaponType": "bow"
          },
          {
            "damage": 0,
            "weaponType": "crossbow"
          },
          {
            "damage": 0,
            "weaponType": "web"
          }
        ],
        "ore-coal": [
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 15,
            "weaponType": "iron-pickaxe"
          }
        ],
        "palmTree1": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "palmTree2": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "palmTree3": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "palmTree4": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "palmTree5": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "palmTree6": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "railing-wood": [
          {
            "damage": 3,
            "weaponType": "dagger"
          },
          {
            "damage": 3,
            "weaponType": "saber"
          },
          {
            "damage": 3,
            "weaponType": "spear"
          },
          {
            "damage": 3,
            "weaponType": "longsword"
          },
          {
            "damage": 3,
            "weaponType": "mace"
          },
          {
            "damage": 4,
            "weaponType": "axe"
          },
          {
            "damage": 4,
            "weaponType": "waraxe"
          },
          {
            "damage": 8,
            "weaponType": "warhammer"
          }
        ],
        "sapling": [
          {
            "damage": 0,
            "weaponType": "bow"
          },
          {
            "damage": 0,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "longsword"
          },
          {
            "damage": 0,
            "weaponType": "crossbow"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          }
        ],
        "smallTree1": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "tallGrass": [
          {
            "damage": 0,
            "weaponType": "bow"
          },
          {
            "damage": 0,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "longsword"
          },
          {
            "damage": 0,
            "weaponType": "crossbow"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          }
        ],
        "tallReeds": [
          {
            "damage": 0,
            "weaponType": "bow"
          },
          {
            "damage": 0,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "longsword"
          },
          {
            "damage": 0,
            "weaponType": "crossbow"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          }
        ],
        "testore": [
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 15,
            "weaponType": "iron-pickaxe"
          }
        ],
        "timber-frame-wall": [
          {
            "damage": 3,
            "weaponType": "dagger"
          },
          {
            "damage": 3,
            "weaponType": "saber"
          },
          {
            "damage": 3,
            "weaponType": "spear"
          },
          {
            "damage": 3,
            "weaponType": "longsword"
          },
          {
            "damage": 3,
            "weaponType": "mace"
          },
          {
            "damage": 4,
            "weaponType": "axe"
          },
          {
            "damage": 4,
            "weaponType": "waraxe"
          },
          {
            "damage": 8,
            "weaponType": "warhammer"
          }
        ],
        "tower-render": [
          {
            "damage": 1,
            "weaponType": "dagger"
          },
          {
            "damage": 1,
            "weaponType": "saber"
          },
          {
            "damage": 1,
            "weaponType": "spear"
          },
          {
            "damage": 1,
            "weaponType": "longsword"
          },
          {
            "damage": 2,
            "weaponType": "mace"
          },
          {
            "damage": 2,
            "weaponType": "axe"
          },
          {
            "damage": 2,
            "weaponType": "waraxe"
          },
          {
            "damage": 6,
            "weaponType": "warhammer"
          },
          {
            "damage": 4,
            "weaponType": "iron-pickaxe"
          }
        ],
        "tree1": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "tree1Small": [
          {
            "damage": 0,
            "weaponType": "bow"
          },
          {
            "damage": 0,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "longsword"
          },
          {
            "damage": 0,
            "weaponType": "crossbow"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          }
        ],
        "tree2": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "tree2Small": [
          {
            "damage": 0,
            "weaponType": "bow"
          },
          {
            "damage": 0,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "longsword"
          },
          {
            "damage": 0,
            "weaponType": "crossbow"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          }
        ],
        "tree3": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "tree4": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "tree5": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "tree6": [
          {
            "damage": 6,
            "weaponType": "dagger"
          },
          {
            "damage": 6,
            "weaponType": "spear"
          },
          {
            "damage": 6,
            "weaponType": "longsword"
          },
          {
            "damage": 10,
            "weaponType": "waraxe"
          },
          {
            "damage": 10,
            "weaponType": "axe"
          },
          {
            "damage": 30,
            "weaponType": "warhammer"
          },
          {
            "damage": 1,
            "weaponType": "bow"
          },
          {
            "damage": 1,
            "weaponType": "web"
          },
          {
            "damage": 1,
            "weaponType": "crossbow"
          },
          {
            "damage": 1,
            "weaponType": "none"
          },
          {
            "damage": 6,
            "weaponType": "iron-pickaxe"
          }
        ],
        "wall-stone": [
          {
            "damage": 3,
            "weaponType": "warhammer"
          }
        ],
        "wall-wood": [
          {
            "damage": 3,
            "weaponType": "dagger"
          },
          {
            "damage": 3,
            "weaponType": "saber"
          },
          {
            "damage": 3,
            "weaponType": "spear"
          },
          {
            "damage": 3,
            "weaponType": "longsword"
          },
          {
            "damage": 3,
            "weaponType": "mace"
          },
          {
            "damage": 4,
            "weaponType": "axe"
          },
          {
            "damage": 4,
            "weaponType": "waraxe"
          },
          {
            "damage": 8,
            "weaponType": "warhammer"
          }
        ],
        "wall2-wood": [
          {
            "damage": 3,
            "weaponType": "dagger"
          },
          {
            "damage": 3,
            "weaponType": "saber"
          },
          {
            "damage": 3,
            "weaponType": "spear"
          },
          {
            "damage": 3,
            "weaponType": "longsword"
          },
          {
            "damage": 3,
            "weaponType": "mace"
          },
          {
            "damage": 4,
            "weaponType": "axe"
          },
          {
            "damage": 4,
            "weaponType": "waraxe"
          },
          {
            "damage": 8,
            "weaponType": "warhammer"
          }
        ]
      },
      "definitions": {
        "bonecaller-stone": {
          "growthSequence": [],
          "hp": 100,
          "onDestructionCreateItems": []
        },
        "castle-footing": {
          "growthSequence": [],
          "hp": 160,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "castle-footing"
              },
              "probability": 1,
              "quantity": 1,
              "replicate": false
            }
          ]
        },
        "castle-merlons": {
          "growthSequence": [],
          "hp": 100,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "castle-merlons"
              },
              "probability": 1,
              "quantity": 1,
              "replicate": false
            }
          ]
        },
        "castle-wall": {
          "growthSequence": [],
          "hp": 140,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "castle-wall"
              },
              "probability": 1,
              "quantity": 1,
              "replicate": false
            }
          ]
        },
        "chest-wood": {
          "growthSequence": [],
          "hp": 3,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "chest-wood"
              },
              "probability": 1,
              "quantity": 1,
              "replicate": false
            }
          ]
        },
        "door-wood": {
          "growthSequence": [],
          "hp": 5,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "door-wood"
              },
              "probability": 1,
              "quantity": 1,
              "replicate": false
            }
          ]
        },
        "floor-cobble": {
          "growthSequence": [],
          "hp": 10,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "floor-cobble"
              },
              "probability": 1,
              "quantity": 1,
              "replicate": false
            }
          ]
        },
        "floor-opening": {
          "growthSequence": [],
          "hp": 1000000,
          "onDestructionCreateItems": []
        },
        "floor-stone": {
          "growthSequence": [],
          "hp": 10,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "floor-stone"
              },
              "probability": 1,
              "quantity": 1,
              "replicate": false
            }
          ]
        },
        "floor-wood": {
          "growthSequence": [],
          "hp": 5,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "floor-wood"
              },
              "probability": 1,
              "quantity": 1,
              "replicate": false
            }
          ]
        },
        "grassSprout": {
          "grass": "sprout",
          "growthSequence": [],
          "hp": 1,
          "onDestructionCreateItems": []
        },
        "grove-low-a": {
          "growthSequence": [
            {
              "entityTileId": "sapling",
              "requiredTime": 10
            },
            {
              "entityTileId": "tree2Small",
              "requiredTime": 20
            }
          ],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            },
            {
              "itemType": {
                "item": "seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ],
          "tree": "grown"
        },
        "grove-low-b": {
          "growthSequence": [
            {
              "entityTileId": "sapling",
              "requiredTime": 10
            },
            {
              "entityTileId": "tree2Small",
              "requiredTime": 20
            }
          ],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            },
            {
              "itemType": {
                "item": "seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ],
          "tree": "grown"
        },
        "grove-oak-a": {
          "growthSequence": [
            {
              "entityTileId": "sapling",
              "requiredTime": 10
            },
            {
              "entityTileId": "tree1Small",
              "requiredTime": 20
            }
          ],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            },
            {
              "itemType": {
                "item": "seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ],
          "tree": "grown"
        },
        "grove-oak-b": {
          "growthSequence": [
            {
              "entityTileId": "sapling",
              "requiredTime": 10
            },
            {
              "entityTileId": "tree1Small",
              "requiredTime": 20
            }
          ],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            },
            {
              "itemType": {
                "item": "seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ],
          "tree": "grown"
        },
        "grove-round-a": {
          "growthSequence": [
            {
              "entityTileId": "sapling",
              "requiredTime": 10
            },
            {
              "entityTileId": "tree2Small",
              "requiredTime": 20
            }
          ],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            },
            {
              "itemType": {
                "item": "seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ],
          "tree": "grown"
        },
        "grove-round-b": {
          "growthSequence": [
            {
              "entityTileId": "sapling",
              "requiredTime": 10
            },
            {
              "entityTileId": "tree2Small",
              "requiredTime": 20
            }
          ],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            },
            {
              "itemType": {
                "item": "seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ],
          "tree": "grown"
        },
        "grove-spruce-a": {
          "growthSequence": [
            {
              "entityTileId": "sapling",
              "requiredTime": 10
            },
            {
              "entityTileId": "tree1Small",
              "requiredTime": 20
            }
          ],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            },
            {
              "itemType": {
                "item": "seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ],
          "tree": "grown"
        },
        "grove-spruce-b": {
          "growthSequence": [
            {
              "entityTileId": "sapling",
              "requiredTime": 10
            },
            {
              "entityTileId": "tree1Small",
              "requiredTime": 20
            }
          ],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            },
            {
              "itemType": {
                "item": "seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ],
          "tree": "grown"
        },
        "meadow-grass-a": {
          "grass": "long",
          "growthSequence": [
            {
              "entityTileId": "meadow-sprout",
              "requiredTime": 15
            }
          ],
          "hp": 2,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "straw"
              },
              "probability": 0.5,
              "quantity": 3,
              "replicate": false
            },
            {
              "itemType": {
                "item": "grass-seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ]
        },
        "meadow-grass-b": {
          "grass": "long",
          "growthSequence": [
            {
              "entityTileId": "meadow-sprout",
              "requiredTime": 15
            }
          ],
          "hp": 2,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "straw"
              },
              "probability": 0.5,
              "quantity": 3,
              "replicate": false
            },
            {
              "itemType": {
                "item": "grass-seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ]
        },
        "meadow-grass-c": {
          "grass": "long",
          "growthSequence": [
            {
              "entityTileId": "meadow-sprout",
              "requiredTime": 15
            }
          ],
          "hp": 2,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "straw"
              },
              "probability": 0.5,
              "quantity": 3,
              "replicate": false
            },
            {
              "itemType": {
                "item": "grass-seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ]
        },
        "meadow-grass-d": {
          "grass": "long",
          "growthSequence": [
            {
              "entityTileId": "meadow-sprout",
              "requiredTime": 15
            }
          ],
          "hp": 2,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "straw"
              },
              "probability": 0.5,
              "quantity": 3,
              "replicate": false
            },
            {
              "itemType": {
                "item": "grass-seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ]
        },
        "meadow-grass-e": {
          "grass": "long",
          "growthSequence": [
            {
              "entityTileId": "meadow-sprout",
              "requiredTime": 15
            }
          ],
          "hp": 2,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "straw"
              },
              "probability": 0.5,
              "quantity": 3,
              "replicate": false
            },
            {
              "itemType": {
                "item": "grass-seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ]
        },
        "meadow-grass-f": {
          "grass": "long",
          "growthSequence": [
            {
              "entityTileId": "meadow-sprout",
              "requiredTime": 15
            }
          ],
          "hp": 2,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "straw"
              },
              "probability": 0.5,
              "quantity": 3,
              "replicate": false
            },
            {
              "itemType": {
                "item": "grass-seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ]
        },
        "meadow-sprout": {
          "grass": "sprout",
          "growthSequence": [],
          "hp": 1,
          "onDestructionCreateItems": []
        },
        "ore-coal": {
          "growthSequence": [],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "coal"
              },
              "probability": 1,
              "quantity": 3,
              "replicate": false
            }
          ]
        },
        "palmTree1": {
          "growthSequence": [],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            },
            {
              "itemType": {
                "item": "seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ],
          "tree": "grown"
        },
        "palmTree2": {
          "growthSequence": [],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            },
            {
              "itemType": {
                "item": "seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ],
          "tree": "grown"
        },
        "palmTree3": {
          "growthSequence": [],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            },
            {
              "itemType": {
                "item": "seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ],
          "tree": "grown"
        },
        "palmTree4": {
          "growthSequence": [],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            },
            {
              "itemType": {
                "item": "seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ],
          "tree": "grown"
        },
        "palmTree5": {
          "growthSequence": [],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            },
            {
              "itemType": {
                "item": "seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ],
          "tree": "grown"
        },
        "palmTree6": {
          "growthSequence": [],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            },
            {
              "itemType": {
                "item": "seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ],
          "tree": "grown"
        },
        "railing-wood": {
          "growthSequence": [],
          "hp": 4,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "railing-wood"
              },
              "probability": 1,
              "quantity": 1,
              "replicate": false
            }
          ]
        },
        "roof-wood": {
          "growthSequence": [],
          "hp": 5,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "roof-wood"
              },
              "probability": 1,
              "quantity": 1,
              "replicate": false
            }
          ]
        },
        "sapling": {
          "growthSequence": [],
          "hp": 1,
          "onDestructionCreateItems": []
        },
        "smallTree1": {
          "growthSequence": [
            {
              "entityTileId": "tree2Small",
              "requiredTime": 30
            }
          ],
          "hp": 15,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            }
          ],
          "tree": "grown"
        },
        "stairs-down": {
          "growthSequence": [],
          "hp": 10,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "stairs"
              },
              "probability": 1,
              "quantity": 1,
              "replicate": false
            }
          ]
        },
        "stairs-up": {
          "growthSequence": [],
          "hp": 10,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "stairs"
              },
              "probability": 1,
              "quantity": 1,
              "replicate": false
            }
          ]
        },
        "table-mid-round": {
          "growthSequence": [],
          "hp": 5,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "table-mid-round"
              },
              "probability": 1,
              "quantity": 1,
              "replicate": false
            }
          ]
        },
        "tallGrass": {
          "grass": "long",
          "growthSequence": [
            {
              "entityTileId": "grassSprout",
              "requiredTime": 15
            }
          ],
          "hp": 2,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "straw"
              },
              "probability": 0.5,
              "quantity": 3,
              "replicate": false
            },
            {
              "itemType": {
                "item": "grass-seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ]
        },
        "tallReeds": {
          "growthSequence": [],
          "hp": 3,
          "onDestructionCreateItems": []
        },
        "testore": {
          "growthSequence": [],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "coal"
              },
              "probability": 0.25,
              "quantity": 3,
              "replicate": false
            },
            {
              "itemType": {
                "item": "iron"
              },
              "probability": 0.15,
              "quantity": 3,
              "replicate": false
            },
            {
              "itemType": {
                "item": "copper"
              },
              "probability": 0.1,
              "quantity": 3,
              "replicate": false
            },
            {
              "itemType": {
                "item": "silver"
              },
              "probability": 0.05,
              "quantity": 3,
              "replicate": false
            },
            {
              "itemType": {
                "item": "gold"
              },
              "probability": 0.025,
              "quantity": 3,
              "replicate": false
            }
          ]
        },
        "thatch-roof": {
          "growthSequence": [],
          "hp": 5,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "thatch-roof"
              },
              "probability": 1,
              "quantity": 1,
              "replicate": false
            }
          ]
        },
        "timber-frame-wall": {
          "growthSequence": [],
          "hp": 50,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "timber-frame-wall"
              },
              "probability": 1,
              "quantity": 1,
              "replicate": false
            }
          ]
        },
        "tower-render": {
          "growthSequence": [],
          "hp": 120,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "tower-render"
              },
              "probability": 1,
              "quantity": 1,
              "replicate": false
            }
          ]
        },
        "tree1": {
          "growthSequence": [
            {
              "entityTileId": "sapling",
              "requiredTime": 10
            },
            {
              "entityTileId": "tree1Small",
              "requiredTime": 20
            }
          ],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            },
            {
              "itemType": {
                "item": "seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ],
          "tree": "grown"
        },
        "tree1Small": {
          "growthSequence": [],
          "hp": 3,
          "onDestructionCreateItems": [],
          "tree": "young"
        },
        "tree2": {
          "growthSequence": [
            {
              "entityTileId": "sapling",
              "requiredTime": 10
            },
            {
              "entityTileId": "tree2Small",
              "requiredTime": 20
            }
          ],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            },
            {
              "itemType": {
                "item": "seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ],
          "tree": "grown"
        },
        "tree2Small": {
          "growthSequence": [],
          "hp": 3,
          "onDestructionCreateItems": [],
          "tree": "young"
        },
        "tree3": {
          "growthSequence": [
            {
              "entityTileId": "sapling",
              "requiredTime": 10
            },
            {
              "entityTileId": "tree2Small",
              "requiredTime": 20
            }
          ],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            },
            {
              "itemType": {
                "item": "seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ],
          "tree": "grown"
        },
        "tree4": {
          "growthSequence": [
            {
              "entityTileId": "sapling",
              "requiredTime": 10
            },
            {
              "entityTileId": "tree2Small",
              "requiredTime": 20
            }
          ],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            },
            {
              "itemType": {
                "item": "seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ],
          "tree": "grown"
        },
        "tree5": {
          "growthSequence": [
            {
              "entityTileId": "sapling",
              "requiredTime": 10
            },
            {
              "entityTileId": "tree2Small",
              "requiredTime": 20
            }
          ],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            },
            {
              "itemType": {
                "item": "seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ],
          "tree": "grown"
        },
        "tree6": {
          "growthSequence": [
            {
              "entityTileId": "sapling",
              "requiredTime": 10
            },
            {
              "entityTileId": "tree2Small",
              "requiredTime": 20
            }
          ],
          "hp": 30,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wood"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": false
            },
            {
              "itemType": {
                "item": "seed"
              },
              "probability": 1,
              "quantity": 2,
              "replicate": true
            }
          ],
          "tree": "grown"
        },
        "wall-stone": {
          "growthSequence": [],
          "hp": 5,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wall-stone"
              },
              "probability": 1,
              "quantity": 1,
              "replicate": false
            }
          ]
        },
        "wall-wood": {
          "growthSequence": [],
          "hp": 50,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wall-wood"
              },
              "probability": 1,
              "quantity": 1,
              "replicate": false
            }
          ]
        },
        "wall2-wood": {
          "growthSequence": [],
          "hp": 50,
          "onDestructionCreateItems": [
            {
              "itemType": {
                "item": "wall2-wood"
              },
              "probability": 1,
              "quantity": 1,
              "replicate": false
            }
          ]
        }
      },
      "types": [
        "bonecaller-stone",
        "chest-wood",
        "door-wood",
        "floor-cobble",
        "floor-stone",
        "floor-wood",
        "grassSprout",
        "ore-coal",
        "palmTree1",
        "palmTree2",
        "palmTree3",
        "palmTree4",
        "palmTree5",
        "palmTree6",
        "roof-wood",
        "sapling",
        "smallTree1",
        "table-mid-round",
        "tallGrass",
        "tallReeds",
        "testore",
        "tree1",
        "tree1Small",
        "tree2",
        "tree2Small",
        "tree3",
        "tree4",
        "tree5",
        "tree6",
        "wall-stone",
        "wall-wood",
        "railing-wood",
        "wall2-wood",
        "stairs-up",
        "stairs-down",
        "floor-opening",
        "timber-frame-wall",
        "thatch-roof",
        "grove-oak-a",
        "grove-oak-b",
        "grove-spruce-a",
        "grove-spruce-b",
        "grove-round-a",
        "grove-round-b",
        "grove-low-a",
        "grove-low-b",
        "meadow-grass-a",
        "meadow-grass-b",
        "meadow-grass-c",
        "meadow-grass-d",
        "meadow-grass-e",
        "meadow-grass-f",
        "meadow-sprout",
        "castle-footing",
        "castle-wall",
        "castle-merlons",
        "tower-render"
      ]
    },
    "vocabularies": {
      "colors": [
        "white",
        "blonde",
        "yellow",
        "light",
        "lightgreen",
        "gold",
        "green",
        "teal",
        "blue",
        "orange",
        "maroon",
        "red",
        "purple",
        "olive",
        "tan",
        "lightbrown",
        "brown",
        "dark",
        "gray",
        "silver",
        "metal",
        "pink",
        "black",
        "na"
      ]
    }
  },
  "spriteColors": {
    "armor": {
      "armor-leather": [
        "blue",
        "brown",
        "green"
      ],
      "armor-legion": [
        "brown",
        "gray",
        "gold"
      ],
      "armor-plate": [
        "gray",
        "metal",
        "yellow",
        "gold",
        "orange",
        "tan"
      ]
    },
    "bauldron": {
      "bauldron": [
        "brown"
      ]
    },
    "body": {
      "bee": [
        "yellow"
      ],
      "chicken": [
        "white"
      ],
      "deer": [
        "brown"
      ],
      "horse": [
        "brown"
      ],
      "human": [
        "white",
        "black",
        "olive",
        "brown",
        "light",
        "dark",
        "tan"
      ],
      "lpc-chicken": [
        "white"
      ],
      "lpc-viper": [
        "green"
      ],
      "orc": [
        "gray",
        "green",
        "lightgreen"
      ],
      "rabbit": [
        "white"
      ],
      "rage-slime": [
        "green"
      ],
      "redspider": [
        "red"
      ],
      "reptile": [
        "green",
        "lightgreen",
        "blue"
      ],
      "reptile-winged": [
        "green",
        "lightgreen",
        "blue"
      ],
      "skeleton": [
        "white",
        "gray",
        "green"
      ],
      "slime": [
        "green"
      ],
      "snake": [
        "green"
      ],
      "spikes1": [
        "white"
      ],
      "thistle": [
        "white"
      ],
      "wasp": [
        "yellow"
      ],
      "wild-hare": [
        "white"
      ],
      "wolfman": [
        "brown",
        "black",
        "gray",
        "white"
      ],
      "zombie": [
        "green"
      ]
    },
    "cape": {
      "cape-solid": [
        "black",
        "blue",
        "brown",
        "gray",
        "green",
        "maroon",
        "red",
        "white",
        "yellow"
      ],
      "cape-tattered": [
        "black",
        "blue",
        "brown",
        "gray",
        "green",
        "maroon",
        "red",
        "white",
        "yellow"
      ],
      "cape-trimmed": [
        "white"
      ]
    },
    "eyes": {
      "cyclops": [
        "red"
      ],
      "normal": [
        "blue",
        "brown",
        "gray",
        "green",
        "orange",
        "purple",
        "red",
        "yellow"
      ]
    },
    "hair": {
      "afro": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "balding": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "bangs": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "bangs_bun": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "bangslong": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "bangslong2": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "bangsshort": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "bedhead": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "bob": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "bob_side_part": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "braid": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "braid2": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "bunches": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "buzzcut": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "cornrows": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "cowlick": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "cowlick_tall": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "curly_long": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "curly_short": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "curtains": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "curtains_long": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "dreadlocks_long": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "dreadlocks_short": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "flat_top_fade": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "flat_top_straight": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "half_up": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "halfmessy": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "high_and_tight": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "high_ponytail": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "idol": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "jewfro": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "lob": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "long": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "long_band": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "long_center_part": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "long_messy": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "long_messy2": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "long_tied": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "longhawk": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "longknot": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "loose": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "messy1": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "messy2": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "messy3": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "mop": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "natural": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "page": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "page2": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "part2": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "parted": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "pixie": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "plain": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "ponytail": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "ponytail2": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "princess": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "sara": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "shorthawk": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "shortknot": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "shoulderl": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "shoulderr": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "single": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "spiked": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "spiked2": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "spiked_beehive": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "spiked_liberty": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "spiked_liberty2": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "spiked_porcupine": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "swoop": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "twists_fade": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "twists_straight": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "unkempt": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "wavy": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ],
      "xlong": [
        "white",
        "blonde",
        "gold",
        "green",
        "blue",
        "red",
        "orange",
        "purple",
        "brown",
        "lightbrown",
        "gray",
        "black"
      ]
    },
    "nose": {
      "big": [
        "white",
        "tan",
        "gray"
      ],
      "button": [
        "white",
        "tan",
        "gray"
      ],
      "straight": [
        "white",
        "tan",
        "gray"
      ]
    },
    "pants": {
      "legion": [
        "brown"
      ],
      "pantaloons": [
        "black",
        "blue",
        "brown",
        "gray",
        "green",
        "maroon",
        "orange",
        "purple",
        "red",
        "tan",
        "white",
        "yellow"
      ],
      "pants": [
        "black",
        "blue",
        "brown",
        "gray",
        "green",
        "maroon",
        "orange",
        "purple",
        "red",
        "tan",
        "white",
        "yellow"
      ],
      "pants-armor": [
        "gray",
        "metal",
        "yellow",
        "gold",
        "tan",
        "orange"
      ],
      "skirts": [
        "brown",
        "black",
        "white"
      ]
    },
    "shield": {
      "shield-crusader": [
        "white"
      ],
      "shield-kite": [
        "gray",
        "orange"
      ],
      "shield-kite_blue": [
        "blue",
        "gray"
      ],
      "shield-kite_gray": [
        "blue",
        "gray",
        "green",
        "orange"
      ],
      "shield-kite_green": [
        "gray"
      ],
      "shield-kite_red": [
        "gray"
      ],
      "shield-round": [
        "black",
        "brown",
        "gold",
        "green",
        "silver",
        "yellow"
      ],
      "shield-spartan": [
        "brown"
      ]
    },
    "shirt": {
      "blouse": [
        "black",
        "blue",
        "green",
        "maroon",
        "purple",
        "red",
        "teal",
        "white",
        "yellow",
        "tan",
        "gray",
        "orange"
      ],
      "blouse_longsleeve": [
        "black",
        "blue",
        "green",
        "maroon",
        "purple",
        "red",
        "teal",
        "white",
        "yellow",
        "tan",
        "gray",
        "orange"
      ],
      "corset": [
        "black",
        "blue",
        "green",
        "maroon",
        "purple",
        "red",
        "teal",
        "white",
        "yellow",
        "brown",
        "tan",
        "gray",
        "orange"
      ],
      "longsleeve": [
        "black",
        "blue",
        "green",
        "maroon",
        "purple",
        "red",
        "teal",
        "white",
        "yellow"
      ],
      "longsleeve_laced": [
        "black",
        "blue",
        "green",
        "maroon",
        "purple",
        "red",
        "teal",
        "white",
        "yellow",
        "tan",
        "gray",
        "orange"
      ],
      "scoop_shirt": [
        "black",
        "blue",
        "green",
        "maroon",
        "purple",
        "red",
        "teal",
        "white",
        "yellow",
        "gray",
        "orange"
      ],
      "sleeveless": [
        "black",
        "blue",
        "green",
        "maroon",
        "purple",
        "red",
        "teal",
        "white",
        "yellow",
        "brown",
        "tan",
        "gray",
        "orange"
      ],
      "sleeveless_laced": [
        "black",
        "blue",
        "green",
        "maroon",
        "purple",
        "red",
        "teal",
        "white",
        "yellow",
        "brown",
        "tan",
        "gray",
        "orange"
      ],
      "sleeveless_striped": [
        "black",
        "blue",
        "green",
        "maroon",
        "purple",
        "red",
        "teal",
        "white",
        "yellow",
        "brown",
        "tan",
        "gray",
        "orange"
      ],
      "tanktop": [
        "black",
        "blue",
        "green",
        "maroon",
        "purple",
        "red",
        "teal",
        "white",
        "yellow",
        "tan",
        "gray",
        "orange"
      ],
      "tunic": [
        "brown",
        "maroon",
        "teal",
        "white"
      ]
    },
    "shoes": {
      "boots": [
        "black",
        "blue",
        "brown",
        "gray",
        "green",
        "maroon",
        "orange",
        "purple",
        "red",
        "tan",
        "teal",
        "white",
        "yellow"
      ],
      "sandals": [
        "brown"
      ],
      "shoes": [
        "black",
        "brown",
        "maroon"
      ],
      "shoes-armor": [
        "gray",
        "metal",
        "yellow",
        "gold",
        "tan",
        "orange"
      ],
      "slippers": [
        "black",
        "brown",
        "gray"
      ]
    },
    "weapon": {
      "axe": [
        "metal"
      ],
      "bow": [
        "brown"
      ],
      "crossbow": [
        "brown"
      ],
      "dagger": [
        "metal",
        "brown"
      ],
      "flail": [
        "metal"
      ],
      "halberd": [
        "metal"
      ],
      "iron-pickaxe": [
        "na"
      ],
      "longsword": [
        "metal"
      ],
      "mace": [
        "metal"
      ],
      "none": [],
      "rapier": [
        "metal"
      ],
      "saber": [
        "metal"
      ],
      "scythe": [
        "metal"
      ],
      "spear": [
        "brown",
        "black",
        "green",
        "metal",
        "purple"
      ],
      "staff": [
        "brown"
      ],
      "waraxe": [
        "metal"
      ],
      "warhammer": [
        "metal"
      ],
      "web": [
        "white"
      ]
    }
  },
  "tiles": {
    "bonecaller-stone": {
      "growthSequence": [],
      "hp": 100,
      "onDestructionCreateItems": []
    },
    "castle-footing": {
      "growthSequence": [],
      "hp": 160,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:824",
            "type": "castle-footing"
          },
          "probability": 1,
          "quantity": 1,
          "replicate": false
        }
      ]
    },
    "castle-merlons": {
      "growthSequence": [],
      "hp": 100,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:924",
            "type": "castle-merlons"
          },
          "probability": 1,
          "quantity": 1,
          "replicate": false
        }
      ]
    },
    "castle-wall": {
      "growthSequence": [],
      "hp": 140,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:872",
            "type": "castle-wall"
          },
          "probability": 1,
          "quantity": 1,
          "replicate": false
        }
      ]
    },
    "chest-wood": {
      "growthSequence": [],
      "hp": 3,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "structure",
            "color": "na",
            "spriteId": "container:140",
            "type": "chest-wood"
          },
          "probability": 1,
          "quantity": 1,
          "replicate": false
        }
      ]
    },
    "door-wood": {
      "growthSequence": [],
      "hp": 5,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "structure",
            "color": "na",
            "spriteId": "fence_medieval:478",
            "type": "door-wood"
          },
          "probability": 1,
          "quantity": 1,
          "replicate": false
        }
      ]
    },
    "floor-cobble": {
      "growthSequence": [],
      "hp": 10,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "structure",
            "color": "na",
            "spriteId": "floors:225",
            "type": "floor-cobble"
          },
          "probability": 1,
          "quantity": 1,
          "replicate": false
        }
      ]
    },
    "floor-opening": {
      "growthSequence": [],
      "hp": 1000000,
      "onDestructionCreateItems": []
    },
    "floor-stone": {
      "growthSequence": [],
      "hp": 10,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "structure",
            "color": "na",
            "spriteId": "floors:129",
            "type": "floor-stone"
          },
          "probability": 1,
          "quantity": 1,
          "replicate": false
        }
      ]
    },
    "floor-wood": {
      "growthSequence": [],
      "hp": 5,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "structure",
            "color": "na",
            "spriteId": "floors:33",
            "type": "floor-wood"
          },
          "probability": 1,
          "quantity": 1,
          "replicate": false
        }
      ]
    },
    "grassSprout": {
      "grass": "sprout",
      "growthSequence": [],
      "hp": 1,
      "onDestructionCreateItems": []
    },
    "grove-low-a": {
      "growthSequence": [
        {
          "entityTileId": "sapling",
          "requiredTime": 10
        },
        {
          "entityTileId": "tree2Small",
          "requiredTime": 20
        }
      ],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ],
      "tree": "grown"
    },
    "grove-low-b": {
      "growthSequence": [
        {
          "entityTileId": "sapling",
          "requiredTime": 10
        },
        {
          "entityTileId": "tree2Small",
          "requiredTime": 20
        }
      ],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ],
      "tree": "grown"
    },
    "grove-oak-a": {
      "growthSequence": [
        {
          "entityTileId": "sapling",
          "requiredTime": 10
        },
        {
          "entityTileId": "tree1Small",
          "requiredTime": 20
        }
      ],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ],
      "tree": "grown"
    },
    "grove-oak-b": {
      "growthSequence": [
        {
          "entityTileId": "sapling",
          "requiredTime": 10
        },
        {
          "entityTileId": "tree1Small",
          "requiredTime": 20
        }
      ],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ],
      "tree": "grown"
    },
    "grove-round-a": {
      "growthSequence": [
        {
          "entityTileId": "sapling",
          "requiredTime": 10
        },
        {
          "entityTileId": "tree2Small",
          "requiredTime": 20
        }
      ],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ],
      "tree": "grown"
    },
    "grove-round-b": {
      "growthSequence": [
        {
          "entityTileId": "sapling",
          "requiredTime": 10
        },
        {
          "entityTileId": "tree2Small",
          "requiredTime": 20
        }
      ],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ],
      "tree": "grown"
    },
    "grove-spruce-a": {
      "growthSequence": [
        {
          "entityTileId": "sapling",
          "requiredTime": 10
        },
        {
          "entityTileId": "tree1Small",
          "requiredTime": 20
        }
      ],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ],
      "tree": "grown"
    },
    "grove-spruce-b": {
      "growthSequence": [
        {
          "entityTileId": "sapling",
          "requiredTime": 10
        },
        {
          "entityTileId": "tree1Small",
          "requiredTime": 20
        }
      ],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ],
      "tree": "grown"
    },
    "meadow-grass-a": {
      "grass": "long",
      "growthSequence": [
        {
          "entityTileId": "meadow-sprout",
          "requiredTime": 15
        }
      ],
      "hp": 2,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-b9ef00e25a4177065abd:1",
            "type": "straw"
          },
          "probability": 0.5,
          "quantity": 3,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-08bd1c8b4020c28035f1:1",
            "type": "grass-seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ]
    },
    "meadow-grass-b": {
      "grass": "long",
      "growthSequence": [
        {
          "entityTileId": "meadow-sprout",
          "requiredTime": 15
        }
      ],
      "hp": 2,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-b9ef00e25a4177065abd:1",
            "type": "straw"
          },
          "probability": 0.5,
          "quantity": 3,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-08bd1c8b4020c28035f1:1",
            "type": "grass-seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ]
    },
    "meadow-grass-c": {
      "grass": "long",
      "growthSequence": [
        {
          "entityTileId": "meadow-sprout",
          "requiredTime": 15
        }
      ],
      "hp": 2,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-b9ef00e25a4177065abd:1",
            "type": "straw"
          },
          "probability": 0.5,
          "quantity": 3,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-08bd1c8b4020c28035f1:1",
            "type": "grass-seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ]
    },
    "meadow-grass-d": {
      "grass": "long",
      "growthSequence": [
        {
          "entityTileId": "meadow-sprout",
          "requiredTime": 15
        }
      ],
      "hp": 2,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-b9ef00e25a4177065abd:1",
            "type": "straw"
          },
          "probability": 0.5,
          "quantity": 3,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-08bd1c8b4020c28035f1:1",
            "type": "grass-seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ]
    },
    "meadow-grass-e": {
      "grass": "long",
      "growthSequence": [
        {
          "entityTileId": "meadow-sprout",
          "requiredTime": 15
        }
      ],
      "hp": 2,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-b9ef00e25a4177065abd:1",
            "type": "straw"
          },
          "probability": 0.5,
          "quantity": 3,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-08bd1c8b4020c28035f1:1",
            "type": "grass-seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ]
    },
    "meadow-grass-f": {
      "grass": "long",
      "growthSequence": [
        {
          "entityTileId": "meadow-sprout",
          "requiredTime": 15
        }
      ],
      "hp": 2,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-b9ef00e25a4177065abd:1",
            "type": "straw"
          },
          "probability": 0.5,
          "quantity": 3,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-08bd1c8b4020c28035f1:1",
            "type": "grass-seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ]
    },
    "meadow-sprout": {
      "grass": "sprout",
      "growthSequence": [],
      "hp": 1,
      "onDestructionCreateItems": []
    },
    "ore-coal": {
      "growthSequence": [],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:161",
            "type": "coal"
          },
          "probability": 1,
          "quantity": 3,
          "replicate": false
        }
      ]
    },
    "palmTree1": {
      "growthSequence": [],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ],
      "tree": "grown"
    },
    "palmTree2": {
      "growthSequence": [],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ],
      "tree": "grown"
    },
    "palmTree3": {
      "growthSequence": [],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ],
      "tree": "grown"
    },
    "palmTree4": {
      "growthSequence": [],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ],
      "tree": "grown"
    },
    "palmTree5": {
      "growthSequence": [],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ],
      "tree": "grown"
    },
    "palmTree6": {
      "growthSequence": [],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ],
      "tree": "grown"
    },
    "railing-wood": {
      "growthSequence": [],
      "hp": 4,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "structure",
            "color": "na",
            "spriteId": "fence_medieval:1",
            "type": "railing-wood"
          },
          "probability": 1,
          "quantity": 1,
          "replicate": false
        }
      ]
    },
    "roof-wood": {
      "growthSequence": [],
      "hp": 5,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:807",
            "type": "roof-wood"
          },
          "probability": 1,
          "quantity": 1,
          "replicate": false
        }
      ]
    },
    "sapling": {
      "growthSequence": [],
      "hp": 1,
      "onDestructionCreateItems": []
    },
    "smallTree1": {
      "growthSequence": [
        {
          "entityTileId": "tree2Small",
          "requiredTime": 30
        }
      ],
      "hp": 15,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        }
      ],
      "tree": "grown"
    },
    "stairs-down": {
      "growthSequence": [],
      "hp": 10,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "structure",
            "color": "na",
            "spriteId": "stairs-icon:1",
            "type": "stairs"
          },
          "probability": 1,
          "quantity": 1,
          "replicate": false
        }
      ]
    },
    "stairs-up": {
      "growthSequence": [],
      "hp": 10,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "structure",
            "color": "na",
            "spriteId": "stairs-icon:1",
            "type": "stairs"
          },
          "probability": 1,
          "quantity": 1,
          "replicate": false
        }
      ]
    },
    "table-mid-round": {
      "growthSequence": [],
      "hp": 5,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "structure",
            "color": "na",
            "spriteId": "furniture-blonde-wood:124",
            "type": "table-mid-round"
          },
          "probability": 1,
          "quantity": 1,
          "replicate": false
        }
      ]
    },
    "tallGrass": {
      "grass": "long",
      "growthSequence": [
        {
          "entityTileId": "grassSprout",
          "requiredTime": 15
        }
      ],
      "hp": 2,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-b9ef00e25a4177065abd:1",
            "type": "straw"
          },
          "probability": 0.5,
          "quantity": 3,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-08bd1c8b4020c28035f1:1",
            "type": "grass-seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ]
    },
    "tallReeds": {
      "growthSequence": [],
      "hp": 3,
      "onDestructionCreateItems": []
    },
    "testore": {
      "growthSequence": [],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:161",
            "type": "coal"
          },
          "probability": 0.25,
          "quantity": 3,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:179",
            "type": "iron"
          },
          "probability": 0.15,
          "quantity": 3,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:180",
            "type": "copper"
          },
          "probability": 0.1,
          "quantity": 3,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:181",
            "type": "silver"
          },
          "probability": 0.05,
          "quantity": 3,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "spriteId": "ore:182",
            "type": "gold"
          },
          "probability": 0.025,
          "quantity": 3,
          "replicate": false
        }
      ]
    },
    "thatch-roof": {
      "growthSequence": [],
      "hp": 5,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:378",
            "type": "thatch-roof"
          },
          "probability": 1,
          "quantity": 1,
          "replicate": false
        }
      ]
    },
    "timber-frame-wall": {
      "growthSequence": [],
      "hp": 50,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:50",
            "type": "timber-frame-wall"
          },
          "probability": 1,
          "quantity": 1,
          "replicate": false
        }
      ]
    },
    "tower-render": {
      "growthSequence": [],
      "hp": 120,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:927",
            "type": "tower-render"
          },
          "probability": 1,
          "quantity": 1,
          "replicate": false
        }
      ]
    },
    "tree1": {
      "growthSequence": [
        {
          "entityTileId": "sapling",
          "requiredTime": 10
        },
        {
          "entityTileId": "tree1Small",
          "requiredTime": 20
        }
      ],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ],
      "tree": "grown"
    },
    "tree1Small": {
      "growthSequence": [],
      "hp": 3,
      "onDestructionCreateItems": [],
      "tree": "young"
    },
    "tree2": {
      "growthSequence": [
        {
          "entityTileId": "sapling",
          "requiredTime": 10
        },
        {
          "entityTileId": "tree2Small",
          "requiredTime": 20
        }
      ],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ],
      "tree": "grown"
    },
    "tree2Small": {
      "growthSequence": [],
      "hp": 3,
      "onDestructionCreateItems": [],
      "tree": "young"
    },
    "tree3": {
      "growthSequence": [
        {
          "entityTileId": "sapling",
          "requiredTime": 10
        },
        {
          "entityTileId": "tree2Small",
          "requiredTime": 20
        }
      ],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ],
      "tree": "grown"
    },
    "tree4": {
      "growthSequence": [
        {
          "entityTileId": "sapling",
          "requiredTime": 10
        },
        {
          "entityTileId": "tree2Small",
          "requiredTime": 20
        }
      ],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ],
      "tree": "grown"
    },
    "tree5": {
      "growthSequence": [
        {
          "entityTileId": "sapling",
          "requiredTime": 10
        },
        {
          "entityTileId": "tree2Small",
          "requiredTime": 20
        }
      ],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ],
      "tree": "grown"
    },
    "tree6": {
      "growthSequence": [
        {
          "entityTileId": "sapling",
          "requiredTime": 10
        },
        {
          "entityTileId": "tree2Small",
          "requiredTime": 20
        }
      ],
      "hp": 30,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "resource",
            "color": "brown",
            "noGlint": true,
            "spriteId": null,
            "type": "wood"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": false
        },
        {
          "itemType": {
            "class": "resource",
            "color": "na",
            "noGlint": true,
            "spriteId": "item-art-1a07b84a0c63a7a63c4f:1",
            "type": "seed"
          },
          "probability": 1,
          "quantity": 2,
          "replicate": true
        }
      ],
      "tree": "grown"
    },
    "wall-stone": {
      "growthSequence": [],
      "hp": 5,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "structure",
            "color": "na",
            "spriteId": "walls2:53",
            "type": "wall-stone"
          },
          "probability": 1,
          "quantity": 1,
          "replicate": false
        }
      ]
    },
    "wall-wood": {
      "growthSequence": [],
      "hp": 50,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "structure",
            "color": "na",
            "spriteId": "authored-terrain:643",
            "type": "wall-wood"
          },
          "probability": 1,
          "quantity": 1,
          "replicate": false
        }
      ]
    },
    "wall2-wood": {
      "growthSequence": [],
      "hp": 50,
      "onDestructionCreateItems": [
        {
          "itemType": {
            "class": "structure",
            "color": "na",
            "spriteId": "walls2:43",
            "type": "wall2-wood"
          },
          "probability": 1,
          "quantity": 1,
          "replicate": false
        }
      ]
    }
  },
  "weapons": {
    "iron-pickaxe": "axe"
  }
}
